/// <reference path="./custom.d.ts" />
/* eslint-disable */

import * as url from "url";
// Because the lib_api package is not compile directly from an react app it will try to use a different fetch from window fetch.
// So portableFetch is replaced by window.fetch
// import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = window.fetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError" = "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AbandonDto
 */
export interface AbandonDto {
    /**
     * 
     * @type {boolean}
     * @memberof AbandonDto
     */
    abandonImmediat: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AbandonDto
     */
    applicationDate: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbandonDto
     */
    decisionAbandon: string;
    /**
     * 
     * @type {boolean}
     * @memberof AbandonDto
     */
    isAbandon: boolean;
}
/**
 * 
 * @export
 * @interface AccessoiresDto
 */
export interface AccessoiresDto {
    /**
     * 
     * @type {boolean}
     * @memberof AccessoiresDto
     */
    autoRadioVisible: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AccessoiresDto
     */
    nombreAntennes: number | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoiresDto
     */
    objetsVisibles: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessoiresDto
     */
    observations: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessoiresDto
     */
    posteCbVisible: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessoiresDto
     */
    telephonePortable: boolean | null;
}
/**
 * 
 * @export
 * @interface Acheteur
 */
export interface Acheteur {
    /**
     * 
     * @type {string}
     * @memberof Acheteur
     */
    nom: string | null;
    /**
     * 
     * @type {string}
     * @memberof Acheteur
     */
    prenom: string | null;
    /**
     * 
     * @type {string}
     * @memberof Acheteur
     */
    raisonSociale: string | null;
}
/**
 * 
 * @export
 * @interface ActionsRequisesDto
 */
export interface ActionsRequisesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ActionsRequisesDto
     */
    actionsRequises: Array<ActionsRequisesDtoActionsRequisesEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum ActionsRequisesDtoActionsRequisesEnum {
    'PROLONGER_MEF' = 'PROLONGER_MEF',
    'MODIFIER_COORDONNEES_PROPRIETAIRE' = 'MODIFIER_COORDONNEES_PROPRIETAIRE',
    'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' = 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE',
    'RENSEIGNER_SORTIE_VEHICULE' = 'RENSEIGNER_SORTIE_VEHICULE',
    'SAISIE_VHU' = 'SAISIE_VHU',
    'SAISIE_NOTIFICATION_MANUELLE' = 'SAISIE_NOTIFICATION_MANUELLE',
    'MAIN_LEVEE' = 'MAIN_LEVEE',
    'TRAITE_EN_FACTURATION' = 'TRAITE_EN_FACTURATION',
    'NON_TRAITE_EN_FACTURATION' = 'NON_TRAITE_EN_FACTURATION',
    'ANNULATION_SORTIE_VEHICULE' = 'ANNULATION_SORTIE_VEHICULE',
    'EXPORT_DONNEES_DOSSIER' = 'EXPORT_DONNEES_DOSSIER',
    'SUPPRESSION_DOSSIER' = 'SUPPRESSION_DOSSIER',
    'SUPPRESSION_DOSSIER_BY_FO' = 'SUPPRESSION_DOSSIER_BY_FO',
    'UPDATE_ENTITES_RATTACHEMENT_ADMIN' = 'UPDATE_ENTITES_RATTACHEMENT_ADMIN',
    'UPDATE_ENTITES_RATTACHEMENT_FO_AF' = 'UPDATE_ENTITES_RATTACHEMENT_FO_AF',
    'MODIFICATION_SORTIE_VEHICULE' = 'MODIFICATION_SORTIE_VEHICULE',
    'UPDATE_DONNEES_VEHICULE' = 'UPDATE_DONNEES_VEHICULE',
    'UPDATE_DONNEES_VEHICULE_JUSTICE' = 'UPDATE_DONNEES_VEHICULE_JUSTICE',
    'UPDATE_CLASSEMENT' = 'UPDATE_CLASSEMENT',
    'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' = 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE',
    'ENREGISTRER_ENTREE' = 'ENREGISTRER_ENTREE',
    'CONTROLER_DONNEES_VEHICULE' = 'CONTROLER_DONNEES_VEHICULE',
    'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' = 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE',
    'RELANCE_VENTE_VOL' = 'RELANCE_VENTE_VOL',
    'RELANCE_VENTE_IMMO_PJ' = 'RELANCE_VENTE_IMMO_PJ',
    'RELANCE_VENTE_OPPOSITION' = 'RELANCE_VENTE_OPPOSITION',
    'RELANCE_VENTE_DOUBLON' = 'RELANCE_VENTE_DOUBLON',
    'RELANCE_VENTE_MANQUANT' = 'RELANCE_VENTE_MANQUANT',
    'RECUPERATION_AR_PND_AUTOMATIQUE' = 'RECUPERATION_AR_PND_AUTOMATIQUE',
    'CONTROLE_BLOCAGE_ARGOS' = 'CONTROLE_BLOCAGE_ARGOS',
    'CONTROLE_BLOCAGE_ANTAI' = 'CONTROLE_BLOCAGE_ANTAI',
    'CONTROLE_BLOCAGE_DNID' = 'CONTROLE_BLOCAGE_DNID',
    'RECUPERATION_COURRIER_AUTOMATIQUE' = 'RECUPERATION_COURRIER_AUTOMATIQUE',
    'RENSEIGNER_INFORMATIONS_SIV' = 'RENSEIGNER_INFORMATIONS_SIV',
    'CONFIRMER_VOL_VVNR' = 'CONFIRMER_VOL_VVNR',
    'VALIDATION_ACTIONS_VVNR_HORS_SIF' = 'VALIDATION_ACTIONS_VVNR_HORS_SIF',
    'IMPORTER_PIECES_JOINTES' = 'IMPORTER_PIECES_JOINTES',
    'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' = 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE',
    'UPDATE_DONNEES_JUDICIAIRE' = 'UPDATE_DONNEES_JUDICIAIRE'
}

/**
 * 
 * @export
 * @interface AgentDto
 */
export interface AgentDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    communeFonction: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    grade: AgentDtoGradeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    matricule: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    nom: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum AgentDtoGradeEnum {
    'APJA' = 'APJA',
    'APJ' = 'APJ',
    'OPJ' = 'OPJ'
}

/**
 * 
 * @export
 * @interface AgentFoDto
 */
export interface AgentFoDto {
    /**
     * 
     * @type {string}
     * @memberof AgentFoDto
     */
    idCorrelationUniteFo: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFoDto
     */
    nigend: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFoDto
     */
    nomAgent: string | null;
}
/**
 * 
 * @export
 * @interface AlienationAcheteurDto
 */
export interface AlienationAcheteurDto {
    /**
     * 
     * @type {string}
     * @memberof AlienationAcheteurDto
     */
    nom: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlienationAcheteurDto
     */
    prenom: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlienationAcheteurDto
     */
    raisonSociale: string | null;
}
/**
 * 
 * @export
 * @interface AlienationActiveSolutionDto
 */
export interface AlienationActiveSolutionDto {
    /**
     * 
     * @type {boolean}
     * @memberof AlienationActiveSolutionDto
     */
    apiClientEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AlienationActiveSolutionDto
     */
    contournementImportEnabled: boolean;
}
/**
 * 
 * @export
 * @interface AlienationInformationDto
 */
export interface AlienationInformationDto {
    /**
     * 
     * @type {AlienationAcheteurDto}
     * @memberof AlienationInformationDto
     */
    acheteur: AlienationAcheteurDto | null;
    /**
     * 
     * @type {string}
     * @memberof AlienationInformationDto
     */
    dateDeclarationEnlevement: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlienationInformationDto
     */
    dateRemiseAuDomaine: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlienationInformationDto
     */
    dateTransmissionPhotos: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlienationInformationDto
     */
    decision: AlienationInformationDtoDecisionEnum | null;
    /**
     * 
     * @type {string}
     * @memberof AlienationInformationDto
     */
    idAlienation: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlienationInformationDto
     */
    statut: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum AlienationInformationDtoDecisionEnum {
    'EN_ATTENTE' = 'EN_ATTENTE',
    'REFUSE_OU_ECHEC_DE_VENTE' = 'REFUSE_OU_ECHEC_DE_VENTE',
    'REFUSE_SCELLE' = 'REFUSE_SCELLE',
    'EN_VENTE' = 'EN_VENTE',
    'VENDU' = 'VENDU',
    'A_RESTITUER' = 'A_RESTITUER',
    'RESTITUE' = 'RESTITUE',
    'ENLEVE' = 'ENLEVE',
    'BLOCAGE_VENTE_AF' = 'BLOCAGE_VENTE_AF',
    'BLOCAGE_VENTE_FO' = 'BLOCAGE_VENTE_FO',
    'BLOCAGE_VENTE_FO_VOL' = 'BLOCAGE_VENTE_FO_VOL',
    'BLOCAGE_VENTE_ADMIN_IMMO_PJ' = 'BLOCAGE_VENTE_ADMIN_IMMO_PJ',
    'BLOCAGE_VENTE_ADMIN_OPPOSITION' = 'BLOCAGE_VENTE_ADMIN_OPPOSITION',
    'BLOCAGE_VENTE_ADMIN_DOUBLON' = 'BLOCAGE_VENTE_ADMIN_DOUBLON'
}

/**
 * 
 * @export
 * @interface AntaiFluxDto
 */
export interface AntaiFluxDto {
    /**
     * 
     * @type {string}
     * @memberof AntaiFluxDto
     */
    dateDebut: string;
    /**
     * 
     * @type {string}
     * @memberof AntaiFluxDto
     */
    error: string | null;
    /**
     * 
     * @type {string}
     * @memberof AntaiFluxDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof AntaiFluxDto
     */
    indexDebut: number;
    /**
     * 
     * @type {number}
     * @memberof AntaiFluxDto
     */
    indexFin: number;
    /**
     * 
     * @type {number}
     * @memberof AntaiFluxDto
     */
    nbWarnings: number;
}
/**
 * 
 * @export
 * @interface AntaiWarningDto
 */
export interface AntaiWarningDto {
    /**
     * 
     * @type {string}
     * @memberof AntaiWarningDto
     */
    antaiId: string;
    /**
     * 
     * @type {string}
     * @memberof AntaiWarningDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AntaiWarningDto
     */
    dossierId: string | null;
    /**
     * 
     * @type {string}
     * @memberof AntaiWarningDto
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof AntaiWarningDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof AntaiWarningDto
     */
    nextRetryAt: string | null;
    /**
     * 
     * @type {number}
     * @memberof AntaiWarningDto
     */
    retriesLeft: number;
    /**
     * 
     * @type {boolean}
     * @memberof AntaiWarningDto
     */
    retryLocked: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AntaiWarningDto
     */
    type: string;
}
/**
 * 
 * @export
 * @interface ApurementError
 */
export interface ApurementError {
    /**
     * 
     * @type {string}
     * @memberof ApurementError
     */
    error: string;
    /**
     * 
     * @type {string}
     * @memberof ApurementError
     */
    idDossier: string;
}
/**
 * 
 * @export
 * @interface ApurementReportResponseDto
 */
export interface ApurementReportResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ApurementReportResponseDto
     */
    dateDeclenchement: string;
    /**
     * 
     * @type {string}
     * @memberof ApurementReportResponseDto
     */
    dateFin: string | null;
    /**
     * 
     * @type {Array<ApurementError>}
     * @memberof ApurementReportResponseDto
     */
    erreurs: Array<ApurementError> | null;
    /**
     * 
     * @type {string}
     * @memberof ApurementReportResponseDto
     */
    id: string;
}
/**
 * 
 * @export
 * @interface ArgosInformationDto
 */
export interface ArgosInformationDto {
    /**
     * 
     * @type {string}
     * @memberof ArgosInformationDto
     */
    dateFinAttenteAssureur: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArgosInformationDto
     */
    dateMiseADispositionArgos: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArgosInformationDto
     */
    delaiAssureurEcoule: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArgosInformationDto
     */
    identifieVvnr: boolean | null;
    /**
     * 
     * @type {InfosAssureurDto}
     * @memberof ArgosInformationDto
     */
    infosAssureurs: InfosAssureurDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArgosInformationDto
     */
    nonPrisEnChargeArgos: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ArgosInformationDto
     */
    statutMismatchVVNR: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArgosInformationDto
     */
    volConfirme: boolean | null;
}
/**
 * 
 * @export
 * @interface AuthRedirectDto
 */
export interface AuthRedirectDto {
    /**
     * 
     * @type {string}
     * @memberof AuthRedirectDto
     */
    redirectUri: string;
}
/**
 * 
 * @export
 * @interface AutocompleteJuridictionResultDto
 */
export interface AutocompleteJuridictionResultDto {
    /**
     * 
     * @type {ReferenceDtoJuridictionResponseDto}
     * @memberof AutocompleteJuridictionResultDto
     */
    reference: ReferenceDtoJuridictionResponseDto;
}
/**
 * 
 * @export
 * @interface AutocompleteUniteFOResultDto
 */
export interface AutocompleteUniteFOResultDto {
    /**
     * 
     * @type {string}
     * @memberof AutocompleteUniteFOResultDto
     */
    field: AutocompleteUniteFOResultDtoFieldEnum;
    /**
     * 
     * @type {ReferenceDtoUniteFOResponseDto}
     * @memberof AutocompleteUniteFOResultDto
     */
    reference: ReferenceDtoUniteFOResponseDto;
}

/**
    * @export
    * @enum {string}
    */
export enum AutocompleteUniteFOResultDtoFieldEnum {
    'CODE' = 'CODE',
    'UNITE' = 'UNITE',
    'ABREVIATION' = 'ABREVIATION'
}

/**
 * 
 * @export
 * @interface AutoriteFourriereDto
 */
export interface AutoriteFourriereDto {
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    cedex: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    codeInsee: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    codePostal: string;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    commentaires: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    dateConfirmationUtilisateur: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AutoriteFourriereDto
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    idAlienation: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    idAlienationUtilisateur: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    libelleComplet: string;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    libelleDepartement: string;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    numeroDepartement: string;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    numeroVoie: string | null;
    /**
     * 
     * @type {TypeAutoriteFourriereDto}
     * @memberof AutoriteFourriereDto
     */
    type: TypeAutoriteFourriereDto;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    ville: string;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereDto
     */
    voie: string;
}
/**
 * 
 * @export
 * @interface AutoriteFourriereRequestDto
 */
export interface AutoriteFourriereRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    cedex: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    commentaires: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    complement: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    idAlienation: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    idAlienationUtilisateur: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    idCorrelationType: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    insee: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    libelle: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    libelleDepartement: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    numeroDepartement: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    numeroVoie: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    ville: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereRequestDto
     */
    voie: string | null;
}
/**
 * 
 * @export
 * @interface AutoriteFourriereViolationDto
 */
export interface AutoriteFourriereViolationDto {
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereViolationDto
     */
    formField: AutoriteFourriereViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof AutoriteFourriereViolationDto
     */
    violationCode: AutoriteFourriereViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AutoriteFourriereViolationDtoFormFieldEnum {
    'NUMERO_DEPARTEMENT' = 'NUMERO_DEPARTEMENT',
    'LIBELLE_DEPARTEMENT' = 'LIBELLE_DEPARTEMENT',
    'TYPE' = 'TYPE',
    'LIBELLE' = 'LIBELLE',
    'CODE_POSTAL' = 'CODE_POSTAL',
    'VILLE' = 'VILLE',
    'VOIE' = 'VOIE',
    'ID_ALIENATION' = 'ID_ALIENATION',
    'ID_ALIENATION_UTILISATEUR' = 'ID_ALIENATION_UTILISATEUR'
}
/**
    * @export
    * @enum {string}
    */
export enum AutoriteFourriereViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'LIBELLE_ALREADY_EXISTS' = 'LIBELLE_ALREADY_EXISTS',
    'TYPE_NOT_FOUND' = 'TYPE_NOT_FOUND',
    'LIBELLE_BAD_FORMAT' = 'LIBELLE_BAD_FORMAT',
    'CODE_POSTAL_BAD_FORMAT' = 'CODE_POSTAL_BAD_FORMAT',
    'ID_ALIENATION_BAD_FORMAT' = 'ID_ALIENATION_BAD_FORMAT',
    'ID_ALIENATION_UNICITY_VIOLATION' = 'ID_ALIENATION_UNICITY_VIOLATION',
    'ID_ALIENATION_UTILISATEUR_UNICITY_VIOLATION' = 'ID_ALIENATION_UTILISATEUR_UNICITY_VIOLATION',
    'INVALID_TYPE' = 'INVALID_TYPE',
    'TYPE_UNICITY' = 'TYPE_UNICITY'
}

/**
 * 
 * @export
 * @interface AutoriteMainleveeDto
 */
export interface AutoriteMainleveeDto {
    /**
     * 
     * @type {string}
     * @memberof AutoriteMainleveeDto
     */
    description: string | null;
}
/**
 * 
 * @export
 * @interface AutoritePrescriptriceDto
 */
export interface AutoritePrescriptriceDto {
    /**
     * 
     * @type {string}
     * @memberof AutoritePrescriptriceDto
     */
    nomAutorite: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutoritePrescriptriceDto
     */
    qualiteAutorite: AutoritePrescriptriceDtoQualiteAutoriteEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum AutoritePrescriptriceDtoQualiteAutoriteEnum {
    'OPJ' = 'OPJ',
    'APJ' = 'APJ',
    'APJA' = 'APJA'
}

/**
 * 
 * @export
 * @interface AvailablePieceJointeDto
 */
export interface AvailablePieceJointeDto {
    /**
     * 
     * @type {string}
     * @memberof AvailablePieceJointeDto
     */
    identifiant: string;
    /**
     * 
     * @type {string}
     * @memberof AvailablePieceJointeDto
     */
    libelle: string;
}
/**
 * 
 * @export
 * @interface BonEnlevementGardienDto
 */
export interface BonEnlevementGardienDto {
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    dateBon: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    idCorrelationCentreVhu: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BonEnlevementGardienDto
     */
    isCarteGriseRetiree: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    motifAbsenceImmatriculation: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    numeroAgrement: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    numeroSiren: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    prefectureAgrement: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienDto
     */
    raisonSociale: string | null;
}
/**
 * 
 * @export
 * @interface BonEnlevementGardienRequestDto
 */
export interface BonEnlevementGardienRequestDto {
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienRequestDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienRequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienRequestDto
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienRequestDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienRequestDto
     */
    idCorrelationCentreVhu: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BonEnlevementGardienRequestDto
     */
    isCarteGriseRetiree: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienRequestDto
     */
    motifAbsenceImmatriculation: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienRequestDto
     */
    numeroAgrement: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienRequestDto
     */
    numeroSiren: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienRequestDto
     */
    prefectureAgrement: string | null;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienRequestDto
     */
    raisonSociale: string | null;
}
/**
 * 
 * @export
 * @interface BonEnlevementGardienViolationDto
 */
export interface BonEnlevementGardienViolationDto {
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienViolationDto
     */
    formField: BonEnlevementGardienViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof BonEnlevementGardienViolationDto
     */
    violationCode: BonEnlevementGardienViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum BonEnlevementGardienViolationDtoFormFieldEnum {
    'ID_CORRELATION_CENTRE_VHU' = 'ID_CORRELATION_CENTRE_VHU',
    'FLAG_CARTE_GRISE_RETIREE' = 'FLAG_CARTE_GRISE_RETIREE',
    'MOTIF_ABSENCE_IMMATRICULATION' = 'MOTIF_ABSENCE_IMMATRICULATION',
    'RAISON_SOCIALE' = 'RAISON_SOCIALE',
    'NUMERO_SIREN' = 'NUMERO_SIREN',
    'NUMERO_VOIE' = 'NUMERO_VOIE',
    'ADRESSE' = 'ADRESSE',
    'COMPLEMENT_ADRESSE' = 'COMPLEMENT_ADRESSE',
    'CODE_POSTAL' = 'CODE_POSTAL',
    'COMMUNE' = 'COMMUNE',
    'NUMERO_AGREMENT' = 'NUMERO_AGREMENT',
    'PREFECTURE_AGREMENT' = 'PREFECTURE_AGREMENT'
}
/**
    * @export
    * @enum {string}
    */
export enum BonEnlevementGardienViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'CODE_POSTAL_WRONG_FORMAT' = 'CODE_POSTAL_WRONG_FORMAT',
    'NUMERO_SIREN_WRONG_FORMAT' = 'NUMERO_SIREN_WRONG_FORMAT',
    'UNKNOWN_CENTRE_VHU' = 'UNKNOWN_CENTRE_VHU'
}

/**
 * 
 * @export
 * @interface BrancheDto
 */
export interface BrancheDto {
    /**
     * 
     * @type {string}
     * @memberof BrancheDto
     */
    branche: BrancheDtoBrancheEnum;
    /**
     * 
     * @type {string}
     * @memberof BrancheDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BrancheDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof BrancheDto
     */
    nature: string;
}

/**
    * @export
    * @enum {string}
    */
export enum BrancheDtoBrancheEnum {
    'ADMINISTRATIVE' = 'ADMINISTRATIVE',
    'NORMALE' = 'NORMALE',
    'INERTE' = 'INERTE',
    'MAITRE_LIEU' = 'MAITRE_LIEU',
    'VOL' = 'VOL'
}

/**
 * 
 * @export
 * @interface BrancheRequestDto
 */
export interface BrancheRequestDto {
    /**
     * 
     * @type {string}
     * @memberof BrancheRequestDto
     */
    branche: BrancheRequestDtoBrancheEnum | null;
    /**
     * 
     * @type {string}
     * @memberof BrancheRequestDto
     */
    nature: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum BrancheRequestDtoBrancheEnum {
    'ADMINISTRATIVE' = 'ADMINISTRATIVE',
    'NORMALE' = 'NORMALE',
    'INERTE' = 'INERTE',
    'MAITRE_LIEU' = 'MAITRE_LIEU',
    'VOL' = 'VOL'
}

/**
 * 
 * @export
 * @interface BrancheViolationDto
 */
export interface BrancheViolationDto {
    /**
     * 
     * @type {string}
     * @memberof BrancheViolationDto
     */
    formField: BrancheViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof BrancheViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof BrancheViolationDto
     */
    violationCode: BrancheViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum BrancheViolationDtoFormFieldEnum {
    'NATURE' = 'NATURE',
    'BRANCHE' = 'BRANCHE'
}
/**
    * @export
    * @enum {string}
    */
export enum BrancheViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD'
}

/**
 * 
 * @export
 * @interface CamundaProcessInstanceDto
 */
export interface CamundaProcessInstanceDto {
    /**
     * 
     * @type {string}
     * @memberof CamundaProcessInstanceDto
     */
    processInstanceId: string;
}
/**
 * 
 * @export
 * @interface CentreVHUDto
 */
export interface CentreVHUDto {
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    adresseMail: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    codePostal: string;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    numeroAgrementVHU: string;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    prefecture: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    raisonSociale: string;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    siren: string;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUDto
     */
    telephone: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CentreVHUDto
     */
    valid: boolean;
}
/**
 * 
 * @export
 * @interface CentreVHURequestDto
 */
export interface CentreVHURequestDto {
    /**
     * 
     * @type {string}
     * @memberof CentreVHURequestDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHURequestDto
     */
    adresseMail: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHURequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHURequestDto
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHURequestDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHURequestDto
     */
    numeroAgrementVHU: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHURequestDto
     */
    prefecture: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHURequestDto
     */
    raisonSociale: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHURequestDto
     */
    siren: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreVHURequestDto
     */
    telephone: string | null;
}
/**
 * 
 * @export
 * @interface CentreVHUViolationDto
 */
export interface CentreVHUViolationDto {
    /**
     * 
     * @type {string}
     * @memberof CentreVHUViolationDto
     */
    formField: CentreVHUViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CentreVHUViolationDto
     */
    violationCode: CentreVHUViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CentreVHUViolationDtoFormFieldEnum {
    'RAISON_SOCIALE' = 'RAISON_SOCIALE',
    'SIREN' = 'SIREN',
    'ADRESSE' = 'ADRESSE',
    'COMPLEMENT_ADRESSE' = 'COMPLEMENT_ADRESSE',
    'CODE_POSTAL' = 'CODE_POSTAL',
    'COMMUNE' = 'COMMUNE',
    'TELEPHONE' = 'TELEPHONE',
    'EMAIL' = 'EMAIL',
    'NUMERO_AGREMENT_VHU' = 'NUMERO_AGREMENT_VHU',
    'PREFECTURE_DELIVRANTE' = 'PREFECTURE_DELIVRANTE'
}
/**
    * @export
    * @enum {string}
    */
export enum CentreVHUViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'RAISON_SOCIALE_BAD_FORMAT' = 'RAISON_SOCIALE_BAD_FORMAT',
    'CODE_POSTAL_BAD_FORMAT' = 'CODE_POSTAL_BAD_FORMAT',
    'SIREN_BAD_FORMAT' = 'SIREN_BAD_FORMAT',
    'COMMUNE_BAD_FORMAT' = 'COMMUNE_BAD_FORMAT',
    'TELEPHONE_BAD_FORMAT' = 'TELEPHONE_BAD_FORMAT',
    'NUMERO_AGREMENT_BAD_FORMAT' = 'NUMERO_AGREMENT_BAD_FORMAT',
    'NUMERO_AGREMENT_ALREADY_USED' = 'NUMERO_AGREMENT_ALREADY_USED',
    'EMAIL_BAD_FORMAT' = 'EMAIL_BAD_FORMAT',
    'INVALID_TYPE' = 'INVALID_TYPE'
}

/**
 * 
 * @export
 * @interface CommentaireRequestDto
 */
export interface CommentaireRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CommentaireRequestDto
     */
    contenu: string | null;
}
/**
 * 
 * @export
 * @interface CommentaireResponseDto
 */
export interface CommentaireResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CommentaireResponseDto
     */
    contenu: string;
    /**
     * 
     * @type {string}
     * @memberof CommentaireResponseDto
     */
    dateAjout: string;
    /**
     * 
     * @type {string}
     * @memberof CommentaireResponseDto
     */
    dateDerniereModification: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentaireResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CommentaireResponseDto
     */
    libelleEntiteRattachement: string;
    /**
     * 
     * @type {string}
     * @memberof CommentaireResponseDto
     */
    profile: CommentaireResponseDtoProfileEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentaireResponseDto
     */
    userFirstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentaireResponseDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentaireResponseDto
     */
    userLastName: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum CommentaireResponseDtoProfileEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface CommentaireViolationDto
 */
export interface CommentaireViolationDto {
    /**
     * 
     * @type {string}
     * @memberof CommentaireViolationDto
     */
    formField: CommentaireViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentaireViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CommentaireViolationDto
     */
    violationCode: CommentaireViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CommentaireViolationDtoFormFieldEnum {
    'CONTENU' = 'CONTENU'
}
/**
    * @export
    * @enum {string}
    */
export enum CommentaireViolationDtoViolationCodeEnum {
    'MISSING_OR_BLANK_CONTENU' = 'MISSING_OR_BLANK_CONTENU',
    'TEXT_TOO_LONG' = 'TEXT_TOO_LONG'
}

/**
 * 
 * @export
 * @interface ComputedResponseDto
 */
export interface ComputedResponseDto {
    /**
     * 
     * @type {AutoriteFourriereDto}
     * @memberof ComputedResponseDto
     */
    autoriteFourriereDto: AutoriteFourriereDto | null;
    /**
     * 
     * @type {BrancheDto}
     * @memberof ComputedResponseDto
     */
    currentBrancheWorkflow: BrancheDto | null;
    /**
     * 
     * @type {string}
     * @memberof ComputedResponseDto
     */
    dateAvantClassementDestruction: string | null;
    /**
     * 
     * @type {string}
     * @memberof ComputedResponseDto
     */
    dateFinMefAdministrative: string | null;
    /**
     * 
     * @type {string}
     * @memberof ComputedResponseDto
     */
    dateNewBranche: string | null;
    /**
     * 
     * @type {FourriereDto}
     * @memberof ComputedResponseDto
     */
    fourriereDto: FourriereDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof ComputedResponseDto
     */
    impossibiliteNotifier: boolean | null;
    /**
     * 
     * @type {JuridictionResponseDto}
     * @memberof ComputedResponseDto
     */
    juridictionDto: JuridictionResponseDto | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof ComputedResponseDto
     */
    listActions: Array<ComputedResponseDtoListActionsEnum> | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof ComputedResponseDto
     */
    listActionsRequises: Array<ComputedResponseDtoListActionsRequisesEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComputedResponseDto
     */
    listAvailableFiles: Array<ComputedResponseDtoListAvailableFilesEnum> | null;
    /**
     * 
     * @type {Array<AvailablePieceJointeDto>}
     * @memberof ComputedResponseDto
     */
    listAvailablePiecesJointes: Array<AvailablePieceJointeDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ComputedResponseDto
     */
    statutConsultable: ComputedResponseDtoStatutConsultableEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ComputedResponseDto
     */
    suiviDestructionSiv: ComputedResponseDtoSuiviDestructionSivEnum | null;
    /**
     * 
     * @type {UniteFOResponseDto}
     * @memberof ComputedResponseDto
     */
    uniteFODto: UniteFOResponseDto | null;
}

/**
    * @export
    * @enum {string}
    */
export enum ComputedResponseDtoListActionsEnum {
    'PROLONGER_MEF' = 'PROLONGER_MEF',
    'MODIFIER_COORDONNEES_PROPRIETAIRE' = 'MODIFIER_COORDONNEES_PROPRIETAIRE',
    'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' = 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE',
    'RENSEIGNER_SORTIE_VEHICULE' = 'RENSEIGNER_SORTIE_VEHICULE',
    'SAISIE_VHU' = 'SAISIE_VHU',
    'SAISIE_NOTIFICATION_MANUELLE' = 'SAISIE_NOTIFICATION_MANUELLE',
    'MAIN_LEVEE' = 'MAIN_LEVEE',
    'TRAITE_EN_FACTURATION' = 'TRAITE_EN_FACTURATION',
    'NON_TRAITE_EN_FACTURATION' = 'NON_TRAITE_EN_FACTURATION',
    'ANNULATION_SORTIE_VEHICULE' = 'ANNULATION_SORTIE_VEHICULE',
    'EXPORT_DONNEES_DOSSIER' = 'EXPORT_DONNEES_DOSSIER',
    'SUPPRESSION_DOSSIER' = 'SUPPRESSION_DOSSIER',
    'SUPPRESSION_DOSSIER_BY_FO' = 'SUPPRESSION_DOSSIER_BY_FO',
    'UPDATE_ENTITES_RATTACHEMENT_ADMIN' = 'UPDATE_ENTITES_RATTACHEMENT_ADMIN',
    'UPDATE_ENTITES_RATTACHEMENT_FO_AF' = 'UPDATE_ENTITES_RATTACHEMENT_FO_AF',
    'MODIFICATION_SORTIE_VEHICULE' = 'MODIFICATION_SORTIE_VEHICULE',
    'UPDATE_DONNEES_VEHICULE' = 'UPDATE_DONNEES_VEHICULE',
    'UPDATE_DONNEES_VEHICULE_JUSTICE' = 'UPDATE_DONNEES_VEHICULE_JUSTICE',
    'UPDATE_CLASSEMENT' = 'UPDATE_CLASSEMENT',
    'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' = 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE',
    'ENREGISTRER_ENTREE' = 'ENREGISTRER_ENTREE',
    'CONTROLER_DONNEES_VEHICULE' = 'CONTROLER_DONNEES_VEHICULE',
    'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' = 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE',
    'RELANCE_VENTE_VOL' = 'RELANCE_VENTE_VOL',
    'RELANCE_VENTE_IMMO_PJ' = 'RELANCE_VENTE_IMMO_PJ',
    'RELANCE_VENTE_OPPOSITION' = 'RELANCE_VENTE_OPPOSITION',
    'RELANCE_VENTE_DOUBLON' = 'RELANCE_VENTE_DOUBLON',
    'RELANCE_VENTE_MANQUANT' = 'RELANCE_VENTE_MANQUANT',
    'RECUPERATION_AR_PND_AUTOMATIQUE' = 'RECUPERATION_AR_PND_AUTOMATIQUE',
    'CONTROLE_BLOCAGE_ARGOS' = 'CONTROLE_BLOCAGE_ARGOS',
    'CONTROLE_BLOCAGE_ANTAI' = 'CONTROLE_BLOCAGE_ANTAI',
    'CONTROLE_BLOCAGE_DNID' = 'CONTROLE_BLOCAGE_DNID',
    'RECUPERATION_COURRIER_AUTOMATIQUE' = 'RECUPERATION_COURRIER_AUTOMATIQUE',
    'RENSEIGNER_INFORMATIONS_SIV' = 'RENSEIGNER_INFORMATIONS_SIV',
    'CONFIRMER_VOL_VVNR' = 'CONFIRMER_VOL_VVNR',
    'VALIDATION_ACTIONS_VVNR_HORS_SIF' = 'VALIDATION_ACTIONS_VVNR_HORS_SIF',
    'IMPORTER_PIECES_JOINTES' = 'IMPORTER_PIECES_JOINTES',
    'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' = 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE',
    'UPDATE_DONNEES_JUDICIAIRE' = 'UPDATE_DONNEES_JUDICIAIRE'
}
/**
    * @export
    * @enum {string}
    */
export enum ComputedResponseDtoListActionsRequisesEnum {
    'PROLONGER_MEF' = 'PROLONGER_MEF',
    'MODIFIER_COORDONNEES_PROPRIETAIRE' = 'MODIFIER_COORDONNEES_PROPRIETAIRE',
    'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' = 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE',
    'RENSEIGNER_SORTIE_VEHICULE' = 'RENSEIGNER_SORTIE_VEHICULE',
    'SAISIE_VHU' = 'SAISIE_VHU',
    'SAISIE_NOTIFICATION_MANUELLE' = 'SAISIE_NOTIFICATION_MANUELLE',
    'MAIN_LEVEE' = 'MAIN_LEVEE',
    'TRAITE_EN_FACTURATION' = 'TRAITE_EN_FACTURATION',
    'NON_TRAITE_EN_FACTURATION' = 'NON_TRAITE_EN_FACTURATION',
    'ANNULATION_SORTIE_VEHICULE' = 'ANNULATION_SORTIE_VEHICULE',
    'EXPORT_DONNEES_DOSSIER' = 'EXPORT_DONNEES_DOSSIER',
    'SUPPRESSION_DOSSIER' = 'SUPPRESSION_DOSSIER',
    'SUPPRESSION_DOSSIER_BY_FO' = 'SUPPRESSION_DOSSIER_BY_FO',
    'UPDATE_ENTITES_RATTACHEMENT_ADMIN' = 'UPDATE_ENTITES_RATTACHEMENT_ADMIN',
    'UPDATE_ENTITES_RATTACHEMENT_FO_AF' = 'UPDATE_ENTITES_RATTACHEMENT_FO_AF',
    'MODIFICATION_SORTIE_VEHICULE' = 'MODIFICATION_SORTIE_VEHICULE',
    'UPDATE_DONNEES_VEHICULE' = 'UPDATE_DONNEES_VEHICULE',
    'UPDATE_DONNEES_VEHICULE_JUSTICE' = 'UPDATE_DONNEES_VEHICULE_JUSTICE',
    'UPDATE_CLASSEMENT' = 'UPDATE_CLASSEMENT',
    'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' = 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE',
    'ENREGISTRER_ENTREE' = 'ENREGISTRER_ENTREE',
    'CONTROLER_DONNEES_VEHICULE' = 'CONTROLER_DONNEES_VEHICULE',
    'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' = 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE',
    'RELANCE_VENTE_VOL' = 'RELANCE_VENTE_VOL',
    'RELANCE_VENTE_IMMO_PJ' = 'RELANCE_VENTE_IMMO_PJ',
    'RELANCE_VENTE_OPPOSITION' = 'RELANCE_VENTE_OPPOSITION',
    'RELANCE_VENTE_DOUBLON' = 'RELANCE_VENTE_DOUBLON',
    'RELANCE_VENTE_MANQUANT' = 'RELANCE_VENTE_MANQUANT',
    'RECUPERATION_AR_PND_AUTOMATIQUE' = 'RECUPERATION_AR_PND_AUTOMATIQUE',
    'CONTROLE_BLOCAGE_ARGOS' = 'CONTROLE_BLOCAGE_ARGOS',
    'CONTROLE_BLOCAGE_ANTAI' = 'CONTROLE_BLOCAGE_ANTAI',
    'CONTROLE_BLOCAGE_DNID' = 'CONTROLE_BLOCAGE_DNID',
    'RECUPERATION_COURRIER_AUTOMATIQUE' = 'RECUPERATION_COURRIER_AUTOMATIQUE',
    'RENSEIGNER_INFORMATIONS_SIV' = 'RENSEIGNER_INFORMATIONS_SIV',
    'CONFIRMER_VOL_VVNR' = 'CONFIRMER_VOL_VVNR',
    'VALIDATION_ACTIONS_VVNR_HORS_SIF' = 'VALIDATION_ACTIONS_VVNR_HORS_SIF',
    'IMPORTER_PIECES_JOINTES' = 'IMPORTER_PIECES_JOINTES',
    'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' = 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE',
    'UPDATE_DONNEES_JUDICIAIRE' = 'UPDATE_DONNEES_JUDICIAIRE'
}
/**
    * @export
    * @enum {string}
    */
export enum ComputedResponseDtoListAvailableFilesEnum {
    'DECISION_CLASSEMENT' = 'DECISION_CLASSEMENT',
    'DECISION_DESTRUCTION' = 'DECISION_DESTRUCTION',
    'CONSTAT_ABANDON' = 'CONSTAT_ABANDON',
    'DECISION_REMISE_DOMAINE' = 'DECISION_REMISE_DOMAINE',
    'BON_ENLEVEMENT_DESTRUCTION' = 'BON_ENLEVEMENT_DESTRUCTION',
    'FICHE_DESCRIPTIVE' = 'FICHE_DESCRIPTIVE',
    'PRESCRIPTION_MEF' = 'PRESCRIPTION_MEF',
    'MAIN_LEVEE_FO' = 'MAIN_LEVEE_FO',
    'MAIN_LEVEE_USAGER' = 'MAIN_LEVEE_USAGER',
    'COURRIER_NOTIFICATION' = 'COURRIER_NOTIFICATION',
    'AR_PND_NOTIFICATION' = 'AR_PND_NOTIFICATION'
}
/**
    * @export
    * @enum {string}
    */
export enum ComputedResponseDtoStatutConsultableEnum {
    'A_REMPLIR' = 'A_REMPLIR',
    'ENREGISTRE' = 'ENREGISTRE',
    'NON_GERE' = 'NON_GERE',
    'NOTIFICATION_ENVOYEE' = 'NOTIFICATION_ENVOYEE',
    'NOTIFIE' = 'NOTIFIE',
    'A_NOTIFIER' = 'A_NOTIFIER',
    'EN_COURS_DE_NOTIFICATION' = 'EN_COURS_DE_NOTIFICATION',
    'A_REMETTRE_AUX_DOMAINES' = 'A_REMETTRE_AUX_DOMAINES',
    'REMIS_AU_DOMAINE' = 'REMIS_AU_DOMAINE',
    'MIS_EN_VENTE' = 'MIS_EN_VENTE',
    'VENDU' = 'VENDU',
    'A_RESTITUER' = 'A_RESTITUER',
    'VENTE_BLOQUEE' = 'VENTE_BLOQUEE',
    'A_DETRUIRE' = 'A_DETRUIRE',
    'SORTI' = 'SORTI',
    'DETRUIT' = 'DETRUIT'
}
/**
    * @export
    * @enum {string}
    */
export enum ComputedResponseDtoSuiviDestructionSivEnum {
    'NON_APPLICABLE' = 'NON_APPLICABLE',
    'DETRUIT_APRES_SORTIE' = 'DETRUIT_APRES_SORTIE',
    'EN_ATTENTE_APPEL' = 'EN_ATTENTE_APPEL',
    'EN_ATTENTE_DEUXIEME_APPEL' = 'EN_ATTENTE_DEUXIEME_APPEL',
    'NON_DETRUIT_APRES_DELAI' = 'NON_DETRUIT_APRES_DELAI'
}

/**
 * 
 * @export
 * @interface ComputedSummaryResponseDto
 */
export interface ComputedSummaryResponseDto {
    /**
     * 
     * @type {BrancheDto}
     * @memberof ComputedSummaryResponseDto
     */
    brancheDto: BrancheDto | null;
    /**
     * 
     * @type {FourriereDto}
     * @memberof ComputedSummaryResponseDto
     */
    fourriereDto: FourriereDto | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof ComputedSummaryResponseDto
     */
    listActionsRequises: Array<ComputedSummaryResponseDtoListActionsRequisesEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof ComputedSummaryResponseDto
     */
    statutConsultable: ComputedSummaryResponseDtoStatutConsultableEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ComputedSummaryResponseDto
     */
    uniteFo: string | null;
    /**
     * 
     * @type {string}
     * @memberof ComputedSummaryResponseDto
     */
    uniteFoAbreviation: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum ComputedSummaryResponseDtoListActionsRequisesEnum {
    'PROLONGER_MEF' = 'PROLONGER_MEF',
    'MODIFIER_COORDONNEES_PROPRIETAIRE' = 'MODIFIER_COORDONNEES_PROPRIETAIRE',
    'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' = 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE',
    'RENSEIGNER_SORTIE_VEHICULE' = 'RENSEIGNER_SORTIE_VEHICULE',
    'SAISIE_VHU' = 'SAISIE_VHU',
    'SAISIE_NOTIFICATION_MANUELLE' = 'SAISIE_NOTIFICATION_MANUELLE',
    'MAIN_LEVEE' = 'MAIN_LEVEE',
    'TRAITE_EN_FACTURATION' = 'TRAITE_EN_FACTURATION',
    'NON_TRAITE_EN_FACTURATION' = 'NON_TRAITE_EN_FACTURATION',
    'ANNULATION_SORTIE_VEHICULE' = 'ANNULATION_SORTIE_VEHICULE',
    'EXPORT_DONNEES_DOSSIER' = 'EXPORT_DONNEES_DOSSIER',
    'SUPPRESSION_DOSSIER' = 'SUPPRESSION_DOSSIER',
    'SUPPRESSION_DOSSIER_BY_FO' = 'SUPPRESSION_DOSSIER_BY_FO',
    'UPDATE_ENTITES_RATTACHEMENT_ADMIN' = 'UPDATE_ENTITES_RATTACHEMENT_ADMIN',
    'UPDATE_ENTITES_RATTACHEMENT_FO_AF' = 'UPDATE_ENTITES_RATTACHEMENT_FO_AF',
    'MODIFICATION_SORTIE_VEHICULE' = 'MODIFICATION_SORTIE_VEHICULE',
    'UPDATE_DONNEES_VEHICULE' = 'UPDATE_DONNEES_VEHICULE',
    'UPDATE_DONNEES_VEHICULE_JUSTICE' = 'UPDATE_DONNEES_VEHICULE_JUSTICE',
    'UPDATE_CLASSEMENT' = 'UPDATE_CLASSEMENT',
    'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' = 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE',
    'ENREGISTRER_ENTREE' = 'ENREGISTRER_ENTREE',
    'CONTROLER_DONNEES_VEHICULE' = 'CONTROLER_DONNEES_VEHICULE',
    'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' = 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE',
    'RELANCE_VENTE_VOL' = 'RELANCE_VENTE_VOL',
    'RELANCE_VENTE_IMMO_PJ' = 'RELANCE_VENTE_IMMO_PJ',
    'RELANCE_VENTE_OPPOSITION' = 'RELANCE_VENTE_OPPOSITION',
    'RELANCE_VENTE_DOUBLON' = 'RELANCE_VENTE_DOUBLON',
    'RELANCE_VENTE_MANQUANT' = 'RELANCE_VENTE_MANQUANT',
    'RECUPERATION_AR_PND_AUTOMATIQUE' = 'RECUPERATION_AR_PND_AUTOMATIQUE',
    'CONTROLE_BLOCAGE_ARGOS' = 'CONTROLE_BLOCAGE_ARGOS',
    'CONTROLE_BLOCAGE_ANTAI' = 'CONTROLE_BLOCAGE_ANTAI',
    'CONTROLE_BLOCAGE_DNID' = 'CONTROLE_BLOCAGE_DNID',
    'RECUPERATION_COURRIER_AUTOMATIQUE' = 'RECUPERATION_COURRIER_AUTOMATIQUE',
    'RENSEIGNER_INFORMATIONS_SIV' = 'RENSEIGNER_INFORMATIONS_SIV',
    'CONFIRMER_VOL_VVNR' = 'CONFIRMER_VOL_VVNR',
    'VALIDATION_ACTIONS_VVNR_HORS_SIF' = 'VALIDATION_ACTIONS_VVNR_HORS_SIF',
    'IMPORTER_PIECES_JOINTES' = 'IMPORTER_PIECES_JOINTES',
    'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' = 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE',
    'UPDATE_DONNEES_JUDICIAIRE' = 'UPDATE_DONNEES_JUDICIAIRE'
}
/**
    * @export
    * @enum {string}
    */
export enum ComputedSummaryResponseDtoStatutConsultableEnum {
    'A_REMPLIR' = 'A_REMPLIR',
    'ENREGISTRE' = 'ENREGISTRE',
    'NON_GERE' = 'NON_GERE',
    'NOTIFICATION_ENVOYEE' = 'NOTIFICATION_ENVOYEE',
    'NOTIFIE' = 'NOTIFIE',
    'A_NOTIFIER' = 'A_NOTIFIER',
    'EN_COURS_DE_NOTIFICATION' = 'EN_COURS_DE_NOTIFICATION',
    'A_REMETTRE_AUX_DOMAINES' = 'A_REMETTRE_AUX_DOMAINES',
    'REMIS_AU_DOMAINE' = 'REMIS_AU_DOMAINE',
    'MIS_EN_VENTE' = 'MIS_EN_VENTE',
    'VENDU' = 'VENDU',
    'A_RESTITUER' = 'A_RESTITUER',
    'VENTE_BLOQUEE' = 'VENTE_BLOQUEE',
    'A_DETRUIRE' = 'A_DETRUIRE',
    'SORTI' = 'SORTI',
    'DETRUIT' = 'DETRUIT'
}

/**
 * 
 * @export
 * @interface ConditionsReactivateAutoriteFourriereDto
 */
export interface ConditionsReactivateAutoriteFourriereDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateAutoriteFourriereDto
     */
    alreadyExistsLibelle: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateAutoriteFourriereDto
     */
    alreadyExistsType: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateAutoriteFourriereDto
     */
    autoriteFourriereValid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateAutoriteFourriereDto
     */
    reactivationAvailable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateAutoriteFourriereDto
     */
    typeValid: boolean;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateCentreVHUDto
 */
export interface ConditionsReactivateCentreVHUDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateCentreVHUDto
     */
    alreadyExists: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateCentreVHUDto
     */
    centreVHUValid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateCentreVHUDto
     */
    reactivationAvailable: boolean;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateEtatDto
 */
export interface ConditionsReactivateEtatDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateEtatDto
     */
    alreadyExist: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateEtatDto
     */
    etatValid: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateEtatDto
     */
    reactivationAvailable: boolean | null;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateFaqDomainDto
 */
export interface ConditionsReactivateFaqDomainDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFaqDomainDto
     */
    alreadyExists: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFaqDomainDto
     */
    faqDomainValid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFaqDomainDto
     */
    reactivationAvailable: boolean;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateFaqDto
 */
export interface ConditionsReactivateFaqDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFaqDto
     */
    alreadyExists: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFaqDto
     */
    faqValid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFaqDto
     */
    reactivationAvailable: boolean;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateFooterLinkDto
 */
export interface ConditionsReactivateFooterLinkDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFooterLinkDto
     */
    alreadyExist: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFooterLinkDto
     */
    linkValid: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFooterLinkDto
     */
    reactivationAvailable: boolean | null;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateFourriereDto
 */
export interface ConditionsReactivateFourriereDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFourriereDto
     */
    alreadyExists: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFourriereDto
     */
    fourriereValid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateFourriereDto
     */
    reactivationAvailable: boolean;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateGenreSimplifieDto
 */
export interface ConditionsReactivateGenreSimplifieDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateGenreSimplifieDto
     */
    alreadyExist: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateGenreSimplifieDto
     */
    genreSimplifieValid: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateGenreSimplifieDto
     */
    reactivationAvailable: boolean | null;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateJuridictionDto
 */
export interface ConditionsReactivateJuridictionDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateJuridictionDto
     */
    juridictionParentValid: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateJuridictionDto
     */
    juridictionValid: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateJuridictionDto
     */
    reactivationAvailable: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateJuridictionDto
     */
    unicity: boolean | null;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateMotifMefDto
 */
export interface ConditionsReactivateMotifMefDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateMotifMefDto
     */
    alreadyExist: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateMotifMefDto
     */
    motifMefValid: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateMotifMefDto
     */
    reactivationAvailable: boolean | null;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateMotifSortieDto
 */
export interface ConditionsReactivateMotifSortieDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateMotifSortieDto
     */
    alreadyExist: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateMotifSortieDto
     */
    motifSortieValid: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateMotifSortieDto
     */
    reactivationAvailable: boolean | null;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateTypeAutoriteFourriereDto
 */
export interface ConditionsReactivateTypeAutoriteFourriereDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateTypeAutoriteFourriereDto
     */
    alreadyExist: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateTypeAutoriteFourriereDto
     */
    reactivationAvailable: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateTypeAutoriteFourriereDto
     */
    typeValid: boolean | null;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateUniteFoDto
 */
export interface ConditionsReactivateUniteFoDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateUniteFoDto
     */
    reactivationAvailable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateUniteFoDto
     */
    uniteAbreviationUnique: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateUniteFoDto
     */
    uniteCodeUnique: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateUniteFoDto
     */
    uniteParentValid: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateUniteFoDto
     */
    uniteUniteUnique: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateUniteFoDto
     */
    uniteValid: boolean;
}
/**
 * 
 * @export
 * @interface ConditionsReactivateVideoTutorielDto
 */
export interface ConditionsReactivateVideoTutorielDto {
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateVideoTutorielDto
     */
    alreadyExist: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateVideoTutorielDto
     */
    reactivationAvailable: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionsReactivateVideoTutorielDto
     */
    videoTutorielValid: boolean | null;
}
/**
 * 
 * @export
 * @interface ConfigurationDto
 */
export interface ConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    microServiceName: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    parsingError: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationDto
     */
    readOnly: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    value: string;
}
/**
 * 
 * @export
 * @interface ConfigurationHistoriqueDto
 */
export interface ConfigurationHistoriqueDto {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHistoriqueDto
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHistoriqueDto
     */
    endOfValidity: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHistoriqueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationHistoriqueDto
     */
    value: string;
}
/**
 * 
 * @export
 * @interface ConfigurationUpdateRequestDto
 */
export interface ConfigurationUpdateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationUpdateRequestDto
     */
    newDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationUpdateRequestDto
     */
    newValue: string | null;
}
/**
 * 
 * @export
 * @interface ControleDonneesVehiculeBlocageVenteRequestDto
 */
export interface ControleDonneesVehiculeBlocageVenteRequestDto {
    /**
     * 
     * @type {ControleDonneesVehiculeRequestDto}
     * @memberof ControleDonneesVehiculeBlocageVenteRequestDto
     */
    nouvellesDonneesVehicule: ControleDonneesVehiculeRequestDto;
    /**
     * 
     * @type {string}
     * @memberof ControleDonneesVehiculeBlocageVenteRequestDto
     */
    statut: string;
}
/**
 * 
 * @export
 * @interface ControleDonneesVehiculeRequestDto
 */
export interface ControleDonneesVehiculeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ControleDonneesVehiculeRequestDto
     */
    newGenre: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControleDonneesVehiculeRequestDto
     */
    newMarque: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControleDonneesVehiculeRequestDto
     */
    newMarqueNonReferencee: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ControleDonneesVehiculeRequestDto
     */
    newModele: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControleDonneesVehiculeRequestDto
     */
    newModeleNonReference: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControleDonneesVehiculeRequestDto
     */
    newPaysEtranger: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ControleDonneesVehiculeRequestDto
     */
    newPlaqueImmatriculation: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControleDonneesVehiculeRequestDto
     */
    newPlaqueImmatriculationVisible: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControleDonneesVehiculeRequestDto
     */
    newSansPlaque: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ControleDonneesVehiculeRequestDto
     */
    newVin: string | null;
}
/**
 * 
 * @export
 * @interface ControleDonneesVehiculeViolationDto
 */
export interface ControleDonneesVehiculeViolationDto {
    /**
     * 
     * @type {string}
     * @memberof ControleDonneesVehiculeViolationDto
     */
    formField: ControleDonneesVehiculeViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof ControleDonneesVehiculeViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ControleDonneesVehiculeViolationDto
     */
    violationCode: ControleDonneesVehiculeViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ControleDonneesVehiculeViolationDtoFormFieldEnum {
    'NEW_MARQUE' = 'NEW_MARQUE',
    'NEW_MODELE' = 'NEW_MODELE',
    'NEW_GENRE' = 'NEW_GENRE',
    'NEW_PAYS_ETRANGER' = 'NEW_PAYS_ETRANGER',
    'NEW_SANS_PLAQUE' = 'NEW_SANS_PLAQUE',
    'NEW_PLAQUE' = 'NEW_PLAQUE',
    'NEW_PLAQUE_VISIBLE' = 'NEW_PLAQUE_VISIBLE',
    'NEW_VIN' = 'NEW_VIN'
}
/**
    * @export
    * @enum {string}
    */
export enum ControleDonneesVehiculeViolationDtoViolationCodeEnum {
    'MISSING_VALUE' = 'MISSING_VALUE',
    'BAD_FORMAT_IMMATRICULATION' = 'BAD_FORMAT_IMMATRICULATION',
    'IMMATRICULATION_ALREADY_EXISTS' = 'IMMATRICULATION_ALREADY_EXISTS',
    'BAD_FORMAT_IDENTIFICATION' = 'BAD_FORMAT_IDENTIFICATION',
    'BAD_VIN' = 'BAD_VIN',
    'VIN_ALREADY_EXISTS' = 'VIN_ALREADY_EXISTS',
    'BAD_NUMERO_SERIE_DICEM' = 'BAD_NUMERO_SERIE_DICEM',
    'FORBIDDEN_PLAQUE' = 'FORBIDDEN_PLAQUE',
    'MARQUE_NOT_FOUND' = 'MARQUE_NOT_FOUND',
    'MODELE_NOT_FOUND' = 'MODELE_NOT_FOUND',
    'FORBIDDEN_MARQUE' = 'FORBIDDEN_MARQUE',
    'FORBIDDEN_MODELE' = 'FORBIDDEN_MODELE',
    'GENRE_NOT_FOUND' = 'GENRE_NOT_FOUND',
    'WRONG_MODELE' = 'WRONG_MODELE'
}

/**
 * 
 * @export
 * @interface ConventionnementSwaPartDto
 */
export interface ConventionnementSwaPartDto {
    /**
     * 
     * @type {string}
     * @memberof ConventionnementSwaPartDto
     */
    dateDebut: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConventionnementSwaPartDto
     */
    dateFin: string | null;
}
/**
 * 
 * @export
 * @interface CoordonneesProprietaireRequestDto
 */
export interface CoordonneesProprietaireRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    boitePostale: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    codeCedex: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    extension: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    libelleCedex: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    libelleCommune: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    libelleVoie: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    lieuDit: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    nom: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    numero: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    pays: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    pointRemise: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    prenom: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    raisonSociale: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireRequestDto
     */
    typeVoie: string | null;
}
/**
 * 
 * @export
 * @interface CoordonneesProprietaireResponseDto
 */
export interface CoordonneesProprietaireResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    boitePostale: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    codeCedex: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    extension: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    libelleCedex: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    libelleCommune: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    libelleVoie: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    lieuDit: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    nom: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    numero: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    pays: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    pointRemise: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    prenom: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    raisonSociale: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireResponseDto
     */
    typeVoie: string | null;
}
/**
 * 
 * @export
 * @interface CoordonneesProprietaireViolationDto
 */
export interface CoordonneesProprietaireViolationDto {
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireViolationDto
     */
    formField: CoordonneesProprietaireViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CoordonneesProprietaireViolationDto
     */
    violationCode: CoordonneesProprietaireViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CoordonneesProprietaireViolationDtoFormFieldEnum {
    'PRENOM' = 'PRENOM',
    'NOM' = 'NOM',
    'RAISON_SOCIALE' = 'RAISON_SOCIALE',
    'POINT_REMISE' = 'POINT_REMISE',
    'NUMERO' = 'NUMERO',
    'EXTENSION' = 'EXTENSION',
    'TYPEVOIE' = 'TYPEVOIE',
    'LIBELLE_VOIE' = 'LIBELLE_VOIE',
    'COMPLEMENT_ADRESSE' = 'COMPLEMENT_ADRESSE',
    'LIEUDIT' = 'LIEUDIT',
    'BOITE_POSTALE' = 'BOITE_POSTALE',
    'CODE_POSTAL' = 'CODE_POSTAL',
    'LIBELLE_COMMUNE' = 'LIBELLE_COMMUNE',
    'CODE_CEDEX' = 'CODE_CEDEX',
    'LIBELLE_CEDEX' = 'LIBELLE_CEDEX',
    'PAYS' = 'PAYS'
}
/**
    * @export
    * @enum {string}
    */
export enum CoordonneesProprietaireViolationDtoViolationCodeEnum {
    'CODE_POSTAL_WRONG_FORMAT' = 'CODE_POSTAL_WRONG_FORMAT'
}

/**
 * 
 * @export
 * @interface CouleurDto
 */
export interface CouleurDto {
    /**
     * 
     * @type {number}
     * @memberof CouleurDto
     */
    code: number | null;
    /**
     * 
     * @type {string}
     * @memberof CouleurDto
     */
    couleur: string;
    /**
     * 
     * @type {string}
     * @memberof CouleurDto
     */
    id: string;
}
/**
 * 
 * @export
 * @interface CountConfigurationResultDto
 */
export interface CountConfigurationResultDto {
    /**
     * 
     * @type {number}
     * @memberof CountConfigurationResultDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface CountDossiersResultDto
 */
export interface CountDossiersResultDto {
    /**
     * 
     * @type {number}
     * @memberof CountDossiersResultDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface CreateDossierFromForceOrdreDto
 */
export interface CreateDossierFromForceOrdreDto {
    /**
     * 
     * @type {FicheAgentFoRequestDto}
     * @memberof CreateDossierFromForceOrdreDto
     */
    ficheAgentFoRequest: FicheAgentFoRequestDto | null;
    /**
     * 
     * @type {FicheConditionsRequestDto}
     * @memberof CreateDossierFromForceOrdreDto
     */
    ficheConditionsRequest: FicheConditionsRequestDto | null;
    /**
     * 
     * @type {FicheDetailsVehiculeFoRequestDto}
     * @memberof CreateDossierFromForceOrdreDto
     */
    ficheDetailsVehiculeRequest: FicheDetailsVehiculeFoRequestDto | null;
    /**
     * 
     * @type {FicheEtatGeneralFoRequestDto}
     * @memberof CreateDossierFromForceOrdreDto
     */
    ficheEtatGeneralRequest: FicheEtatGeneralFoRequestDto | null;
    /**
     * 
     * @type {FicheFourriereFoRequestDto}
     * @memberof CreateDossierFromForceOrdreDto
     */
    ficheFourriereRequest: FicheFourriereFoRequestDto | null;
    /**
     * 
     * @type {FicheVehiculeFoRequestDto}
     * @memberof CreateDossierFromForceOrdreDto
     */
    ficheVehiculeRequest: FicheVehiculeFoRequestDto | null;
}
/**
 * 
 * @export
 * @interface CreateDossierFromGardienFourriereDto
 */
export interface CreateDossierFromGardienFourriereDto {
    /**
     * 
     * @type {FicheFourriereRequestDto}
     * @memberof CreateDossierFromGardienFourriereDto
     */
    ficheFourriereRequest: FicheFourriereRequestDto | null;
    /**
     * 
     * @type {FicheInfractionRequestDto}
     * @memberof CreateDossierFromGardienFourriereDto
     */
    ficheInfractionRequest: FicheInfractionRequestDto | null;
    /**
     * 
     * @type {FicheJudiciaireRequestDto}
     * @memberof CreateDossierFromGardienFourriereDto
     */
    ficheJudiciaireRequest: FicheJudiciaireRequestDto | null;
    /**
     * 
     * @type {FicheVehiculeRequestDto}
     * @memberof CreateDossierFromGardienFourriereDto
     */
    ficheVehiculeRequest: FicheVehiculeRequestDto | null;
}
/**
 * 
 * @export
 * @interface CreateExportResponseDto
 */
export interface CreateExportResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateExportResponseDto
     */
    exportId: string;
}
/**
 * 
 * @export
 * @interface CreateUserRequestDto
 */
export interface CreateUserRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestDto
     */
    email: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserRequestDto
     */
    gestionnaireLocal: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestDto
     */
    nom: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestDto
     */
    prenom: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestDto
     */
    profile: CreateUserRequestDtoProfileEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequestDto
     */
    uniteRattachement: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateUserRequestDtoProfileEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface CreateUserResultDto
 */
export interface CreateUserResultDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserResultDto
     */
    username: string;
}
/**
 * 
 * @export
 * @interface CreateViolationDto
 */
export interface CreateViolationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateViolationDto
     */
    formField: CreateViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CreateViolationDto
     */
    violationCode: CreateViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateViolationDtoFormFieldEnum {
    'PRENOM' = 'PRENOM',
    'NOM' = 'NOM',
    'EMAIL' = 'EMAIL',
    'ENTITE_RATTACHEMENT' = 'ENTITE_RATTACHEMENT',
    'PROFILE' = 'PROFILE'
}
/**
    * @export
    * @enum {string}
    */
export enum CreateViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'BAD_FORMAT_EMAIL' = 'BAD_FORMAT_EMAIL',
    'INVALID_ENTITE_RATTACHEMENT' = 'INVALID_ENTITE_RATTACHEMENT'
}

/**
 * 
 * @export
 * @interface DescriptionDto
 */
export interface DescriptionDto {
    /**
     * 
     * @type {string}
     * @memberof DescriptionDto
     */
    couleur: string | null;
    /**
     * 
     * @type {GenreSimplifieDto}
     * @memberof DescriptionDto
     */
    genreSimplifie: GenreSimplifieDto | null;
    /**
     * 
     * @type {MarqueDto}
     * @memberof DescriptionDto
     */
    marque: MarqueDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof DescriptionDto
     */
    marqueNonReferencee: boolean | null;
    /**
     * 
     * @type {ModeleDto}
     * @memberof DescriptionDto
     */
    modele: ModeleDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof DescriptionDto
     */
    modeleNonReference: boolean | null;
    /**
     * 
     * @type {ProprietaireDto}
     * @memberof DescriptionDto
     */
    proprietaire: ProprietaireDto | null;
    /**
     * 
     * @type {string}
     * @memberof DescriptionDto
     */
    type: string | null;
}
/**
 * 
 * @export
 * @interface DetailedEventDto
 */
export interface DetailedEventDto {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DetailedEventDto
     */
    content: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof DetailedEventDto
     */
    date: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailedEventDto
     */
    details: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventDto
     */
    inducedStatutDossier: DetailedEventDtoInducedStatutDossierEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEventDto
     */
    isIncident: boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventDto
     */
    label: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DetailedEventDtoInducedStatutDossierEnum {
    'A_REMPLIR' = 'A_REMPLIR',
    'ENREGISTRE' = 'ENREGISTRE',
    'NON_GERE' = 'NON_GERE',
    'NOTIFICATION_ENVOYEE' = 'NOTIFICATION_ENVOYEE',
    'NOTIFIE' = 'NOTIFIE',
    'A_NOTIFIER' = 'A_NOTIFIER',
    'EN_COURS_DE_NOTIFICATION' = 'EN_COURS_DE_NOTIFICATION',
    'A_REMETTRE_AUX_DOMAINES' = 'A_REMETTRE_AUX_DOMAINES',
    'REMIS_AU_DOMAINE' = 'REMIS_AU_DOMAINE',
    'MIS_EN_VENTE' = 'MIS_EN_VENTE',
    'VENDU' = 'VENDU',
    'A_RESTITUER' = 'A_RESTITUER',
    'VENTE_BLOQUEE' = 'VENTE_BLOQUEE',
    'A_DETRUIRE' = 'A_DETRUIRE',
    'SORTI' = 'SORTI',
    'DETRUIT' = 'DETRUIT'
}

/**
 * 
 * @export
 * @interface DetailedInformationMessageDto
 */
export interface DetailedInformationMessageDto {
    /**
     * 
     * @type {boolean}
     * @memberof DetailedInformationMessageDto
     */
    active: boolean;
    /**
     * Ce champ contient du Markdown non nettoyé, c\'est à dire avec des balises HTML pouvant potentiellement exécuter du code. Chaque frontend a la responsabilité de nettoyer ce contenu avec une librairie adaptée avant de l\'afficher.
     * @type {string}
     * @memberof DetailedInformationMessageDto
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof DetailedInformationMessageDto
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof DetailedInformationMessageDto
     */
    id: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof DetailedInformationMessageDto
     */
    profiles: Array<DetailedInformationMessageDtoProfilesEnum>;
    /**
     * 
     * @type {string}
     * @memberof DetailedInformationMessageDto
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof DetailedInformationMessageDto
     */
    title: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DetailedInformationMessageDtoProfilesEnum {
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE',
    'BORD_DE_ROUTE' = 'BORD_DE_ROUTE'
}

/**
 * 
 * @export
 * @interface DocumentSpecifiqueDto
 */
export interface DocumentSpecifiqueDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentSpecifiqueDto
     */
    creationDate: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSpecifiqueDto
     */
    hash: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSpecifiqueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSpecifiqueDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSpecifiqueDto
     */
    utilisateurDestinataire: DocumentSpecifiqueDtoUtilisateurDestinataireEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DocumentSpecifiqueDtoUtilisateurDestinataireEnum {
    'GF' = 'GF',
    'AF' = 'AF',
    'PM' = 'PM',
    'GN' = 'GN',
    'PN' = 'PN',
    'PP' = 'PP'
}

/**
 * 
 * @export
 * @interface DonneesAControlerResponseDto
 */
export interface DonneesAControlerResponseDto {
    /**
     * 
     * @type {DonneesFd}
     * @memberof DonneesAControlerResponseDto
     */
    donneesFd: DonneesFd | null;
    /**
     * 
     * @type {DonneesSiv}
     * @memberof DonneesAControlerResponseDto
     */
    donneesSiv: DonneesSiv | null;
}
/**
 * 
 * @export
 * @interface DonneesFd
 */
export interface DonneesFd {
    /**
     * 
     * @type {GenreSimplifieDto}
     * @memberof DonneesFd
     */
    genreSimplifie: GenreSimplifieDto | null;
    /**
     * 
     * @type {MarqueDto}
     * @memberof DonneesFd
     */
    marque: MarqueDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof DonneesFd
     */
    marqueNonReferencee: boolean | null;
    /**
     * 
     * @type {ModeleDto}
     * @memberof DonneesFd
     */
    modele: ModeleDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof DonneesFd
     */
    modeleNonReference: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DonneesFd
     */
    paysEtranger: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DonneesFd
     */
    plaqueImmatriculation: string | null;
    /**
     * 
     * @type {string}
     * @memberof DonneesFd
     */
    plaqueImmatriculationVisible: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DonneesFd
     */
    sansPlaque: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DonneesFd
     */
    vin: string | null;
}
/**
 * 
 * @export
 * @interface DonneesSiv
 */
export interface DonneesSiv {
    /**
     * 
     * @type {MarqueDto}
     * @memberof DonneesSiv
     */
    marque: MarqueDto | null;
    /**
     * 
     * @type {ModeleDto}
     * @memberof DonneesSiv
     */
    modele: ModeleDto | null;
    /**
     * 
     * @type {string}
     * @memberof DonneesSiv
     */
    plaqueImmatriculation: string | null;
    /**
     * 
     * @type {string}
     * @memberof DonneesSiv
     */
    vin: string | null;
}
/**
 * 
 * @export
 * @interface DossierBodyResponseDto
 */
export interface DossierBodyResponseDto {
    /**
     * 
     * @type {AlienationInformationDto}
     * @memberof DossierBodyResponseDto
     */
    alienationInformationDto: AlienationInformationDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierBodyResponseDto
     */
    anonymise: boolean | null;
    /**
     * 
     * @type {ArgosInformationDto}
     * @memberof DossierBodyResponseDto
     */
    argosInformation: ArgosInformationDto | null;
    /**
     * 
     * @type {FicheFourriereDto}
     * @memberof DossierBodyResponseDto
     */
    ficheFourriere: FicheFourriereDto | null;
    /**
     * 
     * @type {FicheInfractionDto}
     * @memberof DossierBodyResponseDto
     */
    ficheInfraction: FicheInfractionDto | null;
    /**
     * 
     * @type {FicheJudiciaireDto}
     * @memberof DossierBodyResponseDto
     */
    ficheJudiciaire: FicheJudiciaireDto | null;
    /**
     * 
     * @type {FicheVehiculeDto}
     * @memberof DossierBodyResponseDto
     */
    ficheVehicule: FicheVehiculeDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierBodyResponseDto
     */
    interdictionCirculer: boolean | null;
    /**
     * 
     * @type {ProfilRightsDto}
     * @memberof DossierBodyResponseDto
     */
    profilMaximumRights: ProfilRightsDto | null;
    /**
     * 
     * @type {SortieVehiculeResponseDto}
     * @memberof DossierBodyResponseDto
     */
    sortieVehicule: SortieVehiculeResponseDto | null;
    /**
     * 
     * @type {TraitementResponseDto}
     * @memberof DossierBodyResponseDto
     */
    traitement: TraitementResponseDto | null;
}
/**
 * 
 * @export
 * @interface DossierCreationFoViolationsDto
 */
export interface DossierCreationFoViolationsDto {
    /**
     * 
     * @type {Array<FicheAgentFoViolationDto>}
     * @memberof DossierCreationFoViolationsDto
     */
    ficheAgentViolationDtoList: Array<FicheAgentFoViolationDto> | null;
    /**
     * 
     * @type {Array<FicheConditionsViolationDto>}
     * @memberof DossierCreationFoViolationsDto
     */
    ficheConditionsViolationDtoList: Array<FicheConditionsViolationDto> | null;
    /**
     * 
     * @type {Array<FicheDetailsFoViolationDto>}
     * @memberof DossierCreationFoViolationsDto
     */
    ficheDetailsVehiculeViolationDtoList: Array<FicheDetailsFoViolationDto> | null;
    /**
     * 
     * @type {Array<FicheEtatGeneralFoViolationDto>}
     * @memberof DossierCreationFoViolationsDto
     */
    ficheEtatGeneralViolationDtoList: Array<FicheEtatGeneralFoViolationDto> | null;
    /**
     * 
     * @type {Array<FicheFourriereFoViolationDto>}
     * @memberof DossierCreationFoViolationsDto
     */
    ficheFourriereViolationDtoList: Array<FicheFourriereFoViolationDto> | null;
    /**
     * 
     * @type {Array<FicheVehiculeFoViolationDto>}
     * @memberof DossierCreationFoViolationsDto
     */
    ficheVehiculeViolationDtoList: Array<FicheVehiculeFoViolationDto> | null;
}
/**
 * 
 * @export
 * @interface DossierDtoAdminFonctionnel
 */
export interface DossierDtoAdminFonctionnel {
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierDtoAdminFonctionnel
     */
    actionsDisponibles: Array<DossierDtoAdminFonctionnelActionsDisponiblesEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierDtoAdminFonctionnel
     */
    actionsRequises: Array<DossierDtoAdminFonctionnelActionsRequisesEnum> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierDtoAdminFonctionnel
     */
    anonymise: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    currentBranche: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    dateDerniereMAJ: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    dateEntree: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    dateSortie: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    immatriculation: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    immatriculationVisible: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierDtoAdminFonctionnel
     */
    interdictionCirculer: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    libelleComplet: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    libelleJuridiction: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    libelleMarque: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    libelleModele: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    libelleNatureMEF: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    libelleUniteFoParent: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DossierDtoAdminFonctionnel
     */
    listAvailableFiles: Array<DossierDtoAdminFonctionnelListAvailableFilesEnum> | null;
    /**
     * 
     * @type {Array<AvailablePieceJointeDto>}
     * @memberof DossierDtoAdminFonctionnel
     */
    listAvailablePiecesJointes: Array<AvailablePieceJointeDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    numeroIDJ: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    numeroParquet: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    numeroPv: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    raisonSociale: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    status: DossierDtoAdminFonctionnelStatusEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    statutVega: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    suiviDestructionSiv: DossierDtoAdminFonctionnelSuiviDestructionSivEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    unite: string | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    valeurJuridique: DossierDtoAdminFonctionnelValeurJuridiqueEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DossierDtoAdminFonctionnel
     */
    vin: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierDtoAdminFonctionnel
     */
    volConfirme: boolean | null;
}

/**
    * @export
    * @enum {string}
    */
export enum DossierDtoAdminFonctionnelActionsDisponiblesEnum {
    'PROLONGER_MEF' = 'PROLONGER_MEF',
    'MODIFIER_COORDONNEES_PROPRIETAIRE' = 'MODIFIER_COORDONNEES_PROPRIETAIRE',
    'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' = 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE',
    'RENSEIGNER_SORTIE_VEHICULE' = 'RENSEIGNER_SORTIE_VEHICULE',
    'SAISIE_VHU' = 'SAISIE_VHU',
    'SAISIE_NOTIFICATION_MANUELLE' = 'SAISIE_NOTIFICATION_MANUELLE',
    'MAIN_LEVEE' = 'MAIN_LEVEE',
    'TRAITE_EN_FACTURATION' = 'TRAITE_EN_FACTURATION',
    'NON_TRAITE_EN_FACTURATION' = 'NON_TRAITE_EN_FACTURATION',
    'ANNULATION_SORTIE_VEHICULE' = 'ANNULATION_SORTIE_VEHICULE',
    'EXPORT_DONNEES_DOSSIER' = 'EXPORT_DONNEES_DOSSIER',
    'SUPPRESSION_DOSSIER' = 'SUPPRESSION_DOSSIER',
    'SUPPRESSION_DOSSIER_BY_FO' = 'SUPPRESSION_DOSSIER_BY_FO',
    'UPDATE_ENTITES_RATTACHEMENT_ADMIN' = 'UPDATE_ENTITES_RATTACHEMENT_ADMIN',
    'UPDATE_ENTITES_RATTACHEMENT_FO_AF' = 'UPDATE_ENTITES_RATTACHEMENT_FO_AF',
    'MODIFICATION_SORTIE_VEHICULE' = 'MODIFICATION_SORTIE_VEHICULE',
    'UPDATE_DONNEES_VEHICULE' = 'UPDATE_DONNEES_VEHICULE',
    'UPDATE_DONNEES_VEHICULE_JUSTICE' = 'UPDATE_DONNEES_VEHICULE_JUSTICE',
    'UPDATE_CLASSEMENT' = 'UPDATE_CLASSEMENT',
    'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' = 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE',
    'ENREGISTRER_ENTREE' = 'ENREGISTRER_ENTREE',
    'CONTROLER_DONNEES_VEHICULE' = 'CONTROLER_DONNEES_VEHICULE',
    'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' = 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE',
    'RELANCE_VENTE_VOL' = 'RELANCE_VENTE_VOL',
    'RELANCE_VENTE_IMMO_PJ' = 'RELANCE_VENTE_IMMO_PJ',
    'RELANCE_VENTE_OPPOSITION' = 'RELANCE_VENTE_OPPOSITION',
    'RELANCE_VENTE_DOUBLON' = 'RELANCE_VENTE_DOUBLON',
    'RELANCE_VENTE_MANQUANT' = 'RELANCE_VENTE_MANQUANT',
    'RECUPERATION_AR_PND_AUTOMATIQUE' = 'RECUPERATION_AR_PND_AUTOMATIQUE',
    'CONTROLE_BLOCAGE_ARGOS' = 'CONTROLE_BLOCAGE_ARGOS',
    'CONTROLE_BLOCAGE_ANTAI' = 'CONTROLE_BLOCAGE_ANTAI',
    'CONTROLE_BLOCAGE_DNID' = 'CONTROLE_BLOCAGE_DNID',
    'RECUPERATION_COURRIER_AUTOMATIQUE' = 'RECUPERATION_COURRIER_AUTOMATIQUE',
    'RENSEIGNER_INFORMATIONS_SIV' = 'RENSEIGNER_INFORMATIONS_SIV',
    'CONFIRMER_VOL_VVNR' = 'CONFIRMER_VOL_VVNR',
    'VALIDATION_ACTIONS_VVNR_HORS_SIF' = 'VALIDATION_ACTIONS_VVNR_HORS_SIF',
    'IMPORTER_PIECES_JOINTES' = 'IMPORTER_PIECES_JOINTES',
    'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' = 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE',
    'UPDATE_DONNEES_JUDICIAIRE' = 'UPDATE_DONNEES_JUDICIAIRE'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierDtoAdminFonctionnelActionsRequisesEnum {
    'PROLONGER_MEF' = 'PROLONGER_MEF',
    'MODIFIER_COORDONNEES_PROPRIETAIRE' = 'MODIFIER_COORDONNEES_PROPRIETAIRE',
    'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' = 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE',
    'RENSEIGNER_SORTIE_VEHICULE' = 'RENSEIGNER_SORTIE_VEHICULE',
    'SAISIE_VHU' = 'SAISIE_VHU',
    'SAISIE_NOTIFICATION_MANUELLE' = 'SAISIE_NOTIFICATION_MANUELLE',
    'MAIN_LEVEE' = 'MAIN_LEVEE',
    'TRAITE_EN_FACTURATION' = 'TRAITE_EN_FACTURATION',
    'NON_TRAITE_EN_FACTURATION' = 'NON_TRAITE_EN_FACTURATION',
    'ANNULATION_SORTIE_VEHICULE' = 'ANNULATION_SORTIE_VEHICULE',
    'EXPORT_DONNEES_DOSSIER' = 'EXPORT_DONNEES_DOSSIER',
    'SUPPRESSION_DOSSIER' = 'SUPPRESSION_DOSSIER',
    'SUPPRESSION_DOSSIER_BY_FO' = 'SUPPRESSION_DOSSIER_BY_FO',
    'UPDATE_ENTITES_RATTACHEMENT_ADMIN' = 'UPDATE_ENTITES_RATTACHEMENT_ADMIN',
    'UPDATE_ENTITES_RATTACHEMENT_FO_AF' = 'UPDATE_ENTITES_RATTACHEMENT_FO_AF',
    'MODIFICATION_SORTIE_VEHICULE' = 'MODIFICATION_SORTIE_VEHICULE',
    'UPDATE_DONNEES_VEHICULE' = 'UPDATE_DONNEES_VEHICULE',
    'UPDATE_DONNEES_VEHICULE_JUSTICE' = 'UPDATE_DONNEES_VEHICULE_JUSTICE',
    'UPDATE_CLASSEMENT' = 'UPDATE_CLASSEMENT',
    'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' = 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE',
    'ENREGISTRER_ENTREE' = 'ENREGISTRER_ENTREE',
    'CONTROLER_DONNEES_VEHICULE' = 'CONTROLER_DONNEES_VEHICULE',
    'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' = 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE',
    'RELANCE_VENTE_VOL' = 'RELANCE_VENTE_VOL',
    'RELANCE_VENTE_IMMO_PJ' = 'RELANCE_VENTE_IMMO_PJ',
    'RELANCE_VENTE_OPPOSITION' = 'RELANCE_VENTE_OPPOSITION',
    'RELANCE_VENTE_DOUBLON' = 'RELANCE_VENTE_DOUBLON',
    'RELANCE_VENTE_MANQUANT' = 'RELANCE_VENTE_MANQUANT',
    'RECUPERATION_AR_PND_AUTOMATIQUE' = 'RECUPERATION_AR_PND_AUTOMATIQUE',
    'CONTROLE_BLOCAGE_ARGOS' = 'CONTROLE_BLOCAGE_ARGOS',
    'CONTROLE_BLOCAGE_ANTAI' = 'CONTROLE_BLOCAGE_ANTAI',
    'CONTROLE_BLOCAGE_DNID' = 'CONTROLE_BLOCAGE_DNID',
    'RECUPERATION_COURRIER_AUTOMATIQUE' = 'RECUPERATION_COURRIER_AUTOMATIQUE',
    'RENSEIGNER_INFORMATIONS_SIV' = 'RENSEIGNER_INFORMATIONS_SIV',
    'CONFIRMER_VOL_VVNR' = 'CONFIRMER_VOL_VVNR',
    'VALIDATION_ACTIONS_VVNR_HORS_SIF' = 'VALIDATION_ACTIONS_VVNR_HORS_SIF',
    'IMPORTER_PIECES_JOINTES' = 'IMPORTER_PIECES_JOINTES',
    'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' = 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE',
    'UPDATE_DONNEES_JUDICIAIRE' = 'UPDATE_DONNEES_JUDICIAIRE'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierDtoAdminFonctionnelListAvailableFilesEnum {
    'DECISION_CLASSEMENT' = 'DECISION_CLASSEMENT',
    'DECISION_DESTRUCTION' = 'DECISION_DESTRUCTION',
    'CONSTAT_ABANDON' = 'CONSTAT_ABANDON',
    'DECISION_REMISE_DOMAINE' = 'DECISION_REMISE_DOMAINE',
    'BON_ENLEVEMENT_DESTRUCTION' = 'BON_ENLEVEMENT_DESTRUCTION',
    'FICHE_DESCRIPTIVE' = 'FICHE_DESCRIPTIVE',
    'PRESCRIPTION_MEF' = 'PRESCRIPTION_MEF',
    'MAIN_LEVEE_FO' = 'MAIN_LEVEE_FO',
    'MAIN_LEVEE_USAGER' = 'MAIN_LEVEE_USAGER',
    'COURRIER_NOTIFICATION' = 'COURRIER_NOTIFICATION',
    'AR_PND_NOTIFICATION' = 'AR_PND_NOTIFICATION'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierDtoAdminFonctionnelStatusEnum {
    'A_REMPLIR' = 'A_REMPLIR',
    'ENREGISTRE' = 'ENREGISTRE',
    'NON_GERE' = 'NON_GERE',
    'NOTIFICATION_ENVOYEE' = 'NOTIFICATION_ENVOYEE',
    'NOTIFIE' = 'NOTIFIE',
    'A_NOTIFIER' = 'A_NOTIFIER',
    'EN_COURS_DE_NOTIFICATION' = 'EN_COURS_DE_NOTIFICATION',
    'A_REMETTRE_AUX_DOMAINES' = 'A_REMETTRE_AUX_DOMAINES',
    'REMIS_AU_DOMAINE' = 'REMIS_AU_DOMAINE',
    'MIS_EN_VENTE' = 'MIS_EN_VENTE',
    'VENDU' = 'VENDU',
    'A_RESTITUER' = 'A_RESTITUER',
    'VENTE_BLOQUEE' = 'VENTE_BLOQUEE',
    'A_DETRUIRE' = 'A_DETRUIRE',
    'SORTI' = 'SORTI',
    'DETRUIT' = 'DETRUIT'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierDtoAdminFonctionnelSuiviDestructionSivEnum {
    'NON_APPLICABLE' = 'NON_APPLICABLE',
    'DETRUIT_APRES_SORTIE' = 'DETRUIT_APRES_SORTIE',
    'EN_ATTENTE_APPEL' = 'EN_ATTENTE_APPEL',
    'EN_ATTENTE_DEUXIEME_APPEL' = 'EN_ATTENTE_DEUXIEME_APPEL',
    'NON_DETRUIT_APRES_DELAI' = 'NON_DETRUIT_APRES_DELAI'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierDtoAdminFonctionnelValeurJuridiqueEnum {
    'PROBATOIRE' = 'PROBATOIRE',
    'CONFISCATOIRE' = 'CONFISCATOIRE'
}

/**
 * 
 * @export
 * @interface DossierEntreeViolationsDto
 */
export interface DossierEntreeViolationsDto {
    /**
     * 
     * @type {Array<EntreeVehiculeViolationDto>}
     * @memberof DossierEntreeViolationsDto
     */
    entreeVehiculeViolationDtoList: Array<EntreeVehiculeViolationDto> | null;
}
/**
 * 
 * @export
 * @interface DossierHeaderResponseDto
 */
export interface DossierHeaderResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DossierHeaderResponseDto
     */
    id: string | null;
}
/**
 * 
 * @export
 * @interface DossierModificationViolationsDto
 */
export interface DossierModificationViolationsDto {
    /**
     * 
     * @type {Array<ControleDonneesVehiculeViolationDto>}
     * @memberof DossierModificationViolationsDto
     */
    controleDonneesVehiculeViolationDtoList: Array<ControleDonneesVehiculeViolationDto> | null;
    /**
     * 
     * @type {Array<FixDataNotificationManuelleViolationDto>}
     * @memberof DossierModificationViolationsDto
     */
    fixDataNotificationManuelleViolationDtoList: Array<FixDataNotificationManuelleViolationDto> | null;
    /**
     * 
     * @type {Array<UpdateClassementViolationDto>}
     * @memberof DossierModificationViolationsDto
     */
    updateClassementViolationDtoList: Array<UpdateClassementViolationDto> | null;
    /**
     * 
     * @type {Array<UpdateDonneesJudiciairesViolationDto>}
     * @memberof DossierModificationViolationsDto
     */
    updateDonneesJudiciairesViolationDtoList: Array<UpdateDonneesJudiciairesViolationDto> | null;
    /**
     * 
     * @type {Array<UpdateDonneesInterieurVehiculeViolationDto>}
     * @memberof DossierModificationViolationsDto
     */
    updateDonneesVehiculeViolationDtoList: Array<UpdateDonneesInterieurVehiculeViolationDto> | null;
    /**
     * 
     * @type {Array<UpdateEntitesRattachementViolationDto>}
     * @memberof DossierModificationViolationsDto
     */
    updateEntitesRattachementViolationDtoList: Array<UpdateEntitesRattachementViolationDto> | null;
}
/**
 * 
 * @export
 * @interface DossierResponseDto
 */
export interface DossierResponseDto {
    /**
     * 
     * @type {DossierBodyResponseDto}
     * @memberof DossierResponseDto
     */
    body: DossierBodyResponseDto | null;
    /**
     * 
     * @type {ComputedResponseDto}
     * @memberof DossierResponseDto
     */
    computed: ComputedResponseDto | null;
    /**
     * 
     * @type {DossierHeaderResponseDto}
     * @memberof DossierResponseDto
     */
    header: DossierHeaderResponseDto | null;
}
/**
 * 
 * @export
 * @interface DossierStatusDto
 */
export interface DossierStatusDto {
    /**
     * 
     * @type {Set<string>}
     * @memberof DossierStatusDto
     */
    actionsRequisesForUserProfile: Array<DossierStatusDtoActionsRequisesForUserProfileEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof DossierStatusDto
     */
    isDeleted: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DossierStatusDto
     */
    statutConsultableForUserProfile: DossierStatusDtoStatutConsultableForUserProfileEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum DossierStatusDtoActionsRequisesForUserProfileEnum {
    'PROLONGER_MEF' = 'PROLONGER_MEF',
    'MODIFIER_COORDONNEES_PROPRIETAIRE' = 'MODIFIER_COORDONNEES_PROPRIETAIRE',
    'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' = 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE',
    'RENSEIGNER_SORTIE_VEHICULE' = 'RENSEIGNER_SORTIE_VEHICULE',
    'SAISIE_VHU' = 'SAISIE_VHU',
    'SAISIE_NOTIFICATION_MANUELLE' = 'SAISIE_NOTIFICATION_MANUELLE',
    'MAIN_LEVEE' = 'MAIN_LEVEE',
    'TRAITE_EN_FACTURATION' = 'TRAITE_EN_FACTURATION',
    'NON_TRAITE_EN_FACTURATION' = 'NON_TRAITE_EN_FACTURATION',
    'ANNULATION_SORTIE_VEHICULE' = 'ANNULATION_SORTIE_VEHICULE',
    'EXPORT_DONNEES_DOSSIER' = 'EXPORT_DONNEES_DOSSIER',
    'SUPPRESSION_DOSSIER' = 'SUPPRESSION_DOSSIER',
    'SUPPRESSION_DOSSIER_BY_FO' = 'SUPPRESSION_DOSSIER_BY_FO',
    'UPDATE_ENTITES_RATTACHEMENT_ADMIN' = 'UPDATE_ENTITES_RATTACHEMENT_ADMIN',
    'UPDATE_ENTITES_RATTACHEMENT_FO_AF' = 'UPDATE_ENTITES_RATTACHEMENT_FO_AF',
    'MODIFICATION_SORTIE_VEHICULE' = 'MODIFICATION_SORTIE_VEHICULE',
    'UPDATE_DONNEES_VEHICULE' = 'UPDATE_DONNEES_VEHICULE',
    'UPDATE_DONNEES_VEHICULE_JUSTICE' = 'UPDATE_DONNEES_VEHICULE_JUSTICE',
    'UPDATE_CLASSEMENT' = 'UPDATE_CLASSEMENT',
    'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' = 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE',
    'ENREGISTRER_ENTREE' = 'ENREGISTRER_ENTREE',
    'CONTROLER_DONNEES_VEHICULE' = 'CONTROLER_DONNEES_VEHICULE',
    'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' = 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE',
    'RELANCE_VENTE_VOL' = 'RELANCE_VENTE_VOL',
    'RELANCE_VENTE_IMMO_PJ' = 'RELANCE_VENTE_IMMO_PJ',
    'RELANCE_VENTE_OPPOSITION' = 'RELANCE_VENTE_OPPOSITION',
    'RELANCE_VENTE_DOUBLON' = 'RELANCE_VENTE_DOUBLON',
    'RELANCE_VENTE_MANQUANT' = 'RELANCE_VENTE_MANQUANT',
    'RECUPERATION_AR_PND_AUTOMATIQUE' = 'RECUPERATION_AR_PND_AUTOMATIQUE',
    'CONTROLE_BLOCAGE_ARGOS' = 'CONTROLE_BLOCAGE_ARGOS',
    'CONTROLE_BLOCAGE_ANTAI' = 'CONTROLE_BLOCAGE_ANTAI',
    'CONTROLE_BLOCAGE_DNID' = 'CONTROLE_BLOCAGE_DNID',
    'RECUPERATION_COURRIER_AUTOMATIQUE' = 'RECUPERATION_COURRIER_AUTOMATIQUE',
    'RENSEIGNER_INFORMATIONS_SIV' = 'RENSEIGNER_INFORMATIONS_SIV',
    'CONFIRMER_VOL_VVNR' = 'CONFIRMER_VOL_VVNR',
    'VALIDATION_ACTIONS_VVNR_HORS_SIF' = 'VALIDATION_ACTIONS_VVNR_HORS_SIF',
    'IMPORTER_PIECES_JOINTES' = 'IMPORTER_PIECES_JOINTES',
    'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' = 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE',
    'UPDATE_DONNEES_JUDICIAIRE' = 'UPDATE_DONNEES_JUDICIAIRE'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierStatusDtoStatutConsultableForUserProfileEnum {
    'A_REMPLIR' = 'A_REMPLIR',
    'ENREGISTRE' = 'ENREGISTRE',
    'NON_GERE' = 'NON_GERE',
    'NOTIFICATION_ENVOYEE' = 'NOTIFICATION_ENVOYEE',
    'NOTIFIE' = 'NOTIFIE',
    'A_NOTIFIER' = 'A_NOTIFIER',
    'EN_COURS_DE_NOTIFICATION' = 'EN_COURS_DE_NOTIFICATION',
    'A_REMETTRE_AUX_DOMAINES' = 'A_REMETTRE_AUX_DOMAINES',
    'REMIS_AU_DOMAINE' = 'REMIS_AU_DOMAINE',
    'MIS_EN_VENTE' = 'MIS_EN_VENTE',
    'VENDU' = 'VENDU',
    'A_RESTITUER' = 'A_RESTITUER',
    'VENTE_BLOQUEE' = 'VENTE_BLOQUEE',
    'A_DETRUIRE' = 'A_DETRUIRE',
    'SORTI' = 'SORTI',
    'DETRUIT' = 'DETRUIT'
}

/**
 * 
 * @export
 * @interface DossierSummaryResponseDto
 */
export interface DossierSummaryResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof DossierSummaryResponseDto
     */
    anonymise: boolean;
    /**
     * 
     * @type {ComputedSummaryResponseDto}
     * @memberof DossierSummaryResponseDto
     */
    computed: ComputedSummaryResponseDto | null;
    /**
     * 
     * @type {FicheFourriereSummaryDto}
     * @memberof DossierSummaryResponseDto
     */
    ficheFourriere: FicheFourriereSummaryDto | null;
    /**
     * 
     * @type {FicheInfractionSummaryDto}
     * @memberof DossierSummaryResponseDto
     */
    ficheInfraction: FicheInfractionSummaryDto | null;
    /**
     * 
     * @type {FicheJudiciaireSummaryDto}
     * @memberof DossierSummaryResponseDto
     */
    ficheJudiciaire: FicheJudiciaireSummaryDto | null;
    /**
     * 
     * @type {FicheVehiculeSummaryDto}
     * @memberof DossierSummaryResponseDto
     */
    ficheVehicule: FicheVehiculeSummaryDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierSummaryResponseDto
     */
    hasAlerts: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DossierSummaryResponseDto
     */
    hasNotifications: boolean;
    /**
     * 
     * @type {string}
     * @memberof DossierSummaryResponseDto
     */
    id: string;
    /**
     * 
     * @type {SortieSummaryDto}
     * @memberof DossierSummaryResponseDto
     */
    sortie: SortieSummaryDto | null;
    /**
     * 
     * @type {SortieJusticeSummaryDto}
     * @memberof DossierSummaryResponseDto
     */
    sortieJustice: SortieJusticeSummaryDto | null;
    /**
     * 
     * @type {TraitementSummaryDto}
     * @memberof DossierSummaryResponseDto
     */
    traitement: TraitementSummaryDto | null;
}
/**
 * 
 * @export
 * @interface DossierViolationsDto
 */
export interface DossierViolationsDto {
    /**
     * 
     * @type {Array<BonEnlevementGardienViolationDto>}
     * @memberof DossierViolationsDto
     */
    bonEnlevementGardienViolationDtoList: Array<BonEnlevementGardienViolationDto> | null;
    /**
     * 
     * @type {Array<CommentaireViolationDto>}
     * @memberof DossierViolationsDto
     */
    commentaireViolationDtos: Array<CommentaireViolationDto> | null;
    /**
     * 
     * @type {Array<FicheFourriereViolationDto>}
     * @memberof DossierViolationsDto
     */
    ficheFourriereViolationDtoList: Array<FicheFourriereViolationDto> | null;
    /**
     * 
     * @type {Array<FicheInfractionViolationDto>}
     * @memberof DossierViolationsDto
     */
    ficheInfractionViolationDtoList: Array<FicheInfractionViolationDto> | null;
    /**
     * 
     * @type {Array<FicheJudiciaireViolationDto>}
     * @memberof DossierViolationsDto
     */
    ficheJudiciaireViolationDtoList: Array<FicheJudiciaireViolationDto> | null;
    /**
     * 
     * @type {Array<FicheVehiculeViolationDto>}
     * @memberof DossierViolationsDto
     */
    ficheVehiculeViolationDtoList: Array<FicheVehiculeViolationDto> | null;
    /**
     * 
     * @type {Array<MainLeveeViolationDto>}
     * @memberof DossierViolationsDto
     */
    mainLeveeViolationDtoList: Array<MainLeveeViolationDto> | null;
    /**
     * 
     * @type {Array<NotificationInfosViolationDto>}
     * @memberof DossierViolationsDto
     */
    notificationInfosViolationDtos: Array<NotificationInfosViolationDto> | null;
    /**
     * 
     * @type {Array<ProlongationViolationDto>}
     * @memberof DossierViolationsDto
     */
    prolongationViolationDtoList: Array<ProlongationViolationDto> | null;
    /**
     * 
     * @type {Array<SortieVehiculeViolationDto>}
     * @memberof DossierViolationsDto
     */
    sortieVehiculeViolationDtoList: Array<SortieVehiculeViolationDto> | null;
    /**
     * 
     * @type {Array<CoordonneesProprietaireViolationDto>}
     * @memberof DossierViolationsDto
     */
    updateCoordonneesProprietaireViolationDtoList: Array<CoordonneesProprietaireViolationDto> | null;
    /**
     * 
     * @type {Array<ExpediteurNotificationViolationDto>}
     * @memberof DossierViolationsDto
     */
    updateExpediteurNotificationViolationDtoList: Array<ExpediteurNotificationViolationDto> | null;
}
/**
 * 
 * @export
 * @interface DossiersStatusResultDto
 */
export interface DossiersStatusResultDto {
    /**
     * 
     * @type {{ [key: string]: DossierStatusDto; }}
     * @memberof DossiersStatusResultDto
     */
    dossiers: { [key: string]: DossierStatusDto; };
}
/**
 * 
 * @export
 * @interface EnergieDto
 */
export interface EnergieDto {
    /**
     * 
     * @type {string}
     * @memberof EnergieDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof EnergieDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnergieDto
     */
    libelle: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnergieDto
     */
    libelleCourt: string | null;
}
/**
 * 
 * @export
 * @interface EntreeVehiculeRequestDto
 */
export interface EntreeVehiculeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof EntreeVehiculeRequestDto
     */
    dateEnlevement: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntreeVehiculeRequestDto
     */
    dateEntree: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntreeVehiculeRequestDto
     */
    idCorrelationAutoriteFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntreeVehiculeRequestDto
     */
    idCorrelationJuridiction: string | null;
}
/**
 * 
 * @export
 * @interface EntreeVehiculeViolationDto
 */
export interface EntreeVehiculeViolationDto {
    /**
     * 
     * @type {string}
     * @memberof EntreeVehiculeViolationDto
     */
    formField: EntreeVehiculeViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof EntreeVehiculeViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof EntreeVehiculeViolationDto
     */
    violationCode: EntreeVehiculeViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EntreeVehiculeViolationDtoFormFieldEnum {
    'ID_CORRELATION_AUTORITE_FOURRIERE' = 'ID_CORRELATION_AUTORITE_FOURRIERE',
    'ID_CORRELATION_JURIDICTION' = 'ID_CORRELATION_JURIDICTION',
    'DATE_ENLEVEMENT' = 'DATE_ENLEVEMENT',
    'DATE_ENTREE' = 'DATE_ENTREE'
}
/**
    * @export
    * @enum {string}
    */
export enum EntreeVehiculeViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'DATE_ENTREE_PRIOR_DATE_ENLEVEMENT' = 'DATE_ENTREE_PRIOR_DATE_ENLEVEMENT',
    'DATE_ENTREE_PRIOR_DATE_CONSTATATION' = 'DATE_ENTREE_PRIOR_DATE_CONSTATATION',
    'DATE_ENLEVEMENT_PRIOR_DATE_CONSTATATION' = 'DATE_ENLEVEMENT_PRIOR_DATE_CONSTATATION',
    'DATE_ENLEVEMENT_PRIOR_DATE_REDACTION' = 'DATE_ENLEVEMENT_PRIOR_DATE_REDACTION',
    'DATE_IN_THE_FUTURE' = 'DATE_IN_THE_FUTURE',
    'INVALID_AUTORITE_FOURRIERE' = 'INVALID_AUTORITE_FOURRIERE',
    'INCONSISTENT_AUTORITE_FOURRIERE' = 'INCONSISTENT_AUTORITE_FOURRIERE',
    'AUTORITE_FOURRIERE_NOT_FOUND' = 'AUTORITE_FOURRIERE_NOT_FOUND',
    'JURIDICTION_NOT_FOUND' = 'JURIDICTION_NOT_FOUND'
}

/**
 * 
 * @export
 * @interface ErrorDto
 */
export interface ErrorDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorDto
     */
    code: ErrorDtoCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof ErrorDto
     */
    localized: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorDto
     */
    message: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ErrorDtoCodeEnum {
    'UNKNOWN_ERROR' = 'UNKNOWN_ERROR',
    'NOT_FOUND_ERROR' = 'NOT_FOUND_ERROR',
    'PROPERTY_ERROR' = 'PROPERTY_ERROR',
    'CONNECTION_FAILED_ERROR' = 'CONNECTION_FAILED_ERROR',
    'HTTP_PARSE_ERROR' = 'HTTP_PARSE_ERROR',
    'SPRING_BAD_REQUEST' = 'SPRING_BAD_REQUEST',
    'FILE_ENCODING_ERROR' = 'FILE_ENCODING_ERROR',
    'FORBIDDEN_HEADER' = 'FORBIDDEN_HEADER',
    'API_AUTHENTICATION_ERROR' = 'API_AUTHENTICATION_ERROR',
    'API_AUTHORIZATION_ERROR' = 'API_AUTHORIZATION_ERROR',
    'API_EXPIRED_TOKEN' = 'API_EXPIRED_TOKEN',
    'API_DOCUMENT_NOT_FOUND_ERROR' = 'API_DOCUMENT_NOT_FOUND_ERROR',
    'API_HEALTH_CHECK_ERROR' = 'API_HEALTH_CHECK_ERROR',
    'API_UNPROCESSABLE_FILE' = 'API_UNPROCESSABLE_FILE',
    'API_WRITE_HTTP_RESPONSE' = 'API_WRITE_HTTP_RESPONSE',
    'API_WRONG_HEADER_IDENTIFIER' = 'API_WRONG_HEADER_IDENTIFIER',
    'API_CANNOT_DELETE_ITSELF' = 'API_CANNOT_DELETE_ITSELF',
    'API_ROUTE_DEPRECATED' = 'API_ROUTE_DEPRECATED',
    'CAMUNDA_PROCESS_INSTANCE_ALREADY_EXISTS_ERROR' = 'CAMUNDA_PROCESS_INSTANCE_ALREADY_EXISTS_ERROR',
    'CAMUNDA_PROCESS_INSTANCE_NOT_FOUND' = 'CAMUNDA_PROCESS_INSTANCE_NOT_FOUND',
    'CAMUNDA_INCIDENT_NOT_FOUND' = 'CAMUNDA_INCIDENT_NOT_FOUND',
    'CAMUNDA_MESSAGE_EMISSION_ERROR' = 'CAMUNDA_MESSAGE_EMISSION_ERROR',
    'CAMUNDA_UNKNOWN_ERROR' = 'CAMUNDA_UNKNOWN_ERROR',
    'NULL_VALUE_ERROR' = 'NULL_VALUE_ERROR',
    'API_DOCUMENT_SPECIFIQUE_NOT_FOUND' = 'API_DOCUMENT_SPECIFIQUE_NOT_FOUND',
    'API_COMMENT_ID_NOT_FOUND' = 'API_COMMENT_ID_NOT_FOUND',
    'IDP_RESPONSE_ERROR' = 'IDP_RESPONSE_ERROR',
    'IDP_INVALID_REQUEST' = 'IDP_INVALID_REQUEST',
    'IDP_INVALID_CLIENT' = 'IDP_INVALID_CLIENT',
    'IDP_INVALID_GRANT' = 'IDP_INVALID_GRANT',
    'IDP_UNAUTHORIZED_CLIENT' = 'IDP_UNAUTHORIZED_CLIENT',
    'IDP_UNSUPPORTED_GRANT_TYPE' = 'IDP_UNSUPPORTED_GRANT_TYPE',
    'IDP_INVALID_SCOPE' = 'IDP_INVALID_SCOPE',
    'KEYCLOAK_MISSING_PROPERTY' = 'KEYCLOAK_MISSING_PROPERTY',
    'KEYCLOAK_INVALID_ROLE' = 'KEYCLOAK_INVALID_ROLE',
    'KEYCLOAK_AUTORITE_FOURRIERE_INVALID' = 'KEYCLOAK_AUTORITE_FOURRIERE_INVALID',
    'KEYCLOAK_AUTORITE_FOURRIERE_NOT_FOUND' = 'KEYCLOAK_AUTORITE_FOURRIERE_NOT_FOUND',
    'KEYCLOAK_AUTORITE_FOURRIERE_NO_ACTIVE_FOUND' = 'KEYCLOAK_AUTORITE_FOURRIERE_NO_ACTIVE_FOUND',
    'KEYCLOAK_AUTORITE_FOURRIERE_MULTIPLE_ACTIVE_FOUND' = 'KEYCLOAK_AUTORITE_FOURRIERE_MULTIPLE_ACTIVE_FOUND',
    'KEYCLOAK_FOURRIERE_INVALID' = 'KEYCLOAK_FOURRIERE_INVALID',
    'KEYCLOAK_FOURRIERE_NOT_FOUND' = 'KEYCLOAK_FOURRIERE_NOT_FOUND',
    'KEYCLOAK_FOURRIERE_NO_ACTIVE_FOUND' = 'KEYCLOAK_FOURRIERE_NO_ACTIVE_FOUND',
    'KEYCLOAK_FOURRIERE_MULTIPLE_ACTIVE_FOUND' = 'KEYCLOAK_FOURRIERE_MULTIPLE_ACTIVE_FOUND',
    'KEYCLOAK_UNITE_FO_INVALID' = 'KEYCLOAK_UNITE_FO_INVALID',
    'KEYCLOAK_UNITE_FO_NOT_FOUND' = 'KEYCLOAK_UNITE_FO_NOT_FOUND',
    'KEYCLOAK_UNITE_FO_NO_ACTIVE_FOUND' = 'KEYCLOAK_UNITE_FO_NO_ACTIVE_FOUND',
    'KEYCLOAK_UNITE_FO_MULTIPLE_ACTIVE_FOUND' = 'KEYCLOAK_UNITE_FO_MULTIPLE_ACTIVE_FOUND',
    'KEYCLOAK_JURIDICTION_INVALID' = 'KEYCLOAK_JURIDICTION_INVALID',
    'KEYCLOAK_JURIDICTION_NOT_FOUND' = 'KEYCLOAK_JURIDICTION_NOT_FOUND',
    'KEYCLOAK_JURIDICTION_NO_ACTIVE_FOUND' = 'KEYCLOAK_JURIDICTION_NO_ACTIVE_FOUND',
    'KEYCLOAK_JURIDICTION_MULTIPLE_ACTIVE_FOUND' = 'KEYCLOAK_JURIDICTION_MULTIPLE_ACTIVE_FOUND',
    'PASSAGE2_MISSING_PROPERTY' = 'PASSAGE2_MISSING_PROPERTY',
    'PASSAGE2_INVALID_ROLE' = 'PASSAGE2_INVALID_ROLE',
    'PASSAGE2_CODE_INSEE_NOT_FOUND' = 'PASSAGE2_CODE_INSEE_NOT_FOUND',
    'PASSAGE2_CODE_INSEE_NO_ACTIVE_FOUND' = 'PASSAGE2_CODE_INSEE_NO_ACTIVE_FOUND',
    'PASSAGE2_CODE_INSEE_MULTIPLE_ACTIVE_FOUND' = 'PASSAGE2_CODE_INSEE_MULTIPLE_ACTIVE_FOUND',
    'PASSAGE2_LIBELLE_LONG_INVALID' = 'PASSAGE2_LIBELLE_LONG_INVALID',
    'PASSAGE2_UNITE_FO_ABREVIATION_NOT_FOUND' = 'PASSAGE2_UNITE_FO_ABREVIATION_NOT_FOUND',
    'PASSAGE2_UNITE_FO_ABREVIATION_NO_ACTIVE_FOUND' = 'PASSAGE2_UNITE_FO_ABREVIATION_NO_ACTIVE_FOUND',
    'PASSAGE2_UNITE_FO_ABREVIATION_MULTIPLE_ACTIVE_FOUND' = 'PASSAGE2_UNITE_FO_ABREVIATION_MULTIPLE_ACTIVE_FOUND',
    'PASSAGE2_UNITE_FO_CODE_NOT_FOUND' = 'PASSAGE2_UNITE_FO_CODE_NOT_FOUND',
    'PASSAGE2_UNITE_FO_CODE_NO_ACTIVE_FOUND' = 'PASSAGE2_UNITE_FO_CODE_NO_ACTIVE_FOUND',
    'PASSAGE2_UNITE_FO_CODE_MULTIPLE_ACTIVE_FOUND' = 'PASSAGE2_UNITE_FO_CODE_MULTIPLE_ACTIVE_FOUND',
    'PASSAGE2_UNITE_FO_NOT_FOUND' = 'PASSAGE2_UNITE_FO_NOT_FOUND',
    'PASSAGE2_UNITE_FO_NO_ACTIVE_FOUND' = 'PASSAGE2_UNITE_FO_NO_ACTIVE_FOUND',
    'PASSAGE2_UNITE_FO_MULTIPLE_ACTIVE_FOUND' = 'PASSAGE2_UNITE_FO_MULTIPLE_ACTIVE_FOUND',
    'PASSAGE2_UNITE_FO_ALL_STRATEGIES_FAILED' = 'PASSAGE2_UNITE_FO_ALL_STRATEGIES_FAILED',
    'DOSSIER_UNKNOWN_ERROR' = 'DOSSIER_UNKNOWN_ERROR',
    'DOSSIER_NOT_FOUND' = 'DOSSIER_NOT_FOUND',
    'DOSSIER_RGPD_DATA_NOT_FOUND' = 'DOSSIER_RGPD_DATA_NOT_FOUND',
    'DOSSIER_CREATE_ERROR' = 'DOSSIER_CREATE_ERROR',
    'DOSSIER_UPDATE_ERROR' = 'DOSSIER_UPDATE_ERROR',
    'DOSSIER_SORTIE_VEHICULE_ERROR' = 'DOSSIER_SORTIE_VEHICULE_ERROR',
    'DOSSIER_ENTREE_VEHICULE_ERROR' = 'DOSSIER_ENTREE_VEHICULE_ERROR',
    'DOSSIER_MISSING_INFO_IN_HEADER' = 'DOSSIER_MISSING_INFO_IN_HEADER',
    'DOSSIER_PROLONGATION_MEF_ERROR' = 'DOSSIER_PROLONGATION_MEF_ERROR',
    'DOSSIER_CLASSEMENT_UNKNOWN_ERROR' = 'DOSSIER_CLASSEMENT_UNKNOWN_ERROR',
    'DOSSIER_EXISTING_CLASSEMENT_ERROR' = 'DOSSIER_EXISTING_CLASSEMENT_ERROR',
    'DOSSIER_UPDATE_ENTITES_RATTACHEMENT_ERROR' = 'DOSSIER_UPDATE_ENTITES_RATTACHEMENT_ERROR',
    'DOSSIER_UPDATE_FOURRIERE_RATTACHEMENT_DOUBLON_DOSSIER_ERROR' = 'DOSSIER_UPDATE_FOURRIERE_RATTACHEMENT_DOUBLON_DOSSIER_ERROR',
    'DOSSIER_UPDATE_DONNEES_VEHICULE_ERROR' = 'DOSSIER_UPDATE_DONNEES_VEHICULE_ERROR',
    'DOSSIER_CONTROLE_DONNEES_VEHICULE_ERROR' = 'DOSSIER_CONTROLE_DONNEES_VEHICULE_ERROR',
    'DOSSIER_BYPASS_CONTROLE_DONNEES_VEHICULE_SIV_ERROR' = 'DOSSIER_BYPASS_CONTROLE_DONNEES_VEHICULE_SIV_ERROR',
    'DOSSIER_COMMENTAIRE_ERROR' = 'DOSSIER_COMMENTAIRE_ERROR',
    'DOSSIER_EXPORT_CSV_ERROR' = 'DOSSIER_EXPORT_CSV_ERROR',
    'DOSSIER_RECUPERATION_ACTIVITE_UTILISATEUR_ERROR' = 'DOSSIER_RECUPERATION_ACTIVITE_UTILISATEUR_ERROR',
    'DOSSIER_EXPORT_STATISTIQUES_ERROR' = 'DOSSIER_EXPORT_STATISTIQUES_ERROR',
    'UPLOAD_APUREMENT_DOSSIERS_ERROR' = 'UPLOAD_APUREMENT_DOSSIERS_ERROR',
    'DOSSIER_BON_ENLEVEMENT_GARDIEN_UNKNOWN_ERROR' = 'DOSSIER_BON_ENLEVEMENT_GARDIEN_UNKNOWN_ERROR',
    'DOSSIER_EXISTING_BON_ENLEVEMENT_GARDIEN_ERROR' = 'DOSSIER_EXISTING_BON_ENLEVEMENT_GARDIEN_ERROR',
    'DOSSIER_INVALID_BON_ENLEVEMENT_GARDIEN_ERROR' = 'DOSSIER_INVALID_BON_ENLEVEMENT_GARDIEN_ERROR',
    'DOSSIER_WORKFLOW_SYNC_ERROR' = 'DOSSIER_WORKFLOW_SYNC_ERROR',
    'DOSSIER_WORKFLOW_RESET_ERROR' = 'DOSSIER_WORKFLOW_RESET_ERROR',
    'DOSSIER_UPDATE_SIV_INFORMATION_ERROR' = 'DOSSIER_UPDATE_SIV_INFORMATION_ERROR',
    'DOSSIER_UPDATE_DICEM_INFORMATION_ERROR' = 'DOSSIER_UPDATE_DICEM_INFORMATION_ERROR',
    'DOSSIER_UPDATE_MAIN_LEVEE_ERROR' = 'DOSSIER_UPDATE_MAIN_LEVEE_ERROR',
    'DOSSIER_REFRESH_BODIES_NOT_COMPLETE' = 'DOSSIER_REFRESH_BODIES_NOT_COMPLETE',
    'DOSSIER_ABANDON_ERROR' = 'DOSSIER_ABANDON_ERROR',
    'DOSSIER_NOTIFICATION_INFOS_ERROR' = 'DOSSIER_NOTIFICATION_INFOS_ERROR',
    'DOSSIER_EVENT_NOT_FOUND' = 'DOSSIER_EVENT_NOT_FOUND',
    'DOSSIER_COMPARAISON_SIV_FD_ERROR' = 'DOSSIER_COMPARAISON_SIV_FD_ERROR',
    'DOSSIER_PIECE_JOINTE_UPLOAD_ERROR' = 'DOSSIER_PIECE_JOINTE_UPLOAD_ERROR',
    'DOSSIER_UPDATE_DONNEES_JUDICIAIRES_ERROR' = 'DOSSIER_UPDATE_DONNEES_JUDICIAIRES_ERROR',
    'HISTORIQUE_LIMIT_EXCEEDED_ERROR' = 'HISTORIQUE_LIMIT_EXCEEDED_ERROR',
    'CLASSEMENT_BAD_TABLE_FORMAT_ERROR' = 'CLASSEMENT_BAD_TABLE_FORMAT_ERROR',
    'CLASSEMENT_BAD_REQUEST' = 'CLASSEMENT_BAD_REQUEST',
    'CLASSEMENT_EXPORT_TABLE_ERROR' = 'CLASSEMENT_EXPORT_TABLE_ERROR',
    'CLASSEMENT_FORBIDDEN_REQUEST' = 'CLASSEMENT_FORBIDDEN_REQUEST',
    'CLASSEMENT_CSV_ERROR' = 'CLASSEMENT_CSV_ERROR',
    'REFERENTIEL_UNKNOWN_ERROR' = 'REFERENTIEL_UNKNOWN_ERROR',
    'REFERENTIEL_NOT_FOUND' = 'REFERENTIEL_NOT_FOUND',
    'REFERENTIEL_NO_ACTIVE_FOUND' = 'REFERENTIEL_NO_ACTIVE_FOUND',
    'REFERENTIEL_MULTIPLE_ACTIVE_FOUND' = 'REFERENTIEL_MULTIPLE_ACTIVE_FOUND',
    'REFERENTIEL_PROFILE_NOT_FOUND' = 'REFERENTIEL_PROFILE_NOT_FOUND',
    'REFERENTIEL_INVALID_FILE' = 'REFERENTIEL_INVALID_FILE',
    'REFERENTIEL_INVALID_DATA' = 'REFERENTIEL_INVALID_DATA',
    'REFERENTIEL_FORBIDDEN_IMPORT' = 'REFERENTIEL_FORBIDDEN_IMPORT',
    'REFERENTIEL_UNABLE_CAST_SIV_DATA' = 'REFERENTIEL_UNABLE_CAST_SIV_DATA',
    'REFERENTIEL_UPDATE_PROFIL_UNITE_FO_ERROR' = 'REFERENTIEL_UPDATE_PROFIL_UNITE_FO_ERROR',
    'REFERENTIEL_CREATE_CENTRE_VHU_ERROR' = 'REFERENTIEL_CREATE_CENTRE_VHU_ERROR',
    'REFERENTIEL_UPDATE_CENTRE_VHU_ERROR' = 'REFERENTIEL_UPDATE_CENTRE_VHU_ERROR',
    'REFERENTIEL_CREATE_BRANCHE_ERROR' = 'REFERENTIEL_CREATE_BRANCHE_ERROR',
    'REFERENTIEL_UPDATE_BRANCHE_ERROR' = 'REFERENTIEL_UPDATE_BRANCHE_ERROR',
    'REFERENTIEL_CREATE_ETAT_ERROR' = 'REFERENTIEL_CREATE_ETAT_ERROR',
    'REFERENTIEL_UPDATE_ETAT_ERROR' = 'REFERENTIEL_UPDATE_ETAT_ERROR',
    'REFERENTIEL_CREATE_FOOTER_LINK_ERROR' = 'REFERENTIEL_CREATE_FOOTER_LINK_ERROR',
    'REFERENTIEL_UPDATE_FOOTER_LINK_ERROR' = 'REFERENTIEL_UPDATE_FOOTER_LINK_ERROR',
    'REFERENTIEL_CREATE_GENRE_SIMPLIFIE_ERROR' = 'REFERENTIEL_CREATE_GENRE_SIMPLIFIE_ERROR',
    'REFERENTIEL_UPDATE_GENRE_SIMPLIFIE_ERROR' = 'REFERENTIEL_UPDATE_GENRE_SIMPLIFIE_ERROR',
    'REFERENTIEL_CREATE_VIDEO_TUTORIEL_ERROR' = 'REFERENTIEL_CREATE_VIDEO_TUTORIEL_ERROR',
    'REFERENTIEL_UPDATE_VIDEO_TUTORIEL_ERROR' = 'REFERENTIEL_UPDATE_VIDEO_TUTORIEL_ERROR',
    'REFERENTIEL_CREATE_JURIDICTION_ERROR' = 'REFERENTIEL_CREATE_JURIDICTION_ERROR',
    'REFERENTIEL_UPDATE_JURIDICTION_ERROR' = 'REFERENTIEL_UPDATE_JURIDICTION_ERROR',
    'REFERENTIEL_CREATE_UNITE_FO_ERROR' = 'REFERENTIEL_CREATE_UNITE_FO_ERROR',
    'REFERENTIEL_UPDATE_UNITE_FO_ERROR' = 'REFERENTIEL_UPDATE_UNITE_FO_ERROR',
    'REFERENTIEL_CREATE_AUTORITE_FOURRIERE_ERROR' = 'REFERENTIEL_CREATE_AUTORITE_FOURRIERE_ERROR',
    'REFERENTIEL_UPDATE_AF_ERROR' = 'REFERENTIEL_UPDATE_AF_ERROR',
    'REFERENTIEL_UPDATE_GF_ERROR' = 'REFERENTIEL_UPDATE_GF_ERROR',
    'REFERENTIEL_CREATE_INFORMATION_MESSAGE_ERROR' = 'REFERENTIEL_CREATE_INFORMATION_MESSAGE_ERROR',
    'REFERENTIEL_UPDATE_INFORMATION_MESSAGE_ERROR' = 'REFERENTIEL_UPDATE_INFORMATION_MESSAGE_ERROR',
    'CONFIGURATION_UNKNOWN_ERROR' = 'CONFIGURATION_UNKNOWN_ERROR',
    'CONFIGURATION_NOT_FOUND' = 'CONFIGURATION_NOT_FOUND',
    'CONFIGURATION_FORBIDDEN_UPDATE' = 'CONFIGURATION_FORBIDDEN_UPDATE',
    'DEPRECATE_REFERENTIELS_UNKNOWN_ERROR' = 'DEPRECATE_REFERENTIELS_UNKNOWN_ERROR',
    'DEPRECATE_REFERENTIELS_UNABLE_TO_DEPRECATE_USED_BY_DOSSIER' = 'DEPRECATE_REFERENTIELS_UNABLE_TO_DEPRECATE_USED_BY_DOSSIER',
    'DEPRECATE_REFERENTIELS_UNABLE_TO_DEPRECATE_PARENT_AND_USED_BY_DOSSIER' = 'DEPRECATE_REFERENTIELS_UNABLE_TO_DEPRECATE_PARENT_AND_USED_BY_DOSSIER',
    'DEPRECATE_REFERENTIELS_UNABLE_TO_DEPRECATE_PARENT' = 'DEPRECATE_REFERENTIELS_UNABLE_TO_DEPRECATE_PARENT',
    'WORKFLOW_CONNECTION_FAILED' = 'WORKFLOW_CONNECTION_FAILED',
    'WORKFLOW_SYNC_PROCESS_FAILED' = 'WORKFLOW_SYNC_PROCESS_FAILED',
    'WORKFLOW_PARSE_JSON_FAILED' = 'WORKFLOW_PARSE_JSON_FAILED',
    'WORKFLOW_UNKNOWN_ERROR' = 'WORKFLOW_UNKNOWN_ERROR',
    'WORKFLOW_WORKER_ERROR' = 'WORKFLOW_WORKER_ERROR',
    'EXPORT_FILES_UNKNOWN_ERROR' = 'EXPORT_FILES_UNKNOWN_ERROR',
    'EXPORT_FILES_WRITE_CSV_ERROR' = 'EXPORT_FILES_WRITE_CSV_ERROR',
    'EXPORT_FILES_WRITE_ZIP_ERROR' = 'EXPORT_FILES_WRITE_ZIP_ERROR',
    'EXPORT_FILES_BAD_REQUEST' = 'EXPORT_FILES_BAD_REQUEST',
    'EXPORT_FILE_NOT_FOUND_EXPORT_ERROR' = 'EXPORT_FILE_NOT_FOUND_EXPORT_ERROR',
    'EXPORT_FILE_NOT_GENERATED_EXPORT_ERROR' = 'EXPORT_FILE_NOT_GENERATED_EXPORT_ERROR',
    'EXPORT_FILE_EXPIRED_EXPORT_ERROR' = 'EXPORT_FILE_EXPIRED_EXPORT_ERROR',
    'EXPORT_FILE_FAILED_EXPORT_ERROR' = 'EXPORT_FILE_FAILED_EXPORT_ERROR',
    'EXPORT_FILE_CANNOT_ACCESS_FILE_ERROR' = 'EXPORT_FILE_CANNOT_ACCESS_FILE_ERROR',
    'EXPORT_FILE_CANNOT_ACCESS_MANUEL' = 'EXPORT_FILE_CANNOT_ACCESS_MANUEL',
    'EXPORT_FILE_CANNOT_ACCESS_FICHE_DESCRIPTIVE' = 'EXPORT_FILE_CANNOT_ACCESS_FICHE_DESCRIPTIVE',
    'EXPORT_FILE_IMPORT_PIECE_JOINTE_ERROR' = 'EXPORT_FILE_IMPORT_PIECE_JOINTE_ERROR',
    'EXPORT_FILE_EXPORT_PIECE_JOINTE_ERROR' = 'EXPORT_FILE_EXPORT_PIECE_JOINTE_ERROR',
    'EXPORT_FILE_EXPORT_DOCUMENT_SPECIFIQUE_ERROR' = 'EXPORT_FILE_EXPORT_DOCUMENT_SPECIFIQUE_ERROR',
    'EXPORT_FILE_EXPORT_DOCUMENT_SPECIFIQUE_NOT_FOUND_ERROR' = 'EXPORT_FILE_EXPORT_DOCUMENT_SPECIFIQUE_NOT_FOUND_ERROR',
    'RIE_SIV_RESPONSE_PARSE_XML_TO_DTO_FAILED' = 'RIE_SIV_RESPONSE_PARSE_XML_TO_DTO_FAILED',
    'RIE_SIV_RESPONSE_PARSE_TO_XML_READER_FAILED' = 'RIE_SIV_RESPONSE_PARSE_TO_XML_READER_FAILED',
    'RIE_SIV_RESPONSE_WITH_ERRORS' = 'RIE_SIV_RESPONSE_WITH_ERRORS',
    'RIE_SIV_BUILD_SOAP_HEADER_FAILED' = 'RIE_SIV_BUILD_SOAP_HEADER_FAILED',
    'RIE_SIV_BAD_REQUEST' = 'RIE_SIV_BAD_REQUEST',
    'RIE_SIV_SEND_REQUEST_FAILED' = 'RIE_SIV_SEND_REQUEST_FAILED',
    'RIE_SIV_UNKNOWN_ERROR' = 'RIE_SIV_UNKNOWN_ERROR',
    'SWAPART_FAILED_TO_REACH_CONVENTIONNEMENT' = 'SWAPART_FAILED_TO_REACH_CONVENTIONNEMENT',
    'SWAPART_FAILED_TO_REACH_LOGIN' = 'SWAPART_FAILED_TO_REACH_LOGIN',
    'SWAPART_LOGIN_ERROR' = 'SWAPART_LOGIN_ERROR',
    'SWAPART_UNKNOWN_ERROR' = 'SWAPART_UNKNOWN_ERROR',
    'FVA_EMPTY_RESPONSE_ERROR' = 'FVA_EMPTY_RESPONSE_ERROR',
    'FVA_SSL_ERROR' = 'FVA_SSL_ERROR',
    'FVA_KEYSTORE_ERROR' = 'FVA_KEYSTORE_ERROR',
    'FVA_BAD_REQUEST_ERROR' = 'FVA_BAD_REQUEST_ERROR',
    'FVA_UNKNOWN_ERROR' = 'FVA_UNKNOWN_ERROR',
    'NOTIFICATION_UNKNOWN_ERROR' = 'NOTIFICATION_UNKNOWN_ERROR',
    'NOTIFICATION_DECOMPRESSION_ARCHIVE_ERROR' = 'NOTIFICATION_DECOMPRESSION_ARCHIVE_ERROR',
    'NOTIFICATION_DIRECTORY_ERROR' = 'NOTIFICATION_DIRECTORY_ERROR',
    'NOTIFICATION_UNABLE_TO_PARSE_XML' = 'NOTIFICATION_UNABLE_TO_PARSE_XML',
    'NOTIFICATION_AUTO_DEMANDE_EDITION_EVENT_ERROR' = 'NOTIFICATION_AUTO_DEMANDE_EDITION_EVENT_ERROR',
    'NOTIFICATION_AUTO_POSTED_EVENT_ERROR' = 'NOTIFICATION_AUTO_POSTED_EVENT_ERROR',
    'NOTIFICATION_AUTO_FIND_BY_ANTAI_ID_ERROR' = 'NOTIFICATION_AUTO_FIND_BY_ANTAI_ID_ERROR',
    'NOTIFICATION_AUTO_INFOS_RETOUR_EVENT_ERROR' = 'NOTIFICATION_AUTO_INFOS_RETOUR_EVENT_ERROR',
    'NOTIFICATION_AUTO_FETCH_COURRIER_ERROR' = 'NOTIFICATION_AUTO_FETCH_COURRIER_ERROR',
    'INES_SAS_INVALID_USER' = 'INES_SAS_INVALID_USER',
    'INES_SAS_INVALID_MESSAGE' = 'INES_SAS_INVALID_MESSAGE',
    'INES_SAS_UNKNOWN_ERROR' = 'INES_SAS_UNKNOWN_ERROR',
    'COMPTES_UTILISATEURS_RESPONSE_CSV_EXCEPTION' = 'COMPTES_UTILISATEURS_RESPONSE_CSV_EXCEPTION',
    'COMPTES_UTILISATEURS_UNKNOWN_ERROR' = 'COMPTES_UTILISATEURS_UNKNOWN_ERROR',
    'COMPTES_UTILISATEURS_USER_NOT_FOUND' = 'COMPTES_UTILISATEURS_USER_NOT_FOUND',
    'COMPTES_UTILISATEURS_CREATE_USERNAME_MAX_INCREMENTS_EXCEEDED' = 'COMPTES_UTILISATEURS_CREATE_USERNAME_MAX_INCREMENTS_EXCEEDED',
    'COMPTES_UTILISATEURS_ENTITY_NOT_FOUND' = 'COMPTES_UTILISATEURS_ENTITY_NOT_FOUND',
    'COMPTES_UTILISATEURS_CLIENT_UNKNOWN_ERROR' = 'COMPTES_UTILISATEURS_CLIENT_UNKNOWN_ERROR',
    'CLIENT_VEGA_UNKNOWN_ERROR' = 'CLIENT_VEGA_UNKNOWN_ERROR',
    'COMPTES_UTILISATEURS_CLIENT_FORBIDDEN_ERROR' = 'COMPTES_UTILISATEURS_CLIENT_FORBIDDEN_ERROR',
    'COMPTES_UTILISATEURS_KEYCLOAK_CONNECT_ERROR' = 'COMPTES_UTILISATEURS_KEYCLOAK_CONNECT_ERROR',
    'COMPTES_UTILISATEURS_BAD_CSV_LINES' = 'COMPTES_UTILISATEURS_BAD_CSV_LINES',
    'COMPTES_UTILISATEURS_UNABLE_READ_FILE' = 'COMPTES_UTILISATEURS_UNABLE_READ_FILE',
    'COMPTES_UTILISATEURS_UNABLE_PARSE_JSON_RESPONSE' = 'COMPTES_UTILISATEURS_UNABLE_PARSE_JSON_RESPONSE',
    'COMPTES_UTILISATEURS_ERROR_KEYCLOAK_GROUP_CONFIGURATION' = 'COMPTES_UTILISATEURS_ERROR_KEYCLOAK_GROUP_CONFIGURATION',
    'COMPTES_UTILISATEURS_UPDATE_ERROR' = 'COMPTES_UTILISATEURS_UPDATE_ERROR',
    'COMPTES_UTILISATEURS_CREATE_ERROR' = 'COMPTES_UTILISATEURS_CREATE_ERROR',
    'PDF_UNKNOWN_ERROR' = 'PDF_UNKNOWN_ERROR',
    'PDF_NOTIFICATION_MAPPER_ERROR' = 'PDF_NOTIFICATION_MAPPER_ERROR',
    'PDF_BON_ENLEVEMENT_MAPPER_ERROR' = 'PDF_BON_ENLEVEMENT_MAPPER_ERROR',
    'PDF_GENERATE_DOCUMENT_ERROR' = 'PDF_GENERATE_DOCUMENT_ERROR',
    'PDF_NOT_FOUND_ERROR' = 'PDF_NOT_FOUND_ERROR',
    'PDF_WRITE_DOCUMENT_IN_RESPONSE_ERROR' = 'PDF_WRITE_DOCUMENT_IN_RESPONSE_ERROR',
    'ALIENATION_UNKNOWN_ERROR' = 'ALIENATION_UNKNOWN_ERROR',
    'ALIENATION_BAD_CSV_LINES' = 'ALIENATION_BAD_CSV_LINES',
    'VEGA_MALFORMED_VEGA_ID_CORRELATION' = 'VEGA_MALFORMED_VEGA_ID_CORRELATION',
    'ALIENATION_UNREADABLE_FILE' = 'ALIENATION_UNREADABLE_FILE',
    'VEGA_UNKNOWN_RESPONSE_ERROR' = 'VEGA_UNKNOWN_RESPONSE_ERROR',
    'VEGA_UNHANDLED_RESPONSE_ERROR' = 'VEGA_UNHANDLED_RESPONSE_ERROR',
    'ALIENATION_UNPROCESSED_RESPONSE_ERROR' = 'ALIENATION_UNPROCESSED_RESPONSE_ERROR',
    'ALIENATION_INVALID_DOSSIER_ALREADY_SENT' = 'ALIENATION_INVALID_DOSSIER_ALREADY_SENT',
    'ALIENATION_INVALID_DOSSIER_NOT_ALIENATION' = 'ALIENATION_INVALID_DOSSIER_NOT_ALIENATION',
    'ALIENATION_INVALID_DOSSIER_NOT_ABANDONED' = 'ALIENATION_INVALID_DOSSIER_NOT_ABANDONED',
    'ALIENATION_CONTOURNEMENT_IMPORT_DISABLED' = 'ALIENATION_CONTOURNEMENT_IMPORT_DISABLED',
    'NULL_IDENTIFICATION' = 'NULL_IDENTIFICATION',
    'SIV_ERROR' = 'SIV_ERROR',
    'CLASSEMENT_INTERNAL_ERROR' = 'CLASSEMENT_INTERNAL_ERROR',
    'STORE_SI_TIERS_UNKONW_ERROR' = 'STORE_SI_TIERS_UNKONW_ERROR',
    'STORE_SI_TIERS_FAIL_TO_SAVE_LOCK' = 'STORE_SI_TIERS_FAIL_TO_SAVE_LOCK',
    'STORE_SI_TIERS_PROCESS_LOCK' = 'STORE_SI_TIERS_PROCESS_LOCK',
    'ANTAI_UNKNOWN_ERROR' = 'ANTAI_UNKNOWN_ERROR',
    'ANTAI_DEMANDE_EDITION_BAD_REQUEST' = 'ANTAI_DEMANDE_EDITION_BAD_REQUEST',
    'NULL_PARAMETER_ERROR' = 'NULL_PARAMETER_ERROR',
    'RANGE_TOO_LARGE' = 'RANGE_TOO_LARGE',
    'BEGINNING_AFTER_END' = 'BEGINNING_AFTER_END',
    'DILA_UNKNOWN_ERROR' = 'DILA_UNKNOWN_ERROR',
    'DILA_CONNECTION_FAILED_ERROR' = 'DILA_CONNECTION_FAILED_ERROR',
    'DILA_API_AUTHENTICATION_ERROR' = 'DILA_API_AUTHENTICATION_ERROR',
    'DILA_MISSING_FOURRIERE_DTO' = 'DILA_MISSING_FOURRIERE_DTO',
    'DILA_DOSSIER_NOT_FOUND' = 'DILA_DOSSIER_NOT_FOUND',
    'DILA_BAD_REQUEST' = 'DILA_BAD_REQUEST',
    'DILA_MISSING_IMMATRICULATION' = 'DILA_MISSING_IMMATRICULATION',
    'DILA_MISSING_NUMERO_OR_DATE' = 'DILA_MISSING_NUMERO_OR_DATE',
    'DILA_FICHE_DESCRIPTIVE_NOT_FOUND' = 'DILA_FICHE_DESCRIPTIVE_NOT_FOUND',
    'DILA_FICHE_DESCRIPTIVE_FORBIDDEN' = 'DILA_FICHE_DESCRIPTIVE_FORBIDDEN',
    'DILA_INTERDICTION_CIRCULER' = 'DILA_INTERDICTION_CIRCULER',
    'DILA_VEHICULE_VOLE' = 'DILA_VEHICULE_VOLE',
    'DILA_ASSURANCE_INVALIDE' = 'DILA_ASSURANCE_INVALIDE',
    'DILA_PERMIS_INVALIDE' = 'DILA_PERMIS_INVALIDE',
    'DILA_PERMIS_NON_VERIFIE' = 'DILA_PERMIS_NON_VERIFIE',
    'DILA_VEHICULE_DEJA_SORTI' = 'DILA_VEHICULE_DEJA_SORTI',
    'DILA_VEHICULE_IMMOBILISE' = 'DILA_VEHICULE_IMMOBILISE',
    'DILA_MAIN_LEVEE_INDISPONIBLE' = 'DILA_MAIN_LEVEE_INDISPONIBLE',
    'DILA_STATUT_IDENTIFICATION_ARGOS_BLOQUANT' = 'DILA_STATUT_IDENTIFICATION_ARGOS_BLOQUANT',
    'PHOTO_UNKNOWN_ERROR' = 'PHOTO_UNKNOWN_ERROR',
    'UPLOAD_PHOTO_OUT_OF_BOUND_FAILURE' = 'UPLOAD_PHOTO_OUT_OF_BOUND_FAILURE',
    'DICEM_FAILED_TO_REACH_CONSULTATION' = 'DICEM_FAILED_TO_REACH_CONSULTATION',
    'DICEM_BAD_REQUEST_ERROR' = 'DICEM_BAD_REQUEST_ERROR',
    'DICEM_UNKNOWN_ERROR' = 'DICEM_UNKNOWN_ERROR',
    'RPSI_BATCH_IS_RUNNING_EXCEPTION' = 'RPSI_BATCH_IS_RUNNING_EXCEPTION',
    'RPSI_REQUEST_LOCKED_EXCEPTION' = 'RPSI_REQUEST_LOCKED_EXCEPTION',
    'RPSI_BATCH_FAILED' = 'RPSI_BATCH_FAILED',
    'ERPC_UNKNOWN_ERROR' = 'ERPC_UNKNOWN_ERROR',
    'ERPC_AUTHORIZATION_ERROR' = 'ERPC_AUTHORIZATION_ERROR',
    'ERPC_AUTHENTIFICATION_ERROR' = 'ERPC_AUTHENTIFICATION_ERROR',
    'ERPC_EMPTY_RESPONSE_ERROR' = 'ERPC_EMPTY_RESPONSE_ERROR',
    'GEOGOUV_UNKNOWN_ERROR' = 'GEOGOUV_UNKNOWN_ERROR'
}

/**
 * 
 * @export
 * @interface EtatConventionnementResponseDto
 */
export interface EtatConventionnementResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof EtatConventionnementResponseDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof EtatConventionnementResponseDto
     */
    codeInsee: string | null;
    /**
     * 
     * @type {ConventionnementSwaPartDto}
     * @memberof EtatConventionnementResponseDto
     */
    conventionnement: ConventionnementSwaPartDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof EtatConventionnementResponseDto
     */
    swapartWasCalled: boolean;
}
/**
 * 
 * @export
 * @interface EtatDto
 */
export interface EtatDto {
    /**
     * 
     * @type {string}
     * @memberof EtatDto
     */
    detail: string | null;
    /**
     * 
     * @type {string}
     * @memberof EtatDto
     */
    etat: EtatDtoEtatEnum;
    /**
     * 
     * @type {string}
     * @memberof EtatDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EtatDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof EtatDto
     */
    libelleCourt: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EtatDto
     */
    valid: boolean | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EtatDtoEtatEnum {
    'BON_ETAT' = 'BON_ETAT',
    'DEGRADE' = 'DEGRADE',
    'DOMMAGES_GRAVES' = 'DOMMAGES_GRAVES'
}

/**
 * 
 * @export
 * @interface EtatRequestDto
 */
export interface EtatRequestDto {
    /**
     * 
     * @type {string}
     * @memberof EtatRequestDto
     */
    detail: string | null;
    /**
     * 
     * @type {string}
     * @memberof EtatRequestDto
     */
    etat: EtatRequestDtoEtatEnum | null;
    /**
     * 
     * @type {string}
     * @memberof EtatRequestDto
     */
    libelleCourt: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EtatRequestDtoEtatEnum {
    'BON_ETAT' = 'BON_ETAT',
    'DEGRADE' = 'DEGRADE',
    'DOMMAGES_GRAVES' = 'DOMMAGES_GRAVES'
}

/**
 * 
 * @export
 * @interface EtatViolationDto
 */
export interface EtatViolationDto {
    /**
     * 
     * @type {string}
     * @memberof EtatViolationDto
     */
    formField: EtatViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof EtatViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof EtatViolationDto
     */
    violationCode: EtatViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EtatViolationDtoFormFieldEnum {
    'ETAT' = 'ETAT',
    'DETAIL' = 'DETAIL',
    'LIBELLE_COURT' = 'LIBELLE_COURT'
}
/**
    * @export
    * @enum {string}
    */
export enum EtatViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD'
}

/**
 * 
 * @export
 * @interface ExpediteurNotificationDto
 */
export interface ExpediteurNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationDto
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationDto
     */
    idCorrelationUniteFo: string | null;
}
/**
 * 
 * @export
 * @interface ExpediteurNotificationRequestDto
 */
export interface ExpediteurNotificationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationRequestDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationRequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationRequestDto
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationRequestDto
     */
    idCorrelationUniteFo: string | null;
}
/**
 * 
 * @export
 * @interface ExpediteurNotificationViolationDto
 */
export interface ExpediteurNotificationViolationDto {
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationViolationDto
     */
    formField: ExpediteurNotificationViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ExpediteurNotificationViolationDto
     */
    violationCode: ExpediteurNotificationViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ExpediteurNotificationViolationDtoFormFieldEnum {
    'UNITE' = 'UNITE',
    'ADRESSE' = 'ADRESSE',
    'CODE_POSTAL' = 'CODE_POSTAL',
    'COMMUNE' = 'COMMUNE'
}
/**
    * @export
    * @enum {string}
    */
export enum ExpediteurNotificationViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'CODE_POSTAL_BAD_FORMAT' = 'CODE_POSTAL_BAD_FORMAT',
    'NOT_FOUND_IN_REFERENTIAL' = 'NOT_FOUND_IN_REFERENTIAL'
}

/**
 * 
 * @export
 * @interface ExportDonneesDossierAdminFonctionnelDto
 */
export interface ExportDonneesDossierAdminFonctionnelDto {
    /**
     * 
     * @type {DossierResponseDto}
     * @memberof ExportDonneesDossierAdminFonctionnelDto
     */
    dossier: DossierResponseDto;
    /**
     * 
     * @type {Array<DetailedEventDto>}
     * @memberof ExportDonneesDossierAdminFonctionnelDto
     */
    events: Array<DetailedEventDto>;
}
/**
 * 
 * @export
 * @interface ExportFilesDto
 */
export interface ExportFilesDto {
    /**
     * 
     * @type {string}
     * @memberof ExportFilesDto
     */
    errorDescription: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExportFilesDto
     */
    errorOccured: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExportFilesDto
     */
    expirationDate: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExportFilesDto
     */
    exportType: string;
    /**
     * 
     * @type {string}
     * @memberof ExportFilesDto
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof ExportFilesDto
     */
    fileType: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExportFilesDto
     */
    generated: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExportFilesDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExportFilesDto
     */
    idUser: string;
}
/**
 * 
 * @export
 * @interface ExportStatistiquesRequestDto
 */
export interface ExportStatistiquesRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ExportStatistiquesRequestDto
     */
    dateDebut: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExportStatistiquesRequestDto
     */
    dateFin: string | null;
}
/**
 * 
 * @export
 * @interface ExportStatistiquesViolationsDto
 */
export interface ExportStatistiquesViolationsDto {
    /**
     * 
     * @type {string}
     * @memberof ExportStatistiquesViolationsDto
     */
    formField: ExportStatistiquesViolationsDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof ExportStatistiquesViolationsDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ExportStatistiquesViolationsDto
     */
    violationCode: ExportStatistiquesViolationsDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ExportStatistiquesViolationsDtoFormFieldEnum {
    'DATE_DEBUT' = 'DATE_DEBUT',
    'DATE_FIN' = 'DATE_FIN'
}
/**
    * @export
    * @enum {string}
    */
export enum ExportStatistiquesViolationsDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'DATE_DEBUT_AFTER_DATE_FIN' = 'DATE_DEBUT_AFTER_DATE_FIN'
}

/**
 * 
 * @export
 * @interface FaqAdminDto
 */
export interface FaqAdminDto {
    /**
     * 
     * @type {string}
     * @memberof FaqAdminDto
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof FaqAdminDto
     */
    domainId: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaqAdminDto
     */
    domainName: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaqAdminDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FaqAdminDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof FaqAdminDto
     */
    profiles: Array<FaqAdminDtoProfilesEnum>;
    /**
     * 
     * @type {string}
     * @memberof FaqAdminDto
     */
    title: string;
    /**
     * 
     * @type {boolean}
     * @memberof FaqAdminDto
     */
    valid: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum FaqAdminDtoProfilesEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface FaqDomainAdminDto
 */
export interface FaqDomainAdminDto {
    /**
     * 
     * @type {string}
     * @memberof FaqDomainAdminDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FaqDomainAdminDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof FaqDomainAdminDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof FaqDomainAdminDto
     */
    valid: boolean;
}
/**
 * 
 * @export
 * @interface FaqDomainDto
 */
export interface FaqDomainDto {
    /**
     * 
     * @type {Array<FaqDto>}
     * @memberof FaqDomainDto
     */
    faqs: Array<FaqDto>;
    /**
     * 
     * @type {string}
     * @memberof FaqDomainDto
     */
    name: string | null;
}
/**
 * 
 * @export
 * @interface FaqDomainRequestDto
 */
export interface FaqDomainRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FaqDomainRequestDto
     */
    name: string | null;
}
/**
 * 
 * @export
 * @interface FaqDomainViolationDto
 */
export interface FaqDomainViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FaqDomainViolationDto
     */
    formField: FaqDomainViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FaqDomainViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FaqDomainViolationDto
     */
    violationCode: FaqDomainViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FaqDomainViolationDtoFormFieldEnum {
    'NAME' = 'NAME'
}
/**
    * @export
    * @enum {string}
    */
export enum FaqDomainViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'NAME_ALREADY_USED' = 'NAME_ALREADY_USED'
}

/**
 * 
 * @export
 * @interface FaqDto
 */
export interface FaqDto {
    /**
     * 
     * @type {string}
     * @memberof FaqDto
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof FaqDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FaqDto
     */
    title: string;
}
/**
 * 
 * @export
 * @interface FaqRequestDto
 */
export interface FaqRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FaqRequestDto
     */
    content: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaqRequestDto
     */
    domainId: string | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof FaqRequestDto
     */
    profiles: Array<FaqRequestDtoProfilesEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof FaqRequestDto
     */
    title: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FaqRequestDtoProfilesEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface FaqViolationDto
 */
export interface FaqViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FaqViolationDto
     */
    formField: FaqViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FaqViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FaqViolationDto
     */
    violationCode: FaqViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FaqViolationDtoFormFieldEnum {
    'DOMAIN_ID' = 'DOMAIN_ID',
    'TITLE' = 'TITLE',
    'PROFILES' = 'PROFILES',
    'CONTENT' = 'CONTENT'
}
/**
    * @export
    * @enum {string}
    */
export enum FaqViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'TITLE_ALREADY_USED' = 'TITLE_ALREADY_USED'
}

/**
 * 
 * @export
 * @interface FicheAgentFoRequestDto
 */
export interface FicheAgentFoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FicheAgentFoRequestDto
     */
    dateEtablissement: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheAgentFoRequestDto
     */
    idCorrelationUniteFoDetachee: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheAgentFoRequestDto
     */
    identifiantNigend: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheAgentFoRequestDto
     */
    presenceResponsableEnlevement: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheAgentFoRequestDto
     */
    qualiteAutorite: FicheAgentFoRequestDtoQualiteAutoriteEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheAgentFoRequestDto
     */
    uniteFoDetachee: boolean | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheAgentFoRequestDtoQualiteAutoriteEnum {
    'OPJ' = 'OPJ',
    'APJ' = 'APJ',
    'APJA' = 'APJA'
}

/**
 * 
 * @export
 * @interface FicheAgentFoViolationDto
 */
export interface FicheAgentFoViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FicheAgentFoViolationDto
     */
    formField: FicheAgentFoViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FicheAgentFoViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FicheAgentFoViolationDto
     */
    violationCode: FicheAgentFoViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheAgentFoViolationDtoFormFieldEnum {
    'UNITE_FO' = 'UNITE_FO'
}
/**
    * @export
    * @enum {string}
    */
export enum FicheAgentFoViolationDtoViolationCodeEnum {
    'UNITE_FO_MANQUANTE' = 'UNITE_FO_MANQUANTE',
    'UNITE_FO_INVALIDE' = 'UNITE_FO_INVALIDE',
    'UNITE_FO_DETACHEE_IDENTIQUE' = 'UNITE_FO_DETACHEE_IDENTIQUE'
}

/**
 * 
 * @export
 * @interface FicheConditionsRequestDto
 */
export interface FicheConditionsRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FicheConditionsRequestDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheConditionsRequestDto
     */
    commune: string | null;
    /**
     * <p>Date de constatation de l\'infraction. <p>L\'heure est ignorée et remplacée par la première heure de la journée selon le fuseau horaire de la fourrière dans laquelle va le véhicule. <p>Exemples : <table border=\"1\">   <thead>     <tr>         <th>entrée</td>         <th>fuseau horaire de la fourrière</td>         <th>date enregistrée</td>     </tr>   </thead>   <tbody>     <tr>         <td>2023-10-01T00:00:00+02:00</td>         <td>+2 (Paris heure d&#39;été)</td>         <td>2023-09-30T22:00:00Z</td>     </tr>     <tr>         <td>2023-08-01T11:18:08Z</td>         <td>+2 (Paris heure d&#39;été)</td>         <td>2023-07-31T22:00:00Z</td>     </tr>     <tr>         <td>2023-12-01T11:18:08Z</td>         <td>+1 (Paris heure d&#39;hiver)</td>         <td>2023-11-30T23:00:00Z</td>     </tr>     <tr>         <td>2023-10-01T11:18:08Z</td>         <td>-4 (Martinique)</td>         <td>2023-10-01T04:00:00Z</td>     </tr>   </tbody> </table> 
     * @type {string}
     * @memberof FicheConditionsRequestDto
     */
    dateConstatationInfraction: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheConditionsRequestDto
     */
    isNeige: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheConditionsRequestDto
     */
    isNuit: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheConditionsRequestDto
     */
    isPluie: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheConditionsRequestDto
     */
    lieuPrive: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheConditionsRequestDto
     */
    motifMefId: string | null;
}
/**
 * 
 * @export
 * @interface FicheConditionsViolationDto
 */
export interface FicheConditionsViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FicheConditionsViolationDto
     */
    formField: FicheConditionsViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FicheConditionsViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FicheConditionsViolationDto
     */
    violationCode: FicheConditionsViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheConditionsViolationDtoFormFieldEnum {
    'DATE_CONSTATATION' = 'DATE_CONSTATATION',
    'MOTIVATION_MESURE' = 'MOTIVATION_MESURE',
    'ADRESSE' = 'ADRESSE',
    'COMMUNE' = 'COMMUNE'
}
/**
    * @export
    * @enum {string}
    */
export enum FicheConditionsViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'DATE_IN_THE_FUTURE' = 'DATE_IN_THE_FUTURE',
    'MOTIF_MEF_NOT_FOUND' = 'MOTIF_MEF_NOT_FOUND',
    'INVALID_MOTIF_MEF' = 'INVALID_MOTIF_MEF',
    'BRANCHE_SHOULD_BE_MAITRE_LIEU' = 'BRANCHE_SHOULD_BE_MAITRE_LIEU'
}

/**
 * 
 * @export
 * @interface FicheDetailsFoViolationDto
 */
export interface FicheDetailsFoViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FicheDetailsFoViolationDto
     */
    formField: FicheDetailsFoViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FicheDetailsFoViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FicheDetailsFoViolationDto
     */
    violationCode: string;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheDetailsFoViolationDtoFormFieldEnum {
    'VERROUILLAGE_PORTES' = 'VERROUILLAGE_PORTES',
    'VERROUILLAGE_COFFRES' = 'VERROUILLAGE_COFFRES',
    'ACCESSOIRES_OBJETS_VISIBLES' = 'ACCESSOIRES_OBJETS_VISIBLES',
    'ACCESSOIRES_OBSERVATIONS' = 'ACCESSOIRES_OBSERVATIONS'
}

/**
 * 
 * @export
 * @interface FicheDetailsVehiculeFoRequestDto
 */
export interface FicheDetailsVehiculeFoRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof FicheDetailsVehiculeFoRequestDto
     */
    coffres: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheDetailsVehiculeFoRequestDto
     */
    objetsVisibles: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheDetailsVehiculeFoRequestDto
     */
    observations: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheDetailsVehiculeFoRequestDto
     */
    portes: boolean | null;
}
/**
 * 
 * @export
 * @interface FicheEtatGeneralFoRequestDto
 */
export interface FicheEtatGeneralFoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FicheEtatGeneralFoRequestDto
     */
    etatLibelle: FicheEtatGeneralFoRequestDtoEtatLibelleEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FicheEtatGeneralFoRequestDto
     */
    etatPrecisionId: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheEtatGeneralFoRequestDtoEtatLibelleEnum {
    'BON_ETAT' = 'BON_ETAT',
    'DEGRADE' = 'DEGRADE',
    'DOMMAGES_GRAVES' = 'DOMMAGES_GRAVES'
}

/**
 * 
 * @export
 * @interface FicheEtatGeneralFoViolationDto
 */
export interface FicheEtatGeneralFoViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FicheEtatGeneralFoViolationDto
     */
    formField: FicheEtatGeneralFoViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FicheEtatGeneralFoViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FicheEtatGeneralFoViolationDto
     */
    violationCode: FicheEtatGeneralFoViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheEtatGeneralFoViolationDtoFormFieldEnum {
    'ETAT_LIBELLE' = 'ETAT_LIBELLE',
    'ETAT_PRECISION' = 'ETAT_PRECISION'
}
/**
    * @export
    * @enum {string}
    */
export enum FicheEtatGeneralFoViolationDtoViolationCodeEnum {
    'MISSING_VALUE' = 'MISSING_VALUE',
    'ETAT_PRECISION_INVALID' = 'ETAT_PRECISION_INVALID',
    'ETAT_WITHOUT_PRECISION_NOT_FOUND' = 'ETAT_WITHOUT_PRECISION_NOT_FOUND',
    'ETAT_PRECISION_MUST_BE_NULL_IN_THIS_CASE' = 'ETAT_PRECISION_MUST_BE_NULL_IN_THIS_CASE'
}

/**
 * 
 * @export
 * @interface FicheFourriereDto
 */
export interface FicheFourriereDto {
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereDto
     */
    dateEnlevement: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereDto
     */
    dateEntree: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereDto
     */
    dateEntreeAutomatique: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereDto
     */
    idCorrelationFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereDto
     */
    numeroFacture: string | null;
}
/**
 * 
 * @export
 * @interface FicheFourriereFoRequestDto
 */
export interface FicheFourriereFoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereFoRequestDto
     */
    autoriteQualifiee: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereFoRequestDto
     */
    idCorrelationAutoriteFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereFoRequestDto
     */
    idCorrelationFourriere: string | null;
}
/**
 * 
 * @export
 * @interface FicheFourriereFoViolationDto
 */
export interface FicheFourriereFoViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereFoViolationDto
     */
    formField: FicheFourriereFoViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereFoViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereFoViolationDto
     */
    violationCode: FicheFourriereFoViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheFourriereFoViolationDtoFormFieldEnum {
    'FOURRIERE' = 'FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'AUTORITE_QUALIFIEE' = 'AUTORITE_QUALIFIEE'
}
/**
    * @export
    * @enum {string}
    */
export enum FicheFourriereFoViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'INVALID_FOURRIERE' = 'INVALID_FOURRIERE',
    'FOURRIERE_NOT_FOUND' = 'FOURRIERE_NOT_FOUND',
    'INVALID_AUTORITE_FOURRIERE' = 'INVALID_AUTORITE_FOURRIERE',
    'AUTORITE_FOURRIERE_NOT_FOUND' = 'AUTORITE_FOURRIERE_NOT_FOUND'
}

/**
 * 
 * @export
 * @interface FicheFourriereRequestDto
 */
export interface FicheFourriereRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereRequestDto
     */
    dateEnlevement: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereRequestDto
     */
    dateEntree: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereRequestDto
     */
    idCorrelationFourriere: string | null;
}
/**
 * 
 * @export
 * @interface FicheFourriereSummaryDto
 */
export interface FicheFourriereSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereSummaryDto
     */
    dateMiseEnFourriere: string | null;
}
/**
 * 
 * @export
 * @interface FicheFourriereViolationDto
 */
export interface FicheFourriereViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereViolationDto
     */
    formField: FicheFourriereViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FicheFourriereViolationDto
     */
    violationCode: FicheFourriereViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheFourriereViolationDtoFormFieldEnum {
    'ENTREE' = 'ENTREE',
    'ENLEVEMENT' = 'ENLEVEMENT',
    'FOURRIERE' = 'FOURRIERE',
    'DATE_CONSTATATION' = 'DATE_CONSTATATION'
}
/**
    * @export
    * @enum {string}
    */
export enum FicheFourriereViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'DATE_ENLEVEMENT_PRIOR_DATE_CONSTATATION' = 'DATE_ENLEVEMENT_PRIOR_DATE_CONSTATATION',
    'DATE_ENLEVEMENT_PRIOR_DATE_REDACTION' = 'DATE_ENLEVEMENT_PRIOR_DATE_REDACTION',
    'DATE_ENTREE_PRIOR_DATE_CONSTATATION' = 'DATE_ENTREE_PRIOR_DATE_CONSTATATION',
    'DATE_ENTREE_PRIOR_DATE_ENLEVEMENT' = 'DATE_ENTREE_PRIOR_DATE_ENLEVEMENT',
    'DATE_IN_THE_FUTURE' = 'DATE_IN_THE_FUTURE',
    'INVALID_FOURRIERE' = 'INVALID_FOURRIERE',
    'FOURRIERE_NOT_FOUND' = 'FOURRIERE_NOT_FOUND'
}

/**
 * 
 * @export
 * @interface FicheInfractionDto
 */
export interface FicheInfractionDto {
    /**
     * 
     * @type {AgentFoDto}
     * @memberof FicheInfractionDto
     */
    agent: AgentFoDto | null;
    /**
     * 
     * @type {AutoriteMainleveeDto}
     * @memberof FicheInfractionDto
     */
    autoriteMainlevee: AutoriteMainleveeDto | null;
    /**
     * 
     * @type {AutoritePrescriptriceDto}
     * @memberof FicheInfractionDto
     */
    autoritePrescriptrice: AutoritePrescriptriceDto | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionDto
     */
    communeEnlevement: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionDto
     */
    dateConstatation: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionDto
     */
    dateRedaction: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionDto
     */
    emailUnite: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionDto
     */
    idCorrelationAutoriteFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionDto
     */
    idCorrelationAutoriteFourriereFicheFo: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionDto
     */
    idCorrelationUniteFO: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionDto
     */
    lieuEnlevement: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheInfractionDto
     */
    lieuPrive: boolean | null;
    /**
     * 
     * @type {MotifMefDto}
     * @memberof FicheInfractionDto
     */
    motifMef: MotifMefDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheInfractionDto
     */
    nuit: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheInfractionDto
     */
    pluieOuNeige: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheInfractionDto
     */
    presenceResponsableEnlevement: boolean | null;
}
/**
 * 
 * @export
 * @interface FicheInfractionRequestDto
 */
export interface FicheInfractionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    autoriteQualifieePourLeverMesure: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    communeEnlevement: string | null;
    /**
     * <p>Date de constatation de l\'infraction. <p>L\'heure est ignorée et remplacée par la première heure de la journée selon le fuseau horaire de la fourrière dans laquelle va le véhicule. <p>Exemples : <table border=\"1\">   <thead>     <tr>         <th>entrée</td>         <th>fuseau horaire de la fourrière</td>         <th>date enregistrée</td>     </tr>   </thead>   <tbody>     <tr>         <td>2023-10-01T00:00:00+02:00</td>         <td>+2 (Paris heure d&#39;été)</td>         <td>2023-09-30T22:00:00Z</td>     </tr>     <tr>         <td>2023-08-01T11:18:08Z</td>         <td>+2 (Paris heure d&#39;été)</td>         <td>2023-07-31T22:00:00Z</td>     </tr>     <tr>         <td>2023-12-01T11:18:08Z</td>         <td>+1 (Paris heure d&#39;hiver)</td>         <td>2023-11-30T23:00:00Z</td>     </tr>     <tr>         <td>2023-10-01T11:18:08Z</td>         <td>-4 (Martinique)</td>         <td>2023-10-01T04:00:00Z</td>     </tr>   </tbody> </table> 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    dateConstatation: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    dateRedaction: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    emailUnite: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    idCorrelationAutoriteFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    idCorrelationFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    idCorrelationUniteFO: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    lieuEnlevement: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheInfractionRequestDto
     */
    lieuPrive: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    motifMefId: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    nigend: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    nomAgent: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    nomAutorite: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheInfractionRequestDto
     */
    nuit: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheInfractionRequestDto
     */
    pluieOuNeige: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionRequestDto
     */
    qualiteAutorite: FicheInfractionRequestDtoQualiteAutoriteEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheInfractionRequestDtoQualiteAutoriteEnum {
    'OPJ' = 'OPJ',
    'APJ' = 'APJ',
    'APJA' = 'APJA'
}

/**
 * 
 * @export
 * @interface FicheInfractionSummaryDto
 */
export interface FicheInfractionSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionSummaryDto
     */
    autoritePrescriptrice: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionSummaryDto
     */
    communeEnlevement: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheInfractionSummaryDto
     */
    lieuPrive: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionSummaryDto
     */
    motivationMesure: string | null;
}
/**
 * 
 * @export
 * @interface FicheInfractionViolationDto
 */
export interface FicheInfractionViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionViolationDto
     */
    formField: FicheInfractionViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FicheInfractionViolationDto
     */
    violationCode: FicheInfractionViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheInfractionViolationDtoFormFieldEnum {
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'FOURRIERE' = 'FOURRIERE',
    'DATE_CONSTATATION' = 'DATE_CONSTATATION',
    'NOM_AUTORITE_PRESCRIPTRICE' = 'NOM_AUTORITE_PRESCRIPTRICE',
    'QUALITE_AUTORITE_PRESCRIPTRICE' = 'QUALITE_AUTORITE_PRESCRIPTRICE',
    'NOM_AGENT' = 'NOM_AGENT',
    'NIGEND' = 'NIGEND',
    'UNITE' = 'UNITE',
    'MAIL_UNITE' = 'MAIL_UNITE',
    'MOTIVATION_MESURE' = 'MOTIVATION_MESURE',
    'LIEU_PRIVE' = 'LIEU_PRIVE',
    'LIEU_ENLEVEMENT' = 'LIEU_ENLEVEMENT',
    'COMMUNE' = 'COMMUNE',
    'NUIT' = 'NUIT',
    'PLUIE_NEIGE' = 'PLUIE_NEIGE',
    'AUTORITE_POUR_LEVER_MESURE' = 'AUTORITE_POUR_LEVER_MESURE',
    'DATE_REDACTION' = 'DATE_REDACTION'
}
/**
    * @export
    * @enum {string}
    */
export enum FicheInfractionViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'MISSING_UNITE_FO' = 'MISSING_UNITE_FO',
    'AUTORITE_FOURRIERE_NOT_FOUND' = 'AUTORITE_FOURRIERE_NOT_FOUND',
    'INVALID_AUTORITE_FOURRIERE' = 'INVALID_AUTORITE_FOURRIERE',
    'UNITE_FO_NOT_FOUND' = 'UNITE_FO_NOT_FOUND',
    'INVALID_UNITE_FO' = 'INVALID_UNITE_FO',
    'FOURRIERE_NOT_FOUND' = 'FOURRIERE_NOT_FOUND',
    'INVALID_FOURRIERE' = 'INVALID_FOURRIERE',
    'MOTIF_MEF_NOT_FOUND' = 'MOTIF_MEF_NOT_FOUND',
    'INVALID_MOTIF_MEF' = 'INVALID_MOTIF_MEF',
    'DATE_IN_THE_FUTURE' = 'DATE_IN_THE_FUTURE',
    'NIGEND_BAD_FORMAT' = 'NIGEND_BAD_FORMAT',
    'MAIL_BAD_FORMAT' = 'MAIL_BAD_FORMAT',
    'DATE_REDACTION_PRIOR_DATE_CONSTATATION' = 'DATE_REDACTION_PRIOR_DATE_CONSTATATION',
    'BRANCHE_SHOULD_BE_MAITRE_LIEU' = 'BRANCHE_SHOULD_BE_MAITRE_LIEU',
    'LIEU_PRIVE_SHOULD_BE_TRUE_WHEN_BRANCHE_MAITRE_LIEU' = 'LIEU_PRIVE_SHOULD_BE_TRUE_WHEN_BRANCHE_MAITRE_LIEU',
    'INCONSISTENT_AUTORITE_FOURRIERE' = 'INCONSISTENT_AUTORITE_FOURRIERE'
}

/**
 * 
 * @export
 * @interface FicheJudiciaireDto
 */
export interface FicheJudiciaireDto {
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireDto
     */
    idCorrelationJuridiction: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireDto
     */
    numeroIDJ: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireDto
     */
    numeroParquet: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireDto
     */
    numeroPv: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireDto
     */
    valeurJuridique: FicheJudiciaireDtoValeurJuridiqueEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheJudiciaireDtoValeurJuridiqueEnum {
    'PROBATOIRE' = 'PROBATOIRE',
    'CONFISCATOIRE' = 'CONFISCATOIRE'
}

/**
 * 
 * @export
 * @interface FicheJudiciaireRequestDto
 */
export interface FicheJudiciaireRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireRequestDto
     */
    idCorrelationJuridiction: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireRequestDto
     */
    numeroIDJ: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireRequestDto
     */
    numeroParquet: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireRequestDto
     */
    numeroPv: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireRequestDto
     */
    valeurJuridique: FicheJudiciaireRequestDtoValeurJuridiqueEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheJudiciaireRequestDtoValeurJuridiqueEnum {
    'PROBATOIRE' = 'PROBATOIRE',
    'CONFISCATOIRE' = 'CONFISCATOIRE'
}

/**
 * 
 * @export
 * @interface FicheJudiciaireSummaryDto
 */
export interface FicheJudiciaireSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireSummaryDto
     */
    numeroParquet: string | null;
}
/**
 * 
 * @export
 * @interface FicheJudiciaireViolationDto
 */
export interface FicheJudiciaireViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireViolationDto
     */
    formField: FicheJudiciaireViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireViolationDto
     */
    violationCode: FicheJudiciaireViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheJudiciaireViolationDtoFormFieldEnum {
    'ID_CORRELATION_JURIDICTION' = 'ID_CORRELATION_JURIDICTION',
    'NUMERO_PARQUET' = 'NUMERO_PARQUET',
    'NUMERO_PV' = 'NUMERO_PV',
    'NUMERO_IDJ' = 'NUMERO_IDJ',
    'VALEUR_JURIDIQUE' = 'VALEUR_JURIDIQUE'
}
/**
    * @export
    * @enum {string}
    */
export enum FicheJudiciaireViolationDtoViolationCodeEnum {
    'JURIDICTION_NOT_FOUND' = 'JURIDICTION_NOT_FOUND',
    'INVALID_JURIDICTION' = 'INVALID_JURIDICTION',
    'MOTIF_MEF_REQUIRED' = 'MOTIF_MEF_REQUIRED',
    'MOTIF_MEF_NOT_FOUND' = 'MOTIF_MEF_NOT_FOUND',
    'MOTIF_MEF_DISABLED' = 'MOTIF_MEF_DISABLED',
    'JURIDICTION_REQUIRED_FOR_MOTIF' = 'JURIDICTION_REQUIRED_FOR_MOTIF'
}

/**
 * 
 * @export
 * @interface FicheJudiciaireWithMotifMefRequestDto
 */
export interface FicheJudiciaireWithMotifMefRequestDto {
    /**
     * 
     * @type {FicheJudiciaireRequestDto}
     * @memberof FicheJudiciaireWithMotifMefRequestDto
     */
    ficheJudiciaireRequestDto: FicheJudiciaireRequestDto | null;
    /**
     * 
     * @type {string}
     * @memberof FicheJudiciaireWithMotifMefRequestDto
     */
    motifMefId: string | null;
}
/**
 * 
 * @export
 * @interface FicheVehiculeDto
 */
export interface FicheVehiculeDto {
    /**
     * 
     * @type {AccessoiresDto}
     * @memberof FicheVehiculeDto
     */
    accessoires: AccessoiresDto | null;
    /**
     * 
     * @type {DescriptionDto}
     * @memberof FicheVehiculeDto
     */
    description: DescriptionDto | null;
    /**
     * 
     * @type {EtatDto}
     * @memberof FicheVehiculeDto
     */
    etat: EtatDto | null;
    /**
     * 
     * @type {ImmatriculationDto}
     * @memberof FicheVehiculeDto
     */
    immatriculation: ImmatriculationDto | null;
    /**
     * 
     * @type {VerrouillageDto}
     * @memberof FicheVehiculeDto
     */
    verrouillage: VerrouillageDto | null;
}
/**
 * 
 * @export
 * @interface FicheVehiculeFoRequestDto
 */
export interface FicheVehiculeFoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoRequestDto
     */
    couleur: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoRequestDto
     */
    genreSimplifie: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoRequestDto
     */
    marque: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeFoRequestDto
     */
    marqueNonReferencee: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoRequestDto
     */
    modele: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeFoRequestDto
     */
    modeleNonReference: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoRequestDto
     */
    numero: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoRequestDto
     */
    numeroImmatriculationVisible: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeFoRequestDto
     */
    paysEtranger: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeFoRequestDto
     */
    plaqueFrancaise: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeFoRequestDto
     */
    sansPlaque: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoRequestDto
     */
    vin: string | null;
}
/**
 * 
 * @export
 * @interface FicheVehiculeFoValidationDto
 */
export interface FicheVehiculeFoValidationDto {
    /**
     * 
     * @type {FicheVehiculeFoRequestDto}
     * @memberof FicheVehiculeFoValidationDto
     */
    ficheVehicule: FicheVehiculeFoRequestDto | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoValidationDto
     */
    idCorrelationFourriere: string | null;
}
/**
 * 
 * @export
 * @interface FicheVehiculeFoViolationDto
 */
export interface FicheVehiculeFoViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoViolationDto
     */
    formField: FicheVehiculeFoViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeFoViolationDto
     */
    violationCode: FicheVehiculeFoViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheVehiculeFoViolationDtoFormFieldEnum {
    'DESCRIPTION_GENRE' = 'DESCRIPTION_GENRE',
    'DESCRIPTION_MARQUE' = 'DESCRIPTION_MARQUE',
    'DESCRIPTION_MODELE' = 'DESCRIPTION_MODELE',
    'DESCRIPTION_COULEUR' = 'DESCRIPTION_COULEUR',
    'ETAT_LIBELLE' = 'ETAT_LIBELLE',
    'ETAT_PRECISION' = 'ETAT_PRECISION',
    'IMMATRICULATION_SANS_PLAQUE' = 'IMMATRICULATION_SANS_PLAQUE',
    'IMMATRICULATION_PAYS_ETRANGER' = 'IMMATRICULATION_PAYS_ETRANGER',
    'TYPE_PLAQUE' = 'TYPE_PLAQUE',
    'IMMATRICULATION_NUMERO' = 'IMMATRICULATION_NUMERO',
    'IMMATRICULATION_NUMERO_VISIBLE' = 'IMMATRICULATION_NUMERO_VISIBLE',
    'IMMATRICULATION_VIN' = 'IMMATRICULATION_VIN',
    'VERROUILLAGE_PORTES' = 'VERROUILLAGE_PORTES',
    'VERROUILLAGE_COFFRES' = 'VERROUILLAGE_COFFRES',
    'ACCESSOIRES_AUTO_RADIO_VISIBLE' = 'ACCESSOIRES_AUTO_RADIO_VISIBLE',
    'ACCESSOIRES_POSTE_CB_VISIBLE' = 'ACCESSOIRES_POSTE_CB_VISIBLE',
    'ACCESSOIRES_TELEPHONE_PORTABLE' = 'ACCESSOIRES_TELEPHONE_PORTABLE',
    'ACCESSOIRES_NOMBRE_ANTENNES' = 'ACCESSOIRES_NOMBRE_ANTENNES',
    'ACCESSOIRES_OBJETS_VISIBLES' = 'ACCESSOIRES_OBJETS_VISIBLES',
    'ACCESSOIRES_OBSERVATIONS' = 'ACCESSOIRES_OBSERVATIONS'
}
/**
    * @export
    * @enum {string}
    */
export enum FicheVehiculeFoViolationDtoViolationCodeEnum {
    'MISSING_VALUE' = 'MISSING_VALUE',
    'BAD_FORMAT' = 'BAD_FORMAT',
    'BAD_VIN' = 'BAD_VIN',
    'BAD_NUMERO_SERIE_DICEM' = 'BAD_NUMERO_SERIE_DICEM',
    'FORBIDDEN_PLAQUE' = 'FORBIDDEN_PLAQUE',
    'FORBIDDEN_MARQUE' = 'FORBIDDEN_MARQUE',
    'FORBIDDEN_MODELE' = 'FORBIDDEN_MODELE',
    'WRONG_MODELE' = 'WRONG_MODELE',
    'BAD_FORMAT_IMMATRICULATION' = 'BAD_FORMAT_IMMATRICULATION',
    'BAD_FORMAT_IDENTIFICATION' = 'BAD_FORMAT_IDENTIFICATION',
    'IMMATRICULATION_ALREADY_EXISTS' = 'IMMATRICULATION_ALREADY_EXISTS',
    'VIN_ALREADY_EXISTS' = 'VIN_ALREADY_EXISTS',
    'TYPE_PLAQUE_NOT_SET' = 'TYPE_PLAQUE_NOT_SET',
    'COULEUR_NOT_FOUND' = 'COULEUR_NOT_FOUND',
    'MARQUE_NOT_FOUND' = 'MARQUE_NOT_FOUND',
    'GENRE_NOT_FOUND' = 'GENRE_NOT_FOUND',
    'INVALID_GENRE' = 'INVALID_GENRE',
    'MODELE_NOT_FOUND' = 'MODELE_NOT_FOUND'
}

/**
 * 
 * @export
 * @interface FicheVehiculeRequestDto
 */
export interface FicheVehiculeRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeRequestDto
     */
    autoRadioVisible: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeRequestDto
     */
    coffres: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    couleur: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    etatLibelle: FicheVehiculeRequestDtoEtatLibelleEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    etatPrecisionId: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    genreSimplifie: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    marque: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeRequestDto
     */
    marqueNonReferencee: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    modele: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeRequestDto
     */
    modeleNonReference: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FicheVehiculeRequestDto
     */
    nombreAntennes: number | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    numero: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    numeroImmatriculationVisible: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    objetsVisibles: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    observations: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeRequestDto
     */
    paysEtranger: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeRequestDto
     */
    portes: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeRequestDto
     */
    posteCbVisible: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeRequestDto
     */
    sansPlaque: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeRequestDto
     */
    telephonePortable: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeRequestDto
     */
    vin: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheVehiculeRequestDtoEtatLibelleEnum {
    'BON_ETAT' = 'BON_ETAT',
    'DEGRADE' = 'DEGRADE',
    'DOMMAGES_GRAVES' = 'DOMMAGES_GRAVES'
}

/**
 * 
 * @export
 * @interface FicheVehiculeSummaryDto
 */
export interface FicheVehiculeSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeSummaryDto
     */
    couleur: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeSummaryDto
     */
    etat: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeSummaryDto
     */
    etranger: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeSummaryDto
     */
    genre: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeSummaryDto
     */
    marque: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeSummaryDto
     */
    modele: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeSummaryDto
     */
    numeroIdentification: string | null;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeSummaryDto
     */
    numeroIdentificationVisible: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FicheVehiculeSummaryDto
     */
    sansPlaques: boolean | null;
}
/**
 * 
 * @export
 * @interface FicheVehiculeViolationDto
 */
export interface FicheVehiculeViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeViolationDto
     */
    formField: FicheVehiculeViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FicheVehiculeViolationDto
     */
    violationCode: FicheVehiculeViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FicheVehiculeViolationDtoFormFieldEnum {
    'DESCRIPTION_GENRE' = 'DESCRIPTION_GENRE',
    'DESCRIPTION_MARQUE' = 'DESCRIPTION_MARQUE',
    'DESCRIPTION_MODELE' = 'DESCRIPTION_MODELE',
    'DESCRIPTION_COULEUR' = 'DESCRIPTION_COULEUR',
    'ETAT_LIBELLE' = 'ETAT_LIBELLE',
    'ETAT_PRECISION' = 'ETAT_PRECISION',
    'IMMATRICULATION_SANS_PLAQUE' = 'IMMATRICULATION_SANS_PLAQUE',
    'IMMATRICULATION_PAYS_ETRANGER' = 'IMMATRICULATION_PAYS_ETRANGER',
    'IMMATRICULATION_NUMERO' = 'IMMATRICULATION_NUMERO',
    'IMMATRICULATION_NUMERO_VISIBLE' = 'IMMATRICULATION_NUMERO_VISIBLE',
    'IMMATRICULATION_VIN' = 'IMMATRICULATION_VIN',
    'VERROUILLAGE_PORTES' = 'VERROUILLAGE_PORTES',
    'VERROUILLAGE_COFFRES' = 'VERROUILLAGE_COFFRES',
    'ACCESSOIRES_AUTO_RADIO_VISIBLE' = 'ACCESSOIRES_AUTO_RADIO_VISIBLE',
    'ACCESSOIRES_POSTE_CB_VISIBLE' = 'ACCESSOIRES_POSTE_CB_VISIBLE',
    'ACCESSOIRES_TELEPHONE_PORTABLE' = 'ACCESSOIRES_TELEPHONE_PORTABLE',
    'ACCESSOIRES_NOMBRE_ANTENNES' = 'ACCESSOIRES_NOMBRE_ANTENNES',
    'ACCESSOIRES_OBJETS_VISIBLES' = 'ACCESSOIRES_OBJETS_VISIBLES',
    'ACCESSOIRES_OBSERVATIONS' = 'ACCESSOIRES_OBSERVATIONS'
}
/**
    * @export
    * @enum {string}
    */
export enum FicheVehiculeViolationDtoViolationCodeEnum {
    'MISSING_VALUE' = 'MISSING_VALUE',
    'BAD_FORMAT' = 'BAD_FORMAT',
    'BAD_VIN' = 'BAD_VIN',
    'BAD_NUMERO_SERIE_DICEM' = 'BAD_NUMERO_SERIE_DICEM',
    'FORBIDDEN_PLAQUE' = 'FORBIDDEN_PLAQUE',
    'FORBIDDEN_MARQUE' = 'FORBIDDEN_MARQUE',
    'FORBIDDEN_MODELE' = 'FORBIDDEN_MODELE',
    'WRONG_MODELE' = 'WRONG_MODELE',
    'BAD_FORMAT_IMMATRICULATION' = 'BAD_FORMAT_IMMATRICULATION',
    'BAD_FORMAT_IDENTIFICATION' = 'BAD_FORMAT_IDENTIFICATION',
    'COULEUR_NOT_FOUND' = 'COULEUR_NOT_FOUND',
    'MARQUE_NOT_FOUND' = 'MARQUE_NOT_FOUND',
    'GENRE_NOT_FOUND' = 'GENRE_NOT_FOUND',
    'INVALID_GENRE' = 'INVALID_GENRE',
    'MODELE_NOT_FOUND' = 'MODELE_NOT_FOUND',
    'ETAT_PRECISION_INVALID' = 'ETAT_PRECISION_INVALID',
    'ETAT_WITHOUT_PRECISION_NOT_FOUND' = 'ETAT_WITHOUT_PRECISION_NOT_FOUND',
    'IMMATRICULATION_ALREADY_EXISTS' = 'IMMATRICULATION_ALREADY_EXISTS',
    'VIN_ALREADY_EXISTS' = 'VIN_ALREADY_EXISTS',
    'ETAT_PRECISION_MUST_BE_NULL_IN_THIS_CASE' = 'ETAT_PRECISION_MUST_BE_NULL_IN_THIS_CASE'
}

/**
 * 
 * @export
 * @interface FichesInfractionAndFourriereRequestsWrapperDto
 */
export interface FichesInfractionAndFourriereRequestsWrapperDto {
    /**
     * 
     * @type {string}
     * @memberof FichesInfractionAndFourriereRequestsWrapperDto
     */
    dateConstatation: string | null;
    /**
     * 
     * @type {string}
     * @memberof FichesInfractionAndFourriereRequestsWrapperDto
     */
    dateRedaction: string | null;
    /**
     * 
     * @type {FicheFourriereRequestDto}
     * @memberof FichesInfractionAndFourriereRequestsWrapperDto
     */
    ficheFourriereRequest: FicheFourriereRequestDto | null;
}
/**
 * 
 * @export
 * @interface FixDataNotificationManuelleRequestDto
 */
export interface FixDataNotificationManuelleRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FixDataNotificationManuelleRequestDto
     */
    dateEnvoi: string | null;
    /**
     * 
     * @type {string}
     * @memberof FixDataNotificationManuelleRequestDto
     */
    dateSignature: string | null;
    /**
     * 
     * @type {string}
     * @memberof FixDataNotificationManuelleRequestDto
     */
    etatDistribution: FixDataNotificationManuelleRequestDtoEtatDistributionEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FixDataNotificationManuelleRequestDto
     */
    justification: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FixDataNotificationManuelleRequestDtoEtatDistributionEnum {
    'DESTINATAIRE_INCONNU' = 'DESTINATAIRE_INCONNU',
    'REFUS_PLI' = 'REFUS_PLI',
    'RECEPTION_LRAR' = 'RECEPTION_LRAR',
    'ABSENCE_AVEC_RETRAIT' = 'ABSENCE_AVEC_RETRAIT',
    'ABSENCE_SANS_RETRAIT' = 'ABSENCE_SANS_RETRAIT'
}

/**
 * 
 * @export
 * @interface FixDataNotificationManuelleViolationDto
 */
export interface FixDataNotificationManuelleViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FixDataNotificationManuelleViolationDto
     */
    formField: FixDataNotificationManuelleViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FixDataNotificationManuelleViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FixDataNotificationManuelleViolationDto
     */
    violationCode: FixDataNotificationManuelleViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FixDataNotificationManuelleViolationDtoFormFieldEnum {
    'NEW_DATE_ENVOI' = 'NEW_DATE_ENVOI',
    'NEW_DATE_SIGNATURE' = 'NEW_DATE_SIGNATURE',
    'NEW_ETAT_DISTRIBUTION' = 'NEW_ETAT_DISTRIBUTION',
    'JUSTIFICATION' = 'JUSTIFICATION'
}
/**
    * @export
    * @enum {string}
    */
export enum FixDataNotificationManuelleViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'DATE_IN_FUTURE' = 'DATE_IN_FUTURE',
    'DATE_ENVOI_BEFORE_DATE_ENTREE' = 'DATE_ENVOI_BEFORE_DATE_ENTREE',
    'MISSING_DATE_ENVOI' = 'MISSING_DATE_ENVOI',
    'DATE_SIGNATURE_BEFORE_DATE_ENVOI' = 'DATE_SIGNATURE_BEFORE_DATE_ENVOI',
    'DATA_SHOULD_ALREADY_EXISTS' = 'DATA_SHOULD_ALREADY_EXISTS',
    'DATE_SIGNATURE_INCOMPLETE_FIX_RETOUR_NOTIFICATION_MANUELLE' = 'DATE_SIGNATURE_INCOMPLETE_FIX_RETOUR_NOTIFICATION_MANUELLE',
    'ETAT_DISTRIBUTION_INCOMPLETE_FIX_RETOUR_NOTIFICATION_MANUELLE' = 'ETAT_DISTRIBUTION_INCOMPLETE_FIX_RETOUR_NOTIFICATION_MANUELLE',
    'NO_MODIFICATION' = 'NO_MODIFICATION'
}

/**
 * 
 * @export
 * @interface FluxStatusDto
 */
export interface FluxStatusDto {
    /**
     * 
     * @type {string}
     * @memberof FluxStatusDto
     */
    flux: FluxStatusDtoFluxEnum;
    /**
     * 
     * @type {string}
     * @memberof FluxStatusDto
     */
    status: FluxStatusDtoStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FluxStatusDtoFluxEnum {
    'RPSI' = 'RPSI',
    'ALIENATION_ETAT_BIENS' = 'ALIENATION_ETAT_BIENS',
    'ALIENATION_AUTORITE' = 'ALIENATION_AUTORITE',
    'ALIENATION_FOURRIERE' = 'ALIENATION_FOURRIERE',
    'ANTAI' = 'ANTAI'
}
/**
    * @export
    * @enum {string}
    */
export enum FluxStatusDtoStatusEnum {
    'SUCCESS' = 'SUCCESS',
    'WARNING' = 'WARNING',
    'ERROR' = 'ERROR'
}

/**
 * 
 * @export
 * @interface FluxStatusSummaryDto
 */
export interface FluxStatusSummaryDto {
    /**
     * 
     * @type {Array<FluxStatusDto>}
     * @memberof FluxStatusSummaryDto
     */
    statuses: Array<FluxStatusDto>;
}
/**
 * 
 * @export
 * @interface FoFullUserDto
 */
export interface FoFullUserDto {
    /**
     * 
     * @type {string}
     * @memberof FoFullUserDto
     */
    email: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FoFullUserDto
     */
    enabled: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FoFullUserDto
     */
    firstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof FoFullUserDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FoFullUserDto
     */
    lastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof FoFullUserDto
     */
    libelleLongUniteFo: string | null;
    /**
     * 
     * @type {UniteFOResponseDto}
     * @memberof FoFullUserDto
     */
    uniteFO: UniteFOResponseDto | null;
    /**
     * 
     * @type {UniteFOResponseDto}
     * @memberof FoFullUserDto
     */
    uniteFineFO: UniteFOResponseDto | null;
    /**
     * 
     * @type {string}
     * @memberof FoFullUserDto
     */
    username: string;
}
/**
 * 
 * @export
 * @interface FooterLinkDto
 */
export interface FooterLinkDto {
    /**
     * 
     * @type {string}
     * @memberof FooterLinkDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FooterLinkDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof FooterLinkDto
     */
    link: string;
    /**
     * 
     * @type {string}
     * @memberof FooterLinkDto
     */
    profile: FooterLinkDtoProfileEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FooterLinkDto
     */
    text: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FooterLinkDto
     */
    valid: boolean | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FooterLinkDtoProfileEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface FooterLinkRequestDto
 */
export interface FooterLinkRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FooterLinkRequestDto
     */
    link: string;
    /**
     * 
     * @type {string}
     * @memberof FooterLinkRequestDto
     */
    profile: FooterLinkRequestDtoProfileEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FooterLinkRequestDto
     */
    text: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FooterLinkRequestDtoProfileEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface FooterLinkViolationDto
 */
export interface FooterLinkViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FooterLinkViolationDto
     */
    formField: FooterLinkViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FooterLinkViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FooterLinkViolationDto
     */
    violationCode: FooterLinkViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FooterLinkViolationDtoFormFieldEnum {
    'LINK' = 'LINK',
    'TEXT' = 'TEXT',
    'PROFILE' = 'PROFILE'
}
/**
    * @export
    * @enum {string}
    */
export enum FooterLinkViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'EMPTY_FIELD' = 'EMPTY_FIELD'
}

/**
 * 
 * @export
 * @interface FourriereDto
 */
export interface FourriereDto {
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    adresseDnid: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    adresseMail: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    adresseMailResponsable: string | null;
    /**
     * 
     * @type {Array<AutoriteFourriereDto>}
     * @memberof FourriereDto
     */
    autoritesFourrieres: Array<AutoriteFourriereDto>;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    codePostal: string;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    commentaires: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    coordonneesGPS: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    dateAgrement: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    dateConfirmationUtilisateur: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FourriereDto
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    finAgrement: string | null;
    /**
     * 
     * @type {HorairesDto}
     * @memberof FourriereDto
     */
    horaires: HorairesDto | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    idAlienation: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    noVoie: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    nomResponsable: string | null;
    /**
     * 
     * @type {number}
     * @memberof FourriereDto
     */
    nombreEmplacements: number | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    numeroAgrement: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    raisonSociale: string;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    raisonSocialeDnid: string;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    telephoneFixe: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereDto
     */
    telephoneMobile: string | null;
}
/**
 * 
 * @export
 * @interface FourriereRequestDto
 */
export interface FourriereRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    adresseDnid: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    commentaires: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    dateAgrement: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    emailResponsable: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    finAgrement: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    gps: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    idAlienation: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FourriereRequestDto
     */
    listIdCorrelationAf: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof FourriereRequestDto
     */
    nbPlaces: number | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    nomResponsable: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    numeroAgrement: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    numeroVoie: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    raisonSociale: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    raisonSocialeDnid: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    telephoneFixe: string | null;
    /**
     * 
     * @type {string}
     * @memberof FourriereRequestDto
     */
    telephonePortable: string | null;
}
/**
 * 
 * @export
 * @interface FourriereViolationDto
 */
export interface FourriereViolationDto {
    /**
     * 
     * @type {string}
     * @memberof FourriereViolationDto
     */
    formField: FourriereViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FourriereViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof FourriereViolationDto
     */
    violationCode: FourriereViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum FourriereViolationDtoFormFieldEnum {
    'RAISON_SOCIALE' = 'RAISON_SOCIALE',
    'RAISON_SOCIALE_DNID' = 'RAISON_SOCIALE_DNID',
    'DATE_AGREMENT_FIN' = 'DATE_AGREMENT_FIN',
    'AF_RATTACHEMENT' = 'AF_RATTACHEMENT',
    'CODE_POSTAL' = 'CODE_POSTAL',
    'ADRESSE' = 'ADRESSE',
    'NUMERO_VOIE' = 'NUMERO_VOIE',
    'COMMUNE' = 'COMMUNE',
    'TELEPHONE_PORTABLE' = 'TELEPHONE_PORTABLE',
    'TELEPHONE_FIXE' = 'TELEPHONE_FIXE',
    'EMAIL' = 'EMAIL',
    'EMAIL_RESPONSABLE' = 'EMAIL_RESPONSABLE',
    'ID_ALIENATION' = 'ID_ALIENATION'
}
/**
    * @export
    * @enum {string}
    */
export enum FourriereViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'CODE_POSTAL_BAD_FORMAT' = 'CODE_POSTAL_BAD_FORMAT',
    'NUMERO_VOIE_BAD_FORMAT' = 'NUMERO_VOIE_BAD_FORMAT',
    'DATE_DEBUT_AGREMENT_AFTER_DATE_FIN_AGREMENT' = 'DATE_DEBUT_AGREMENT_AFTER_DATE_FIN_AGREMENT',
    'ADRESSE_AND_RAISON_SOCIALE_UNICITY' = 'ADRESSE_AND_RAISON_SOCIALE_UNICITY',
    'ID_ALIENATION_BAD_FORMAT' = 'ID_ALIENATION_BAD_FORMAT',
    'ID_ALIENATION_UNICITY_VIOLATION' = 'ID_ALIENATION_UNICITY_VIOLATION',
    'ID_ALIENATION_SHOULD_BE_NULL' = 'ID_ALIENATION_SHOULD_BE_NULL',
    'PHONE_BAD_FORMAT' = 'PHONE_BAD_FORMAT',
    'EMAIL_BAD_FORMAT' = 'EMAIL_BAD_FORMAT',
    'AF_NOT_FOUND' = 'AF_NOT_FOUND',
    'AF_NOT_ACTIVE' = 'AF_NOT_ACTIVE'
}

/**
 * 
 * @export
 * @interface GenreSimplifieDto
 */
export interface GenreSimplifieDto {
    /**
     * 
     * @type {boolean}
     * @memberof GenreSimplifieDto
     */
    dicem: boolean;
    /**
     * 
     * @type {Set<string>}
     * @memberof GenreSimplifieDto
     */
    formatsPlaque: Array<GenreSimplifieDtoFormatsPlaqueEnum>;
    /**
     * 
     * @type {string}
     * @memberof GenreSimplifieDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GenreSimplifieDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof GenreSimplifieDto
     */
    libelle: string;
    /**
     * 
     * @type {boolean}
     * @memberof GenreSimplifieDto
     */
    valid: boolean | null;
}

/**
    * @export
    * @enum {string}
    */
export enum GenreSimplifieDtoFormatsPlaqueEnum {
    'ANCIEN' = 'ANCIEN',
    'FNI' = 'FNI',
    'W_GARAGE' = 'W_GARAGE',
    'SIV' = 'SIV',
    'DEUX_ROUES' = 'DEUX_ROUES'
}

/**
 * 
 * @export
 * @interface GenreSimplifieRequestDto
 */
export interface GenreSimplifieRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof GenreSimplifieRequestDto
     */
    dicem: boolean | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof GenreSimplifieRequestDto
     */
    formatsPlaques: Array<GenreSimplifieRequestDtoFormatsPlaquesEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof GenreSimplifieRequestDto
     */
    libelle: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum GenreSimplifieRequestDtoFormatsPlaquesEnum {
    'ANCIEN' = 'ANCIEN',
    'FNI' = 'FNI',
    'W_GARAGE' = 'W_GARAGE',
    'SIV' = 'SIV',
    'DEUX_ROUES' = 'DEUX_ROUES'
}

/**
 * 
 * @export
 * @interface GenreSimplifieViolationDto
 */
export interface GenreSimplifieViolationDto {
    /**
     * 
     * @type {string}
     * @memberof GenreSimplifieViolationDto
     */
    formField: GenreSimplifieViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof GenreSimplifieViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof GenreSimplifieViolationDto
     */
    violationCode: GenreSimplifieViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GenreSimplifieViolationDtoFormFieldEnum {
    'LIBELLE' = 'LIBELLE',
    'DICEM' = 'DICEM',
    'FORMATS_PLAQUES' = 'FORMATS_PLAQUES'
}
/**
    * @export
    * @enum {string}
    */
export enum GenreSimplifieViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD'
}

/**
 * 
 * @export
 * @interface GetFluxNextExecutionTimeResponseDto
 */
export interface GetFluxNextExecutionTimeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetFluxNextExecutionTimeResponseDto
     */
    fluxType: GetFluxNextExecutionTimeResponseDtoFluxTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetFluxNextExecutionTimeResponseDto
     */
    nextExecutionTime: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum GetFluxNextExecutionTimeResponseDtoFluxTypeEnum {
    'ALIENATION_UPDATE_STATUS_BIEN' = 'ALIENATION_UPDATE_STATUS_BIEN',
    'ALIENATION_LIEU_DEPOT' = 'ALIENATION_LIEU_DEPOT',
    'ALIENATION_ENTITE_REMETTANTE' = 'ALIENATION_ENTITE_REMETTANTE',
    'ANTAI_RECUPERATION_INFORMATION_SYNCHRONIZATION' = 'ANTAI_RECUPERATION_INFORMATION_SYNCHRONIZATION',
    'ANTAI_RECUPERATION_INFORMATION_RETRY' = 'ANTAI_RECUPERATION_INFORMATION_RETRY',
    'DOSSIER_PURGE' = 'DOSSIER_PURGE',
    'DOSSIER_ANONYMISATION' = 'DOSSIER_ANONYMISATION',
    'DOSSIER_RESYNC' = 'DOSSIER_RESYNC',
    'DOSSIER_BLOCAGE' = 'DOSSIER_BLOCAGE',
    'DOSSIER_UNSYNC' = 'DOSSIER_UNSYNC',
    'RPSI_BATCH' = 'RPSI_BATCH',
    'REPORT_PURGE' = 'REPORT_PURGE'
}

/**
 * 
 * @export
 * @interface GitInfoDto
 */
export interface GitInfoDto {
    /**
     * 
     * @type {string}
     * @memberof GitInfoDto
     */
    commitId: string;
    /**
     * 
     * @type {string}
     * @memberof GitInfoDto
     */
    commitMessage: string;
}
/**
 * 
 * @export
 * @interface Horaire
 */
export interface Horaire {
    /**
     * 
     * @type {string}
     * @memberof Horaire
     */
    debut: string;
    /**
     * 
     * @type {string}
     * @memberof Horaire
     */
    fin: string;
}
/**
 * 
 * @export
 * @interface HorairesDto
 */
export interface HorairesDto {
    /**
     * 
     * @type {Jour}
     * @memberof HorairesDto
     */
    dimanche: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof HorairesDto
     */
    jeudi: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof HorairesDto
     */
    lundi: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof HorairesDto
     */
    mardi: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof HorairesDto
     */
    mercredi: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof HorairesDto
     */
    samedi: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof HorairesDto
     */
    vendredi: Jour | null;
}
/**
 * 
 * @export
 * @interface ImmatriculationDto
 */
export interface ImmatriculationDto {
    /**
     * 
     * @type {string}
     * @memberof ImmatriculationDto
     */
    numero: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImmatriculationDto
     */
    numeroImmatriculationVisible: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImmatriculationDto
     */
    paysEtranger: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImmatriculationDto
     */
    sansPlaque: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ImmatriculationDto
     */
    vin: string | null;
}
/**
 * 
 * @export
 * @interface ImportTableViolationDto
 */
export interface ImportTableViolationDto {
    /**
     * 
     * @type {string}
     * @memberof ImportTableViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ImportTableViolationDto
     */
    violationCode: ImportTableViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ImportTableViolationDtoViolationCodeEnum {
    'UNKNOWN_COLUMN' = 'UNKNOWN_COLUMN',
    'TYPE_REF_UNKNOWN' = 'TYPE_REF_UNKNOWN',
    'BAD_VALUE_IN_COLUMN' = 'BAD_VALUE_IN_COLUMN',
    'UNKNOWN_VALUE_WARNING' = 'UNKNOWN_VALUE_WARNING',
    'UNKNOWN_BOOLEAN_WARNING' = 'UNKNOWN_BOOLEAN_WARNING',
    'NOT_UNIQUE_DECISION' = 'NOT_UNIQUE_DECISION',
    'NOT_UNIQUE_OUTPUT' = 'NOT_UNIQUE_OUTPUT',
    'BAD_DEFAULT_RULE' = 'BAD_DEFAULT_RULE'
}

/**
 * 
 * @export
 * @interface ImportViolationListDto
 */
export interface ImportViolationListDto {
    /**
     * 
     * @type {Array<ImportTableViolationDto>}
     * @memberof ImportViolationListDto
     */
    violations: Array<ImportTableViolationDto>;
}
/**
 * 
 * @export
 * @interface ImpossibiliteNotifierDto
 */
export interface ImpossibiliteNotifierDto {
    /**
     * 
     * @type {string}
     * @memberof ImpossibiliteNotifierDto
     */
    dateImpossibiliteNotifier: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImpossibiliteNotifierDto
     */
    isPresent: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImpossibiliteNotifierDto
     */
    willImpossibiliteNotifierBeSet: boolean | null;
}
/**
 * 
 * @export
 * @interface InformationMessageDto
 */
export interface InformationMessageDto {
    /**
     * 
     * @type {string}
     * @memberof InformationMessageDto
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof InformationMessageDto
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof InformationMessageDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InformationMessageDto
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof InformationMessageDto
     */
    title: string;
}
/**
 * 
 * @export
 * @interface InformationMessageRequestDto
 */
export interface InformationMessageRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof InformationMessageRequestDto
     */
    active: boolean | null;
    /**
     * Ce champ contient du Markdown non nettoyé, c\'est à dire avec des balises HTML pouvant potentiellement exécuter du code. Chaque frontend a la responsabilité de nettoyer ce contenu avec une librairie adaptée avant de l\'afficher.
     * @type {string}
     * @memberof InformationMessageRequestDto
     */
    content: string | null;
    /**
     * 
     * @type {string}
     * @memberof InformationMessageRequestDto
     */
    endDate: string | null;
    /**
     * 
     * @type {string}
     * @memberof InformationMessageRequestDto
     */
    startDate: string | null;
    /**
     * 
     * @type {string}
     * @memberof InformationMessageRequestDto
     */
    title: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InformationMessageRequestDto
     */
    userProfileList: Array<InformationMessageRequestDtoUserProfileListEnum> | null;
}

/**
    * @export
    * @enum {string}
    */
export enum InformationMessageRequestDtoUserProfileListEnum {
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE',
    'BORD_DE_ROUTE' = 'BORD_DE_ROUTE'
}

/**
 * 
 * @export
 * @interface InformationMessageViolationDto
 */
export interface InformationMessageViolationDto {
    /**
     * 
     * @type {string}
     * @memberof InformationMessageViolationDto
     */
    formField: InformationMessageViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof InformationMessageViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof InformationMessageViolationDto
     */
    violationCode: InformationMessageViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InformationMessageViolationDtoFormFieldEnum {
    'TITRE' = 'TITRE',
    'CONTENT' = 'CONTENT',
    'START_DATE' = 'START_DATE',
    'END_DATE' = 'END_DATE',
    'VALID' = 'VALID',
    'PROFILES' = 'PROFILES'
}
/**
    * @export
    * @enum {string}
    */
export enum InformationMessageViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'BEFORE_NOW' = 'BEFORE_NOW',
    'DATE_BEFORE' = 'DATE_BEFORE',
    'EDIT_DATE' = 'EDIT_DATE',
    'EDIT' = 'EDIT'
}

/**
 * 
 * @export
 * @interface InformationMessageViolationsDto
 */
export interface InformationMessageViolationsDto {
    /**
     * 
     * @type {Array<InformationMessageViolationDto>}
     * @memberof InformationMessageViolationsDto
     */
    informationMessageViolationDtos: Array<InformationMessageViolationDto> | null;
}
/**
 * 
 * @export
 * @interface InfosAssureurDto
 */
export interface InfosAssureurDto {
    /**
     * 
     * @type {boolean}
     * @memberof InfosAssureurDto
     */
    assureIndeminse: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof InfosAssureurDto
     */
    dateContact: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosAssureurDto
     */
    dateInfosAssureur: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosAssureurDto
     */
    immatriculation: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosAssureurDto
     */
    priseEnChargeVol: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosAssureurDto
     */
    sirenAssureurAvise: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosAssureurDto
     */
    vin: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InfosAssureurDto
     */
    volAdherent: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof InfosAssureurDto
     */
    volFoves: boolean | null;
}
/**
 * 
 * @export
 * @interface InfosSivDocumentRequestDto
 */
export interface InfosSivDocumentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof InfosSivDocumentRequestDto
     */
    dateCi: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivDocumentRequestDto
     */
    numeroFormule: string | null;
}
/**
 * 
 * @export
 * @interface InfosSivPersonneRattacheeRequestDto
 */
export interface InfosSivPersonneRattacheeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    boitePostale: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    codeCedex: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    codeTypePersonne: InfosSivPersonneRattacheeRequestDtoCodeTypePersonneEnum | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    extension: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    libelleCedex: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    libelleCommune: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    libelleVoie: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    lieuDit: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    nomNaissance: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    nomUsage: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    numeroVoie: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    pays: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    pointRemise: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    prenom: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    raisonSociale: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivPersonneRattacheeRequestDto
     */
    typeVoie: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum InfosSivPersonneRattacheeRequestDtoCodeTypePersonneEnum {
    'TITULAIRE' = 'TITULAIRE',
    'ACQUEREUR' = 'ACQUEREUR',
    'LOCATAIRE' = 'LOCATAIRE',
    'LOUEUR' = 'LOUEUR'
}

/**
 * 
 * @export
 * @interface InfosSivRequestDto
 */
export interface InfosSivRequestDto {
    /**
     * 
     * @type {InfosSivDocumentRequestDto}
     * @memberof InfosSivRequestDto
     */
    infosSivDocumentRequestDto: InfosSivDocumentRequestDto | null;
    /**
     * 
     * @type {InfosSivPersonneRattacheeRequestDto}
     * @memberof InfosSivRequestDto
     */
    infosSivPersonneRattacheeRequestDto: InfosSivPersonneRattacheeRequestDto | null;
    /**
     * 
     * @type {InfosSivSituationAdministrativeRequestDto}
     * @memberof InfosSivRequestDto
     */
    infosSivSituationAdministrativeRequestDto: InfosSivSituationAdministrativeRequestDto | null;
    /**
     * 
     * @type {InfosSivVehiculeRequestDto}
     * @memberof InfosSivRequestDto
     */
    infosSivVehiculeRequestDto: InfosSivVehiculeRequestDto | null;
}
/**
 * 
 * @export
 * @interface InfosSivSituationAdministrativeRequestDto
 */
export interface InfosSivSituationAdministrativeRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof InfosSivSituationAdministrativeRequestDto
     */
    flagPve: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof InfosSivSituationAdministrativeRequestDto
     */
    flagVehiculeVole: boolean | null;
}
/**
 * 
 * @export
 * @interface InfosSivVehiculeRequestDto
 */
export interface InfosSivVehiculeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof InfosSivVehiculeRequestDto
     */
    cnit: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivVehiculeRequestDto
     */
    datePremiereImmatriculation: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivVehiculeRequestDto
     */
    idCorrelationGenre: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivVehiculeRequestDto
     */
    idCorrelationMarque: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivVehiculeRequestDto
     */
    idCorrelationModele: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivVehiculeRequestDto
     */
    numeroImmatriculation: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfosSivVehiculeRequestDto
     */
    vin: string | null;
}
/**
 * 
 * @export
 * @interface InterdictionCirculer
 */
export interface InterdictionCirculer {
    /**
     * 
     * @type {string}
     * @memberof InterdictionCirculer
     */
    dateDebutPermissionProvisoire: string | null;
    /**
     * 
     * @type {string}
     * @memberof InterdictionCirculer
     */
    dateFinPermissionProvisoire: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InterdictionCirculer
     */
    hasInterdictionCirculer: boolean;
    /**
     * 
     * @type {string}
     * @memberof InterdictionCirculer
     */
    motifInterdictionCirculer: string | null;
}
/**
 * 
 * @export
 * @interface InternalHorairesRequestDto
 */
export interface InternalHorairesRequestDto {
    /**
     * 
     * @type {Jour}
     * @memberof InternalHorairesRequestDto
     */
    dimanche: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof InternalHorairesRequestDto
     */
    jeudi: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof InternalHorairesRequestDto
     */
    lundi: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof InternalHorairesRequestDto
     */
    mardi: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof InternalHorairesRequestDto
     */
    mercredi: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof InternalHorairesRequestDto
     */
    samedi: Jour | null;
    /**
     * 
     * @type {Jour}
     * @memberof InternalHorairesRequestDto
     */
    vendredi: Jour | null;
}
/**
 * 
 * @export
 * @interface JacksonCompatiblePageDtoUserDto
 */
export interface JacksonCompatiblePageDtoUserDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof JacksonCompatiblePageDtoUserDto
     */
    elements: Array<UserDto>;
    /**
     * 
     * @type {number}
     * @memberof JacksonCompatiblePageDtoUserDto
     */
    totalElements: number;
}
/**
 * 
 * @export
 * @interface Jour
 */
export interface Jour {
    /**
     * 
     * @type {Array<Horaire>}
     * @memberof Jour
     */
    horairesAppel: Array<Horaire>;
    /**
     * 
     * @type {Array<Horaire>}
     * @memberof Jour
     */
    horairesOuverture: Array<Horaire>;
    /**
     * 
     * @type {boolean}
     * @memberof Jour
     */
    surRdvUniquement: boolean;
}
/**
 * 
 * @export
 * @interface JuridictionAdminResponseDto
 */
export interface JuridictionAdminResponseDto {
    /**
     * 
     * @type {string}
     * @memberof JuridictionAdminResponseDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof JuridictionAdminResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JuridictionAdminResponseDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof JuridictionAdminResponseDto
     */
    idCorrelationJuridictionParent: string | null;
    /**
     * 
     * @type {string}
     * @memberof JuridictionAdminResponseDto
     */
    libelle: string;
    /**
     * 
     * @type {string}
     * @memberof JuridictionAdminResponseDto
     */
    numero: string | null;
    /**
     * 
     * @type {string}
     * @memberof JuridictionAdminResponseDto
     */
    origineElement: string;
    /**
     * 
     * @type {string}
     * @memberof JuridictionAdminResponseDto
     */
    type: JuridictionAdminResponseDtoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JuridictionAdminResponseDto
     */
    valid: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum JuridictionAdminResponseDtoTypeEnum {
    'COUR_APPEL' = 'COUR_APPEL',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE'
}

/**
 * 
 * @export
 * @interface JuridictionRequestDto
 */
export interface JuridictionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof JuridictionRequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof JuridictionRequestDto
     */
    idCorrelationJuridictionParent: string | null;
    /**
     * 
     * @type {string}
     * @memberof JuridictionRequestDto
     */
    libelle: string | null;
    /**
     * 
     * @type {string}
     * @memberof JuridictionRequestDto
     */
    numero: string | null;
    /**
     * 
     * @type {string}
     * @memberof JuridictionRequestDto
     */
    origineElement: string | null;
    /**
     * 
     * @type {string}
     * @memberof JuridictionRequestDto
     */
    type: JuridictionRequestDtoTypeEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum JuridictionRequestDtoTypeEnum {
    'COUR_APPEL' = 'COUR_APPEL',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE'
}

/**
 * 
 * @export
 * @interface JuridictionResponseDto
 */
export interface JuridictionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof JuridictionResponseDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof JuridictionResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JuridictionResponseDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof JuridictionResponseDto
     */
    idCorrelationJuridictionParent: string | null;
    /**
     * 
     * @type {string}
     * @memberof JuridictionResponseDto
     */
    libelle: string;
    /**
     * 
     * @type {string}
     * @memberof JuridictionResponseDto
     */
    numero: string;
    /**
     * 
     * @type {string}
     * @memberof JuridictionResponseDto
     */
    origineElement: string;
    /**
     * 
     * @type {string}
     * @memberof JuridictionResponseDto
     */
    type: JuridictionResponseDtoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JuridictionResponseDto
     */
    valid: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum JuridictionResponseDtoTypeEnum {
    'COUR_APPEL' = 'COUR_APPEL',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE'
}

/**
 * 
 * @export
 * @interface JuridictionViolationDto
 */
export interface JuridictionViolationDto {
    /**
     * 
     * @type {string}
     * @memberof JuridictionViolationDto
     */
    formField: JuridictionViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof JuridictionViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof JuridictionViolationDto
     */
    violationCode: JuridictionViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum JuridictionViolationDtoFormFieldEnum {
    'ORIGINE_ELEMENT' = 'ORIGINE_ELEMENT',
    'NUMERO' = 'NUMERO',
    'TYPE' = 'TYPE',
    'LIBELLE' = 'LIBELLE',
    'CODE_POSTAL' = 'CODE_POSTAL',
    'JURIDICTION_PARENTE' = 'JURIDICTION_PARENTE'
}
/**
    * @export
    * @enum {string}
    */
export enum JuridictionViolationDtoViolationCodeEnum {
    'CODE_POSTAL_BAD_FORMAT' = 'CODE_POSTAL_BAD_FORMAT',
    'MISSING_FIELD' = 'MISSING_FIELD',
    'INVALID_TYPE' = 'INVALID_TYPE',
    'INVALID_JURIDICTION' = 'INVALID_JURIDICTION'
}

/**
 * 
 * @export
 * @interface JwtDto
 */
export interface JwtDto {
    /**
     * 
     * @type {string}
     * @memberof JwtDto
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof JwtDto
     */
    refreshToken: string | null;
}
/**
 * 
 * @export
 * @interface MainLeveeDto
 */
export interface MainLeveeDto {
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    codePostalProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    communeAdresseProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    communeFonctionAgent: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    communeRedaction: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    dateDebutPermissionProvisoire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    dateFinPermissionProvisoire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    dateMiseAJour: string;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    dateProcesVerbal: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    gradeAgent: MainLeveeDtoGradeAgentEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    idCorrelationFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    idCorrelationGenreSimplifie: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    idMarque: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    immatriculation: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MainLeveeDto
     */
    interdictionCirculer: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    justificationSortie: MainLeveeDtoJustificationSortieEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    lieuAdresseProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    matriculeAgent: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    motifInterdictionCirculer: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    nomAgent: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    nomProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    numProcesVerbal: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    prenomProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    raisonSocialeSocieteRemorquage: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    rsProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    siretSocieteRemorquage: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeDto
     */
    typeRestitution: MainLeveeDtoTypeRestitutionEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum MainLeveeDtoGradeAgentEnum {
    'APJA' = 'APJA',
    'APJ' = 'APJ',
    'OPJ' = 'OPJ'
}
/**
    * @export
    * @enum {string}
    */
export enum MainLeveeDtoJustificationSortieEnum {
    'VERIFICATIONS_NON_USAGE_STUPEFIANTS' = 'VERIFICATIONS_NON_USAGE_STUPEFIANTS',
    'VOL' = 'VOL',
    'LOCATION_TITRE_ONEREUX_A_UN_TIERS' = 'LOCATION_TITRE_ONEREUX_A_UN_TIERS',
    'DECISION_APRES_CONTESTATION_PROCUREUR_OU_PREFET' = 'DECISION_APRES_CONTESTATION_PROCUREUR_OU_PREFET'
}
/**
    * @export
    * @enum {string}
    */
export enum MainLeveeDtoTypeRestitutionEnum {
    'ASSURANCE_PERMIS' = 'ASSURANCE_PERMIS',
    'ASSURANCE_REMORQUE' = 'ASSURANCE_REMORQUE'
}

/**
 * 
 * @export
 * @interface MainLeveeViolationDto
 */
export interface MainLeveeViolationDto {
    /**
     * 
     * @type {string}
     * @memberof MainLeveeViolationDto
     */
    formField: MainLeveeViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof MainLeveeViolationDto
     */
    violationCode: MainLeveeViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum MainLeveeViolationDtoFormFieldEnum {
    'NUM_PROCES_VERBAL' = 'NUM_PROCES_VERBAL',
    'DATE_PROCES_VERBAL' = 'DATE_PROCES_VERBAL',
    'GRADE_AGENT' = 'GRADE_AGENT',
    'MATRICULE_AGENT' = 'MATRICULE_AGENT',
    'COMMUNE_FONCTION' = 'COMMUNE_FONCTION',
    'TYPE_RESTITUTION' = 'TYPE_RESTITUTION',
    'GENRE_SIMPLIFIE_ID' = 'GENRE_SIMPLIFIE_ID',
    'IMMATRICULATION' = 'IMMATRICULATION',
    'MARQUE_ID' = 'MARQUE_ID',
    'NOM_PROPRIETAIRE' = 'NOM_PROPRIETAIRE',
    'LIEU_ADRESSE_PROPRIETAIRE' = 'LIEU_ADRESSE_PROPRIETAIRE',
    'CODE_POSTAL_PROPRIETAIRE' = 'CODE_POSTAL_PROPRIETAIRE',
    'COMMUNE_ADRESSE_PROPRIETAIRE' = 'COMMUNE_ADRESSE_PROPRIETAIRE',
    'FOURRIERE_ID' = 'FOURRIERE_ID',
    'DEBUT_AUTORISATION' = 'DEBUT_AUTORISATION',
    'FIN_AUTORISATION' = 'FIN_AUTORISATION',
    'COMMUNE_REDACTION' = 'COMMUNE_REDACTION',
    'JUSTIFICATION_SORTIE' = 'JUSTIFICATION_SORTIE',
    'SIRET_SOCIETE_REMORQUAGE' = 'SIRET_SOCIETE_REMORQUAGE'
}
/**
    * @export
    * @enum {string}
    */
export enum MainLeveeViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'FIELD_EMPTY_IF_NOT_IC' = 'FIELD_EMPTY_IF_NOT_IC',
    'DATE_FIN_BEFORE_DATE_DEBUT' = 'DATE_FIN_BEFORE_DATE_DEBUT',
    'MANDATORY_IF_IC' = 'MANDATORY_IF_IC',
    'BAD_NUMERIC_FORMAT' = 'BAD_NUMERIC_FORMAT',
    'INVALID_GENRE_SIMPLIFIE' = 'INVALID_GENRE_SIMPLIFIE',
    'INVALID_MARQUE' = 'INVALID_MARQUE',
    'INVALID_FOURRIERE' = 'INVALID_FOURRIERE',
    'INVALID_IMMATRICULATION' = 'INVALID_IMMATRICULATION',
    'DATE_IN_FUTURE' = 'DATE_IN_FUTURE',
    'SIRET_BAD_FORMAT' = 'SIRET_BAD_FORMAT'
}

/**
 * 
 * @export
 * @interface MainleveeResponseDto
 */
export interface MainleveeResponseDto {
    /**
     * 
     * @type {Acheteur}
     * @memberof MainleveeResponseDto
     */
    acheteur: Acheteur | null;
    /**
     * 
     * @type {AgentDto}
     * @memberof MainleveeResponseDto
     */
    agent: AgentDto;
    /**
     * 
     * @type {string}
     * @memberof MainleveeResponseDto
     */
    communeRedaction: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeResponseDto
     */
    idCorrelationFourriere: string | null;
    /**
     * 
     * @type {InterdictionCirculer}
     * @memberof MainleveeResponseDto
     */
    interdictionCirculer: InterdictionCirculer;
    /**
     * 
     * @type {string}
     * @memberof MainleveeResponseDto
     */
    justificationSortie: MainleveeResponseDtoJustificationSortieEnum | null;
    /**
     * 
     * @type {ProcesVerbalDto}
     * @memberof MainleveeResponseDto
     */
    procesVerbal: ProcesVerbalDto;
    /**
     * 
     * @type {Proprietaire}
     * @memberof MainleveeResponseDto
     */
    proprietaire: Proprietaire;
    /**
     * 
     * @type {string}
     * @memberof MainleveeResponseDto
     */
    raisonSocialeSocieteRemorquage: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeResponseDto
     */
    siretSocieteRemorquage: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeResponseDto
     */
    typeRestitution: MainleveeResponseDtoTypeRestitutionEnum | null;
    /**
     * 
     * @type {Vehicule}
     * @memberof MainleveeResponseDto
     */
    vehicule: Vehicule;
}

/**
    * @export
    * @enum {string}
    */
export enum MainleveeResponseDtoJustificationSortieEnum {
    'VERIFICATIONS_NON_USAGE_STUPEFIANTS' = 'VERIFICATIONS_NON_USAGE_STUPEFIANTS',
    'VOL' = 'VOL',
    'LOCATION_TITRE_ONEREUX_A_UN_TIERS' = 'LOCATION_TITRE_ONEREUX_A_UN_TIERS',
    'DECISION_APRES_CONTESTATION_PROCUREUR_OU_PREFET' = 'DECISION_APRES_CONTESTATION_PROCUREUR_OU_PREFET'
}
/**
    * @export
    * @enum {string}
    */
export enum MainleveeResponseDtoTypeRestitutionEnum {
    'ASSURANCE_PERMIS' = 'ASSURANCE_PERMIS',
    'ASSURANCE_REMORQUE' = 'ASSURANCE_REMORQUE'
}

/**
 * 
 * @export
 * @interface MainleveeUsagerDto
 */
export interface MainleveeUsagerDto {
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    codePostalProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    codeVerification: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    communeAdresseProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    dateConstatation: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    dateEdition: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    dateEtablissement: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    idCorrelationFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    idCorrelationGenreSimplifie: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    idCorrelationUniteFo: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    idMarque: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    immatriculation: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    lieuAdresseProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    nomDemandeur: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    nomProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    prenomProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    prenomsDemandeur: string | null;
    /**
     * 
     * @type {string}
     * @memberof MainleveeUsagerDto
     */
    rsProprietaire: string | null;
}
/**
 * 
 * @export
 * @interface MarqueDto
 */
export interface MarqueDto {
    /**
     * 
     * @type {string}
     * @memberof MarqueDto
     */
    categorie: MarqueDtoCategorieEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MarqueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MarqueDto
     */
    idCorrelation: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarqueDto
     */
    libelle: string;
    /**
     * 
     * @type {string}
     * @memberof MarqueDto
     */
    marqueExacteId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarqueDto
     */
    prioritaire: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MarqueDto
     */
    type: MarqueDtoTypeEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum MarqueDtoCategorieEnum {
    'A_CATEGORISER' = 'A_CATEGORISER',
    'PREMIUM' = 'PREMIUM',
    'NON_VALORISABLE' = 'NON_VALORISABLE'
}
/**
    * @export
    * @enum {string}
    */
export enum MarqueDtoTypeEnum {
    'EXACTE' = 'EXACTE',
    'APPROXIMATIVE' = 'APPROXIMATIVE',
    'INCONNUE' = 'INCONNUE'
}

/**
 * 
 * @export
 * @interface MarqueRequestDto
 */
export interface MarqueRequestDto {
    /**
     * 
     * @type {string}
     * @memberof MarqueRequestDto
     */
    categorie: MarqueRequestDtoCategorieEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MarqueRequestDto
     */
    marqueExacteId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarqueRequestDto
     */
    type: MarqueRequestDtoTypeEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum MarqueRequestDtoCategorieEnum {
    'A_CATEGORISER' = 'A_CATEGORISER',
    'PREMIUM' = 'PREMIUM',
    'NON_VALORISABLE' = 'NON_VALORISABLE'
}
/**
    * @export
    * @enum {string}
    */
export enum MarqueRequestDtoTypeEnum {
    'EXACTE' = 'EXACTE',
    'APPROXIMATIVE' = 'APPROXIMATIVE',
    'INCONNUE' = 'INCONNUE'
}

/**
 * 
 * @export
 * @interface MarqueViolationDto
 */
export interface MarqueViolationDto {
    /**
     * 
     * @type {string}
     * @memberof MarqueViolationDto
     */
    formField: MarqueViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof MarqueViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof MarqueViolationDto
     */
    violationCode: MarqueViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum MarqueViolationDtoFormFieldEnum {
    'CATEGORIE' = 'CATEGORIE',
    'TYPE' = 'TYPE',
    'MARQUE_EXACTE' = 'MARQUE_EXACTE'
}
/**
    * @export
    * @enum {string}
    */
export enum MarqueViolationDtoViolationCodeEnum {
    'MARQUE_HAS_APPROXIMATIVE_LINKED' = 'MARQUE_HAS_APPROXIMATIVE_LINKED',
    'MARQUE_HAS_EXACTE_MARQUE_LINKED' = 'MARQUE_HAS_EXACTE_MARQUE_LINKED',
    'MARQUE_EXACTE_NOT_FOUND' = 'MARQUE_EXACTE_NOT_FOUND',
    'MARQUE_EXACTE_NOT_EXACTE' = 'MARQUE_EXACTE_NOT_EXACTE'
}

/**
 * 
 * @export
 * @interface MigrateUniteFoRequestDto
 */
export interface MigrateUniteFoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof MigrateUniteFoRequestDto
     */
    comment: string | null;
    /**
     * 
     * @type {string}
     * @memberof MigrateUniteFoRequestDto
     */
    newUniteFoIdCorrelation: string | null;
    /**
     * 
     * @type {string}
     * @memberof MigrateUniteFoRequestDto
     */
    oldUniteFoIdCorrelation: string | null;
}
/**
 * 
 * @export
 * @interface MigrateUniteFoViolationDto
 */
export interface MigrateUniteFoViolationDto {
    /**
     * 
     * @type {string}
     * @memberof MigrateUniteFoViolationDto
     */
    formField: MigrateUniteFoViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof MigrateUniteFoViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof MigrateUniteFoViolationDto
     */
    violationCode: MigrateUniteFoViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum MigrateUniteFoViolationDtoFormFieldEnum {
    'NEW_UNITE_FO_CORRELATION_ID' = 'NEW_UNITE_FO_CORRELATION_ID',
    'OLD_UNITE_FO_CORRELATION_ID' = 'OLD_UNITE_FO_CORRELATION_ID',
    'COMMENT' = 'COMMENT'
}
/**
    * @export
    * @enum {string}
    */
export enum MigrateUniteFoViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'INVALID_UNITE_FO' = 'INVALID_UNITE_FO',
    'UNITE_FO_NOT_FOUND' = 'UNITE_FO_NOT_FOUND',
    'NO_MODIFICATION' = 'NO_MODIFICATION'
}

/**
 * 
 * @export
 * @interface ModeleDto
 */
export interface ModeleDto {
    /**
     * 
     * @type {string}
     * @memberof ModeleDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ModeleDto
     */
    idCorrelation: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModeleDto
     */
    libelle: string;
    /**
     * 
     * @type {string}
     * @memberof ModeleDto
     */
    marque: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModeleDto
     */
    prioritaire: boolean | null;
}
/**
 * 
 * @export
 * @interface MotifMefDto
 */
export interface MotifMefDto {
    /**
     * 
     * @type {BrancheDto}
     * @memberof MotifMefDto
     */
    branche: BrancheDto;
    /**
     * 
     * @type {boolean}
     * @memberof MotifMefDto
     */
    dicem: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MotifMefDto
     */
    enabled: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MotifMefDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MotifMefDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof MotifMefDto
     */
    motifMef: string;
    /**
     * 
     * @type {string}
     * @memberof MotifMefDto
     */
    nature: string;
    /**
     * 
     * @type {string}
     * @memberof MotifMefDto
     */
    natureLibelleCourt: string;
    /**
     * 
     * @type {boolean}
     * @memberof MotifMefDto
     */
    rodeo: boolean | null;
}
/**
 * 
 * @export
 * @interface MotifMefRequestDto
 */
export interface MotifMefRequestDto {
    /**
     * 
     * @type {string}
     * @memberof MotifMefRequestDto
     */
    brancheIdCorrelation: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MotifMefRequestDto
     */
    dicem: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MotifMefRequestDto
     */
    motifMef: string | null;
    /**
     * 
     * @type {string}
     * @memberof MotifMefRequestDto
     */
    nature: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MotifMefRequestDto
     */
    rodeo: boolean | null;
}
/**
 * 
 * @export
 * @interface MotifMefViolationDto
 */
export interface MotifMefViolationDto {
    /**
     * 
     * @type {string}
     * @memberof MotifMefViolationDto
     */
    formField: MotifMefViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof MotifMefViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof MotifMefViolationDto
     */
    violationCode: MotifMefViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum MotifMefViolationDtoFormFieldEnum {
    'MOTIF_MEF' = 'MOTIF_MEF',
    'BRANCHE' = 'BRANCHE',
    'NATURE' = 'NATURE',
    'DICEM' = 'DICEM',
    'RODEO' = 'RODEO'
}
/**
    * @export
    * @enum {string}
    */
export enum MotifMefViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'BRANCHE_NOT_FOUND' = 'BRANCHE_NOT_FOUND',
    'BRANCHE_NOT_ACTIVE' = 'BRANCHE_NOT_ACTIVE',
    'MOTIF_MEF_UNICITY_VIOLATION' = 'MOTIF_MEF_UNICITY_VIOLATION'
}

/**
 * 
 * @export
 * @interface MotifSortieDto
 */
export interface MotifSortieDto {
    /**
     * 
     * @type {string}
     * @memberof MotifSortieDto
     */
    commentaire: string;
    /**
     * 
     * @type {number}
     * @memberof MotifSortieDto
     */
    delaiEffacementEnMois: number;
    /**
     * 
     * @type {string}
     * @memberof MotifSortieDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MotifSortieDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof MotifSortieDto
     */
    motif: string;
    /**
     * 
     * @type {boolean}
     * @memberof MotifSortieDto
     */
    valid: boolean | null;
}
/**
 * 
 * @export
 * @interface MotifSortieRequestDto
 */
export interface MotifSortieRequestDto {
    /**
     * 
     * @type {string}
     * @memberof MotifSortieRequestDto
     */
    commentaire: string | null;
    /**
     * 
     * @type {number}
     * @memberof MotifSortieRequestDto
     */
    delaiEffacement: number | null;
    /**
     * 
     * @type {string}
     * @memberof MotifSortieRequestDto
     */
    motif: string | null;
}
/**
 * 
 * @export
 * @interface MotifSortieViolationDto
 */
export interface MotifSortieViolationDto {
    /**
     * 
     * @type {string}
     * @memberof MotifSortieViolationDto
     */
    formField: MotifSortieViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof MotifSortieViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof MotifSortieViolationDto
     */
    violationCode: MotifSortieViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum MotifSortieViolationDtoFormFieldEnum {
    'MOTIF' = 'MOTIF',
    'COMMENTAIRE' = 'COMMENTAIRE',
    'DELAI_EFFACEMENT' = 'DELAI_EFFACEMENT'
}
/**
    * @export
    * @enum {string}
    */
export enum MotifSortieViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'DELAI_EFFACEMENT_NEGATIVE_VALUE' = 'DELAI_EFFACEMENT_NEGATIVE_VALUE',
    'MOTIF_UNICITY_VIOLATION' = 'MOTIF_UNICITY_VIOLATION'
}

/**
 * 
 * @export
 * @interface MotifsSortieRequiringCustomCheckDto
 */
export interface MotifsSortieRequiringCustomCheckDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof MotifsSortieRequiringCustomCheckDto
     */
    idsCorrelation: Array<string>;
}
/**
 * 
 * @export
 * @interface NotificationAutomatiqueInfosDto
 */
export interface NotificationAutomatiqueInfosDto {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationAutomatiqueInfosDto
     */
    absenceRetour: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAutomatiqueInfosDto
     */
    antaiId: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAutomatiqueInfosDto
     */
    arPndFilename: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAutomatiqueInfosDto
     */
    compteurEnvoi: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAutomatiqueInfosDto
     */
    courrierFilename: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAutomatiqueInfosDto
     */
    dateDeclenchementAbsenceRetour: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAutomatiqueInfosDto
     */
    dateDemandeEdition: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAutomatiqueInfosDto
     */
    dateEstimeeRetour: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAutomatiqueInfosDto
     */
    dateMiseAJourEtat: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAutomatiqueInfosDto
     */
    dateRemisEnPoste: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAutomatiqueInfosDto
     */
    etatDistribution: NotificationAutomatiqueInfosDtoEtatDistributionEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationAutomatiqueInfosDto
     */
    fileIds: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationAutomatiqueInfosDto
     */
    remisEnPoste: boolean | null;
}

/**
    * @export
    * @enum {string}
    */
export enum NotificationAutomatiqueInfosDtoEtatDistributionEnum {
    'AR' = 'AR',
    'REFUSE' = 'REFUSE',
    'NON_RECLAME' = 'NON_RECLAME',
    'DEFAUT_ACCESS_OU_ADRESSAGE' = 'DEFAUT_ACCESS_OU_ADRESSAGE',
    'DESTINATAIRE_INCONNU' = 'DESTINATAIRE_INCONNU',
    'INCONNU' = 'INCONNU'
}

/**
 * 
 * @export
 * @interface NotificationInfosRequestDto
 */
export interface NotificationInfosRequestDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationInfosRequestDto
     */
    dateEnvoi: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationInfosRequestDto
     */
    dateRetour: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationInfosRequestDto
     */
    etatDistribution: NotificationInfosRequestDtoEtatDistributionEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum NotificationInfosRequestDtoEtatDistributionEnum {
    'DESTINATAIRE_INCONNU' = 'DESTINATAIRE_INCONNU',
    'REFUS_PLI' = 'REFUS_PLI',
    'RECEPTION_LRAR' = 'RECEPTION_LRAR',
    'ABSENCE_AVEC_RETRAIT' = 'ABSENCE_AVEC_RETRAIT',
    'ABSENCE_SANS_RETRAIT' = 'ABSENCE_SANS_RETRAIT'
}

/**
 * 
 * @export
 * @interface NotificationInfosViolationDto
 */
export interface NotificationInfosViolationDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationInfosViolationDto
     */
    formField: NotificationInfosViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationInfosViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationInfosViolationDto
     */
    violationCode: NotificationInfosViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum NotificationInfosViolationDtoFormFieldEnum {
    'DATE_ENVOI' = 'DATE_ENVOI',
    'DATE_RETOUR' = 'DATE_RETOUR',
    'ETAT_DISTRIBUTION' = 'ETAT_DISTRIBUTION'
}
/**
    * @export
    * @enum {string}
    */
export enum NotificationInfosViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'DATE_ENVOI_DIFFERENT_FROM_DOSSIER' = 'DATE_ENVOI_DIFFERENT_FROM_DOSSIER',
    'DATE_IN_THE_FUTURE' = 'DATE_IN_THE_FUTURE',
    'DATE_ENVOI_BEFORE_ENTREE' = 'DATE_ENVOI_BEFORE_ENTREE',
    'DATE_RETOUR_BEFORE_ENVOI' = 'DATE_RETOUR_BEFORE_ENVOI'
}

/**
 * 
 * @export
 * @interface NotificationManuelleInfosDto
 */
export interface NotificationManuelleInfosDto {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationManuelleInfosDto
     */
    absenceRetour: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationManuelleInfosDto
     */
    ajoutActionRequiseRetour: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationManuelleInfosDto
     */
    dateDeclenchementAbsenceRetour: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationManuelleInfosDto
     */
    dateDeclenchementActionRequiseRetour: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationManuelleInfosDto
     */
    dateEnvoi: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationManuelleInfosDto
     */
    dateRetour: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationManuelleInfosDto
     */
    dateRetourEstimee: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationManuelleInfosDto
     */
    etatDistribution: NotificationManuelleInfosDtoEtatDistributionEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum NotificationManuelleInfosDtoEtatDistributionEnum {
    'DESTINATAIRE_INCONNU' = 'DESTINATAIRE_INCONNU',
    'REFUS_PLI' = 'REFUS_PLI',
    'RECEPTION_LRAR' = 'RECEPTION_LRAR',
    'ABSENCE_AVEC_RETRAIT' = 'ABSENCE_AVEC_RETRAIT',
    'ABSENCE_SANS_RETRAIT' = 'ABSENCE_SANS_RETRAIT'
}

/**
 * 
 * @export
 * @interface PieceJointeTypeResponseDto
 */
export interface PieceJointeTypeResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof PieceJointeTypeResponseDto
     */
    disponible: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PieceJointeTypeResponseDto
     */
    identifiant: string;
    /**
     * 
     * @type {string}
     * @memberof PieceJointeTypeResponseDto
     */
    libelle: string;
}
/**
 * 
 * @export
 * @interface ProcesVerbalDto
 */
export interface ProcesVerbalDto {
    /**
     * 
     * @type {string}
     * @memberof ProcesVerbalDto
     */
    date: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcesVerbalDto
     */
    numero: string | null;
}
/**
 * 
 * @export
 * @interface ProfilAutoriteFourriereRequestDto
 */
export interface ProfilAutoriteFourriereRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ProfilAutoriteFourriereRequestDto
     */
    cedex: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilAutoriteFourriereRequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilAutoriteFourriereRequestDto
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilAutoriteFourriereRequestDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilAutoriteFourriereRequestDto
     */
    numeroVoie: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilAutoriteFourriereRequestDto
     */
    voie: string | null;
}
/**
 * 
 * @export
 * @interface ProfilAutoriteFourriereViolationDto
 */
export interface ProfilAutoriteFourriereViolationDto {
    /**
     * 
     * @type {string}
     * @memberof ProfilAutoriteFourriereViolationDto
     */
    formField: ProfilAutoriteFourriereViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfilAutoriteFourriereViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilAutoriteFourriereViolationDto
     */
    violationCode: ProfilAutoriteFourriereViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProfilAutoriteFourriereViolationDtoFormFieldEnum {
    'TYPE' = 'TYPE',
    'NOM_VOIE' = 'NOM_VOIE',
    'NUMERO_VOIE' = 'NUMERO_VOIE',
    'ADRESSE' = 'ADRESSE',
    'COMPLEMENT_ADRESSE' = 'COMPLEMENT_ADRESSE',
    'CODE_POSTAL' = 'CODE_POSTAL',
    'COMMUNE' = 'COMMUNE',
    'CEDEX' = 'CEDEX'
}
/**
    * @export
    * @enum {string}
    */
export enum ProfilAutoriteFourriereViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'NOT_IN_REFERENTIEL' = 'NOT_IN_REFERENTIEL',
    'CODE_POSTAL_WRONG_FORMAT' = 'CODE_POSTAL_WRONG_FORMAT',
    'STRING_LENGTH_LIMIT' = 'STRING_LENGTH_LIMIT'
}

/**
 * 
 * @export
 * @interface ProfilAutoriteFourriereViolationsDto
 */
export interface ProfilAutoriteFourriereViolationsDto {
    /**
     * 
     * @type {Array<ProfilAutoriteFourriereViolationDto>}
     * @memberof ProfilAutoriteFourriereViolationsDto
     */
    violationDtos: Array<ProfilAutoriteFourriereViolationDto> | null;
}
/**
 * 
 * @export
 * @interface ProfilFourriereRequestDto
 */
export interface ProfilFourriereRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    adresseMail: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfilFourriereRequestDto
     */
    autoriteFourriereRattachement: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    complementAdresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    coordonneesGps: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    dateAgrementDebut: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    dateAgrementFin: string | null;
    /**
     * 
     * @type {InternalHorairesRequestDto}
     * @memberof ProfilFourriereRequestDto
     */
    horaires: InternalHorairesRequestDto | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    mailResponsable: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    nomResponsable: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    nomVoie: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProfilFourriereRequestDto
     */
    nombrePlacesParc: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    numeroAgrement: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    numeroVoie: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    raisonSociale: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    telephoneFixe: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereRequestDto
     */
    telephoneMobile: string | null;
}
/**
 * 
 * @export
 * @interface ProfilFourriereViolationDto
 */
export interface ProfilFourriereViolationDto {
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereViolationDto
     */
    formField: ProfilFourriereViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilFourriereViolationDto
     */
    violationCode: ProfilFourriereViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProfilFourriereViolationDtoFormFieldEnum {
    'ID' = 'ID',
    'ID_CORRELATION' = 'ID_CORRELATION',
    'AUTORITES_FOURRIERE_IDS' = 'AUTORITES_FOURRIERE_IDS',
    'RAISON_SOCIALE' = 'RAISON_SOCIALE',
    'NUMERO_AGREMENT' = 'NUMERO_AGREMENT',
    'DATE_AGREMENT_DEBUT' = 'DATE_AGREMENT_DEBUT',
    'DATE_AGREMENT_FIN' = 'DATE_AGREMENT_FIN',
    'NOMBRE_EMPLACEMENTS' = 'NOMBRE_EMPLACEMENTS',
    'NOM_VOIE' = 'NOM_VOIE',
    'NUMERO_VOIE' = 'NUMERO_VOIE',
    'ADRESSE' = 'ADRESSE',
    'COMPLEMENT_ADRESSE' = 'COMPLEMENT_ADRESSE',
    'CODE_POSTAL' = 'CODE_POSTAL',
    'COMMUNE' = 'COMMUNE',
    'TELEPHONE_FIXE' = 'TELEPHONE_FIXE',
    'TELEPHONE_MOBILE' = 'TELEPHONE_MOBILE',
    'ADRESSE_MAIL' = 'ADRESSE_MAIL',
    'COORDONNEES_GPS' = 'COORDONNEES_GPS',
    'NOM_RESPONSABLE' = 'NOM_RESPONSABLE',
    'ADRESSE_MAIL_RESPONSABLE' = 'ADRESSE_MAIL_RESPONSABLE',
    'HORAIRES' = 'HORAIRES'
}
/**
    * @export
    * @enum {string}
    */
export enum ProfilFourriereViolationDtoViolationCodeEnum {
    'ADRESSE_AND_RAISON_SOCIALE_UNICITY' = 'ADRESSE_AND_RAISON_SOCIALE_UNICITY',
    'MISSING_FIELD' = 'MISSING_FIELD',
    'NUMERO_VOIE_BAD_FORMAT' = 'NUMERO_VOIE_BAD_FORMAT',
    'PHONE_WRONG_FORMAT' = 'PHONE_WRONG_FORMAT',
    'MAIL_WRONG_FORMAT' = 'MAIL_WRONG_FORMAT',
    'CODE_POSTAL_WRONG_FORMAT' = 'CODE_POSTAL_WRONG_FORMAT',
    'NOMBRE_PLACES_NOT_SUPERIOR_TO_ONE' = 'NOMBRE_PLACES_NOT_SUPERIOR_TO_ONE',
    'DATE_DEBUT_AGREMENT_AFTER_DATE_FIN_AGREMENT' = 'DATE_DEBUT_AGREMENT_AFTER_DATE_FIN_AGREMENT',
    'INCONSISTENT_HORAIRES_DEBUT_AFTER_FIN' = 'INCONSISTENT_HORAIRES_DEBUT_AFTER_FIN',
    'JOUR_RDV_AVEC_HORAIRES_OUVERTURE' = 'JOUR_RDV_AVEC_HORAIRES_OUVERTURE',
    'JOUR_OUVERT_SANS_HORAIRES_OUVERTURE' = 'JOUR_OUVERT_SANS_HORAIRES_OUVERTURE',
    'JOUR_OUVERT_SANS_HORAIRES_APPEL' = 'JOUR_OUVERT_SANS_HORAIRES_APPEL',
    'STRING_LENGTH_LIMIT' = 'STRING_LENGTH_LIMIT'
}

/**
 * 
 * @export
 * @interface ProfilFourriereViolationsDto
 */
export interface ProfilFourriereViolationsDto {
    /**
     * 
     * @type {Array<ProfilFourriereViolationDto>}
     * @memberof ProfilFourriereViolationsDto
     */
    violationDtos: Array<ProfilFourriereViolationDto> | null;
}
/**
 * 
 * @export
 * @interface ProfilRightsDto
 */
export interface ProfilRightsDto {
    /**
     * 
     * @type {string}
     * @memberof ProfilRightsDto
     */
    agentJustice: ProfilRightsDtoAgentJusticeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfilRightsDto
     */
    autoriteFourriere: ProfilRightsDtoAutoriteFourriereEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfilRightsDto
     */
    forceOrdre: ProfilRightsDtoForceOrdreEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfilRightsDto
     */
    gardienFourriere: ProfilRightsDtoGardienFourriereEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProfilRightsDtoAgentJusticeEnum {
    'NONE' = 'NONE',
    'READ' = 'READ',
    'WRITE' = 'WRITE'
}
/**
    * @export
    * @enum {string}
    */
export enum ProfilRightsDtoAutoriteFourriereEnum {
    'NONE' = 'NONE',
    'READ' = 'READ',
    'WRITE' = 'WRITE'
}
/**
    * @export
    * @enum {string}
    */
export enum ProfilRightsDtoForceOrdreEnum {
    'NONE' = 'NONE',
    'READ' = 'READ',
    'WRITE' = 'WRITE'
}
/**
    * @export
    * @enum {string}
    */
export enum ProfilRightsDtoGardienFourriereEnum {
    'NONE' = 'NONE',
    'READ' = 'READ',
    'WRITE' = 'WRITE'
}

/**
 * 
 * @export
 * @interface ProlongationRequestDto
 */
export interface ProlongationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ProlongationRequestDto
     */
    dateDecisionProcureur: string | null;
}
/**
 * 
 * @export
 * @interface ProlongationViolationDto
 */
export interface ProlongationViolationDto {
    /**
     * 
     * @type {string}
     * @memberof ProlongationViolationDto
     */
    formField: ProlongationViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof ProlongationViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ProlongationViolationDto
     */
    violationCode: ProlongationViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProlongationViolationDtoFormFieldEnum {
    'DATE_DECISION_PROCUREUR' = 'DATE_DECISION_PROCUREUR'
}
/**
    * @export
    * @enum {string}
    */
export enum ProlongationViolationDtoViolationCodeEnum {
    'MISSING_DATE_DECISION_PROCUREUR' = 'MISSING_DATE_DECISION_PROCUREUR',
    'DATE_DECISION_AFTER_NOW' = 'DATE_DECISION_AFTER_NOW',
    'DATE_DECISION_BEFORE_DATE_ENTREE' = 'DATE_DECISION_BEFORE_DATE_ENTREE'
}

/**
 * 
 * @export
 * @interface Proprietaire
 */
export interface Proprietaire {
    /**
     * 
     * @type {string}
     * @memberof Proprietaire
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof Proprietaire
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof Proprietaire
     */
    commune: string | null;
    /**
     * 
     * @type {string}
     * @memberof Proprietaire
     */
    nom: string | null;
    /**
     * 
     * @type {string}
     * @memberof Proprietaire
     */
    prenom: string | null;
    /**
     * 
     * @type {string}
     * @memberof Proprietaire
     */
    raisonSociale: string | null;
}
/**
 * 
 * @export
 * @interface ProprietaireCourantDto
 */
export interface ProprietaireCourantDto {
    /**
     * 
     * @type {string}
     * @memberof ProprietaireCourantDto
     */
    nom: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProprietaireCourantDto
     */
    prenom: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProprietaireCourantDto
     */
    raisonSociale: string | null;
}
/**
 * 
 * @export
 * @interface ProprietaireDto
 */
export interface ProprietaireDto {
    /**
     * 
     * @type {string}
     * @memberof ProprietaireDto
     */
    nom: string | null;
}
/**
 * 
 * @export
 * @interface RecuperationActiviteUtilisateurRequestDto
 */
export interface RecuperationActiviteUtilisateurRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RecuperationActiviteUtilisateurRequestDto
     */
    dateDebut: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecuperationActiviteUtilisateurRequestDto
     */
    dateFin: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecuperationActiviteUtilisateurRequestDto
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecuperationActiviteUtilisateurRequestDto
     */
    nom: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecuperationActiviteUtilisateurRequestDto
     */
    prenom: string | null;
}
/**
 * 
 * @export
 * @interface RecuperationActiviteUtilisateurViolationsDto
 */
export interface RecuperationActiviteUtilisateurViolationsDto {
    /**
     * 
     * @type {string}
     * @memberof RecuperationActiviteUtilisateurViolationsDto
     */
    formField: RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof RecuperationActiviteUtilisateurViolationsDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof RecuperationActiviteUtilisateurViolationsDto
     */
    violationCode: RecuperationActiviteUtilisateurViolationsDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum RecuperationActiviteUtilisateurViolationsDtoFormFieldEnum {
    'ID' = 'ID',
    'NOM' = 'NOM',
    'PRENOM' = 'PRENOM',
    'DATE_DEBUT' = 'DATE_DEBUT',
    'DATE_FIN' = 'DATE_FIN'
}
/**
    * @export
    * @enum {string}
    */
export enum RecuperationActiviteUtilisateurViolationsDtoViolationCodeEnum {
    'FIELD_CANNOT_BE_BLANK' = 'FIELD_CANNOT_BE_BLANK',
    'MISSING_AT_LEAST_ONE_FIELD' = 'MISSING_AT_LEAST_ONE_FIELD',
    'DATE_DEBUT_AFTER_DATE_FIN' = 'DATE_DEBUT_AFTER_DATE_FIN'
}

/**
 * 
 * @export
 * @interface ReferenceDtoAutoriteFourriereDto
 */
export interface ReferenceDtoAutoriteFourriereDto {
    /**
     * 
     * @type {Array<AutoriteFourriereDto>}
     * @memberof ReferenceDtoAutoriteFourriereDto
     */
    referenceDtoList: Array<AutoriteFourriereDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoBrancheDto
 */
export interface ReferenceDtoBrancheDto {
    /**
     * 
     * @type {Array<BrancheDto>}
     * @memberof ReferenceDtoBrancheDto
     */
    referenceDtoList: Array<BrancheDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoCentreVHUDto
 */
export interface ReferenceDtoCentreVHUDto {
    /**
     * 
     * @type {Array<CentreVHUDto>}
     * @memberof ReferenceDtoCentreVHUDto
     */
    referenceDtoList: Array<CentreVHUDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoCouleurDto
 */
export interface ReferenceDtoCouleurDto {
    /**
     * 
     * @type {Array<CouleurDto>}
     * @memberof ReferenceDtoCouleurDto
     */
    referenceDtoList: Array<CouleurDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoEnergieDto
 */
export interface ReferenceDtoEnergieDto {
    /**
     * 
     * @type {Array<EnergieDto>}
     * @memberof ReferenceDtoEnergieDto
     */
    referenceDtoList: Array<EnergieDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoEtatDto
 */
export interface ReferenceDtoEtatDto {
    /**
     * 
     * @type {Array<EtatDto>}
     * @memberof ReferenceDtoEtatDto
     */
    referenceDtoList: Array<EtatDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoFaqAdminDto
 */
export interface ReferenceDtoFaqAdminDto {
    /**
     * 
     * @type {Array<FaqAdminDto>}
     * @memberof ReferenceDtoFaqAdminDto
     */
    referenceDtoList: Array<FaqAdminDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoFaqDomainAdminDto
 */
export interface ReferenceDtoFaqDomainAdminDto {
    /**
     * 
     * @type {Array<FaqDomainAdminDto>}
     * @memberof ReferenceDtoFaqDomainAdminDto
     */
    referenceDtoList: Array<FaqDomainAdminDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoFaqDomainDto
 */
export interface ReferenceDtoFaqDomainDto {
    /**
     * 
     * @type {Array<FaqDomainDto>}
     * @memberof ReferenceDtoFaqDomainDto
     */
    referenceDtoList: Array<FaqDomainDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoFaqDto
 */
export interface ReferenceDtoFaqDto {
    /**
     * 
     * @type {Array<FaqDto>}
     * @memberof ReferenceDtoFaqDto
     */
    referenceDtoList: Array<FaqDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoFooterLinkDto
 */
export interface ReferenceDtoFooterLinkDto {
    /**
     * 
     * @type {Array<FooterLinkDto>}
     * @memberof ReferenceDtoFooterLinkDto
     */
    referenceDtoList: Array<FooterLinkDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoFourriereDto
 */
export interface ReferenceDtoFourriereDto {
    /**
     * 
     * @type {Array<FourriereDto>}
     * @memberof ReferenceDtoFourriereDto
     */
    referenceDtoList: Array<FourriereDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoGenreSimplifieDto
 */
export interface ReferenceDtoGenreSimplifieDto {
    /**
     * 
     * @type {Array<GenreSimplifieDto>}
     * @memberof ReferenceDtoGenreSimplifieDto
     */
    referenceDtoList: Array<GenreSimplifieDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoInformationMessageDto
 */
export interface ReferenceDtoInformationMessageDto {
    /**
     * 
     * @type {Array<InformationMessageDto>}
     * @memberof ReferenceDtoInformationMessageDto
     */
    referenceDtoList: Array<InformationMessageDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoJuridictionAdminResponseDto
 */
export interface ReferenceDtoJuridictionAdminResponseDto {
    /**
     * 
     * @type {Array<JuridictionAdminResponseDto>}
     * @memberof ReferenceDtoJuridictionAdminResponseDto
     */
    referenceDtoList: Array<JuridictionAdminResponseDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoJuridictionResponseDto
 */
export interface ReferenceDtoJuridictionResponseDto {
    /**
     * 
     * @type {Array<JuridictionResponseDto>}
     * @memberof ReferenceDtoJuridictionResponseDto
     */
    referenceDtoList: Array<JuridictionResponseDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoMarqueDto
 */
export interface ReferenceDtoMarqueDto {
    /**
     * 
     * @type {Array<MarqueDto>}
     * @memberof ReferenceDtoMarqueDto
     */
    referenceDtoList: Array<MarqueDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoModeleDto
 */
export interface ReferenceDtoModeleDto {
    /**
     * 
     * @type {Array<ModeleDto>}
     * @memberof ReferenceDtoModeleDto
     */
    referenceDtoList: Array<ModeleDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoMotifMefDto
 */
export interface ReferenceDtoMotifMefDto {
    /**
     * 
     * @type {Array<MotifMefDto>}
     * @memberof ReferenceDtoMotifMefDto
     */
    referenceDtoList: Array<MotifMefDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoMotifSortieDto
 */
export interface ReferenceDtoMotifSortieDto {
    /**
     * 
     * @type {Array<MotifSortieDto>}
     * @memberof ReferenceDtoMotifSortieDto
     */
    referenceDtoList: Array<MotifSortieDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoStatutDto
 */
export interface ReferenceDtoStatutDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferenceDtoStatutDto
     */
    statuts: Array<ReferenceDtoStatutDtoStatutsEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum ReferenceDtoStatutDtoStatutsEnum {
    'A_REMPLIR' = 'A_REMPLIR',
    'ENREGISTRE' = 'ENREGISTRE',
    'NON_GERE' = 'NON_GERE',
    'NOTIFICATION_ENVOYEE' = 'NOTIFICATION_ENVOYEE',
    'NOTIFIE' = 'NOTIFIE',
    'A_NOTIFIER' = 'A_NOTIFIER',
    'EN_COURS_DE_NOTIFICATION' = 'EN_COURS_DE_NOTIFICATION',
    'A_REMETTRE_AUX_DOMAINES' = 'A_REMETTRE_AUX_DOMAINES',
    'REMIS_AU_DOMAINE' = 'REMIS_AU_DOMAINE',
    'MIS_EN_VENTE' = 'MIS_EN_VENTE',
    'VENDU' = 'VENDU',
    'A_RESTITUER' = 'A_RESTITUER',
    'VENTE_BLOQUEE' = 'VENTE_BLOQUEE',
    'A_DETRUIRE' = 'A_DETRUIRE',
    'SORTI' = 'SORTI',
    'DETRUIT' = 'DETRUIT'
}

/**
 * 
 * @export
 * @interface ReferenceDtoTypeAutoriteFourriereDto
 */
export interface ReferenceDtoTypeAutoriteFourriereDto {
    /**
     * 
     * @type {Array<TypeAutoriteFourriereDto>}
     * @memberof ReferenceDtoTypeAutoriteFourriereDto
     */
    referenceDtoList: Array<TypeAutoriteFourriereDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoUniteFOAdminResponseDto
 */
export interface ReferenceDtoUniteFOAdminResponseDto {
    /**
     * 
     * @type {Array<UniteFOAdminResponseDto>}
     * @memberof ReferenceDtoUniteFOAdminResponseDto
     */
    referenceDtoList: Array<UniteFOAdminResponseDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoUniteFOResponseDto
 */
export interface ReferenceDtoUniteFOResponseDto {
    /**
     * 
     * @type {Array<UniteFOResponseDto>}
     * @memberof ReferenceDtoUniteFOResponseDto
     */
    referenceDtoList: Array<UniteFOResponseDto>;
}
/**
 * 
 * @export
 * @interface ReferenceDtoVideoTutorielDto
 */
export interface ReferenceDtoVideoTutorielDto {
    /**
     * 
     * @type {Array<VideoTutorielDto>}
     * @memberof ReferenceDtoVideoTutorielDto
     */
    referenceDtoList: Array<VideoTutorielDto>;
}
/**
 * 
 * @export
 * @interface ReferentielCommentairesRequestDto
 */
export interface ReferentielCommentairesRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ReferentielCommentairesRequestDto
     */
    commentaires: string | null;
}
/**
 * 
 * @export
 * @interface ReferentielEnumDto
 */
export interface ReferentielEnumDto {
    /**
     * 
     * @type {string}
     * @memberof ReferentielEnumDto
     */
    referentialEnumCSV: ReferentielEnumDtoReferentialEnumCSVEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ReferentielEnumDtoReferentialEnumCSVEnum {
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'BRANCHE' = 'BRANCHE',
    'CENTRE_VHU' = 'CENTRE_VHU',
    'ETAT' = 'ETAT',
    'FOURRIERE' = 'FOURRIERE',
    'FOOTER_LINK' = 'FOOTER_LINK',
    'GENRE_SIMPLIFIE' = 'GENRE_SIMPLIFIE',
    'MOTIF_MEF' = 'MOTIF_MEF',
    'MOTIF_SORTIE' = 'MOTIF_SORTIE',
    'TYPE_AF' = 'TYPE_AF',
    'UNITE_FO' = 'UNITE_FO',
    'FAQ' = 'FAQ',
    'VIDEO_TUTORIEL' = 'VIDEO_TUTORIEL'
}

/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoAutoriteFourriereDto
 */
export interface ReferentielSearchResultDtoAutoriteFourriereDto {
    /**
     * 
     * @type {ReferenceDtoAutoriteFourriereDto}
     * @memberof ReferentielSearchResultDtoAutoriteFourriereDto
     */
    results: ReferenceDtoAutoriteFourriereDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoAutoriteFourriereDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoCentreVHUDto
 */
export interface ReferentielSearchResultDtoCentreVHUDto {
    /**
     * 
     * @type {ReferenceDtoCentreVHUDto}
     * @memberof ReferentielSearchResultDtoCentreVHUDto
     */
    results: ReferenceDtoCentreVHUDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoCentreVHUDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoEtatDto
 */
export interface ReferentielSearchResultDtoEtatDto {
    /**
     * 
     * @type {ReferenceDtoEtatDto}
     * @memberof ReferentielSearchResultDtoEtatDto
     */
    results: ReferenceDtoEtatDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoEtatDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoFaqAdminDto
 */
export interface ReferentielSearchResultDtoFaqAdminDto {
    /**
     * 
     * @type {ReferenceDtoFaqAdminDto}
     * @memberof ReferentielSearchResultDtoFaqAdminDto
     */
    results: ReferenceDtoFaqAdminDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoFaqAdminDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoFaqDomainAdminDto
 */
export interface ReferentielSearchResultDtoFaqDomainAdminDto {
    /**
     * 
     * @type {ReferenceDtoFaqDomainAdminDto}
     * @memberof ReferentielSearchResultDtoFaqDomainAdminDto
     */
    results: ReferenceDtoFaqDomainAdminDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoFaqDomainAdminDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoFooterLinkDto
 */
export interface ReferentielSearchResultDtoFooterLinkDto {
    /**
     * 
     * @type {ReferenceDtoFooterLinkDto}
     * @memberof ReferentielSearchResultDtoFooterLinkDto
     */
    results: ReferenceDtoFooterLinkDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoFooterLinkDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoFourriereDto
 */
export interface ReferentielSearchResultDtoFourriereDto {
    /**
     * 
     * @type {ReferenceDtoFourriereDto}
     * @memberof ReferentielSearchResultDtoFourriereDto
     */
    results: ReferenceDtoFourriereDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoFourriereDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoGenreSimplifieDto
 */
export interface ReferentielSearchResultDtoGenreSimplifieDto {
    /**
     * 
     * @type {ReferenceDtoGenreSimplifieDto}
     * @memberof ReferentielSearchResultDtoGenreSimplifieDto
     */
    results: ReferenceDtoGenreSimplifieDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoGenreSimplifieDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoJuridictionAdminResponseDto
 */
export interface ReferentielSearchResultDtoJuridictionAdminResponseDto {
    /**
     * 
     * @type {ReferenceDtoJuridictionAdminResponseDto}
     * @memberof ReferentielSearchResultDtoJuridictionAdminResponseDto
     */
    results: ReferenceDtoJuridictionAdminResponseDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoJuridictionAdminResponseDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoMarqueDto
 */
export interface ReferentielSearchResultDtoMarqueDto {
    /**
     * 
     * @type {ReferenceDtoMarqueDto}
     * @memberof ReferentielSearchResultDtoMarqueDto
     */
    results: ReferenceDtoMarqueDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoMarqueDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoModeleDto
 */
export interface ReferentielSearchResultDtoModeleDto {
    /**
     * 
     * @type {ReferenceDtoModeleDto}
     * @memberof ReferentielSearchResultDtoModeleDto
     */
    results: ReferenceDtoModeleDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoModeleDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoMotifMefDto
 */
export interface ReferentielSearchResultDtoMotifMefDto {
    /**
     * 
     * @type {ReferenceDtoMotifMefDto}
     * @memberof ReferentielSearchResultDtoMotifMefDto
     */
    results: ReferenceDtoMotifMefDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoMotifMefDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoMotifSortieDto
 */
export interface ReferentielSearchResultDtoMotifSortieDto {
    /**
     * 
     * @type {ReferenceDtoMotifSortieDto}
     * @memberof ReferentielSearchResultDtoMotifSortieDto
     */
    results: ReferenceDtoMotifSortieDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoMotifSortieDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoTypeAutoriteFourriereDto
 */
export interface ReferentielSearchResultDtoTypeAutoriteFourriereDto {
    /**
     * 
     * @type {ReferenceDtoTypeAutoriteFourriereDto}
     * @memberof ReferentielSearchResultDtoTypeAutoriteFourriereDto
     */
    results: ReferenceDtoTypeAutoriteFourriereDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoTypeAutoriteFourriereDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoUniteFOAdminResponseDto
 */
export interface ReferentielSearchResultDtoUniteFOAdminResponseDto {
    /**
     * 
     * @type {ReferenceDtoUniteFOAdminResponseDto}
     * @memberof ReferentielSearchResultDtoUniteFOAdminResponseDto
     */
    results: ReferenceDtoUniteFOAdminResponseDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoUniteFOAdminResponseDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielSearchResultDtoVideoTutorielDto
 */
export interface ReferentielSearchResultDtoVideoTutorielDto {
    /**
     * 
     * @type {ReferenceDtoVideoTutorielDto}
     * @memberof ReferentielSearchResultDtoVideoTutorielDto
     */
    results: ReferenceDtoVideoTutorielDto;
    /**
     * 
     * @type {number}
     * @memberof ReferentielSearchResultDtoVideoTutorielDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ReferentielUsesDto
 */
export interface ReferentielUsesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferentielUsesDto
     */
    listChildrenIdCorrelation: Array<string> | null;
    /**
     * 
     * @type {SearchDossierIdResultDto}
     * @memberof ReferentielUsesDto
     */
    searchDossierResult: SearchDossierIdResultDto | null;
}
/**
 * 
 * @export
 * @interface ReferentielViolationsDto
 */
export interface ReferentielViolationsDto {
    /**
     * 
     * @type {Array<AutoriteFourriereViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    autoriteFourriereViolationsDto: Array<AutoriteFourriereViolationDto> | null;
    /**
     * 
     * @type {Array<BrancheViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    brancheViolationsDto: Array<BrancheViolationDto> | null;
    /**
     * 
     * @type {Array<CentreVHUViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    centreVHUViolationsDto: Array<CentreVHUViolationDto> | null;
    /**
     * 
     * @type {Array<EtatViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    etatViolationsDto: Array<EtatViolationDto> | null;
    /**
     * 
     * @type {Array<FaqDomainViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    faqDomainViolationsDto: Array<FaqDomainViolationDto> | null;
    /**
     * 
     * @type {Array<FaqViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    faqViolationsDto: Array<FaqViolationDto> | null;
    /**
     * 
     * @type {Array<FooterLinkViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    footerLinkViolationsDto: Array<FooterLinkViolationDto> | null;
    /**
     * 
     * @type {Array<FourriereViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    fourriereViolationsDto: Array<FourriereViolationDto> | null;
    /**
     * 
     * @type {Array<GenreSimplifieViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    genreSimplifieViolationsDto: Array<GenreSimplifieViolationDto> | null;
    /**
     * 
     * @type {Array<JuridictionViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    juridictionViolationsDto: Array<JuridictionViolationDto> | null;
    /**
     * 
     * @type {Array<MarqueViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    marqueViolationsDto: Array<MarqueViolationDto> | null;
    /**
     * 
     * @type {Array<MotifMefViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    motifMefViolationsDto: Array<MotifMefViolationDto> | null;
    /**
     * 
     * @type {Array<MotifSortieViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    motifSortieViolationsDto: Array<MotifSortieViolationDto> | null;
    /**
     * 
     * @type {Array<TypeAutoriteFourriereViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    typeAutoriteFourriereViolationDto: Array<TypeAutoriteFourriereViolationDto> | null;
    /**
     * 
     * @type {Array<UniteFoViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    uniteFoViolationsDto: Array<UniteFoViolationDto> | null;
    /**
     * 
     * @type {Array<VideoTutorielViolationDto>}
     * @memberof ReferentielViolationsDto
     */
    videoTutorielViolationsDto: Array<VideoTutorielViolationDto> | null;
}
/**
 * 
 * @export
 * @interface RelanceVenteDto
 */
export interface RelanceVenteDto {
    /**
     * 
     * @type {string}
     * @memberof RelanceVenteDto
     */
    dossierId: string;
    /**
     * 
     * @type {string}
     * @memberof RelanceVenteDto
     */
    relanceVenteType: RelanceVenteDtoRelanceVenteTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RelanceVenteDto
     */
    statut: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum RelanceVenteDtoRelanceVenteTypeEnum {
    'MANQUANT' = 'MANQUANT',
    'VOL' = 'VOL',
    'IMMO_PJ' = 'IMMO_PJ',
    'OPPOSITION' = 'OPPOSITION',
    'DOUBLON' = 'DOUBLON',
    'ERREUR_IDENTIFICATION_SANS_MODIFICATION' = 'ERREUR_IDENTIFICATION_SANS_MODIFICATION'
}

/**
 * 
 * @export
 * @interface ReportRequestDto
 */
export interface ReportRequestDto {
    /**
     * 
     * @type {any}
     * @memberof ReportRequestDto
     */
    applicationData: any | null;
    /**
     * 
     * @type {string}
     * @memberof ReportRequestDto
     */
    modeleTelephone: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportRequestDto
     */
    versionBdr: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportRequestDto
     */
    versionOs: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportRequestDto
     */
    versionSdkAndroid: string | null;
}
/**
 * 
 * @export
 * @interface RequiredUserActionsDto
 */
export interface RequiredUserActionsDto {
    /**
     * 
     * @type {string}
     * @memberof RequiredUserActionsDto
     */
    idAutoriteFourriereToConfirm: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequiredUserActionsDto
     */
    idFourriereToConfirm: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RequiredUserActionsDto
     */
    mustConfirmAccount: boolean;
}
/**
 * 
 * @export
 * @interface RpsiFluxDto
 */
export interface RpsiFluxDto {
    /**
     * 
     * @type {string}
     * @memberof RpsiFluxDto
     */
    dateAppel: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RpsiFluxDto
     */
    errors: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RpsiFluxDto
     */
    filename: string | null;
    /**
     * 
     * @type {string}
     * @memberof RpsiFluxDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RpsiFluxDto
     */
    maxMajDate: string | null;
}
/**
 * 
 * @export
 * @interface SearchAlienationAutoriteFourriereFluxDto
 */
export interface SearchAlienationAutoriteFourriereFluxDto {
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationAutoriteFourriereFluxDto
     */
    dateAppel: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationAutoriteFourriereFluxDto
     */
    error: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationAutoriteFourriereFluxDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SearchAlienationAutoriteFourriereFluxDto
     */
    nbWarnings: number;
}
/**
 * 
 * @export
 * @interface SearchAlienationAutoriteFourriereWarningDto
 */
export interface SearchAlienationAutoriteFourriereWarningDto {
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationAutoriteFourriereWarningDto
     */
    autoriteFourriereId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationAutoriteFourriereWarningDto
     */
    autoriteFourriereIdCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationAutoriteFourriereWarningDto
     */
    dateAppel: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationAutoriteFourriereWarningDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationAutoriteFourriereWarningDto
     */
    message: string;
}
/**
 * 
 * @export
 * @interface SearchAlienationFourriereFluxDto
 */
export interface SearchAlienationFourriereFluxDto {
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationFourriereFluxDto
     */
    dateAppel: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationFourriereFluxDto
     */
    error: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationFourriereFluxDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SearchAlienationFourriereFluxDto
     */
    nbWarnings: number;
}
/**
 * 
 * @export
 * @interface SearchAlienationFourriereWarningDto
 */
export interface SearchAlienationFourriereWarningDto {
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationFourriereWarningDto
     */
    dateAppel: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationFourriereWarningDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationFourriereWarningDto
     */
    message: string;
}
/**
 * 
 * @export
 * @interface SearchAlienationRecuperationEtatBienFluxDto
 */
export interface SearchAlienationRecuperationEtatBienFluxDto {
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationRecuperationEtatBienFluxDto
     */
    dateAppel: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationRecuperationEtatBienFluxDto
     */
    dateDebut: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationRecuperationEtatBienFluxDto
     */
    dateFin: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationRecuperationEtatBienFluxDto
     */
    error: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationRecuperationEtatBienFluxDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SearchAlienationRecuperationEtatBienFluxDto
     */
    nbWarnings: number;
}
/**
 * 
 * @export
 * @interface SearchAlienationRecuperationEtatBienWarningDto
 */
export interface SearchAlienationRecuperationEtatBienWarningDto {
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationRecuperationEtatBienWarningDto
     */
    alienationId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationRecuperationEtatBienWarningDto
     */
    dateAppel: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationRecuperationEtatBienWarningDto
     */
    dossierId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationRecuperationEtatBienWarningDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SearchAlienationRecuperationEtatBienWarningDto
     */
    message: string;
}
/**
 * 
 * @export
 * @interface SearchAlienationResponseDtoSearchAlienationAutoriteFourriereFluxDto
 */
export interface SearchAlienationResponseDtoSearchAlienationAutoriteFourriereFluxDto {
    /**
     * 
     * @type {Array<SearchAlienationAutoriteFourriereFluxDto>}
     * @memberof SearchAlienationResponseDtoSearchAlienationAutoriteFourriereFluxDto
     */
    flux: Array<SearchAlienationAutoriteFourriereFluxDto>;
    /**
     * 
     * @type {number}
     * @memberof SearchAlienationResponseDtoSearchAlienationAutoriteFourriereFluxDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchAlienationResponseDtoSearchAlienationFourriereFluxDto
 */
export interface SearchAlienationResponseDtoSearchAlienationFourriereFluxDto {
    /**
     * 
     * @type {Array<SearchAlienationFourriereFluxDto>}
     * @memberof SearchAlienationResponseDtoSearchAlienationFourriereFluxDto
     */
    flux: Array<SearchAlienationFourriereFluxDto>;
    /**
     * 
     * @type {number}
     * @memberof SearchAlienationResponseDtoSearchAlienationFourriereFluxDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchAlienationResponseDtoSearchAlienationRecuperationEtatBienFluxDto
 */
export interface SearchAlienationResponseDtoSearchAlienationRecuperationEtatBienFluxDto {
    /**
     * 
     * @type {Array<SearchAlienationRecuperationEtatBienFluxDto>}
     * @memberof SearchAlienationResponseDtoSearchAlienationRecuperationEtatBienFluxDto
     */
    flux: Array<SearchAlienationRecuperationEtatBienFluxDto>;
    /**
     * 
     * @type {number}
     * @memberof SearchAlienationResponseDtoSearchAlienationRecuperationEtatBienFluxDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchAlienationWarningResponseDtoSearchAlienationAutoriteFourriereWarningDto
 */
export interface SearchAlienationWarningResponseDtoSearchAlienationAutoriteFourriereWarningDto {
    /**
     * 
     * @type {number}
     * @memberof SearchAlienationWarningResponseDtoSearchAlienationAutoriteFourriereWarningDto
     */
    total: number;
    /**
     * 
     * @type {Array<SearchAlienationAutoriteFourriereWarningDto>}
     * @memberof SearchAlienationWarningResponseDtoSearchAlienationAutoriteFourriereWarningDto
     */
    warnings: Array<SearchAlienationAutoriteFourriereWarningDto>;
}
/**
 * 
 * @export
 * @interface SearchAlienationWarningResponseDtoSearchAlienationFourriereWarningDto
 */
export interface SearchAlienationWarningResponseDtoSearchAlienationFourriereWarningDto {
    /**
     * 
     * @type {number}
     * @memberof SearchAlienationWarningResponseDtoSearchAlienationFourriereWarningDto
     */
    total: number;
    /**
     * 
     * @type {Array<SearchAlienationFourriereWarningDto>}
     * @memberof SearchAlienationWarningResponseDtoSearchAlienationFourriereWarningDto
     */
    warnings: Array<SearchAlienationFourriereWarningDto>;
}
/**
 * 
 * @export
 * @interface SearchAlienationWarningResponseDtoSearchAlienationRecuperationEtatBienWarningDto
 */
export interface SearchAlienationWarningResponseDtoSearchAlienationRecuperationEtatBienWarningDto {
    /**
     * 
     * @type {number}
     * @memberof SearchAlienationWarningResponseDtoSearchAlienationRecuperationEtatBienWarningDto
     */
    total: number;
    /**
     * 
     * @type {Array<SearchAlienationRecuperationEtatBienWarningDto>}
     * @memberof SearchAlienationWarningResponseDtoSearchAlienationRecuperationEtatBienWarningDto
     */
    warnings: Array<SearchAlienationRecuperationEtatBienWarningDto>;
}
/**
 * 
 * @export
 * @interface SearchAntaiEventWarningResponseDto
 */
export interface SearchAntaiEventWarningResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SearchAntaiEventWarningResponseDto
     */
    total: number;
    /**
     * 
     * @type {Array<AntaiWarningDto>}
     * @memberof SearchAntaiEventWarningResponseDto
     */
    warnings: Array<AntaiWarningDto>;
}
/**
 * 
 * @export
 * @interface SearchAntaiRecuperationEventResponseDto
 */
export interface SearchAntaiRecuperationEventResponseDto {
    /**
     * 
     * @type {Array<AntaiFluxDto>}
     * @memberof SearchAntaiRecuperationEventResponseDto
     */
    flux: Array<AntaiFluxDto>;
    /**
     * 
     * @type {number}
     * @memberof SearchAntaiRecuperationEventResponseDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchCommuneEnlevementResultDto
 */
export interface SearchCommuneEnlevementResultDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchCommuneEnlevementResultDto
     */
    communeList: Array<string>;
}
/**
 * 
 * @export
 * @interface SearchConfigurationResultDto
 */
export interface SearchConfigurationResultDto {
    /**
     * 
     * @type {Array<ConfigurationDto>}
     * @memberof SearchConfigurationResultDto
     */
    configurations: Array<ConfigurationDto>;
    /**
     * 
     * @type {number}
     * @memberof SearchConfigurationResultDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchDossierIdResultDto
 */
export interface SearchDossierIdResultDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDossierIdResultDto
     */
    listDossierId: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SearchDossierIdResultDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchDossiersResponseDto
 */
export interface SearchDossiersResponseDto {
    /**
     * 
     * @type {Array<DossierSummaryResponseDto>}
     * @memberof SearchDossiersResponseDto
     */
    dossiers: Array<DossierSummaryResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof SearchDossiersResponseDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchFluxRpsiResponseDto
 */
export interface SearchFluxRpsiResponseDto {
    /**
     * 
     * @type {Array<RpsiFluxDto>}
     * @memberof SearchFluxRpsiResponseDto
     */
    flux: Array<RpsiFluxDto>;
    /**
     * Nombre total de flux RPSI trouvés
     * @type {number}
     * @memberof SearchFluxRpsiResponseDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchInformationMessageResultDto
 */
export interface SearchInformationMessageResultDto {
    /**
     * 
     * @type {Array<DetailedInformationMessageDto>}
     * @memberof SearchInformationMessageResultDto
     */
    messages: Array<DetailedInformationMessageDto>;
    /**
     * 
     * @type {number}
     * @memberof SearchInformationMessageResultDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SearchUserEventsRequestDto
 */
export interface SearchUserEventsRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SearchUserEventsRequestDto
     */
    dateDebut: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchUserEventsRequestDto
     */
    dateFin: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchUserEventsRequestDto
     */
    operations: Array<SearchUserEventsRequestDtoOperationsEnum> | null;
    /**
     * 
     * @type {number}
     * @memberof SearchUserEventsRequestDto
     */
    page: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchUserEventsRequestDto
     */
    pageSize: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchUserEventsRequestDto
     */
    profils: Array<SearchUserEventsRequestDtoProfilsEnum> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUserEventsRequestDto
     */
    sortByDate: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUserEventsRequestDto
     */
    sortByOperationType: boolean | null;
}

/**
    * @export
    * @enum {string}
    */
export enum SearchUserEventsRequestDtoOperationsEnum {
    'CREATE' = 'CREATE',
    'DELETE' = 'DELETE'
}
/**
    * @export
    * @enum {string}
    */
export enum SearchUserEventsRequestDtoProfilsEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface SearchUserEventsResultDto
 */
export interface SearchUserEventsResultDto {
    /**
     * 
     * @type {Array<UserEventDto>}
     * @memberof SearchUserEventsResultDto
     */
    events: Array<UserEventDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUserEventsResultDto
     */
    hasNextPage: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof SearchUserEventsResultDto
     */
    totalResults: number | null;
}
/**
 * 
 * @export
 * @interface SearchUserResultDto
 */
export interface SearchUserResultDto {
    /**
     * 
     * @type {JacksonCompatiblePageDtoUserDto}
     * @memberof SearchUserResultDto
     */
    pageUsers: JacksonCompatiblePageDtoUserDto | null;
}
/**
 * 
 * @export
 * @interface SortieJusticeSummaryDto
 */
export interface SortieJusticeSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof SortieJusticeSummaryDto
     */
    decision: string | null;
    /**
     * 
     * @type {string}
     * @memberof SortieJusticeSummaryDto
     */
    sortFinal: string | null;
}
/**
 * 
 * @export
 * @interface SortieSummaryDto
 */
export interface SortieSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof SortieSummaryDto
     */
    dateSortie: string | null;
    /**
     * 
     * @type {string}
     * @memberof SortieSummaryDto
     */
    motifSortie: string | null;
    /**
     * 
     * @type {string}
     * @memberof SortieSummaryDto
     */
    statutFacturation: SortieSummaryDtoStatutFacturationEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum SortieSummaryDtoStatutFacturationEnum {
    'TRAITE' = 'TRAITE',
    'NON_TRAITE' = 'NON_TRAITE',
    'NON_CONCERNE' = 'NON_CONCERNE'
}

/**
 * 
 * @export
 * @interface SortieVehiculeRequestDto
 */
export interface SortieVehiculeRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof SortieVehiculeRequestDto
     */
    codeMainLeveeCorrect: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SortieVehiculeRequestDto
     */
    dateSortie: string | null;
    /**
     * Utiliser motifSortieIdCorrelation
     * @type {string}
     * @memberof SortieVehiculeRequestDto
     */
    motifId: string | null;
    /**
     * 
     * @type {string}
     * @memberof SortieVehiculeRequestDto
     */
    motifSortieIdCorrelation: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SortieVehiculeRequestDto
     */
    nomProprietaireCoherent: boolean | null;
}
/**
 * 
 * @export
 * @interface SortieVehiculeResponseDto
 */
export interface SortieVehiculeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SortieVehiculeResponseDto
     */
    dateSaisieSortie: string | null;
    /**
     * 
     * @type {string}
     * @memberof SortieVehiculeResponseDto
     */
    dateSortie: string | null;
    /**
     * 
     * @type {MotifSortieDto}
     * @memberof SortieVehiculeResponseDto
     */
    motifSortie: MotifSortieDto | null;
    /**
     * 
     * @type {string}
     * @memberof SortieVehiculeResponseDto
     */
    statutFacturation: SortieVehiculeResponseDtoStatutFacturationEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum SortieVehiculeResponseDtoStatutFacturationEnum {
    'TRAITE' = 'TRAITE',
    'NON_TRAITE' = 'NON_TRAITE',
    'NON_CONCERNE' = 'NON_CONCERNE'
}

/**
 * 
 * @export
 * @interface SortieVehiculeViolationDto
 */
export interface SortieVehiculeViolationDto {
    /**
     * 
     * @type {string}
     * @memberof SortieVehiculeViolationDto
     */
    formField: SortieVehiculeViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof SortieVehiculeViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof SortieVehiculeViolationDto
     */
    violationCode: SortieVehiculeViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum SortieVehiculeViolationDtoFormFieldEnum {
    'DATE_SORTIE' = 'DATE_SORTIE',
    'MOTIF_SORTIE' = 'MOTIF_SORTIE',
    'NOM_PROPRIETAIRE_COHERENT' = 'NOM_PROPRIETAIRE_COHERENT',
    'CODE_ML_CORRECT' = 'CODE_ML_CORRECT',
    'COMMENT' = 'COMMENT'
}
/**
    * @export
    * @enum {string}
    */
export enum SortieVehiculeViolationDtoViolationCodeEnum {
    'MISSING_DATE_SORTIE' = 'MISSING_DATE_SORTIE',
    'MISSING_COMMENT' = 'MISSING_COMMENT',
    'DATE_SORTIE_BEFORE_DATE_ENTREE' = 'DATE_SORTIE_BEFORE_DATE_ENTREE',
    'DATE_SORTIE_IN_FUTURE' = 'DATE_SORTIE_IN_FUTURE',
    'NO_MODIFICATION' = 'NO_MODIFICATION',
    'INVALID_MOTIF_SORTIE' = 'INVALID_MOTIF_SORTIE',
    'MISSING_MOTIF_SORTIE' = 'MISSING_MOTIF_SORTIE',
    'NOM_PROPRIETAIRE_INCOHERENT' = 'NOM_PROPRIETAIRE_INCOHERENT',
    'CODE_ML_INCORRECT' = 'CODE_ML_INCORRECT'
}

/**
 * 
 * @export
 * @interface SourceImpossibiliteNotifierDto
 */
export interface SourceImpossibiliteNotifierDto {
    /**
     * 
     * @type {string}
     * @memberof SourceImpossibiliteNotifierDto
     */
    code: SourceImpossibiliteNotifierDtoCodeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SourceImpossibiliteNotifierDto
     */
    message: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum SourceImpossibiliteNotifierDtoCodeEnum {
    'NOT_FRANCE' = 'NOT_FRANCE',
    'MISSING_RAISON_SOCIALE_NOM' = 'MISSING_RAISON_SOCIALE_NOM',
    'MISSING_COMMUNE' = 'MISSING_COMMUNE',
    'MISSING_CODE_POSTAL' = 'MISSING_CODE_POSTAL'
}

/**
 * 
 * @export
 * @interface SourcesImpossibiliteNotifierDto
 */
export interface SourcesImpossibiliteNotifierDto {
    /**
     * 
     * @type {Array<SourceImpossibiliteNotifierDto>}
     * @memberof SourcesImpossibiliteNotifierDto
     */
    sources: Array<SourceImpossibiliteNotifierDto>;
}
/**
 * 
 * @export
 * @interface SummaryEventDto
 */
export interface SummaryEventDto {
    /**
     * 
     * @type {string}
     * @memberof SummaryEventDto
     */
    date: string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryEventDto
     */
    details: string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryEventDto
     */
    label: string;
}
/**
 * 
 * @export
 * @interface TraitementResponseDto
 */
export interface TraitementResponseDto {
    /**
     * 
     * @type {AbandonDto}
     * @memberof TraitementResponseDto
     */
    abandon: AbandonDto | null;
    /**
     * 
     * @type {BonEnlevementGardienDto}
     * @memberof TraitementResponseDto
     */
    bonEnlevementGardienData: BonEnlevementGardienDto | null;
    /**
     * 
     * @type {Array<BrancheDto>}
     * @memberof TraitementResponseDto
     */
    branches: Array<BrancheDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TraitementResponseDto
     */
    classement: TraitementResponseDtoClassementEnum | null;
    /**
     * 
     * @type {string}
     * @memberof TraitementResponseDto
     */
    dateMiseAJour: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraitementResponseDto
     */
    dateOrdreDestruction: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraitementResponseDto
     */
    dateProlongationDecisionProcureur: string | null;
    /**
     * 
     * @type {ExpediteurNotificationDto}
     * @memberof TraitementResponseDto
     */
    expediteurNotification: ExpediteurNotificationDto | null;
    /**
     * 
     * @type {ImpossibiliteNotifierDto}
     * @memberof TraitementResponseDto
     */
    impossibiliteNotifier: ImpossibiliteNotifierDto | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TraitementResponseDto
     */
    listStatut: Array<TraitementResponseDtoListStatutEnum> | null;
    /**
     * 
     * @type {MainLeveeDto}
     * @memberof TraitementResponseDto
     */
    mainLevee: MainLeveeDto | null;
    /**
     * 
     * @type {MainleveeUsagerDto}
     * @memberof TraitementResponseDto
     */
    mainLeveeUsager: MainleveeUsagerDto | null;
    /**
     * 
     * @type {NotificationAutomatiqueInfosDto}
     * @memberof TraitementResponseDto
     */
    notificationAutomatique: NotificationAutomatiqueInfosDto | null;
    /**
     * 
     * @type {NotificationManuelleInfosDto}
     * @memberof TraitementResponseDto
     */
    notificationManuelle: NotificationManuelleInfosDto | null;
    /**
     * 
     * @type {string}
     * @memberof TraitementResponseDto
     */
    typeNotification: TraitementResponseDtoTypeNotificationEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum TraitementResponseDtoClassementEnum {
    'ALIENATION' = 'ALIENATION',
    'DESTRUCTION' = 'DESTRUCTION',
    'MANUEL' = 'MANUEL'
}
/**
    * @export
    * @enum {string}
    */
export enum TraitementResponseDtoListStatutEnum {
    'A_REMPLIR' = 'A_REMPLIR',
    'ENREGISTRE' = 'ENREGISTRE',
    'NON_GERE' = 'NON_GERE',
    'NOTIFICATION_ENVOYEE' = 'NOTIFICATION_ENVOYEE',
    'NOTIFIE' = 'NOTIFIE',
    'A_NOTIFIER' = 'A_NOTIFIER',
    'EN_COURS_DE_NOTIFICATION' = 'EN_COURS_DE_NOTIFICATION',
    'A_REMETTRE_AUX_DOMAINES' = 'A_REMETTRE_AUX_DOMAINES',
    'REMIS_AU_DOMAINE' = 'REMIS_AU_DOMAINE',
    'MIS_EN_VENTE' = 'MIS_EN_VENTE',
    'VENDU' = 'VENDU',
    'A_RESTITUER' = 'A_RESTITUER',
    'VENTE_BLOQUEE' = 'VENTE_BLOQUEE',
    'A_DETRUIRE' = 'A_DETRUIRE',
    'SORTI' = 'SORTI',
    'DETRUIT' = 'DETRUIT'
}
/**
    * @export
    * @enum {string}
    */
export enum TraitementResponseDtoTypeNotificationEnum {
    'IMPOSSIBILITE_NOTIFIER' = 'IMPOSSIBILITE_NOTIFIER',
    'NOTIFICATION_AUTOMATIQUE' = 'NOTIFICATION_AUTOMATIQUE',
    'NOTIFICATION_MANUELLE' = 'NOTIFICATION_MANUELLE'
}

/**
 * 
 * @export
 * @interface TraitementSummaryDto
 */
export interface TraitementSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof TraitementSummaryDto
     */
    classement: TraitementSummaryDtoClassementEnum | null;
    /**
     * 
     * @type {string}
     * @memberof TraitementSummaryDto
     */
    dateBonEnlevement: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraitementSummaryDto
     */
    dateMiseAJour: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraitementSummaryDto
     */
    dateOrdreDestruction: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum TraitementSummaryDtoClassementEnum {
    'ALIENATION' = 'ALIENATION',
    'DESTRUCTION' = 'DESTRUCTION',
    'MANUEL' = 'MANUEL'
}

/**
 * 
 * @export
 * @interface TypeAutoriteFourriereDto
 */
export interface TypeAutoriteFourriereDto {
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereDto
     */
    alienationCodeTypologieNiveau1: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereDto
     */
    alienationCodeTypologieNiveau2: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereDto
     */
    displayedText: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereDto
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof TypeAutoriteFourriereDto
     */
    valid: boolean | null;
}
/**
 * 
 * @export
 * @interface TypeAutoriteFourriereRequestDto
 */
export interface TypeAutoriteFourriereRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereRequestDto
     */
    codeTypologieNiveau1: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereRequestDto
     */
    codeTypologieNiveau2: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereRequestDto
     */
    displayedText: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereRequestDto
     */
    type: string | null;
}
/**
 * 
 * @export
 * @interface TypeAutoriteFourriereViolationDto
 */
export interface TypeAutoriteFourriereViolationDto {
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereViolationDto
     */
    formField: TypeAutoriteFourriereViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof TypeAutoriteFourriereViolationDto
     */
    violationCode: TypeAutoriteFourriereViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TypeAutoriteFourriereViolationDtoFormFieldEnum {
    'TYPE' = 'TYPE',
    'LIBELLE_NOTIFICATION' = 'LIBELLE_NOTIFICATION',
    'CODE_TYPOLOGIE_NIVEAU_1' = 'CODE_TYPOLOGIE_NIVEAU_1',
    'CODE_TYPOLOGIE_NIVEAU_2' = 'CODE_TYPOLOGIE_NIVEAU_2'
}
/**
    * @export
    * @enum {string}
    */
export enum TypeAutoriteFourriereViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'TYPE_UNICITY_VIOLATION' = 'TYPE_UNICITY_VIOLATION'
}

/**
 * 
 * @export
 * @interface UniteFOAdminResponseDto
 */
export interface UniteFOAdminResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    abreviation: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    codeInsee: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    ctRattachement: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    idCorrelationParent: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UniteFOAdminResponseDto
     */
    notificationManuelle: boolean;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    rpsiStatus: UniteFOAdminResponseDtoRpsiStatusEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    telephone: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    unite: string;
    /**
     * 
     * @type {boolean}
     * @memberof UniteFOAdminResponseDto
     */
    valid: boolean;
    /**
     * 
     * @type {string}
     * @memberof UniteFOAdminResponseDto
     */
    ville: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UniteFOAdminResponseDtoRpsiStatusEnum {
    'NOUVELLE_UNITE' = 'NOUVELLE_UNITE',
    'A_SUPPRIMER_DOSSIER_ATTACHE' = 'A_SUPPRIMER_DOSSIER_ATTACHE',
    'A_SUPPRIMER_UNITE_PARENT' = 'A_SUPPRIMER_UNITE_PARENT',
    'A_SUPPRIMER_UNITE_PARENT_ET_DOSSIER_ATTACHE' = 'A_SUPPRIMER_UNITE_PARENT_ET_DOSSIER_ATTACHE',
    'MISE_A_JOUR_ERREUR_VALIDATION' = 'MISE_A_JOUR_ERREUR_VALIDATION'
}

/**
 * 
 * @export
 * @interface UniteFOResponseDto
 */
export interface UniteFOResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    abreviation: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    codeInsee: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    ctRattachement: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    idCorrelationParent: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UniteFOResponseDto
     */
    notificationManuelle: boolean;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    telephone: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    unite: string;
    /**
     * 
     * @type {boolean}
     * @memberof UniteFOResponseDto
     */
    valid: boolean;
    /**
     * 
     * @type {string}
     * @memberof UniteFOResponseDto
     */
    ville: string | null;
}
/**
 * 
 * @export
 * @interface UniteFoRequestDto
 */
export interface UniteFoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    abreviation: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    adresse: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    code: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    codeInsee: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    codePostal: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    ctRattachement: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    idCorrelationUniteFoParent: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    telephone: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    type: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    unite: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniteFoRequestDto
     */
    ville: string | null;
}
/**
 * 
 * @export
 * @interface UniteFoViolationDto
 */
export interface UniteFoViolationDto {
    /**
     * 
     * @type {string}
     * @memberof UniteFoViolationDto
     */
    formField: UniteFoViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UniteFoViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UniteFoViolationDto
     */
    violationCode: UniteFoViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UniteFoViolationDtoFormFieldEnum {
    'TYPE' = 'TYPE',
    'CODE' = 'CODE',
    'UNITE' = 'UNITE',
    'ABREVIATION' = 'ABREVIATION',
    'CODE_POSTAL' = 'CODE_POSTAL',
    'EMAIL' = 'EMAIL',
    'TELEPHONE' = 'TELEPHONE',
    'CODE_INSEE' = 'CODE_INSEE',
    'PARENT' = 'PARENT'
}
/**
    * @export
    * @enum {string}
    */
export enum UniteFoViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'MISSING_CODE_INSEE' = 'MISSING_CODE_INSEE',
    'INVALID_UNITE_FO' = 'INVALID_UNITE_FO',
    'UNITE_PARENT_IS_UNITE_FILLE' = 'UNITE_PARENT_IS_UNITE_FILLE',
    'UNITE_IS_UNITE_PARENT' = 'UNITE_IS_UNITE_PARENT',
    'UNITE_PARENT_CANT_BE_ITSELF' = 'UNITE_PARENT_CANT_BE_ITSELF',
    'TYPE_BAD_FORMAT' = 'TYPE_BAD_FORMAT',
    'PHONE_BAD_FORMAT' = 'PHONE_BAD_FORMAT',
    'EMAIL_BAD_FORMAT' = 'EMAIL_BAD_FORMAT',
    'CODE_POSTAL_BAD_FORMAT' = 'CODE_POSTAL_BAD_FORMAT',
    'CODE_ALREADY_USED' = 'CODE_ALREADY_USED',
    'LIBELLE_ALREADY_USED' = 'LIBELLE_ALREADY_USED',
    'ABREVIATION_ALREADY_USED' = 'ABREVIATION_ALREADY_USED'
}

/**
 * 
 * @export
 * @interface UpdateClassementRequestDto
 */
export interface UpdateClassementRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateClassementRequestDto
     */
    justification: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClassementRequestDto
     */
    newClassement: UpdateClassementRequestDtoNewClassementEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateClassementRequestDtoNewClassementEnum {
    'ALIENATION' = 'ALIENATION',
    'DESTRUCTION' = 'DESTRUCTION',
    'MANUEL' = 'MANUEL'
}

/**
 * 
 * @export
 * @interface UpdateClassementViolationDto
 */
export interface UpdateClassementViolationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateClassementViolationDto
     */
    formField: UpdateClassementViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateClassementViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClassementViolationDto
     */
    violationCode: UpdateClassementViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateClassementViolationDtoFormFieldEnum {
    'JUSTIFICATION' = 'JUSTIFICATION',
    'NEW_CLASSEMENT' = 'NEW_CLASSEMENT'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateClassementViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'MISSING_COMMENT' = 'MISSING_COMMENT'
}

/**
 * 
 * @export
 * @interface UpdateCommentaireRequestDto
 */
export interface UpdateCommentaireRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCommentaireRequestDto
     */
    commentaireId: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCommentaireRequestDto
     */
    contenu: string | null;
}
/**
 * 
 * @export
 * @interface UpdateDonneesInterieurVehiculeRequestDto
 */
export interface UpdateDonneesInterieurVehiculeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesInterieurVehiculeRequestDto
     */
    comment: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesInterieurVehiculeRequestDto
     */
    commentProlongationMef: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesInterieurVehiculeRequestDto
     */
    dateProlongationMef: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesInterieurVehiculeRequestDto
     */
    newEtatIdCorrelation: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesInterieurVehiculeRequestDto
     */
    newMotifEntreeIdCorrelation: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDonneesInterieurVehiculeRequestDto
     */
    newPaysEtranger: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesInterieurVehiculeRequestDto
     */
    newPlaqueImmatriculation: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDonneesInterieurVehiculeRequestDto
     */
    newSansPlaque: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateDonneesInterieurVehiculeViolationDto
 */
export interface UpdateDonneesInterieurVehiculeViolationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesInterieurVehiculeViolationDto
     */
    formField: UpdateDonneesInterieurVehiculeViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesInterieurVehiculeViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesInterieurVehiculeViolationDto
     */
    violationCode: UpdateDonneesInterieurVehiculeViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateDonneesInterieurVehiculeViolationDtoFormFieldEnum {
    'NEW_MOTIF_ENTREE_ID_CORRELATION' = 'NEW_MOTIF_ENTREE_ID_CORRELATION',
    'NEW_IS_PAYS_ETRANGER' = 'NEW_IS_PAYS_ETRANGER',
    'NEW_IS_SANS_PLAQUE' = 'NEW_IS_SANS_PLAQUE',
    'NEW_PLAQUE_IMMATRICULATION' = 'NEW_PLAQUE_IMMATRICULATION',
    'NEW_ETAT_ID_CORRELATION' = 'NEW_ETAT_ID_CORRELATION',
    'COMMENT' = 'COMMENT',
    'NEW_DATE_PROLONGATION_MEF' = 'NEW_DATE_PROLONGATION_MEF',
    'COMMENT_PROLONGATION_MEF' = 'COMMENT_PROLONGATION_MEF'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateDonneesInterieurVehiculeViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'NO_MODIFICATION' = 'NO_MODIFICATION',
    'MOTIF_MEF_NOT_FOUND' = 'MOTIF_MEF_NOT_FOUND',
    'ETAT_NOT_FOUND' = 'ETAT_NOT_FOUND',
    'FORBIDDEN_PLAQUE' = 'FORBIDDEN_PLAQUE',
    'BAD_FORMAT_IMMATRICULATION' = 'BAD_FORMAT_IMMATRICULATION',
    'BAD_FORMAT_IDENTIFICATION' = 'BAD_FORMAT_IDENTIFICATION',
    'DATE_DECISION_AFTER_NOW' = 'DATE_DECISION_AFTER_NOW',
    'DATE_DECISION_BEFORE_DATE_ENTREE' = 'DATE_DECISION_BEFORE_DATE_ENTREE'
}

/**
 * 
 * @export
 * @interface UpdateDonneesJudiciairesRequestDto
 */
export interface UpdateDonneesJudiciairesRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesJudiciairesRequestDto
     */
    newIdCorrelationJuridiction: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesJudiciairesRequestDto
     */
    newNumeroIDJ: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesJudiciairesRequestDto
     */
    newNumeroParquet: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesJudiciairesRequestDto
     */
    newNumeroPv: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesJudiciairesRequestDto
     */
    newValeurJuridique: UpdateDonneesJudiciairesRequestDtoNewValeurJuridiqueEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateDonneesJudiciairesRequestDtoNewValeurJuridiqueEnum {
    'PROBATOIRE' = 'PROBATOIRE',
    'CONFISCATOIRE' = 'CONFISCATOIRE'
}

/**
 * 
 * @export
 * @interface UpdateDonneesJudiciairesViolationDto
 */
export interface UpdateDonneesJudiciairesViolationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesJudiciairesViolationDto
     */
    formField: UpdateDonneesJudiciairesViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesJudiciairesViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonneesJudiciairesViolationDto
     */
    violationCode: UpdateDonneesJudiciairesViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateDonneesJudiciairesViolationDtoFormFieldEnum {
    'NEW_ID_CORRELATION_JURIDICTION' = 'NEW_ID_CORRELATION_JURIDICTION',
    'NEW_NUMERO_PARQUET' = 'NEW_NUMERO_PARQUET',
    'NEW_NUMERO_PV' = 'NEW_NUMERO_PV',
    'NEW_NUMERO_IDJ' = 'NEW_NUMERO_IDJ',
    'NEW_VALEUR_JURIDIQUE' = 'NEW_VALEUR_JURIDIQUE'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateDonneesJudiciairesViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'NO_MODIFICATION' = 'NO_MODIFICATION',
    'JURIDICTION_NOT_FOUND' = 'JURIDICTION_NOT_FOUND',
    'INVALID_JURIDICTION' = 'INVALID_JURIDICTION'
}

/**
 * 
 * @export
 * @interface UpdateEntitesRattachementRequestDto
 */
export interface UpdateEntitesRattachementRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEntitesRattachementRequestDto
     */
    comment: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEntitesRattachementRequestDto
     */
    newAutoriteFourriereIdCorrelation: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEntitesRattachementRequestDto
     */
    newFourriereIdCorrelation: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEntitesRattachementRequestDto
     */
    newUniteFoIdCorrelation: string | null;
}
/**
 * 
 * @export
 * @interface UpdateEntitesRattachementViolationDto
 */
export interface UpdateEntitesRattachementViolationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEntitesRattachementViolationDto
     */
    formField: UpdateEntitesRattachementViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEntitesRattachementViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEntitesRattachementViolationDto
     */
    violationCode: UpdateEntitesRattachementViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateEntitesRattachementViolationDtoFormFieldEnum {
    'NEW_FOURRIERE_CORRELATION_ID' = 'NEW_FOURRIERE_CORRELATION_ID',
    'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' = 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID',
    'NEW_UNITE_FO_CORRELATION_ID' = 'NEW_UNITE_FO_CORRELATION_ID',
    'COMMENT' = 'COMMENT'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateEntitesRattachementViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'INVALID_FOURRIERE' = 'INVALID_FOURRIERE',
    'FOURRIERE_NOT_FOUND' = 'FOURRIERE_NOT_FOUND',
    'INVALID_AF' = 'INVALID_AF',
    'AF_NOT_FOUND' = 'AF_NOT_FOUND',
    'INVALID_UNITE_FO' = 'INVALID_UNITE_FO',
    'UNITE_FO_NOT_FOUND' = 'UNITE_FO_NOT_FOUND',
    'NO_MODIFICATION' = 'NO_MODIFICATION'
}

/**
 * 
 * @export
 * @interface UpdateMainLeveeRequestDto
 */
export interface UpdateMainLeveeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    codePostalProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    communeAdresseProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    communeFonctionAgent: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    communeRedaction: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    dateDebutPermissionProvisoire: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    dateFinPermissionProvisoire: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    dateProcesVerbal: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    gradeAgent: UpdateMainLeveeRequestDtoGradeAgentEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    idCorrelationFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    idCorrelationGenreSimplifie: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    idMarque: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    immatriculation: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMainLeveeRequestDto
     */
    interdictionCirculer: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    justificationSortie: UpdateMainLeveeRequestDtoJustificationSortieEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    lieuAdresseProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    matriculeAgent: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    motifInterdictionCirculer: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    nomAgent: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    nomProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    numProcesVerbal: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    prenomProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    raisonSocialeSocieteRemorquage: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    rsProprietaire: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    siretSocieteRemorquage: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMainLeveeRequestDto
     */
    typeRestitution: UpdateMainLeveeRequestDtoTypeRestitutionEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateMainLeveeRequestDtoGradeAgentEnum {
    'APJA' = 'APJA',
    'APJ' = 'APJ',
    'OPJ' = 'OPJ'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateMainLeveeRequestDtoJustificationSortieEnum {
    'VERIFICATIONS_NON_USAGE_STUPEFIANTS' = 'VERIFICATIONS_NON_USAGE_STUPEFIANTS',
    'VOL' = 'VOL',
    'LOCATION_TITRE_ONEREUX_A_UN_TIERS' = 'LOCATION_TITRE_ONEREUX_A_UN_TIERS',
    'DECISION_APRES_CONTESTATION_PROCUREUR_OU_PREFET' = 'DECISION_APRES_CONTESTATION_PROCUREUR_OU_PREFET'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateMainLeveeRequestDtoTypeRestitutionEnum {
    'ASSURANCE_PERMIS' = 'ASSURANCE_PERMIS',
    'ASSURANCE_REMORQUE' = 'ASSURANCE_REMORQUE'
}

/**
 * 
 * @export
 * @interface UpdateSortieVehiculeRequestDto
 */
export interface UpdateSortieVehiculeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSortieVehiculeRequestDto
     */
    comment: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSortieVehiculeRequestDto
     */
    dateSortie: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSortieVehiculeRequestDto
     */
    motifId: string | null;
}
/**
 * 
 * @export
 * @interface UpdateUserRequestDto
 */
export interface UpdateUserRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserRequestDto
     */
    actif: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequestDto
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequestDto
     */
    entiteRattachement: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequestDto
     */
    firstName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserRequestDto
     */
    gestionnaireLocal: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequestDto
     */
    lastName: string | null;
}
/**
 * 
 * @export
 * @interface UpdateViolationDto
 */
export interface UpdateViolationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateViolationDto
     */
    formField: UpdateViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateViolationDto
     */
    violationCode: UpdateViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateViolationDtoFormFieldEnum {
    'FIRSTNAME' = 'FIRSTNAME',
    'LASTNAME' = 'LASTNAME',
    'EMAIL' = 'EMAIL',
    'UNITE_RATTACHEMENT' = 'UNITE_RATTACHEMENT',
    'ACTIF' = 'ACTIF'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'BAD_FORMAT_EMAIL' = 'BAD_FORMAT_EMAIL',
    'INVALID_ENTITE_RATTACHEMENT' = 'INVALID_ENTITE_RATTACHEMENT'
}

/**
 * 
 * @export
 * @interface UploadApurementDossiersFileViolationsDto
 */
export interface UploadApurementDossiersFileViolationsDto {
    /**
     * 
     * @type {Array<UploadApurementDossiersViolationDto>}
     * @memberof UploadApurementDossiersFileViolationsDto
     */
    uploadApurementDossiersViolationDtos: Array<UploadApurementDossiersViolationDto>;
}
/**
 * 
 * @export
 * @interface UploadApurementDossiersViolationDto
 */
export interface UploadApurementDossiersViolationDto {
    /**
     * 
     * @type {string}
     * @memberof UploadApurementDossiersViolationDto
     */
    formField: UploadApurementDossiersViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadApurementDossiersViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UploadApurementDossiersViolationDto
     */
    violationCode: UploadApurementDossiersViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UploadApurementDossiersViolationDtoFormFieldEnum {
    'FILE' = 'FILE'
}
/**
    * @export
    * @enum {string}
    */
export enum UploadApurementDossiersViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'FILE_IS_NOT_CSV' = 'FILE_IS_NOT_CSV'
}

/**
 * 
 * @export
 * @interface UploadDocumentSpecifiqueFileViolationsDto
 */
export interface UploadDocumentSpecifiqueFileViolationsDto {
    /**
     * 
     * @type {Array<UploadDocumentSpecifiqueViolationDto>}
     * @memberof UploadDocumentSpecifiqueFileViolationsDto
     */
    uploadDocumentSpecifiqueViolationDtoList: Array<UploadDocumentSpecifiqueViolationDto> | null;
}
/**
 * 
 * @export
 * @interface UploadDocumentSpecifiqueViolationDto
 */
export interface UploadDocumentSpecifiqueViolationDto {
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentSpecifiqueViolationDto
     */
    formField: UploadDocumentSpecifiqueViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentSpecifiqueViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentSpecifiqueViolationDto
     */
    violationCode: UploadDocumentSpecifiqueViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UploadDocumentSpecifiqueViolationDtoFormFieldEnum {
    'NAME' = 'NAME',
    'TYPE_DESTINATAIRE' = 'TYPE_DESTINATAIRE',
    'FILE' = 'FILE'
}
/**
    * @export
    * @enum {string}
    */
export enum UploadDocumentSpecifiqueViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'BAD_FILE_CONTENT_TYPE' = 'BAD_FILE_CONTENT_TYPE',
    'FILE_TOO_LARGE' = 'FILE_TOO_LARGE',
    'NAME_ALREADY_EXISTS' = 'NAME_ALREADY_EXISTS'
}

/**
 * 
 * @export
 * @interface UploadPieceJointeFileViolationsDto
 */
export interface UploadPieceJointeFileViolationsDto {
    /**
     * 
     * @type {Array<UploadPieceJointeViolationDto>}
     * @memberof UploadPieceJointeFileViolationsDto
     */
    uploadPieceJointeViolationDtoList: Array<UploadPieceJointeViolationDto> | null;
}
/**
 * 
 * @export
 * @interface UploadPieceJointeViolationDto
 */
export interface UploadPieceJointeViolationDto {
    /**
     * 
     * @type {string}
     * @memberof UploadPieceJointeViolationDto
     */
    formField: UploadPieceJointeViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadPieceJointeViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UploadPieceJointeViolationDto
     */
    violationCode: UploadPieceJointeViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UploadPieceJointeViolationDtoFormFieldEnum {
    'TYPE' = 'TYPE',
    'FILE' = 'FILE'
}
/**
    * @export
    * @enum {string}
    */
export enum UploadPieceJointeViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD',
    'TYPE_ALREADY_EXIST' = 'TYPE_ALREADY_EXIST',
    'BAD_TYPE' = 'BAD_TYPE',
    'FILE_TOO_LARGE' = 'FILE_TOO_LARGE',
    'BAD_FILE_CONTENT_TYPE' = 'BAD_FILE_CONTENT_TYPE'
}

/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    ableToWrite: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    email: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    enabled: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    firstName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    gestionnaireLocal: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    idCorrelationAutoriteFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    idCorrelationFourriere: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    idCorrelationJuridiction: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    idCorrelationUniteFO: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    idCorrelationUniteFineFO: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    libelleEntiteRattachement: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    passage2UniteFOLibelle: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    passage2UniteFoCodeUnite: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    passage2UniteFoTypeOrganisation: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    profile: UserDtoProfileEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    typeUniteFo: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    uniteFOCommuneFonction: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    username: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserDtoProfileEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface UserEventDto
 */
export interface UserEventDto {
    /**
     * 
     * @type {string}
     * @memberof UserEventDto
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof UserEventDto
     */
    libelleEntiteRattachement: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEventDto
     */
    operationType: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEventDto
     */
    profile: UserEventDtoProfileEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UserEventDtoProfileEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface UserViolationsDto
 */
export interface UserViolationsDto {
    /**
     * 
     * @type {Array<CreateViolationDto>}
     * @memberof UserViolationsDto
     */
    createUserViolations: Array<CreateViolationDto> | null;
    /**
     * 
     * @type {Array<UpdateViolationDto>}
     * @memberof UserViolationsDto
     */
    updateUserViolations: Array<UpdateViolationDto> | null;
}
/**
 * 
 * @export
 * @interface Vehicule
 */
export interface Vehicule {
    /**
     * 
     * @type {string}
     * @memberof Vehicule
     */
    idCorrelationGenreSimplifie: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicule
     */
    idMarque: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicule
     */
    immatriculation: string | null;
}
/**
 * 
 * @export
 * @interface VerrouillageDto
 */
export interface VerrouillageDto {
    /**
     * 
     * @type {boolean}
     * @memberof VerrouillageDto
     */
    coffres: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VerrouillageDto
     */
    portes: boolean | null;
}
/**
 * 
 * @export
 * @interface VersionDto
 */
export interface VersionDto {
    /**
     * 
     * @type {Array<GitInfoDto>}
     * @memberof VersionDto
     */
    gitInfos: Array<GitInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof VersionDto
     */
    version: string;
}
/**
 * 
 * @export
 * @interface VideoTutorielDto
 */
export interface VideoTutorielDto {
    /**
     * 
     * @type {string}
     * @memberof VideoTutorielDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VideoTutorielDto
     */
    idCorrelation: string;
    /**
     * 
     * @type {string}
     * @memberof VideoTutorielDto
     */
    profile: VideoTutorielDtoProfileEnum;
    /**
     * 
     * @type {boolean}
     * @memberof VideoTutorielDto
     */
    valid: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VideoTutorielDto
     */
    videoId: string;
}

/**
    * @export
    * @enum {string}
    */
export enum VideoTutorielDtoProfileEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface VideoTutorielRequestDto
 */
export interface VideoTutorielRequestDto {
    /**
     * 
     * @type {string}
     * @memberof VideoTutorielRequestDto
     */
    profile: VideoTutorielRequestDtoProfileEnum | null;
    /**
     * 
     * @type {string}
     * @memberof VideoTutorielRequestDto
     */
    videoId: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum VideoTutorielRequestDtoProfileEnum {
    'ADMIN_FONCTIONNEL' = 'ADMIN_FONCTIONNEL',
    'FORCE_DE_L_ORDRE' = 'FORCE_DE_L_ORDRE',
    'GARDIEN_FOURRIERE' = 'GARDIEN_FOURRIERE',
    'AUTORITE_FOURRIERE' = 'AUTORITE_FOURRIERE',
    'DSR_BLR' = 'DSR_BLR',
    'CSU' = 'CSU',
    'TRIBUNAL_JUDICIAIRE' = 'TRIBUNAL_JUDICIAIRE',
    'COUR_APPEL' = 'COUR_APPEL',
    'UNITE_OPERATIONNELLE' = 'UNITE_OPERATIONNELLE',
    'NATIONAL_JUSTICE' = 'NATIONAL_JUSTICE'
}

/**
 * 
 * @export
 * @interface VideoTutorielViolationDto
 */
export interface VideoTutorielViolationDto {
    /**
     * 
     * @type {string}
     * @memberof VideoTutorielViolationDto
     */
    formField: VideoTutorielViolationDtoFormFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof VideoTutorielViolationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof VideoTutorielViolationDto
     */
    violationCode: VideoTutorielViolationDtoViolationCodeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum VideoTutorielViolationDtoFormFieldEnum {
    'VIDEO_ID' = 'VIDEO_ID',
    'PROFILE' = 'PROFILE'
}
/**
    * @export
    * @enum {string}
    */
export enum VideoTutorielViolationDtoViolationCodeEnum {
    'MISSING_FIELD' = 'MISSING_FIELD'
}


//////////////////////////////////// AdminFonctionnelControllerApi /////////////////////////////////////////////////////

/**
 * objet contenant les query params de la route countConfigurationsWithSpecsUsingGET
 * @export
 * @interface CountConfigurationsWithSpecsUsingGETQueryParams
 */
export interface CountConfigurationsWithSpecsUsingGETQueryParams {
    /**
     * 
     * @type {string}
     * @memberof CountConfigurationsWithSpecsUsingGETQueryParams
     */
    fullNameOrDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CountConfigurationsWithSpecsUsingGETQueryParams
     */
    hasError?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CountConfigurationsWithSpecsUsingGETQueryParams
     */
    microServiceName?: string;
    /**
     * 
     * @type {number}
     * @memberof CountConfigurationsWithSpecsUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CountConfigurationsWithSpecsUsingGETQueryParams
     */
    pageSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CountConfigurationsWithSpecsUsingGETQueryParams
     */
    sortByMicroServiceName?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CountConfigurationsWithSpecsUsingGETQueryParams
     */
    value?: string;
}

/**
 * objet contenant les query params de la route etatUsingGET
 * @export
 * @interface EtatUsingGETQueryParams
 */
export interface EtatUsingGETQueryParams {
    /**
     * 
     * @type {string}
     * @memberof EtatUsingGETQueryParams
     */
    codeInsee?: string;
    /**
     * 
     * @type {string}
     * @memberof EtatUsingGETQueryParams
     */
    idCorrelationUniteFo?: string;
    /**
     * 
     * @type {string}
     * @memberof EtatUsingGETQueryParams
     */
    typeUniteFo?: string;
}

/**
 * objet contenant les query params de la route searchConfigurationsWithSpecsUsingGET
 * @export
 * @interface SearchConfigurationsWithSpecsUsingGETQueryParams
 */
export interface SearchConfigurationsWithSpecsUsingGETQueryParams {
    /**
     * 
     * @type {string}
     * @memberof SearchConfigurationsWithSpecsUsingGETQueryParams
     */
    fullNameOrDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchConfigurationsWithSpecsUsingGETQueryParams
     */
    hasError?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchConfigurationsWithSpecsUsingGETQueryParams
     */
    microServiceName?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchConfigurationsWithSpecsUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchConfigurationsWithSpecsUsingGETQueryParams
     */
    pageSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SearchConfigurationsWithSpecsUsingGETQueryParams
     */
    sortByMicroServiceName?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchConfigurationsWithSpecsUsingGETQueryParams
     */
    value?: string;
}

/**
 * objet contenant les query params de la route searchEtatUsingSpecsUsingGET
 * @export
 * @interface SearchEtatUsingSpecsUsingGETQueryParams
 */
export interface SearchEtatUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchEtatUsingSpecsUsingGETQueryParams
     * @type {SearchEtatUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchEtatUsingSpecsUsingGETQueryParams
     */
    filters: SearchEtatUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchEtatUsingSpecsUsingGETQueryParams
     * @type {SearchEtatUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchEtatUsingSpecsUsingGETQueryParams
     */
    sorts: SearchEtatUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchEtatUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchEtatUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchEtatUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchEtatUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchEtatUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

export interface SearchEtatUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchEtatUsingSpecsUsingGETQueryParamsSorts
    */
    etat?: boolean;
}

/**
 * objet contenant les query params de la route searchFaqDomainUsingSpecsUsingGET
 * @export
 * @interface SearchFaqDomainUsingSpecsUsingGETQueryParams
 */
export interface SearchFaqDomainUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchFaqDomainUsingSpecsUsingGETQueryParams
     * @type {SearchFaqDomainUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchFaqDomainUsingSpecsUsingGETQueryParams
     */
    filters: SearchFaqDomainUsingSpecsUsingGETQueryParamsFilters;
}

export interface SearchFaqDomainUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFaqDomainUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFaqDomainUsingSpecsUsingGETQueryParamsFilters
    */
    name?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchFaqDomainUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchFaqDomainUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFaqDomainUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

/**
 * objet contenant les query params de la route searchFaqUsingSpecsUsingGET
 * @export
 * @interface SearchFaqUsingSpecsUsingGETQueryParams
 */
export interface SearchFaqUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchFaqUsingSpecsUsingGETQueryParams
     * @type {SearchFaqUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchFaqUsingSpecsUsingGETQueryParams
     */
    filters: SearchFaqUsingSpecsUsingGETQueryParamsFilters;
}

export interface SearchFaqUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFaqUsingSpecsUsingGETQueryParamsFilters
    */
    domainId?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFaqUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchFaqUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchFaqUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFaqUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

/**
 * objet contenant les query params de la route searchFluxAutoriteFourriereUsingGET
 * @export
 * @interface SearchFluxAutoriteFourriereUsingGETQueryParams
 */
export interface SearchFluxAutoriteFourriereUsingGETQueryParams {
    /**
     * 
     * @type {number}
     * @memberof SearchFluxAutoriteFourriereUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchFluxAutoriteFourriereUsingGETQueryParams
     */
    pageSize?: number;
    /**
     * objet contenant les sortDto de SearchFluxAutoriteFourriereUsingGETQueryParams
     * @type {SearchFluxAutoriteFourriereUsingGETQueryParamsSortDto}
     * @memberof SearchFluxAutoriteFourriereUsingGETQueryParams
     */
    sortDto: SearchFluxAutoriteFourriereUsingGETQueryParamsSortDto;
}

export interface SearchFluxAutoriteFourriereUsingGETQueryParamsSortDto {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFluxAutoriteFourriereUsingGETQueryParamsSortDto
    */
    dateAppel?: boolean;
}

/**
 * objet contenant les query params de la route searchFluxEtatBienUsingGET
 * @export
 * @interface SearchFluxEtatBienUsingGETQueryParams
 */
export interface SearchFluxEtatBienUsingGETQueryParams {
    /**
     * 
     * @type {number}
     * @memberof SearchFluxEtatBienUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchFluxEtatBienUsingGETQueryParams
     */
    pageSize?: number;
    /**
     * objet contenant les sortDto de SearchFluxEtatBienUsingGETQueryParams
     * @type {SearchFluxEtatBienUsingGETQueryParamsSortDto}
     * @memberof SearchFluxEtatBienUsingGETQueryParams
     */
    sortDto: SearchFluxEtatBienUsingGETQueryParamsSortDto;
}

export interface SearchFluxEtatBienUsingGETQueryParamsSortDto {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFluxEtatBienUsingGETQueryParamsSortDto
    */
    dateAppel?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFluxEtatBienUsingGETQueryParamsSortDto
    */
    dateDebut?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFluxEtatBienUsingGETQueryParamsSortDto
    */
    dateFin?: boolean;
}

/**
 * objet contenant les query params de la route searchFluxFourriereUsingGET
 * @export
 * @interface SearchFluxFourriereUsingGETQueryParams
 */
export interface SearchFluxFourriereUsingGETQueryParams {
    /**
     * 
     * @type {number}
     * @memberof SearchFluxFourriereUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchFluxFourriereUsingGETQueryParams
     */
    pageSize?: number;
    /**
     * objet contenant les sortDto de SearchFluxFourriereUsingGETQueryParams
     * @type {SearchFluxFourriereUsingGETQueryParamsSortDto}
     * @memberof SearchFluxFourriereUsingGETQueryParams
     */
    sortDto: SearchFluxFourriereUsingGETQueryParamsSortDto;
}

export interface SearchFluxFourriereUsingGETQueryParamsSortDto {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFluxFourriereUsingGETQueryParamsSortDto
    */
    dateAppel?: boolean;
}

/**
 * objet contenant les query params de la route searchFluxRpsiUsingGET
 * @export
 * @interface SearchFluxRpsiUsingGETQueryParams
 */
export interface SearchFluxRpsiUsingGETQueryParams {
    /**
     * 
     * @type {number}
     * @memberof SearchFluxRpsiUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchFluxRpsiUsingGETQueryParams
     */
    pageSize?: number;
    /**
     * objet contenant les sortDto de SearchFluxRpsiUsingGETQueryParams
     * @type {SearchFluxRpsiUsingGETQueryParamsSortDto}
     * @memberof SearchFluxRpsiUsingGETQueryParams
     */
    sortDto: SearchFluxRpsiUsingGETQueryParamsSortDto;
}

export interface SearchFluxRpsiUsingGETQueryParamsSortDto {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFluxRpsiUsingGETQueryParamsSortDto
    */
    dateAppel?: boolean;
}

/**
 * objet contenant les query params de la route searchFluxUsingGET
 * @export
 * @interface SearchFluxUsingGETQueryParams
 */
export interface SearchFluxUsingGETQueryParams {
    /**
     * 
     * @type {number}
     * @memberof SearchFluxUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchFluxUsingGETQueryParams
     */
    pageSize?: number;
    /**
     * objet contenant les sortDto de SearchFluxUsingGETQueryParams
     * @type {SearchFluxUsingGETQueryParamsSortDto}
     * @memberof SearchFluxUsingGETQueryParams
     */
    sortDto: SearchFluxUsingGETQueryParamsSortDto;
}

export interface SearchFluxUsingGETQueryParamsSortDto {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFluxUsingGETQueryParamsSortDto
    */
    dateDebut?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFluxUsingGETQueryParamsSortDto
    */
    indexDebut?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFluxUsingGETQueryParamsSortDto
    */
    indexFin?: boolean;
}

/**
 * objet contenant les query params de la route searchFooterLinkUsingSpecsUsingGET
 * @export
 * @interface SearchFooterLinkUsingSpecsUsingGETQueryParams
 */
export interface SearchFooterLinkUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchFooterLinkUsingSpecsUsingGETQueryParams
     * @type {SearchFooterLinkUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchFooterLinkUsingSpecsUsingGETQueryParams
     */
    filters: SearchFooterLinkUsingSpecsUsingGETQueryParamsFilters;
}

export interface SearchFooterLinkUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFooterLinkUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchFooterLinkUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchFooterLinkUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFooterLinkUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

/**
 * objet contenant les query params de la route searchGenreSimplifieUsingSpecsUsingGET
 * @export
 * @interface SearchGenreSimplifieUsingSpecsUsingGETQueryParams
 */
export interface SearchGenreSimplifieUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchGenreSimplifieUsingSpecsUsingGETQueryParams
     * @type {SearchGenreSimplifieUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchGenreSimplifieUsingSpecsUsingGETQueryParams
     */
    filters: SearchGenreSimplifieUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchGenreSimplifieUsingSpecsUsingGETQueryParams
     * @type {SearchGenreSimplifieUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchGenreSimplifieUsingSpecsUsingGETQueryParams
     */
    sorts: SearchGenreSimplifieUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchGenreSimplifieUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchGenreSimplifieUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchGenreSimplifieUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchGenreSimplifieUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchGenreSimplifieUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

export interface SearchGenreSimplifieUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchGenreSimplifieUsingSpecsUsingGETQueryParamsSorts
    */
    libelle?: boolean;
}

/**
 * objet contenant les query params de la route searchMotifSortieUsingSpecsUsingGET
 * @export
 * @interface SearchMotifSortieUsingSpecsUsingGETQueryParams
 */
export interface SearchMotifSortieUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchMotifSortieUsingSpecsUsingGETQueryParams
     * @type {SearchMotifSortieUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchMotifSortieUsingSpecsUsingGETQueryParams
     */
    filters: SearchMotifSortieUsingSpecsUsingGETQueryParamsFilters;
}

export interface SearchMotifSortieUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchMotifSortieUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchMotifSortieUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchMotifSortieUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMotifSortieUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

/**
 * objet contenant les query params de la route searchTypeAfUsingSpecsUsingGET
 * @export
 * @interface SearchTypeAfUsingSpecsUsingGETQueryParams
 */
export interface SearchTypeAfUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchTypeAfUsingSpecsUsingGETQueryParams
     * @type {SearchTypeAfUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchTypeAfUsingSpecsUsingGETQueryParams
     */
    filters: SearchTypeAfUsingSpecsUsingGETQueryParamsFilters;
}

export interface SearchTypeAfUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchTypeAfUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchTypeAfUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchTypeAfUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchTypeAfUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

/**
 * objet contenant les query params de la route searchVideoTutorielUsingSpecsUsingGET
 * @export
 * @interface SearchVideoTutorielUsingSpecsUsingGETQueryParams
 */
export interface SearchVideoTutorielUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchVideoTutorielUsingSpecsUsingGETQueryParams
     * @type {SearchVideoTutorielUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchVideoTutorielUsingSpecsUsingGETQueryParams
     */
    filters: SearchVideoTutorielUsingSpecsUsingGETQueryParamsFilters;
}

export interface SearchVideoTutorielUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchVideoTutorielUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchVideoTutorielUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchVideoTutorielUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchVideoTutorielUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

/**
 * objet contenant les query params de la route searchWarningsFluxAutoriteFourriereUsingGET
 * @export
 * @interface SearchWarningsFluxAutoriteFourriereUsingGETQueryParams
 */
export interface SearchWarningsFluxAutoriteFourriereUsingGETQueryParams {
    /**
     * 
     * @type {number}
     * @memberof SearchWarningsFluxAutoriteFourriereUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchWarningsFluxAutoriteFourriereUsingGETQueryParams
     */
    pageSize?: number;
}

/**
 * objet contenant les query params de la route searchWarningsFluxFourriereUsingGET
 * @export
 * @interface SearchWarningsFluxFourriereUsingGETQueryParams
 */
export interface SearchWarningsFluxFourriereUsingGETQueryParams {
    /**
     * 
     * @type {number}
     * @memberof SearchWarningsFluxFourriereUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchWarningsFluxFourriereUsingGETQueryParams
     */
    pageSize?: number;
}

/**
 * objet contenant les query params de la route searchWarningsOfFluxEtatBienUsingGET
 * @export
 * @interface SearchWarningsOfFluxEtatBienUsingGETQueryParams
 */
export interface SearchWarningsOfFluxEtatBienUsingGETQueryParams {
    /**
     * 
     * @type {number}
     * @memberof SearchWarningsOfFluxEtatBienUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchWarningsOfFluxEtatBienUsingGETQueryParams
     */
    pageSize?: number;
}

/**
 * objet contenant les query params de la route uploadDocumentSpecifiqueUsingPOST
 * @export
 * @interface UploadDocumentSpecifiqueUsingPOSTQueryParams
 */
export interface UploadDocumentSpecifiqueUsingPOSTQueryParams {
    /**
     * 
     * @type {string}
     * @memberof UploadDocumentSpecifiqueUsingPOSTQueryParams
     */
    nomDocument: string;
    /**
     * 
     * @type {Array<'GF' | 'AF' | 'PM' | 'GN' | 'PN' | 'PP'>}
     * @memberof UploadDocumentSpecifiqueUsingPOSTQueryParams
     */
    utilisateursDestinataires: Array<'GF' | 'AF' | 'PM' | 'GN' | 'PN' | 'PP'>;
}

/**
 * objet contenant les query params de la route validateUploadDocumentSpecifiqueFieldUsingPOST
 * @export
 * @interface ValidateUploadDocumentSpecifiqueFieldUsingPOSTQueryParams
 */
export interface ValidateUploadDocumentSpecifiqueFieldUsingPOSTQueryParams {
    /**
     * 
     * @type {string}
     * @memberof ValidateUploadDocumentSpecifiqueFieldUsingPOSTQueryParams
     */
    nomDocument: string;
    /**
     * 
     * @type {Array<'GF' | 'AF' | 'PM' | 'GN' | 'PN' | 'PP'>}
     * @memberof ValidateUploadDocumentSpecifiqueFieldUsingPOSTQueryParams
     */
    utilisateursDestinataires: Array<'GF' | 'AF' | 'PM' | 'GN' | 'PN' | 'PP'>;
}

/**
 * objet contenant les query params de la route validateUploadDocumentSpecifiqueUsingPOST
 * @export
 * @interface ValidateUploadDocumentSpecifiqueUsingPOSTQueryParams
 */
export interface ValidateUploadDocumentSpecifiqueUsingPOSTQueryParams {
    /**
     * 
     * @type {string}
     * @memberof ValidateUploadDocumentSpecifiqueUsingPOSTQueryParams
     */
    nomDocument: string;
    /**
     * 
     * @type {Array<'GF' | 'AF' | 'PM' | 'GN' | 'PN' | 'PP'>}
     * @memberof ValidateUploadDocumentSpecifiqueUsingPOSTQueryParams
     */
    utilisateursDestinataires: Array<'GF' | 'AF' | 'PM' | 'GN' | 'PN' | 'PP'>;
}

/**
 * objet contenant les query params de la route warningsOfFluxUsingGET
 * @export
 * @interface WarningsOfFluxUsingGETQueryParams
 */
export interface WarningsOfFluxUsingGETQueryParams {
    /**
     * 
     * @type {number}
     * @memberof WarningsOfFluxUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof WarningsOfFluxUsingGETQueryParams
     */
    pageSize?: number;
}

/**
 * AdminFonctionnelControllerApi - fetch parameter creator
 * @export
 */
export const AdminFonctionnelControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant à l\'admin fonctionnel d\'annuler la sortie d\'un véhicule
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annulationSortieVehiculeUsingPUT(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling annulationSortieVehiculeUsingPUT.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/annulation-sortie`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les positions des domaines faq
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFaqDomainPositionUsingPOST(requestBody: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling changeFaqDomainPositionUsingPOST.');
            }
            const localVarPath = `/api/referentiel/faq-domain/position`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;string&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(requestBody || {}) : (requestBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les positions des questions
         * @param {string} domainId id du domaine des questions
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFaqPositionUsingPOST(domainId: string, requestBody: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'domainId' is not null or undefined
            if (domainId === null || domainId === undefined) {
                throw new RequiredError('domainId','Required parameter domainId was null or undefined when calling changeFaqPositionUsingPOST.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling changeFaqPositionUsingPOST.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions/{domainId}/position`
                .replace(`{${"domainId"}}`, encodeURIComponent(String(domainId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;string&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(requestBody || {}) : (requestBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une autorité de fourrière peut être réactivée
         * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationAutoriteFourriereUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationAutoriteFourriereUsingGET.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un centre vhu peut être réactivée
         * @param {string} idCorrelation Identifiant du centre vhu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationCentreVhuUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationCentreVhuUsingGET.');
            }
            const localVarPath = `/api/referentiel/centre-vhu/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un état peut être réactivé
         * @param {string} idCorrelation Identifiant de l\'état
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationEtatUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationEtatUsingGET.');
            }
            const localVarPath = `/api/referentiel/etat/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un domaine faq peut être réactivée
         * @param {string} idCorrelation Identifiant du domaine faq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationFaqDomainUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationFaqDomainUsingGET.');
            }
            const localVarPath = `/api/referentiel/faq-domain/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une question peut être réactivée
         * @param {string} idCorrelation Identifiant de la question
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationFaqUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationFaqUsingGET.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un lien peut être réactivé
         * @param {string} idCorrelation Identifiant du lien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationFooterLinkUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationFooterLinkUsingGET.');
            }
            const localVarPath = `/api/referentiel/footer-link/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une  fourrière peut être réactivée
         * @param {string} idCorrelation Identifiant de la fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationFourriereUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationFourriereUsingGET.');
            }
            const localVarPath = `/api/referentiel/fourriere/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un genre simplifié peut être réactivé
         * @param {string} idCorrelation Identifiant du genre simplifié
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationGenreSimplifieUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationGenreSimplifieUsingGET.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une juridiction peut être réactivée
         * @param {string} idCorrelation Identifiant de la juridiction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationJuridictionUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationJuridictionUsingGET.');
            }
            const localVarPath = `/api/referentiel/juridiction/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un motif de MEF peut être réactivé
         * @param {string} idCorrelation Identifiant du motif de MEF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationMotifMefUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationMotifMefUsingGET.');
            }
            const localVarPath = `/api/referentiel/motif-mef/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un motif de sortie peut être réactivé
         * @param {string} idCorrelation Identifiant du motif de sortie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationMotifSortieUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationMotifSortieUsingGET.');
            }
            const localVarPath = `/api/referentiel/motif-sortie/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un type d\'AF peut être réactivé
         * @param {string} idCorrelation Identifiant du type d\'AF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationTypeAfUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationTypeAfUsingGET.');
            }
            const localVarPath = `/api/referentiel/type-autorite-fourriere/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une unité FO peut être réactivée
         * @param {string} idCorrelation Identifiant de l\'unité FO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationUsingGET.');
            }
            const localVarPath = `/api/referentiel/unite-fo/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une vidéo tutorielle peut être réactivée
         * @param {string} idCorrelation Identifiant de la vidéo représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationVideoTutorielUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling conditionReactivationVideoTutorielUsingGET.');
            }
            const localVarPath = `/api/referentiel/video-tutoriel/{idCorrelation}/condition-reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'importer un fichier avec les retours de la DNID.
         * @param {any} file Fichier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contournementCsvImportUsingPOST(file: any, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling contournementCsvImportUsingPOST.');
            }
            const localVarPath = `/api/hermes/contournement/retour`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Récupère le nombre de configurations filtrés par le body de la requête
         * @param {countConfigurationsWithSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route countConfigurationsWithSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countConfigurationsWithSpecsUsingGET(queryParams: CountConfigurationsWithSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            const localVarPath = `/api/configuration/with-specs/count`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.fullNameOrDescription !== undefined) {
                localVarQueryParameter['fullNameOrDescription'] = queryParams.fullNameOrDescription;
            }

            if (queryParams.hasError !== undefined) {
                localVarQueryParameter['hasError'] = queryParams.hasError;
            }

            if (queryParams.microServiceName !== undefined) {
                localVarQueryParameter['microServiceName'] = queryParams.microServiceName;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            if (queryParams.sortByMicroServiceName !== undefined) {
                localVarQueryParameter['sortByMicroServiceName'] = queryParams.sortByMicroServiceName;
            }

            if (queryParams.value !== undefined) {
                localVarQueryParameter['value'] = queryParams.value;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer une autorite de fourrière.
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto Données utilisées pour créer l\'autorité de fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAutoriteFourriereUsingPOST(autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'autoriteFourriereRequestDto' is not null or undefined
            if (autoriteFourriereRequestDto === null || autoriteFourriereRequestDto === undefined) {
                throw new RequiredError('autoriteFourriereRequestDto','Required parameter autoriteFourriereRequestDto was null or undefined when calling createAutoriteFourriereUsingPOST.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(autoriteFourriereRequestDto || {}) : (autoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer une branche
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrancheUsingPOST(brancheRequestDto: BrancheRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'brancheRequestDto' is not null or undefined
            if (brancheRequestDto === null || brancheRequestDto === undefined) {
                throw new RequiredError('brancheRequestDto','Required parameter brancheRequestDto was null or undefined when calling createBrancheUsingPOST.');
            }
            const localVarPath = `/api/referentiel/branche`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BrancheRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(brancheRequestDto || {}) : (brancheRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer un centre VHU
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCentreVHUUsingPOST(centreVHURequestDto: CentreVHURequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'centreVHURequestDto' is not null or undefined
            if (centreVHURequestDto === null || centreVHURequestDto === undefined) {
                throw new RequiredError('centreVHURequestDto','Required parameter centreVHURequestDto was null or undefined when calling createCentreVHUUsingPOST.');
            }
            const localVarPath = `/api/referentiel/centre-vhu`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CentreVHURequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(centreVHURequestDto || {}) : (centreVHURequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer un état du véhicule
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEtatUsingPOST(etatRequestDto: EtatRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'etatRequestDto' is not null or undefined
            if (etatRequestDto === null || etatRequestDto === undefined) {
                throw new RequiredError('etatRequestDto','Required parameter etatRequestDto was null or undefined when calling createEtatUsingPOST.');
            }
            const localVarPath = `/api/referentiel/etat`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EtatRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(etatRequestDto || {}) : (etatRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer un domaine faq
         * @param {FaqDomainRequestDto} faqDomainRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFaqDomainUsingPOST(faqDomainRequestDto: FaqDomainRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'faqDomainRequestDto' is not null or undefined
            if (faqDomainRequestDto === null || faqDomainRequestDto === undefined) {
                throw new RequiredError('faqDomainRequestDto','Required parameter faqDomainRequestDto was null or undefined when calling createFaqDomainUsingPOST.');
            }
            const localVarPath = `/api/referentiel/faq-domain`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FaqDomainRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(faqDomainRequestDto || {}) : (faqDomainRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer une question
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFaqUsingPOST(faqRequestDto: FaqRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'faqRequestDto' is not null or undefined
            if (faqRequestDto === null || faqRequestDto === undefined) {
                throw new RequiredError('faqRequestDto','Required parameter faqRequestDto was null or undefined when calling createFaqUsingPOST.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FaqRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(faqRequestDto || {}) : (faqRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer un lien de bas de page
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFooterLinkUsingPOST(footerLinkRequestDto: FooterLinkRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'footerLinkRequestDto' is not null or undefined
            if (footerLinkRequestDto === null || footerLinkRequestDto === undefined) {
                throw new RequiredError('footerLinkRequestDto','Required parameter footerLinkRequestDto was null or undefined when calling createFooterLinkUsingPOST.');
            }
            const localVarPath = `/api/referentiel/footer-link`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FooterLinkRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(footerLinkRequestDto || {}) : (footerLinkRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer une fourrière.
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFourriereUsingPOST(fourriereRequestDto: FourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'fourriereRequestDto' is not null or undefined
            if (fourriereRequestDto === null || fourriereRequestDto === undefined) {
                throw new RequiredError('fourriereRequestDto','Required parameter fourriereRequestDto was null or undefined when calling createFourriereUsingPOST.');
            }
            const localVarPath = `/api/referentiel/fourriere`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fourriereRequestDto || {}) : (fourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer un genre simplifié
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGenreSimplifieUsingPOST(genreSimplifieRequestDto: GenreSimplifieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'genreSimplifieRequestDto' is not null or undefined
            if (genreSimplifieRequestDto === null || genreSimplifieRequestDto === undefined) {
                throw new RequiredError('genreSimplifieRequestDto','Required parameter genreSimplifieRequestDto was null or undefined when calling createGenreSimplifieUsingPOST.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GenreSimplifieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(genreSimplifieRequestDto || {}) : (genreSimplifieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route pour créer un bandeau d\'information à afficher.
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInformationMessageUsingPOST(informationMessageRequestDto: InformationMessageRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'informationMessageRequestDto' is not null or undefined
            if (informationMessageRequestDto === null || informationMessageRequestDto === undefined) {
                throw new RequiredError('informationMessageRequestDto','Required parameter informationMessageRequestDto was null or undefined when calling createInformationMessageUsingPOST.');
            }
            const localVarPath = `/api/referentiel/message-information`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"InformationMessageRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(informationMessageRequestDto || {}) : (informationMessageRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer une juridiction.
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJuridictionUsingPOST(juridictionRequestDto: JuridictionRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'juridictionRequestDto' is not null or undefined
            if (juridictionRequestDto === null || juridictionRequestDto === undefined) {
                throw new RequiredError('juridictionRequestDto','Required parameter juridictionRequestDto was null or undefined when calling createJuridictionUsingPOST.');
            }
            const localVarPath = `/api/referentiel/juridiction`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"JuridictionRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(juridictionRequestDto || {}) : (juridictionRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer un motif de MEF.
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMotifMefUsingPOST(motifMefRequestDto: MotifMefRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'motifMefRequestDto' is not null or undefined
            if (motifMefRequestDto === null || motifMefRequestDto === undefined) {
                throw new RequiredError('motifMefRequestDto','Required parameter motifMefRequestDto was null or undefined when calling createMotifMefUsingPOST.');
            }
            const localVarPath = `/api/referentiel/motif-mef`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifMefRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifMefRequestDto || {}) : (motifMefRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer un motif de sortie.
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMotifSortieUsingPOST(motifSortieRequestDto: MotifSortieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'motifSortieRequestDto' is not null or undefined
            if (motifSortieRequestDto === null || motifSortieRequestDto === undefined) {
                throw new RequiredError('motifSortieRequestDto','Required parameter motifSortieRequestDto was null or undefined when calling createMotifSortieUsingPOST.');
            }
            const localVarPath = `/api/referentiel/motif-sortie`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifSortieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifSortieRequestDto || {}) : (motifSortieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer un type d\'AF.
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTypeAfUsingPOST(typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'typeAutoriteFourriereRequestDto' is not null or undefined
            if (typeAutoriteFourriereRequestDto === null || typeAutoriteFourriereRequestDto === undefined) {
                throw new RequiredError('typeAutoriteFourriereRequestDto','Required parameter typeAutoriteFourriereRequestDto was null or undefined when calling createTypeAfUsingPOST.');
            }
            const localVarPath = `/api/referentiel/type-autorite-fourriere`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TypeAutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(typeAutoriteFourriereRequestDto || {}) : (typeAutoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer une unité de force de l\'ordre.
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUniteFoUsingPOST(uniteFoRequestDto: UniteFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'uniteFoRequestDto' is not null or undefined
            if (uniteFoRequestDto === null || uniteFoRequestDto === undefined) {
                throw new RequiredError('uniteFoRequestDto','Required parameter uniteFoRequestDto was null or undefined when calling createUniteFoUsingPOST.');
            }
            const localVarPath = `/api/referentiel/unite-fo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UniteFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(uniteFoRequestDto || {}) : (uniteFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer une vidéo tutorielle
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoTutorielUsingPOST(videoTutorielRequestDto: VideoTutorielRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'videoTutorielRequestDto' is not null or undefined
            if (videoTutorielRequestDto === null || videoTutorielRequestDto === undefined) {
                throw new RequiredError('videoTutorielRequestDto','Required parameter videoTutorielRequestDto was null or undefined when calling createVideoTutorielUsingPOST.');
            }
            const localVarPath = `/api/referentiel/video-tutoriel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VideoTutorielRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(videoTutorielRequestDto || {}) : (videoTutorielRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary API permettant de supprimer un document spécifique
         * @param {string} idDocumentSpecifique UUID du document spécifique
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentSpecifiqueUsingDELETE(idDocumentSpecifique: string, options: any = {}): FetchArgs {
            // verify required parameter 'idDocumentSpecifique' is not null or undefined
            if (idDocumentSpecifique === null || idDocumentSpecifique === undefined) {
                throw new RequiredError('idDocumentSpecifique','Required parameter idDocumentSpecifique was null or undefined when calling deleteDocumentSpecifiqueUsingDELETE.');
            }
            const localVarPath = `/api/admin-fonctionnel/document-specifique/{idDocumentSpecifique}`
                .replace(`{${"idDocumentSpecifique"}}`, encodeURIComponent(String(idDocumentSpecifique)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Suppression d\'une des pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePieceJointeUsingDELETE1(dossierId: string, type: string, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling deletePieceJointeUsingDELETE1.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling deletePieceJointeUsingDELETE1.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{dossierId}/piece-jointe/{type}`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'une autorité de fourrière.
         * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
         * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateAutoriteFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateAutoriteFourriereUsingPUT.');
            }
            // verify required parameter 'referentielCommentairesRequestDto' is not null or undefined
            if (referentielCommentairesRequestDto === null || referentielCommentairesRequestDto === undefined) {
                throw new RequiredError('referentielCommentairesRequestDto','Required parameter referentielCommentairesRequestDto was null or undefined when calling deprecateAutoriteFourriereUsingPUT.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReferentielCommentairesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(referentielCommentairesRequestDto || {}) : (referentielCommentairesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'un centre vhu.
         * @param {string} idCorrelation Identifiant du centre vhu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateCentreVhuUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateCentreVhuUsingPUT.');
            }
            const localVarPath = `/api/referentiel/centre-vhu/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'un état de véhicule.
         * @param {string} idCorrelation Identifiant de l\'état
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateEtatUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateEtatUsingPUT.');
            }
            const localVarPath = `/api/referentiel/etat/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'un domaine faq.
         * @param {string} idCorrelation Identifiant du domaine faq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateFaqDomainUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateFaqDomainUsingPUT.');
            }
            const localVarPath = `/api/referentiel/faq-domain/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'une question
         * @param {string} idCorrelation Identifiant de la question
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateFaqUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateFaqUsingPUT.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'un lien de pied de page.
         * @param {string} idCorrelation Identifiant du lien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateFooterLinkUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateFooterLinkUsingPUT.');
            }
            const localVarPath = `/api/referentiel/footer-link/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'une fourrière.
         * @param {string} idCorrelation Identifiant de la fourrière
         * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateFourriereUsingPUT.');
            }
            // verify required parameter 'referentielCommentairesRequestDto' is not null or undefined
            if (referentielCommentairesRequestDto === null || referentielCommentairesRequestDto === undefined) {
                throw new RequiredError('referentielCommentairesRequestDto','Required parameter referentielCommentairesRequestDto was null or undefined when calling deprecateFourriereUsingPUT.');
            }
            const localVarPath = `/api/referentiel/fourriere/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReferentielCommentairesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(referentielCommentairesRequestDto || {}) : (referentielCommentairesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'un genre simplifié.
         * @param {string} idCorrelation Identifiant du genre simplifié
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateGenreSimplifieUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateGenreSimplifieUsingPUT.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'une juridiction.
         * @param {string} idCorrelation Identifiant de la juridiction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateJuridictionUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateJuridictionUsingPUT.');
            }
            const localVarPath = `/api/referentiel/juridiction/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'un motif de MEF.
         * @param {string} idCorrelation Identifiant du motif de MEF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateMotifMefUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateMotifMefUsingPUT.');
            }
            const localVarPath = `/api/referentiel/motif-mef/{idCorrelation}/deprecation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'un motif de sortie.
         * @param {string} idCorrelation Identifiant du motif de sortie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateMotifSortieUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateMotifSortieUsingPUT.');
            }
            const localVarPath = `/api/referentiel/motif-sortie/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'un type d\'AF.
         * @param {string} idCorrelation Identifiant du type d\'AF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateTypeAfUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateTypeAfUsingPUT.');
            }
            const localVarPath = `/api/referentiel/type-autorite-fourriere/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'une unité FO.
         * @param {string} idCorrelation Identifiant de l\'unité FO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateUsingPUT.');
            }
            const localVarPath = `/api/referentiel/unite-fo/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Désactivation d\'une vidéo tutorielle.
         * @param {string} idCorrelation Identifiant de la vidéo représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateVideoTutorielUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling deprecateVideoTutorielUsingPUT.');
            }
            const localVarPath = `/api/referentiel/video-tutoriel/{idCorrelation}/desactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'exporter la table de décision au format DMN.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCsvTableUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/classement/export/dmn`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Téléchargement d\'une des pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsingGET1(dossierId: string, type: string, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling downloadUsingGET1.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling downloadUsingGET1.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{dossierId}/piece-jointe/{type}`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {etatUsingGETQueryParams} queryParams objet contenant les query params de la route etatUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        etatUsingGET(queryParams: EtatUsingGETQueryParams, options: any = {}): FetchArgs {
            const localVarPath = `/api/conventionnement`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.codeInsee !== undefined) {
                localVarQueryParameter['codeInsee'] = queryParams.codeInsee;
            }

            if (queryParams.idCorrelationUniteFo !== undefined) {
                localVarQueryParameter['idCorrelationUniteFo'] = queryParams.idCorrelationUniteFo;
            }

            if (queryParams.typeUniteFo !== undefined) {
                localVarQueryParameter['typeUniteFo'] = queryParams.typeUniteFo;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer l\'AR/PND depuis l\'ANTAI
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchArPndUsingPOST1(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchArPndUsingPOST1.');
            }
            const localVarPath = `/api/admin-fonctionnel/notification/ar-pnd/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer le courrier de notification depuis l\'ANTAI
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCourrierUsingPOST1(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchCourrierUsingPOST1.');
            }
            const localVarPath = `/api/admin-fonctionnel/notification/courrier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les données de notification manuelle d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {FixDataNotificationManuelleRequestDto} fixDataNotificationManuelleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixDataNotificationManuelleUsingPOST(id: string, fixDataNotificationManuelleRequestDto: FixDataNotificationManuelleRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fixDataNotificationManuelleUsingPOST.');
            }
            // verify required parameter 'fixDataNotificationManuelleRequestDto' is not null or undefined
            if (fixDataNotificationManuelleRequestDto === null || fixDataNotificationManuelleRequestDto === undefined) {
                throw new RequiredError('fixDataNotificationManuelleRequestDto','Required parameter fixDataNotificationManuelleRequestDto was null or undefined when calling fixDataNotificationManuelleUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/notification-manuelle`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FixDataNotificationManuelleRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fixDataNotificationManuelleRequestDto || {}) : (fixDataNotificationManuelleRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de déterminer quelle solution est active pour le partenaire alienation.<br/> Celle-ci pouvant être l\'API du partenaire alienation ou la solution de contournement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlienationActiveSolutionUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/hermes/solution-active`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'exporter l\'ensemble des données d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDonneesAndEventsDossierUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAllDonneesAndEventsDossierUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Récupère la liste des noms de microservices ayant des configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMicroServiceNamesUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/configuration/all-service-names`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Récupère un rapport d\'apurement par son id.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApurementReportUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getApurementReportUsingGET.');
            }
            const localVarPath = `/api/apurement/report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Récupération de la liste des anciennes version d\'une configuration via son idCorrelation
         * @param {string} idCorrelation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationHistoriqueUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling getConfigurationHistoriqueUsingGET.');
            }
            const localVarPath = `/api/configuration/historique/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'obtenir la liste des détails des évènements
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailedEventsUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDetailedEventsUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/detailed-events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel d\'exporter les statistiques
         * @param {ExportStatistiquesRequestDto} exportStatistiquesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportStatistiquesUsingPOST(exportStatistiquesRequestDto: ExportStatistiquesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'exportStatistiquesRequestDto' is not null or undefined
            if (exportStatistiquesRequestDto === null || exportStatistiquesRequestDto === undefined) {
                throw new RequiredError('exportStatistiquesRequestDto','Required parameter exportStatistiquesRequestDto was null or undefined when calling getExportStatistiquesUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/administration-avancee/export-statistiques`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ExportStatistiquesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(exportStatistiquesRequestDto || {}) : (exportStatistiquesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Router permettant de récupérer le statuts des flux
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFluxStatusesUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin-fonctionnel/flux-status`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche les fourrieres associées à une autorité fourriere
         * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFourrieresFromValidAutoriteFourriereUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling getFourrieresFromValidAutoriteFourriereUsingGET.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/{idCorrelation}/fourrieres`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'obtenir les informations du bandeau de l\'admin fonctionnel avec l\'objet DossierDtoAdminFonctionnel
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformationsByDossierIdUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getInformationsByDossierIdUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Permet de récupérer la date de la prochaine exécution planifiée d\'un flux
         * @param {'ALIENATION_UPDATE_STATUS_BIEN' | 'ALIENATION_LIEU_DEPOT' | 'ALIENATION_ENTITE_REMETTANTE' | 'ANTAI_RECUPERATION_INFORMATION_SYNCHRONIZATION' | 'ANTAI_RECUPERATION_INFORMATION_RETRY' | 'DOSSIER_PURGE' | 'DOSSIER_ANONYMISATION' | 'DOSSIER_RESYNC' | 'DOSSIER_BLOCAGE' | 'DOSSIER_UNSYNC' | 'RPSI_BATCH' | 'REPORT_PURGE'} fluxType Type de flux dont on souhaite connaître la prochaine date d\'exécution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextExecutionTimeUsingGET(fluxType: 'ALIENATION_UPDATE_STATUS_BIEN' | 'ALIENATION_LIEU_DEPOT' | 'ALIENATION_ENTITE_REMETTANTE' | 'ANTAI_RECUPERATION_INFORMATION_SYNCHRONIZATION' | 'ANTAI_RECUPERATION_INFORMATION_RETRY' | 'DOSSIER_PURGE' | 'DOSSIER_ANONYMISATION' | 'DOSSIER_RESYNC' | 'DOSSIER_BLOCAGE' | 'DOSSIER_UNSYNC' | 'RPSI_BATCH' | 'REPORT_PURGE', options: any = {}): FetchArgs {
            // verify required parameter 'fluxType' is not null or undefined
            if (fluxType === null || fluxType === undefined) {
                throw new RequiredError('fluxType','Required parameter fluxType was null or undefined when calling getNextExecutionTimeUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/flux/{fluxType}/next-execution-time`
                .replace(`{${"fluxType"}}`, encodeURIComponent(String(fluxType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant les questions valides, regroupées par domaines pour l\'admin.
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} profile Profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidFaqByDomainsForProfileUsingGET(profile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', options: any = {}): FetchArgs {
            // verify required parameter 'profile' is not null or undefined
            if (profile === null || profile === undefined) {
                throw new RequiredError('profile','Required parameter profile was null or undefined when calling getOnlyValidFaqByDomainsForProfileUsingGET.');
            }
            const localVarPath = `/api/referentiel/faq/domaine/{profile}`
                .replace(`{${"profile"}}`, encodeURIComponent(String(profile)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récuperer le pdf actions camunda
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdfActionsCamundaUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin-fonctionnel/administration-avancee/actions-camunda`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer la liste des types de pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPieceJointeTypesUsingGET1(dossierId: string, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling getPieceJointeTypesUsingGET1.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{dossierId}/pieces-jointes/types`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer les instances Camunda d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessInstancesUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProcessInstancesUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/process-instances`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer un flux spécifique de synchronisation des fourrières avec la DNID
         * @param {string} fluxId Id du flux, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecificFluxFourriereUsingGET(fluxId: string, options: any = {}): FetchArgs {
            // verify required parameter 'fluxId' is not null or undefined
            if (fluxId === null || fluxId === undefined) {
                throw new RequiredError('fluxId','Required parameter fluxId was null or undefined when calling getSpecificFluxFourriereUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/alienation/fourriere/flux/{fluxId}`
                .replace(`{${"fluxId"}}`, encodeURIComponent(String(fluxId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'importer une table de décision au format DMN.
         * @param {any} file Fichier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCsvTableUsingPOST(file: any, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling importCsvTableUsingPOST.');
            }
            const localVarPath = `/api/classement/import/dmn`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route pour valider un champ du formulaire de mise à jour du bandeau d\'information à afficher.
         * @param {'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES'} field 
         * @param {string} id 
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        informationMessageValidateFieldUsingPOST(field: 'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES', id: string, informationMessageRequestDto: InformationMessageRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling informationMessageValidateFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling informationMessageValidateFieldUsingPOST.');
            }
            // verify required parameter 'informationMessageRequestDto' is not null or undefined
            if (informationMessageRequestDto === null || informationMessageRequestDto === undefined) {
                throw new RequiredError('informationMessageRequestDto','Required parameter informationMessageRequestDto was null or undefined when calling informationMessageValidateFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/message-information/{id}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"InformationMessageRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(informationMessageRequestDto || {}) : (informationMessageRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route pour valider un champ du formulaire de création d\'un bandeau d\'information à afficher.
         * @param {'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES'} field 
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        informationMessageValidateFieldUsingPOST1(field: 'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES', informationMessageRequestDto: InformationMessageRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling informationMessageValidateFieldUsingPOST1.');
            }
            // verify required parameter 'informationMessageRequestDto' is not null or undefined
            if (informationMessageRequestDto === null || informationMessageRequestDto === undefined) {
                throw new RequiredError('informationMessageRequestDto','Required parameter informationMessageRequestDto was null or undefined when calling informationMessageValidateFieldUsingPOST1.');
            }
            const localVarPath = `/api/referentiel/message-information/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"InformationMessageRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(informationMessageRequestDto || {}) : (informationMessageRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route pour valider un formulaire de création d\'un bandeau d\'information à afficher.
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        informationMessageValidateUsingPOST(informationMessageRequestDto: InformationMessageRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'informationMessageRequestDto' is not null or undefined
            if (informationMessageRequestDto === null || informationMessageRequestDto === undefined) {
                throw new RequiredError('informationMessageRequestDto','Required parameter informationMessageRequestDto was null or undefined when calling informationMessageValidateUsingPOST.');
            }
            const localVarPath = `/api/referentiel/message-information/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"InformationMessageRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(informationMessageRequestDto || {}) : (informationMessageRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de migrer d\'une unité fo à une autre les dossiers associés
         * @param {MigrateUniteFoRequestDto} migrateUniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateUniteFoUsingPOST(migrateUniteFoRequestDto: MigrateUniteFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'migrateUniteFoRequestDto' is not null or undefined
            if (migrateUniteFoRequestDto === null || migrateUniteFoRequestDto === undefined) {
                throw new RequiredError('migrateUniteFoRequestDto','Required parameter migrateUniteFoRequestDto was null or undefined when calling migrateUniteFoUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/migrate-unite-fo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MigrateUniteFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(migrateUniteFoRequestDto || {}) : (migrateUniteFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'une autorité de fourrière.
         * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
         * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateAutoriteFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateAutoriteFourriereUsingPUT.');
            }
            // verify required parameter 'referentielCommentairesRequestDto' is not null or undefined
            if (referentielCommentairesRequestDto === null || referentielCommentairesRequestDto === undefined) {
                throw new RequiredError('referentielCommentairesRequestDto','Required parameter referentielCommentairesRequestDto was null or undefined when calling reactivateAutoriteFourriereUsingPUT.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReferentielCommentairesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(referentielCommentairesRequestDto || {}) : (referentielCommentairesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'un centre vhu.
         * @param {string} idCorrelation Identifiant du centre vhu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateCentreVhuUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateCentreVhuUsingPUT.');
            }
            const localVarPath = `/api/referentiel/centre-vhu/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'un état de véhicule.
         * @param {string} idCorrelation Identifiant de l\'état
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateEtatUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateEtatUsingPUT.');
            }
            const localVarPath = `/api/referentiel/etat/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'un domaine faq.
         * @param {string} idCorrelation Identifiant du domaine faq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateFaqDomainUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateFaqDomainUsingPUT.');
            }
            const localVarPath = `/api/referentiel/faq-domain/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'une question
         * @param {string} idCorrelation Identifiant de la question
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateFaqUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateFaqUsingPUT.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'un lien de pied de page.
         * @param {string} idCorrelation Identifiant du lien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateFooterLinkUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateFooterLinkUsingPUT.');
            }
            const localVarPath = `/api/referentiel/footer-link/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'une fourrière.
         * @param {string} idCorrelation Identifiant de la fourrière
         * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateFourriereUsingPUT.');
            }
            // verify required parameter 'referentielCommentairesRequestDto' is not null or undefined
            if (referentielCommentairesRequestDto === null || referentielCommentairesRequestDto === undefined) {
                throw new RequiredError('referentielCommentairesRequestDto','Required parameter referentielCommentairesRequestDto was null or undefined when calling reactivateFourriereUsingPUT.');
            }
            const localVarPath = `/api/referentiel/fourriere/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReferentielCommentairesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(referentielCommentairesRequestDto || {}) : (referentielCommentairesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'un genre simplifié.
         * @param {string} idCorrelation Identifiant du genre simplifié
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateGenreSimplifieUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateGenreSimplifieUsingPUT.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'une juridiction.
         * @param {string} idCorrelation Identifiant de la juridiction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateJuridictionUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateJuridictionUsingPUT.');
            }
            const localVarPath = `/api/referentiel/juridiction/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'un motif de MEF.
         * @param {string} idCorrelation Identifiant du motif de MEF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateMotifMefUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateMotifMefUsingPUT.');
            }
            const localVarPath = `/api/referentiel/motif-mef/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'un motif de sortie.
         * @param {string} idCorrelation Identifiant du motif de sortie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateMotifSortieUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateMotifSortieUsingPUT.');
            }
            const localVarPath = `/api/referentiel/motif-sortie/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'un type d\'AF.
         * @param {string} idCorrelation Identifiant du type d\'AF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateTypeAfUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateTypeAfUsingPUT.');
            }
            const localVarPath = `/api/referentiel/type-autorite-fourriere/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'une unité FO.
         * @param {string} idCorrelation Identifiant de l\'unité FO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateUsingPUT.');
            }
            const localVarPath = `/api/referentiel/unite-fo/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Réactivation d\'une vidéo tutorielle.
         * @param {string} idCorrelation Identifiant de la vidéo représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateVideoTutorielUsingPUT(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling reactivateVideoTutorielUsingPUT.');
            }
            const localVarPath = `/api/referentiel/video-tutoriel/{idCorrelation}/reactivation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Récupération de l\'historique des actions d\'un utilisateur
         * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recupererHistoriqueActionsUtilisateurUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'recuperationActiviteUtilisateurRequestDto' is not null or undefined
            if (recuperationActiviteUtilisateurRequestDto === null || recuperationActiviteUtilisateurRequestDto === undefined) {
                throw new RequiredError('recuperationActiviteUtilisateurRequestDto','Required parameter recuperationActiviteUtilisateurRequestDto was null or undefined when calling recupererHistoriqueActionsUtilisateurUsingPOST.');
            }
            const localVarPath = `/api/administration-avancee/recuperation-activite-utilisateur/historique/actions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RecuperationActiviteUtilisateurRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(recuperationActiviteUtilisateurRequestDto || {}) : (recuperationActiviteUtilisateurRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Récupération de l\'historique des consultations d\'un dossier par un utilisateur
         * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recupererHistoriqueConnexionsUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'recuperationActiviteUtilisateurRequestDto' is not null or undefined
            if (recuperationActiviteUtilisateurRequestDto === null || recuperationActiviteUtilisateurRequestDto === undefined) {
                throw new RequiredError('recuperationActiviteUtilisateurRequestDto','Required parameter recuperationActiviteUtilisateurRequestDto was null or undefined when calling recupererHistoriqueConnexionsUsingPOST.');
            }
            const localVarPath = `/api/administration-avancee/recuperation-activite-utilisateur/historique/connexions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RecuperationActiviteUtilisateurRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(recuperationActiviteUtilisateurRequestDto || {}) : (recuperationActiviteUtilisateurRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Récupération de l\'historique des consultations d\'un dossier par un utilisateur
         * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recupererHistoriqueConsultationsDossierUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'recuperationActiviteUtilisateurRequestDto' is not null or undefined
            if (recuperationActiviteUtilisateurRequestDto === null || recuperationActiviteUtilisateurRequestDto === undefined) {
                throw new RequiredError('recuperationActiviteUtilisateurRequestDto','Required parameter recuperationActiviteUtilisateurRequestDto was null or undefined when calling recupererHistoriqueConsultationsDossierUsingPOST.');
            }
            const localVarPath = `/api/administration-avancee/recuperation-activite-utilisateur/historique/consultations-dossier`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RecuperationActiviteUtilisateurRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(recuperationActiviteUtilisateurRequestDto || {}) : (recuperationActiviteUtilisateurRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route déclenchant une relance du processus de vente chez le service des domaines, engendrant une nouvelle remise aux domaines.
         * @param {RelanceVenteDto} relanceVenteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relanceVenteAdminUsingPOST(relanceVenteDto: RelanceVenteDto, options: any = {}): FetchArgs {
            // verify required parameter 'relanceVenteDto' is not null or undefined
            if (relanceVenteDto === null || relanceVenteDto === undefined) {
                throw new RequiredError('relanceVenteDto','Required parameter relanceVenteDto was null or undefined when calling relanceVenteAdminUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/relance-vente`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RelanceVenteDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(relanceVenteDto || {}) : (relanceVenteDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de sauvegarder une fiche descriptive
         * @param {any} file La fiche descriptive, représentée par un InputStream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFicheDescriptiveUsingPOST(file: any, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling saveFicheDescriptiveUsingPOST.');
            }
            const localVarPath = `/api/fiche-descriptive/save`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de sauvegarder un manuel Bdr
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
         * @param {any} file Le manuel, représenté par un InputStream.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManualBdrUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options: any = {}): FetchArgs {
            // verify required parameter 'userProfile' is not null or undefined
            if (userProfile === null || userProfile === undefined) {
                throw new RequiredError('userProfile','Required parameter userProfile was null or undefined when calling saveManualBdrUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling saveManualBdrUsingPOST.');
            }
            const localVarPath = `/api/manual/bdr/{userProfile}`
                .replace(`{${"userProfile"}}`, encodeURIComponent(String(userProfile)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de sauvegarder un manuel utilisateur
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
         * @param {any} file Le manuel, représenté par un InputStream.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManualUtilisateurUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options: any = {}): FetchArgs {
            // verify required parameter 'userProfile' is not null or undefined
            if (userProfile === null || userProfile === undefined) {
                throw new RequiredError('userProfile','Required parameter userProfile was null or undefined when calling saveManualUtilisateurUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling saveManualUtilisateurUsingPOST.');
            }
            const localVarPath = `/api/manual/{userProfile}`
                .replace(`{${"userProfile"}}`, encodeURIComponent(String(userProfile)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche de la liste des configurations filtrés par le body de la requête
         * @param {searchConfigurationsWithSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchConfigurationsWithSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConfigurationsWithSpecsUsingGET(queryParams: SearchConfigurationsWithSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            const localVarPath = `/api/configuration/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.fullNameOrDescription !== undefined) {
                localVarQueryParameter['fullNameOrDescription'] = queryParams.fullNameOrDescription;
            }

            if (queryParams.hasError !== undefined) {
                localVarQueryParameter['hasError'] = queryParams.hasError;
            }

            if (queryParams.microServiceName !== undefined) {
                localVarQueryParameter['microServiceName'] = queryParams.microServiceName;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            if (queryParams.sortByMicroServiceName !== undefined) {
                localVarQueryParameter['sortByMicroServiceName'] = queryParams.sortByMicroServiceName;
            }

            if (queryParams.value !== undefined) {
                localVarQueryParameter['value'] = queryParams.value;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche de la liste des états filtrés par le body de la requête
         * @param {searchEtatUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchEtatUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEtatUsingSpecsUsingGET(queryParams: SearchEtatUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchEtatUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchEtatUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/etat/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            if (queryParams.sorts.etat !== undefined) {
                localVarQueryParameter['sorts.etat'] = queryParams.sorts.etat;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche de la liste de domaine faq filtrés par le body de la requête
         * @param {searchFaqDomainUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFaqDomainUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFaqDomainUsingSpecsUsingGET(queryParams: SearchFaqDomainUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchFaqDomainUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/faq/domain/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.name !== undefined) {
                localVarQueryParameter['filters.name'] = queryParams.filters.name;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche de la liste des faq filtrés par le body de la requête
         * @param {searchFaqUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFaqUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFaqUsingSpecsUsingGET(queryParams: SearchFaqUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchFaqUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/faq/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.domainId !== undefined) {
                localVarQueryParameter['filters.domainId'] = queryParams.filters.domainId;
            }
            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les flux de autorités fourrière aliénation
         * @param {searchFluxAutoriteFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxAutoriteFourriereUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFluxAutoriteFourriereUsingGET(queryParams: SearchFluxAutoriteFourriereUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'sortDto' is not null or undefined
            if (queryParams.sortDto === null || queryParams.sortDto === undefined) {
                throw new RequiredError('sortDto','Required parameter sortDto was null or undefined when calling searchFluxAutoriteFourriereUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/alienation/autorite-fourriere/flux`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            if (queryParams.sortDto.dateAppel !== undefined) {
                localVarQueryParameter['sortDto.dateAppel'] = queryParams.sortDto.dateAppel;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les flux Aliénation de récupération de l\'état des biens
         * @param {searchFluxEtatBienUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxEtatBienUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFluxEtatBienUsingGET(queryParams: SearchFluxEtatBienUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'sortDto' is not null or undefined
            if (queryParams.sortDto === null || queryParams.sortDto === undefined) {
                throw new RequiredError('sortDto','Required parameter sortDto was null or undefined when calling searchFluxEtatBienUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/alienation/etat-bien`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            if (queryParams.sortDto.dateAppel !== undefined) {
                localVarQueryParameter['sortDto.dateAppel'] = queryParams.sortDto.dateAppel;
            }
            if (queryParams.sortDto.dateDebut !== undefined) {
                localVarQueryParameter['sortDto.dateDebut'] = queryParams.sortDto.dateDebut;
            }
            if (queryParams.sortDto.dateFin !== undefined) {
                localVarQueryParameter['sortDto.dateFin'] = queryParams.sortDto.dateFin;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les flux spécifiques de synchronisation des fourrières avec la DNID
         * @param {searchFluxFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxFourriereUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFluxFourriereUsingGET(queryParams: SearchFluxFourriereUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'sortDto' is not null or undefined
            if (queryParams.sortDto === null || queryParams.sortDto === undefined) {
                throw new RequiredError('sortDto','Required parameter sortDto was null or undefined when calling searchFluxFourriereUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/alienation/fourriere/flux`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            if (queryParams.sortDto.dateAppel !== undefined) {
                localVarQueryParameter['sortDto.dateAppel'] = queryParams.sortDto.dateAppel;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les flux du batch rpsi
         * @param {searchFluxRpsiUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxRpsiUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFluxRpsiUsingGET(queryParams: SearchFluxRpsiUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'sortDto' is not null or undefined
            if (queryParams.sortDto === null || queryParams.sortDto === undefined) {
                throw new RequiredError('sortDto','Required parameter sortDto was null or undefined when calling searchFluxRpsiUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/rpsi/flux`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            if (queryParams.sortDto.dateAppel !== undefined) {
                localVarQueryParameter['sortDto.dateAppel'] = queryParams.sortDto.dateAppel;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les flux Antai
         * @param {searchFluxUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFluxUsingGET(queryParams: SearchFluxUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'sortDto' is not null or undefined
            if (queryParams.sortDto === null || queryParams.sortDto === undefined) {
                throw new RequiredError('sortDto','Required parameter sortDto was null or undefined when calling searchFluxUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/antai/flux`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            if (queryParams.sortDto.dateDebut !== undefined) {
                localVarQueryParameter['sortDto.dateDebut'] = queryParams.sortDto.dateDebut;
            }
            if (queryParams.sortDto.indexDebut !== undefined) {
                localVarQueryParameter['sortDto.indexDebut'] = queryParams.sortDto.indexDebut;
            }
            if (queryParams.sortDto.indexFin !== undefined) {
                localVarQueryParameter['sortDto.indexFin'] = queryParams.sortDto.indexFin;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche de la liste des liens de pied de page filtrés par le body de la requête
         * @param {searchFooterLinkUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFooterLinkUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFooterLinkUsingSpecsUsingGET(queryParams: SearchFooterLinkUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchFooterLinkUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/footer-link/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche de la liste des genres simplifiés filtrés par le body de la requête
         * @param {searchGenreSimplifieUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchGenreSimplifieUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGenreSimplifieUsingSpecsUsingGET(queryParams: SearchGenreSimplifieUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchGenreSimplifieUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchGenreSimplifieUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            if (queryParams.sorts.libelle !== undefined) {
                localVarQueryParameter['sorts.libelle'] = queryParams.sorts.libelle;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche de la liste de motifs de sortie filtrée par le body de la requête
         * @param {searchMotifSortieUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchMotifSortieUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMotifSortieUsingSpecsUsingGET(queryParams: SearchMotifSortieUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchMotifSortieUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/motif-sortie/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer un flux Aliénation de récupération des autorités fourrière
         * @param {string} fluxId Id du flux, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSpecificFluxAutoriteFouriereUsingGET(fluxId: string, options: any = {}): FetchArgs {
            // verify required parameter 'fluxId' is not null or undefined
            if (fluxId === null || fluxId === undefined) {
                throw new RequiredError('fluxId','Required parameter fluxId was null or undefined when calling searchSpecificFluxAutoriteFouriereUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/alienation/autorite-fourriere/flux/{fluxId}`
                .replace(`{${"fluxId"}}`, encodeURIComponent(String(fluxId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer un flux Aliénation de récupération de l\'état des biens
         * @param {string} fluxId Id du flux, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSpecificFluxEtatBienUsingGET(fluxId: string, options: any = {}): FetchArgs {
            // verify required parameter 'fluxId' is not null or undefined
            if (fluxId === null || fluxId === undefined) {
                throw new RequiredError('fluxId','Required parameter fluxId was null or undefined when calling searchSpecificFluxEtatBienUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/alienation/etat-bien/flux/{fluxId}`
                .replace(`{${"fluxId"}}`, encodeURIComponent(String(fluxId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer un flux Antai de récupération d\'un évènement
         * @param {string} fluxId Id du flux, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSpecificFluxUsingGET(fluxId: string, options: any = {}): FetchArgs {
            // verify required parameter 'fluxId' is not null or undefined
            if (fluxId === null || fluxId === undefined) {
                throw new RequiredError('fluxId','Required parameter fluxId was null or undefined when calling searchSpecificFluxUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/antai/flux/{fluxId}`
                .replace(`{${"fluxId"}}`, encodeURIComponent(String(fluxId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche de la liste des types d\'AF filtrée par le body de la requête
         * @param {searchTypeAfUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchTypeAfUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTypeAfUsingSpecsUsingGET(queryParams: SearchTypeAfUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchTypeAfUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/type-autorite-fourriere/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer les événements d\'administration sur les utilisateurs
         * @param {SearchUserEventsRequestDto} searchUserEventsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserEventsUsingPOST(searchUserEventsRequestDto: SearchUserEventsRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'searchUserEventsRequestDto' is not null or undefined
            if (searchUserEventsRequestDto === null || searchUserEventsRequestDto === undefined) {
                throw new RequiredError('searchUserEventsRequestDto','Required parameter searchUserEventsRequestDto was null or undefined when calling searchUserEventsUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/user-events`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SearchUserEventsRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(searchUserEventsRequestDto || {}) : (searchUserEventsRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des utilisations d\'une autorite de fourrière dans le SI
         * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesAutoriteFourriereUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling searchUsesAutoriteFourriereUsingGET.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/{idCorrelation}/uses`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des utilisations d\'un état dans le SI
         * @param {string} idCorrelation Identifiant de l\'état
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesEtatUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling searchUsesEtatUsingGET.');
            }
            const localVarPath = `/api/referentiel/etat/{idCorrelation}/uses`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des utilisations d\'une fourrière dans le SI
         * @param {string} idCorrelation Identifiant de la fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesFourriereUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling searchUsesFourriereUsingGET.');
            }
            const localVarPath = `/api/referentiel/fourriere/{idCorrelation}/uses`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des utilisations d\'un genre simplifié dans le SI
         * @param {string} idCorrelation Identifiant du genre simplifié
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesGenreSimplifieUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling searchUsesGenreSimplifieUsingGET.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie/{idCorrelation}/uses`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des utilisations d\'une juridiction dans le SI
         * @param {string} idCorrelation Identifiant de la juridiction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesJuridictionUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling searchUsesJuridictionUsingGET.');
            }
            const localVarPath = `/api/referentiel/juridiction/{idCorrelation}/uses`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche des utilisations d\'une Unité FO dans le SI
         * @param {string} idCorrelation Identifiant de l\'unité FO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesUniteFoUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling searchUsesUniteFoUsingGET.');
            }
            const localVarPath = `/api/referentiel/unite-fo/{idCorrelation}/uses`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche de la liste des vidéos tutorielles filtrées par le body de la requête
         * @param {searchVideoTutorielUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchVideoTutorielUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVideoTutorielUsingSpecsUsingGET(queryParams: SearchVideoTutorielUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchVideoTutorielUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/video-tutoriel/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux de autorité fourrières aliénation
          * @param {string} fluxId Id du flux, représenté par un UUID
         * @param {searchWarningsFluxAutoriteFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchWarningsFluxAutoriteFourriereUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWarningsFluxAutoriteFourriereUsingGET(fluxId: string, queryParams: SearchWarningsFluxAutoriteFourriereUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'fluxId' is not null or undefined
            if (fluxId === null || fluxId === undefined) {
                throw new RequiredError('fluxId','Required parameter fluxId was null or undefined when calling searchWarningsFluxAutoriteFourriereUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/alienation/autorite-fourriere/flux/{fluxId}/warnings`
                .replace(`{${"fluxId"}}`, encodeURIComponent(String(fluxId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux spécifique de synchronisation des fourrières avec la DNID
          * @param {string} fluxId Id du flux, représenté par un UUID
         * @param {searchWarningsFluxFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchWarningsFluxFourriereUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWarningsFluxFourriereUsingGET(fluxId: string, queryParams: SearchWarningsFluxFourriereUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'fluxId' is not null or undefined
            if (fluxId === null || fluxId === undefined) {
                throw new RequiredError('fluxId','Required parameter fluxId was null or undefined when calling searchWarningsFluxFourriereUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/alienation/fourriere/flux/{fluxId}/warnings`
                .replace(`{${"fluxId"}}`, encodeURIComponent(String(fluxId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux
          * @param {string} fluxId Id du flux, représenté par un UUID.
         * @param {searchWarningsOfFluxEtatBienUsingGETQueryParams} queryParams objet contenant les query params de la route searchWarningsOfFluxEtatBienUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWarningsOfFluxEtatBienUsingGET(fluxId: string, queryParams: SearchWarningsOfFluxEtatBienUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'fluxId' is not null or undefined
            if (fluxId === null || fluxId === undefined) {
                throw new RequiredError('fluxId','Required parameter fluxId was null or undefined when calling searchWarningsOfFluxEtatBienUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/alienation/etat-bien/flux/{fluxId}/warnings`
                .replace(`{${"fluxId"}}`, encodeURIComponent(String(fluxId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de supprimer un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppressionDossierUsingDELETE(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling suppressionDossierUsingDELETE.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour une autorité de fourrière.
         * @param {string} idCorrelation ID de l\'autorite de fourrière, représenté par un UUID
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAutoriteFourriereUsingPUT(idCorrelation: string, autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateAutoriteFourriereUsingPUT.');
            }
            // verify required parameter 'autoriteFourriereRequestDto' is not null or undefined
            if (autoriteFourriereRequestDto === null || autoriteFourriereRequestDto === undefined) {
                throw new RequiredError('autoriteFourriereRequestDto','Required parameter autoriteFourriereRequestDto was null or undefined when calling updateAutoriteFourriereUsingPUT.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(autoriteFourriereRequestDto || {}) : (autoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour une branche
         * @param {string} idCorrelation ID corrélation de la branche, représenté par un UUID
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrancheUsingPUT(idCorrelation: string, brancheRequestDto: BrancheRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateBrancheUsingPUT.');
            }
            // verify required parameter 'brancheRequestDto' is not null or undefined
            if (brancheRequestDto === null || brancheRequestDto === undefined) {
                throw new RequiredError('brancheRequestDto','Required parameter brancheRequestDto was null or undefined when calling updateBrancheUsingPUT.');
            }
            const localVarPath = `/api/referentiel/branche/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BrancheRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(brancheRequestDto || {}) : (brancheRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour un centre VHU.
         * @param {string} idCorrelation ID du centre vhu, représenté par un UUID
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCentreVHUUsingPUT(idCorrelation: string, centreVHURequestDto: CentreVHURequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateCentreVHUUsingPUT.');
            }
            // verify required parameter 'centreVHURequestDto' is not null or undefined
            if (centreVHURequestDto === null || centreVHURequestDto === undefined) {
                throw new RequiredError('centreVHURequestDto','Required parameter centreVHURequestDto was null or undefined when calling updateCentreVHUUsingPUT.');
            }
            const localVarPath = `/api/referentiel/centre-vhu/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CentreVHURequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(centreVHURequestDto || {}) : (centreVHURequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier le classement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateClassementRequestDto} updateClassementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassementUsingPOST(id: string, updateClassementRequestDto: UpdateClassementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateClassementUsingPOST.');
            }
            // verify required parameter 'updateClassementRequestDto' is not null or undefined
            if (updateClassementRequestDto === null || updateClassementRequestDto === undefined) {
                throw new RequiredError('updateClassementRequestDto','Required parameter updateClassementRequestDto was null or undefined when calling updateClassementUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/classement`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateClassementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateClassementRequestDto || {}) : (updateClassementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour une configuration de l\'application
         * @param {string} idCorrelation ID corrélation de la configuration, représenté par un UUID
         * @param {ConfigurationUpdateRequestDto} configurationUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigurationUsingPUT(idCorrelation: string, configurationUpdateRequestDto: ConfigurationUpdateRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateConfigurationUsingPUT.');
            }
            // verify required parameter 'configurationUpdateRequestDto' is not null or undefined
            if (configurationUpdateRequestDto === null || configurationUpdateRequestDto === undefined) {
                throw new RequiredError('configurationUpdateRequestDto','Required parameter configurationUpdateRequestDto was null or undefined when calling updateConfigurationUsingPUT.');
            }
            const localVarPath = `/api/configuration/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ConfigurationUpdateRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(configurationUpdateRequestDto || {}) : (configurationUpdateRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonneesInterieurVehiculeUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateDonneesInterieurVehiculeUsingPOST.');
            }
            // verify required parameter 'updateDonneesInterieurVehiculeRequestDto' is not null or undefined
            if (updateDonneesInterieurVehiculeRequestDto === null || updateDonneesInterieurVehiculeRequestDto === undefined) {
                throw new RequiredError('updateDonneesInterieurVehiculeRequestDto','Required parameter updateDonneesInterieurVehiculeRequestDto was null or undefined when calling updateDonneesInterieurVehiculeUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/vehicule`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesInterieurVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesInterieurVehiculeRequestDto || {}) : (updateDonneesInterieurVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les données judiciaires d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonneesJudiciairesUsingPOST1(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateDonneesJudiciairesUsingPOST1.');
            }
            // verify required parameter 'updateDonneesJudiciairesRequestDto' is not null or undefined
            if (updateDonneesJudiciairesRequestDto === null || updateDonneesJudiciairesRequestDto === undefined) {
                throw new RequiredError('updateDonneesJudiciairesRequestDto','Required parameter updateDonneesJudiciairesRequestDto was null or undefined when calling updateDonneesJudiciairesUsingPOST1.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/judiciaires`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesJudiciairesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesJudiciairesRequestDto || {}) : (updateDonneesJudiciairesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les entitées de rattachement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntitesRattachementUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateEntitesRattachementUsingPOST.');
            }
            // verify required parameter 'updateEntitesRattachementRequestDto' is not null or undefined
            if (updateEntitesRattachementRequestDto === null || updateEntitesRattachementRequestDto === undefined) {
                throw new RequiredError('updateEntitesRattachementRequestDto','Required parameter updateEntitesRattachementRequestDto was null or undefined when calling updateEntitesRattachementUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/entites-rattachement`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateEntitesRattachementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateEntitesRattachementRequestDto || {}) : (updateEntitesRattachementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour un état du véhicule
         * @param {string} idCorrelation ID corrélation de l\'état, représenté par un UUID
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEtatUsingPUT(idCorrelation: string, etatRequestDto: EtatRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateEtatUsingPUT.');
            }
            // verify required parameter 'etatRequestDto' is not null or undefined
            if (etatRequestDto === null || etatRequestDto === undefined) {
                throw new RequiredError('etatRequestDto','Required parameter etatRequestDto was null or undefined when calling updateEtatUsingPUT.');
            }
            const localVarPath = `/api/referentiel/etat/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EtatRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(etatRequestDto || {}) : (etatRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour un domain faq.
         * @param {string} idCorrelation ID du domaine faq, représenté par un UUID
         * @param {FaqDomainRequestDto} faqDomainRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFaqDomainUsingPUT(idCorrelation: string, faqDomainRequestDto: FaqDomainRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateFaqDomainUsingPUT.');
            }
            // verify required parameter 'faqDomainRequestDto' is not null or undefined
            if (faqDomainRequestDto === null || faqDomainRequestDto === undefined) {
                throw new RequiredError('faqDomainRequestDto','Required parameter faqDomainRequestDto was null or undefined when calling updateFaqDomainUsingPUT.');
            }
            const localVarPath = `/api/referentiel/faq-domain/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FaqDomainRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(faqDomainRequestDto || {}) : (faqDomainRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour une question
         * @param {string} idCorrelation ID de la question, représenté par un UUID
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFaqUsingPUT(idCorrelation: string, faqRequestDto: FaqRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateFaqUsingPUT.');
            }
            // verify required parameter 'faqRequestDto' is not null or undefined
            if (faqRequestDto === null || faqRequestDto === undefined) {
                throw new RequiredError('faqRequestDto','Required parameter faqRequestDto was null or undefined when calling updateFaqUsingPUT.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FaqRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(faqRequestDto || {}) : (faqRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour un lien de bas de page
         * @param {string} idCorrelation ID corrélation du lien de bas de page, représenté par un UUID
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFooterLinkUsingPUT(idCorrelation: string, footerLinkRequestDto: FooterLinkRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateFooterLinkUsingPUT.');
            }
            // verify required parameter 'footerLinkRequestDto' is not null or undefined
            if (footerLinkRequestDto === null || footerLinkRequestDto === undefined) {
                throw new RequiredError('footerLinkRequestDto','Required parameter footerLinkRequestDto was null or undefined when calling updateFooterLinkUsingPUT.');
            }
            const localVarPath = `/api/referentiel/footer-link/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FooterLinkRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(footerLinkRequestDto || {}) : (footerLinkRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour une fourrière.
         * @param {string} idCorrelation ID de la fourrère, représentée par un UUID
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFourriereUsingPUT(idCorrelation: string, fourriereRequestDto: FourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateFourriereUsingPUT.');
            }
            // verify required parameter 'fourriereRequestDto' is not null or undefined
            if (fourriereRequestDto === null || fourriereRequestDto === undefined) {
                throw new RequiredError('fourriereRequestDto','Required parameter fourriereRequestDto was null or undefined when calling updateFourriereUsingPUT.');
            }
            const localVarPath = `/api/referentiel/fourriere/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fourriereRequestDto || {}) : (fourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour un genre simplifié
         * @param {string} idCorrelation ID corrélation du genre simplifié, représenté par un UUID
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGenreSimplifieUsingPUT(idCorrelation: string, genreSimplifieRequestDto: GenreSimplifieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateGenreSimplifieUsingPUT.');
            }
            // verify required parameter 'genreSimplifieRequestDto' is not null or undefined
            if (genreSimplifieRequestDto === null || genreSimplifieRequestDto === undefined) {
                throw new RequiredError('genreSimplifieRequestDto','Required parameter genreSimplifieRequestDto was null or undefined when calling updateGenreSimplifieUsingPUT.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GenreSimplifieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(genreSimplifieRequestDto || {}) : (genreSimplifieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route pour éditer un bandeau d\'information à afficher.
         * @param {string} id 
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformationMessageUsingPOST(id: string, informationMessageRequestDto: InformationMessageRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateInformationMessageUsingPOST.');
            }
            // verify required parameter 'informationMessageRequestDto' is not null or undefined
            if (informationMessageRequestDto === null || informationMessageRequestDto === undefined) {
                throw new RequiredError('informationMessageRequestDto','Required parameter informationMessageRequestDto was null or undefined when calling updateInformationMessageUsingPOST.');
            }
            const localVarPath = `/api/referentiel/message-information/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"InformationMessageRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(informationMessageRequestDto || {}) : (informationMessageRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route pour valider le formulaire de mise à jour d\'un bandeau d\'information.
         * @param {string} id 
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformationMessageValidateUsingPOST(id: string, informationMessageRequestDto: InformationMessageRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateInformationMessageValidateUsingPOST.');
            }
            // verify required parameter 'informationMessageRequestDto' is not null or undefined
            if (informationMessageRequestDto === null || informationMessageRequestDto === undefined) {
                throw new RequiredError('informationMessageRequestDto','Required parameter informationMessageRequestDto was null or undefined when calling updateInformationMessageValidateUsingPOST.');
            }
            const localVarPath = `/api/referentiel/message-information/{id}/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"InformationMessageRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(informationMessageRequestDto || {}) : (informationMessageRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de renseigner manuellement les données siv d\'un véhicule
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {InfosSivRequestDto} infosSivRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfosSivManuelUsingPOST(id: string, infosSivRequestDto: InfosSivRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateInfosSivManuelUsingPOST.');
            }
            // verify required parameter 'infosSivRequestDto' is not null or undefined
            if (infosSivRequestDto === null || infosSivRequestDto === undefined) {
                throw new RequiredError('infosSivRequestDto','Required parameter infosSivRequestDto was null or undefined when calling updateInfosSivManuelUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/infos-siv`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"InfosSivRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(infosSivRequestDto || {}) : (infosSivRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour une juridiction.
         * @param {string} idCorrelation ID de la juridiction, représenté par un UUID
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJuridictionUsingPUT(idCorrelation: string, juridictionRequestDto: JuridictionRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateJuridictionUsingPUT.');
            }
            // verify required parameter 'juridictionRequestDto' is not null or undefined
            if (juridictionRequestDto === null || juridictionRequestDto === undefined) {
                throw new RequiredError('juridictionRequestDto','Required parameter juridictionRequestDto was null or undefined when calling updateJuridictionUsingPUT.');
            }
            const localVarPath = `/api/referentiel/juridiction/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"JuridictionRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(juridictionRequestDto || {}) : (juridictionRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier la catégorie d\'une marque.
         * @param {string} idCorrelation 
         * @param {MarqueRequestDto} marqueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarqueUsingPOST(idCorrelation: string, marqueRequestDto: MarqueRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateMarqueUsingPOST.');
            }
            // verify required parameter 'marqueRequestDto' is not null or undefined
            if (marqueRequestDto === null || marqueRequestDto === undefined) {
                throw new RequiredError('marqueRequestDto','Required parameter marqueRequestDto was null or undefined when calling updateMarqueUsingPOST.');
            }
            const localVarPath = `/api/referentiel/marque/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MarqueRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(marqueRequestDto || {}) : (marqueRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour un motif de MEF.
         * @param {string} idCorrelation ID du motif de MEF, représenté par un UUID
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMotifMefUsingPUT(idCorrelation: string, motifMefRequestDto: MotifMefRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateMotifMefUsingPUT.');
            }
            // verify required parameter 'motifMefRequestDto' is not null or undefined
            if (motifMefRequestDto === null || motifMefRequestDto === undefined) {
                throw new RequiredError('motifMefRequestDto','Required parameter motifMefRequestDto was null or undefined when calling updateMotifMefUsingPUT.');
            }
            const localVarPath = `/api/referentiel/motif-mef/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifMefRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifMefRequestDto || {}) : (motifMefRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier un motif de sortie.
         * @param {string} idCorrelation Identifiant de correlation du motif
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMotifSortieUsingPUT(idCorrelation: string, motifSortieRequestDto: MotifSortieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateMotifSortieUsingPUT.');
            }
            // verify required parameter 'motifSortieRequestDto' is not null or undefined
            if (motifSortieRequestDto === null || motifSortieRequestDto === undefined) {
                throw new RequiredError('motifSortieRequestDto','Required parameter motifSortieRequestDto was null or undefined when calling updateMotifSortieUsingPUT.');
            }
            const localVarPath = `/api/referentiel/motif-sortie/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifSortieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifSortieRequestDto || {}) : (motifSortieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les données de sortie d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateSortieVehiculeRequestDto} updateSortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSortieVehiculeUsingPOST(id: string, updateSortieVehiculeRequestDto: UpdateSortieVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateSortieVehiculeUsingPOST.');
            }
            // verify required parameter 'updateSortieVehiculeRequestDto' is not null or undefined
            if (updateSortieVehiculeRequestDto === null || updateSortieVehiculeRequestDto === undefined) {
                throw new RequiredError('updateSortieVehiculeRequestDto','Required parameter updateSortieVehiculeRequestDto was null or undefined when calling updateSortieVehiculeUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/update-sortie`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateSortieVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateSortieVehiculeRequestDto || {}) : (updateSortieVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier un type d\'AF.
         * @param {string} idCorrelation Identifiant de correlation du type
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTypeAfUsingPUT(idCorrelation: string, typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateTypeAfUsingPUT.');
            }
            // verify required parameter 'typeAutoriteFourriereRequestDto' is not null or undefined
            if (typeAutoriteFourriereRequestDto === null || typeAutoriteFourriereRequestDto === undefined) {
                throw new RequiredError('typeAutoriteFourriereRequestDto','Required parameter typeAutoriteFourriereRequestDto was null or undefined when calling updateTypeAfUsingPUT.');
            }
            const localVarPath = `/api/referentiel/type-autorite-fourriere/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TypeAutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(typeAutoriteFourriereRequestDto || {}) : (typeAutoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour une unité de force de l\'ordre.
         * @param {string} idCorrelation ID de l\'unité force de l\'ordre, représenté par un UUID
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUniteFoUsingPUT(idCorrelation: string, uniteFoRequestDto: UniteFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateUniteFoUsingPUT.');
            }
            // verify required parameter 'uniteFoRequestDto' is not null or undefined
            if (uniteFoRequestDto === null || uniteFoRequestDto === undefined) {
                throw new RequiredError('uniteFoRequestDto','Required parameter uniteFoRequestDto was null or undefined when calling updateUniteFoUsingPUT.');
            }
            const localVarPath = `/api/referentiel/unite-fo/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UniteFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(uniteFoRequestDto || {}) : (uniteFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour une vidéo tutorielle
         * @param {string} idCorrelation ID corrélation de la vidéo tutorielle, représenté par un UUID
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVideoTutorielUsingPUT(idCorrelation: string, videoTutorielRequestDto: VideoTutorielRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateVideoTutorielUsingPUT.');
            }
            // verify required parameter 'videoTutorielRequestDto' is not null or undefined
            if (videoTutorielRequestDto === null || videoTutorielRequestDto === undefined) {
                throw new RequiredError('videoTutorielRequestDto','Required parameter videoTutorielRequestDto was null or undefined when calling updateVideoTutorielUsingPUT.');
            }
            const localVarPath = `/api/referentiel/video-tutoriel/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VideoTutorielRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(videoTutorielRequestDto || {}) : (videoTutorielRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary API permettant d\'uploader le csv d\'apurement des dossiers.
         * @param {any} file Fichier csv contenant les ids des dossiers à apurer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApurementDossiersFileUsingPOST(file: any, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadApurementDossiersFileUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/apurement/dossiers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary API permettant d\'uploader un document spécifique pour un destinataire
           * @param {any} file Fichier du document
         * @param {uploadDocumentSpecifiqueUsingPOSTQueryParams} queryParams objet contenant les query params de la route uploadDocumentSpecifiqueUsingPOST
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentSpecifiqueUsingPOST(file: any, queryParams: UploadDocumentSpecifiqueUsingPOSTQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'nomDocument' is not null or undefined
            if (queryParams.nomDocument === null || queryParams.nomDocument === undefined) {
                throw new RequiredError('nomDocument','Required parameter nomDocument was null or undefined when calling uploadDocumentSpecifiqueUsingPOST.');
            }
            // verify required parameter 'utilisateursDestinataires' is not null or undefined
            if (queryParams.utilisateursDestinataires === null || queryParams.utilisateursDestinataires === undefined) {
                throw new RequiredError('utilisateursDestinataires','Required parameter utilisateursDestinataires was null or undefined when calling uploadDocumentSpecifiqueUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadDocumentSpecifiqueUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/document-specifique`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.nomDocument !== undefined) {
                localVarQueryParameter['nomDocument'] = queryParams.nomDocument;
            }

            if (queryParams.utilisateursDestinataires) {
                localVarQueryParameter['utilisateursDestinataires'] = queryParams.utilisateursDestinataires;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary API permettant d\'uploader une pièce jointe pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPieceJointeUsingPOST1(dossierId: string, type: string, file: any, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling uploadPieceJointeUsingPOST1.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling uploadPieceJointeUsingPOST1.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadPieceJointeUsingPOST1.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{dossierId}/piece-jointe/{type}`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une autorité fourrière.
         * @param {'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR'} field Nom du champ à valider, défini par un enum
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateAutoriteFourriereFieldUsingPOST(field: 'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR', autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateAutoriteFourriereFieldUsingPOST.');
            }
            // verify required parameter 'autoriteFourriereRequestDto' is not null or undefined
            if (autoriteFourriereRequestDto === null || autoriteFourriereRequestDto === undefined) {
                throw new RequiredError('autoriteFourriereRequestDto','Required parameter autoriteFourriereRequestDto was null or undefined when calling validateCreateAutoriteFourriereFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(autoriteFourriereRequestDto || {}) : (autoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une autorité de fourrière.
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateAutoriteFourriereUsingPOST(autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'autoriteFourriereRequestDto' is not null or undefined
            if (autoriteFourriereRequestDto === null || autoriteFourriereRequestDto === undefined) {
                throw new RequiredError('autoriteFourriereRequestDto','Required parameter autoriteFourriereRequestDto was null or undefined when calling validateCreateAutoriteFourriereUsingPOST.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(autoriteFourriereRequestDto || {}) : (autoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une branche.
         * @param {'NATURE' | 'BRANCHE'} field Nom du champ à valider, défini par un enum
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateBrancheFieldUsingPOST(field: 'NATURE' | 'BRANCHE', brancheRequestDto: BrancheRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateBrancheFieldUsingPOST.');
            }
            // verify required parameter 'brancheRequestDto' is not null or undefined
            if (brancheRequestDto === null || brancheRequestDto === undefined) {
                throw new RequiredError('brancheRequestDto','Required parameter brancheRequestDto was null or undefined when calling validateCreateBrancheFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/branche/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BrancheRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(brancheRequestDto || {}) : (brancheRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une branche
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateBrancheUsingPOST(brancheRequestDto: BrancheRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'brancheRequestDto' is not null or undefined
            if (brancheRequestDto === null || brancheRequestDto === undefined) {
                throw new RequiredError('brancheRequestDto','Required parameter brancheRequestDto was null or undefined when calling validateCreateBrancheUsingPOST.');
            }
            const localVarPath = `/api/referentiel/branche/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BrancheRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(brancheRequestDto || {}) : (brancheRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un centre vhu.
         * @param {'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE'} field Nom du champ à valider, défini par un enum
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateCentreVHUFieldUsingPOST(field: 'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE', centreVHURequestDto: CentreVHURequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateCentreVHUFieldUsingPOST.');
            }
            // verify required parameter 'centreVHURequestDto' is not null or undefined
            if (centreVHURequestDto === null || centreVHURequestDto === undefined) {
                throw new RequiredError('centreVHURequestDto','Required parameter centreVHURequestDto was null or undefined when calling validateCreateCentreVHUFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/centre-vhu/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CentreVHURequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(centreVHURequestDto || {}) : (centreVHURequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un centre VHU
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateCentreVHUUsingPOST(centreVHURequestDto: CentreVHURequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'centreVHURequestDto' is not null or undefined
            if (centreVHURequestDto === null || centreVHURequestDto === undefined) {
                throw new RequiredError('centreVHURequestDto','Required parameter centreVHURequestDto was null or undefined when calling validateCreateCentreVHUUsingPOST.');
            }
            const localVarPath = `/api/referentiel/centre-vhu/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CentreVHURequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(centreVHURequestDto || {}) : (centreVHURequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un état de véhicule
         * @param {'ETAT' | 'DETAIL' | 'LIBELLE_COURT'} field Nom du champ à valider, défini par un enum
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateEtatFieldUsingPOST(field: 'ETAT' | 'DETAIL' | 'LIBELLE_COURT', etatRequestDto: EtatRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateEtatFieldUsingPOST.');
            }
            // verify required parameter 'etatRequestDto' is not null or undefined
            if (etatRequestDto === null || etatRequestDto === undefined) {
                throw new RequiredError('etatRequestDto','Required parameter etatRequestDto was null or undefined when calling validateCreateEtatFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/etat/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EtatRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(etatRequestDto || {}) : (etatRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un état de véhicule
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateEtatUsingPOST(etatRequestDto: EtatRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'etatRequestDto' is not null or undefined
            if (etatRequestDto === null || etatRequestDto === undefined) {
                throw new RequiredError('etatRequestDto','Required parameter etatRequestDto was null or undefined when calling validateCreateEtatUsingPOST.');
            }
            const localVarPath = `/api/referentiel/etat/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EtatRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(etatRequestDto || {}) : (etatRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un lien de bas de page
         * @param {'LINK' | 'TEXT' | 'PROFILE'} field Nom du champ à valider, défini par un enum
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateFooterLinkFieldUsingPOST(field: 'LINK' | 'TEXT' | 'PROFILE', footerLinkRequestDto: FooterLinkRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateFooterLinkFieldUsingPOST.');
            }
            // verify required parameter 'footerLinkRequestDto' is not null or undefined
            if (footerLinkRequestDto === null || footerLinkRequestDto === undefined) {
                throw new RequiredError('footerLinkRequestDto','Required parameter footerLinkRequestDto was null or undefined when calling validateCreateFooterLinkFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/footer-link/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FooterLinkRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(footerLinkRequestDto || {}) : (footerLinkRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un lien de bas de page
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateFooterLinkUsingPOST(footerLinkRequestDto: FooterLinkRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'footerLinkRequestDto' is not null or undefined
            if (footerLinkRequestDto === null || footerLinkRequestDto === undefined) {
                throw new RequiredError('footerLinkRequestDto','Required parameter footerLinkRequestDto was null or undefined when calling validateCreateFooterLinkUsingPOST.');
            }
            const localVarPath = `/api/referentiel/footer-link/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FooterLinkRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(footerLinkRequestDto || {}) : (footerLinkRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une fourrière.
         * @param {'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION'} field Nom du champ à valider, défini par un enum
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateFourriereFieldUsingPOST(field: 'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION', fourriereRequestDto: FourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateFourriereFieldUsingPOST.');
            }
            // verify required parameter 'fourriereRequestDto' is not null or undefined
            if (fourriereRequestDto === null || fourriereRequestDto === undefined) {
                throw new RequiredError('fourriereRequestDto','Required parameter fourriereRequestDto was null or undefined when calling validateCreateFourriereFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/fourriere/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fourriereRequestDto || {}) : (fourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une fourrière.
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateFourriereUsingPOST(fourriereRequestDto: FourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'fourriereRequestDto' is not null or undefined
            if (fourriereRequestDto === null || fourriereRequestDto === undefined) {
                throw new RequiredError('fourriereRequestDto','Required parameter fourriereRequestDto was null or undefined when calling validateCreateFourriereUsingPOST.');
            }
            const localVarPath = `/api/referentiel/fourriere/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fourriereRequestDto || {}) : (fourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un genre simplifié
         * @param {'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES'} field Nom du champ à valider, défini par un enum
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateGenreSimplifieFieldUsingPOST(field: 'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES', genreSimplifieRequestDto: GenreSimplifieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateGenreSimplifieFieldUsingPOST.');
            }
            // verify required parameter 'genreSimplifieRequestDto' is not null or undefined
            if (genreSimplifieRequestDto === null || genreSimplifieRequestDto === undefined) {
                throw new RequiredError('genreSimplifieRequestDto','Required parameter genreSimplifieRequestDto was null or undefined when calling validateCreateGenreSimplifieFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GenreSimplifieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(genreSimplifieRequestDto || {}) : (genreSimplifieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un genre simplifié
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateGenreSimplifieUsingPOST(genreSimplifieRequestDto: GenreSimplifieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'genreSimplifieRequestDto' is not null or undefined
            if (genreSimplifieRequestDto === null || genreSimplifieRequestDto === undefined) {
                throw new RequiredError('genreSimplifieRequestDto','Required parameter genreSimplifieRequestDto was null or undefined when calling validateCreateGenreSimplifieUsingPOST.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GenreSimplifieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(genreSimplifieRequestDto || {}) : (genreSimplifieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une juridiction
         * @param {'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE'} field Nom du champ à valider, défini par un enum
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateJuridictionFieldUsingPOST(field: 'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE', juridictionRequestDto: JuridictionRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateJuridictionFieldUsingPOST.');
            }
            // verify required parameter 'juridictionRequestDto' is not null or undefined
            if (juridictionRequestDto === null || juridictionRequestDto === undefined) {
                throw new RequiredError('juridictionRequestDto','Required parameter juridictionRequestDto was null or undefined when calling validateCreateJuridictionFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/juridiction/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"JuridictionRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(juridictionRequestDto || {}) : (juridictionRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une juridiction
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateJuridictionUsingPOST(juridictionRequestDto: JuridictionRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'juridictionRequestDto' is not null or undefined
            if (juridictionRequestDto === null || juridictionRequestDto === undefined) {
                throw new RequiredError('juridictionRequestDto','Required parameter juridictionRequestDto was null or undefined when calling validateCreateJuridictionUsingPOST.');
            }
            const localVarPath = `/api/referentiel/juridiction/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"JuridictionRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(juridictionRequestDto || {}) : (juridictionRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un motif de MEF.
         * @param {'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO'} field Nom du champ à valider, défini par un enum
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateMotifMefFieldUsingPOST(field: 'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO', motifMefRequestDto: MotifMefRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateMotifMefFieldUsingPOST.');
            }
            // verify required parameter 'motifMefRequestDto' is not null or undefined
            if (motifMefRequestDto === null || motifMefRequestDto === undefined) {
                throw new RequiredError('motifMefRequestDto','Required parameter motifMefRequestDto was null or undefined when calling validateCreateMotifMefFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/motif-mef/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifMefRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifMefRequestDto || {}) : (motifMefRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un motif de MEF.
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateMotifMefUsingPOST(motifMefRequestDto: MotifMefRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'motifMefRequestDto' is not null or undefined
            if (motifMefRequestDto === null || motifMefRequestDto === undefined) {
                throw new RequiredError('motifMefRequestDto','Required parameter motifMefRequestDto was null or undefined when calling validateCreateMotifMefUsingPOST.');
            }
            const localVarPath = `/api/referentiel/motif-mef/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifMefRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifMefRequestDto || {}) : (motifMefRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un motif de sortie.
         * @param {'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT'} field Nom du champ à valider, défini par un enum
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateMotifSortieFieldUsingPOST(field: 'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT', motifSortieRequestDto: MotifSortieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateMotifSortieFieldUsingPOST.');
            }
            // verify required parameter 'motifSortieRequestDto' is not null or undefined
            if (motifSortieRequestDto === null || motifSortieRequestDto === undefined) {
                throw new RequiredError('motifSortieRequestDto','Required parameter motifSortieRequestDto was null or undefined when calling validateCreateMotifSortieFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/motif-sortie/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifSortieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifSortieRequestDto || {}) : (motifSortieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un motif de sortie.
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateMotifSortieUsingPOST(motifSortieRequestDto: MotifSortieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'motifSortieRequestDto' is not null or undefined
            if (motifSortieRequestDto === null || motifSortieRequestDto === undefined) {
                throw new RequiredError('motifSortieRequestDto','Required parameter motifSortieRequestDto was null or undefined when calling validateCreateMotifSortieUsingPOST.');
            }
            const localVarPath = `/api/referentiel/motif-sortie/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifSortieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifSortieRequestDto || {}) : (motifSortieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un type d\'AF.
         * @param {'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2'} field Nom du champ à valider, défini par un enum
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateTypeAFFieldUsingPOST(field: 'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2', typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateTypeAFFieldUsingPOST.');
            }
            // verify required parameter 'typeAutoriteFourriereRequestDto' is not null or undefined
            if (typeAutoriteFourriereRequestDto === null || typeAutoriteFourriereRequestDto === undefined) {
                throw new RequiredError('typeAutoriteFourriereRequestDto','Required parameter typeAutoriteFourriereRequestDto was null or undefined when calling validateCreateTypeAFFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/type-autorite-fourriere/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TypeAutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(typeAutoriteFourriereRequestDto || {}) : (typeAutoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un type d\'AF.
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateTypeAfUsingPOST(typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'typeAutoriteFourriereRequestDto' is not null or undefined
            if (typeAutoriteFourriereRequestDto === null || typeAutoriteFourriereRequestDto === undefined) {
                throw new RequiredError('typeAutoriteFourriereRequestDto','Required parameter typeAutoriteFourriereRequestDto was null or undefined when calling validateCreateTypeAfUsingPOST.');
            }
            const localVarPath = `/api/referentiel/type-autorite-fourriere/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TypeAutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(typeAutoriteFourriereRequestDto || {}) : (typeAutoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une unité FO.
         * @param {'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT'} field Nom du champ à valider, défini par un enum
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateUniteFoFieldUsingPOST(field: 'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT', uniteFoRequestDto: UniteFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateUniteFoFieldUsingPOST.');
            }
            // verify required parameter 'uniteFoRequestDto' is not null or undefined
            if (uniteFoRequestDto === null || uniteFoRequestDto === undefined) {
                throw new RequiredError('uniteFoRequestDto','Required parameter uniteFoRequestDto was null or undefined when calling validateCreateUniteFoFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/unite-fo/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UniteFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(uniteFoRequestDto || {}) : (uniteFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une unite FO.
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateUniteFoUsingPOST(uniteFoRequestDto: UniteFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'uniteFoRequestDto' is not null or undefined
            if (uniteFoRequestDto === null || uniteFoRequestDto === undefined) {
                throw new RequiredError('uniteFoRequestDto','Required parameter uniteFoRequestDto was null or undefined when calling validateCreateUniteFoUsingPOST.');
            }
            const localVarPath = `/api/referentiel/unite-fo/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UniteFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(uniteFoRequestDto || {}) : (uniteFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une vidéo tutorielle.
         * @param {'VIDEO_ID' | 'PROFILE'} field Nom du champ à valider, défini par un enum
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateVideoTutorielFieldUsingPOST(field: 'VIDEO_ID' | 'PROFILE', videoTutorielRequestDto: VideoTutorielRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateVideoTutorielFieldUsingPOST.');
            }
            // verify required parameter 'videoTutorielRequestDto' is not null or undefined
            if (videoTutorielRequestDto === null || videoTutorielRequestDto === undefined) {
                throw new RequiredError('videoTutorielRequestDto','Required parameter videoTutorielRequestDto was null or undefined when calling validateCreateVideoTutorielFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/videoTutoriel/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VideoTutorielRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(videoTutorielRequestDto || {}) : (videoTutorielRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une vidéo tutorielle
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateVideoTutorielUsingPOST(videoTutorielRequestDto: VideoTutorielRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'videoTutorielRequestDto' is not null or undefined
            if (videoTutorielRequestDto === null || videoTutorielRequestDto === undefined) {
                throw new RequiredError('videoTutorielRequestDto','Required parameter videoTutorielRequestDto was null or undefined when calling validateCreateVideoTutorielUsingPOST.');
            }
            const localVarPath = `/api/referentiel/videoTutoriel/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VideoTutorielRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(videoTutorielRequestDto || {}) : (videoTutorielRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de l\'entité ExportStatistiques.
         * @param {ExportStatistiquesRequestDto} exportStatistiquesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExportStatistiquesRequestUsingPOST(exportStatistiquesRequestDto: ExportStatistiquesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'exportStatistiquesRequestDto' is not null or undefined
            if (exportStatistiquesRequestDto === null || exportStatistiquesRequestDto === undefined) {
                throw new RequiredError('exportStatistiquesRequestDto','Required parameter exportStatistiquesRequestDto was null or undefined when calling validateExportStatistiquesRequestUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/administration-avancee/export-statistiques/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ExportStatistiquesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(exportStatistiquesRequestDto || {}) : (exportStatistiquesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un domaine faq.
         * @param {'NAME'} field Nom du champ à valider, défini par un enum
         * @param {FaqDomainRequestDto} faqDomainRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFaqDomainFieldUsingPOST(field: 'NAME', faqDomainRequestDto: FaqDomainRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFaqDomainFieldUsingPOST.');
            }
            // verify required parameter 'faqDomainRequestDto' is not null or undefined
            if (faqDomainRequestDto === null || faqDomainRequestDto === undefined) {
                throw new RequiredError('faqDomainRequestDto','Required parameter faqDomainRequestDto was null or undefined when calling validateFaqDomainFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/faq-domain/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FaqDomainRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(faqDomainRequestDto || {}) : (faqDomainRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un domaine faq
         * @param {FaqDomainRequestDto} faqDomainRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFaqDomainUsingPOST(faqDomainRequestDto: FaqDomainRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'faqDomainRequestDto' is not null or undefined
            if (faqDomainRequestDto === null || faqDomainRequestDto === undefined) {
                throw new RequiredError('faqDomainRequestDto','Required parameter faqDomainRequestDto was null or undefined when calling validateFaqDomainUsingPOST.');
            }
            const localVarPath = `/api/referentiel/faq-domain/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FaqDomainRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(faqDomainRequestDto || {}) : (faqDomainRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une question
         * @param {'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT'} field Nom du champ à valider, défini par un enum
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFaqFieldUsingPOST(field: 'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT', faqRequestDto: FaqRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFaqFieldUsingPOST.');
            }
            // verify required parameter 'faqRequestDto' is not null or undefined
            if (faqRequestDto === null || faqRequestDto === undefined) {
                throw new RequiredError('faqRequestDto','Required parameter faqRequestDto was null or undefined when calling validateFaqFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FaqRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(faqRequestDto || {}) : (faqRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une question
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFaqUsingPOST(faqRequestDto: FaqRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'faqRequestDto' is not null or undefined
            if (faqRequestDto === null || faqRequestDto === undefined) {
                throw new RequiredError('faqRequestDto','Required parameter faqRequestDto was null or undefined when calling validateFaqUsingPOST.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FaqRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(faqRequestDto || {}) : (faqRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications du classement d\'un dossier
         * @param {'JUSTIFICATION' | 'NEW_CLASSEMENT'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateClassementRequestDto} updateClassementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFieldUpdateClassementUsingPOST(field: 'JUSTIFICATION' | 'NEW_CLASSEMENT', id: string, updateClassementRequestDto: UpdateClassementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFieldUpdateClassementUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateFieldUpdateClassementUsingPOST.');
            }
            // verify required parameter 'updateClassementRequestDto' is not null or undefined
            if (updateClassementRequestDto === null || updateClassementRequestDto === undefined) {
                throw new RequiredError('updateClassementRequestDto','Required parameter updateClassementRequestDto was null or undefined when calling validateFieldUpdateClassementUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/classement/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateClassementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateClassementRequestDto || {}) : (updateClassementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications de la notification manuelle d\'un dossier
         * @param {'NEW_DATE_ENVOI' | 'NEW_DATE_SIGNATURE' | 'NEW_ETAT_DISTRIBUTION' | 'JUSTIFICATION'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {FixDataNotificationManuelleRequestDto} fixDataNotificationManuelleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFixDataNotificationManuelleFieldUsingPOST(field: 'NEW_DATE_ENVOI' | 'NEW_DATE_SIGNATURE' | 'NEW_ETAT_DISTRIBUTION' | 'JUSTIFICATION', id: string, fixDataNotificationManuelleRequestDto: FixDataNotificationManuelleRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFixDataNotificationManuelleFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateFixDataNotificationManuelleFieldUsingPOST.');
            }
            // verify required parameter 'fixDataNotificationManuelleRequestDto' is not null or undefined
            if (fixDataNotificationManuelleRequestDto === null || fixDataNotificationManuelleRequestDto === undefined) {
                throw new RequiredError('fixDataNotificationManuelleRequestDto','Required parameter fixDataNotificationManuelleRequestDto was null or undefined when calling validateFixDataNotificationManuelleFieldUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/notification-manuelle/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FixDataNotificationManuelleRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fixDataNotificationManuelleRequestDto || {}) : (fixDataNotificationManuelleRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications de la notification manuelle d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {FixDataNotificationManuelleRequestDto} fixDataNotificationManuelleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFixDataNotificationManuelleUsingPOST(id: string, fixDataNotificationManuelleRequestDto: FixDataNotificationManuelleRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateFixDataNotificationManuelleUsingPOST.');
            }
            // verify required parameter 'fixDataNotificationManuelleRequestDto' is not null or undefined
            if (fixDataNotificationManuelleRequestDto === null || fixDataNotificationManuelleRequestDto === undefined) {
                throw new RequiredError('fixDataNotificationManuelleRequestDto','Required parameter fixDataNotificationManuelleRequestDto was null or undefined when calling validateFixDataNotificationManuelleUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/notification-manuelle/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FixDataNotificationManuelleRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fixDataNotificationManuelleRequestDto || {}) : (fixDataNotificationManuelleRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications d\'un champ de la migration d\'unité FO
         * @param {'NEW_UNITE_FO_CORRELATION_ID' | 'OLD_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
         * @param {MigrateUniteFoRequestDto} migrateUniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMigrateUniteFoFieldUsingPOST(field: 'NEW_UNITE_FO_CORRELATION_ID' | 'OLD_UNITE_FO_CORRELATION_ID' | 'COMMENT', migrateUniteFoRequestDto: MigrateUniteFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateMigrateUniteFoFieldUsingPOST.');
            }
            // verify required parameter 'migrateUniteFoRequestDto' is not null or undefined
            if (migrateUniteFoRequestDto === null || migrateUniteFoRequestDto === undefined) {
                throw new RequiredError('migrateUniteFoRequestDto','Required parameter migrateUniteFoRequestDto was null or undefined when calling validateMigrateUniteFoFieldUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/migrate-unite-fo/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MigrateUniteFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(migrateUniteFoRequestDto || {}) : (migrateUniteFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications de la migration d\'unité FO
         * @param {MigrateUniteFoRequestDto} migrateUniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMigrateUniteFoUsingPOST(migrateUniteFoRequestDto: MigrateUniteFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'migrateUniteFoRequestDto' is not null or undefined
            if (migrateUniteFoRequestDto === null || migrateUniteFoRequestDto === undefined) {
                throw new RequiredError('migrateUniteFoRequestDto','Required parameter migrateUniteFoRequestDto was null or undefined when calling validateMigrateUniteFoUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/migrate-unite-fo/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MigrateUniteFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(migrateUniteFoRequestDto || {}) : (migrateUniteFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une autorité fourrière.
         * @param {'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID de l\'autorite de fourrière, représenté par un UUID
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateAutoriteFourriereFieldUsingPOST(field: 'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR', idCorrelation: string, autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateAutoriteFourriereFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateAutoriteFourriereFieldUsingPOST.');
            }
            // verify required parameter 'autoriteFourriereRequestDto' is not null or undefined
            if (autoriteFourriereRequestDto === null || autoriteFourriereRequestDto === undefined) {
                throw new RequiredError('autoriteFourriereRequestDto','Required parameter autoriteFourriereRequestDto was null or undefined when calling validateUpdateAutoriteFourriereFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/update/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(autoriteFourriereRequestDto || {}) : (autoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une autorité de fourrière.
         * @param {string} idCorrelation ID de l\'autorite de fourrière, représenté par un UUID
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateAutoriteFourriereUsingPOST(idCorrelation: string, autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateAutoriteFourriereUsingPOST.');
            }
            // verify required parameter 'autoriteFourriereRequestDto' is not null or undefined
            if (autoriteFourriereRequestDto === null || autoriteFourriereRequestDto === undefined) {
                throw new RequiredError('autoriteFourriereRequestDto','Required parameter autoriteFourriereRequestDto was null or undefined when calling validateUpdateAutoriteFourriereUsingPOST.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/update/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(autoriteFourriereRequestDto || {}) : (autoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une branche.
         * @param {'NATURE' | 'BRANCHE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation de la branche, représenté par un UUID
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateBrancheFieldUsingPOST(field: 'NATURE' | 'BRANCHE', idCorrelation: string, brancheRequestDto: BrancheRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateBrancheFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateBrancheFieldUsingPOST.');
            }
            // verify required parameter 'brancheRequestDto' is not null or undefined
            if (brancheRequestDto === null || brancheRequestDto === undefined) {
                throw new RequiredError('brancheRequestDto','Required parameter brancheRequestDto was null or undefined when calling validateUpdateBrancheFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/branche/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BrancheRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(brancheRequestDto || {}) : (brancheRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une branche
         * @param {string} idCorrelation ID corrélation de la branche, représenté par un UUID
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateBrancheUsingPOST(idCorrelation: string, brancheRequestDto: BrancheRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateBrancheUsingPOST.');
            }
            // verify required parameter 'brancheRequestDto' is not null or undefined
            if (brancheRequestDto === null || brancheRequestDto === undefined) {
                throw new RequiredError('brancheRequestDto','Required parameter brancheRequestDto was null or undefined when calling validateUpdateBrancheUsingPOST.');
            }
            const localVarPath = `/api/referentiel/branche/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BrancheRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(brancheRequestDto || {}) : (brancheRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un centre vhu.
         * @param {'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation du centre vhu à mettre à jour
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateCentreVHUFieldUsingPOST(field: 'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE', idCorrelation: string, centreVHURequestDto: CentreVHURequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateCentreVHUFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateCentreVHUFieldUsingPOST.');
            }
            // verify required parameter 'centreVHURequestDto' is not null or undefined
            if (centreVHURequestDto === null || centreVHURequestDto === undefined) {
                throw new RequiredError('centreVHURequestDto','Required parameter centreVHURequestDto was null or undefined when calling validateUpdateCentreVHUFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/centre-vhu/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CentreVHURequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(centreVHURequestDto || {}) : (centreVHURequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un centre vhu.
         * @param {string} idCorrelation Id de corrélation du centre vhu à mettre à jour
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateCentreVHUUsingPOST(idCorrelation: string, centreVHURequestDto: CentreVHURequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateCentreVHUUsingPOST.');
            }
            // verify required parameter 'centreVHURequestDto' is not null or undefined
            if (centreVHURequestDto === null || centreVHURequestDto === undefined) {
                throw new RequiredError('centreVHURequestDto','Required parameter centreVHURequestDto was null or undefined when calling validateUpdateCentreVHUUsingPOST.');
            }
            const localVarPath = `/api/referentiel/centre-vhu/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CentreVHURequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(centreVHURequestDto || {}) : (centreVHURequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications du classement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateClassementRequestDto} updateClassementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateClassementUsingPOST(id: string, updateClassementRequestDto: UpdateClassementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateClassementUsingPOST.');
            }
            // verify required parameter 'updateClassementRequestDto' is not null or undefined
            if (updateClassementRequestDto === null || updateClassementRequestDto === undefined) {
                throw new RequiredError('updateClassementRequestDto','Required parameter updateClassementRequestDto was null or undefined when calling validateUpdateClassementUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/classement/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateClassementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateClassementRequestDto || {}) : (updateClassementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider une modification des données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
         * @param {'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeFieldUsingPOST(field: 'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF', id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateDonneesInterieurVehiculeFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateDonneesInterieurVehiculeFieldUsingPOST.');
            }
            // verify required parameter 'updateDonneesInterieurVehiculeRequestDto' is not null or undefined
            if (updateDonneesInterieurVehiculeRequestDto === null || updateDonneesInterieurVehiculeRequestDto === undefined) {
                throw new RequiredError('updateDonneesInterieurVehiculeRequestDto','Required parameter updateDonneesInterieurVehiculeRequestDto was null or undefined when calling validateUpdateDonneesInterieurVehiculeFieldUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/vehicule/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesInterieurVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesInterieurVehiculeRequestDto || {}) : (updateDonneesInterieurVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications des données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateDonneesInterieurVehiculeUsingPOST.');
            }
            // verify required parameter 'updateDonneesInterieurVehiculeRequestDto' is not null or undefined
            if (updateDonneesInterieurVehiculeRequestDto === null || updateDonneesInterieurVehiculeRequestDto === undefined) {
                throw new RequiredError('updateDonneesInterieurVehiculeRequestDto','Required parameter updateDonneesInterieurVehiculeRequestDto was null or undefined when calling validateUpdateDonneesInterieurVehiculeUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/vehicule/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesInterieurVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesInterieurVehiculeRequestDto || {}) : (updateDonneesInterieurVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider une modification des données judiciaires d\'un dossier
         * @param {'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesJudiciairesFieldUsingPOST1(field: 'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE', id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateDonneesJudiciairesFieldUsingPOST1.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateDonneesJudiciairesFieldUsingPOST1.');
            }
            // verify required parameter 'updateDonneesJudiciairesRequestDto' is not null or undefined
            if (updateDonneesJudiciairesRequestDto === null || updateDonneesJudiciairesRequestDto === undefined) {
                throw new RequiredError('updateDonneesJudiciairesRequestDto','Required parameter updateDonneesJudiciairesRequestDto was null or undefined when calling validateUpdateDonneesJudiciairesFieldUsingPOST1.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/judiciaires/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesJudiciairesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesJudiciairesRequestDto || {}) : (updateDonneesJudiciairesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications des données judiciaires d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesJudiciairesUsingPOST1(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateDonneesJudiciairesUsingPOST1.');
            }
            // verify required parameter 'updateDonneesJudiciairesRequestDto' is not null or undefined
            if (updateDonneesJudiciairesRequestDto === null || updateDonneesJudiciairesRequestDto === undefined) {
                throw new RequiredError('updateDonneesJudiciairesRequestDto','Required parameter updateDonneesJudiciairesRequestDto was null or undefined when calling validateUpdateDonneesJudiciairesUsingPOST1.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/judiciaires/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesJudiciairesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesJudiciairesRequestDto || {}) : (updateDonneesJudiciairesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications des entitées de rattachement d\'un dossier
         * @param {'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementFieldUsingPOST(field: 'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT', id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateEntitesRattachementFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateEntitesRattachementFieldUsingPOST.');
            }
            // verify required parameter 'updateEntitesRattachementRequestDto' is not null or undefined
            if (updateEntitesRattachementRequestDto === null || updateEntitesRattachementRequestDto === undefined) {
                throw new RequiredError('updateEntitesRattachementRequestDto','Required parameter updateEntitesRattachementRequestDto was null or undefined when calling validateUpdateEntitesRattachementFieldUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/entites-rattachement/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateEntitesRattachementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateEntitesRattachementRequestDto || {}) : (updateEntitesRattachementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications des entitées de rattachement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateEntitesRattachementUsingPOST.');
            }
            // verify required parameter 'updateEntitesRattachementRequestDto' is not null or undefined
            if (updateEntitesRattachementRequestDto === null || updateEntitesRattachementRequestDto === undefined) {
                throw new RequiredError('updateEntitesRattachementRequestDto','Required parameter updateEntitesRattachementRequestDto was null or undefined when calling validateUpdateEntitesRattachementUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/entites-rattachement/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateEntitesRattachementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateEntitesRattachementRequestDto || {}) : (updateEntitesRattachementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un état de véhicule
         * @param {'ETAT' | 'DETAIL' | 'LIBELLE_COURT'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation de l\'état, représenté par un UUID
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEtatFieldUsingPOST(field: 'ETAT' | 'DETAIL' | 'LIBELLE_COURT', idCorrelation: string, etatRequestDto: EtatRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateEtatFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateEtatFieldUsingPOST.');
            }
            // verify required parameter 'etatRequestDto' is not null or undefined
            if (etatRequestDto === null || etatRequestDto === undefined) {
                throw new RequiredError('etatRequestDto','Required parameter etatRequestDto was null or undefined when calling validateUpdateEtatFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/etat/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EtatRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(etatRequestDto || {}) : (etatRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un état de véhicule
         * @param {string} idCorrelation ID corrélation de l\'état, représenté par un UUID
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEtatUsingPOST(idCorrelation: string, etatRequestDto: EtatRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateEtatUsingPOST.');
            }
            // verify required parameter 'etatRequestDto' is not null or undefined
            if (etatRequestDto === null || etatRequestDto === undefined) {
                throw new RequiredError('etatRequestDto','Required parameter etatRequestDto was null or undefined when calling validateUpdateEtatUsingPOST.');
            }
            const localVarPath = `/api/referentiel/etat/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EtatRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(etatRequestDto || {}) : (etatRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de modification d\'une question
         * @param {'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation de la question à mettre à jour
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFaqFieldUsingPOST(field: 'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT', idCorrelation: string, faqRequestDto: FaqRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateFaqFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateFaqFieldUsingPOST.');
            }
            // verify required parameter 'faqRequestDto' is not null or undefined
            if (faqRequestDto === null || faqRequestDto === undefined) {
                throw new RequiredError('faqRequestDto','Required parameter faqRequestDto was null or undefined when calling validateUpdateFaqFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FaqRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(faqRequestDto || {}) : (faqRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de la modification d\'une question
         * @param {string} idCorrelation Id de corrélation de la question à mettre à jour
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFaqUsingPOST(idCorrelation: string, faqRequestDto: FaqRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateFaqUsingPOST.');
            }
            // verify required parameter 'faqRequestDto' is not null or undefined
            if (faqRequestDto === null || faqRequestDto === undefined) {
                throw new RequiredError('faqRequestDto','Required parameter faqRequestDto was null or undefined when calling validateUpdateFaqUsingPOST.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FaqRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(faqRequestDto || {}) : (faqRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un lien de bas de page
         * @param {'LINK' | 'TEXT' | 'PROFILE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation du lien de bas de page, représenté par un UUID
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFooterLinkFieldUsingPOST(field: 'LINK' | 'TEXT' | 'PROFILE', idCorrelation: string, footerLinkRequestDto: FooterLinkRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateFooterLinkFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateFooterLinkFieldUsingPOST.');
            }
            // verify required parameter 'footerLinkRequestDto' is not null or undefined
            if (footerLinkRequestDto === null || footerLinkRequestDto === undefined) {
                throw new RequiredError('footerLinkRequestDto','Required parameter footerLinkRequestDto was null or undefined when calling validateUpdateFooterLinkFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/footer-link/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FooterLinkRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(footerLinkRequestDto || {}) : (footerLinkRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un lien de bas de page
         * @param {string} idCorrelation ID corrélation du lien de bas de page, représenté par un UUID
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFooterLinkUsingPOST(idCorrelation: string, footerLinkRequestDto: FooterLinkRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateFooterLinkUsingPOST.');
            }
            // verify required parameter 'footerLinkRequestDto' is not null or undefined
            if (footerLinkRequestDto === null || footerLinkRequestDto === undefined) {
                throw new RequiredError('footerLinkRequestDto','Required parameter footerLinkRequestDto was null or undefined when calling validateUpdateFooterLinkUsingPOST.');
            }
            const localVarPath = `/api/referentiel/footer-link/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FooterLinkRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(footerLinkRequestDto || {}) : (footerLinkRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une fourrière.
         * @param {'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation de la fourrière à mettre à jour
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFourriereFieldUsingPOST(field: 'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION', idCorrelation: string, fourriereRequestDto: FourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateFourriereFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateFourriereFieldUsingPOST.');
            }
            // verify required parameter 'fourriereRequestDto' is not null or undefined
            if (fourriereRequestDto === null || fourriereRequestDto === undefined) {
                throw new RequiredError('fourriereRequestDto','Required parameter fourriereRequestDto was null or undefined when calling validateUpdateFourriereFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/fourriere/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fourriereRequestDto || {}) : (fourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une fourrière.
         * @param {string} idCorrelation Id de corrélation de la fourrière à mettre à jour
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFourriereUsingPOST(idCorrelation: string, fourriereRequestDto: FourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateFourriereUsingPOST.');
            }
            // verify required parameter 'fourriereRequestDto' is not null or undefined
            if (fourriereRequestDto === null || fourriereRequestDto === undefined) {
                throw new RequiredError('fourriereRequestDto','Required parameter fourriereRequestDto was null or undefined when calling validateUpdateFourriereUsingPOST.');
            }
            const localVarPath = `/api/referentiel/fourriere/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fourriereRequestDto || {}) : (fourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un genre simplifié
         * @param {'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation de le genre simplifié, représenté par un UUID
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateGenreSimplifieFieldUsingPOST(field: 'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES', idCorrelation: string, genreSimplifieRequestDto: GenreSimplifieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateGenreSimplifieFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateGenreSimplifieFieldUsingPOST.');
            }
            // verify required parameter 'genreSimplifieRequestDto' is not null or undefined
            if (genreSimplifieRequestDto === null || genreSimplifieRequestDto === undefined) {
                throw new RequiredError('genreSimplifieRequestDto','Required parameter genreSimplifieRequestDto was null or undefined when calling validateUpdateGenreSimplifieFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GenreSimplifieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(genreSimplifieRequestDto || {}) : (genreSimplifieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un genre simplifié
         * @param {string} idCorrelation ID corrélation de le genre simplifié, représenté par un UUID
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateGenreSimplifieUsingPOST(idCorrelation: string, genreSimplifieRequestDto: GenreSimplifieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateGenreSimplifieUsingPOST.');
            }
            // verify required parameter 'genreSimplifieRequestDto' is not null or undefined
            if (genreSimplifieRequestDto === null || genreSimplifieRequestDto === undefined) {
                throw new RequiredError('genreSimplifieRequestDto','Required parameter genreSimplifieRequestDto was null or undefined when calling validateUpdateGenreSimplifieUsingPOST.');
            }
            const localVarPath = `/api/referentiel/genre-simplifie/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GenreSimplifieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(genreSimplifieRequestDto || {}) : (genreSimplifieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une juridiction
         * @param {'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation de la juridiction, représenté par un UUID
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateJuridictionFieldUsingPOST(field: 'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE', idCorrelation: string, juridictionRequestDto: JuridictionRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateJuridictionFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateJuridictionFieldUsingPOST.');
            }
            // verify required parameter 'juridictionRequestDto' is not null or undefined
            if (juridictionRequestDto === null || juridictionRequestDto === undefined) {
                throw new RequiredError('juridictionRequestDto','Required parameter juridictionRequestDto was null or undefined when calling validateUpdateJuridictionFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/juridiction/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"JuridictionRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(juridictionRequestDto || {}) : (juridictionRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une juridiction
         * @param {string} idCorrelation ID corrélation de la juridiction, représenté par un UUID
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateJuridictionUsingPOST(idCorrelation: string, juridictionRequestDto: JuridictionRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateJuridictionUsingPOST.');
            }
            // verify required parameter 'juridictionRequestDto' is not null or undefined
            if (juridictionRequestDto === null || juridictionRequestDto === undefined) {
                throw new RequiredError('juridictionRequestDto','Required parameter juridictionRequestDto was null or undefined when calling validateUpdateJuridictionUsingPOST.');
            }
            const localVarPath = `/api/referentiel/juridiction/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"JuridictionRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(juridictionRequestDto || {}) : (juridictionRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une marque.
         * @param {'CATEGORIE' | 'TYPE' | 'MARQUE_EXACTE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation de la marque à mettre à jour
         * @param {MarqueRequestDto} marqueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMarqueFieldUsingPOST(field: 'CATEGORIE' | 'TYPE' | 'MARQUE_EXACTE', idCorrelation: string, marqueRequestDto: MarqueRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateMarqueFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateMarqueFieldUsingPOST.');
            }
            // verify required parameter 'marqueRequestDto' is not null or undefined
            if (marqueRequestDto === null || marqueRequestDto === undefined) {
                throw new RequiredError('marqueRequestDto','Required parameter marqueRequestDto was null or undefined when calling validateUpdateMarqueFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/marque/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MarqueRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(marqueRequestDto || {}) : (marqueRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une marque.
         * @param {string} idCorrelation Id de corrélation de la marque à mettre à jour
         * @param {MarqueRequestDto} marqueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMarqueUsingPOST(idCorrelation: string, marqueRequestDto: MarqueRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateMarqueUsingPOST.');
            }
            // verify required parameter 'marqueRequestDto' is not null or undefined
            if (marqueRequestDto === null || marqueRequestDto === undefined) {
                throw new RequiredError('marqueRequestDto','Required parameter marqueRequestDto was null or undefined when calling validateUpdateMarqueUsingPOST.');
            }
            const localVarPath = `/api/referentiel/marque/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MarqueRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(marqueRequestDto || {}) : (marqueRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un motif de mef.
         * @param {'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation du motif de MEF à mettre à jour
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMotifMefFieldUsingPOST(field: 'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO', idCorrelation: string, motifMefRequestDto: MotifMefRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateMotifMefFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateMotifMefFieldUsingPOST.');
            }
            // verify required parameter 'motifMefRequestDto' is not null or undefined
            if (motifMefRequestDto === null || motifMefRequestDto === undefined) {
                throw new RequiredError('motifMefRequestDto','Required parameter motifMefRequestDto was null or undefined when calling validateUpdateMotifMefFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/motif-mef/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifMefRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifMefRequestDto || {}) : (motifMefRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un motif de MEF.
         * @param {string} idCorrelation Id de corrélation du motif à mettre à jour
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMotifMefUsingPOST(idCorrelation: string, motifMefRequestDto: MotifMefRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateMotifMefUsingPOST.');
            }
            // verify required parameter 'motifMefRequestDto' is not null or undefined
            if (motifMefRequestDto === null || motifMefRequestDto === undefined) {
                throw new RequiredError('motifMefRequestDto','Required parameter motifMefRequestDto was null or undefined when calling validateUpdateMotifMefUsingPOST.');
            }
            const localVarPath = `/api/referentiel/motif-mef/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifMefRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifMefRequestDto || {}) : (motifMefRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un motif de sortie.
         * @param {'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Identifiant de correlation du motif
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMotifSortieFieldUsingPUT(field: 'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT', idCorrelation: string, motifSortieRequestDto: MotifSortieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateMotifSortieFieldUsingPUT.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateMotifSortieFieldUsingPUT.');
            }
            // verify required parameter 'motifSortieRequestDto' is not null or undefined
            if (motifSortieRequestDto === null || motifSortieRequestDto === undefined) {
                throw new RequiredError('motifSortieRequestDto','Required parameter motifSortieRequestDto was null or undefined when calling validateUpdateMotifSortieFieldUsingPUT.');
            }
            const localVarPath = `/api/referentiel/motif-sortie/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifSortieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifSortieRequestDto || {}) : (motifSortieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un motif de sortie.
         * @param {string} idCorrelation Identifiant de correlation du motif
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMotifSortieUsingPOST(idCorrelation: string, motifSortieRequestDto: MotifSortieRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateMotifSortieUsingPOST.');
            }
            // verify required parameter 'motifSortieRequestDto' is not null or undefined
            if (motifSortieRequestDto === null || motifSortieRequestDto === undefined) {
                throw new RequiredError('motifSortieRequestDto','Required parameter motifSortieRequestDto was null or undefined when calling validateUpdateMotifSortieUsingPOST.');
            }
            const localVarPath = `/api/referentiel/motif-sortie/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MotifSortieRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(motifSortieRequestDto || {}) : (motifSortieRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications des entitées de rattachement d\'un dossier
         * @param {'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateSortieVehiculeRequestDto} updateSortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateSortieVehiculeFieldUsingPOST(field: 'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT', id: string, updateSortieVehiculeRequestDto: UpdateSortieVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateSortieVehiculeFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateSortieVehiculeFieldUsingPOST.');
            }
            // verify required parameter 'updateSortieVehiculeRequestDto' is not null or undefined
            if (updateSortieVehiculeRequestDto === null || updateSortieVehiculeRequestDto === undefined) {
                throw new RequiredError('updateSortieVehiculeRequestDto','Required parameter updateSortieVehiculeRequestDto was null or undefined when calling validateUpdateSortieVehiculeFieldUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/update-sortie/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateSortieVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateSortieVehiculeRequestDto || {}) : (updateSortieVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications de la sortie d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateSortieVehiculeRequestDto} updateSortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateSortieVehiculeUsingPOST(id: string, updateSortieVehiculeRequestDto: UpdateSortieVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateSortieVehiculeUsingPOST.');
            }
            // verify required parameter 'updateSortieVehiculeRequestDto' is not null or undefined
            if (updateSortieVehiculeRequestDto === null || updateSortieVehiculeRequestDto === undefined) {
                throw new RequiredError('updateSortieVehiculeRequestDto','Required parameter updateSortieVehiculeRequestDto was null or undefined when calling validateUpdateSortieVehiculeUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{id}/update-sortie/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateSortieVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateSortieVehiculeRequestDto || {}) : (updateSortieVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un type d\'AF.
         * @param {'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Identifiant de correlation du type
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateTypeAfFieldUsingPOST(field: 'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2', idCorrelation: string, typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateTypeAfFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateTypeAfFieldUsingPOST.');
            }
            // verify required parameter 'typeAutoriteFourriereRequestDto' is not null or undefined
            if (typeAutoriteFourriereRequestDto === null || typeAutoriteFourriereRequestDto === undefined) {
                throw new RequiredError('typeAutoriteFourriereRequestDto','Required parameter typeAutoriteFourriereRequestDto was null or undefined when calling validateUpdateTypeAfFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/type-autorite-fourriere/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TypeAutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(typeAutoriteFourriereRequestDto || {}) : (typeAutoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un type d\'AF.
         * @param {string} idCorrelation Identifiant de correlation du type
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateTypeAfUsingPOST(idCorrelation: string, typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateTypeAfUsingPOST.');
            }
            // verify required parameter 'typeAutoriteFourriereRequestDto' is not null or undefined
            if (typeAutoriteFourriereRequestDto === null || typeAutoriteFourriereRequestDto === undefined) {
                throw new RequiredError('typeAutoriteFourriereRequestDto','Required parameter typeAutoriteFourriereRequestDto was null or undefined when calling validateUpdateTypeAfUsingPOST.');
            }
            const localVarPath = `/api/referentiel/type-autorite-fourriere/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TypeAutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(typeAutoriteFourriereRequestDto || {}) : (typeAutoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une unité FO.
         * @param {'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation de l\'unité FO à mettre à jour
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateUniteFoFieldUsingPOST(field: 'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT', idCorrelation: string, uniteFoRequestDto: UniteFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateUniteFoFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateUniteFoFieldUsingPOST.');
            }
            // verify required parameter 'uniteFoRequestDto' is not null or undefined
            if (uniteFoRequestDto === null || uniteFoRequestDto === undefined) {
                throw new RequiredError('uniteFoRequestDto','Required parameter uniteFoRequestDto was null or undefined when calling validateUpdateUniteFoFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/unite-fo/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UniteFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(uniteFoRequestDto || {}) : (uniteFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une unite FO.
         * @param {string} idCorrelation Id de corrélation de l\'unité FO à mettre à jour
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateUniteFoUsingPOST(idCorrelation: string, uniteFoRequestDto: UniteFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateUniteFoUsingPOST.');
            }
            // verify required parameter 'uniteFoRequestDto' is not null or undefined
            if (uniteFoRequestDto === null || uniteFoRequestDto === undefined) {
                throw new RequiredError('uniteFoRequestDto','Required parameter uniteFoRequestDto was null or undefined when calling validateUpdateUniteFoUsingPOST.');
            }
            const localVarPath = `/api/referentiel/unite-fo/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UniteFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(uniteFoRequestDto || {}) : (uniteFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une vidéo tutorielle.
         * @param {'VIDEO_ID' | 'PROFILE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation de la vidéo tutorielle, représenté par un UUID
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateVideoTutorielFieldUsingPOST(field: 'VIDEO_ID' | 'PROFILE', idCorrelation: string, videoTutorielRequestDto: VideoTutorielRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateVideoTutorielFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateVideoTutorielFieldUsingPOST.');
            }
            // verify required parameter 'videoTutorielRequestDto' is not null or undefined
            if (videoTutorielRequestDto === null || videoTutorielRequestDto === undefined) {
                throw new RequiredError('videoTutorielRequestDto','Required parameter videoTutorielRequestDto was null or undefined when calling validateUpdateVideoTutorielFieldUsingPOST.');
            }
            const localVarPath = `/api/referentiel/videoTutoriel/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VideoTutorielRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(videoTutorielRequestDto || {}) : (videoTutorielRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une vidéo tutorielle
         * @param {string} idCorrelation ID corrélation de la vidéo tutorielle, représenté par un UUID
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateVideoTutorielUsingPOST(idCorrelation: string, videoTutorielRequestDto: VideoTutorielRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateUpdateVideoTutorielUsingPOST.');
            }
            // verify required parameter 'videoTutorielRequestDto' is not null or undefined
            if (videoTutorielRequestDto === null || videoTutorielRequestDto === undefined) {
                throw new RequiredError('videoTutorielRequestDto','Required parameter videoTutorielRequestDto was null or undefined when calling validateUpdateVideoTutorielUsingPOST.');
            }
            const localVarPath = `/api/referentiel/videoTutoriel/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VideoTutorielRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(videoTutorielRequestDto || {}) : (videoTutorielRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un des champs pour l\'upload du csv d\'apurement des dossiers.
         * @param {'FILE'} field Le champ à valider, représenté par une énumération.
         * @param {any} file Fichier csv contenant les ids des dossiers à apurer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadApurementDossiersFieldUsingPOST(field: 'FILE', file: any, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUploadApurementDossiersFieldUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling validateUploadApurementDossiersFieldUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/apurement/dossiers/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation des champs pour l\'upload du csv d\'apurement des dossiers.
         * @param {any} file Fichier csv contenant les ids des dossiers à apurer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadApurementDossiersUsingPOST(file: any, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling validateUploadApurementDossiersUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/apurement/dossiers/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un des champs pour l\'upload d\'un document spécifique.
           * @param {any} file Fichier du document specifique
          * @param {'NAME' | 'TYPE_DESTINATAIRE' | 'FILE'} field Le champ à valider, représenté par une énumération.
         * @param {validateUploadDocumentSpecifiqueFieldUsingPOSTQueryParams} queryParams objet contenant les query params de la route validateUploadDocumentSpecifiqueFieldUsingPOST
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadDocumentSpecifiqueFieldUsingPOST(file: any, field: 'NAME' | 'TYPE_DESTINATAIRE' | 'FILE', queryParams: ValidateUploadDocumentSpecifiqueFieldUsingPOSTQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUploadDocumentSpecifiqueFieldUsingPOST.');
            }
            // verify required parameter 'nomDocument' is not null or undefined
            if (queryParams.nomDocument === null || queryParams.nomDocument === undefined) {
                throw new RequiredError('nomDocument','Required parameter nomDocument was null or undefined when calling validateUploadDocumentSpecifiqueFieldUsingPOST.');
            }
            // verify required parameter 'utilisateursDestinataires' is not null or undefined
            if (queryParams.utilisateursDestinataires === null || queryParams.utilisateursDestinataires === undefined) {
                throw new RequiredError('utilisateursDestinataires','Required parameter utilisateursDestinataires was null or undefined when calling validateUploadDocumentSpecifiqueFieldUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling validateUploadDocumentSpecifiqueFieldUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/document-specifique/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.nomDocument !== undefined) {
                localVarQueryParameter['nomDocument'] = queryParams.nomDocument;
            }

            if (queryParams.utilisateursDestinataires) {
                localVarQueryParameter['utilisateursDestinataires'] = queryParams.utilisateursDestinataires;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation des champs pour l\'upload d\'un document spécifique pour un type de destinataire existant.
           * @param {any} file Fichier du document specifique
         * @param {validateUploadDocumentSpecifiqueUsingPOSTQueryParams} queryParams objet contenant les query params de la route validateUploadDocumentSpecifiqueUsingPOST
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadDocumentSpecifiqueUsingPOST(file: any, queryParams: ValidateUploadDocumentSpecifiqueUsingPOSTQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'nomDocument' is not null or undefined
            if (queryParams.nomDocument === null || queryParams.nomDocument === undefined) {
                throw new RequiredError('nomDocument','Required parameter nomDocument was null or undefined when calling validateUploadDocumentSpecifiqueUsingPOST.');
            }
            // verify required parameter 'utilisateursDestinataires' is not null or undefined
            if (queryParams.utilisateursDestinataires === null || queryParams.utilisateursDestinataires === undefined) {
                throw new RequiredError('utilisateursDestinataires','Required parameter utilisateursDestinataires was null or undefined when calling validateUploadDocumentSpecifiqueUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling validateUploadDocumentSpecifiqueUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/document-specifique/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.nomDocument !== undefined) {
                localVarQueryParameter['nomDocument'] = queryParams.nomDocument;
            }

            if (queryParams.utilisateursDestinataires) {
                localVarQueryParameter['utilisateursDestinataires'] = queryParams.utilisateursDestinataires;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {'TYPE' | 'FILE'} field Le champ à valider, représenté par une énumération.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadPieceJointeFieldUsingPOST1(dossierId: string, field: 'TYPE' | 'FILE', type: string, file: any, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling validateUploadPieceJointeFieldUsingPOST1.');
            }
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUploadPieceJointeFieldUsingPOST1.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling validateUploadPieceJointeFieldUsingPOST1.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling validateUploadPieceJointeFieldUsingPOST1.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{dossierId}/piece-jointe/{type}/validation/{field}`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadPieceJointeUsingPOST1(dossierId: string, type: string, file: any, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling validateUploadPieceJointeUsingPOST1.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling validateUploadPieceJointeUsingPOST1.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling validateUploadPieceJointeUsingPOST1.');
            }
            const localVarPath = `/api/admin-fonctionnel/dossier/{dossierId}/piece-jointe/{type}/validation`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un champ spécifique de l\'entité ExportStatistiques.
         * @param {'DATE_DEBUT' | 'DATE_FIN'} field Le champ à valider, représenté par une énumération.
         * @param {ExportStatistiquesRequestDto} exportStatistiquesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validationExportStatistiquesFieldUsingPOST(field: 'DATE_DEBUT' | 'DATE_FIN', exportStatistiquesRequestDto: ExportStatistiquesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validationExportStatistiquesFieldUsingPOST.');
            }
            // verify required parameter 'exportStatistiquesRequestDto' is not null or undefined
            if (exportStatistiquesRequestDto === null || exportStatistiquesRequestDto === undefined) {
                throw new RequiredError('exportStatistiquesRequestDto','Required parameter exportStatistiquesRequestDto was null or undefined when calling validationExportStatistiquesFieldUsingPOST.');
            }
            const localVarPath = `/api/admin-fonctionnel/administration-avancee/export-statistiques/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ExportStatistiquesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(exportStatistiquesRequestDto || {}) : (exportStatistiquesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un champ lors de la récupération de l\'activité d\'un utilisateur.
         * @param {'ID' | 'NOM' | 'PRENOM' | 'DATE_DEBUT' | 'DATE_FIN'} field Le champ à valider, représenté par une énumération.
         * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validationRecuperationActiviteUtilisateurFieldUsingPOST(field: 'ID' | 'NOM' | 'PRENOM' | 'DATE_DEBUT' | 'DATE_FIN', recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validationRecuperationActiviteUtilisateurFieldUsingPOST.');
            }
            // verify required parameter 'recuperationActiviteUtilisateurRequestDto' is not null or undefined
            if (recuperationActiviteUtilisateurRequestDto === null || recuperationActiviteUtilisateurRequestDto === undefined) {
                throw new RequiredError('recuperationActiviteUtilisateurRequestDto','Required parameter recuperationActiviteUtilisateurRequestDto was null or undefined when calling validationRecuperationActiviteUtilisateurFieldUsingPOST.');
            }
            const localVarPath = `/api/administration-avancee/recuperation-activite-utilisateur/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RecuperationActiviteUtilisateurRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(recuperationActiviteUtilisateurRequestDto || {}) : (recuperationActiviteUtilisateurRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs lors de la récupération de l\'activité d\'un utilisateur.
         * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validationRecuperationActiviteUtilisateurUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'recuperationActiviteUtilisateurRequestDto' is not null or undefined
            if (recuperationActiviteUtilisateurRequestDto === null || recuperationActiviteUtilisateurRequestDto === undefined) {
                throw new RequiredError('recuperationActiviteUtilisateurRequestDto','Required parameter recuperationActiviteUtilisateurRequestDto was null or undefined when calling validationRecuperationActiviteUtilisateurUsingPOST.');
            }
            const localVarPath = `/api/administration-avancee/recuperation-activite-utilisateur/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RecuperationActiviteUtilisateurRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(recuperationActiviteUtilisateurRequestDto || {}) : (recuperationActiviteUtilisateurRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux
          * @param {string} fluxId 
         * @param {warningsOfFluxUsingGETQueryParams} queryParams objet contenant les query params de la route warningsOfFluxUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningsOfFluxUsingGET(fluxId: string, queryParams: WarningsOfFluxUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'fluxId' is not null or undefined
            if (fluxId === null || fluxId === undefined) {
                throw new RequiredError('fluxId','Required parameter fluxId was null or undefined when calling warningsOfFluxUsingGET.');
            }
            const localVarPath = `/api/admin-fonctionnel/antai/flux/{fluxId}/warnings`
                .replace(`{${"fluxId"}}`, encodeURIComponent(String(fluxId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFonctionnelControllerApi - functional programming interface
 * @export
 */
export const AdminFonctionnelControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant à l\'admin fonctionnel d\'annuler la sortie d\'un véhicule
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annulationSortieVehiculeUsingPUT(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).annulationSortieVehiculeUsingPUT(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les positions des domaines faq
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFaqDomainPositionUsingPOST(requestBody: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<FaqDomainAdminDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).changeFaqDomainPositionUsingPOST(requestBody, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les positions des questions
         * @param {string} domainId id du domaine des questions
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFaqPositionUsingPOST(domainId: string, requestBody: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<FaqAdminDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).changeFaqPositionUsingPOST(domainId, requestBody, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une autorité de fourrière peut être réactivée
         * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationAutoriteFourriereUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateAutoriteFourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationAutoriteFourriereUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un centre vhu peut être réactivée
         * @param {string} idCorrelation Identifiant du centre vhu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationCentreVhuUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateCentreVHUDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationCentreVhuUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un état peut être réactivé
         * @param {string} idCorrelation Identifiant de l\'état
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationEtatUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateEtatDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationEtatUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un domaine faq peut être réactivée
         * @param {string} idCorrelation Identifiant du domaine faq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationFaqDomainUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateFaqDomainDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationFaqDomainUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une question peut être réactivée
         * @param {string} idCorrelation Identifiant de la question
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationFaqUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateFaqDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationFaqUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un lien peut être réactivé
         * @param {string} idCorrelation Identifiant du lien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationFooterLinkUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateFooterLinkDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationFooterLinkUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une  fourrière peut être réactivée
         * @param {string} idCorrelation Identifiant de la fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationFourriereUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateFourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationFourriereUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un genre simplifié peut être réactivé
         * @param {string} idCorrelation Identifiant du genre simplifié
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationGenreSimplifieUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateGenreSimplifieDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationGenreSimplifieUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une juridiction peut être réactivée
         * @param {string} idCorrelation Identifiant de la juridiction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationJuridictionUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateJuridictionDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationJuridictionUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un motif de MEF peut être réactivé
         * @param {string} idCorrelation Identifiant du motif de MEF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationMotifMefUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateMotifMefDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationMotifMefUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un motif de sortie peut être réactivé
         * @param {string} idCorrelation Identifiant du motif de sortie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationMotifSortieUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateMotifSortieDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationMotifSortieUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si un type d\'AF peut être réactivé
         * @param {string} idCorrelation Identifiant du type d\'AF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationTypeAfUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateTypeAutoriteFourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationTypeAfUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une unité FO peut être réactivée
         * @param {string} idCorrelation Identifiant de l\'unité FO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateUniteFoDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des données permettant de savoir si une vidéo tutorielle peut être réactivée
         * @param {string} idCorrelation Identifiant de la vidéo représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conditionReactivationVideoTutorielUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConditionsReactivateVideoTutorielDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).conditionReactivationVideoTutorielUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'importer un fichier avec les retours de la DNID.
         * @param {any} file Fichier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contournementCsvImportUsingPOST(file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).contournementCsvImportUsingPOST(file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Récupère le nombre de configurations filtrés par le body de la requête
         * @param {countConfigurationsWithSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route countConfigurationsWithSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countConfigurationsWithSpecsUsingGET(queryParams: CountConfigurationsWithSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CountConfigurationResultDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).countConfigurationsWithSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer une autorite de fourrière.
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto Données utilisées pour créer l\'autorité de fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAutoriteFourriereUsingPOST(autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AutoriteFourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createAutoriteFourriereUsingPOST(autoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer une branche
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrancheUsingPOST(brancheRequestDto: BrancheRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BrancheDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createBrancheUsingPOST(brancheRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer un centre VHU
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCentreVHUUsingPOST(centreVHURequestDto: CentreVHURequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CentreVHUDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createCentreVHUUsingPOST(centreVHURequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer un état du véhicule
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEtatUsingPOST(etatRequestDto: EtatRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EtatDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createEtatUsingPOST(etatRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer un domaine faq
         * @param {FaqDomainRequestDto} faqDomainRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFaqDomainUsingPOST(faqDomainRequestDto: FaqDomainRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FaqDomainAdminDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createFaqDomainUsingPOST(faqDomainRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer une question
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFaqUsingPOST(faqRequestDto: FaqRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FaqAdminDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createFaqUsingPOST(faqRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer un lien de bas de page
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFooterLinkUsingPOST(footerLinkRequestDto: FooterLinkRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FooterLinkDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createFooterLinkUsingPOST(footerLinkRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer une fourrière.
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFourriereUsingPOST(fourriereRequestDto: FourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createFourriereUsingPOST(fourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer un genre simplifié
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGenreSimplifieUsingPOST(genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GenreSimplifieDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createGenreSimplifieUsingPOST(genreSimplifieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route pour créer un bandeau d\'information à afficher.
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInformationMessageUsingPOST(informationMessageRequestDto: InformationMessageRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createInformationMessageUsingPOST(informationMessageRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer une juridiction.
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJuridictionUsingPOST(juridictionRequestDto: JuridictionRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JuridictionAdminResponseDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createJuridictionUsingPOST(juridictionRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer un motif de MEF.
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMotifMefUsingPOST(motifMefRequestDto: MotifMefRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MotifMefDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createMotifMefUsingPOST(motifMefRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer un motif de sortie.
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMotifSortieUsingPOST(motifSortieRequestDto: MotifSortieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MotifSortieDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createMotifSortieUsingPOST(motifSortieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer un type d\'AF.
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTypeAfUsingPOST(typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TypeAutoriteFourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createTypeAfUsingPOST(typeAutoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer une unité de force de l\'ordre.
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUniteFoUsingPOST(uniteFoRequestDto: UniteFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UniteFOAdminResponseDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createUniteFoUsingPOST(uniteFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer une vidéo tutorielle
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVideoTutorielUsingPOST(videoTutorielRequestDto: VideoTutorielRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoTutorielDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).createVideoTutorielUsingPOST(videoTutorielRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary API permettant de supprimer un document spécifique
         * @param {string} idDocumentSpecifique UUID du document spécifique
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentSpecifiqueUsingDELETE(idDocumentSpecifique: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deleteDocumentSpecifiqueUsingDELETE(idDocumentSpecifique, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Suppression d\'une des pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePieceJointeUsingDELETE1(dossierId: string, type: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deletePieceJointeUsingDELETE1(dossierId, type, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'une autorité de fourrière.
         * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
         * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateAutoriteFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateAutoriteFourriereUsingPUT(idCorrelation, referentielCommentairesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'un centre vhu.
         * @param {string} idCorrelation Identifiant du centre vhu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateCentreVhuUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateCentreVhuUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'un état de véhicule.
         * @param {string} idCorrelation Identifiant de l\'état
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateEtatUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateEtatUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'un domaine faq.
         * @param {string} idCorrelation Identifiant du domaine faq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateFaqDomainUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateFaqDomainUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'une question
         * @param {string} idCorrelation Identifiant de la question
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateFaqUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateFaqUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'un lien de pied de page.
         * @param {string} idCorrelation Identifiant du lien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateFooterLinkUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateFooterLinkUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'une fourrière.
         * @param {string} idCorrelation Identifiant de la fourrière
         * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateFourriereUsingPUT(idCorrelation, referentielCommentairesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'un genre simplifié.
         * @param {string} idCorrelation Identifiant du genre simplifié
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateGenreSimplifieUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateGenreSimplifieUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'une juridiction.
         * @param {string} idCorrelation Identifiant de la juridiction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateJuridictionUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateJuridictionUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'un motif de MEF.
         * @param {string} idCorrelation Identifiant du motif de MEF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateMotifMefUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateMotifMefUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'un motif de sortie.
         * @param {string} idCorrelation Identifiant du motif de sortie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateMotifSortieUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateMotifSortieUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'un type d\'AF.
         * @param {string} idCorrelation Identifiant du type d\'AF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateTypeAfUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateTypeAfUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'une unité FO.
         * @param {string} idCorrelation Identifiant de l\'unité FO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Désactivation d\'une vidéo tutorielle.
         * @param {string} idCorrelation Identifiant de la vidéo représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecateVideoTutorielUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).deprecateVideoTutorielUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'exporter la table de décision au format DMN.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCsvTableUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).downloadCsvTableUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Téléchargement d\'une des pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsingGET1(dossierId: string, type: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).downloadUsingGET1(dossierId, type, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @param {etatUsingGETQueryParams} queryParams objet contenant les query params de la route etatUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        etatUsingGET(queryParams: EtatUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EtatConventionnementResponseDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).etatUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer l\'AR/PND depuis l\'ANTAI
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchArPndUsingPOST1(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).fetchArPndUsingPOST1(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer le courrier de notification depuis l\'ANTAI
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCourrierUsingPOST1(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).fetchCourrierUsingPOST1(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les données de notification manuelle d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {FixDataNotificationManuelleRequestDto} fixDataNotificationManuelleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixDataNotificationManuelleUsingPOST(id: string, fixDataNotificationManuelleRequestDto: FixDataNotificationManuelleRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).fixDataNotificationManuelleUsingPOST(id, fixDataNotificationManuelleRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de déterminer quelle solution est active pour le partenaire alienation.<br/> Celle-ci pouvant être l\'API du partenaire alienation ou la solution de contournement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlienationActiveSolutionUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AlienationActiveSolutionDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getAlienationActiveSolutionUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'exporter l\'ensemble des données d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDonneesAndEventsDossierUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ExportDonneesDossierAdminFonctionnelDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getAllDonneesAndEventsDossierUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Récupère la liste des noms de microservices ayant des configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMicroServiceNamesUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getAllMicroServiceNamesUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Récupère un rapport d\'apurement par son id.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApurementReportUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ApurementReportResponseDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getApurementReportUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Récupération de la liste des anciennes version d\'une configuration via son idCorrelation
         * @param {string} idCorrelation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationHistoriqueUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ConfigurationHistoriqueDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getConfigurationHistoriqueUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'obtenir la liste des détails des évènements
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailedEventsUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DetailedEventDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getDetailedEventsUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel d\'exporter les statistiques
         * @param {ExportStatistiquesRequestDto} exportStatistiquesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportStatistiquesUsingPOST(exportStatistiquesRequestDto: ExportStatistiquesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getExportStatistiquesUsingPOST(exportStatistiquesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Router permettant de récupérer le statuts des flux
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFluxStatusesUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FluxStatusSummaryDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getFluxStatusesUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche les fourrieres associées à une autorité fourriere
         * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFourrieresFromValidAutoriteFourriereUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoFourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getFourrieresFromValidAutoriteFourriereUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'obtenir les informations du bandeau de l\'admin fonctionnel avec l\'objet DossierDtoAdminFonctionnel
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformationsByDossierIdUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getInformationsByDossierIdUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Permet de récupérer la date de la prochaine exécution planifiée d\'un flux
         * @param {'ALIENATION_UPDATE_STATUS_BIEN' | 'ALIENATION_LIEU_DEPOT' | 'ALIENATION_ENTITE_REMETTANTE' | 'ANTAI_RECUPERATION_INFORMATION_SYNCHRONIZATION' | 'ANTAI_RECUPERATION_INFORMATION_RETRY' | 'DOSSIER_PURGE' | 'DOSSIER_ANONYMISATION' | 'DOSSIER_RESYNC' | 'DOSSIER_BLOCAGE' | 'DOSSIER_UNSYNC' | 'RPSI_BATCH' | 'REPORT_PURGE'} fluxType Type de flux dont on souhaite connaître la prochaine date d\'exécution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextExecutionTimeUsingGET(fluxType: 'ALIENATION_UPDATE_STATUS_BIEN' | 'ALIENATION_LIEU_DEPOT' | 'ALIENATION_ENTITE_REMETTANTE' | 'ANTAI_RECUPERATION_INFORMATION_SYNCHRONIZATION' | 'ANTAI_RECUPERATION_INFORMATION_RETRY' | 'DOSSIER_PURGE' | 'DOSSIER_ANONYMISATION' | 'DOSSIER_RESYNC' | 'DOSSIER_BLOCAGE' | 'DOSSIER_UNSYNC' | 'RPSI_BATCH' | 'REPORT_PURGE', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GetFluxNextExecutionTimeResponseDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getNextExecutionTimeUsingGET(fluxType, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant les questions valides, regroupées par domaines pour l\'admin.
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} profile Profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidFaqByDomainsForProfileUsingGET(profile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoFaqDomainDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getOnlyValidFaqByDomainsForProfileUsingGET(profile, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récuperer le pdf actions camunda
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdfActionsCamundaUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getPdfActionsCamundaUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer la liste des types de pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPieceJointeTypesUsingGET1(dossierId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<PieceJointeTypeResponseDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getPieceJointeTypesUsingGET1(dossierId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer les instances Camunda d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessInstancesUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CamundaProcessInstanceDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getProcessInstancesUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer un flux spécifique de synchronisation des fourrières avec la DNID
         * @param {string} fluxId Id du flux, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecificFluxFourriereUsingGET(fluxId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAlienationFourriereFluxDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).getSpecificFluxFourriereUsingGET(fluxId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'importer une table de décision au format DMN.
         * @param {any} file Fichier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCsvTableUsingPOST(file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImportViolationListDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).importCsvTableUsingPOST(file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route pour valider un champ du formulaire de mise à jour du bandeau d\'information à afficher.
         * @param {'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES'} field 
         * @param {string} id 
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        informationMessageValidateFieldUsingPOST(field: 'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES', id: string, informationMessageRequestDto: InformationMessageRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InformationMessageViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).informationMessageValidateFieldUsingPOST(field, id, informationMessageRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route pour valider un champ du formulaire de création d\'un bandeau d\'information à afficher.
         * @param {'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES'} field 
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        informationMessageValidateFieldUsingPOST1(field: 'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES', informationMessageRequestDto: InformationMessageRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InformationMessageViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).informationMessageValidateFieldUsingPOST1(field, informationMessageRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route pour valider un formulaire de création d\'un bandeau d\'information à afficher.
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        informationMessageValidateUsingPOST(informationMessageRequestDto: InformationMessageRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InformationMessageViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).informationMessageValidateUsingPOST(informationMessageRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de migrer d\'une unité fo à une autre les dossiers associés
         * @param {MigrateUniteFoRequestDto} migrateUniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateUniteFoUsingPOST(migrateUniteFoRequestDto: MigrateUniteFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).migrateUniteFoUsingPOST(migrateUniteFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'une autorité de fourrière.
         * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
         * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateAutoriteFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateAutoriteFourriereUsingPUT(idCorrelation, referentielCommentairesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'un centre vhu.
         * @param {string} idCorrelation Identifiant du centre vhu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateCentreVhuUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateCentreVhuUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'un état de véhicule.
         * @param {string} idCorrelation Identifiant de l\'état
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateEtatUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateEtatUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'un domaine faq.
         * @param {string} idCorrelation Identifiant du domaine faq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateFaqDomainUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateFaqDomainUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'une question
         * @param {string} idCorrelation Identifiant de la question
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateFaqUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateFaqUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'un lien de pied de page.
         * @param {string} idCorrelation Identifiant du lien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateFooterLinkUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateFooterLinkUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'une fourrière.
         * @param {string} idCorrelation Identifiant de la fourrière
         * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateFourriereUsingPUT(idCorrelation, referentielCommentairesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'un genre simplifié.
         * @param {string} idCorrelation Identifiant du genre simplifié
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateGenreSimplifieUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateGenreSimplifieUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'une juridiction.
         * @param {string} idCorrelation Identifiant de la juridiction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateJuridictionUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateJuridictionUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'un motif de MEF.
         * @param {string} idCorrelation Identifiant du motif de MEF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateMotifMefUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateMotifMefUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'un motif de sortie.
         * @param {string} idCorrelation Identifiant du motif de sortie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateMotifSortieUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateMotifSortieUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'un type d\'AF.
         * @param {string} idCorrelation Identifiant du type d\'AF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateTypeAfUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateTypeAfUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'une unité FO.
         * @param {string} idCorrelation Identifiant de l\'unité FO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Réactivation d\'une vidéo tutorielle.
         * @param {string} idCorrelation Identifiant de la vidéo représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateVideoTutorielUsingPUT(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).reactivateVideoTutorielUsingPUT(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Récupération de l\'historique des actions d\'un utilisateur
         * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recupererHistoriqueActionsUtilisateurUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).recupererHistoriqueActionsUtilisateurUsingPOST(recuperationActiviteUtilisateurRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Récupération de l\'historique des consultations d\'un dossier par un utilisateur
         * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recupererHistoriqueConnexionsUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).recupererHistoriqueConnexionsUsingPOST(recuperationActiviteUtilisateurRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Récupération de l\'historique des consultations d\'un dossier par un utilisateur
         * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recupererHistoriqueConsultationsDossierUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).recupererHistoriqueConsultationsDossierUsingPOST(recuperationActiviteUtilisateurRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route déclenchant une relance du processus de vente chez le service des domaines, engendrant une nouvelle remise aux domaines.
         * @param {RelanceVenteDto} relanceVenteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relanceVenteAdminUsingPOST(relanceVenteDto: RelanceVenteDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).relanceVenteAdminUsingPOST(relanceVenteDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de sauvegarder une fiche descriptive
         * @param {any} file La fiche descriptive, représentée par un InputStream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFicheDescriptiveUsingPOST(file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).saveFicheDescriptiveUsingPOST(file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de sauvegarder un manuel Bdr
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
         * @param {any} file Le manuel, représenté par un InputStream.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManualBdrUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).saveManualBdrUsingPOST(userProfile, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de sauvegarder un manuel utilisateur
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
         * @param {any} file Le manuel, représenté par un InputStream.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManualUtilisateurUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).saveManualUtilisateurUsingPOST(userProfile, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche de la liste des configurations filtrés par le body de la requête
         * @param {searchConfigurationsWithSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchConfigurationsWithSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConfigurationsWithSpecsUsingGET(queryParams: SearchConfigurationsWithSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchConfigurationResultDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchConfigurationsWithSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche de la liste des états filtrés par le body de la requête
         * @param {searchEtatUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchEtatUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEtatUsingSpecsUsingGET(queryParams: SearchEtatUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoEtatDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchEtatUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche de la liste de domaine faq filtrés par le body de la requête
         * @param {searchFaqDomainUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFaqDomainUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFaqDomainUsingSpecsUsingGET(queryParams: SearchFaqDomainUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoFaqDomainAdminDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchFaqDomainUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche de la liste des faq filtrés par le body de la requête
         * @param {searchFaqUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFaqUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFaqUsingSpecsUsingGET(queryParams: SearchFaqUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoFaqAdminDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchFaqUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les flux de autorités fourrière aliénation
         * @param {searchFluxAutoriteFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxAutoriteFourriereUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFluxAutoriteFourriereUsingGET(queryParams: SearchFluxAutoriteFourriereUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAlienationResponseDtoSearchAlienationAutoriteFourriereFluxDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchFluxAutoriteFourriereUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les flux Aliénation de récupération de l\'état des biens
         * @param {searchFluxEtatBienUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxEtatBienUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFluxEtatBienUsingGET(queryParams: SearchFluxEtatBienUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAlienationResponseDtoSearchAlienationRecuperationEtatBienFluxDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchFluxEtatBienUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les flux spécifiques de synchronisation des fourrières avec la DNID
         * @param {searchFluxFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxFourriereUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFluxFourriereUsingGET(queryParams: SearchFluxFourriereUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAlienationResponseDtoSearchAlienationFourriereFluxDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchFluxFourriereUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les flux du batch rpsi
         * @param {searchFluxRpsiUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxRpsiUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFluxRpsiUsingGET(queryParams: SearchFluxRpsiUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchFluxRpsiResponseDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchFluxRpsiUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les flux Antai
         * @param {searchFluxUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFluxUsingGET(queryParams: SearchFluxUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAntaiRecuperationEventResponseDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchFluxUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche de la liste des liens de pied de page filtrés par le body de la requête
         * @param {searchFooterLinkUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFooterLinkUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFooterLinkUsingSpecsUsingGET(queryParams: SearchFooterLinkUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoFooterLinkDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchFooterLinkUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche de la liste des genres simplifiés filtrés par le body de la requête
         * @param {searchGenreSimplifieUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchGenreSimplifieUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGenreSimplifieUsingSpecsUsingGET(queryParams: SearchGenreSimplifieUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoGenreSimplifieDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchGenreSimplifieUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche de la liste de motifs de sortie filtrée par le body de la requête
         * @param {searchMotifSortieUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchMotifSortieUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMotifSortieUsingSpecsUsingGET(queryParams: SearchMotifSortieUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoMotifSortieDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchMotifSortieUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer un flux Aliénation de récupération des autorités fourrière
         * @param {string} fluxId Id du flux, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSpecificFluxAutoriteFouriereUsingGET(fluxId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAlienationAutoriteFourriereFluxDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchSpecificFluxAutoriteFouriereUsingGET(fluxId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer un flux Aliénation de récupération de l\'état des biens
         * @param {string} fluxId Id du flux, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSpecificFluxEtatBienUsingGET(fluxId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAlienationRecuperationEtatBienFluxDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchSpecificFluxEtatBienUsingGET(fluxId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer un flux Antai de récupération d\'un évènement
         * @param {string} fluxId Id du flux, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSpecificFluxUsingGET(fluxId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AntaiFluxDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchSpecificFluxUsingGET(fluxId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche de la liste des types d\'AF filtrée par le body de la requête
         * @param {searchTypeAfUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchTypeAfUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTypeAfUsingSpecsUsingGET(queryParams: SearchTypeAfUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoTypeAutoriteFourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchTypeAfUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer les événements d\'administration sur les utilisateurs
         * @param {SearchUserEventsRequestDto} searchUserEventsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserEventsUsingPOST(searchUserEventsRequestDto: SearchUserEventsRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchUserEventsResultDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchUserEventsUsingPOST(searchUserEventsRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des utilisations d\'une autorite de fourrière dans le SI
         * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesAutoriteFourriereUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielUsesDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchUsesAutoriteFourriereUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des utilisations d\'un état dans le SI
         * @param {string} idCorrelation Identifiant de l\'état
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesEtatUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielUsesDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchUsesEtatUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des utilisations d\'une fourrière dans le SI
         * @param {string} idCorrelation Identifiant de la fourrière
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesFourriereUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielUsesDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchUsesFourriereUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des utilisations d\'un genre simplifié dans le SI
         * @param {string} idCorrelation Identifiant du genre simplifié
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesGenreSimplifieUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielUsesDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchUsesGenreSimplifieUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des utilisations d\'une juridiction dans le SI
         * @param {string} idCorrelation Identifiant de la juridiction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesJuridictionUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielUsesDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchUsesJuridictionUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche des utilisations d\'une Unité FO dans le SI
         * @param {string} idCorrelation Identifiant de l\'unité FO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsesUniteFoUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielUsesDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchUsesUniteFoUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche de la liste des vidéos tutorielles filtrées par le body de la requête
         * @param {searchVideoTutorielUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchVideoTutorielUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVideoTutorielUsingSpecsUsingGET(queryParams: SearchVideoTutorielUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoVideoTutorielDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchVideoTutorielUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux de autorité fourrières aliénation
         * @param {string} fluxId Id du flux, représenté par un UUID
         * @param {searchWarningsFluxAutoriteFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchWarningsFluxAutoriteFourriereUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWarningsFluxAutoriteFourriereUsingGET(fluxId: string, queryParams: SearchWarningsFluxAutoriteFourriereUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAlienationWarningResponseDtoSearchAlienationAutoriteFourriereWarningDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchWarningsFluxAutoriteFourriereUsingGET(fluxId, queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux spécifique de synchronisation des fourrières avec la DNID
         * @param {string} fluxId Id du flux, représenté par un UUID
         * @param {searchWarningsFluxFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchWarningsFluxFourriereUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWarningsFluxFourriereUsingGET(fluxId: string, queryParams: SearchWarningsFluxFourriereUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAlienationWarningResponseDtoSearchAlienationFourriereWarningDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchWarningsFluxFourriereUsingGET(fluxId, queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux
         * @param {string} fluxId Id du flux, représenté par un UUID.
         * @param {searchWarningsOfFluxEtatBienUsingGETQueryParams} queryParams objet contenant les query params de la route searchWarningsOfFluxEtatBienUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWarningsOfFluxEtatBienUsingGET(fluxId: string, queryParams: SearchWarningsOfFluxEtatBienUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAlienationWarningResponseDtoSearchAlienationRecuperationEtatBienWarningDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).searchWarningsOfFluxEtatBienUsingGET(fluxId, queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de supprimer un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppressionDossierUsingDELETE(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).suppressionDossierUsingDELETE(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour une autorité de fourrière.
         * @param {string} idCorrelation ID de l\'autorite de fourrière, représenté par un UUID
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAutoriteFourriereUsingPUT(idCorrelation: string, autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AutoriteFourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateAutoriteFourriereUsingPUT(idCorrelation, autoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour une branche
         * @param {string} idCorrelation ID corrélation de la branche, représenté par un UUID
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrancheUsingPUT(idCorrelation: string, brancheRequestDto: BrancheRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BrancheDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateBrancheUsingPUT(idCorrelation, brancheRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour un centre VHU.
         * @param {string} idCorrelation ID du centre vhu, représenté par un UUID
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCentreVHUUsingPUT(idCorrelation: string, centreVHURequestDto: CentreVHURequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CentreVHUDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateCentreVHUUsingPUT(idCorrelation, centreVHURequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier le classement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateClassementRequestDto} updateClassementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassementUsingPOST(id: string, updateClassementRequestDto: UpdateClassementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateClassementUsingPOST(id, updateClassementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour une configuration de l\'application
         * @param {string} idCorrelation ID corrélation de la configuration, représenté par un UUID
         * @param {ConfigurationUpdateRequestDto} configurationUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigurationUsingPUT(idCorrelation: string, configurationUpdateRequestDto: ConfigurationUpdateRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ConfigurationDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateConfigurationUsingPUT(idCorrelation, configurationUpdateRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonneesInterieurVehiculeUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateDonneesInterieurVehiculeUsingPOST(id, updateDonneesInterieurVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les données judiciaires d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonneesJudiciairesUsingPOST1(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateDonneesJudiciairesUsingPOST1(id, updateDonneesJudiciairesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les entitées de rattachement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntitesRattachementUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateEntitesRattachementUsingPOST(id, updateEntitesRattachementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour un état du véhicule
         * @param {string} idCorrelation ID corrélation de l\'état, représenté par un UUID
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEtatUsingPUT(idCorrelation: string, etatRequestDto: EtatRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EtatDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateEtatUsingPUT(idCorrelation, etatRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour un domain faq.
         * @param {string} idCorrelation ID du domaine faq, représenté par un UUID
         * @param {FaqDomainRequestDto} faqDomainRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFaqDomainUsingPUT(idCorrelation: string, faqDomainRequestDto: FaqDomainRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FaqDomainAdminDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateFaqDomainUsingPUT(idCorrelation, faqDomainRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour une question
         * @param {string} idCorrelation ID de la question, représenté par un UUID
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFaqUsingPUT(idCorrelation: string, faqRequestDto: FaqRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FaqAdminDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateFaqUsingPUT(idCorrelation, faqRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour un lien de bas de page
         * @param {string} idCorrelation ID corrélation du lien de bas de page, représenté par un UUID
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFooterLinkUsingPUT(idCorrelation: string, footerLinkRequestDto: FooterLinkRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FooterLinkDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateFooterLinkUsingPUT(idCorrelation, footerLinkRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour une fourrière.
         * @param {string} idCorrelation ID de la fourrère, représentée par un UUID
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFourriereUsingPUT(idCorrelation: string, fourriereRequestDto: FourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateFourriereUsingPUT(idCorrelation, fourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour un genre simplifié
         * @param {string} idCorrelation ID corrélation du genre simplifié, représenté par un UUID
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGenreSimplifieUsingPUT(idCorrelation: string, genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GenreSimplifieDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateGenreSimplifieUsingPUT(idCorrelation, genreSimplifieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route pour éditer un bandeau d\'information à afficher.
         * @param {string} id 
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformationMessageUsingPOST(id: string, informationMessageRequestDto: InformationMessageRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateInformationMessageUsingPOST(id, informationMessageRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route pour valider le formulaire de mise à jour d\'un bandeau d\'information.
         * @param {string} id 
         * @param {InformationMessageRequestDto} informationMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformationMessageValidateUsingPOST(id: string, informationMessageRequestDto: InformationMessageRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InformationMessageViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateInformationMessageValidateUsingPOST(id, informationMessageRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de renseigner manuellement les données siv d\'un véhicule
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {InfosSivRequestDto} infosSivRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfosSivManuelUsingPOST(id: string, infosSivRequestDto: InfosSivRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateInfosSivManuelUsingPOST(id, infosSivRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour une juridiction.
         * @param {string} idCorrelation ID de la juridiction, représenté par un UUID
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJuridictionUsingPUT(idCorrelation: string, juridictionRequestDto: JuridictionRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JuridictionAdminResponseDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateJuridictionUsingPUT(idCorrelation, juridictionRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier la catégorie d\'une marque.
         * @param {string} idCorrelation 
         * @param {MarqueRequestDto} marqueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarqueUsingPOST(idCorrelation: string, marqueRequestDto: MarqueRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MarqueDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateMarqueUsingPOST(idCorrelation, marqueRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour un motif de MEF.
         * @param {string} idCorrelation ID du motif de MEF, représenté par un UUID
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMotifMefUsingPUT(idCorrelation: string, motifMefRequestDto: MotifMefRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MotifMefDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateMotifMefUsingPUT(idCorrelation, motifMefRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier un motif de sortie.
         * @param {string} idCorrelation Identifiant de correlation du motif
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMotifSortieUsingPUT(idCorrelation: string, motifSortieRequestDto: MotifSortieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MotifSortieDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateMotifSortieUsingPUT(idCorrelation, motifSortieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les données de sortie d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateSortieVehiculeRequestDto} updateSortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSortieVehiculeUsingPOST(id: string, updateSortieVehiculeRequestDto: UpdateSortieVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateSortieVehiculeUsingPOST(id, updateSortieVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier un type d\'AF.
         * @param {string} idCorrelation Identifiant de correlation du type
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTypeAfUsingPUT(idCorrelation: string, typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TypeAutoriteFourriereDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateTypeAfUsingPUT(idCorrelation, typeAutoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour une unité de force de l\'ordre.
         * @param {string} idCorrelation ID de l\'unité force de l\'ordre, représenté par un UUID
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUniteFoUsingPUT(idCorrelation: string, uniteFoRequestDto: UniteFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UniteFOAdminResponseDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateUniteFoUsingPUT(idCorrelation, uniteFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour une vidéo tutorielle
         * @param {string} idCorrelation ID corrélation de la vidéo tutorielle, représenté par un UUID
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVideoTutorielUsingPUT(idCorrelation: string, videoTutorielRequestDto: VideoTutorielRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VideoTutorielDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).updateVideoTutorielUsingPUT(idCorrelation, videoTutorielRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary API permettant d\'uploader le csv d\'apurement des dossiers.
         * @param {any} file Fichier csv contenant les ids des dossiers à apurer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadApurementDossiersFileUsingPOST(file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).uploadApurementDossiersFileUsingPOST(file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary API permettant d\'uploader un document spécifique pour un destinataire
         * @param {any} file Fichier du document
         * @param {uploadDocumentSpecifiqueUsingPOSTQueryParams} queryParams objet contenant les query params de la route uploadDocumentSpecifiqueUsingPOST
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentSpecifiqueUsingPOST(file: any, queryParams: UploadDocumentSpecifiqueUsingPOSTQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DocumentSpecifiqueDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).uploadDocumentSpecifiqueUsingPOST(file, queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary API permettant d\'uploader une pièce jointe pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPieceJointeUsingPOST1(dossierId: string, type: string, file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierDtoAdminFonctionnel> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).uploadPieceJointeUsingPOST1(dossierId, type, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une autorité fourrière.
         * @param {'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR'} field Nom du champ à valider, défini par un enum
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateAutoriteFourriereFieldUsingPOST(field: 'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR', autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateAutoriteFourriereFieldUsingPOST(field, autoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une autorité de fourrière.
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateAutoriteFourriereUsingPOST(autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateAutoriteFourriereUsingPOST(autoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une branche.
         * @param {'NATURE' | 'BRANCHE'} field Nom du champ à valider, défini par un enum
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateBrancheFieldUsingPOST(field: 'NATURE' | 'BRANCHE', brancheRequestDto: BrancheRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateBrancheFieldUsingPOST(field, brancheRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une branche
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateBrancheUsingPOST(brancheRequestDto: BrancheRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateBrancheUsingPOST(brancheRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un centre vhu.
         * @param {'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE'} field Nom du champ à valider, défini par un enum
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateCentreVHUFieldUsingPOST(field: 'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE', centreVHURequestDto: CentreVHURequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateCentreVHUFieldUsingPOST(field, centreVHURequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un centre VHU
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateCentreVHUUsingPOST(centreVHURequestDto: CentreVHURequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateCentreVHUUsingPOST(centreVHURequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un état de véhicule
         * @param {'ETAT' | 'DETAIL' | 'LIBELLE_COURT'} field Nom du champ à valider, défini par un enum
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateEtatFieldUsingPOST(field: 'ETAT' | 'DETAIL' | 'LIBELLE_COURT', etatRequestDto: EtatRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateEtatFieldUsingPOST(field, etatRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un état de véhicule
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateEtatUsingPOST(etatRequestDto: EtatRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateEtatUsingPOST(etatRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un lien de bas de page
         * @param {'LINK' | 'TEXT' | 'PROFILE'} field Nom du champ à valider, défini par un enum
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateFooterLinkFieldUsingPOST(field: 'LINK' | 'TEXT' | 'PROFILE', footerLinkRequestDto: FooterLinkRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateFooterLinkFieldUsingPOST(field, footerLinkRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un lien de bas de page
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateFooterLinkUsingPOST(footerLinkRequestDto: FooterLinkRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateFooterLinkUsingPOST(footerLinkRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une fourrière.
         * @param {'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION'} field Nom du champ à valider, défini par un enum
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateFourriereFieldUsingPOST(field: 'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION', fourriereRequestDto: FourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateFourriereFieldUsingPOST(field, fourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une fourrière.
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateFourriereUsingPOST(fourriereRequestDto: FourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateFourriereUsingPOST(fourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un genre simplifié
         * @param {'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES'} field Nom du champ à valider, défini par un enum
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateGenreSimplifieFieldUsingPOST(field: 'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES', genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateGenreSimplifieFieldUsingPOST(field, genreSimplifieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un genre simplifié
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateGenreSimplifieUsingPOST(genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateGenreSimplifieUsingPOST(genreSimplifieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une juridiction
         * @param {'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE'} field Nom du champ à valider, défini par un enum
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateJuridictionFieldUsingPOST(field: 'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE', juridictionRequestDto: JuridictionRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateJuridictionFieldUsingPOST(field, juridictionRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une juridiction
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateJuridictionUsingPOST(juridictionRequestDto: JuridictionRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateJuridictionUsingPOST(juridictionRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un motif de MEF.
         * @param {'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO'} field Nom du champ à valider, défini par un enum
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateMotifMefFieldUsingPOST(field: 'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO', motifMefRequestDto: MotifMefRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateMotifMefFieldUsingPOST(field, motifMefRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un motif de MEF.
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateMotifMefUsingPOST(motifMefRequestDto: MotifMefRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateMotifMefUsingPOST(motifMefRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un motif de sortie.
         * @param {'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT'} field Nom du champ à valider, défini par un enum
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateMotifSortieFieldUsingPOST(field: 'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT', motifSortieRequestDto: MotifSortieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateMotifSortieFieldUsingPOST(field, motifSortieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un motif de sortie.
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateMotifSortieUsingPOST(motifSortieRequestDto: MotifSortieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateMotifSortieUsingPOST(motifSortieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un type d\'AF.
         * @param {'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2'} field Nom du champ à valider, défini par un enum
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateTypeAFFieldUsingPOST(field: 'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2', typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateTypeAFFieldUsingPOST(field, typeAutoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un type d\'AF.
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateTypeAfUsingPOST(typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateTypeAfUsingPOST(typeAutoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une unité FO.
         * @param {'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT'} field Nom du champ à valider, défini par un enum
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateUniteFoFieldUsingPOST(field: 'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT', uniteFoRequestDto: UniteFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateUniteFoFieldUsingPOST(field, uniteFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une unite FO.
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateUniteFoUsingPOST(uniteFoRequestDto: UniteFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateUniteFoUsingPOST(uniteFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une vidéo tutorielle.
         * @param {'VIDEO_ID' | 'PROFILE'} field Nom du champ à valider, défini par un enum
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateVideoTutorielFieldUsingPOST(field: 'VIDEO_ID' | 'PROFILE', videoTutorielRequestDto: VideoTutorielRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateVideoTutorielFieldUsingPOST(field, videoTutorielRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une vidéo tutorielle
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateVideoTutorielUsingPOST(videoTutorielRequestDto: VideoTutorielRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateCreateVideoTutorielUsingPOST(videoTutorielRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de l\'entité ExportStatistiques.
         * @param {ExportStatistiquesRequestDto} exportStatistiquesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExportStatistiquesRequestUsingPOST(exportStatistiquesRequestDto: ExportStatistiquesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ExportStatistiquesViolationsDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateExportStatistiquesRequestUsingPOST(exportStatistiquesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'un domaine faq.
         * @param {'NAME'} field Nom du champ à valider, défini par un enum
         * @param {FaqDomainRequestDto} faqDomainRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFaqDomainFieldUsingPOST(field: 'NAME', faqDomainRequestDto: FaqDomainRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateFaqDomainFieldUsingPOST(field, faqDomainRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'un domaine faq
         * @param {FaqDomainRequestDto} faqDomainRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFaqDomainUsingPOST(faqDomainRequestDto: FaqDomainRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateFaqDomainUsingPOST(faqDomainRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de création d\'une question
         * @param {'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT'} field Nom du champ à valider, défini par un enum
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFaqFieldUsingPOST(field: 'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT', faqRequestDto: FaqRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateFaqFieldUsingPOST(field, faqRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de création d\'une question
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFaqUsingPOST(faqRequestDto: FaqRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateFaqUsingPOST(faqRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications du classement d\'un dossier
         * @param {'JUSTIFICATION' | 'NEW_CLASSEMENT'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateClassementRequestDto} updateClassementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFieldUpdateClassementUsingPOST(field: 'JUSTIFICATION' | 'NEW_CLASSEMENT', id: string, updateClassementRequestDto: UpdateClassementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateFieldUpdateClassementUsingPOST(field, id, updateClassementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications de la notification manuelle d\'un dossier
         * @param {'NEW_DATE_ENVOI' | 'NEW_DATE_SIGNATURE' | 'NEW_ETAT_DISTRIBUTION' | 'JUSTIFICATION'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {FixDataNotificationManuelleRequestDto} fixDataNotificationManuelleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFixDataNotificationManuelleFieldUsingPOST(field: 'NEW_DATE_ENVOI' | 'NEW_DATE_SIGNATURE' | 'NEW_ETAT_DISTRIBUTION' | 'JUSTIFICATION', id: string, fixDataNotificationManuelleRequestDto: FixDataNotificationManuelleRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateFixDataNotificationManuelleFieldUsingPOST(field, id, fixDataNotificationManuelleRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications de la notification manuelle d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {FixDataNotificationManuelleRequestDto} fixDataNotificationManuelleRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFixDataNotificationManuelleUsingPOST(id: string, fixDataNotificationManuelleRequestDto: FixDataNotificationManuelleRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateFixDataNotificationManuelleUsingPOST(id, fixDataNotificationManuelleRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications d\'un champ de la migration d\'unité FO
         * @param {'NEW_UNITE_FO_CORRELATION_ID' | 'OLD_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
         * @param {MigrateUniteFoRequestDto} migrateUniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMigrateUniteFoFieldUsingPOST(field: 'NEW_UNITE_FO_CORRELATION_ID' | 'OLD_UNITE_FO_CORRELATION_ID' | 'COMMENT', migrateUniteFoRequestDto: MigrateUniteFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<MigrateUniteFoViolationDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateMigrateUniteFoFieldUsingPOST(field, migrateUniteFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications de la migration d\'unité FO
         * @param {MigrateUniteFoRequestDto} migrateUniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMigrateUniteFoUsingPOST(migrateUniteFoRequestDto: MigrateUniteFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<MigrateUniteFoViolationDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateMigrateUniteFoUsingPOST(migrateUniteFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une autorité fourrière.
         * @param {'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID de l\'autorite de fourrière, représenté par un UUID
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateAutoriteFourriereFieldUsingPOST(field: 'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR', idCorrelation: string, autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateAutoriteFourriereFieldUsingPOST(field, idCorrelation, autoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une autorité de fourrière.
         * @param {string} idCorrelation ID de l\'autorite de fourrière, représenté par un UUID
         * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateAutoriteFourriereUsingPOST(idCorrelation: string, autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateAutoriteFourriereUsingPOST(idCorrelation, autoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une branche.
         * @param {'NATURE' | 'BRANCHE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation de la branche, représenté par un UUID
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateBrancheFieldUsingPOST(field: 'NATURE' | 'BRANCHE', idCorrelation: string, brancheRequestDto: BrancheRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateBrancheFieldUsingPOST(field, idCorrelation, brancheRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une branche
         * @param {string} idCorrelation ID corrélation de la branche, représenté par un UUID
         * @param {BrancheRequestDto} brancheRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateBrancheUsingPOST(idCorrelation: string, brancheRequestDto: BrancheRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateBrancheUsingPOST(idCorrelation, brancheRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un centre vhu.
         * @param {'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation du centre vhu à mettre à jour
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateCentreVHUFieldUsingPOST(field: 'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE', idCorrelation: string, centreVHURequestDto: CentreVHURequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateCentreVHUFieldUsingPOST(field, idCorrelation, centreVHURequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un centre vhu.
         * @param {string} idCorrelation Id de corrélation du centre vhu à mettre à jour
         * @param {CentreVHURequestDto} centreVHURequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateCentreVHUUsingPOST(idCorrelation: string, centreVHURequestDto: CentreVHURequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateCentreVHUUsingPOST(idCorrelation, centreVHURequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications du classement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateClassementRequestDto} updateClassementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateClassementUsingPOST(id: string, updateClassementRequestDto: UpdateClassementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateClassementUsingPOST(id, updateClassementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider une modification des données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
         * @param {'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeFieldUsingPOST(field: 'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF', id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateDonneesInterieurVehiculeFieldUsingPOST(field, id, updateDonneesInterieurVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications des données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateDonneesInterieurVehiculeUsingPOST(id, updateDonneesInterieurVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider une modification des données judiciaires d\'un dossier
         * @param {'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesJudiciairesFieldUsingPOST1(field: 'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE', id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateDonneesJudiciairesFieldUsingPOST1(field, id, updateDonneesJudiciairesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications des données judiciaires d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesJudiciairesUsingPOST1(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateDonneesJudiciairesUsingPOST1(id, updateDonneesJudiciairesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications des entitées de rattachement d\'un dossier
         * @param {'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementFieldUsingPOST(field: 'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT', id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateEntitesRattachementFieldUsingPOST(field, id, updateEntitesRattachementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications des entitées de rattachement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateEntitesRattachementUsingPOST(id, updateEntitesRattachementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un état de véhicule
         * @param {'ETAT' | 'DETAIL' | 'LIBELLE_COURT'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation de l\'état, représenté par un UUID
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEtatFieldUsingPOST(field: 'ETAT' | 'DETAIL' | 'LIBELLE_COURT', idCorrelation: string, etatRequestDto: EtatRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateEtatFieldUsingPOST(field, idCorrelation, etatRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un état de véhicule
         * @param {string} idCorrelation ID corrélation de l\'état, représenté par un UUID
         * @param {EtatRequestDto} etatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEtatUsingPOST(idCorrelation: string, etatRequestDto: EtatRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateEtatUsingPOST(idCorrelation, etatRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de modification d\'une question
         * @param {'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation de la question à mettre à jour
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFaqFieldUsingPOST(field: 'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT', idCorrelation: string, faqRequestDto: FaqRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateFaqFieldUsingPOST(field, idCorrelation, faqRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de la modification d\'une question
         * @param {string} idCorrelation Id de corrélation de la question à mettre à jour
         * @param {FaqRequestDto} faqRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFaqUsingPOST(idCorrelation: string, faqRequestDto: FaqRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateFaqUsingPOST(idCorrelation, faqRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un lien de bas de page
         * @param {'LINK' | 'TEXT' | 'PROFILE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation du lien de bas de page, représenté par un UUID
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFooterLinkFieldUsingPOST(field: 'LINK' | 'TEXT' | 'PROFILE', idCorrelation: string, footerLinkRequestDto: FooterLinkRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateFooterLinkFieldUsingPOST(field, idCorrelation, footerLinkRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un lien de bas de page
         * @param {string} idCorrelation ID corrélation du lien de bas de page, représenté par un UUID
         * @param {FooterLinkRequestDto} footerLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFooterLinkUsingPOST(idCorrelation: string, footerLinkRequestDto: FooterLinkRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateFooterLinkUsingPOST(idCorrelation, footerLinkRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une fourrière.
         * @param {'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation de la fourrière à mettre à jour
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFourriereFieldUsingPOST(field: 'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION', idCorrelation: string, fourriereRequestDto: FourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateFourriereFieldUsingPOST(field, idCorrelation, fourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une fourrière.
         * @param {string} idCorrelation Id de corrélation de la fourrière à mettre à jour
         * @param {FourriereRequestDto} fourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFourriereUsingPOST(idCorrelation: string, fourriereRequestDto: FourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateFourriereUsingPOST(idCorrelation, fourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un genre simplifié
         * @param {'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation de le genre simplifié, représenté par un UUID
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateGenreSimplifieFieldUsingPOST(field: 'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES', idCorrelation: string, genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateGenreSimplifieFieldUsingPOST(field, idCorrelation, genreSimplifieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un genre simplifié
         * @param {string} idCorrelation ID corrélation de le genre simplifié, représenté par un UUID
         * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateGenreSimplifieUsingPOST(idCorrelation: string, genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateGenreSimplifieUsingPOST(idCorrelation, genreSimplifieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une juridiction
         * @param {'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation de la juridiction, représenté par un UUID
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateJuridictionFieldUsingPOST(field: 'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE', idCorrelation: string, juridictionRequestDto: JuridictionRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateJuridictionFieldUsingPOST(field, idCorrelation, juridictionRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une juridiction
         * @param {string} idCorrelation ID corrélation de la juridiction, représenté par un UUID
         * @param {JuridictionRequestDto} juridictionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateJuridictionUsingPOST(idCorrelation: string, juridictionRequestDto: JuridictionRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateJuridictionUsingPOST(idCorrelation, juridictionRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une marque.
         * @param {'CATEGORIE' | 'TYPE' | 'MARQUE_EXACTE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation de la marque à mettre à jour
         * @param {MarqueRequestDto} marqueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMarqueFieldUsingPOST(field: 'CATEGORIE' | 'TYPE' | 'MARQUE_EXACTE', idCorrelation: string, marqueRequestDto: MarqueRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateMarqueFieldUsingPOST(field, idCorrelation, marqueRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une marque.
         * @param {string} idCorrelation Id de corrélation de la marque à mettre à jour
         * @param {MarqueRequestDto} marqueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMarqueUsingPOST(idCorrelation: string, marqueRequestDto: MarqueRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateMarqueUsingPOST(idCorrelation, marqueRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un motif de mef.
         * @param {'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation du motif de MEF à mettre à jour
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMotifMefFieldUsingPOST(field: 'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO', idCorrelation: string, motifMefRequestDto: MotifMefRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateMotifMefFieldUsingPOST(field, idCorrelation, motifMefRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un motif de MEF.
         * @param {string} idCorrelation Id de corrélation du motif à mettre à jour
         * @param {MotifMefRequestDto} motifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMotifMefUsingPOST(idCorrelation: string, motifMefRequestDto: MotifMefRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateMotifMefUsingPOST(idCorrelation, motifMefRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un motif de sortie.
         * @param {'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Identifiant de correlation du motif
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMotifSortieFieldUsingPUT(field: 'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT', idCorrelation: string, motifSortieRequestDto: MotifSortieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateMotifSortieFieldUsingPUT(field, idCorrelation, motifSortieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un motif de sortie.
         * @param {string} idCorrelation Identifiant de correlation du motif
         * @param {MotifSortieRequestDto} motifSortieRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMotifSortieUsingPOST(idCorrelation: string, motifSortieRequestDto: MotifSortieRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateMotifSortieUsingPOST(idCorrelation, motifSortieRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications des entitées de rattachement d\'un dossier
         * @param {'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateSortieVehiculeRequestDto} updateSortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateSortieVehiculeFieldUsingPOST(field: 'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT', id: string, updateSortieVehiculeRequestDto: UpdateSortieVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateSortieVehiculeFieldUsingPOST(field, id, updateSortieVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications de la sortie d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateSortieVehiculeRequestDto} updateSortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateSortieVehiculeUsingPOST(id: string, updateSortieVehiculeRequestDto: UpdateSortieVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateSortieVehiculeUsingPOST(id, updateSortieVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'un type d\'AF.
         * @param {'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Identifiant de correlation du type
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateTypeAfFieldUsingPOST(field: 'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2', idCorrelation: string, typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateTypeAfFieldUsingPOST(field, idCorrelation, typeAutoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'un type d\'AF.
         * @param {string} idCorrelation Identifiant de correlation du type
         * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateTypeAfUsingPOST(idCorrelation: string, typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateTypeAfUsingPOST(idCorrelation, typeAutoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une unité FO.
         * @param {'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation Id de corrélation de l\'unité FO à mettre à jour
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateUniteFoFieldUsingPOST(field: 'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT', idCorrelation: string, uniteFoRequestDto: UniteFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateUniteFoFieldUsingPOST(field, idCorrelation, uniteFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une unite FO.
         * @param {string} idCorrelation Id de corrélation de l\'unité FO à mettre à jour
         * @param {UniteFoRequestDto} uniteFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateUniteFoUsingPOST(idCorrelation: string, uniteFoRequestDto: UniteFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateUniteFoUsingPOST(idCorrelation, uniteFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des données de mise à jour d\'une vidéo tutorielle.
         * @param {'VIDEO_ID' | 'PROFILE'} field Nom du champ à valider, défini par un enum
         * @param {string} idCorrelation ID corrélation de la vidéo tutorielle, représenté par un UUID
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateVideoTutorielFieldUsingPOST(field: 'VIDEO_ID' | 'PROFILE', idCorrelation: string, videoTutorielRequestDto: VideoTutorielRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateVideoTutorielFieldUsingPOST(field, idCorrelation, videoTutorielRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les données de mise à jour d\'une vidéo tutorielle
         * @param {string} idCorrelation ID corrélation de la vidéo tutorielle, représenté par un UUID
         * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateVideoTutorielUsingPOST(idCorrelation: string, videoTutorielRequestDto: VideoTutorielRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUpdateVideoTutorielUsingPOST(idCorrelation, videoTutorielRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un des champs pour l\'upload du csv d\'apurement des dossiers.
         * @param {'FILE'} field Le champ à valider, représenté par une énumération.
         * @param {any} file Fichier csv contenant les ids des dossiers à apurer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadApurementDossiersFieldUsingPOST(field: 'FILE', file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadApurementDossiersFileViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUploadApurementDossiersFieldUsingPOST(field, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation des champs pour l\'upload du csv d\'apurement des dossiers.
         * @param {any} file Fichier csv contenant les ids des dossiers à apurer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadApurementDossiersUsingPOST(file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadApurementDossiersFileViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUploadApurementDossiersUsingPOST(file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un des champs pour l\'upload d\'un document spécifique.
         * @param {'NAME' | 'TYPE_DESTINATAIRE' | 'FILE'} field Le champ à valider, représenté par une énumération.
         * @param {any} file Fichier du document specifique
         * @param {validateUploadDocumentSpecifiqueFieldUsingPOSTQueryParams} queryParams objet contenant les query params de la route validateUploadDocumentSpecifiqueFieldUsingPOST
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadDocumentSpecifiqueFieldUsingPOST(file: any, field: 'NAME' | 'TYPE_DESTINATAIRE' | 'FILE', queryParams: ValidateUploadDocumentSpecifiqueFieldUsingPOSTQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadDocumentSpecifiqueFileViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUploadDocumentSpecifiqueFieldUsingPOST(file, field, queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation des champs pour l\'upload d\'un document spécifique pour un type de destinataire existant.
         * @param {any} file Fichier du document specifique
         * @param {validateUploadDocumentSpecifiqueUsingPOSTQueryParams} queryParams objet contenant les query params de la route validateUploadDocumentSpecifiqueUsingPOST
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadDocumentSpecifiqueUsingPOST(file: any, queryParams: ValidateUploadDocumentSpecifiqueUsingPOSTQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadDocumentSpecifiqueFileViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUploadDocumentSpecifiqueUsingPOST(file, queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {'TYPE' | 'FILE'} field Le champ à valider, représenté par une énumération.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadPieceJointeFieldUsingPOST1(dossierId: string, field: 'TYPE' | 'FILE', type: string, file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadPieceJointeFileViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUploadPieceJointeFieldUsingPOST1(dossierId, field, type, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadPieceJointeUsingPOST1(dossierId: string, type: string, file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadPieceJointeFileViolationsDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validateUploadPieceJointeUsingPOST1(dossierId, type, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un champ spécifique de l\'entité ExportStatistiques.
         * @param {'DATE_DEBUT' | 'DATE_FIN'} field Le champ à valider, représenté par une énumération.
         * @param {ExportStatistiquesRequestDto} exportStatistiquesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validationExportStatistiquesFieldUsingPOST(field: 'DATE_DEBUT' | 'DATE_FIN', exportStatistiquesRequestDto: ExportStatistiquesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ExportStatistiquesViolationsDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validationExportStatistiquesFieldUsingPOST(field, exportStatistiquesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un champ lors de la récupération de l\'activité d\'un utilisateur.
         * @param {'ID' | 'NOM' | 'PRENOM' | 'DATE_DEBUT' | 'DATE_FIN'} field Le champ à valider, représenté par une énumération.
         * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validationRecuperationActiviteUtilisateurFieldUsingPOST(field: 'ID' | 'NOM' | 'PRENOM' | 'DATE_DEBUT' | 'DATE_FIN', recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<RecuperationActiviteUtilisateurViolationsDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validationRecuperationActiviteUtilisateurFieldUsingPOST(field, recuperationActiviteUtilisateurRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs lors de la récupération de l\'activité d\'un utilisateur.
         * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validationRecuperationActiviteUtilisateurUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<RecuperationActiviteUtilisateurViolationsDto>> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).validationRecuperationActiviteUtilisateurUsingPOST(recuperationActiviteUtilisateurRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux
         * @param {string} fluxId 
         * @param {warningsOfFluxUsingGETQueryParams} queryParams objet contenant les query params de la route warningsOfFluxUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningsOfFluxUsingGET(fluxId: string, queryParams: WarningsOfFluxUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchAntaiEventWarningResponseDto> {
            const localVarFetchArgs = AdminFonctionnelControllerApiFetchParamCreator(configuration).warningsOfFluxUsingGET(fluxId, queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdminFonctionnelControllerApi - object-oriented interface
 * @export
 * @class AdminFonctionnelControllerApi
 * @extends {BaseAPI}
 */
export class AdminFonctionnelControllerApi extends BaseAPI {
    /**
     * @summary Route permettant à l\'admin fonctionnel d\'annuler la sortie d\'un véhicule
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public annulationSortieVehiculeUsingPUT(id: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).annulationSortieVehiculeUsingPUT(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les positions des domaines faq
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public changeFaqDomainPositionUsingPOST(requestBody: Array<string>, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).changeFaqDomainPositionUsingPOST(requestBody, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les positions des questions
     * @param {string} domainId id du domaine des questions
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public changeFaqPositionUsingPOST(domainId: string, requestBody: Array<string>, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).changeFaqPositionUsingPOST(domainId, requestBody, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si une autorité de fourrière peut être réactivée
     * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationAutoriteFourriereUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationAutoriteFourriereUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si un centre vhu peut être réactivée
     * @param {string} idCorrelation Identifiant du centre vhu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationCentreVhuUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationCentreVhuUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si un état peut être réactivé
     * @param {string} idCorrelation Identifiant de l\'état
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationEtatUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationEtatUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si un domaine faq peut être réactivée
     * @param {string} idCorrelation Identifiant du domaine faq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationFaqDomainUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationFaqDomainUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si une question peut être réactivée
     * @param {string} idCorrelation Identifiant de la question
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationFaqUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationFaqUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si un lien peut être réactivé
     * @param {string} idCorrelation Identifiant du lien
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationFooterLinkUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationFooterLinkUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si une  fourrière peut être réactivée
     * @param {string} idCorrelation Identifiant de la fourrière
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationFourriereUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationFourriereUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si un genre simplifié peut être réactivé
     * @param {string} idCorrelation Identifiant du genre simplifié
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationGenreSimplifieUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationGenreSimplifieUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si une juridiction peut être réactivée
     * @param {string} idCorrelation Identifiant de la juridiction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationJuridictionUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationJuridictionUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si un motif de MEF peut être réactivé
     * @param {string} idCorrelation Identifiant du motif de MEF
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationMotifMefUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationMotifMefUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si un motif de sortie peut être réactivé
     * @param {string} idCorrelation Identifiant du motif de sortie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationMotifSortieUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationMotifSortieUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si un type d\'AF peut être réactivé
     * @param {string} idCorrelation Identifiant du type d\'AF
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationTypeAfUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationTypeAfUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si une unité FO peut être réactivée
     * @param {string} idCorrelation Identifiant de l\'unité FO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des données permettant de savoir si une vidéo tutorielle peut être réactivée
     * @param {string} idCorrelation Identifiant de la vidéo représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public conditionReactivationVideoTutorielUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).conditionReactivationVideoTutorielUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'importer un fichier avec les retours de la DNID.
     * @param {any} file Fichier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public contournementCsvImportUsingPOST(file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).contournementCsvImportUsingPOST(file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Récupère le nombre de configurations filtrés par le body de la requête
     * @param {countConfigurationsWithSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route countConfigurationsWithSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public countConfigurationsWithSpecsUsingGET(queryParams: CountConfigurationsWithSpecsUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).countConfigurationsWithSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer une autorite de fourrière.
     * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto Données utilisées pour créer l\'autorité de fourrière
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAutoriteFourriereUsingPOST(autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createAutoriteFourriereUsingPOST(autoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer une branche
     * @param {BrancheRequestDto} brancheRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBrancheUsingPOST(brancheRequestDto: BrancheRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createBrancheUsingPOST(brancheRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer un centre VHU
     * @param {CentreVHURequestDto} centreVHURequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCentreVHUUsingPOST(centreVHURequestDto: CentreVHURequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createCentreVHUUsingPOST(centreVHURequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer un état du véhicule
     * @param {EtatRequestDto} etatRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createEtatUsingPOST(etatRequestDto: EtatRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createEtatUsingPOST(etatRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer un domaine faq
     * @param {FaqDomainRequestDto} faqDomainRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFaqDomainUsingPOST(faqDomainRequestDto: FaqDomainRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createFaqDomainUsingPOST(faqDomainRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer une question
     * @param {FaqRequestDto} faqRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFaqUsingPOST(faqRequestDto: FaqRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createFaqUsingPOST(faqRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer un lien de bas de page
     * @param {FooterLinkRequestDto} footerLinkRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFooterLinkUsingPOST(footerLinkRequestDto: FooterLinkRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createFooterLinkUsingPOST(footerLinkRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer une fourrière.
     * @param {FourriereRequestDto} fourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFourriereUsingPOST(fourriereRequestDto: FourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createFourriereUsingPOST(fourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer un genre simplifié
     * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createGenreSimplifieUsingPOST(genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createGenreSimplifieUsingPOST(genreSimplifieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route pour créer un bandeau d\'information à afficher.
     * @param {InformationMessageRequestDto} informationMessageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInformationMessageUsingPOST(informationMessageRequestDto: InformationMessageRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createInformationMessageUsingPOST(informationMessageRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer une juridiction.
     * @param {JuridictionRequestDto} juridictionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createJuridictionUsingPOST(juridictionRequestDto: JuridictionRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createJuridictionUsingPOST(juridictionRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer un motif de MEF.
     * @param {MotifMefRequestDto} motifMefRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createMotifMefUsingPOST(motifMefRequestDto: MotifMefRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createMotifMefUsingPOST(motifMefRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer un motif de sortie.
     * @param {MotifSortieRequestDto} motifSortieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createMotifSortieUsingPOST(motifSortieRequestDto: MotifSortieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createMotifSortieUsingPOST(motifSortieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer un type d\'AF.
     * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTypeAfUsingPOST(typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createTypeAfUsingPOST(typeAutoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer une unité de force de l\'ordre.
     * @param {UniteFoRequestDto} uniteFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUniteFoUsingPOST(uniteFoRequestDto: UniteFoRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createUniteFoUsingPOST(uniteFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer une vidéo tutorielle
     * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createVideoTutorielUsingPOST(videoTutorielRequestDto: VideoTutorielRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).createVideoTutorielUsingPOST(videoTutorielRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary API permettant de supprimer un document spécifique
     * @param {string} idDocumentSpecifique UUID du document spécifique
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDocumentSpecifiqueUsingDELETE(idDocumentSpecifique: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deleteDocumentSpecifiqueUsingDELETE(idDocumentSpecifique, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Suppression d\'une des pièces jointes disponibles pour un dossier
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {string} type Type de la pièce jointe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePieceJointeUsingDELETE1(dossierId: string, type: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deletePieceJointeUsingDELETE1(dossierId, type, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'une autorité de fourrière.
     * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
     * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateAutoriteFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateAutoriteFourriereUsingPUT(idCorrelation, referentielCommentairesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'un centre vhu.
     * @param {string} idCorrelation Identifiant du centre vhu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateCentreVhuUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateCentreVhuUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'un état de véhicule.
     * @param {string} idCorrelation Identifiant de l\'état
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateEtatUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateEtatUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'un domaine faq.
     * @param {string} idCorrelation Identifiant du domaine faq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateFaqDomainUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateFaqDomainUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'une question
     * @param {string} idCorrelation Identifiant de la question
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateFaqUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateFaqUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'un lien de pied de page.
     * @param {string} idCorrelation Identifiant du lien
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateFooterLinkUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateFooterLinkUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'une fourrière.
     * @param {string} idCorrelation Identifiant de la fourrière
     * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateFourriereUsingPUT(idCorrelation, referentielCommentairesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'un genre simplifié.
     * @param {string} idCorrelation Identifiant du genre simplifié
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateGenreSimplifieUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateGenreSimplifieUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'une juridiction.
     * @param {string} idCorrelation Identifiant de la juridiction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateJuridictionUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateJuridictionUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'un motif de MEF.
     * @param {string} idCorrelation Identifiant du motif de MEF
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateMotifMefUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateMotifMefUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'un motif de sortie.
     * @param {string} idCorrelation Identifiant du motif de sortie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateMotifSortieUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateMotifSortieUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'un type d\'AF.
     * @param {string} idCorrelation Identifiant du type d\'AF
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateTypeAfUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateTypeAfUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'une unité FO.
     * @param {string} idCorrelation Identifiant de l\'unité FO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Désactivation d\'une vidéo tutorielle.
     * @param {string} idCorrelation Identifiant de la vidéo représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecateVideoTutorielUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).deprecateVideoTutorielUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'exporter la table de décision au format DMN.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadCsvTableUsingGET(options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).downloadCsvTableUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Téléchargement d\'une des pièces jointes disponibles pour un dossier
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {string} type Type de la pièce jointe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadUsingGET1(dossierId: string, type: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).downloadUsingGET1(dossierId, type, options)(this.fetch, this.basePath);
    }

    /**
     * @param {etatUsingGETQueryParams} queryParams objet contenant les query params de la route etatUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public etatUsingGET(queryParams: EtatUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).etatUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer l\'AR/PND depuis l\'ANTAI
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchArPndUsingPOST1(id: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).fetchArPndUsingPOST1(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer le courrier de notification depuis l\'ANTAI
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchCourrierUsingPOST1(id: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).fetchCourrierUsingPOST1(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les données de notification manuelle d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {FixDataNotificationManuelleRequestDto} fixDataNotificationManuelleRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fixDataNotificationManuelleUsingPOST(id: string, fixDataNotificationManuelleRequestDto: FixDataNotificationManuelleRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).fixDataNotificationManuelleUsingPOST(id, fixDataNotificationManuelleRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de déterminer quelle solution est active pour le partenaire alienation.<br/> Celle-ci pouvant être l\'API du partenaire alienation ou la solution de contournement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAlienationActiveSolutionUsingGET(options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getAlienationActiveSolutionUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'exporter l\'ensemble des données d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllDonneesAndEventsDossierUsingGET(id: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getAllDonneesAndEventsDossierUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Récupère la liste des noms de microservices ayant des configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllMicroServiceNamesUsingGET(options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getAllMicroServiceNamesUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Récupère un rapport d\'apurement par son id.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApurementReportUsingGET(id: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getApurementReportUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Récupération de la liste des anciennes version d\'une configuration via son idCorrelation
     * @param {string} idCorrelation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConfigurationHistoriqueUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getConfigurationHistoriqueUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'obtenir la liste des détails des évènements
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDetailedEventsUsingGET(id: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getDetailedEventsUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel d\'exporter les statistiques
     * @param {ExportStatistiquesRequestDto} exportStatistiquesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExportStatistiquesUsingPOST(exportStatistiquesRequestDto: ExportStatistiquesRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getExportStatistiquesUsingPOST(exportStatistiquesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Router permettant de récupérer le statuts des flux
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFluxStatusesUsingGET(options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getFluxStatusesUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche les fourrieres associées à une autorité fourriere
     * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFourrieresFromValidAutoriteFourriereUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getFourrieresFromValidAutoriteFourriereUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'obtenir les informations du bandeau de l\'admin fonctionnel avec l\'objet DossierDtoAdminFonctionnel
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInformationsByDossierIdUsingGET(id: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getInformationsByDossierIdUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Permet de récupérer la date de la prochaine exécution planifiée d\'un flux
     * @param {'ALIENATION_UPDATE_STATUS_BIEN' | 'ALIENATION_LIEU_DEPOT' | 'ALIENATION_ENTITE_REMETTANTE' | 'ANTAI_RECUPERATION_INFORMATION_SYNCHRONIZATION' | 'ANTAI_RECUPERATION_INFORMATION_RETRY' | 'DOSSIER_PURGE' | 'DOSSIER_ANONYMISATION' | 'DOSSIER_RESYNC' | 'DOSSIER_BLOCAGE' | 'DOSSIER_UNSYNC' | 'RPSI_BATCH' | 'REPORT_PURGE'} fluxType Type de flux dont on souhaite connaître la prochaine date d\'exécution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNextExecutionTimeUsingGET(fluxType: 'ALIENATION_UPDATE_STATUS_BIEN' | 'ALIENATION_LIEU_DEPOT' | 'ALIENATION_ENTITE_REMETTANTE' | 'ANTAI_RECUPERATION_INFORMATION_SYNCHRONIZATION' | 'ANTAI_RECUPERATION_INFORMATION_RETRY' | 'DOSSIER_PURGE' | 'DOSSIER_ANONYMISATION' | 'DOSSIER_RESYNC' | 'DOSSIER_BLOCAGE' | 'DOSSIER_UNSYNC' | 'RPSI_BATCH' | 'REPORT_PURGE', options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getNextExecutionTimeUsingGET(fluxType, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant les questions valides, regroupées par domaines pour l\'admin.
     * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} profile Profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOnlyValidFaqByDomainsForProfileUsingGET(profile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getOnlyValidFaqByDomainsForProfileUsingGET(profile, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récuperer le pdf actions camunda
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPdfActionsCamundaUsingGET(options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getPdfActionsCamundaUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer la liste des types de pièces jointes disponibles pour un dossier
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPieceJointeTypesUsingGET1(dossierId: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getPieceJointeTypesUsingGET1(dossierId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer les instances Camunda d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessInstancesUsingGET(id: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getProcessInstancesUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer un flux spécifique de synchronisation des fourrières avec la DNID
     * @param {string} fluxId Id du flux, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSpecificFluxFourriereUsingGET(fluxId: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).getSpecificFluxFourriereUsingGET(fluxId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'importer une table de décision au format DMN.
     * @param {any} file Fichier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importCsvTableUsingPOST(file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).importCsvTableUsingPOST(file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route pour valider un champ du formulaire de mise à jour du bandeau d\'information à afficher.
     * @param {'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES'} field 
     * @param {string} id 
     * @param {InformationMessageRequestDto} informationMessageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public informationMessageValidateFieldUsingPOST(field: 'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES', id: string, informationMessageRequestDto: InformationMessageRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).informationMessageValidateFieldUsingPOST(field, id, informationMessageRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route pour valider un champ du formulaire de création d\'un bandeau d\'information à afficher.
     * @param {'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES'} field 
     * @param {InformationMessageRequestDto} informationMessageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public informationMessageValidateFieldUsingPOST1(field: 'TITRE' | 'CONTENT' | 'START_DATE' | 'END_DATE' | 'VALID' | 'PROFILES', informationMessageRequestDto: InformationMessageRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).informationMessageValidateFieldUsingPOST1(field, informationMessageRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route pour valider un formulaire de création d\'un bandeau d\'information à afficher.
     * @param {InformationMessageRequestDto} informationMessageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public informationMessageValidateUsingPOST(informationMessageRequestDto: InformationMessageRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).informationMessageValidateUsingPOST(informationMessageRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de migrer d\'une unité fo à une autre les dossiers associés
     * @param {MigrateUniteFoRequestDto} migrateUniteFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public migrateUniteFoUsingPOST(migrateUniteFoRequestDto: MigrateUniteFoRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).migrateUniteFoUsingPOST(migrateUniteFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'une autorité de fourrière.
     * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
     * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateAutoriteFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateAutoriteFourriereUsingPUT(idCorrelation, referentielCommentairesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'un centre vhu.
     * @param {string} idCorrelation Identifiant du centre vhu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateCentreVhuUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateCentreVhuUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'un état de véhicule.
     * @param {string} idCorrelation Identifiant de l\'état
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateEtatUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateEtatUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'un domaine faq.
     * @param {string} idCorrelation Identifiant du domaine faq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateFaqDomainUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateFaqDomainUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'une question
     * @param {string} idCorrelation Identifiant de la question
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateFaqUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateFaqUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'un lien de pied de page.
     * @param {string} idCorrelation Identifiant du lien
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateFooterLinkUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateFooterLinkUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'une fourrière.
     * @param {string} idCorrelation Identifiant de la fourrière
     * @param {ReferentielCommentairesRequestDto} referentielCommentairesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateFourriereUsingPUT(idCorrelation: string, referentielCommentairesRequestDto: ReferentielCommentairesRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateFourriereUsingPUT(idCorrelation, referentielCommentairesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'un genre simplifié.
     * @param {string} idCorrelation Identifiant du genre simplifié
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateGenreSimplifieUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateGenreSimplifieUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'une juridiction.
     * @param {string} idCorrelation Identifiant de la juridiction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateJuridictionUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateJuridictionUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'un motif de MEF.
     * @param {string} idCorrelation Identifiant du motif de MEF
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateMotifMefUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateMotifMefUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'un motif de sortie.
     * @param {string} idCorrelation Identifiant du motif de sortie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateMotifSortieUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateMotifSortieUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'un type d\'AF.
     * @param {string} idCorrelation Identifiant du type d\'AF
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateTypeAfUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateTypeAfUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'une unité FO.
     * @param {string} idCorrelation Identifiant de l\'unité FO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Réactivation d\'une vidéo tutorielle.
     * @param {string} idCorrelation Identifiant de la vidéo représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateVideoTutorielUsingPUT(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).reactivateVideoTutorielUsingPUT(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Récupération de l\'historique des actions d\'un utilisateur
     * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recupererHistoriqueActionsUtilisateurUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).recupererHistoriqueActionsUtilisateurUsingPOST(recuperationActiviteUtilisateurRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Récupération de l\'historique des consultations d\'un dossier par un utilisateur
     * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recupererHistoriqueConnexionsUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).recupererHistoriqueConnexionsUsingPOST(recuperationActiviteUtilisateurRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Récupération de l\'historique des consultations d\'un dossier par un utilisateur
     * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recupererHistoriqueConsultationsDossierUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).recupererHistoriqueConsultationsDossierUsingPOST(recuperationActiviteUtilisateurRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route déclenchant une relance du processus de vente chez le service des domaines, engendrant une nouvelle remise aux domaines.
     * @param {RelanceVenteDto} relanceVenteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public relanceVenteAdminUsingPOST(relanceVenteDto: RelanceVenteDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).relanceVenteAdminUsingPOST(relanceVenteDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de sauvegarder une fiche descriptive
     * @param {any} file La fiche descriptive, représentée par un InputStream
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveFicheDescriptiveUsingPOST(file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).saveFicheDescriptiveUsingPOST(file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de sauvegarder un manuel Bdr
     * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
     * @param {any} file Le manuel, représenté par un InputStream.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveManualBdrUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).saveManualBdrUsingPOST(userProfile, file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de sauvegarder un manuel utilisateur
     * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
     * @param {any} file Le manuel, représenté par un InputStream.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveManualUtilisateurUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).saveManualUtilisateurUsingPOST(userProfile, file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche de la liste des configurations filtrés par le body de la requête
     * @param {searchConfigurationsWithSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchConfigurationsWithSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchConfigurationsWithSpecsUsingGET(queryParams: SearchConfigurationsWithSpecsUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchConfigurationsWithSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche de la liste des états filtrés par le body de la requête
     * @param {searchEtatUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchEtatUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchEtatUsingSpecsUsingGET(queryParams: SearchEtatUsingSpecsUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchEtatUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche de la liste de domaine faq filtrés par le body de la requête
     * @param {searchFaqDomainUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFaqDomainUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFaqDomainUsingSpecsUsingGET(queryParams: SearchFaqDomainUsingSpecsUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchFaqDomainUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche de la liste des faq filtrés par le body de la requête
     * @param {searchFaqUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFaqUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFaqUsingSpecsUsingGET(queryParams: SearchFaqUsingSpecsUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchFaqUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer les flux de autorités fourrière aliénation
     * @param {searchFluxAutoriteFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxAutoriteFourriereUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFluxAutoriteFourriereUsingGET(queryParams: SearchFluxAutoriteFourriereUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchFluxAutoriteFourriereUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer les flux Aliénation de récupération de l\'état des biens
     * @param {searchFluxEtatBienUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxEtatBienUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFluxEtatBienUsingGET(queryParams: SearchFluxEtatBienUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchFluxEtatBienUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer les flux spécifiques de synchronisation des fourrières avec la DNID
     * @param {searchFluxFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxFourriereUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFluxFourriereUsingGET(queryParams: SearchFluxFourriereUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchFluxFourriereUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer les flux du batch rpsi
     * @param {searchFluxRpsiUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxRpsiUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFluxRpsiUsingGET(queryParams: SearchFluxRpsiUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchFluxRpsiUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer les flux Antai
     * @param {searchFluxUsingGETQueryParams} queryParams objet contenant les query params de la route searchFluxUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFluxUsingGET(queryParams: SearchFluxUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchFluxUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche de la liste des liens de pied de page filtrés par le body de la requête
     * @param {searchFooterLinkUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFooterLinkUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFooterLinkUsingSpecsUsingGET(queryParams: SearchFooterLinkUsingSpecsUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchFooterLinkUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche de la liste des genres simplifiés filtrés par le body de la requête
     * @param {searchGenreSimplifieUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchGenreSimplifieUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchGenreSimplifieUsingSpecsUsingGET(queryParams: SearchGenreSimplifieUsingSpecsUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchGenreSimplifieUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche de la liste de motifs de sortie filtrée par le body de la requête
     * @param {searchMotifSortieUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchMotifSortieUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchMotifSortieUsingSpecsUsingGET(queryParams: SearchMotifSortieUsingSpecsUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchMotifSortieUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer un flux Aliénation de récupération des autorités fourrière
     * @param {string} fluxId Id du flux, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchSpecificFluxAutoriteFouriereUsingGET(fluxId: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchSpecificFluxAutoriteFouriereUsingGET(fluxId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer un flux Aliénation de récupération de l\'état des biens
     * @param {string} fluxId Id du flux, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchSpecificFluxEtatBienUsingGET(fluxId: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchSpecificFluxEtatBienUsingGET(fluxId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer un flux Antai de récupération d\'un évènement
     * @param {string} fluxId Id du flux, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchSpecificFluxUsingGET(fluxId: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchSpecificFluxUsingGET(fluxId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche de la liste des types d\'AF filtrée par le body de la requête
     * @param {searchTypeAfUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchTypeAfUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchTypeAfUsingSpecsUsingGET(queryParams: SearchTypeAfUsingSpecsUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchTypeAfUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer les événements d\'administration sur les utilisateurs
     * @param {SearchUserEventsRequestDto} searchUserEventsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUserEventsUsingPOST(searchUserEventsRequestDto: SearchUserEventsRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchUserEventsUsingPOST(searchUserEventsRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des utilisations d\'une autorite de fourrière dans le SI
     * @param {string} idCorrelation Identifiant de l\'autorité de fourrière
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUsesAutoriteFourriereUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchUsesAutoriteFourriereUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des utilisations d\'un état dans le SI
     * @param {string} idCorrelation Identifiant de l\'état
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUsesEtatUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchUsesEtatUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des utilisations d\'une fourrière dans le SI
     * @param {string} idCorrelation Identifiant de la fourrière
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUsesFourriereUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchUsesFourriereUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des utilisations d\'un genre simplifié dans le SI
     * @param {string} idCorrelation Identifiant du genre simplifié
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUsesGenreSimplifieUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchUsesGenreSimplifieUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des utilisations d\'une juridiction dans le SI
     * @param {string} idCorrelation Identifiant de la juridiction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUsesJuridictionUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchUsesJuridictionUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche des utilisations d\'une Unité FO dans le SI
     * @param {string} idCorrelation Identifiant de l\'unité FO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUsesUniteFoUsingGET(idCorrelation: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchUsesUniteFoUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche de la liste des vidéos tutorielles filtrées par le body de la requête
     * @param {searchVideoTutorielUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchVideoTutorielUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchVideoTutorielUsingSpecsUsingGET(queryParams: SearchVideoTutorielUsingSpecsUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchVideoTutorielUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux de autorité fourrières aliénation
     * @param {string} fluxId Id du flux, représenté par un UUID
     * @param {searchWarningsFluxAutoriteFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchWarningsFluxAutoriteFourriereUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchWarningsFluxAutoriteFourriereUsingGET(fluxId: string, queryParams: SearchWarningsFluxAutoriteFourriereUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchWarningsFluxAutoriteFourriereUsingGET(fluxId, queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux spécifique de synchronisation des fourrières avec la DNID
     * @param {string} fluxId Id du flux, représenté par un UUID
     * @param {searchWarningsFluxFourriereUsingGETQueryParams} queryParams objet contenant les query params de la route searchWarningsFluxFourriereUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchWarningsFluxFourriereUsingGET(fluxId: string, queryParams: SearchWarningsFluxFourriereUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchWarningsFluxFourriereUsingGET(fluxId, queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux
     * @param {string} fluxId Id du flux, représenté par un UUID.
     * @param {searchWarningsOfFluxEtatBienUsingGETQueryParams} queryParams objet contenant les query params de la route searchWarningsOfFluxEtatBienUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchWarningsOfFluxEtatBienUsingGET(fluxId: string, queryParams: SearchWarningsOfFluxEtatBienUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).searchWarningsOfFluxEtatBienUsingGET(fluxId, queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de supprimer un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public suppressionDossierUsingDELETE(id: string, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).suppressionDossierUsingDELETE(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour une autorité de fourrière.
     * @param {string} idCorrelation ID de l\'autorite de fourrière, représenté par un UUID
     * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAutoriteFourriereUsingPUT(idCorrelation: string, autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateAutoriteFourriereUsingPUT(idCorrelation, autoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour une branche
     * @param {string} idCorrelation ID corrélation de la branche, représenté par un UUID
     * @param {BrancheRequestDto} brancheRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBrancheUsingPUT(idCorrelation: string, brancheRequestDto: BrancheRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateBrancheUsingPUT(idCorrelation, brancheRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour un centre VHU.
     * @param {string} idCorrelation ID du centre vhu, représenté par un UUID
     * @param {CentreVHURequestDto} centreVHURequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCentreVHUUsingPUT(idCorrelation: string, centreVHURequestDto: CentreVHURequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateCentreVHUUsingPUT(idCorrelation, centreVHURequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier le classement d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateClassementRequestDto} updateClassementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateClassementUsingPOST(id: string, updateClassementRequestDto: UpdateClassementRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateClassementUsingPOST(id, updateClassementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour une configuration de l\'application
     * @param {string} idCorrelation ID corrélation de la configuration, représenté par un UUID
     * @param {ConfigurationUpdateRequestDto} configurationUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateConfigurationUsingPUT(idCorrelation: string, configurationUpdateRequestDto: ConfigurationUpdateRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateConfigurationUsingPUT(idCorrelation, configurationUpdateRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDonneesInterieurVehiculeUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateDonneesInterieurVehiculeUsingPOST(id, updateDonneesInterieurVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les données judiciaires d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDonneesJudiciairesUsingPOST1(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateDonneesJudiciairesUsingPOST1(id, updateDonneesJudiciairesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les entitées de rattachement d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEntitesRattachementUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateEntitesRattachementUsingPOST(id, updateEntitesRattachementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour un état du véhicule
     * @param {string} idCorrelation ID corrélation de l\'état, représenté par un UUID
     * @param {EtatRequestDto} etatRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEtatUsingPUT(idCorrelation: string, etatRequestDto: EtatRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateEtatUsingPUT(idCorrelation, etatRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour un domain faq.
     * @param {string} idCorrelation ID du domaine faq, représenté par un UUID
     * @param {FaqDomainRequestDto} faqDomainRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFaqDomainUsingPUT(idCorrelation: string, faqDomainRequestDto: FaqDomainRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateFaqDomainUsingPUT(idCorrelation, faqDomainRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour une question
     * @param {string} idCorrelation ID de la question, représenté par un UUID
     * @param {FaqRequestDto} faqRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFaqUsingPUT(idCorrelation: string, faqRequestDto: FaqRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateFaqUsingPUT(idCorrelation, faqRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour un lien de bas de page
     * @param {string} idCorrelation ID corrélation du lien de bas de page, représenté par un UUID
     * @param {FooterLinkRequestDto} footerLinkRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFooterLinkUsingPUT(idCorrelation: string, footerLinkRequestDto: FooterLinkRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateFooterLinkUsingPUT(idCorrelation, footerLinkRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour une fourrière.
     * @param {string} idCorrelation ID de la fourrère, représentée par un UUID
     * @param {FourriereRequestDto} fourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFourriereUsingPUT(idCorrelation: string, fourriereRequestDto: FourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateFourriereUsingPUT(idCorrelation, fourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour un genre simplifié
     * @param {string} idCorrelation ID corrélation du genre simplifié, représenté par un UUID
     * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateGenreSimplifieUsingPUT(idCorrelation: string, genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateGenreSimplifieUsingPUT(idCorrelation, genreSimplifieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route pour éditer un bandeau d\'information à afficher.
     * @param {string} id 
     * @param {InformationMessageRequestDto} informationMessageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInformationMessageUsingPOST(id: string, informationMessageRequestDto: InformationMessageRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateInformationMessageUsingPOST(id, informationMessageRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route pour valider le formulaire de mise à jour d\'un bandeau d\'information.
     * @param {string} id 
     * @param {InformationMessageRequestDto} informationMessageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInformationMessageValidateUsingPOST(id: string, informationMessageRequestDto: InformationMessageRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateInformationMessageValidateUsingPOST(id, informationMessageRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de renseigner manuellement les données siv d\'un véhicule
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {InfosSivRequestDto} infosSivRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInfosSivManuelUsingPOST(id: string, infosSivRequestDto: InfosSivRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateInfosSivManuelUsingPOST(id, infosSivRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour une juridiction.
     * @param {string} idCorrelation ID de la juridiction, représenté par un UUID
     * @param {JuridictionRequestDto} juridictionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateJuridictionUsingPUT(idCorrelation: string, juridictionRequestDto: JuridictionRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateJuridictionUsingPUT(idCorrelation, juridictionRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier la catégorie d\'une marque.
     * @param {string} idCorrelation 
     * @param {MarqueRequestDto} marqueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMarqueUsingPOST(idCorrelation: string, marqueRequestDto: MarqueRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateMarqueUsingPOST(idCorrelation, marqueRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour un motif de MEF.
     * @param {string} idCorrelation ID du motif de MEF, représenté par un UUID
     * @param {MotifMefRequestDto} motifMefRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMotifMefUsingPUT(idCorrelation: string, motifMefRequestDto: MotifMefRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateMotifMefUsingPUT(idCorrelation, motifMefRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier un motif de sortie.
     * @param {string} idCorrelation Identifiant de correlation du motif
     * @param {MotifSortieRequestDto} motifSortieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMotifSortieUsingPUT(idCorrelation: string, motifSortieRequestDto: MotifSortieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateMotifSortieUsingPUT(idCorrelation, motifSortieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les données de sortie d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateSortieVehiculeRequestDto} updateSortieVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSortieVehiculeUsingPOST(id: string, updateSortieVehiculeRequestDto: UpdateSortieVehiculeRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateSortieVehiculeUsingPOST(id, updateSortieVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier un type d\'AF.
     * @param {string} idCorrelation Identifiant de correlation du type
     * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTypeAfUsingPUT(idCorrelation: string, typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateTypeAfUsingPUT(idCorrelation, typeAutoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour une unité de force de l\'ordre.
     * @param {string} idCorrelation ID de l\'unité force de l\'ordre, représenté par un UUID
     * @param {UniteFoRequestDto} uniteFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUniteFoUsingPUT(idCorrelation: string, uniteFoRequestDto: UniteFoRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateUniteFoUsingPUT(idCorrelation, uniteFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour une vidéo tutorielle
     * @param {string} idCorrelation ID corrélation de la vidéo tutorielle, représenté par un UUID
     * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateVideoTutorielUsingPUT(idCorrelation: string, videoTutorielRequestDto: VideoTutorielRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).updateVideoTutorielUsingPUT(idCorrelation, videoTutorielRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary API permettant d\'uploader le csv d\'apurement des dossiers.
     * @param {any} file Fichier csv contenant les ids des dossiers à apurer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadApurementDossiersFileUsingPOST(file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).uploadApurementDossiersFileUsingPOST(file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary API permettant d\'uploader un document spécifique pour un destinataire
     * @param {any} file Fichier du document
     * @param {uploadDocumentSpecifiqueUsingPOSTQueryParams} queryParams objet contenant les query params de la route uploadDocumentSpecifiqueUsingPOST
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadDocumentSpecifiqueUsingPOST(file: any, queryParams: UploadDocumentSpecifiqueUsingPOSTQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).uploadDocumentSpecifiqueUsingPOST(file, queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary API permettant d\'uploader une pièce jointe pour un dossier
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {string} type Type de la pièce jointe
     * @param {any} file Fichier de la pièce jointe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPieceJointeUsingPOST1(dossierId: string, type: string, file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).uploadPieceJointeUsingPOST1(dossierId, type, file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'une autorité fourrière.
     * @param {'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR'} field Nom du champ à valider, défini par un enum
     * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateAutoriteFourriereFieldUsingPOST(field: 'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR', autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateAutoriteFourriereFieldUsingPOST(field, autoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'une autorité de fourrière.
     * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateAutoriteFourriereUsingPOST(autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateAutoriteFourriereUsingPOST(autoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'une branche.
     * @param {'NATURE' | 'BRANCHE'} field Nom du champ à valider, défini par un enum
     * @param {BrancheRequestDto} brancheRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateBrancheFieldUsingPOST(field: 'NATURE' | 'BRANCHE', brancheRequestDto: BrancheRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateBrancheFieldUsingPOST(field, brancheRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'une branche
     * @param {BrancheRequestDto} brancheRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateBrancheUsingPOST(brancheRequestDto: BrancheRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateBrancheUsingPOST(brancheRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'un centre vhu.
     * @param {'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE'} field Nom du champ à valider, défini par un enum
     * @param {CentreVHURequestDto} centreVHURequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateCentreVHUFieldUsingPOST(field: 'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE', centreVHURequestDto: CentreVHURequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateCentreVHUFieldUsingPOST(field, centreVHURequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'un centre VHU
     * @param {CentreVHURequestDto} centreVHURequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateCentreVHUUsingPOST(centreVHURequestDto: CentreVHURequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateCentreVHUUsingPOST(centreVHURequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'un état de véhicule
     * @param {'ETAT' | 'DETAIL' | 'LIBELLE_COURT'} field Nom du champ à valider, défini par un enum
     * @param {EtatRequestDto} etatRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateEtatFieldUsingPOST(field: 'ETAT' | 'DETAIL' | 'LIBELLE_COURT', etatRequestDto: EtatRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateEtatFieldUsingPOST(field, etatRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'un état de véhicule
     * @param {EtatRequestDto} etatRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateEtatUsingPOST(etatRequestDto: EtatRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateEtatUsingPOST(etatRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'un lien de bas de page
     * @param {'LINK' | 'TEXT' | 'PROFILE'} field Nom du champ à valider, défini par un enum
     * @param {FooterLinkRequestDto} footerLinkRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateFooterLinkFieldUsingPOST(field: 'LINK' | 'TEXT' | 'PROFILE', footerLinkRequestDto: FooterLinkRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateFooterLinkFieldUsingPOST(field, footerLinkRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'un lien de bas de page
     * @param {FooterLinkRequestDto} footerLinkRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateFooterLinkUsingPOST(footerLinkRequestDto: FooterLinkRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateFooterLinkUsingPOST(footerLinkRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'une fourrière.
     * @param {'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION'} field Nom du champ à valider, défini par un enum
     * @param {FourriereRequestDto} fourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateFourriereFieldUsingPOST(field: 'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION', fourriereRequestDto: FourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateFourriereFieldUsingPOST(field, fourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'une fourrière.
     * @param {FourriereRequestDto} fourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateFourriereUsingPOST(fourriereRequestDto: FourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateFourriereUsingPOST(fourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'un genre simplifié
     * @param {'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES'} field Nom du champ à valider, défini par un enum
     * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateGenreSimplifieFieldUsingPOST(field: 'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES', genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateGenreSimplifieFieldUsingPOST(field, genreSimplifieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'un genre simplifié
     * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateGenreSimplifieUsingPOST(genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateGenreSimplifieUsingPOST(genreSimplifieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'une juridiction
     * @param {'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE'} field Nom du champ à valider, défini par un enum
     * @param {JuridictionRequestDto} juridictionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateJuridictionFieldUsingPOST(field: 'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE', juridictionRequestDto: JuridictionRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateJuridictionFieldUsingPOST(field, juridictionRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'une juridiction
     * @param {JuridictionRequestDto} juridictionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateJuridictionUsingPOST(juridictionRequestDto: JuridictionRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateJuridictionUsingPOST(juridictionRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'un motif de MEF.
     * @param {'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO'} field Nom du champ à valider, défini par un enum
     * @param {MotifMefRequestDto} motifMefRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateMotifMefFieldUsingPOST(field: 'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO', motifMefRequestDto: MotifMefRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateMotifMefFieldUsingPOST(field, motifMefRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'un motif de MEF.
     * @param {MotifMefRequestDto} motifMefRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateMotifMefUsingPOST(motifMefRequestDto: MotifMefRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateMotifMefUsingPOST(motifMefRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'un motif de sortie.
     * @param {'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT'} field Nom du champ à valider, défini par un enum
     * @param {MotifSortieRequestDto} motifSortieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateMotifSortieFieldUsingPOST(field: 'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT', motifSortieRequestDto: MotifSortieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateMotifSortieFieldUsingPOST(field, motifSortieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'un motif de sortie.
     * @param {MotifSortieRequestDto} motifSortieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateMotifSortieUsingPOST(motifSortieRequestDto: MotifSortieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateMotifSortieUsingPOST(motifSortieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'un type d\'AF.
     * @param {'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2'} field Nom du champ à valider, défini par un enum
     * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateTypeAFFieldUsingPOST(field: 'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2', typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateTypeAFFieldUsingPOST(field, typeAutoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'un type d\'AF.
     * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateTypeAfUsingPOST(typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateTypeAfUsingPOST(typeAutoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'une unité FO.
     * @param {'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT'} field Nom du champ à valider, défini par un enum
     * @param {UniteFoRequestDto} uniteFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateUniteFoFieldUsingPOST(field: 'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT', uniteFoRequestDto: UniteFoRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateUniteFoFieldUsingPOST(field, uniteFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'une unite FO.
     * @param {UniteFoRequestDto} uniteFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateUniteFoUsingPOST(uniteFoRequestDto: UniteFoRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateUniteFoUsingPOST(uniteFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'une vidéo tutorielle.
     * @param {'VIDEO_ID' | 'PROFILE'} field Nom du champ à valider, défini par un enum
     * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateVideoTutorielFieldUsingPOST(field: 'VIDEO_ID' | 'PROFILE', videoTutorielRequestDto: VideoTutorielRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateVideoTutorielFieldUsingPOST(field, videoTutorielRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'une vidéo tutorielle
     * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateVideoTutorielUsingPOST(videoTutorielRequestDto: VideoTutorielRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateCreateVideoTutorielUsingPOST(videoTutorielRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de l\'entité ExportStatistiques.
     * @param {ExportStatistiquesRequestDto} exportStatistiquesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateExportStatistiquesRequestUsingPOST(exportStatistiquesRequestDto: ExportStatistiquesRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateExportStatistiquesRequestUsingPOST(exportStatistiquesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'un domaine faq.
     * @param {'NAME'} field Nom du champ à valider, défini par un enum
     * @param {FaqDomainRequestDto} faqDomainRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFaqDomainFieldUsingPOST(field: 'NAME', faqDomainRequestDto: FaqDomainRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateFaqDomainFieldUsingPOST(field, faqDomainRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'un domaine faq
     * @param {FaqDomainRequestDto} faqDomainRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFaqDomainUsingPOST(faqDomainRequestDto: FaqDomainRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateFaqDomainUsingPOST(faqDomainRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de création d\'une question
     * @param {'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT'} field Nom du champ à valider, défini par un enum
     * @param {FaqRequestDto} faqRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFaqFieldUsingPOST(field: 'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT', faqRequestDto: FaqRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateFaqFieldUsingPOST(field, faqRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de création d\'une question
     * @param {FaqRequestDto} faqRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFaqUsingPOST(faqRequestDto: FaqRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateFaqUsingPOST(faqRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications du classement d\'un dossier
     * @param {'JUSTIFICATION' | 'NEW_CLASSEMENT'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateClassementRequestDto} updateClassementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFieldUpdateClassementUsingPOST(field: 'JUSTIFICATION' | 'NEW_CLASSEMENT', id: string, updateClassementRequestDto: UpdateClassementRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateFieldUpdateClassementUsingPOST(field, id, updateClassementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications de la notification manuelle d\'un dossier
     * @param {'NEW_DATE_ENVOI' | 'NEW_DATE_SIGNATURE' | 'NEW_ETAT_DISTRIBUTION' | 'JUSTIFICATION'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {FixDataNotificationManuelleRequestDto} fixDataNotificationManuelleRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFixDataNotificationManuelleFieldUsingPOST(field: 'NEW_DATE_ENVOI' | 'NEW_DATE_SIGNATURE' | 'NEW_ETAT_DISTRIBUTION' | 'JUSTIFICATION', id: string, fixDataNotificationManuelleRequestDto: FixDataNotificationManuelleRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateFixDataNotificationManuelleFieldUsingPOST(field, id, fixDataNotificationManuelleRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications de la notification manuelle d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {FixDataNotificationManuelleRequestDto} fixDataNotificationManuelleRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFixDataNotificationManuelleUsingPOST(id: string, fixDataNotificationManuelleRequestDto: FixDataNotificationManuelleRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateFixDataNotificationManuelleUsingPOST(id, fixDataNotificationManuelleRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications d\'un champ de la migration d\'unité FO
     * @param {'NEW_UNITE_FO_CORRELATION_ID' | 'OLD_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
     * @param {MigrateUniteFoRequestDto} migrateUniteFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateMigrateUniteFoFieldUsingPOST(field: 'NEW_UNITE_FO_CORRELATION_ID' | 'OLD_UNITE_FO_CORRELATION_ID' | 'COMMENT', migrateUniteFoRequestDto: MigrateUniteFoRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateMigrateUniteFoFieldUsingPOST(field, migrateUniteFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications de la migration d\'unité FO
     * @param {MigrateUniteFoRequestDto} migrateUniteFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateMigrateUniteFoUsingPOST(migrateUniteFoRequestDto: MigrateUniteFoRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateMigrateUniteFoUsingPOST(migrateUniteFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'une autorité fourrière.
     * @param {'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation ID de l\'autorite de fourrière, représenté par un UUID
     * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateAutoriteFourriereFieldUsingPOST(field: 'NUMERO_DEPARTEMENT' | 'LIBELLE_DEPARTEMENT' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'VILLE' | 'VOIE' | 'ID_ALIENATION' | 'ID_ALIENATION_UTILISATEUR', idCorrelation: string, autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateAutoriteFourriereFieldUsingPOST(field, idCorrelation, autoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'une autorité de fourrière.
     * @param {string} idCorrelation ID de l\'autorite de fourrière, représenté par un UUID
     * @param {AutoriteFourriereRequestDto} autoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateAutoriteFourriereUsingPOST(idCorrelation: string, autoriteFourriereRequestDto: AutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateAutoriteFourriereUsingPOST(idCorrelation, autoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'une branche.
     * @param {'NATURE' | 'BRANCHE'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation ID corrélation de la branche, représenté par un UUID
     * @param {BrancheRequestDto} brancheRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateBrancheFieldUsingPOST(field: 'NATURE' | 'BRANCHE', idCorrelation: string, brancheRequestDto: BrancheRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateBrancheFieldUsingPOST(field, idCorrelation, brancheRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'une branche
     * @param {string} idCorrelation ID corrélation de la branche, représenté par un UUID
     * @param {BrancheRequestDto} brancheRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateBrancheUsingPOST(idCorrelation: string, brancheRequestDto: BrancheRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateBrancheUsingPOST(idCorrelation, brancheRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'un centre vhu.
     * @param {'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation Id de corrélation du centre vhu à mettre à jour
     * @param {CentreVHURequestDto} centreVHURequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateCentreVHUFieldUsingPOST(field: 'RAISON_SOCIALE' | 'SIREN' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE' | 'EMAIL' | 'NUMERO_AGREMENT_VHU' | 'PREFECTURE_DELIVRANTE', idCorrelation: string, centreVHURequestDto: CentreVHURequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateCentreVHUFieldUsingPOST(field, idCorrelation, centreVHURequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'un centre vhu.
     * @param {string} idCorrelation Id de corrélation du centre vhu à mettre à jour
     * @param {CentreVHURequestDto} centreVHURequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateCentreVHUUsingPOST(idCorrelation: string, centreVHURequestDto: CentreVHURequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateCentreVHUUsingPOST(idCorrelation, centreVHURequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications du classement d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateClassementRequestDto} updateClassementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateClassementUsingPOST(id: string, updateClassementRequestDto: UpdateClassementRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateClassementUsingPOST(id, updateClassementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider une modification des données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
     * @param {'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateDonneesInterieurVehiculeFieldUsingPOST(field: 'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF', id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateDonneesInterieurVehiculeFieldUsingPOST(field, id, updateDonneesInterieurVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications des données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateDonneesInterieurVehiculeUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateDonneesInterieurVehiculeUsingPOST(id, updateDonneesInterieurVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider une modification des données judiciaires d\'un dossier
     * @param {'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateDonneesJudiciairesFieldUsingPOST1(field: 'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE', id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateDonneesJudiciairesFieldUsingPOST1(field, id, updateDonneesJudiciairesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications des données judiciaires d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateDonneesJudiciairesUsingPOST1(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateDonneesJudiciairesUsingPOST1(id, updateDonneesJudiciairesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications des entitées de rattachement d\'un dossier
     * @param {'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateEntitesRattachementFieldUsingPOST(field: 'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT', id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateEntitesRattachementFieldUsingPOST(field, id, updateEntitesRattachementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications des entitées de rattachement d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateEntitesRattachementUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateEntitesRattachementUsingPOST(id, updateEntitesRattachementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'un état de véhicule
     * @param {'ETAT' | 'DETAIL' | 'LIBELLE_COURT'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation ID corrélation de l\'état, représenté par un UUID
     * @param {EtatRequestDto} etatRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateEtatFieldUsingPOST(field: 'ETAT' | 'DETAIL' | 'LIBELLE_COURT', idCorrelation: string, etatRequestDto: EtatRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateEtatFieldUsingPOST(field, idCorrelation, etatRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'un état de véhicule
     * @param {string} idCorrelation ID corrélation de l\'état, représenté par un UUID
     * @param {EtatRequestDto} etatRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateEtatUsingPOST(idCorrelation: string, etatRequestDto: EtatRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateEtatUsingPOST(idCorrelation, etatRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de modification d\'une question
     * @param {'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation Id de corrélation de la question à mettre à jour
     * @param {FaqRequestDto} faqRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateFaqFieldUsingPOST(field: 'DOMAIN_ID' | 'TITLE' | 'PROFILES' | 'CONTENT', idCorrelation: string, faqRequestDto: FaqRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateFaqFieldUsingPOST(field, idCorrelation, faqRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de la modification d\'une question
     * @param {string} idCorrelation Id de corrélation de la question à mettre à jour
     * @param {FaqRequestDto} faqRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateFaqUsingPOST(idCorrelation: string, faqRequestDto: FaqRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateFaqUsingPOST(idCorrelation, faqRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'un lien de bas de page
     * @param {'LINK' | 'TEXT' | 'PROFILE'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation ID corrélation du lien de bas de page, représenté par un UUID
     * @param {FooterLinkRequestDto} footerLinkRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateFooterLinkFieldUsingPOST(field: 'LINK' | 'TEXT' | 'PROFILE', idCorrelation: string, footerLinkRequestDto: FooterLinkRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateFooterLinkFieldUsingPOST(field, idCorrelation, footerLinkRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'un lien de bas de page
     * @param {string} idCorrelation ID corrélation du lien de bas de page, représenté par un UUID
     * @param {FooterLinkRequestDto} footerLinkRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateFooterLinkUsingPOST(idCorrelation: string, footerLinkRequestDto: FooterLinkRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateFooterLinkUsingPOST(idCorrelation, footerLinkRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'une fourrière.
     * @param {'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation Id de corrélation de la fourrière à mettre à jour
     * @param {FourriereRequestDto} fourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateFourriereFieldUsingPOST(field: 'RAISON_SOCIALE' | 'RAISON_SOCIALE_DNID' | 'DATE_AGREMENT_FIN' | 'AF_RATTACHEMENT' | 'CODE_POSTAL' | 'ADRESSE' | 'NUMERO_VOIE' | 'COMMUNE' | 'TELEPHONE_PORTABLE' | 'TELEPHONE_FIXE' | 'EMAIL' | 'EMAIL_RESPONSABLE' | 'ID_ALIENATION', idCorrelation: string, fourriereRequestDto: FourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateFourriereFieldUsingPOST(field, idCorrelation, fourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'une fourrière.
     * @param {string} idCorrelation Id de corrélation de la fourrière à mettre à jour
     * @param {FourriereRequestDto} fourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateFourriereUsingPOST(idCorrelation: string, fourriereRequestDto: FourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateFourriereUsingPOST(idCorrelation, fourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'un genre simplifié
     * @param {'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation ID corrélation de le genre simplifié, représenté par un UUID
     * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateGenreSimplifieFieldUsingPOST(field: 'LIBELLE' | 'DICEM' | 'FORMATS_PLAQUES', idCorrelation: string, genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateGenreSimplifieFieldUsingPOST(field, idCorrelation, genreSimplifieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'un genre simplifié
     * @param {string} idCorrelation ID corrélation de le genre simplifié, représenté par un UUID
     * @param {GenreSimplifieRequestDto} genreSimplifieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateGenreSimplifieUsingPOST(idCorrelation: string, genreSimplifieRequestDto: GenreSimplifieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateGenreSimplifieUsingPOST(idCorrelation, genreSimplifieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'une juridiction
     * @param {'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation ID corrélation de la juridiction, représenté par un UUID
     * @param {JuridictionRequestDto} juridictionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateJuridictionFieldUsingPOST(field: 'ORIGINE_ELEMENT' | 'NUMERO' | 'TYPE' | 'LIBELLE' | 'CODE_POSTAL' | 'JURIDICTION_PARENTE', idCorrelation: string, juridictionRequestDto: JuridictionRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateJuridictionFieldUsingPOST(field, idCorrelation, juridictionRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'une juridiction
     * @param {string} idCorrelation ID corrélation de la juridiction, représenté par un UUID
     * @param {JuridictionRequestDto} juridictionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateJuridictionUsingPOST(idCorrelation: string, juridictionRequestDto: JuridictionRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateJuridictionUsingPOST(idCorrelation, juridictionRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'une marque.
     * @param {'CATEGORIE' | 'TYPE' | 'MARQUE_EXACTE'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation Id de corrélation de la marque à mettre à jour
     * @param {MarqueRequestDto} marqueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateMarqueFieldUsingPOST(field: 'CATEGORIE' | 'TYPE' | 'MARQUE_EXACTE', idCorrelation: string, marqueRequestDto: MarqueRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateMarqueFieldUsingPOST(field, idCorrelation, marqueRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'une marque.
     * @param {string} idCorrelation Id de corrélation de la marque à mettre à jour
     * @param {MarqueRequestDto} marqueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateMarqueUsingPOST(idCorrelation: string, marqueRequestDto: MarqueRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateMarqueUsingPOST(idCorrelation, marqueRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'un motif de mef.
     * @param {'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation Id de corrélation du motif de MEF à mettre à jour
     * @param {MotifMefRequestDto} motifMefRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateMotifMefFieldUsingPOST(field: 'MOTIF_MEF' | 'BRANCHE' | 'NATURE' | 'DICEM' | 'RODEO', idCorrelation: string, motifMefRequestDto: MotifMefRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateMotifMefFieldUsingPOST(field, idCorrelation, motifMefRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'un motif de MEF.
     * @param {string} idCorrelation Id de corrélation du motif à mettre à jour
     * @param {MotifMefRequestDto} motifMefRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateMotifMefUsingPOST(idCorrelation: string, motifMefRequestDto: MotifMefRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateMotifMefUsingPOST(idCorrelation, motifMefRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'un motif de sortie.
     * @param {'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation Identifiant de correlation du motif
     * @param {MotifSortieRequestDto} motifSortieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateMotifSortieFieldUsingPUT(field: 'MOTIF' | 'COMMENTAIRE' | 'DELAI_EFFACEMENT', idCorrelation: string, motifSortieRequestDto: MotifSortieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateMotifSortieFieldUsingPUT(field, idCorrelation, motifSortieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'un motif de sortie.
     * @param {string} idCorrelation Identifiant de correlation du motif
     * @param {MotifSortieRequestDto} motifSortieRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateMotifSortieUsingPOST(idCorrelation: string, motifSortieRequestDto: MotifSortieRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateMotifSortieUsingPOST(idCorrelation, motifSortieRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications des entitées de rattachement d\'un dossier
     * @param {'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateSortieVehiculeRequestDto} updateSortieVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateSortieVehiculeFieldUsingPOST(field: 'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT', id: string, updateSortieVehiculeRequestDto: UpdateSortieVehiculeRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateSortieVehiculeFieldUsingPOST(field, id, updateSortieVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications de la sortie d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateSortieVehiculeRequestDto} updateSortieVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateSortieVehiculeUsingPOST(id: string, updateSortieVehiculeRequestDto: UpdateSortieVehiculeRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateSortieVehiculeUsingPOST(id, updateSortieVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'un type d\'AF.
     * @param {'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation Identifiant de correlation du type
     * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateTypeAfFieldUsingPOST(field: 'TYPE' | 'LIBELLE_NOTIFICATION' | 'CODE_TYPOLOGIE_NIVEAU_1' | 'CODE_TYPOLOGIE_NIVEAU_2', idCorrelation: string, typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateTypeAfFieldUsingPOST(field, idCorrelation, typeAutoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'un type d\'AF.
     * @param {string} idCorrelation Identifiant de correlation du type
     * @param {TypeAutoriteFourriereRequestDto} typeAutoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateTypeAfUsingPOST(idCorrelation: string, typeAutoriteFourriereRequestDto: TypeAutoriteFourriereRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateTypeAfUsingPOST(idCorrelation, typeAutoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'une unité FO.
     * @param {'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation Id de corrélation de l\'unité FO à mettre à jour
     * @param {UniteFoRequestDto} uniteFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateUniteFoFieldUsingPOST(field: 'TYPE' | 'CODE' | 'UNITE' | 'ABREVIATION' | 'CODE_POSTAL' | 'EMAIL' | 'TELEPHONE' | 'CODE_INSEE' | 'PARENT', idCorrelation: string, uniteFoRequestDto: UniteFoRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateUniteFoFieldUsingPOST(field, idCorrelation, uniteFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'une unite FO.
     * @param {string} idCorrelation Id de corrélation de l\'unité FO à mettre à jour
     * @param {UniteFoRequestDto} uniteFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateUniteFoUsingPOST(idCorrelation: string, uniteFoRequestDto: UniteFoRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateUniteFoUsingPOST(idCorrelation, uniteFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des données de mise à jour d\'une vidéo tutorielle.
     * @param {'VIDEO_ID' | 'PROFILE'} field Nom du champ à valider, défini par un enum
     * @param {string} idCorrelation ID corrélation de la vidéo tutorielle, représenté par un UUID
     * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateVideoTutorielFieldUsingPOST(field: 'VIDEO_ID' | 'PROFILE', idCorrelation: string, videoTutorielRequestDto: VideoTutorielRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateVideoTutorielFieldUsingPOST(field, idCorrelation, videoTutorielRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les données de mise à jour d\'une vidéo tutorielle
     * @param {string} idCorrelation ID corrélation de la vidéo tutorielle, représenté par un UUID
     * @param {VideoTutorielRequestDto} videoTutorielRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateVideoTutorielUsingPOST(idCorrelation: string, videoTutorielRequestDto: VideoTutorielRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUpdateVideoTutorielUsingPOST(idCorrelation, videoTutorielRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un des champs pour l\'upload du csv d\'apurement des dossiers.
     * @param {'FILE'} field Le champ à valider, représenté par une énumération.
     * @param {any} file Fichier csv contenant les ids des dossiers à apurer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUploadApurementDossiersFieldUsingPOST(field: 'FILE', file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUploadApurementDossiersFieldUsingPOST(field, file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation des champs pour l\'upload du csv d\'apurement des dossiers.
     * @param {any} file Fichier csv contenant les ids des dossiers à apurer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUploadApurementDossiersUsingPOST(file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUploadApurementDossiersUsingPOST(file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un des champs pour l\'upload d\'un document spécifique.
     * @param {'NAME' | 'TYPE_DESTINATAIRE' | 'FILE'} field Le champ à valider, représenté par une énumération.
     * @param {any} file Fichier du document specifique
     * @param {validateUploadDocumentSpecifiqueFieldUsingPOSTQueryParams} queryParams objet contenant les query params de la route validateUploadDocumentSpecifiqueFieldUsingPOST
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUploadDocumentSpecifiqueFieldUsingPOST(file: any, field: 'NAME' | 'TYPE_DESTINATAIRE' | 'FILE', queryParams: ValidateUploadDocumentSpecifiqueFieldUsingPOSTQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUploadDocumentSpecifiqueFieldUsingPOST(file, field, queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation des champs pour l\'upload d\'un document spécifique pour un type de destinataire existant.
     * @param {any} file Fichier du document specifique
     * @param {validateUploadDocumentSpecifiqueUsingPOSTQueryParams} queryParams objet contenant les query params de la route validateUploadDocumentSpecifiqueUsingPOST
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUploadDocumentSpecifiqueUsingPOST(file: any, queryParams: ValidateUploadDocumentSpecifiqueUsingPOSTQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUploadDocumentSpecifiqueUsingPOST(file, queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {'TYPE' | 'FILE'} field Le champ à valider, représenté par une énumération.
     * @param {string} type Type de la pièce jointe
     * @param {any} file Fichier de la pièce jointe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUploadPieceJointeFieldUsingPOST1(dossierId: string, field: 'TYPE' | 'FILE', type: string, file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUploadPieceJointeFieldUsingPOST1(dossierId, field, type, file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {string} type Type de la pièce jointe
     * @param {any} file Fichier de la pièce jointe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUploadPieceJointeUsingPOST1(dossierId: string, type: string, file: any, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validateUploadPieceJointeUsingPOST1(dossierId, type, file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un champ spécifique de l\'entité ExportStatistiques.
     * @param {'DATE_DEBUT' | 'DATE_FIN'} field Le champ à valider, représenté par une énumération.
     * @param {ExportStatistiquesRequestDto} exportStatistiquesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validationExportStatistiquesFieldUsingPOST(field: 'DATE_DEBUT' | 'DATE_FIN', exportStatistiquesRequestDto: ExportStatistiquesRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validationExportStatistiquesFieldUsingPOST(field, exportStatistiquesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un champ lors de la récupération de l\'activité d\'un utilisateur.
     * @param {'ID' | 'NOM' | 'PRENOM' | 'DATE_DEBUT' | 'DATE_FIN'} field Le champ à valider, représenté par une énumération.
     * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validationRecuperationActiviteUtilisateurFieldUsingPOST(field: 'ID' | 'NOM' | 'PRENOM' | 'DATE_DEBUT' | 'DATE_FIN', recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validationRecuperationActiviteUtilisateurFieldUsingPOST(field, recuperationActiviteUtilisateurRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs lors de la récupération de l\'activité d\'un utilisateur.
     * @param {RecuperationActiviteUtilisateurRequestDto} recuperationActiviteUtilisateurRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validationRecuperationActiviteUtilisateurUsingPOST(recuperationActiviteUtilisateurRequestDto: RecuperationActiviteUtilisateurRequestDto, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).validationRecuperationActiviteUtilisateurUsingPOST(recuperationActiviteUtilisateurRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à l\'admin fonctionnel de récupérer les warnings d\'un flux
     * @param {string} fluxId 
     * @param {warningsOfFluxUsingGETQueryParams} queryParams objet contenant les query params de la route warningsOfFluxUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public warningsOfFluxUsingGET(fluxId: string, queryParams: WarningsOfFluxUsingGETQueryParams, options?: any) {
        return AdminFonctionnelControllerApiFp(this.configuration).warningsOfFluxUsingGET(fluxId, queryParams, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// AuthControllerApi /////////////////////////////////////////////////////

/**
 * objet contenant les query params de la route authenticateUsingGET
 * @export
 * @interface AuthenticateUsingGETQueryParams
 */
export interface AuthenticateUsingGETQueryParams {
    /**
     * Code fourni par le fournisseur d\'identités dans les queryparam
     * @type {string}
     * @memberof AuthenticateUsingGETQueryParams
     */
    code: string;
    /**
     * Uri de redirection, cette URL doit être configurée dans le fournisseur d\'identités
     * @type {string}
     * @memberof AuthenticateUsingGETQueryParams
     */
    redirectUri: string;
}

/**
 * objet contenant les query params de la route redirectToLoginUsingGET
 * @export
 * @interface RedirectToLoginUsingGETQueryParams
 */
export interface RedirectToLoginUsingGETQueryParams {
    /**
     * Uri de redirection, cette URL doit être configurée dans le fournisseur d\'identités
     * @type {string}
     * @memberof RedirectToLoginUsingGETQueryParams
     */
    redirectUri: string;
}

/**
 * objet contenant les query params de la route redirectToLogoutUsingGET
 * @export
 * @interface RedirectToLogoutUsingGETQueryParams
 */
export interface RedirectToLogoutUsingGETQueryParams {
    /**
     * Uri de redirection, cette URL doit être configurée dans le fournisseur d\'identités
     * @type {string}
     * @memberof RedirectToLogoutUsingGETQueryParams
     */
    redirectUri: string;
}

/**
 * objet contenant les query params de la route refreshUsingGET
 * @export
 * @interface RefreshUsingGETQueryParams
 */
export interface RefreshUsingGETQueryParams {
    /**
     * Jeton de rafraîchissement
     * @type {string}
     * @memberof RefreshUsingGETQueryParams
     */
    refreshToken: string;
}

/**
 * AuthControllerApi - fetch parameter creator
 * @export
 */
export const AuthControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de s\'authentifier depuis le portail OpenId connect.
         * @param {authenticateUsingGETQueryParams} queryParams objet contenant les query params de la route authenticateUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUsingGET(queryParams: AuthenticateUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'code' is not null or undefined
            if (queryParams.code === null || queryParams.code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling authenticateUsingGET.');
            }
            // verify required parameter 'redirectUri' is not null or undefined
            if (queryParams.redirectUri === null || queryParams.redirectUri === undefined) {
                throw new RequiredError('redirectUri','Required parameter redirectUri was null or undefined when calling authenticateUsingGET.');
            }
            const localVarPath = `/authentication`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (queryParams.code !== undefined) {
                localVarQueryParameter['code'] = queryParams.code;
            }

            if (queryParams.redirectUri !== undefined) {
                localVarQueryParameter['redirectUri'] = queryParams.redirectUri;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer l\'uri de redirection vers le portail OpenId Connect afin de s\'authentifier.
         * @param {redirectToLoginUsingGETQueryParams} queryParams objet contenant les query params de la route redirectToLoginUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToLoginUsingGET(queryParams: RedirectToLoginUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'redirectUri' is not null or undefined
            if (queryParams.redirectUri === null || queryParams.redirectUri === undefined) {
                throw new RequiredError('redirectUri','Required parameter redirectUri was null or undefined when calling redirectToLoginUsingGET.');
            }
            const localVarPath = `/authentication/redirect/login`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (queryParams.redirectUri !== undefined) {
                localVarQueryParameter['redirectUri'] = queryParams.redirectUri;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer l\'uri de redirection vers le portail OpenId Connect afin de se déconnecter.
         * @param {redirectToLogoutUsingGETQueryParams} queryParams objet contenant les query params de la route redirectToLogoutUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToLogoutUsingGET(queryParams: RedirectToLogoutUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'redirectUri' is not null or undefined
            if (queryParams.redirectUri === null || queryParams.redirectUri === undefined) {
                throw new RequiredError('redirectUri','Required parameter redirectUri was null or undefined when calling redirectToLogoutUsingGET.');
            }
            const localVarPath = `/authentication/redirect/logout`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (queryParams.redirectUri !== undefined) {
                localVarQueryParameter['redirectUri'] = queryParams.redirectUri;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de rafraichir le token utilisateur
         * @param {refreshUsingGETQueryParams} queryParams objet contenant les query params de la route refreshUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshUsingGET(queryParams: RefreshUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'refreshToken' is not null or undefined
            if (queryParams.refreshToken === null || queryParams.refreshToken === undefined) {
                throw new RequiredError('refreshToken','Required parameter refreshToken was null or undefined when calling refreshUsingGET.');
            }
            const localVarPath = `/authentication/refresh`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (queryParams.refreshToken !== undefined) {
                localVarQueryParameter['refreshToken'] = queryParams.refreshToken;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthControllerApi - functional programming interface
 * @export
 */
export const AuthControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de s\'authentifier depuis le portail OpenId connect.
         * @param {authenticateUsingGETQueryParams} queryParams objet contenant les query params de la route authenticateUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUsingGET(queryParams: AuthenticateUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JwtDto> {
            const localVarFetchArgs = AuthControllerApiFetchParamCreator(configuration).authenticateUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer l\'uri de redirection vers le portail OpenId Connect afin de s\'authentifier.
         * @param {redirectToLoginUsingGETQueryParams} queryParams objet contenant les query params de la route redirectToLoginUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToLoginUsingGET(queryParams: RedirectToLoginUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthRedirectDto> {
            const localVarFetchArgs = AuthControllerApiFetchParamCreator(configuration).redirectToLoginUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer l\'uri de redirection vers le portail OpenId Connect afin de se déconnecter.
         * @param {redirectToLogoutUsingGETQueryParams} queryParams objet contenant les query params de la route redirectToLogoutUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToLogoutUsingGET(queryParams: RedirectToLogoutUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AuthRedirectDto> {
            const localVarFetchArgs = AuthControllerApiFetchParamCreator(configuration).redirectToLogoutUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de rafraichir le token utilisateur
         * @param {refreshUsingGETQueryParams} queryParams objet contenant les query params de la route refreshUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshUsingGET(queryParams: RefreshUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JwtDto> {
            const localVarFetchArgs = AuthControllerApiFetchParamCreator(configuration).refreshUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AuthControllerApi - object-oriented interface
 * @export
 * @class AuthControllerApi
 * @extends {BaseAPI}
 */
export class AuthControllerApi extends BaseAPI {
    /**
     * @summary Route permettant de s\'authentifier depuis le portail OpenId connect.
     * @param {authenticateUsingGETQueryParams} queryParams objet contenant les query params de la route authenticateUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authenticateUsingGET(queryParams: AuthenticateUsingGETQueryParams, options?: any) {
        return AuthControllerApiFp(this.configuration).authenticateUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer l\'uri de redirection vers le portail OpenId Connect afin de s\'authentifier.
     * @param {redirectToLoginUsingGETQueryParams} queryParams objet contenant les query params de la route redirectToLoginUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public redirectToLoginUsingGET(queryParams: RedirectToLoginUsingGETQueryParams, options?: any) {
        return AuthControllerApiFp(this.configuration).redirectToLoginUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer l\'uri de redirection vers le portail OpenId Connect afin de se déconnecter.
     * @param {redirectToLogoutUsingGETQueryParams} queryParams objet contenant les query params de la route redirectToLogoutUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public redirectToLogoutUsingGET(queryParams: RedirectToLogoutUsingGETQueryParams, options?: any) {
        return AuthControllerApiFp(this.configuration).redirectToLogoutUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de rafraichir le token utilisateur
     * @param {refreshUsingGETQueryParams} queryParams objet contenant les query params de la route refreshUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refreshUsingGET(queryParams: RefreshUsingGETQueryParams, options?: any) {
        return AuthControllerApiFp(this.configuration).refreshUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// AutoriteFourriereControllerApi /////////////////////////////////////////////////////

/**
 * objet contenant les query params de la route getSourceImpossibiliteNotifierAfUsingGET
 * @export
 * @interface GetSourceImpossibiliteNotifierAfUsingGETQueryParams
 */
export interface GetSourceImpossibiliteNotifierAfUsingGETQueryParams {
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    boitePostale?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    codeCedex?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    codePostal?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    complementAdresse?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    extension?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    libelleCedex?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    libelleCommune?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    libelleVoie?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    lieuDit?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    nom?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    numero?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    pays?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    pointRemise?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    prenom?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    raisonSociale?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierAfUsingGETQueryParams
     */
    typeVoie?: string;
}

/**
 * objet contenant les query params de la route validateProlongationUsingPOST
 * @export
 * @interface ValidateProlongationUsingPOSTQueryParams
 */
export interface ValidateProlongationUsingPOSTQueryParams {
    /**
     * Le champ à valider, représenté par une énumération.
     * @type {'DATE_DECISION_PROCUREUR'}
     * @memberof ValidateProlongationUsingPOSTQueryParams
     */
    field?: 'DATE_DECISION_PROCUREUR';
}

/**
 * AutoriteFourriereControllerApi - fetch parameter creator
 * @export
 */
export const AutoriteFourriereControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de confirmer les informations de son compte Keycloak
         * @param {string} username Nom d\'utilisateur du compte Keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAccountUsingPUT(username: string, options: any = {}): FetchArgs {
            // verify required parameter 'username' is not null or undefined
            if (username === null || username === undefined) {
                throw new RequiredError('username','Required parameter username was null or undefined when calling confirmAccountUsingPUT.');
            }
            const localVarPath = `/api/comptes-utilisateurs/{username}/confirm`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de confirmer la validité des informations d\'une autorité de fourrière
         * @param {string} id Id de l\'autorité de fourrière, et non son id de corrélation, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAutoriteFourriereUsingPUT(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling confirmAutoriteFourriereUsingPUT.');
            }
            const localVarPath = `/api/autorite-fourriere/profil/autorite-fourriere/{id}/confirm`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de calculer les violations menant à une impossibilité de notifier
          * @param {string} id ID du dossier, représenté par un UUID
         * @param {getSourceImpossibiliteNotifierAfUsingGETQueryParams} queryParams objet contenant les query params de la route getSourceImpossibiliteNotifierAfUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceImpossibiliteNotifierAfUsingGET(id: string, queryParams: GetSourceImpossibiliteNotifierAfUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSourceImpossibiliteNotifierAfUsingGET.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/impossibilite-notifier`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.boitePostale !== undefined) {
                localVarQueryParameter['boitePostale'] = queryParams.boitePostale;
            }

            if (queryParams.codeCedex !== undefined) {
                localVarQueryParameter['codeCedex'] = queryParams.codeCedex;
            }

            if (queryParams.codePostal !== undefined) {
                localVarQueryParameter['codePostal'] = queryParams.codePostal;
            }

            if (queryParams.complementAdresse !== undefined) {
                localVarQueryParameter['complementAdresse'] = queryParams.complementAdresse;
            }

            if (queryParams.extension !== undefined) {
                localVarQueryParameter['extension'] = queryParams.extension;
            }

            if (queryParams.libelleCedex !== undefined) {
                localVarQueryParameter['libelleCedex'] = queryParams.libelleCedex;
            }

            if (queryParams.libelleCommune !== undefined) {
                localVarQueryParameter['libelleCommune'] = queryParams.libelleCommune;
            }

            if (queryParams.libelleVoie !== undefined) {
                localVarQueryParameter['libelleVoie'] = queryParams.libelleVoie;
            }

            if (queryParams.lieuDit !== undefined) {
                localVarQueryParameter['lieuDit'] = queryParams.lieuDit;
            }

            if (queryParams.nom !== undefined) {
                localVarQueryParameter['nom'] = queryParams.nom;
            }

            if (queryParams.numero !== undefined) {
                localVarQueryParameter['numero'] = queryParams.numero;
            }

            if (queryParams.pays !== undefined) {
                localVarQueryParameter['pays'] = queryParams.pays;
            }

            if (queryParams.pointRemise !== undefined) {
                localVarQueryParameter['pointRemise'] = queryParams.pointRemise;
            }

            if (queryParams.prenom !== undefined) {
                localVarQueryParameter['prenom'] = queryParams.prenom;
            }

            if (queryParams.raisonSociale !== undefined) {
                localVarQueryParameter['raisonSociale'] = queryParams.raisonSociale;
            }

            if (queryParams.typeVoie !== undefined) {
                localVarQueryParameter['typeVoie'] = queryParams.typeVoie;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route de récupération des coordonnées propriétaire d\'un dossier
         * @param {string} id Id du dossier, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCoordonneesProprietaireUsingGET1(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling retrieveCoordonneesProprietaireUsingGET1.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/coordonnees-proprietaire`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de prolonger la mise en fourrière d\'un véhicule.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {ProlongationRequestDto} prolongationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProlongationMiseEnFourriereUsingPOST(id: string, prolongationRequestDto: ProlongationRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling submitProlongationMiseEnFourriereUsingPOST.');
            }
            // verify required parameter 'prolongationRequestDto' is not null or undefined
            if (prolongationRequestDto === null || prolongationRequestDto === undefined) {
                throw new RequiredError('prolongationRequestDto','Required parameter prolongationRequestDto was null or undefined when calling submitProlongationMiseEnFourriereUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/prolongation-mef`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProlongationRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(prolongationRequestDto || {}) : (prolongationRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier le statut de traitement en facturation du dossier.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {boolean} traite Boolean spécifiant si le dossier a été traité en facturation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTraitementFacturationUsingPOST(id: string, traite: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling submitTraitementFacturationUsingPOST.');
            }
            // verify required parameter 'traite' is not null or undefined
            if (traite === null || traite === undefined) {
                throw new RequiredError('traite','Required parameter traite was null or undefined when calling submitTraitementFacturationUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/traitement-facturation/{traite}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"traite"}}`, encodeURIComponent(String(traite)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour les données d\'une autorité de fourrière.
         * @param {string} idCorrelation Id de corrélation de l\'autorité de fourrière, representé par un UUID.
         * @param {ProfilAutoriteFourriereRequestDto} profilAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAutoriteFourriereInfoUsingPOST(idCorrelation: string, profilAutoriteFourriereRequestDto: ProfilAutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling updateAutoriteFourriereInfoUsingPOST.');
            }
            // verify required parameter 'profilAutoriteFourriereRequestDto' is not null or undefined
            if (profilAutoriteFourriereRequestDto === null || profilAutoriteFourriereRequestDto === undefined) {
                throw new RequiredError('profilAutoriteFourriereRequestDto','Required parameter profilAutoriteFourriereRequestDto was null or undefined when calling updateAutoriteFourriereInfoUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/profil/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProfilAutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(profilAutoriteFourriereRequestDto || {}) : (profilAutoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les coordonnees du propriétaire
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoordonneesProprietairesAfUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCoordonneesProprietairesAfUsingPOST.');
            }
            // verify required parameter 'coordonneesProprietaireRequestDto' is not null or undefined
            if (coordonneesProprietaireRequestDto === null || coordonneesProprietaireRequestDto === undefined) {
                throw new RequiredError('coordonneesProprietaireRequestDto','Required parameter coordonneesProprietaireRequestDto was null or undefined when calling updateCoordonneesProprietairesAfUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/coordonnees-proprietaires`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CoordonneesProprietaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(coordonneesProprietaireRequestDto || {}) : (coordonneesProprietaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonneesInterieurVehiculeForNotAdminUsingPOST1(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateDonneesInterieurVehiculeForNotAdminUsingPOST1.');
            }
            // verify required parameter 'updateDonneesInterieurVehiculeRequestDto' is not null or undefined
            if (updateDonneesInterieurVehiculeRequestDto === null || updateDonneesInterieurVehiculeRequestDto === undefined) {
                throw new RequiredError('updateDonneesInterieurVehiculeRequestDto','Required parameter updateDonneesInterieurVehiculeRequestDto was null or undefined when calling updateDonneesInterieurVehiculeForNotAdminUsingPOST1.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/vehicule`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesInterieurVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesInterieurVehiculeRequestDto || {}) : (updateDonneesInterieurVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les entitées de rattachement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntitesRattachementAFUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateEntitesRattachementAFUsingPOST.');
            }
            // verify required parameter 'updateEntitesRattachementRequestDto' is not null or undefined
            if (updateEntitesRattachementRequestDto === null || updateEntitesRattachementRequestDto === undefined) {
                throw new RequiredError('updateEntitesRattachementRequestDto','Required parameter updateEntitesRattachementRequestDto was null or undefined when calling updateEntitesRattachementAFUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/entites-rattachement/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateEntitesRattachementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateEntitesRattachementRequestDto || {}) : (updateEntitesRattachementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ du formulaire de mise à jour du profile Autorité de Fourrière.
         * @param {'TYPE' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'CEDEX'} field Intitulé du champ à valider
         * @param {string} idCorrelation Id de l\'autorité de fourrière, représenté par un UUID.
         * @param {ProfilAutoriteFourriereRequestDto} profilAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAutoriteFourriereInfosFieldUsingPOST(field: 'TYPE' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'CEDEX', idCorrelation: string, profilAutoriteFourriereRequestDto: ProfilAutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateAutoriteFourriereInfosFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateAutoriteFourriereInfosFieldUsingPOST.');
            }
            // verify required parameter 'profilAutoriteFourriereRequestDto' is not null or undefined
            if (profilAutoriteFourriereRequestDto === null || profilAutoriteFourriereRequestDto === undefined) {
                throw new RequiredError('profilAutoriteFourriereRequestDto','Required parameter profilAutoriteFourriereRequestDto was null or undefined when calling validateAutoriteFourriereInfosFieldUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/profil/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProfilAutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(profilAutoriteFourriereRequestDto || {}) : (profilAutoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider tous les champs du formulaire de mise à jour du profile Autorité de Fourrière.
         * @param {string} idCorrelation Id de l\'autorité de fourrière, représenté par un UUID.
         * @param {ProfilAutoriteFourriereRequestDto} profilAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAutoriteFourriereInfosUsingPOST(idCorrelation: string, profilAutoriteFourriereRequestDto: ProfilAutoriteFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateAutoriteFourriereInfosUsingPOST.');
            }
            // verify required parameter 'profilAutoriteFourriereRequestDto' is not null or undefined
            if (profilAutoriteFourriereRequestDto === null || profilAutoriteFourriereRequestDto === undefined) {
                throw new RequiredError('profilAutoriteFourriereRequestDto','Required parameter profilAutoriteFourriereRequestDto was null or undefined when calling validateAutoriteFourriereInfosUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/profil/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProfilAutoriteFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(profilAutoriteFourriereRequestDto || {}) : (profilAutoriteFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider tous les champs du formulaire de mise à jour des coordonnées propriétaires pour les autorité de fourriere
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCoordonneesProprietairesAfUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateCoordonneesProprietairesAfUsingPOST.');
            }
            // verify required parameter 'coordonneesProprietaireRequestDto' is not null or undefined
            if (coordonneesProprietaireRequestDto === null || coordonneesProprietaireRequestDto === undefined) {
                throw new RequiredError('coordonneesProprietaireRequestDto','Required parameter coordonneesProprietaireRequestDto was null or undefined when calling validateCoordonneesProprietairesAfUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/coordonnees-proprietaires/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CoordonneesProprietaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(coordonneesProprietaireRequestDto || {}) : (coordonneesProprietaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ du formulaire de mise à jour des Coordonnéees propriétaires.
         * @param {'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS'} field Le champ à valider, représenté par une énumération.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCoordonneesProprietairesFieldAfUsingPOST(field: 'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS', id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCoordonneesProprietairesFieldAfUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateCoordonneesProprietairesFieldAfUsingPOST.');
            }
            // verify required parameter 'coordonneesProprietaireRequestDto' is not null or undefined
            if (coordonneesProprietaireRequestDto === null || coordonneesProprietaireRequestDto === undefined) {
                throw new RequiredError('coordonneesProprietaireRequestDto','Required parameter coordonneesProprietaireRequestDto was null or undefined when calling validateCoordonneesProprietairesFieldAfUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/coordonnees-proprietaires/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CoordonneesProprietaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(coordonneesProprietaireRequestDto || {}) : (coordonneesProprietaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route validant le champ spécifié dans le formulaire de mise en fourrière. Si aucun champ n\'est spécifié, tous les champs remplis seront validés.
          * @param {string} id ID du dossier, représenté par un UUID.
         * @param {validateProlongationUsingPOSTQueryParams} queryParams objet contenant les query params de la route validateProlongationUsingPOST
          * @param {ProlongationRequestDto} prolongationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProlongationUsingPOST(id: string, queryParams: ValidateProlongationUsingPOSTQueryParams, prolongationRequestDto: ProlongationRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateProlongationUsingPOST.');
            }
            // verify required parameter 'prolongationRequestDto' is not null or undefined
            if (prolongationRequestDto === null || prolongationRequestDto === undefined) {
                throw new RequiredError('prolongationRequestDto','Required parameter prolongationRequestDto was null or undefined when calling validateProlongationUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/prolongation/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.field !== undefined) {
                localVarQueryParameter['field'] = queryParams.field;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProlongationRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(prolongationRequestDto || {}) : (prolongationRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider une modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
         * @param {'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST1(field: 'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF', id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST1.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST1.');
            }
            // verify required parameter 'updateDonneesInterieurVehiculeRequestDto' is not null or undefined
            if (updateDonneesInterieurVehiculeRequestDto === null || updateDonneesInterieurVehiculeRequestDto === undefined) {
                throw new RequiredError('updateDonneesInterieurVehiculeRequestDto','Required parameter updateDonneesInterieurVehiculeRequestDto was null or undefined when calling validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST1.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/vehicule/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesInterieurVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesInterieurVehiculeRequestDto || {}) : (updateDonneesInterieurVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST1(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST1.');
            }
            // verify required parameter 'updateDonneesInterieurVehiculeRequestDto' is not null or undefined
            if (updateDonneesInterieurVehiculeRequestDto === null || updateDonneesInterieurVehiculeRequestDto === undefined) {
                throw new RequiredError('updateDonneesInterieurVehiculeRequestDto','Required parameter updateDonneesInterieurVehiculeRequestDto was null or undefined when calling validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST1.');
            }
            const localVarPath = `/api/autorite-fourriere/dossier/{id}/vehicule/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesInterieurVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesInterieurVehiculeRequestDto || {}) : (updateDonneesInterieurVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider l\'ensemble des champs du formulaire de modifications des entités de rattachement d\'un dossier.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementAFUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateEntitesRattachementAFUsingPOST.');
            }
            // verify required parameter 'updateEntitesRattachementRequestDto' is not null or undefined
            if (updateEntitesRattachementRequestDto === null || updateEntitesRattachementRequestDto === undefined) {
                throw new RequiredError('updateEntitesRattachementRequestDto','Required parameter updateEntitesRattachementRequestDto was null or undefined when calling validateUpdateEntitesRattachementAFUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/entites-rattachement/{id}/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateEntitesRattachementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateEntitesRattachementRequestDto || {}) : (updateEntitesRattachementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un des champs du formulaire de modifications des entités de rattachement d\'un dossier.
         * @param {'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementFieldAFUsingPOST(field: 'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT', id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateEntitesRattachementFieldAFUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateEntitesRattachementFieldAFUsingPOST.');
            }
            // verify required parameter 'updateEntitesRattachementRequestDto' is not null or undefined
            if (updateEntitesRattachementRequestDto === null || updateEntitesRattachementRequestDto === undefined) {
                throw new RequiredError('updateEntitesRattachementRequestDto','Required parameter updateEntitesRattachementRequestDto was null or undefined when calling validateUpdateEntitesRattachementFieldAFUsingPOST.');
            }
            const localVarPath = `/api/autorite-fourriere/entites-rattachement/{id}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateEntitesRattachementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateEntitesRattachementRequestDto || {}) : (updateEntitesRattachementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AutoriteFourriereControllerApi - functional programming interface
 * @export
 */
export const AutoriteFourriereControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de confirmer les informations de son compte Keycloak
         * @param {string} username Nom d\'utilisateur du compte Keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAccountUsingPUT(username: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).confirmAccountUsingPUT(username, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de confirmer la validité des informations d\'une autorité de fourrière
         * @param {string} id Id de l\'autorité de fourrière, et non son id de corrélation, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAutoriteFourriereUsingPUT(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AutoriteFourriereDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).confirmAutoriteFourriereUsingPUT(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de calculer les violations menant à une impossibilité de notifier
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {getSourceImpossibiliteNotifierAfUsingGETQueryParams} queryParams objet contenant les query params de la route getSourceImpossibiliteNotifierAfUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceImpossibiliteNotifierAfUsingGET(id: string, queryParams: GetSourceImpossibiliteNotifierAfUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SourcesImpossibiliteNotifierDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).getSourceImpossibiliteNotifierAfUsingGET(id, queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route de récupération des coordonnées propriétaire d\'un dossier
         * @param {string} id Id du dossier, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCoordonneesProprietaireUsingGET1(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CoordonneesProprietaireResponseDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).retrieveCoordonneesProprietaireUsingGET1(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de prolonger la mise en fourrière d\'un véhicule.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {ProlongationRequestDto} prolongationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProlongationMiseEnFourriereUsingPOST(id: string, prolongationRequestDto: ProlongationRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).submitProlongationMiseEnFourriereUsingPOST(id, prolongationRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier le statut de traitement en facturation du dossier.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {boolean} traite Boolean spécifiant si le dossier a été traité en facturation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTraitementFacturationUsingPOST(id: string, traite: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).submitTraitementFacturationUsingPOST(id, traite, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour les données d\'une autorité de fourrière.
         * @param {string} idCorrelation Id de corrélation de l\'autorité de fourrière, representé par un UUID.
         * @param {ProfilAutoriteFourriereRequestDto} profilAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAutoriteFourriereInfoUsingPOST(idCorrelation: string, profilAutoriteFourriereRequestDto: ProfilAutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AutoriteFourriereDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).updateAutoriteFourriereInfoUsingPOST(idCorrelation, profilAutoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les coordonnees du propriétaire
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoordonneesProprietairesAfUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).updateCoordonneesProprietairesAfUsingPOST(id, coordonneesProprietaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonneesInterieurVehiculeForNotAdminUsingPOST1(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).updateDonneesInterieurVehiculeForNotAdminUsingPOST1(id, updateDonneesInterieurVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les entitées de rattachement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntitesRattachementAFUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).updateEntitesRattachementAFUsingPOST(id, updateEntitesRattachementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ du formulaire de mise à jour du profile Autorité de Fourrière.
         * @param {'TYPE' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'CEDEX'} field Intitulé du champ à valider
         * @param {string} idCorrelation Id de l\'autorité de fourrière, représenté par un UUID.
         * @param {ProfilAutoriteFourriereRequestDto} profilAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAutoriteFourriereInfosFieldUsingPOST(field: 'TYPE' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'CEDEX', idCorrelation: string, profilAutoriteFourriereRequestDto: ProfilAutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProfilAutoriteFourriereViolationsDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).validateAutoriteFourriereInfosFieldUsingPOST(field, idCorrelation, profilAutoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider tous les champs du formulaire de mise à jour du profile Autorité de Fourrière.
         * @param {string} idCorrelation Id de l\'autorité de fourrière, représenté par un UUID.
         * @param {ProfilAutoriteFourriereRequestDto} profilAutoriteFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAutoriteFourriereInfosUsingPOST(idCorrelation: string, profilAutoriteFourriereRequestDto: ProfilAutoriteFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProfilAutoriteFourriereViolationsDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).validateAutoriteFourriereInfosUsingPOST(idCorrelation, profilAutoriteFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider tous les champs du formulaire de mise à jour des coordonnées propriétaires pour les autorité de fourriere
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCoordonneesProprietairesAfUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).validateCoordonneesProprietairesAfUsingPOST(id, coordonneesProprietaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ du formulaire de mise à jour des Coordonnéees propriétaires.
         * @param {'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS'} field Le champ à valider, représenté par une énumération.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCoordonneesProprietairesFieldAfUsingPOST(field: 'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS', id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).validateCoordonneesProprietairesFieldAfUsingPOST(field, id, coordonneesProprietaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route validant le champ spécifié dans le formulaire de mise en fourrière. Si aucun champ n\'est spécifié, tous les champs remplis seront validés.
         * @param {string} id ID du dossier, représenté par un UUID.
         * @param {validateProlongationUsingPOSTQueryParams} queryParams objet contenant les query params de la route validateProlongationUsingPOST
         * @param {ProlongationRequestDto} prolongationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProlongationUsingPOST(id: string, queryParams: ValidateProlongationUsingPOSTQueryParams, prolongationRequestDto: ProlongationRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).validateProlongationUsingPOST(id, queryParams, prolongationRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider une modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
         * @param {'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST1(field: 'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF', id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST1(field, id, updateDonneesInterieurVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST1(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST1(id, updateDonneesInterieurVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider l\'ensemble des champs du formulaire de modifications des entités de rattachement d\'un dossier.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementAFUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).validateUpdateEntitesRattachementAFUsingPOST(id, updateEntitesRattachementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un des champs du formulaire de modifications des entités de rattachement d\'un dossier.
         * @param {'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementFieldAFUsingPOST(field: 'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT', id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = AutoriteFourriereControllerApiFetchParamCreator(configuration).validateUpdateEntitesRattachementFieldAFUsingPOST(field, id, updateEntitesRattachementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AutoriteFourriereControllerApi - object-oriented interface
 * @export
 * @class AutoriteFourriereControllerApi
 * @extends {BaseAPI}
 */
export class AutoriteFourriereControllerApi extends BaseAPI {
    /**
     * @summary Route permettant de confirmer les informations de son compte Keycloak
     * @param {string} username Nom d\'utilisateur du compte Keycloak
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmAccountUsingPUT(username: string, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).confirmAccountUsingPUT(username, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de confirmer la validité des informations d\'une autorité de fourrière
     * @param {string} id Id de l\'autorité de fourrière, et non son id de corrélation, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmAutoriteFourriereUsingPUT(id: string, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).confirmAutoriteFourriereUsingPUT(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de calculer les violations menant à une impossibilité de notifier
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {getSourceImpossibiliteNotifierAfUsingGETQueryParams} queryParams objet contenant les query params de la route getSourceImpossibiliteNotifierAfUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSourceImpossibiliteNotifierAfUsingGET(id: string, queryParams: GetSourceImpossibiliteNotifierAfUsingGETQueryParams, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).getSourceImpossibiliteNotifierAfUsingGET(id, queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route de récupération des coordonnées propriétaire d\'un dossier
     * @param {string} id Id du dossier, représenté par son UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveCoordonneesProprietaireUsingGET1(id: string, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).retrieveCoordonneesProprietaireUsingGET1(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de prolonger la mise en fourrière d\'un véhicule.
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {ProlongationRequestDto} prolongationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitProlongationMiseEnFourriereUsingPOST(id: string, prolongationRequestDto: ProlongationRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).submitProlongationMiseEnFourriereUsingPOST(id, prolongationRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier le statut de traitement en facturation du dossier.
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {boolean} traite Boolean spécifiant si le dossier a été traité en facturation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitTraitementFacturationUsingPOST(id: string, traite: boolean, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).submitTraitementFacturationUsingPOST(id, traite, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour les données d\'une autorité de fourrière.
     * @param {string} idCorrelation Id de corrélation de l\'autorité de fourrière, representé par un UUID.
     * @param {ProfilAutoriteFourriereRequestDto} profilAutoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAutoriteFourriereInfoUsingPOST(idCorrelation: string, profilAutoriteFourriereRequestDto: ProfilAutoriteFourriereRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).updateAutoriteFourriereInfoUsingPOST(idCorrelation, profilAutoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les coordonnees du propriétaire
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCoordonneesProprietairesAfUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).updateCoordonneesProprietairesAfUsingPOST(id, coordonneesProprietaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDonneesInterieurVehiculeForNotAdminUsingPOST1(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).updateDonneesInterieurVehiculeForNotAdminUsingPOST1(id, updateDonneesInterieurVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les entitées de rattachement d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEntitesRattachementAFUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).updateEntitesRattachementAFUsingPOST(id, updateEntitesRattachementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ du formulaire de mise à jour du profile Autorité de Fourrière.
     * @param {'TYPE' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'CEDEX'} field Intitulé du champ à valider
     * @param {string} idCorrelation Id de l\'autorité de fourrière, représenté par un UUID.
     * @param {ProfilAutoriteFourriereRequestDto} profilAutoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateAutoriteFourriereInfosFieldUsingPOST(field: 'TYPE' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'CEDEX', idCorrelation: string, profilAutoriteFourriereRequestDto: ProfilAutoriteFourriereRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).validateAutoriteFourriereInfosFieldUsingPOST(field, idCorrelation, profilAutoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider tous les champs du formulaire de mise à jour du profile Autorité de Fourrière.
     * @param {string} idCorrelation Id de l\'autorité de fourrière, représenté par un UUID.
     * @param {ProfilAutoriteFourriereRequestDto} profilAutoriteFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateAutoriteFourriereInfosUsingPOST(idCorrelation: string, profilAutoriteFourriereRequestDto: ProfilAutoriteFourriereRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).validateAutoriteFourriereInfosUsingPOST(idCorrelation, profilAutoriteFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider tous les champs du formulaire de mise à jour des coordonnées propriétaires pour les autorité de fourriere
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCoordonneesProprietairesAfUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).validateCoordonneesProprietairesAfUsingPOST(id, coordonneesProprietaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ du formulaire de mise à jour des Coordonnéees propriétaires.
     * @param {'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS'} field Le champ à valider, représenté par une énumération.
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCoordonneesProprietairesFieldAfUsingPOST(field: 'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS', id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).validateCoordonneesProprietairesFieldAfUsingPOST(field, id, coordonneesProprietaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route validant le champ spécifié dans le formulaire de mise en fourrière. Si aucun champ n\'est spécifié, tous les champs remplis seront validés.
     * @param {string} id ID du dossier, représenté par un UUID.
     * @param {validateProlongationUsingPOSTQueryParams} queryParams objet contenant les query params de la route validateProlongationUsingPOST
     * @param {ProlongationRequestDto} prolongationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateProlongationUsingPOST(id: string, queryParams: ValidateProlongationUsingPOSTQueryParams, prolongationRequestDto: ProlongationRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).validateProlongationUsingPOST(id, queryParams, prolongationRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider une modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
     * @param {'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST1(field: 'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF', id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST1(field, id, updateDonneesInterieurVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST1(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST1(id, updateDonneesInterieurVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider l\'ensemble des champs du formulaire de modifications des entités de rattachement d\'un dossier.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateEntitesRattachementAFUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).validateUpdateEntitesRattachementAFUsingPOST(id, updateEntitesRattachementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un des champs du formulaire de modifications des entités de rattachement d\'un dossier.
     * @param {'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateEntitesRattachementFieldAFUsingPOST(field: 'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT', id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any) {
        return AutoriteFourriereControllerApiFp(this.configuration).validateUpdateEntitesRattachementFieldAFUsingPOST(field, id, updateEntitesRattachementRequestDto, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// CommentaireControllerApi /////////////////////////////////////////////////////

/**
 * CommentaireControllerApi - fetch parameter creator
 * @export
 */
export const CommentaireControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant d\'ajouter un commentaire à un dossier
         * @param {string} dossierId Id du dossier
         * @param {CommentaireRequestDto} commentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentaireUsingPOST(dossierId: string, commentaireRequestDto: CommentaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling addCommentaireUsingPOST.');
            }
            // verify required parameter 'commentaireRequestDto' is not null or undefined
            if (commentaireRequestDto === null || commentaireRequestDto === undefined) {
                throw new RequiredError('commentaireRequestDto','Required parameter commentaireRequestDto was null or undefined when calling addCommentaireUsingPOST.');
            }
            const localVarPath = `/api/dossier/{dossierId}/commentaire`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CommentaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(commentaireRequestDto || {}) : (commentaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de supprimer un commentaire d\'un dossier
         * @param {string} commentaireId Id du commentaire à supprimer
         * @param {string} dossierId Id du dossier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE(commentaireId: string, dossierId: string, options: any = {}): FetchArgs {
            // verify required parameter 'commentaireId' is not null or undefined
            if (commentaireId === null || commentaireId === undefined) {
                throw new RequiredError('commentaireId','Required parameter commentaireId was null or undefined when calling deleteUsingDELETE.');
            }
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling deleteUsingDELETE.');
            }
            const localVarPath = `/api/dossier/{dossierId}/commentaire/{commentaireId}`
                .replace(`{${"commentaireId"}}`, encodeURIComponent(String(commentaireId)))
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer les commentaires d\'un dossier
         * @param {string} dossierId Id du dossier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentairesUsingGET(dossierId: string, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling getCommentairesUsingGET.');
            }
            const localVarPath = `/api/dossier/{dossierId}/commentaire`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de faire une modification sur un commentaire d\'un dossier
         * @param {string} dossierId Id du dossier
         * @param {UpdateCommentaireRequestDto} updateCommentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentaireUsingPOST(dossierId: string, updateCommentaireRequestDto: UpdateCommentaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling updateCommentaireUsingPOST.');
            }
            // verify required parameter 'updateCommentaireRequestDto' is not null or undefined
            if (updateCommentaireRequestDto === null || updateCommentaireRequestDto === undefined) {
                throw new RequiredError('updateCommentaireRequestDto','Required parameter updateCommentaireRequestDto was null or undefined when calling updateCommentaireUsingPOST.');
            }
            const localVarPath = `/api/dossier/{dossierId}/commentaire/update`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateCommentaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateCommentaireRequestDto || {}) : (updateCommentaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ d\'une requête d\'action sur un commentaire
         * @param {string} dossierId Id du dossier
         * @param {'CONTENU'} field Champ du commentaire
         * @param {CommentaireRequestDto} commentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddCommentaireFieldUsingPOST(dossierId: string, field: 'CONTENU', commentaireRequestDto: CommentaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling validateAddCommentaireFieldUsingPOST.');
            }
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateAddCommentaireFieldUsingPOST.');
            }
            // verify required parameter 'commentaireRequestDto' is not null or undefined
            if (commentaireRequestDto === null || commentaireRequestDto === undefined) {
                throw new RequiredError('commentaireRequestDto','Required parameter commentaireRequestDto was null or undefined when calling validateAddCommentaireFieldUsingPOST.');
            }
            const localVarPath = `/api/dossier/{dossierId}/commentaire/validation/{field}`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CommentaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(commentaireRequestDto || {}) : (commentaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider une requête d\'action sur un commentaire
         * @param {string} dossierId Id du dossier
         * @param {CommentaireRequestDto} commentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddCommentaireUsingPOST(dossierId: string, commentaireRequestDto: CommentaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling validateAddCommentaireUsingPOST.');
            }
            // verify required parameter 'commentaireRequestDto' is not null or undefined
            if (commentaireRequestDto === null || commentaireRequestDto === undefined) {
                throw new RequiredError('commentaireRequestDto','Required parameter commentaireRequestDto was null or undefined when calling validateAddCommentaireUsingPOST.');
            }
            const localVarPath = `/api/dossier/{dossierId}/commentaire/validation`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CommentaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(commentaireRequestDto || {}) : (commentaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ d\'une requête de modification sur un commentaire
         * @param {string} dossierId Id du dossier
         * @param {'CONTENU'} field Champ du commentaire
         * @param {UpdateCommentaireRequestDto} updateCommentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFieldUpdateCommentaireUsingPOST(dossierId: string, field: 'CONTENU', updateCommentaireRequestDto: UpdateCommentaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling validateFieldUpdateCommentaireUsingPOST.');
            }
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFieldUpdateCommentaireUsingPOST.');
            }
            // verify required parameter 'updateCommentaireRequestDto' is not null or undefined
            if (updateCommentaireRequestDto === null || updateCommentaireRequestDto === undefined) {
                throw new RequiredError('updateCommentaireRequestDto','Required parameter updateCommentaireRequestDto was null or undefined when calling validateFieldUpdateCommentaireUsingPOST.');
            }
            const localVarPath = `/api/dossier/{dossierId}/commentaire/update/validation/{field}`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateCommentaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateCommentaireRequestDto || {}) : (updateCommentaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider une requête de modification sur un commentaire
         * @param {string} dossierId Id du dossier
         * @param {UpdateCommentaireRequestDto} updateCommentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateCommentaireUsingPOST(dossierId: string, updateCommentaireRequestDto: UpdateCommentaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling validateUpdateCommentaireUsingPOST.');
            }
            // verify required parameter 'updateCommentaireRequestDto' is not null or undefined
            if (updateCommentaireRequestDto === null || updateCommentaireRequestDto === undefined) {
                throw new RequiredError('updateCommentaireRequestDto','Required parameter updateCommentaireRequestDto was null or undefined when calling validateUpdateCommentaireUsingPOST.');
            }
            const localVarPath = `/api/dossier/{dossierId}/commentaire/update/validation`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateCommentaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateCommentaireRequestDto || {}) : (updateCommentaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentaireControllerApi - functional programming interface
 * @export
 */
export const CommentaireControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant d\'ajouter un commentaire à un dossier
         * @param {string} dossierId Id du dossier
         * @param {CommentaireRequestDto} commentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommentaireUsingPOST(dossierId: string, commentaireRequestDto: CommentaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CommentaireResponseDto>> {
            const localVarFetchArgs = CommentaireControllerApiFetchParamCreator(configuration).addCommentaireUsingPOST(dossierId, commentaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de supprimer un commentaire d\'un dossier
         * @param {string} commentaireId Id du commentaire à supprimer
         * @param {string} dossierId Id du dossier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE(commentaireId: string, dossierId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CommentaireResponseDto>> {
            const localVarFetchArgs = CommentaireControllerApiFetchParamCreator(configuration).deleteUsingDELETE(commentaireId, dossierId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer les commentaires d\'un dossier
         * @param {string} dossierId Id du dossier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentairesUsingGET(dossierId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CommentaireResponseDto>> {
            const localVarFetchArgs = CommentaireControllerApiFetchParamCreator(configuration).getCommentairesUsingGET(dossierId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de faire une modification sur un commentaire d\'un dossier
         * @param {string} dossierId Id du dossier
         * @param {UpdateCommentaireRequestDto} updateCommentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentaireUsingPOST(dossierId: string, updateCommentaireRequestDto: UpdateCommentaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CommentaireResponseDto>> {
            const localVarFetchArgs = CommentaireControllerApiFetchParamCreator(configuration).updateCommentaireUsingPOST(dossierId, updateCommentaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ d\'une requête d\'action sur un commentaire
         * @param {string} dossierId Id du dossier
         * @param {'CONTENU'} field Champ du commentaire
         * @param {CommentaireRequestDto} commentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddCommentaireFieldUsingPOST(dossierId: string, field: 'CONTENU', commentaireRequestDto: CommentaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = CommentaireControllerApiFetchParamCreator(configuration).validateAddCommentaireFieldUsingPOST(dossierId, field, commentaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider une requête d\'action sur un commentaire
         * @param {string} dossierId Id du dossier
         * @param {CommentaireRequestDto} commentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddCommentaireUsingPOST(dossierId: string, commentaireRequestDto: CommentaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = CommentaireControllerApiFetchParamCreator(configuration).validateAddCommentaireUsingPOST(dossierId, commentaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ d\'une requête de modification sur un commentaire
         * @param {string} dossierId Id du dossier
         * @param {'CONTENU'} field Champ du commentaire
         * @param {UpdateCommentaireRequestDto} updateCommentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFieldUpdateCommentaireUsingPOST(dossierId: string, field: 'CONTENU', updateCommentaireRequestDto: UpdateCommentaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = CommentaireControllerApiFetchParamCreator(configuration).validateFieldUpdateCommentaireUsingPOST(dossierId, field, updateCommentaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider une requête de modification sur un commentaire
         * @param {string} dossierId Id du dossier
         * @param {UpdateCommentaireRequestDto} updateCommentaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateCommentaireUsingPOST(dossierId: string, updateCommentaireRequestDto: UpdateCommentaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = CommentaireControllerApiFetchParamCreator(configuration).validateUpdateCommentaireUsingPOST(dossierId, updateCommentaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CommentaireControllerApi - object-oriented interface
 * @export
 * @class CommentaireControllerApi
 * @extends {BaseAPI}
 */
export class CommentaireControllerApi extends BaseAPI {
    /**
     * @summary Route permettant d\'ajouter un commentaire à un dossier
     * @param {string} dossierId Id du dossier
     * @param {CommentaireRequestDto} commentaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCommentaireUsingPOST(dossierId: string, commentaireRequestDto: CommentaireRequestDto, options?: any) {
        return CommentaireControllerApiFp(this.configuration).addCommentaireUsingPOST(dossierId, commentaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de supprimer un commentaire d\'un dossier
     * @param {string} commentaireId Id du commentaire à supprimer
     * @param {string} dossierId Id du dossier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUsingDELETE(commentaireId: string, dossierId: string, options?: any) {
        return CommentaireControllerApiFp(this.configuration).deleteUsingDELETE(commentaireId, dossierId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer les commentaires d\'un dossier
     * @param {string} dossierId Id du dossier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCommentairesUsingGET(dossierId: string, options?: any) {
        return CommentaireControllerApiFp(this.configuration).getCommentairesUsingGET(dossierId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de faire une modification sur un commentaire d\'un dossier
     * @param {string} dossierId Id du dossier
     * @param {UpdateCommentaireRequestDto} updateCommentaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCommentaireUsingPOST(dossierId: string, updateCommentaireRequestDto: UpdateCommentaireRequestDto, options?: any) {
        return CommentaireControllerApiFp(this.configuration).updateCommentaireUsingPOST(dossierId, updateCommentaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ d\'une requête d\'action sur un commentaire
     * @param {string} dossierId Id du dossier
     * @param {'CONTENU'} field Champ du commentaire
     * @param {CommentaireRequestDto} commentaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateAddCommentaireFieldUsingPOST(dossierId: string, field: 'CONTENU', commentaireRequestDto: CommentaireRequestDto, options?: any) {
        return CommentaireControllerApiFp(this.configuration).validateAddCommentaireFieldUsingPOST(dossierId, field, commentaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider une requête d\'action sur un commentaire
     * @param {string} dossierId Id du dossier
     * @param {CommentaireRequestDto} commentaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateAddCommentaireUsingPOST(dossierId: string, commentaireRequestDto: CommentaireRequestDto, options?: any) {
        return CommentaireControllerApiFp(this.configuration).validateAddCommentaireUsingPOST(dossierId, commentaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ d\'une requête de modification sur un commentaire
     * @param {string} dossierId Id du dossier
     * @param {'CONTENU'} field Champ du commentaire
     * @param {UpdateCommentaireRequestDto} updateCommentaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFieldUpdateCommentaireUsingPOST(dossierId: string, field: 'CONTENU', updateCommentaireRequestDto: UpdateCommentaireRequestDto, options?: any) {
        return CommentaireControllerApiFp(this.configuration).validateFieldUpdateCommentaireUsingPOST(dossierId, field, updateCommentaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider une requête de modification sur un commentaire
     * @param {string} dossierId Id du dossier
     * @param {UpdateCommentaireRequestDto} updateCommentaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateCommentaireUsingPOST(dossierId: string, updateCommentaireRequestDto: UpdateCommentaireRequestDto, options?: any) {
        return CommentaireControllerApiFp(this.configuration).validateUpdateCommentaireUsingPOST(dossierId, updateCommentaireRequestDto, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// ComptesUtilisateursControllerApi /////////////////////////////////////////////////////

/**
 * objet contenant les query params de la route searchUsingGET
 * @export
 * @interface SearchUsingGETQueryParams
 */
export interface SearchUsingGETQueryParams {
    /**
     * 
     * @type {string}
     * @memberof SearchUsingGETQueryParams
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUsingGETQueryParams
     */
    entiteRattachement?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUsingGETQueryParams
     */
    exact?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchUsingGETQueryParams
     */
    firstName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUsingGETQueryParams
     */
    gestionnaireLocal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchUsingGETQueryParams
     */
    lastName?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchUsingGETQueryParams
     */
    pageSize?: number;
    /**
     * 
     * @type {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'}
     * @memberof SearchUsingGETQueryParams
     */
    userType?: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE';
    /**
     * 
     * @type {string}
     * @memberof SearchUsingGETQueryParams
     */
    username?: string;
}

/**
 * ComptesUtilisateursControllerApi - fetch parameter creator
 * @export
 */
export const ComptesUtilisateursControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Non utilisable. Route créant un utilisateur et retournant les valeurs générées
         * @param {CreateUserRequestDto} createUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsingPOST(createUserRequestDto: CreateUserRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'createUserRequestDto' is not null or undefined
            if (createUserRequestDto === null || createUserRequestDto === undefined) {
                throw new RequiredError('createUserRequestDto','Required parameter createUserRequestDto was null or undefined when calling createUsingPOST.');
            }
            const localVarPath = `/api/comptes-utilisateurs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateUserRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(createUserRequestDto || {}) : (createUserRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de supprimer un utilisateur
         * @param {string} userId Id du compte à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserUsingDELETE(userId: string, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling deleteUserUsingDELETE.');
            }
            const localVarPath = `/api/comptes-utilisateurs/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer les actions requises de l\'utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequiredActionsUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/comptes-utilisateurs/action-requises`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de réinitialiser le mot de passe d\'un utilisateur
         * @param {string} userId Id du compte dont on veut réinitialiser le mot de passe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordUsingPUT(userId: string, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling resetPasswordUsingPUT.');
            }
            const localVarPath = `/api/comptes-utilisateurs/{userId}/reset-password`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer une liste d\'utilisateurs paginée. Tous si admin, appartenant à la même entité que l\'utilisateur si autre profil
         * @param {searchUsingGETQueryParams} queryParams objet contenant les query params de la route searchUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsingGET(queryParams: SearchUsingGETQueryParams, options: any = {}): FetchArgs {
            const localVarPath = `/api/comptes-utilisateurs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.email !== undefined) {
                localVarQueryParameter['email'] = queryParams.email;
            }

            if (queryParams.entiteRattachement !== undefined) {
                localVarQueryParameter['entiteRattachement'] = queryParams.entiteRattachement;
            }

            if (queryParams.exact !== undefined) {
                localVarQueryParameter['exact'] = queryParams.exact;
            }

            if (queryParams.firstName !== undefined) {
                localVarQueryParameter['firstName'] = queryParams.firstName;
            }

            if (queryParams.gestionnaireLocal !== undefined) {
                localVarQueryParameter['gestionnaireLocal'] = queryParams.gestionnaireLocal;
            }

            if (queryParams.lastName !== undefined) {
                localVarQueryParameter['lastName'] = queryParams.lastName;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            if (queryParams.userType !== undefined) {
                localVarQueryParameter['userType'] = queryParams.userType;
            }

            if (queryParams.username !== undefined) {
                localVarQueryParameter['username'] = queryParams.username;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour un utilisateur
         * @param {string} userId Id du compte à mettre à jour
         * @param {UpdateUserRequestDto} updateUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT(userId: string, updateUserRequestDto: UpdateUserRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling updateUsingPUT.');
            }
            // verify required parameter 'updateUserRequestDto' is not null or undefined
            if (updateUserRequestDto === null || updateUserRequestDto === undefined) {
                throw new RequiredError('updateUserRequestDto','Required parameter updateUserRequestDto was null or undefined when calling updateUsingPUT.');
            }
            const localVarPath = `/api/comptes-utilisateurs/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateUserRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateUserRequestDto || {}) : (updateUserRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Non utilisable. Route validant le champ spécifié dans le formulaire de création d\'un compte.
         * @param {'PRENOM' | 'NOM' | 'EMAIL' | 'ENTITE_RATTACHEMENT' | 'PROFILE'} field Le champ à valider, représenté par une énumération.
         * @param {CreateUserRequestDto} createUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateFieldUsingPOST(field: 'PRENOM' | 'NOM' | 'EMAIL' | 'ENTITE_RATTACHEMENT' | 'PROFILE', createUserRequestDto: CreateUserRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCreateFieldUsingPOST.');
            }
            // verify required parameter 'createUserRequestDto' is not null or undefined
            if (createUserRequestDto === null || createUserRequestDto === undefined) {
                throw new RequiredError('createUserRequestDto','Required parameter createUserRequestDto was null or undefined when calling validateCreateFieldUsingPOST.');
            }
            const localVarPath = `/api/comptes-utilisateurs/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateUserRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(createUserRequestDto || {}) : (createUserRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Non utilisable. Route validant tous les champs du formulaire de création d\'un utilisateur
         * @param {CreateUserRequestDto} createUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateUsingPOST(createUserRequestDto: CreateUserRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'createUserRequestDto' is not null or undefined
            if (createUserRequestDto === null || createUserRequestDto === undefined) {
                throw new RequiredError('createUserRequestDto','Required parameter createUserRequestDto was null or undefined when calling validateCreateUsingPOST.');
            }
            const localVarPath = `/api/comptes-utilisateurs/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateUserRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(createUserRequestDto || {}) : (createUserRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route validant le champ spécifié dans le formulaire de mise à jour d\'un compte.
         * @param {'FIRSTNAME' | 'LASTNAME' | 'EMAIL' | 'UNITE_RATTACHEMENT' | 'ACTIF'} field Le champ à valider, représenté par une énumération.
         * @param {string} userId ID du compte, représenté par une chaine de caractères.
         * @param {UpdateUserRequestDto} updateUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFieldUsingPOST(field: 'FIRSTNAME' | 'LASTNAME' | 'EMAIL' | 'UNITE_RATTACHEMENT' | 'ACTIF', userId: string, updateUserRequestDto: UpdateUserRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateFieldUsingPOST.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling validateUpdateFieldUsingPOST.');
            }
            // verify required parameter 'updateUserRequestDto' is not null or undefined
            if (updateUserRequestDto === null || updateUserRequestDto === undefined) {
                throw new RequiredError('updateUserRequestDto','Required parameter updateUserRequestDto was null or undefined when calling validateUpdateFieldUsingPOST.');
            }
            const localVarPath = `/api/comptes-utilisateurs/{userId}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateUserRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateUserRequestDto || {}) : (updateUserRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route validant tous les champs du formulaire de mise à jour d\'un utilisateur
         * @param {string} userId ID du compte, représenté par une chaine de caractères.
         * @param {UpdateUserRequestDto} updateUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateUsingPOST(userId: string, updateUserRequestDto: UpdateUserRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling validateUpdateUsingPOST.');
            }
            // verify required parameter 'updateUserRequestDto' is not null or undefined
            if (updateUserRequestDto === null || updateUserRequestDto === undefined) {
                throw new RequiredError('updateUserRequestDto','Required parameter updateUserRequestDto was null or undefined when calling validateUpdateUsingPOST.');
            }
            const localVarPath = `/api/comptes-utilisateurs/{userId}/validation`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateUserRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateUserRequestDto || {}) : (updateUserRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComptesUtilisateursControllerApi - functional programming interface
 * @export
 */
export const ComptesUtilisateursControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Non utilisable. Route créant un utilisateur et retournant les valeurs générées
         * @param {CreateUserRequestDto} createUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsingPOST(createUserRequestDto: CreateUserRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CreateUserResultDto> {
            const localVarFetchArgs = ComptesUtilisateursControllerApiFetchParamCreator(configuration).createUsingPOST(createUserRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de supprimer un utilisateur
         * @param {string} userId Id du compte à supprimer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserUsingDELETE(userId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ComptesUtilisateursControllerApiFetchParamCreator(configuration).deleteUserUsingDELETE(userId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer les actions requises de l\'utilisateur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequiredActionsUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RequiredUserActionsDto> {
            const localVarFetchArgs = ComptesUtilisateursControllerApiFetchParamCreator(configuration).getRequiredActionsUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de réinitialiser le mot de passe d\'un utilisateur
         * @param {string} userId Id du compte dont on veut réinitialiser le mot de passe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordUsingPUT(userId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ComptesUtilisateursControllerApiFetchParamCreator(configuration).resetPasswordUsingPUT(userId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer une liste d\'utilisateurs paginée. Tous si admin, appartenant à la même entité que l\'utilisateur si autre profil
         * @param {searchUsingGETQueryParams} queryParams objet contenant les query params de la route searchUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsingGET(queryParams: SearchUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchUserResultDto> {
            const localVarFetchArgs = ComptesUtilisateursControllerApiFetchParamCreator(configuration).searchUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour un utilisateur
         * @param {string} userId Id du compte à mettre à jour
         * @param {UpdateUserRequestDto} updateUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT(userId: string, updateUserRequestDto: UpdateUserRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDto> {
            const localVarFetchArgs = ComptesUtilisateursControllerApiFetchParamCreator(configuration).updateUsingPUT(userId, updateUserRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Non utilisable. Route validant le champ spécifié dans le formulaire de création d\'un compte.
         * @param {'PRENOM' | 'NOM' | 'EMAIL' | 'ENTITE_RATTACHEMENT' | 'PROFILE'} field Le champ à valider, représenté par une énumération.
         * @param {CreateUserRequestDto} createUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateFieldUsingPOST(field: 'PRENOM' | 'NOM' | 'EMAIL' | 'ENTITE_RATTACHEMENT' | 'PROFILE', createUserRequestDto: CreateUserRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserViolationsDto> {
            const localVarFetchArgs = ComptesUtilisateursControllerApiFetchParamCreator(configuration).validateCreateFieldUsingPOST(field, createUserRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Non utilisable. Route validant tous les champs du formulaire de création d\'un utilisateur
         * @param {CreateUserRequestDto} createUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateUsingPOST(createUserRequestDto: CreateUserRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserViolationsDto> {
            const localVarFetchArgs = ComptesUtilisateursControllerApiFetchParamCreator(configuration).validateCreateUsingPOST(createUserRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route validant le champ spécifié dans le formulaire de mise à jour d\'un compte.
         * @param {'FIRSTNAME' | 'LASTNAME' | 'EMAIL' | 'UNITE_RATTACHEMENT' | 'ACTIF'} field Le champ à valider, représenté par une énumération.
         * @param {string} userId ID du compte, représenté par une chaine de caractères.
         * @param {UpdateUserRequestDto} updateUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateFieldUsingPOST(field: 'FIRSTNAME' | 'LASTNAME' | 'EMAIL' | 'UNITE_RATTACHEMENT' | 'ACTIF', userId: string, updateUserRequestDto: UpdateUserRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserViolationsDto> {
            const localVarFetchArgs = ComptesUtilisateursControllerApiFetchParamCreator(configuration).validateUpdateFieldUsingPOST(field, userId, updateUserRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route validant tous les champs du formulaire de mise à jour d\'un utilisateur
         * @param {string} userId ID du compte, représenté par une chaine de caractères.
         * @param {UpdateUserRequestDto} updateUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateUsingPOST(userId: string, updateUserRequestDto: UpdateUserRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserViolationsDto> {
            const localVarFetchArgs = ComptesUtilisateursControllerApiFetchParamCreator(configuration).validateUpdateUsingPOST(userId, updateUserRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ComptesUtilisateursControllerApi - object-oriented interface
 * @export
 * @class ComptesUtilisateursControllerApi
 * @extends {BaseAPI}
 */
export class ComptesUtilisateursControllerApi extends BaseAPI {
    /**
     * @summary Non utilisable. Route créant un utilisateur et retournant les valeurs générées
     * @param {CreateUserRequestDto} createUserRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUsingPOST(createUserRequestDto: CreateUserRequestDto, options?: any) {
        return ComptesUtilisateursControllerApiFp(this.configuration).createUsingPOST(createUserRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de supprimer un utilisateur
     * @param {string} userId Id du compte à supprimer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUserUsingDELETE(userId: string, options?: any) {
        return ComptesUtilisateursControllerApiFp(this.configuration).deleteUserUsingDELETE(userId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer les actions requises de l\'utilisateur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRequiredActionsUsingGET(options?: any) {
        return ComptesUtilisateursControllerApiFp(this.configuration).getRequiredActionsUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de réinitialiser le mot de passe d\'un utilisateur
     * @param {string} userId Id du compte dont on veut réinitialiser le mot de passe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetPasswordUsingPUT(userId: string, options?: any) {
        return ComptesUtilisateursControllerApiFp(this.configuration).resetPasswordUsingPUT(userId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer une liste d\'utilisateurs paginée. Tous si admin, appartenant à la même entité que l\'utilisateur si autre profil
     * @param {searchUsingGETQueryParams} queryParams objet contenant les query params de la route searchUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUsingGET(queryParams: SearchUsingGETQueryParams, options?: any) {
        return ComptesUtilisateursControllerApiFp(this.configuration).searchUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour un utilisateur
     * @param {string} userId Id du compte à mettre à jour
     * @param {UpdateUserRequestDto} updateUserRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUsingPUT(userId: string, updateUserRequestDto: UpdateUserRequestDto, options?: any) {
        return ComptesUtilisateursControllerApiFp(this.configuration).updateUsingPUT(userId, updateUserRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Non utilisable. Route validant le champ spécifié dans le formulaire de création d\'un compte.
     * @param {'PRENOM' | 'NOM' | 'EMAIL' | 'ENTITE_RATTACHEMENT' | 'PROFILE'} field Le champ à valider, représenté par une énumération.
     * @param {CreateUserRequestDto} createUserRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateFieldUsingPOST(field: 'PRENOM' | 'NOM' | 'EMAIL' | 'ENTITE_RATTACHEMENT' | 'PROFILE', createUserRequestDto: CreateUserRequestDto, options?: any) {
        return ComptesUtilisateursControllerApiFp(this.configuration).validateCreateFieldUsingPOST(field, createUserRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Non utilisable. Route validant tous les champs du formulaire de création d\'un utilisateur
     * @param {CreateUserRequestDto} createUserRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCreateUsingPOST(createUserRequestDto: CreateUserRequestDto, options?: any) {
        return ComptesUtilisateursControllerApiFp(this.configuration).validateCreateUsingPOST(createUserRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route validant le champ spécifié dans le formulaire de mise à jour d\'un compte.
     * @param {'FIRSTNAME' | 'LASTNAME' | 'EMAIL' | 'UNITE_RATTACHEMENT' | 'ACTIF'} field Le champ à valider, représenté par une énumération.
     * @param {string} userId ID du compte, représenté par une chaine de caractères.
     * @param {UpdateUserRequestDto} updateUserRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateFieldUsingPOST(field: 'FIRSTNAME' | 'LASTNAME' | 'EMAIL' | 'UNITE_RATTACHEMENT' | 'ACTIF', userId: string, updateUserRequestDto: UpdateUserRequestDto, options?: any) {
        return ComptesUtilisateursControllerApiFp(this.configuration).validateUpdateFieldUsingPOST(field, userId, updateUserRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route validant tous les champs du formulaire de mise à jour d\'un utilisateur
     * @param {string} userId ID du compte, représenté par une chaine de caractères.
     * @param {UpdateUserRequestDto} updateUserRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateUsingPOST(userId: string, updateUserRequestDto: UpdateUserRequestDto, options?: any) {
        return ComptesUtilisateursControllerApiFp(this.configuration).validateUpdateUsingPOST(userId, updateUserRequestDto, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// DocumentSpecifiqueControllerApi /////////////////////////////////////////////////////

/**
 * objet contenant les query params de la route downloadDocumentSpecifiqueUsingGET
 * @export
 * @interface DownloadDocumentSpecifiqueUsingGETQueryParams
 */
export interface DownloadDocumentSpecifiqueUsingGETQueryParams {
    /**
     * Id du document, représenté par son hash.
     * @type {string}
     * @memberof DownloadDocumentSpecifiqueUsingGETQueryParams
     */
    hash: string;
    /**
     * Nom du document spécifique
     * @type {string}
     * @memberof DownloadDocumentSpecifiqueUsingGETQueryParams
     */
    name: string;
}

/**
 * DocumentSpecifiqueControllerApi - fetch parameter creator
 * @export
 */
export const DocumentSpecifiqueControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @param {downloadDocumentSpecifiqueUsingGETQueryParams} queryParams objet contenant les query params de la route downloadDocumentSpecifiqueUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentSpecifiqueUsingGET(queryParams: DownloadDocumentSpecifiqueUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'hash' is not null or undefined
            if (queryParams.hash === null || queryParams.hash === undefined) {
                throw new RequiredError('hash','Required parameter hash was null or undefined when calling downloadDocumentSpecifiqueUsingGET.');
            }
            // verify required parameter 'name' is not null or undefined
            if (queryParams.name === null || queryParams.name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling downloadDocumentSpecifiqueUsingGET.');
            }
            const localVarPath = `/api/document-specifique/download`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.hash !== undefined) {
                localVarQueryParameter['hash'] = queryParams.hash;
            }

            if (queryParams.name !== undefined) {
                localVarQueryParameter['name'] = queryParams.name;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsSpecifiquesUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/document-specifique`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentSpecifiqueControllerApi - functional programming interface
 * @export
 */
export const DocumentSpecifiqueControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @param {downloadDocumentSpecifiqueUsingGETQueryParams} queryParams objet contenant les query params de la route downloadDocumentSpecifiqueUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentSpecifiqueUsingGET(queryParams: DownloadDocumentSpecifiqueUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DocumentSpecifiqueControllerApiFetchParamCreator(configuration).downloadDocumentSpecifiqueUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsSpecifiquesUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DocumentSpecifiqueDto>> {
            const localVarFetchArgs = DocumentSpecifiqueControllerApiFetchParamCreator(configuration).getDocumentsSpecifiquesUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DocumentSpecifiqueControllerApi - object-oriented interface
 * @export
 * @class DocumentSpecifiqueControllerApi
 * @extends {BaseAPI}
 */
export class DocumentSpecifiqueControllerApi extends BaseAPI {
    /**
     * @param {downloadDocumentSpecifiqueUsingGETQueryParams} queryParams objet contenant les query params de la route downloadDocumentSpecifiqueUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadDocumentSpecifiqueUsingGET(queryParams: DownloadDocumentSpecifiqueUsingGETQueryParams, options?: any) {
        return DocumentSpecifiqueControllerApiFp(this.configuration).downloadDocumentSpecifiqueUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDocumentsSpecifiquesUsingGET(options?: any) {
        return DocumentSpecifiqueControllerApiFp(this.configuration).getDocumentsSpecifiquesUsingGET(options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// DossierControllerApi /////////////////////////////////////////////////////

/**
 * objet contenant les query params de la route countDossierSummariesUsingGET
 * @export
 * @interface CountDossierSummariesUsingGETQueryParams
 */
export interface CountDossierSummariesUsingGETQueryParams {
    /**
     * objet contenant les dossierCriteriaDto de CountDossierSummariesUsingGETQueryParams
     * @type {CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto}
     * @memberof CountDossierSummariesUsingGETQueryParams
     */
    dossierCriteriaDto: CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto;
    /**
     * objet contenant les dossierSortDto de CountDossierSummariesUsingGETQueryParams
     * @type {CountDossierSummariesUsingGETQueryParamsDossierSortDto}
     * @memberof CountDossierSummariesUsingGETQueryParams
     */
    dossierSortDto: CountDossierSummariesUsingGETQueryParamsDossierSortDto;
    /**
     * 
     * @type {number}
     * @memberof CountDossierSummariesUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CountDossierSummariesUsingGETQueryParams
     */
    pageSize?: number;
}

export interface CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto {
    /**
    * 
    * @type {Array<'PROLONGER_MEF' | 'MODIFIER_COORDONNEES_PROPRIETAIRE' | 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' | 'RENSEIGNER_SORTIE_VEHICULE' | 'SAISIE_VHU' | 'SAISIE_NOTIFICATION_MANUELLE' | 'MAIN_LEVEE' | 'TRAITE_EN_FACTURATION' | 'NON_TRAITE_EN_FACTURATION' | 'ANNULATION_SORTIE_VEHICULE' | 'EXPORT_DONNEES_DOSSIER' | 'SUPPRESSION_DOSSIER' | 'SUPPRESSION_DOSSIER_BY_FO' | 'UPDATE_ENTITES_RATTACHEMENT_ADMIN' | 'UPDATE_ENTITES_RATTACHEMENT_FO_AF' | 'MODIFICATION_SORTIE_VEHICULE' | 'UPDATE_DONNEES_VEHICULE' | 'UPDATE_DONNEES_VEHICULE_JUSTICE' | 'UPDATE_CLASSEMENT' | 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' | 'ENREGISTRER_ENTREE' | 'CONTROLER_DONNEES_VEHICULE' | 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' | 'RELANCE_VENTE_VOL' | 'RELANCE_VENTE_IMMO_PJ' | 'RELANCE_VENTE_OPPOSITION' | 'RELANCE_VENTE_DOUBLON' | 'RELANCE_VENTE_MANQUANT' | 'RECUPERATION_AR_PND_AUTOMATIQUE' | 'CONTROLE_BLOCAGE_ARGOS' | 'CONTROLE_BLOCAGE_ANTAI' | 'CONTROLE_BLOCAGE_DNID' | 'RECUPERATION_COURRIER_AUTOMATIQUE' | 'RENSEIGNER_INFORMATIONS_SIV' | 'CONFIRMER_VOL_VVNR' | 'VALIDATION_ACTIONS_VVNR_HORS_SIF' | 'IMPORTER_PIECES_JOINTES' | 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' | 'UPDATE_DONNEES_JUDICIAIRE'> | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    actionsRequises?: Array<'PROLONGER_MEF' | 'MODIFIER_COORDONNEES_PROPRIETAIRE' | 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' | 'RENSEIGNER_SORTIE_VEHICULE' | 'SAISIE_VHU' | 'SAISIE_NOTIFICATION_MANUELLE' | 'MAIN_LEVEE' | 'TRAITE_EN_FACTURATION' | 'NON_TRAITE_EN_FACTURATION' | 'ANNULATION_SORTIE_VEHICULE' | 'EXPORT_DONNEES_DOSSIER' | 'SUPPRESSION_DOSSIER' | 'SUPPRESSION_DOSSIER_BY_FO' | 'UPDATE_ENTITES_RATTACHEMENT_ADMIN' | 'UPDATE_ENTITES_RATTACHEMENT_FO_AF' | 'MODIFICATION_SORTIE_VEHICULE' | 'UPDATE_DONNEES_VEHICULE' | 'UPDATE_DONNEES_VEHICULE_JUSTICE' | 'UPDATE_CLASSEMENT' | 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' | 'ENREGISTRER_ENTREE' | 'CONTROLER_DONNEES_VEHICULE' | 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' | 'RELANCE_VENTE_VOL' | 'RELANCE_VENTE_IMMO_PJ' | 'RELANCE_VENTE_OPPOSITION' | 'RELANCE_VENTE_DOUBLON' | 'RELANCE_VENTE_MANQUANT' | 'RECUPERATION_AR_PND_AUTOMATIQUE' | 'CONTROLE_BLOCAGE_ARGOS' | 'CONTROLE_BLOCAGE_ANTAI' | 'CONTROLE_BLOCAGE_DNID' | 'RECUPERATION_COURRIER_AUTOMATIQUE' | 'RENSEIGNER_INFORMATIONS_SIV' | 'CONFIRMER_VOL_VVNR' | 'VALIDATION_ACTIONS_VVNR_HORS_SIF' | 'IMPORTER_PIECES_JOINTES' | 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' | 'UPDATE_DONNEES_JUDICIAIRE'>;
    /**
    * 
    * @type {string | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    antaiId?: string;
    /**
    * 
    * @type {Array<'ALIENATION' | 'DESTRUCTION' | 'MANUEL'> | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    classementList?: Array<'ALIENATION' | 'DESTRUCTION' | 'MANUEL'>;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    communeEnlevementList?: Array<string>;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromAbandon?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromBonEnlevement?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromMiseAJour?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromMiseEnFourriere?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromOrdreDestruction?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromSortieDefinitive?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToAbandon?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToBonEnlevement?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToMiseAJour?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToMiseEnFourriere?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToOrdreDestruction?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToSortieDefinitive?: Date;
    /**
    * 
    * @type {string | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idAutoriteFourriere?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idCorrelationMarque?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idCorrelationModele?: string;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idFourriereList?: Array<string>;
    /**
    * 
    * @type {string | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idJuridiction?: string;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idJuridictionList?: Array<string>;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idMotifSortieList?: Array<string>;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idNatureBrancheList?: Array<string>;
    /**
    * 
    * @type {string | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idUniteFO?: string;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idUniteFOList?: Array<string>;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    includeDossiersAnonymises?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    includeDossiersSortis?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    isDetruitApresSortie?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    isMarqueNonReference?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    isModeleNonReference?: boolean;
    /**
    * Utiliser \'numeroRecherche\' à la place (prioritaire)
    * @type {string | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    numeroImmatriculation?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    numeroRecherche?: string;
    /**
    * 
    * @type {Array<'A_REMPLIR' | 'ENREGISTRE' | 'NON_GERE' | 'NOTIFICATION_ENVOYEE' | 'NOTIFIE' | 'A_NOTIFIER' | 'EN_COURS_DE_NOTIFICATION' | 'A_REMETTRE_AUX_DOMAINES' | 'REMIS_AU_DOMAINE' | 'MIS_EN_VENTE' | 'VENDU' | 'A_RESTITUER' | 'VENTE_BLOQUEE' | 'A_DETRUIRE' | 'SORTI' | 'DETRUIT'> | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    statutDossierEnumList?: Array<'A_REMPLIR' | 'ENREGISTRE' | 'NON_GERE' | 'NOTIFICATION_ENVOYEE' | 'NOTIFIE' | 'A_NOTIFIER' | 'EN_COURS_DE_NOTIFICATION' | 'A_REMETTRE_AUX_DOMAINES' | 'REMIS_AU_DOMAINE' | 'MIS_EN_VENTE' | 'VENDU' | 'A_RESTITUER' | 'VENTE_BLOQUEE' | 'A_DETRUIRE' | 'SORTI' | 'DETRUIT'>;
    /**
    * 
    * @type {Array<'TRAITE' | 'NON_TRAITE' | 'NON_CONCERNE'> | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    statutsFacturation?: Array<'TRAITE' | 'NON_TRAITE' | 'NON_CONCERNE'>;
}

export interface CountDossierSummariesUsingGETQueryParamsDossierSortDto {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    alertesIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    classementIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    couleurIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateAbandonIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateBonEnlevementIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateMiseAJourIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateMiseFourriereIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateOrdreDestructionIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateSortieDefinitiveIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    fourriereIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    immatriculationIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    marqueIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    modeleIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    natureMiseEnFourriereIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof CountDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    statutIsAsc?: boolean;
}

/**
 * objet contenant les query params de la route searchDossierSummariesUsingGET
 * @export
 * @interface SearchDossierSummariesUsingGETQueryParams
 */
export interface SearchDossierSummariesUsingGETQueryParams {
    /**
     * objet contenant les dossierCriteriaDto de SearchDossierSummariesUsingGETQueryParams
     * @type {SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto}
     * @memberof SearchDossierSummariesUsingGETQueryParams
     */
    dossierCriteriaDto: SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto;
    /**
     * objet contenant les dossierSortDto de SearchDossierSummariesUsingGETQueryParams
     * @type {SearchDossierSummariesUsingGETQueryParamsDossierSortDto}
     * @memberof SearchDossierSummariesUsingGETQueryParams
     */
    dossierSortDto: SearchDossierSummariesUsingGETQueryParamsDossierSortDto;
    /**
     * 
     * @type {number}
     * @memberof SearchDossierSummariesUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchDossierSummariesUsingGETQueryParams
     */
    pageSize?: number;
}

export interface SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto {
    /**
    * 
    * @type {Array<'PROLONGER_MEF' | 'MODIFIER_COORDONNEES_PROPRIETAIRE' | 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' | 'RENSEIGNER_SORTIE_VEHICULE' | 'SAISIE_VHU' | 'SAISIE_NOTIFICATION_MANUELLE' | 'MAIN_LEVEE' | 'TRAITE_EN_FACTURATION' | 'NON_TRAITE_EN_FACTURATION' | 'ANNULATION_SORTIE_VEHICULE' | 'EXPORT_DONNEES_DOSSIER' | 'SUPPRESSION_DOSSIER' | 'SUPPRESSION_DOSSIER_BY_FO' | 'UPDATE_ENTITES_RATTACHEMENT_ADMIN' | 'UPDATE_ENTITES_RATTACHEMENT_FO_AF' | 'MODIFICATION_SORTIE_VEHICULE' | 'UPDATE_DONNEES_VEHICULE' | 'UPDATE_DONNEES_VEHICULE_JUSTICE' | 'UPDATE_CLASSEMENT' | 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' | 'ENREGISTRER_ENTREE' | 'CONTROLER_DONNEES_VEHICULE' | 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' | 'RELANCE_VENTE_VOL' | 'RELANCE_VENTE_IMMO_PJ' | 'RELANCE_VENTE_OPPOSITION' | 'RELANCE_VENTE_DOUBLON' | 'RELANCE_VENTE_MANQUANT' | 'RECUPERATION_AR_PND_AUTOMATIQUE' | 'CONTROLE_BLOCAGE_ARGOS' | 'CONTROLE_BLOCAGE_ANTAI' | 'CONTROLE_BLOCAGE_DNID' | 'RECUPERATION_COURRIER_AUTOMATIQUE' | 'RENSEIGNER_INFORMATIONS_SIV' | 'CONFIRMER_VOL_VVNR' | 'VALIDATION_ACTIONS_VVNR_HORS_SIF' | 'IMPORTER_PIECES_JOINTES' | 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' | 'UPDATE_DONNEES_JUDICIAIRE'> | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    actionsRequises?: Array<'PROLONGER_MEF' | 'MODIFIER_COORDONNEES_PROPRIETAIRE' | 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' | 'RENSEIGNER_SORTIE_VEHICULE' | 'SAISIE_VHU' | 'SAISIE_NOTIFICATION_MANUELLE' | 'MAIN_LEVEE' | 'TRAITE_EN_FACTURATION' | 'NON_TRAITE_EN_FACTURATION' | 'ANNULATION_SORTIE_VEHICULE' | 'EXPORT_DONNEES_DOSSIER' | 'SUPPRESSION_DOSSIER' | 'SUPPRESSION_DOSSIER_BY_FO' | 'UPDATE_ENTITES_RATTACHEMENT_ADMIN' | 'UPDATE_ENTITES_RATTACHEMENT_FO_AF' | 'MODIFICATION_SORTIE_VEHICULE' | 'UPDATE_DONNEES_VEHICULE' | 'UPDATE_DONNEES_VEHICULE_JUSTICE' | 'UPDATE_CLASSEMENT' | 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' | 'ENREGISTRER_ENTREE' | 'CONTROLER_DONNEES_VEHICULE' | 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' | 'RELANCE_VENTE_VOL' | 'RELANCE_VENTE_IMMO_PJ' | 'RELANCE_VENTE_OPPOSITION' | 'RELANCE_VENTE_DOUBLON' | 'RELANCE_VENTE_MANQUANT' | 'RECUPERATION_AR_PND_AUTOMATIQUE' | 'CONTROLE_BLOCAGE_ARGOS' | 'CONTROLE_BLOCAGE_ANTAI' | 'CONTROLE_BLOCAGE_DNID' | 'RECUPERATION_COURRIER_AUTOMATIQUE' | 'RENSEIGNER_INFORMATIONS_SIV' | 'CONFIRMER_VOL_VVNR' | 'VALIDATION_ACTIONS_VVNR_HORS_SIF' | 'IMPORTER_PIECES_JOINTES' | 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' | 'UPDATE_DONNEES_JUDICIAIRE'>;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    antaiId?: string;
    /**
    * 
    * @type {Array<'ALIENATION' | 'DESTRUCTION' | 'MANUEL'> | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    classementList?: Array<'ALIENATION' | 'DESTRUCTION' | 'MANUEL'>;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    communeEnlevementList?: Array<string>;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromAbandon?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromBonEnlevement?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromMiseAJour?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromMiseEnFourriere?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromOrdreDestruction?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromSortieDefinitive?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToAbandon?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToBonEnlevement?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToMiseAJour?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToMiseEnFourriere?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToOrdreDestruction?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    dateToSortieDefinitive?: Date;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idAutoriteFourriere?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idCorrelationMarque?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idCorrelationModele?: string;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idFourriereList?: Array<string>;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idJuridiction?: string;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idJuridictionList?: Array<string>;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idMotifSortieList?: Array<string>;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idNatureBrancheList?: Array<string>;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idUniteFO?: string;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    idUniteFOList?: Array<string>;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    includeDossiersAnonymises?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    includeDossiersSortis?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    isDetruitApresSortie?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    isMarqueNonReference?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    isModeleNonReference?: boolean;
    /**
    * Utiliser \'numeroRecherche\' à la place (prioritaire)
    * @type {string | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    numeroImmatriculation?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    numeroRecherche?: string;
    /**
    * 
    * @type {Array<'A_REMPLIR' | 'ENREGISTRE' | 'NON_GERE' | 'NOTIFICATION_ENVOYEE' | 'NOTIFIE' | 'A_NOTIFIER' | 'EN_COURS_DE_NOTIFICATION' | 'A_REMETTRE_AUX_DOMAINES' | 'REMIS_AU_DOMAINE' | 'MIS_EN_VENTE' | 'VENDU' | 'A_RESTITUER' | 'VENTE_BLOQUEE' | 'A_DETRUIRE' | 'SORTI' | 'DETRUIT'> | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    statutDossierEnumList?: Array<'A_REMPLIR' | 'ENREGISTRE' | 'NON_GERE' | 'NOTIFICATION_ENVOYEE' | 'NOTIFIE' | 'A_NOTIFIER' | 'EN_COURS_DE_NOTIFICATION' | 'A_REMETTRE_AUX_DOMAINES' | 'REMIS_AU_DOMAINE' | 'MIS_EN_VENTE' | 'VENDU' | 'A_RESTITUER' | 'VENTE_BLOQUEE' | 'A_DETRUIRE' | 'SORTI' | 'DETRUIT'>;
    /**
    * 
    * @type {Array<'TRAITE' | 'NON_TRAITE' | 'NON_CONCERNE'> | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierCriteriaDto
    */
    statutsFacturation?: Array<'TRAITE' | 'NON_TRAITE' | 'NON_CONCERNE'>;
}

export interface SearchDossierSummariesUsingGETQueryParamsDossierSortDto {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    alertesIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    classementIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    couleurIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateAbandonIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateBonEnlevementIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateMiseAJourIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateMiseFourriereIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateOrdreDestructionIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    dateSortieDefinitiveIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    fourriereIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    immatriculationIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    marqueIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    modeleIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    natureMiseEnFourriereIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchDossierSummariesUsingGETQueryParamsDossierSortDto
    */
    statutIsAsc?: boolean;
}

/**
 * DossierControllerApi - fetch parameter creator
 * @export
 */
export const DossierControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route pour compter des dossiers avec possibilité de filtres
         * @param {countDossierSummariesUsingGETQueryParams} queryParams objet contenant les query params de la route countDossierSummariesUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDossierSummariesUsingGET(queryParams: CountDossierSummariesUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'dossierCriteriaDto' is not null or undefined
            if (queryParams.dossierCriteriaDto === null || queryParams.dossierCriteriaDto === undefined) {
                throw new RequiredError('dossierCriteriaDto','Required parameter dossierCriteriaDto was null or undefined when calling countDossierSummariesUsingGET.');
            }
            // verify required parameter 'dossierSortDto' is not null or undefined
            if (queryParams.dossierSortDto === null || queryParams.dossierSortDto === undefined) {
                throw new RequiredError('dossierSortDto','Required parameter dossierSortDto was null or undefined when calling countDossierSummariesUsingGET.');
            }
            const localVarPath = `/api/dossier/count`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.dossierCriteriaDto.actionsRequises !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.actionsRequises'] = queryParams.dossierCriteriaDto.actionsRequises;
            }
            if (queryParams.dossierCriteriaDto.antaiId !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.antaiId'] = queryParams.dossierCriteriaDto.antaiId;
            }
            if (queryParams.dossierCriteriaDto.classementList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.classementList'] = queryParams.dossierCriteriaDto.classementList;
            }
            if (queryParams.dossierCriteriaDto.communeEnlevementList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.communeEnlevementList'] = queryParams.dossierCriteriaDto.communeEnlevementList;
            }
            if (queryParams.dossierCriteriaDto.dateFromAbandon !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromAbandon'] = (queryParams.dossierCriteriaDto.dateFromAbandon as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromBonEnlevement !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromBonEnlevement'] = (queryParams.dossierCriteriaDto.dateFromBonEnlevement as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromMiseAJour !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromMiseAJour'] = (queryParams.dossierCriteriaDto.dateFromMiseAJour as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromMiseEnFourriere !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromMiseEnFourriere'] = (queryParams.dossierCriteriaDto.dateFromMiseEnFourriere as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromOrdreDestruction !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromOrdreDestruction'] = (queryParams.dossierCriteriaDto.dateFromOrdreDestruction as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromSortieDefinitive !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromSortieDefinitive'] = (queryParams.dossierCriteriaDto.dateFromSortieDefinitive as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToAbandon !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToAbandon'] = (queryParams.dossierCriteriaDto.dateToAbandon as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToBonEnlevement !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToBonEnlevement'] = (queryParams.dossierCriteriaDto.dateToBonEnlevement as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToMiseAJour !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToMiseAJour'] = (queryParams.dossierCriteriaDto.dateToMiseAJour as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToMiseEnFourriere !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToMiseEnFourriere'] = (queryParams.dossierCriteriaDto.dateToMiseEnFourriere as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToOrdreDestruction !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToOrdreDestruction'] = (queryParams.dossierCriteriaDto.dateToOrdreDestruction as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToSortieDefinitive !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToSortieDefinitive'] = (queryParams.dossierCriteriaDto.dateToSortieDefinitive as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.idAutoriteFourriere !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idAutoriteFourriere'] = queryParams.dossierCriteriaDto.idAutoriteFourriere;
            }
            if (queryParams.dossierCriteriaDto.idCorrelationMarque !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idCorrelationMarque'] = queryParams.dossierCriteriaDto.idCorrelationMarque;
            }
            if (queryParams.dossierCriteriaDto.idCorrelationModele !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idCorrelationModele'] = queryParams.dossierCriteriaDto.idCorrelationModele;
            }
            if (queryParams.dossierCriteriaDto.idFourriereList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idFourriereList'] = queryParams.dossierCriteriaDto.idFourriereList;
            }
            if (queryParams.dossierCriteriaDto.idJuridiction !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idJuridiction'] = queryParams.dossierCriteriaDto.idJuridiction;
            }
            if (queryParams.dossierCriteriaDto.idJuridictionList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idJuridictionList'] = queryParams.dossierCriteriaDto.idJuridictionList;
            }
            if (queryParams.dossierCriteriaDto.idMotifSortieList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idMotifSortieList'] = queryParams.dossierCriteriaDto.idMotifSortieList;
            }
            if (queryParams.dossierCriteriaDto.idNatureBrancheList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idNatureBrancheList'] = queryParams.dossierCriteriaDto.idNatureBrancheList;
            }
            if (queryParams.dossierCriteriaDto.idUniteFO !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idUniteFO'] = queryParams.dossierCriteriaDto.idUniteFO;
            }
            if (queryParams.dossierCriteriaDto.idUniteFOList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idUniteFOList'] = queryParams.dossierCriteriaDto.idUniteFOList;
            }
            if (queryParams.dossierCriteriaDto.includeDossiersAnonymises !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.includeDossiersAnonymises'] = queryParams.dossierCriteriaDto.includeDossiersAnonymises;
            }
            if (queryParams.dossierCriteriaDto.includeDossiersSortis !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.includeDossiersSortis'] = queryParams.dossierCriteriaDto.includeDossiersSortis;
            }
            if (queryParams.dossierCriteriaDto.isDetruitApresSortie !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.isDetruitApresSortie'] = queryParams.dossierCriteriaDto.isDetruitApresSortie;
            }
            if (queryParams.dossierCriteriaDto.isMarqueNonReference !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.isMarqueNonReference'] = queryParams.dossierCriteriaDto.isMarqueNonReference;
            }
            if (queryParams.dossierCriteriaDto.isModeleNonReference !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.isModeleNonReference'] = queryParams.dossierCriteriaDto.isModeleNonReference;
            }
            if (queryParams.dossierCriteriaDto.numeroImmatriculation !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.numeroImmatriculation'] = queryParams.dossierCriteriaDto.numeroImmatriculation;
            }
            if (queryParams.dossierCriteriaDto.numeroRecherche !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.numeroRecherche'] = queryParams.dossierCriteriaDto.numeroRecherche;
            }
            if (queryParams.dossierCriteriaDto.statutDossierEnumList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.statutDossierEnumList'] = queryParams.dossierCriteriaDto.statutDossierEnumList;
            }
            if (queryParams.dossierCriteriaDto.statutsFacturation !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.statutsFacturation'] = queryParams.dossierCriteriaDto.statutsFacturation;
            }

            if (queryParams.dossierSortDto.alertesIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.alertesIsAsc'] = queryParams.dossierSortDto.alertesIsAsc;
            }
            if (queryParams.dossierSortDto.classementIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.classementIsAsc'] = queryParams.dossierSortDto.classementIsAsc;
            }
            if (queryParams.dossierSortDto.couleurIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.couleurIsAsc'] = queryParams.dossierSortDto.couleurIsAsc;
            }
            if (queryParams.dossierSortDto.dateAbandonIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateAbandonIsAsc'] = queryParams.dossierSortDto.dateAbandonIsAsc;
            }
            if (queryParams.dossierSortDto.dateBonEnlevementIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateBonEnlevementIsAsc'] = queryParams.dossierSortDto.dateBonEnlevementIsAsc;
            }
            if (queryParams.dossierSortDto.dateMiseAJourIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateMiseAJourIsAsc'] = queryParams.dossierSortDto.dateMiseAJourIsAsc;
            }
            if (queryParams.dossierSortDto.dateMiseFourriereIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateMiseFourriereIsAsc'] = queryParams.dossierSortDto.dateMiseFourriereIsAsc;
            }
            if (queryParams.dossierSortDto.dateOrdreDestructionIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateOrdreDestructionIsAsc'] = queryParams.dossierSortDto.dateOrdreDestructionIsAsc;
            }
            if (queryParams.dossierSortDto.dateSortieDefinitiveIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateSortieDefinitiveIsAsc'] = queryParams.dossierSortDto.dateSortieDefinitiveIsAsc;
            }
            if (queryParams.dossierSortDto.fourriereIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.fourriereIsAsc'] = queryParams.dossierSortDto.fourriereIsAsc;
            }
            if (queryParams.dossierSortDto.immatriculationIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.immatriculationIsAsc'] = queryParams.dossierSortDto.immatriculationIsAsc;
            }
            if (queryParams.dossierSortDto.marqueIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.marqueIsAsc'] = queryParams.dossierSortDto.marqueIsAsc;
            }
            if (queryParams.dossierSortDto.modeleIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.modeleIsAsc'] = queryParams.dossierSortDto.modeleIsAsc;
            }
            if (queryParams.dossierSortDto.natureMiseEnFourriereIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.natureMiseEnFourriereIsAsc'] = queryParams.dossierSortDto.natureMiseEnFourriereIsAsc;
            }
            if (queryParams.dossierSortDto.statutIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.statutIsAsc'] = queryParams.dossierSortDto.statutIsAsc;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de télécharger un des documents disponibles d\'un dossier
         * @param {'DECISION_CLASSEMENT' | 'DECISION_DESTRUCTION' | 'CONSTAT_ABANDON' | 'DECISION_REMISE_DOMAINE' | 'BON_ENLEVEMENT_DESTRUCTION' | 'FICHE_DESCRIPTIVE' | 'PRESCRIPTION_MEF' | 'MAIN_LEVEE_FO' | 'MAIN_LEVEE_USAGER' | 'COURRIER_NOTIFICATION' | 'AR_PND_NOTIFICATION'} document Document représenté par un enum.
         * @param {string} id Id du dossier, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentUsingGET(document: 'DECISION_CLASSEMENT' | 'DECISION_DESTRUCTION' | 'CONSTAT_ABANDON' | 'DECISION_REMISE_DOMAINE' | 'BON_ENLEVEMENT_DESTRUCTION' | 'FICHE_DESCRIPTIVE' | 'PRESCRIPTION_MEF' | 'MAIN_LEVEE_FO' | 'MAIN_LEVEE_USAGER' | 'COURRIER_NOTIFICATION' | 'AR_PND_NOTIFICATION', id: string, options: any = {}): FetchArgs {
            // verify required parameter 'document' is not null or undefined
            if (document === null || document === undefined) {
                throw new RequiredError('document','Required parameter document was null or undefined when calling downloadDocumentUsingGET.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling downloadDocumentUsingGET.');
            }
            const localVarPath = `/api/dossier/{id}/document/{document}`
                .replace(`{${"document"}}`, encodeURIComponent(String(document)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'obtenir la liste des actions requises sur un dossier, activées à partir du profil.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionsRequisesByProfileUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/dossier/actions-requises`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'accéder aux données d\'un dossier.
         * @param {string} id Id du dossier, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getByIdUsingGET.');
            }
            const localVarPath = `/api/dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'accéder aux données sur le propriétaire associé à un dossier.
         * @param {string} id Id du dossier, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfosProprietaireCourantByIdUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getInfosProprietaireCourantByIdUsingGET.');
            }
            const localVarPath = `/api/dossier/sortie/{id}/proprietaire/infos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'obtenir les ids de corrélation des motifs de sortie pour lesquels le gardien de fourrière doit valider que le code sur la main levée correspond à celui généré par le SIF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotifsSortieRequiringCodeMLCheckUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/dossier/sortie/motif-sortie/with-code-ml-check`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'obtenir les ids de corrélation des motifs de sortie pour lesquels le gardien de fourrière doit valider que les informations du propriétaire sont cohérentes avec celles retournées par la route \"/api/dossier/sortie/{id}/proprietaires/infos\".
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotifsSortieRequiringProprietaireInfoCheckUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/dossier/sortie/motif-sortie/with-proprietaire-check`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer le suivi de mise en fourriere d\'un dossier.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuiviMefUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSuiviMefUsingGET.');
            }
            const localVarPath = `/api/dossier/{id}/suivi-mef`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route de recherche des dossiers avec possibilité de filtres et de pagination de la requête, seulement une partie des informations des dossiers est renvoyée
         * @param {searchDossierSummariesUsingGETQueryParams} queryParams objet contenant les query params de la route searchDossierSummariesUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDossierSummariesUsingGET(queryParams: SearchDossierSummariesUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'dossierCriteriaDto' is not null or undefined
            if (queryParams.dossierCriteriaDto === null || queryParams.dossierCriteriaDto === undefined) {
                throw new RequiredError('dossierCriteriaDto','Required parameter dossierCriteriaDto was null or undefined when calling searchDossierSummariesUsingGET.');
            }
            // verify required parameter 'dossierSortDto' is not null or undefined
            if (queryParams.dossierSortDto === null || queryParams.dossierSortDto === undefined) {
                throw new RequiredError('dossierSortDto','Required parameter dossierSortDto was null or undefined when calling searchDossierSummariesUsingGET.');
            }
            const localVarPath = `/api/dossier`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.dossierCriteriaDto.actionsRequises !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.actionsRequises'] = queryParams.dossierCriteriaDto.actionsRequises;
            }
            if (queryParams.dossierCriteriaDto.antaiId !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.antaiId'] = queryParams.dossierCriteriaDto.antaiId;
            }
            if (queryParams.dossierCriteriaDto.classementList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.classementList'] = queryParams.dossierCriteriaDto.classementList;
            }
            if (queryParams.dossierCriteriaDto.communeEnlevementList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.communeEnlevementList'] = queryParams.dossierCriteriaDto.communeEnlevementList;
            }
            if (queryParams.dossierCriteriaDto.dateFromAbandon !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromAbandon'] = (queryParams.dossierCriteriaDto.dateFromAbandon as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromBonEnlevement !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromBonEnlevement'] = (queryParams.dossierCriteriaDto.dateFromBonEnlevement as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromMiseAJour !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromMiseAJour'] = (queryParams.dossierCriteriaDto.dateFromMiseAJour as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromMiseEnFourriere !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromMiseEnFourriere'] = (queryParams.dossierCriteriaDto.dateFromMiseEnFourriere as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromOrdreDestruction !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromOrdreDestruction'] = (queryParams.dossierCriteriaDto.dateFromOrdreDestruction as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromSortieDefinitive !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromSortieDefinitive'] = (queryParams.dossierCriteriaDto.dateFromSortieDefinitive as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToAbandon !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToAbandon'] = (queryParams.dossierCriteriaDto.dateToAbandon as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToBonEnlevement !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToBonEnlevement'] = (queryParams.dossierCriteriaDto.dateToBonEnlevement as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToMiseAJour !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToMiseAJour'] = (queryParams.dossierCriteriaDto.dateToMiseAJour as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToMiseEnFourriere !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToMiseEnFourriere'] = (queryParams.dossierCriteriaDto.dateToMiseEnFourriere as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToOrdreDestruction !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToOrdreDestruction'] = (queryParams.dossierCriteriaDto.dateToOrdreDestruction as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToSortieDefinitive !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToSortieDefinitive'] = (queryParams.dossierCriteriaDto.dateToSortieDefinitive as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.idAutoriteFourriere !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idAutoriteFourriere'] = queryParams.dossierCriteriaDto.idAutoriteFourriere;
            }
            if (queryParams.dossierCriteriaDto.idCorrelationMarque !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idCorrelationMarque'] = queryParams.dossierCriteriaDto.idCorrelationMarque;
            }
            if (queryParams.dossierCriteriaDto.idCorrelationModele !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idCorrelationModele'] = queryParams.dossierCriteriaDto.idCorrelationModele;
            }
            if (queryParams.dossierCriteriaDto.idFourriereList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idFourriereList'] = queryParams.dossierCriteriaDto.idFourriereList;
            }
            if (queryParams.dossierCriteriaDto.idJuridiction !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idJuridiction'] = queryParams.dossierCriteriaDto.idJuridiction;
            }
            if (queryParams.dossierCriteriaDto.idJuridictionList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idJuridictionList'] = queryParams.dossierCriteriaDto.idJuridictionList;
            }
            if (queryParams.dossierCriteriaDto.idMotifSortieList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idMotifSortieList'] = queryParams.dossierCriteriaDto.idMotifSortieList;
            }
            if (queryParams.dossierCriteriaDto.idNatureBrancheList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idNatureBrancheList'] = queryParams.dossierCriteriaDto.idNatureBrancheList;
            }
            if (queryParams.dossierCriteriaDto.idUniteFO !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idUniteFO'] = queryParams.dossierCriteriaDto.idUniteFO;
            }
            if (queryParams.dossierCriteriaDto.idUniteFOList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idUniteFOList'] = queryParams.dossierCriteriaDto.idUniteFOList;
            }
            if (queryParams.dossierCriteriaDto.includeDossiersAnonymises !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.includeDossiersAnonymises'] = queryParams.dossierCriteriaDto.includeDossiersAnonymises;
            }
            if (queryParams.dossierCriteriaDto.includeDossiersSortis !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.includeDossiersSortis'] = queryParams.dossierCriteriaDto.includeDossiersSortis;
            }
            if (queryParams.dossierCriteriaDto.isDetruitApresSortie !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.isDetruitApresSortie'] = queryParams.dossierCriteriaDto.isDetruitApresSortie;
            }
            if (queryParams.dossierCriteriaDto.isMarqueNonReference !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.isMarqueNonReference'] = queryParams.dossierCriteriaDto.isMarqueNonReference;
            }
            if (queryParams.dossierCriteriaDto.isModeleNonReference !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.isModeleNonReference'] = queryParams.dossierCriteriaDto.isModeleNonReference;
            }
            if (queryParams.dossierCriteriaDto.numeroImmatriculation !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.numeroImmatriculation'] = queryParams.dossierCriteriaDto.numeroImmatriculation;
            }
            if (queryParams.dossierCriteriaDto.numeroRecherche !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.numeroRecherche'] = queryParams.dossierCriteriaDto.numeroRecherche;
            }
            if (queryParams.dossierCriteriaDto.statutDossierEnumList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.statutDossierEnumList'] = queryParams.dossierCriteriaDto.statutDossierEnumList;
            }
            if (queryParams.dossierCriteriaDto.statutsFacturation !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.statutsFacturation'] = queryParams.dossierCriteriaDto.statutsFacturation;
            }

            if (queryParams.dossierSortDto.alertesIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.alertesIsAsc'] = queryParams.dossierSortDto.alertesIsAsc;
            }
            if (queryParams.dossierSortDto.classementIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.classementIsAsc'] = queryParams.dossierSortDto.classementIsAsc;
            }
            if (queryParams.dossierSortDto.couleurIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.couleurIsAsc'] = queryParams.dossierSortDto.couleurIsAsc;
            }
            if (queryParams.dossierSortDto.dateAbandonIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateAbandonIsAsc'] = queryParams.dossierSortDto.dateAbandonIsAsc;
            }
            if (queryParams.dossierSortDto.dateBonEnlevementIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateBonEnlevementIsAsc'] = queryParams.dossierSortDto.dateBonEnlevementIsAsc;
            }
            if (queryParams.dossierSortDto.dateMiseAJourIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateMiseAJourIsAsc'] = queryParams.dossierSortDto.dateMiseAJourIsAsc;
            }
            if (queryParams.dossierSortDto.dateMiseFourriereIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateMiseFourriereIsAsc'] = queryParams.dossierSortDto.dateMiseFourriereIsAsc;
            }
            if (queryParams.dossierSortDto.dateOrdreDestructionIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateOrdreDestructionIsAsc'] = queryParams.dossierSortDto.dateOrdreDestructionIsAsc;
            }
            if (queryParams.dossierSortDto.dateSortieDefinitiveIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateSortieDefinitiveIsAsc'] = queryParams.dossierSortDto.dateSortieDefinitiveIsAsc;
            }
            if (queryParams.dossierSortDto.fourriereIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.fourriereIsAsc'] = queryParams.dossierSortDto.fourriereIsAsc;
            }
            if (queryParams.dossierSortDto.immatriculationIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.immatriculationIsAsc'] = queryParams.dossierSortDto.immatriculationIsAsc;
            }
            if (queryParams.dossierSortDto.marqueIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.marqueIsAsc'] = queryParams.dossierSortDto.marqueIsAsc;
            }
            if (queryParams.dossierSortDto.modeleIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.modeleIsAsc'] = queryParams.dossierSortDto.modeleIsAsc;
            }
            if (queryParams.dossierSortDto.natureMiseEnFourriereIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.natureMiseEnFourriereIsAsc'] = queryParams.dossierSortDto.natureMiseEnFourriereIsAsc;
            }
            if (queryParams.dossierSortDto.statutIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.statutIsAsc'] = queryParams.dossierSortDto.statutIsAsc;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DossierControllerApi - functional programming interface
 * @export
 */
export const DossierControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route pour compter des dossiers avec possibilité de filtres
         * @param {countDossierSummariesUsingGETQueryParams} queryParams objet contenant les query params de la route countDossierSummariesUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDossierSummariesUsingGET(queryParams: CountDossierSummariesUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CountDossiersResultDto> {
            const localVarFetchArgs = DossierControllerApiFetchParamCreator(configuration).countDossierSummariesUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de télécharger un des documents disponibles d\'un dossier
         * @param {'DECISION_CLASSEMENT' | 'DECISION_DESTRUCTION' | 'CONSTAT_ABANDON' | 'DECISION_REMISE_DOMAINE' | 'BON_ENLEVEMENT_DESTRUCTION' | 'FICHE_DESCRIPTIVE' | 'PRESCRIPTION_MEF' | 'MAIN_LEVEE_FO' | 'MAIN_LEVEE_USAGER' | 'COURRIER_NOTIFICATION' | 'AR_PND_NOTIFICATION'} document Document représenté par un enum.
         * @param {string} id Id du dossier, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentUsingGET(document: 'DECISION_CLASSEMENT' | 'DECISION_DESTRUCTION' | 'CONSTAT_ABANDON' | 'DECISION_REMISE_DOMAINE' | 'BON_ENLEVEMENT_DESTRUCTION' | 'FICHE_DESCRIPTIVE' | 'PRESCRIPTION_MEF' | 'MAIN_LEVEE_FO' | 'MAIN_LEVEE_USAGER' | 'COURRIER_NOTIFICATION' | 'AR_PND_NOTIFICATION', id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DossierControllerApiFetchParamCreator(configuration).downloadDocumentUsingGET(document, id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'obtenir la liste des actions requises sur un dossier, activées à partir du profil.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionsRequisesByProfileUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ActionsRequisesDto> {
            const localVarFetchArgs = DossierControllerApiFetchParamCreator(configuration).getActionsRequisesByProfileUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'accéder aux données d\'un dossier.
         * @param {string} id Id du dossier, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = DossierControllerApiFetchParamCreator(configuration).getByIdUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'accéder aux données sur le propriétaire associé à un dossier.
         * @param {string} id Id du dossier, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfosProprietaireCourantByIdUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProprietaireCourantDto> {
            const localVarFetchArgs = DossierControllerApiFetchParamCreator(configuration).getInfosProprietaireCourantByIdUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'obtenir les ids de corrélation des motifs de sortie pour lesquels le gardien de fourrière doit valider que le code sur la main levée correspond à celui généré par le SIF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotifsSortieRequiringCodeMLCheckUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MotifsSortieRequiringCustomCheckDto> {
            const localVarFetchArgs = DossierControllerApiFetchParamCreator(configuration).getMotifsSortieRequiringCodeMLCheckUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'obtenir les ids de corrélation des motifs de sortie pour lesquels le gardien de fourrière doit valider que les informations du propriétaire sont cohérentes avec celles retournées par la route \"/api/dossier/sortie/{id}/proprietaires/infos\".
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotifsSortieRequiringProprietaireInfoCheckUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MotifsSortieRequiringCustomCheckDto> {
            const localVarFetchArgs = DossierControllerApiFetchParamCreator(configuration).getMotifsSortieRequiringProprietaireInfoCheckUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer le suivi de mise en fourriere d\'un dossier.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuiviMefUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SummaryEventDto>> {
            const localVarFetchArgs = DossierControllerApiFetchParamCreator(configuration).getSuiviMefUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route de recherche des dossiers avec possibilité de filtres et de pagination de la requête, seulement une partie des informations des dossiers est renvoyée
         * @param {searchDossierSummariesUsingGETQueryParams} queryParams objet contenant les query params de la route searchDossierSummariesUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDossierSummariesUsingGET(queryParams: SearchDossierSummariesUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchDossiersResponseDto> {
            const localVarFetchArgs = DossierControllerApiFetchParamCreator(configuration).searchDossierSummariesUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DossierControllerApi - object-oriented interface
 * @export
 * @class DossierControllerApi
 * @extends {BaseAPI}
 */
export class DossierControllerApi extends BaseAPI {
    /**
     * @summary Route pour compter des dossiers avec possibilité de filtres
     * @param {countDossierSummariesUsingGETQueryParams} queryParams objet contenant les query params de la route countDossierSummariesUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public countDossierSummariesUsingGET(queryParams: CountDossierSummariesUsingGETQueryParams, options?: any) {
        return DossierControllerApiFp(this.configuration).countDossierSummariesUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de télécharger un des documents disponibles d\'un dossier
     * @param {'DECISION_CLASSEMENT' | 'DECISION_DESTRUCTION' | 'CONSTAT_ABANDON' | 'DECISION_REMISE_DOMAINE' | 'BON_ENLEVEMENT_DESTRUCTION' | 'FICHE_DESCRIPTIVE' | 'PRESCRIPTION_MEF' | 'MAIN_LEVEE_FO' | 'MAIN_LEVEE_USAGER' | 'COURRIER_NOTIFICATION' | 'AR_PND_NOTIFICATION'} document Document représenté par un enum.
     * @param {string} id Id du dossier, représenté par son UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadDocumentUsingGET(document: 'DECISION_CLASSEMENT' | 'DECISION_DESTRUCTION' | 'CONSTAT_ABANDON' | 'DECISION_REMISE_DOMAINE' | 'BON_ENLEVEMENT_DESTRUCTION' | 'FICHE_DESCRIPTIVE' | 'PRESCRIPTION_MEF' | 'MAIN_LEVEE_FO' | 'MAIN_LEVEE_USAGER' | 'COURRIER_NOTIFICATION' | 'AR_PND_NOTIFICATION', id: string, options?: any) {
        return DossierControllerApiFp(this.configuration).downloadDocumentUsingGET(document, id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'obtenir la liste des actions requises sur un dossier, activées à partir du profil.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getActionsRequisesByProfileUsingGET(options?: any) {
        return DossierControllerApiFp(this.configuration).getActionsRequisesByProfileUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'accéder aux données d\'un dossier.
     * @param {string} id Id du dossier, représenté par son UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByIdUsingGET(id: string, options?: any) {
        return DossierControllerApiFp(this.configuration).getByIdUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'accéder aux données sur le propriétaire associé à un dossier.
     * @param {string} id Id du dossier, représenté par son UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInfosProprietaireCourantByIdUsingGET(id: string, options?: any) {
        return DossierControllerApiFp(this.configuration).getInfosProprietaireCourantByIdUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'obtenir les ids de corrélation des motifs de sortie pour lesquels le gardien de fourrière doit valider que le code sur la main levée correspond à celui généré par le SIF.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMotifsSortieRequiringCodeMLCheckUsingGET(options?: any) {
        return DossierControllerApiFp(this.configuration).getMotifsSortieRequiringCodeMLCheckUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'obtenir les ids de corrélation des motifs de sortie pour lesquels le gardien de fourrière doit valider que les informations du propriétaire sont cohérentes avec celles retournées par la route \"/api/dossier/sortie/{id}/proprietaires/infos\".
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMotifsSortieRequiringProprietaireInfoCheckUsingGET(options?: any) {
        return DossierControllerApiFp(this.configuration).getMotifsSortieRequiringProprietaireInfoCheckUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer le suivi de mise en fourriere d\'un dossier.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSuiviMefUsingGET(id: string, options?: any) {
        return DossierControllerApiFp(this.configuration).getSuiviMefUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route de recherche des dossiers avec possibilité de filtres et de pagination de la requête, seulement une partie des informations des dossiers est renvoyée
     * @param {searchDossierSummariesUsingGETQueryParams} queryParams objet contenant les query params de la route searchDossierSummariesUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchDossierSummariesUsingGET(queryParams: SearchDossierSummariesUsingGETQueryParams, options?: any) {
        return DossierControllerApiFp(this.configuration).searchDossierSummariesUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// ExportControllerApi /////////////////////////////////////////////////////

/**
 * objet contenant les query params de la route exportDashboardUsingGET
 * @export
 * @interface ExportDashboardUsingGETQueryParams
 */
export interface ExportDashboardUsingGETQueryParams {
    /**
     * objet contenant les dossierCriteriaDto de ExportDashboardUsingGETQueryParams
     * @type {ExportDashboardUsingGETQueryParamsDossierCriteriaDto}
     * @memberof ExportDashboardUsingGETQueryParams
     */
    dossierCriteriaDto: ExportDashboardUsingGETQueryParamsDossierCriteriaDto;
    /**
     * objet contenant les dossierSortDto de ExportDashboardUsingGETQueryParams
     * @type {ExportDashboardUsingGETQueryParamsDossierSortDto}
     * @memberof ExportDashboardUsingGETQueryParams
     */
    dossierSortDto: ExportDashboardUsingGETQueryParamsDossierSortDto;
    /**
     * 
     * @type {number}
     * @memberof ExportDashboardUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExportDashboardUsingGETQueryParams
     */
    pageSize?: number;
}

export interface ExportDashboardUsingGETQueryParamsDossierCriteriaDto {
    /**
    * 
    * @type {Array<'PROLONGER_MEF' | 'MODIFIER_COORDONNEES_PROPRIETAIRE' | 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' | 'RENSEIGNER_SORTIE_VEHICULE' | 'SAISIE_VHU' | 'SAISIE_NOTIFICATION_MANUELLE' | 'MAIN_LEVEE' | 'TRAITE_EN_FACTURATION' | 'NON_TRAITE_EN_FACTURATION' | 'ANNULATION_SORTIE_VEHICULE' | 'EXPORT_DONNEES_DOSSIER' | 'SUPPRESSION_DOSSIER' | 'SUPPRESSION_DOSSIER_BY_FO' | 'UPDATE_ENTITES_RATTACHEMENT_ADMIN' | 'UPDATE_ENTITES_RATTACHEMENT_FO_AF' | 'MODIFICATION_SORTIE_VEHICULE' | 'UPDATE_DONNEES_VEHICULE' | 'UPDATE_DONNEES_VEHICULE_JUSTICE' | 'UPDATE_CLASSEMENT' | 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' | 'ENREGISTRER_ENTREE' | 'CONTROLER_DONNEES_VEHICULE' | 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' | 'RELANCE_VENTE_VOL' | 'RELANCE_VENTE_IMMO_PJ' | 'RELANCE_VENTE_OPPOSITION' | 'RELANCE_VENTE_DOUBLON' | 'RELANCE_VENTE_MANQUANT' | 'RECUPERATION_AR_PND_AUTOMATIQUE' | 'CONTROLE_BLOCAGE_ARGOS' | 'CONTROLE_BLOCAGE_ANTAI' | 'CONTROLE_BLOCAGE_DNID' | 'RECUPERATION_COURRIER_AUTOMATIQUE' | 'RENSEIGNER_INFORMATIONS_SIV' | 'CONFIRMER_VOL_VVNR' | 'VALIDATION_ACTIONS_VVNR_HORS_SIF' | 'IMPORTER_PIECES_JOINTES' | 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' | 'UPDATE_DONNEES_JUDICIAIRE'> | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    actionsRequises?: Array<'PROLONGER_MEF' | 'MODIFIER_COORDONNEES_PROPRIETAIRE' | 'CORRIGER_DONNEES_NOTIFICATION_MANUELLE' | 'RENSEIGNER_SORTIE_VEHICULE' | 'SAISIE_VHU' | 'SAISIE_NOTIFICATION_MANUELLE' | 'MAIN_LEVEE' | 'TRAITE_EN_FACTURATION' | 'NON_TRAITE_EN_FACTURATION' | 'ANNULATION_SORTIE_VEHICULE' | 'EXPORT_DONNEES_DOSSIER' | 'SUPPRESSION_DOSSIER' | 'SUPPRESSION_DOSSIER_BY_FO' | 'UPDATE_ENTITES_RATTACHEMENT_ADMIN' | 'UPDATE_ENTITES_RATTACHEMENT_FO_AF' | 'MODIFICATION_SORTIE_VEHICULE' | 'UPDATE_DONNEES_VEHICULE' | 'UPDATE_DONNEES_VEHICULE_JUSTICE' | 'UPDATE_CLASSEMENT' | 'RENSEIGNER_STATUT_RETOUR_NOTIFICATION_MANUELLE' | 'ENREGISTRER_ENTREE' | 'CONTROLER_DONNEES_VEHICULE' | 'CONTROLE_DONNEES_ERREUR_IDENTIFICATION_VEHICULE' | 'RELANCE_VENTE_VOL' | 'RELANCE_VENTE_IMMO_PJ' | 'RELANCE_VENTE_OPPOSITION' | 'RELANCE_VENTE_DOUBLON' | 'RELANCE_VENTE_MANQUANT' | 'RECUPERATION_AR_PND_AUTOMATIQUE' | 'CONTROLE_BLOCAGE_ARGOS' | 'CONTROLE_BLOCAGE_ANTAI' | 'CONTROLE_BLOCAGE_DNID' | 'RECUPERATION_COURRIER_AUTOMATIQUE' | 'RENSEIGNER_INFORMATIONS_SIV' | 'CONFIRMER_VOL_VVNR' | 'VALIDATION_ACTIONS_VVNR_HORS_SIF' | 'IMPORTER_PIECES_JOINTES' | 'CONFIRMER_NON_IDENTIFIABILITE_PROPRIETAIRE' | 'UPDATE_DONNEES_JUDICIAIRE'>;
    /**
    * 
    * @type {string | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    antaiId?: string;
    /**
    * 
    * @type {Array<'ALIENATION' | 'DESTRUCTION' | 'MANUEL'> | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    classementList?: Array<'ALIENATION' | 'DESTRUCTION' | 'MANUEL'>;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    communeEnlevementList?: Array<string>;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromAbandon?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromBonEnlevement?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromMiseAJour?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromMiseEnFourriere?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromOrdreDestruction?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateFromSortieDefinitive?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateToAbandon?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateToBonEnlevement?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateToMiseAJour?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateToMiseEnFourriere?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateToOrdreDestruction?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    dateToSortieDefinitive?: Date;
    /**
    * 
    * @type {string | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    idAutoriteFourriere?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    idCorrelationMarque?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    idCorrelationModele?: string;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    idFourriereList?: Array<string>;
    /**
    * 
    * @type {string | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    idJuridiction?: string;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    idJuridictionList?: Array<string>;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    idMotifSortieList?: Array<string>;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    idNatureBrancheList?: Array<string>;
    /**
    * 
    * @type {string | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    idUniteFO?: string;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    idUniteFOList?: Array<string>;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    includeDossiersAnonymises?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    includeDossiersSortis?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    isDetruitApresSortie?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    isMarqueNonReference?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    isModeleNonReference?: boolean;
    /**
    * Utiliser \'numeroRecherche\' à la place (prioritaire)
    * @type {string | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    numeroImmatriculation?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    numeroRecherche?: string;
    /**
    * 
    * @type {Array<'A_REMPLIR' | 'ENREGISTRE' | 'NON_GERE' | 'NOTIFICATION_ENVOYEE' | 'NOTIFIE' | 'A_NOTIFIER' | 'EN_COURS_DE_NOTIFICATION' | 'A_REMETTRE_AUX_DOMAINES' | 'REMIS_AU_DOMAINE' | 'MIS_EN_VENTE' | 'VENDU' | 'A_RESTITUER' | 'VENTE_BLOQUEE' | 'A_DETRUIRE' | 'SORTI' | 'DETRUIT'> | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    statutDossierEnumList?: Array<'A_REMPLIR' | 'ENREGISTRE' | 'NON_GERE' | 'NOTIFICATION_ENVOYEE' | 'NOTIFIE' | 'A_NOTIFIER' | 'EN_COURS_DE_NOTIFICATION' | 'A_REMETTRE_AUX_DOMAINES' | 'REMIS_AU_DOMAINE' | 'MIS_EN_VENTE' | 'VENDU' | 'A_RESTITUER' | 'VENTE_BLOQUEE' | 'A_DETRUIRE' | 'SORTI' | 'DETRUIT'>;
    /**
    * 
    * @type {Array<'TRAITE' | 'NON_TRAITE' | 'NON_CONCERNE'> | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierCriteriaDto
    */
    statutsFacturation?: Array<'TRAITE' | 'NON_TRAITE' | 'NON_CONCERNE'>;
}

export interface ExportDashboardUsingGETQueryParamsDossierSortDto {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    alertesIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    classementIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    couleurIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    dateAbandonIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    dateBonEnlevementIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    dateMiseAJourIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    dateMiseFourriereIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    dateOrdreDestructionIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    dateSortieDefinitiveIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    fourriereIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    immatriculationIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    marqueIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    modeleIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    natureMiseEnFourriereIsAsc?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof ExportDashboardUsingGETQueryParamsDossierSortDto
    */
    statutIsAsc?: boolean;
}

/**
 * ExportControllerApi - fetch parameter creator
 * @export
 */
export const ExportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de télécharger un fichier dont l\'export a précédemment été demandé.
         * @param {string} exportId Id de l\'export, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExportUsingGET(exportId: string, options: any = {}): FetchArgs {
            // verify required parameter 'exportId' is not null or undefined
            if (exportId === null || exportId === undefined) {
                throw new RequiredError('exportId','Required parameter exportId was null or undefined when calling downloadExportUsingGET.');
            }
            const localVarPath = `/api/export/download/{exportId}`
                .replace(`{${"exportId"}}`, encodeURIComponent(String(exportId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant d\'initialiser l\'export des dossiers au format CSV.
         * @param {exportDashboardUsingGETQueryParams} queryParams objet contenant les query params de la route exportDashboardUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDashboardUsingGET(queryParams: ExportDashboardUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'dossierCriteriaDto' is not null or undefined
            if (queryParams.dossierCriteriaDto === null || queryParams.dossierCriteriaDto === undefined) {
                throw new RequiredError('dossierCriteriaDto','Required parameter dossierCriteriaDto was null or undefined when calling exportDashboardUsingGET.');
            }
            // verify required parameter 'dossierSortDto' is not null or undefined
            if (queryParams.dossierSortDto === null || queryParams.dossierSortDto === undefined) {
                throw new RequiredError('dossierSortDto','Required parameter dossierSortDto was null or undefined when calling exportDashboardUsingGET.');
            }
            const localVarPath = `/api/export/dossier`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.dossierCriteriaDto.actionsRequises !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.actionsRequises'] = queryParams.dossierCriteriaDto.actionsRequises;
            }
            if (queryParams.dossierCriteriaDto.antaiId !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.antaiId'] = queryParams.dossierCriteriaDto.antaiId;
            }
            if (queryParams.dossierCriteriaDto.classementList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.classementList'] = queryParams.dossierCriteriaDto.classementList;
            }
            if (queryParams.dossierCriteriaDto.communeEnlevementList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.communeEnlevementList'] = queryParams.dossierCriteriaDto.communeEnlevementList;
            }
            if (queryParams.dossierCriteriaDto.dateFromAbandon !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromAbandon'] = (queryParams.dossierCriteriaDto.dateFromAbandon as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromBonEnlevement !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromBonEnlevement'] = (queryParams.dossierCriteriaDto.dateFromBonEnlevement as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromMiseAJour !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromMiseAJour'] = (queryParams.dossierCriteriaDto.dateFromMiseAJour as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromMiseEnFourriere !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromMiseEnFourriere'] = (queryParams.dossierCriteriaDto.dateFromMiseEnFourriere as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromOrdreDestruction !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromOrdreDestruction'] = (queryParams.dossierCriteriaDto.dateFromOrdreDestruction as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateFromSortieDefinitive !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateFromSortieDefinitive'] = (queryParams.dossierCriteriaDto.dateFromSortieDefinitive as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToAbandon !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToAbandon'] = (queryParams.dossierCriteriaDto.dateToAbandon as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToBonEnlevement !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToBonEnlevement'] = (queryParams.dossierCriteriaDto.dateToBonEnlevement as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToMiseAJour !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToMiseAJour'] = (queryParams.dossierCriteriaDto.dateToMiseAJour as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToMiseEnFourriere !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToMiseEnFourriere'] = (queryParams.dossierCriteriaDto.dateToMiseEnFourriere as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToOrdreDestruction !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToOrdreDestruction'] = (queryParams.dossierCriteriaDto.dateToOrdreDestruction as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.dateToSortieDefinitive !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.dateToSortieDefinitive'] = (queryParams.dossierCriteriaDto.dateToSortieDefinitive as any).toISOString();
            }
            if (queryParams.dossierCriteriaDto.idAutoriteFourriere !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idAutoriteFourriere'] = queryParams.dossierCriteriaDto.idAutoriteFourriere;
            }
            if (queryParams.dossierCriteriaDto.idCorrelationMarque !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idCorrelationMarque'] = queryParams.dossierCriteriaDto.idCorrelationMarque;
            }
            if (queryParams.dossierCriteriaDto.idCorrelationModele !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idCorrelationModele'] = queryParams.dossierCriteriaDto.idCorrelationModele;
            }
            if (queryParams.dossierCriteriaDto.idFourriereList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idFourriereList'] = queryParams.dossierCriteriaDto.idFourriereList;
            }
            if (queryParams.dossierCriteriaDto.idJuridiction !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idJuridiction'] = queryParams.dossierCriteriaDto.idJuridiction;
            }
            if (queryParams.dossierCriteriaDto.idJuridictionList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idJuridictionList'] = queryParams.dossierCriteriaDto.idJuridictionList;
            }
            if (queryParams.dossierCriteriaDto.idMotifSortieList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idMotifSortieList'] = queryParams.dossierCriteriaDto.idMotifSortieList;
            }
            if (queryParams.dossierCriteriaDto.idNatureBrancheList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idNatureBrancheList'] = queryParams.dossierCriteriaDto.idNatureBrancheList;
            }
            if (queryParams.dossierCriteriaDto.idUniteFO !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idUniteFO'] = queryParams.dossierCriteriaDto.idUniteFO;
            }
            if (queryParams.dossierCriteriaDto.idUniteFOList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.idUniteFOList'] = queryParams.dossierCriteriaDto.idUniteFOList;
            }
            if (queryParams.dossierCriteriaDto.includeDossiersAnonymises !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.includeDossiersAnonymises'] = queryParams.dossierCriteriaDto.includeDossiersAnonymises;
            }
            if (queryParams.dossierCriteriaDto.includeDossiersSortis !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.includeDossiersSortis'] = queryParams.dossierCriteriaDto.includeDossiersSortis;
            }
            if (queryParams.dossierCriteriaDto.isDetruitApresSortie !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.isDetruitApresSortie'] = queryParams.dossierCriteriaDto.isDetruitApresSortie;
            }
            if (queryParams.dossierCriteriaDto.isMarqueNonReference !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.isMarqueNonReference'] = queryParams.dossierCriteriaDto.isMarqueNonReference;
            }
            if (queryParams.dossierCriteriaDto.isModeleNonReference !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.isModeleNonReference'] = queryParams.dossierCriteriaDto.isModeleNonReference;
            }
            if (queryParams.dossierCriteriaDto.numeroImmatriculation !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.numeroImmatriculation'] = queryParams.dossierCriteriaDto.numeroImmatriculation;
            }
            if (queryParams.dossierCriteriaDto.numeroRecherche !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.numeroRecherche'] = queryParams.dossierCriteriaDto.numeroRecherche;
            }
            if (queryParams.dossierCriteriaDto.statutDossierEnumList !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.statutDossierEnumList'] = queryParams.dossierCriteriaDto.statutDossierEnumList;
            }
            if (queryParams.dossierCriteriaDto.statutsFacturation !== undefined) {
                localVarQueryParameter['dossierCriteriaDto.statutsFacturation'] = queryParams.dossierCriteriaDto.statutsFacturation;
            }

            if (queryParams.dossierSortDto.alertesIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.alertesIsAsc'] = queryParams.dossierSortDto.alertesIsAsc;
            }
            if (queryParams.dossierSortDto.classementIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.classementIsAsc'] = queryParams.dossierSortDto.classementIsAsc;
            }
            if (queryParams.dossierSortDto.couleurIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.couleurIsAsc'] = queryParams.dossierSortDto.couleurIsAsc;
            }
            if (queryParams.dossierSortDto.dateAbandonIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateAbandonIsAsc'] = queryParams.dossierSortDto.dateAbandonIsAsc;
            }
            if (queryParams.dossierSortDto.dateBonEnlevementIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateBonEnlevementIsAsc'] = queryParams.dossierSortDto.dateBonEnlevementIsAsc;
            }
            if (queryParams.dossierSortDto.dateMiseAJourIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateMiseAJourIsAsc'] = queryParams.dossierSortDto.dateMiseAJourIsAsc;
            }
            if (queryParams.dossierSortDto.dateMiseFourriereIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateMiseFourriereIsAsc'] = queryParams.dossierSortDto.dateMiseFourriereIsAsc;
            }
            if (queryParams.dossierSortDto.dateOrdreDestructionIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateOrdreDestructionIsAsc'] = queryParams.dossierSortDto.dateOrdreDestructionIsAsc;
            }
            if (queryParams.dossierSortDto.dateSortieDefinitiveIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.dateSortieDefinitiveIsAsc'] = queryParams.dossierSortDto.dateSortieDefinitiveIsAsc;
            }
            if (queryParams.dossierSortDto.fourriereIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.fourriereIsAsc'] = queryParams.dossierSortDto.fourriereIsAsc;
            }
            if (queryParams.dossierSortDto.immatriculationIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.immatriculationIsAsc'] = queryParams.dossierSortDto.immatriculationIsAsc;
            }
            if (queryParams.dossierSortDto.marqueIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.marqueIsAsc'] = queryParams.dossierSortDto.marqueIsAsc;
            }
            if (queryParams.dossierSortDto.modeleIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.modeleIsAsc'] = queryParams.dossierSortDto.modeleIsAsc;
            }
            if (queryParams.dossierSortDto.natureMiseEnFourriereIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.natureMiseEnFourriereIsAsc'] = queryParams.dossierSortDto.natureMiseEnFourriereIsAsc;
            }
            if (queryParams.dossierSortDto.statutIsAsc !== undefined) {
                localVarQueryParameter['dossierSortDto.statutIsAsc'] = queryParams.dossierSortDto.statutIsAsc;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer la liste des demandes d\'export.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExportFilesUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/export`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportControllerApi - functional programming interface
 * @export
 */
export const ExportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de télécharger un fichier dont l\'export a précédemment été demandé.
         * @param {string} exportId Id de l\'export, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExportUsingGET(exportId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ExportControllerApiFetchParamCreator(configuration).downloadExportUsingGET(exportId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant d\'initialiser l\'export des dossiers au format CSV.
         * @param {exportDashboardUsingGETQueryParams} queryParams objet contenant les query params de la route exportDashboardUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDashboardUsingGET(queryParams: ExportDashboardUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CreateExportResponseDto> {
            const localVarFetchArgs = ExportControllerApiFetchParamCreator(configuration).exportDashboardUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer la liste des demandes d\'export.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExportFilesUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ExportFilesDto>> {
            const localVarFetchArgs = ExportControllerApiFetchParamCreator(configuration).searchExportFilesUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ExportControllerApi - object-oriented interface
 * @export
 * @class ExportControllerApi
 * @extends {BaseAPI}
 */
export class ExportControllerApi extends BaseAPI {
    /**
     * @summary Route permettant de télécharger un fichier dont l\'export a précédemment été demandé.
     * @param {string} exportId Id de l\'export, représenté par son UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadExportUsingGET(exportId: string, options?: any) {
        return ExportControllerApiFp(this.configuration).downloadExportUsingGET(exportId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant d\'initialiser l\'export des dossiers au format CSV.
     * @param {exportDashboardUsingGETQueryParams} queryParams objet contenant les query params de la route exportDashboardUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportDashboardUsingGET(queryParams: ExportDashboardUsingGETQueryParams, options?: any) {
        return ExportControllerApiFp(this.configuration).exportDashboardUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer la liste des demandes d\'export.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchExportFilesUsingGET(options?: any) {
        return ExportControllerApiFp(this.configuration).searchExportFilesUsingGET(options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// FicheDescriptiveControllerApi /////////////////////////////////////////////////////

/**
 * FicheDescriptiveControllerApi - fetch parameter creator
 * @export
 */
export const FicheDescriptiveControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de télécharger la fiche descriptive d\'un véhicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFicheDescriptiveUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/fiche-descriptive/download`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FicheDescriptiveControllerApi - functional programming interface
 * @export
 */
export const FicheDescriptiveControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de télécharger la fiche descriptive d\'un véhicule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFicheDescriptiveUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = FicheDescriptiveControllerApiFetchParamCreator(configuration).downloadFicheDescriptiveUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * FicheDescriptiveControllerApi - object-oriented interface
 * @export
 * @class FicheDescriptiveControllerApi
 * @extends {BaseAPI}
 */
export class FicheDescriptiveControllerApi extends BaseAPI {
    /**
     * @summary Route permettant de télécharger la fiche descriptive d\'un véhicule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadFicheDescriptiveUsingGET(options?: any) {
        return FicheDescriptiveControllerApiFp(this.configuration).downloadFicheDescriptiveUsingGET(options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// ForceOrdreControllerApi /////////////////////////////////////////////////////

/**
 * objet contenant les query params de la route getSourceImpossibiliteNotifierFoUsingGET
 * @export
 * @interface GetSourceImpossibiliteNotifierFoUsingGETQueryParams
 */
export interface GetSourceImpossibiliteNotifierFoUsingGETQueryParams {
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    boitePostale?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    codeCedex?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    codePostal?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    complementAdresse?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    extension?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    libelleCedex?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    libelleCommune?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    libelleVoie?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    lieuDit?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    nom?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    numero?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    pays?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    pointRemise?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    prenom?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    raisonSociale?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSourceImpossibiliteNotifierFoUsingGETQueryParams
     */
    typeVoie?: string;
}

/**
 * objet contenant les query params de la route getStatusUsingGET
 * @export
 * @interface GetStatusUsingGETQueryParams
 */
export interface GetStatusUsingGETQueryParams {
    /**
     * 
     * @type {Set<string>}
     * @memberof GetStatusUsingGETQueryParams
     */
    idDossiers?: Set<string>;
}

/**
 * ForceOrdreControllerApi - fetch parameter creator
 * @export
 */
export const ForceOrdreControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary   Route effectuant un contrôle des données du véhicule   relançant la vente si aucune modification n\'est constatée   sinon en relançant l\'identification au SIV 
         * @param {string} id ID du dossier
         * @param {ControleDonneesVehiculeBlocageVenteRequestDto} controleDonneesVehiculeBlocageVenteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeControleDonneesVehiculeBlocageVenteUsingPOST(id: string, controleDonneesVehiculeBlocageVenteRequestDto: ControleDonneesVehiculeBlocageVenteRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling computeControleDonneesVehiculeBlocageVenteUsingPOST.');
            }
            // verify required parameter 'controleDonneesVehiculeBlocageVenteRequestDto' is not null or undefined
            if (controleDonneesVehiculeBlocageVenteRequestDto === null || controleDonneesVehiculeBlocageVenteRequestDto === undefined) {
                throw new RequiredError('controleDonneesVehiculeBlocageVenteRequestDto','Required parameter controleDonneesVehiculeBlocageVenteRequestDto was null or undefined when calling computeControleDonneesVehiculeBlocageVenteUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/controle-blocage-vente`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ControleDonneesVehiculeBlocageVenteRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(controleDonneesVehiculeBlocageVenteRequestDto || {}) : (controleDonneesVehiculeBlocageVenteRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de confirmer la non identifiabilité du propriétaire d\'un véhicule volé
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmNonIdentifiabiliteProprietaireUsingPOST(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling confirmNonIdentifiabiliteProprietaireUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/non-identifiabilite-proprietaire`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de confirmer le vol d\'un véhicule identifié vvnr
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmVolVvnrUsingPOST(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling confirmVolVvnrUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/vol-vvnr`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Générer un rapport BDR
         * @param {ReportRequestDto} reportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBdrReportUsingPOST(reportRequestDto: ReportRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'reportRequestDto' is not null or undefined
            if (reportRequestDto === null || reportRequestDto === undefined) {
                throw new RequiredError('reportRequestDto','Required parameter reportRequestDto was null or undefined when calling createBdrReportUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/bdr-report`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReportRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(reportRequestDto || {}) : (reportRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer l\'AR/PND depuis l\'ANTAI
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchArPndUsingPOST(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchArPndUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/notification/ar-pnd/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer le courrier de notification depuis l\'ANTAI
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCourrierUsingPOST(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchCourrierUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/notification/courrier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Récupération des données à contrôler, dans le cas où les données du véhicule ne correspondent pas aux données du siv.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDonneesAControlerUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDonneesAControlerUsingGET.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/donnees-vehicule`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de calculer les violations menant à une impossibilité de notifier
          * @param {string} id ID du dossier, représenté par un UUID
         * @param {getSourceImpossibiliteNotifierFoUsingGETQueryParams} queryParams objet contenant les query params de la route getSourceImpossibiliteNotifierFoUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceImpossibiliteNotifierFoUsingGET(id: string, queryParams: GetSourceImpossibiliteNotifierFoUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSourceImpossibiliteNotifierFoUsingGET.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/impossibilite-notifier`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.boitePostale !== undefined) {
                localVarQueryParameter['boitePostale'] = queryParams.boitePostale;
            }

            if (queryParams.codeCedex !== undefined) {
                localVarQueryParameter['codeCedex'] = queryParams.codeCedex;
            }

            if (queryParams.codePostal !== undefined) {
                localVarQueryParameter['codePostal'] = queryParams.codePostal;
            }

            if (queryParams.complementAdresse !== undefined) {
                localVarQueryParameter['complementAdresse'] = queryParams.complementAdresse;
            }

            if (queryParams.extension !== undefined) {
                localVarQueryParameter['extension'] = queryParams.extension;
            }

            if (queryParams.libelleCedex !== undefined) {
                localVarQueryParameter['libelleCedex'] = queryParams.libelleCedex;
            }

            if (queryParams.libelleCommune !== undefined) {
                localVarQueryParameter['libelleCommune'] = queryParams.libelleCommune;
            }

            if (queryParams.libelleVoie !== undefined) {
                localVarQueryParameter['libelleVoie'] = queryParams.libelleVoie;
            }

            if (queryParams.lieuDit !== undefined) {
                localVarQueryParameter['lieuDit'] = queryParams.lieuDit;
            }

            if (queryParams.nom !== undefined) {
                localVarQueryParameter['nom'] = queryParams.nom;
            }

            if (queryParams.numero !== undefined) {
                localVarQueryParameter['numero'] = queryParams.numero;
            }

            if (queryParams.pays !== undefined) {
                localVarQueryParameter['pays'] = queryParams.pays;
            }

            if (queryParams.pointRemise !== undefined) {
                localVarQueryParameter['pointRemise'] = queryParams.pointRemise;
            }

            if (queryParams.prenom !== undefined) {
                localVarQueryParameter['prenom'] = queryParams.prenom;
            }

            if (queryParams.raisonSociale !== undefined) {
                localVarQueryParameter['raisonSociale'] = queryParams.raisonSociale;
            }

            if (queryParams.typeVoie !== undefined) {
                localVarQueryParameter['typeVoie'] = queryParams.typeVoie;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route de recherche de dossiers par IDs, retourne le statut de suppression et les actions requises filtrées par profil utilisateur.
         * @param {getStatusUsingGETQueryParams} queryParams objet contenant les query params de la route getStatusUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusUsingGET(queryParams: GetStatusUsingGETQueryParams, options: any = {}): FetchArgs {
            const localVarPath = `/api/force-ordre/dossier-status`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.idDossiers) {
                localVarQueryParameter['idDossiers'] = queryParams.idDossiers;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer les PDFs de notification manuelle.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualNotificationPdfUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling manualNotificationPdfUsingGET.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/notification/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Création d\'un dossier via une fiche descriptive pour un profil force de l\'ordre
         * @param {CreateDossierFromForceOrdreDto} createDossierFromForceOrdreDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDossierWithInitialInfoUsingPOST(createDossierFromForceOrdreDto: CreateDossierFromForceOrdreDto, options: any = {}): FetchArgs {
            // verify required parameter 'createDossierFromForceOrdreDto' is not null or undefined
            if (createDossierFromForceOrdreDto === null || createDossierFromForceOrdreDto === undefined) {
                throw new RequiredError('createDossierFromForceOrdreDto','Required parameter createDossierFromForceOrdreDto was null or undefined when calling postDossierWithInitialInfoUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateDossierFromForceOrdreDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(createDossierFromForceOrdreDto || {}) : (createDossierFromForceOrdreDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route de récupération des coordonnées propriétaire d\'un dossier
         * @param {string} id Id du dossier, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCoordonneesProprietaireUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling retrieveCoordonneesProprietaireUsingGET.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/coordonnees-proprietaire`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer les informations d\'un utilisateur de profile FO.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFoUserInformationUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/force-ordre/me`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Récupération des données de la main levée d\'un dossier.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMainleveeUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling retrieveMainleveeUsingGET.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/main-levee`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Soumission du formulaire de notification manuelle
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {NotificationInfosRequestDto} notificationInfosRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitNotificationInfosUsingPOST(id: string, notificationInfosRequestDto: NotificationInfosRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling submitNotificationInfosUsingPOST.');
            }
            // verify required parameter 'notificationInfosRequestDto' is not null or undefined
            if (notificationInfosRequestDto === null || notificationInfosRequestDto === undefined) {
                throw new RequiredError('notificationInfosRequestDto','Required parameter notificationInfosRequestDto was null or undefined when calling submitNotificationInfosUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/notification-infos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NotificationInfosRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notificationInfosRequestDto || {}) : (notificationInfosRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant à un FO de supprimer un dossier créé par une de ses unités et qui n\'a pas encore été enregistré par un gardien de fourrière.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppressionDossierUsingDELETE1(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling suppressionDossierUsingDELETE1.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les données d\'un dossier, dans le cas où les données du véhicule ne correspondent pas aux données du siv.
         * @param {string} id 
         * @param {ControleDonneesVehiculeRequestDto} controleDonneesVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateControleDonneesVehiculeUsingPOST(id: string, controleDonneesVehiculeRequestDto: ControleDonneesVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateControleDonneesVehiculeUsingPOST.');
            }
            // verify required parameter 'controleDonneesVehiculeRequestDto' is not null or undefined
            if (controleDonneesVehiculeRequestDto === null || controleDonneesVehiculeRequestDto === undefined) {
                throw new RequiredError('controleDonneesVehiculeRequestDto','Required parameter controleDonneesVehiculeRequestDto was null or undefined when calling updateControleDonneesVehiculeUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/donnees-vehicule`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ControleDonneesVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(controleDonneesVehiculeRequestDto || {}) : (controleDonneesVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les coordonnees du propriétaire pour les fo
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoordonneesProprietairesFoUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCoordonneesProprietairesFoUsingPOST.');
            }
            // verify required parameter 'coordonneesProprietaireRequestDto' is not null or undefined
            if (coordonneesProprietaireRequestDto === null || coordonneesProprietaireRequestDto === undefined) {
                throw new RequiredError('coordonneesProprietaireRequestDto','Required parameter coordonneesProprietaireRequestDto was null or undefined when calling updateCoordonneesProprietairesFoUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/coordonnees-proprietaires`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CoordonneesProprietaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(coordonneesProprietaireRequestDto || {}) : (coordonneesProprietaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonneesInterieurVehiculeForNotAdminUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateDonneesInterieurVehiculeForNotAdminUsingPOST.');
            }
            // verify required parameter 'updateDonneesInterieurVehiculeRequestDto' is not null or undefined
            if (updateDonneesInterieurVehiculeRequestDto === null || updateDonneesInterieurVehiculeRequestDto === undefined) {
                throw new RequiredError('updateDonneesInterieurVehiculeRequestDto','Required parameter updateDonneesInterieurVehiculeRequestDto was null or undefined when calling updateDonneesInterieurVehiculeForNotAdminUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/vehicule`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesInterieurVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesInterieurVehiculeRequestDto || {}) : (updateDonneesInterieurVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de modifier les entitées de rattachement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntitesRattachementFOUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateEntitesRattachementFOUsingPOST.');
            }
            // verify required parameter 'updateEntitesRattachementRequestDto' is not null or undefined
            if (updateEntitesRattachementRequestDto === null || updateEntitesRattachementRequestDto === undefined) {
                throw new RequiredError('updateEntitesRattachementRequestDto','Required parameter updateEntitesRattachementRequestDto was null or undefined when calling updateEntitesRattachementFOUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/entites-rattachement/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateEntitesRattachementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateEntitesRattachementRequestDto || {}) : (updateEntitesRattachementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Soumission du formulaire d\'expéditeur de notification manuelle.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {ExpediteurNotificationRequestDto} expediteurNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpediteurNotificationUsingPOST(id: string, expediteurNotificationRequestDto: ExpediteurNotificationRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateExpediteurNotificationUsingPOST.');
            }
            // verify required parameter 'expediteurNotificationRequestDto' is not null or undefined
            if (expediteurNotificationRequestDto === null || expediteurNotificationRequestDto === undefined) {
                throw new RequiredError('expediteurNotificationRequestDto','Required parameter expediteurNotificationRequestDto was null or undefined when calling updateExpediteurNotificationUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/expediteur`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ExpediteurNotificationRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(expediteurNotificationRequestDto || {}) : (expediteurNotificationRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de mettre à jour la main levée
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {UpdateMainLeveeRequestDto} updateMainLeveeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMainLeveeUsingPOST(id: string, updateMainLeveeRequestDto: UpdateMainLeveeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateMainLeveeUsingPOST.');
            }
            // verify required parameter 'updateMainLeveeRequestDto' is not null or undefined
            if (updateMainLeveeRequestDto === null || updateMainLeveeRequestDto === undefined) {
                throw new RequiredError('updateMainLeveeRequestDto','Required parameter updateMainLeveeRequestDto was null or undefined when calling updateMainLeveeUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/main-levee`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateMainLeveeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateMainLeveeRequestDto || {}) : (updateMainLeveeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary API permettant d\'uploader une photo et les informations associées d\'un côté d\'un véhicule.
         * @param {'AVANT' | 'GAUCHE' | 'DROITE' | 'ARRIERE' | 'AUTRE'} coteVehicule côté du véhicule de la photo
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {any} file Fiche contenant la photo
         * @param {any} photoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPhotoVehiculeUsingPOST(coteVehicule: 'AVANT' | 'GAUCHE' | 'DROITE' | 'ARRIERE' | 'AUTRE', id: string, file: any, photoRequestDto: any, options: any = {}): FetchArgs {
            // verify required parameter 'coteVehicule' is not null or undefined
            if (coteVehicule === null || coteVehicule === undefined) {
                throw new RequiredError('coteVehicule','Required parameter coteVehicule was null or undefined when calling uploadPhotoVehiculeUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling uploadPhotoVehiculeUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadPhotoVehiculeUsingPOST.');
            }
            // verify required parameter 'photoRequestDto' is not null or undefined
            if (photoRequestDto === null || photoRequestDto === undefined) {
                throw new RequiredError('photoRequestDto','Required parameter photoRequestDto was null or undefined when calling uploadPhotoVehiculeUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/photo/{coteVehicule}`
                .replace(`{${"coteVehicule"}}`, encodeURIComponent(String(coteVehicule)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            if (photoRequestDto !== undefined) {
                localVarFormParams.append('photoRequestDto', photoRequestDto as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider que les actions hors SIF ont été effectuées
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateActionsHorsSifUsingPOST(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateActionsHorsSifUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/vol-vvnr/actions-hors-sif/validate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider la modification lors du contrôle des données d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {ControleDonneesVehiculeRequestDto} controleDonneesVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateControleDonneesVehiculeUsingPOST(id: string, controleDonneesVehiculeRequestDto: ControleDonneesVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateControleDonneesVehiculeUsingPOST.');
            }
            // verify required parameter 'controleDonneesVehiculeRequestDto' is not null or undefined
            if (controleDonneesVehiculeRequestDto === null || controleDonneesVehiculeRequestDto === undefined) {
                throw new RequiredError('controleDonneesVehiculeRequestDto','Required parameter controleDonneesVehiculeRequestDto was null or undefined when calling validateControleDonneesVehiculeUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/donnees-vehicule/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ControleDonneesVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(controleDonneesVehiculeRequestDto || {}) : (controleDonneesVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ du formulaire de mise à jour des Coordonnéees propriétaires.
         * @param {'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS'} field Le champ à valider, représenté par une énumération.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCoordonneesProprietairesFieldFoUsingPOST(field: 'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS', id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateCoordonneesProprietairesFieldFoUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateCoordonneesProprietairesFieldFoUsingPOST.');
            }
            // verify required parameter 'coordonneesProprietaireRequestDto' is not null or undefined
            if (coordonneesProprietaireRequestDto === null || coordonneesProprietaireRequestDto === undefined) {
                throw new RequiredError('coordonneesProprietaireRequestDto','Required parameter coordonneesProprietaireRequestDto was null or undefined when calling validateCoordonneesProprietairesFieldFoUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/coordonnees-proprietaires/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CoordonneesProprietaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(coordonneesProprietaireRequestDto || {}) : (coordonneesProprietaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider tous les champs du formulaire de mise à jour des coordonnées propriétaires pour les fo
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCoordonneesProprietairesFoUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateCoordonneesProprietairesFoUsingPOST.');
            }
            // verify required parameter 'coordonneesProprietaireRequestDto' is not null or undefined
            if (coordonneesProprietaireRequestDto === null || coordonneesProprietaireRequestDto === undefined) {
                throw new RequiredError('coordonneesProprietaireRequestDto','Required parameter coordonneesProprietaireRequestDto was null or undefined when calling validateCoordonneesProprietairesFoUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/coordonnees-proprietaires/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CoordonneesProprietaireRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(coordonneesProprietaireRequestDto || {}) : (coordonneesProprietaireRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un dossier pour une création FO via une fiche descriptive
         * @param {CreateDossierFromForceOrdreDto} createDossierFromForceOrdreDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDossierWithInitialInfoUsingPOST(createDossierFromForceOrdreDto: CreateDossierFromForceOrdreDto, options: any = {}): FetchArgs {
            // verify required parameter 'createDossierFromForceOrdreDto' is not null or undefined
            if (createDossierFromForceOrdreDto === null || createDossierFromForceOrdreDto === undefined) {
                throw new RequiredError('createDossierFromForceOrdreDto','Required parameter createDossierFromForceOrdreDto was null or undefined when calling validateDossierWithInitialInfoUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateDossierFromForceOrdreDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(createDossierFromForceOrdreDto || {}) : (createDossierFromForceOrdreDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un champ des informations de l\'expéditeur de la notification manuelle pour un dossier existant.
         * @param {'UNITE' | 'ADRESSE' | 'CODE_POSTAL' | 'COMMUNE'} field Le champ à valider, représenté par une énumération.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {ExpediteurNotificationRequestDto} expediteurNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExpediteurNotificationFieldUsingPOST(field: 'UNITE' | 'ADRESSE' | 'CODE_POSTAL' | 'COMMUNE', id: string, expediteurNotificationRequestDto: ExpediteurNotificationRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateExpediteurNotificationFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateExpediteurNotificationFieldUsingPOST.');
            }
            // verify required parameter 'expediteurNotificationRequestDto' is not null or undefined
            if (expediteurNotificationRequestDto === null || expediteurNotificationRequestDto === undefined) {
                throw new RequiredError('expediteurNotificationRequestDto','Required parameter expediteurNotificationRequestDto was null or undefined when calling validateExpediteurNotificationFieldUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/expediteur/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ExpediteurNotificationRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(expediteurNotificationRequestDto || {}) : (expediteurNotificationRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs des informations de l\'expéditeur de la notification manuelle pour un dossier existant.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {ExpediteurNotificationRequestDto} expediteurNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExpediteurNotificationUsingPOST(id: string, expediteurNotificationRequestDto: ExpediteurNotificationRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateExpediteurNotificationUsingPOST.');
            }
            // verify required parameter 'expediteurNotificationRequestDto' is not null or undefined
            if (expediteurNotificationRequestDto === null || expediteurNotificationRequestDto === undefined) {
                throw new RequiredError('expediteurNotificationRequestDto','Required parameter expediteurNotificationRequestDto was null or undefined when calling validateExpediteurNotificationUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/expediteur/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ExpediteurNotificationRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(expediteurNotificationRequestDto || {}) : (expediteurNotificationRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche agent pour un dossier non créé.
         * @param {'UNITE_FO'} field Le champ à valider, représenté par une énumération.
         * @param {FicheAgentFoRequestDto} ficheAgentFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheAgentFoFieldWithoutDossierUsingPOST(field: 'UNITE_FO', ficheAgentFoRequestDto: FicheAgentFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFicheAgentFoFieldWithoutDossierUsingPOST.');
            }
            // verify required parameter 'ficheAgentFoRequestDto' is not null or undefined
            if (ficheAgentFoRequestDto === null || ficheAgentFoRequestDto === undefined) {
                throw new RequiredError('ficheAgentFoRequestDto','Required parameter ficheAgentFoRequestDto was null or undefined when calling validateFicheAgentFoFieldWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-agent/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheAgentFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheAgentFoRequestDto || {}) : (ficheAgentFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche agent pour un dossier non créé.
         * @param {FicheAgentFoRequestDto} ficheAgentFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheAgentWithoutDossierUsingPOST(ficheAgentFoRequestDto: FicheAgentFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'ficheAgentFoRequestDto' is not null or undefined
            if (ficheAgentFoRequestDto === null || ficheAgentFoRequestDto === undefined) {
                throw new RequiredError('ficheAgentFoRequestDto','Required parameter ficheAgentFoRequestDto was null or undefined when calling validateFicheAgentWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-agent/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheAgentFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheAgentFoRequestDto || {}) : (ficheAgentFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche conditions pour un dossier non créé.
         * @param {'DATE_CONSTATATION' | 'MOTIVATION_MESURE' | 'ADRESSE' | 'COMMUNE'} field Le champ à valider, représenté par une énumération.
         * @param {FicheConditionsRequestDto} ficheConditionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheConditionsFieldWithoutDossierUsingPOST(field: 'DATE_CONSTATATION' | 'MOTIVATION_MESURE' | 'ADRESSE' | 'COMMUNE', ficheConditionsRequestDto: FicheConditionsRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFicheConditionsFieldWithoutDossierUsingPOST.');
            }
            // verify required parameter 'ficheConditionsRequestDto' is not null or undefined
            if (ficheConditionsRequestDto === null || ficheConditionsRequestDto === undefined) {
                throw new RequiredError('ficheConditionsRequestDto','Required parameter ficheConditionsRequestDto was null or undefined when calling validateFicheConditionsFieldWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-conditions/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheConditionsRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheConditionsRequestDto || {}) : (ficheConditionsRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche conditions pour un dossier non créé.
         * @param {FicheConditionsRequestDto} ficheConditionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheConditionsWithoutDossierUsingPOST(ficheConditionsRequestDto: FicheConditionsRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'ficheConditionsRequestDto' is not null or undefined
            if (ficheConditionsRequestDto === null || ficheConditionsRequestDto === undefined) {
                throw new RequiredError('ficheConditionsRequestDto','Required parameter ficheConditionsRequestDto was null or undefined when calling validateFicheConditionsWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-conditions/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheConditionsRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheConditionsRequestDto || {}) : (ficheConditionsRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche de détails véhicule pour un dossier non créé.
         * @param {'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS'} field Le champ à valider, représenté par une énumération.
         * @param {FicheDetailsVehiculeFoRequestDto} ficheDetailsVehiculeFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheDetailsVehiculeFieldWithoutDossierUsingPOST(field: 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS', ficheDetailsVehiculeFoRequestDto: FicheDetailsVehiculeFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFicheDetailsVehiculeFieldWithoutDossierUsingPOST.');
            }
            // verify required parameter 'ficheDetailsVehiculeFoRequestDto' is not null or undefined
            if (ficheDetailsVehiculeFoRequestDto === null || ficheDetailsVehiculeFoRequestDto === undefined) {
                throw new RequiredError('ficheDetailsVehiculeFoRequestDto','Required parameter ficheDetailsVehiculeFoRequestDto was null or undefined when calling validateFicheDetailsVehiculeFieldWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-details-vehicule/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheDetailsVehiculeFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheDetailsVehiculeFoRequestDto || {}) : (ficheDetailsVehiculeFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche de détails véhicule pour un dossier non créé.
         * @param {FicheDetailsVehiculeFoRequestDto} ficheDetailsVehiculeFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheDetailsVehiculeWithoutDossierUsingPOST(ficheDetailsVehiculeFoRequestDto: FicheDetailsVehiculeFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'ficheDetailsVehiculeFoRequestDto' is not null or undefined
            if (ficheDetailsVehiculeFoRequestDto === null || ficheDetailsVehiculeFoRequestDto === undefined) {
                throw new RequiredError('ficheDetailsVehiculeFoRequestDto','Required parameter ficheDetailsVehiculeFoRequestDto was null or undefined when calling validateFicheDetailsVehiculeWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-details-vehicule/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheDetailsVehiculeFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheDetailsVehiculeFoRequestDto || {}) : (ficheDetailsVehiculeFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche état général pour un dossier non créé.
         * @param {'ETAT_LIBELLE' | 'ETAT_PRECISION'} field Le champ à valider, représenté par une énumération.
         * @param {FicheEtatGeneralFoRequestDto} ficheEtatGeneralFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheEtatGeneralFieldWithoutDossierUsingPOST(field: 'ETAT_LIBELLE' | 'ETAT_PRECISION', ficheEtatGeneralFoRequestDto: FicheEtatGeneralFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFicheEtatGeneralFieldWithoutDossierUsingPOST.');
            }
            // verify required parameter 'ficheEtatGeneralFoRequestDto' is not null or undefined
            if (ficheEtatGeneralFoRequestDto === null || ficheEtatGeneralFoRequestDto === undefined) {
                throw new RequiredError('ficheEtatGeneralFoRequestDto','Required parameter ficheEtatGeneralFoRequestDto was null or undefined when calling validateFicheEtatGeneralFieldWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-etat-general/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheEtatGeneralFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheEtatGeneralFoRequestDto || {}) : (ficheEtatGeneralFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche etat général pour un dossier non créé.
         * @param {FicheEtatGeneralFoRequestDto} ficheEtatGeneralFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheEtatGeneralWithoutDossierUsingPOST(ficheEtatGeneralFoRequestDto: FicheEtatGeneralFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'ficheEtatGeneralFoRequestDto' is not null or undefined
            if (ficheEtatGeneralFoRequestDto === null || ficheEtatGeneralFoRequestDto === undefined) {
                throw new RequiredError('ficheEtatGeneralFoRequestDto','Required parameter ficheEtatGeneralFoRequestDto was null or undefined when calling validateFicheEtatGeneralWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-etat-general/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheEtatGeneralFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheEtatGeneralFoRequestDto || {}) : (ficheEtatGeneralFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un champ de la fiche fourrière pour un dossier non créé.
         * @param {'FOURRIERE' | 'AUTORITE_FOURRIERE' | 'AUTORITE_QUALIFIEE'} field Le champ à valider, représenté par une énumération.
         * @param {FicheFourriereFoRequestDto} ficheFourriereFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheFourriereFieldWithoutDossierUsingPOST1(field: 'FOURRIERE' | 'AUTORITE_FOURRIERE' | 'AUTORITE_QUALIFIEE', ficheFourriereFoRequestDto: FicheFourriereFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFicheFourriereFieldWithoutDossierUsingPOST1.');
            }
            // verify required parameter 'ficheFourriereFoRequestDto' is not null or undefined
            if (ficheFourriereFoRequestDto === null || ficheFourriereFoRequestDto === undefined) {
                throw new RequiredError('ficheFourriereFoRequestDto','Required parameter ficheFourriereFoRequestDto was null or undefined when calling validateFicheFourriereFieldWithoutDossierUsingPOST1.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-fourriere/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheFourriereFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheFourriereFoRequestDto || {}) : (ficheFourriereFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche fourrière pour un dossier non créé.
         * @param {FicheFourriereFoRequestDto} ficheFourriereFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheFourriereWithoutDossierUsingPOST1(ficheFourriereFoRequestDto: FicheFourriereFoRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'ficheFourriereFoRequestDto' is not null or undefined
            if (ficheFourriereFoRequestDto === null || ficheFourriereFoRequestDto === undefined) {
                throw new RequiredError('ficheFourriereFoRequestDto','Required parameter ficheFourriereFoRequestDto was null or undefined when calling validateFicheFourriereWithoutDossierUsingPOST1.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-fourriere/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheFourriereFoRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheFourriereFoRequestDto || {}) : (ficheFourriereFoRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche véhicule pour un dossier non créé.
         * @param {'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'TYPE_PLAQUE' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS'} field Le champ à valider, représenté par une énumération.
         * @param {FicheVehiculeFoValidationDto} ficheVehiculeFoValidationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheVehiculeFieldWithoutDossierUsingPOST1(field: 'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'TYPE_PLAQUE' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS', ficheVehiculeFoValidationDto: FicheVehiculeFoValidationDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFicheVehiculeFieldWithoutDossierUsingPOST1.');
            }
            // verify required parameter 'ficheVehiculeFoValidationDto' is not null or undefined
            if (ficheVehiculeFoValidationDto === null || ficheVehiculeFoValidationDto === undefined) {
                throw new RequiredError('ficheVehiculeFoValidationDto','Required parameter ficheVehiculeFoValidationDto was null or undefined when calling validateFicheVehiculeFieldWithoutDossierUsingPOST1.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-vehicule/v2/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheVehiculeFoValidationDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheVehiculeFoValidationDto || {}) : (ficheVehiculeFoValidationDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche véhicule pour un dossier non créé.
         * @param {FicheVehiculeFoValidationDto} ficheVehiculeFoValidationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheVehiculeWithoutDossierUsingPOST1(ficheVehiculeFoValidationDto: FicheVehiculeFoValidationDto, options: any = {}): FetchArgs {
            // verify required parameter 'ficheVehiculeFoValidationDto' is not null or undefined
            if (ficheVehiculeFoValidationDto === null || ficheVehiculeFoValidationDto === undefined) {
                throw new RequiredError('ficheVehiculeFoValidationDto','Required parameter ficheVehiculeFoValidationDto was null or undefined when calling validateFicheVehiculeWithoutDossierUsingPOST1.');
            }
            const localVarPath = `/api/force-ordre/dossier/fiche-vehicule/v2/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheVehiculeFoValidationDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheVehiculeFoValidationDto || {}) : (ficheVehiculeFoValidationDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider la modification d\'un champ lors du contrôle des données d\'un dossier
         * @param {'NEW_MARQUE' | 'NEW_MODELE' | 'NEW_GENRE' | 'NEW_PAYS_ETRANGER' | 'NEW_SANS_PLAQUE' | 'NEW_PLAQUE' | 'NEW_PLAQUE_VISIBLE' | 'NEW_VIN'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {ControleDonneesVehiculeRequestDto} controleDonneesVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFieldControleDonneesVehiculeUsingPOST(field: 'NEW_MARQUE' | 'NEW_MODELE' | 'NEW_GENRE' | 'NEW_PAYS_ETRANGER' | 'NEW_SANS_PLAQUE' | 'NEW_PLAQUE' | 'NEW_PLAQUE_VISIBLE' | 'NEW_VIN', id: string, controleDonneesVehiculeRequestDto: ControleDonneesVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFieldControleDonneesVehiculeUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateFieldControleDonneesVehiculeUsingPOST.');
            }
            // verify required parameter 'controleDonneesVehiculeRequestDto' is not null or undefined
            if (controleDonneesVehiculeRequestDto === null || controleDonneesVehiculeRequestDto === undefined) {
                throw new RequiredError('controleDonneesVehiculeRequestDto','Required parameter controleDonneesVehiculeRequestDto was null or undefined when calling validateFieldControleDonneesVehiculeUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/donnees-vehicule/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ControleDonneesVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(controleDonneesVehiculeRequestDto || {}) : (controleDonneesVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ des informations de notification manuelle pour un dossier existant.
         * @param {'DATE_ENVOI' | 'DATE_RETOUR' | 'ETAT_DISTRIBUTION'} field Le champ à valider, représenté par une énumération.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {NotificationInfosRequestDto} notificationInfosRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateNotificationInfosFieldUsingPOST(field: 'DATE_ENVOI' | 'DATE_RETOUR' | 'ETAT_DISTRIBUTION', id: string, notificationInfosRequestDto: NotificationInfosRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateNotificationInfosFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateNotificationInfosFieldUsingPOST.');
            }
            // verify required parameter 'notificationInfosRequestDto' is not null or undefined
            if (notificationInfosRequestDto === null || notificationInfosRequestDto === undefined) {
                throw new RequiredError('notificationInfosRequestDto','Required parameter notificationInfosRequestDto was null or undefined when calling validateNotificationInfosFieldUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/notification-infos/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NotificationInfosRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notificationInfosRequestDto || {}) : (notificationInfosRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs des informations d\'une notification manuelle pour un dossier existant.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {NotificationInfosRequestDto} notificationInfosRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateNotificationInfosUsingPOST(id: string, notificationInfosRequestDto: NotificationInfosRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateNotificationInfosUsingPOST.');
            }
            // verify required parameter 'notificationInfosRequestDto' is not null or undefined
            if (notificationInfosRequestDto === null || notificationInfosRequestDto === undefined) {
                throw new RequiredError('notificationInfosRequestDto','Required parameter notificationInfosRequestDto was null or undefined when calling validateNotificationInfosUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/notification-infos/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NotificationInfosRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notificationInfosRequestDto || {}) : (notificationInfosRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider une modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
         * @param {'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST(field: 'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF', id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST.');
            }
            // verify required parameter 'updateDonneesInterieurVehiculeRequestDto' is not null or undefined
            if (updateDonneesInterieurVehiculeRequestDto === null || updateDonneesInterieurVehiculeRequestDto === undefined) {
                throw new RequiredError('updateDonneesInterieurVehiculeRequestDto','Required parameter updateDonneesInterieurVehiculeRequestDto was null or undefined when calling validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/vehicule/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesInterieurVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesInterieurVehiculeRequestDto || {}) : (updateDonneesInterieurVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST.');
            }
            // verify required parameter 'updateDonneesInterieurVehiculeRequestDto' is not null or undefined
            if (updateDonneesInterieurVehiculeRequestDto === null || updateDonneesInterieurVehiculeRequestDto === undefined) {
                throw new RequiredError('updateDonneesInterieurVehiculeRequestDto','Required parameter updateDonneesInterieurVehiculeRequestDto was null or undefined when calling validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/vehicule/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesInterieurVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesInterieurVehiculeRequestDto || {}) : (updateDonneesInterieurVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider l\'ensemble des champs du formulaire de modifications des entités de rattachement d\'un dossier.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementFOUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateEntitesRattachementFOUsingPOST.');
            }
            // verify required parameter 'updateEntitesRattachementRequestDto' is not null or undefined
            if (updateEntitesRattachementRequestDto === null || updateEntitesRattachementRequestDto === undefined) {
                throw new RequiredError('updateEntitesRattachementRequestDto','Required parameter updateEntitesRattachementRequestDto was null or undefined when calling validateUpdateEntitesRattachementFOUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/entites-rattachement/{id}/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateEntitesRattachementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateEntitesRattachementRequestDto || {}) : (updateEntitesRattachementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un des champs du formulaire de modifications des entités de rattachement d\'un dossier.
         * @param {'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementFieldFOUsingPOST(field: 'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT', id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateEntitesRattachementFieldFOUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateEntitesRattachementFieldFOUsingPOST.');
            }
            // verify required parameter 'updateEntitesRattachementRequestDto' is not null or undefined
            if (updateEntitesRattachementRequestDto === null || updateEntitesRattachementRequestDto === undefined) {
                throw new RequiredError('updateEntitesRattachementRequestDto','Required parameter updateEntitesRattachementRequestDto was null or undefined when calling validateUpdateEntitesRattachementFieldFOUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/entites-rattachement/{id}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateEntitesRattachementRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateEntitesRattachementRequestDto || {}) : (updateEntitesRattachementRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ du formulaire de mise à jour de la main levée.
         * @param {'NUM_PROCES_VERBAL' | 'DATE_PROCES_VERBAL' | 'GRADE_AGENT' | 'MATRICULE_AGENT' | 'COMMUNE_FONCTION' | 'TYPE_RESTITUTION' | 'GENRE_SIMPLIFIE_ID' | 'IMMATRICULATION' | 'MARQUE_ID' | 'NOM_PROPRIETAIRE' | 'LIEU_ADRESSE_PROPRIETAIRE' | 'CODE_POSTAL_PROPRIETAIRE' | 'COMMUNE_ADRESSE_PROPRIETAIRE' | 'FOURRIERE_ID' | 'DEBUT_AUTORISATION' | 'FIN_AUTORISATION' | 'COMMUNE_REDACTION' | 'JUSTIFICATION_SORTIE' | 'SIRET_SOCIETE_REMORQUAGE'} field Le champ à valider, représenté par une énumération.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {UpdateMainLeveeRequestDto} updateMainLeveeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMainLeveeFieldUsingPOST(field: 'NUM_PROCES_VERBAL' | 'DATE_PROCES_VERBAL' | 'GRADE_AGENT' | 'MATRICULE_AGENT' | 'COMMUNE_FONCTION' | 'TYPE_RESTITUTION' | 'GENRE_SIMPLIFIE_ID' | 'IMMATRICULATION' | 'MARQUE_ID' | 'NOM_PROPRIETAIRE' | 'LIEU_ADRESSE_PROPRIETAIRE' | 'CODE_POSTAL_PROPRIETAIRE' | 'COMMUNE_ADRESSE_PROPRIETAIRE' | 'FOURRIERE_ID' | 'DEBUT_AUTORISATION' | 'FIN_AUTORISATION' | 'COMMUNE_REDACTION' | 'JUSTIFICATION_SORTIE' | 'SIRET_SOCIETE_REMORQUAGE', id: string, updateMainLeveeRequestDto: UpdateMainLeveeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateMainLeveeFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateMainLeveeFieldUsingPOST.');
            }
            // verify required parameter 'updateMainLeveeRequestDto' is not null or undefined
            if (updateMainLeveeRequestDto === null || updateMainLeveeRequestDto === undefined) {
                throw new RequiredError('updateMainLeveeRequestDto','Required parameter updateMainLeveeRequestDto was null or undefined when calling validateUpdateMainLeveeFieldUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/main-levee/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateMainLeveeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateMainLeveeRequestDto || {}) : (updateMainLeveeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider tous les champs du formulaire de mise à jour de la main levée.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {UpdateMainLeveeRequestDto} updateMainLeveeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMainLeveeUsingPOST(id: string, updateMainLeveeRequestDto: UpdateMainLeveeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateMainLeveeUsingPOST.');
            }
            // verify required parameter 'updateMainLeveeRequestDto' is not null or undefined
            if (updateMainLeveeRequestDto === null || updateMainLeveeRequestDto === undefined) {
                throw new RequiredError('updateMainLeveeRequestDto','Required parameter updateMainLeveeRequestDto was null or undefined when calling validateUpdateMainLeveeUsingPOST.');
            }
            const localVarPath = `/api/force-ordre/dossier/{id}/main-levee/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateMainLeveeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateMainLeveeRequestDto || {}) : (updateMainLeveeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForceOrdreControllerApi - functional programming interface
 * @export
 */
export const ForceOrdreControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary   Route effectuant un contrôle des données du véhicule   relançant la vente si aucune modification n\'est constatée   sinon en relançant l\'identification au SIV 
         * @param {string} id ID du dossier
         * @param {ControleDonneesVehiculeBlocageVenteRequestDto} controleDonneesVehiculeBlocageVenteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        computeControleDonneesVehiculeBlocageVenteUsingPOST(id: string, controleDonneesVehiculeBlocageVenteRequestDto: ControleDonneesVehiculeBlocageVenteRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).computeControleDonneesVehiculeBlocageVenteUsingPOST(id, controleDonneesVehiculeBlocageVenteRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de confirmer la non identifiabilité du propriétaire d\'un véhicule volé
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmNonIdentifiabiliteProprietaireUsingPOST(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).confirmNonIdentifiabiliteProprietaireUsingPOST(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de confirmer le vol d\'un véhicule identifié vvnr
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmVolVvnrUsingPOST(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).confirmVolVvnrUsingPOST(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Générer un rapport BDR
         * @param {ReportRequestDto} reportRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBdrReportUsingPOST(reportRequestDto: ReportRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).createBdrReportUsingPOST(reportRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer l\'AR/PND depuis l\'ANTAI
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchArPndUsingPOST(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).fetchArPndUsingPOST(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer le courrier de notification depuis l\'ANTAI
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCourrierUsingPOST(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).fetchCourrierUsingPOST(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Récupération des données à contrôler, dans le cas où les données du véhicule ne correspondent pas aux données du siv.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDonneesAControlerUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DonneesAControlerResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).getDonneesAControlerUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de calculer les violations menant à une impossibilité de notifier
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {getSourceImpossibiliteNotifierFoUsingGETQueryParams} queryParams objet contenant les query params de la route getSourceImpossibiliteNotifierFoUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceImpossibiliteNotifierFoUsingGET(id: string, queryParams: GetSourceImpossibiliteNotifierFoUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SourcesImpossibiliteNotifierDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).getSourceImpossibiliteNotifierFoUsingGET(id, queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route de recherche de dossiers par IDs, retourne le statut de suppression et les actions requises filtrées par profil utilisateur.
         * @param {getStatusUsingGETQueryParams} queryParams objet contenant les query params de la route getStatusUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusUsingGET(queryParams: GetStatusUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossiersStatusResultDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).getStatusUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer les PDFs de notification manuelle.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualNotificationPdfUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).manualNotificationPdfUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Création d\'un dossier via une fiche descriptive pour un profil force de l\'ordre
         * @param {CreateDossierFromForceOrdreDto} createDossierFromForceOrdreDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDossierWithInitialInfoUsingPOST(createDossierFromForceOrdreDto: CreateDossierFromForceOrdreDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).postDossierWithInitialInfoUsingPOST(createDossierFromForceOrdreDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route de récupération des coordonnées propriétaire d\'un dossier
         * @param {string} id Id du dossier, représenté par son UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCoordonneesProprietaireUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CoordonneesProprietaireResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).retrieveCoordonneesProprietaireUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer les informations d\'un utilisateur de profile FO.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFoUserInformationUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FoFullUserDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).retrieveFoUserInformationUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Récupération des données de la main levée d\'un dossier.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMainleveeUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MainleveeResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).retrieveMainleveeUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Soumission du formulaire de notification manuelle
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {NotificationInfosRequestDto} notificationInfosRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitNotificationInfosUsingPOST(id: string, notificationInfosRequestDto: NotificationInfosRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).submitNotificationInfosUsingPOST(id, notificationInfosRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant à un FO de supprimer un dossier créé par une de ses unités et qui n\'a pas encore été enregistré par un gardien de fourrière.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppressionDossierUsingDELETE1(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossiersStatusResultDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).suppressionDossierUsingDELETE1(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les données d\'un dossier, dans le cas où les données du véhicule ne correspondent pas aux données du siv.
         * @param {string} id 
         * @param {ControleDonneesVehiculeRequestDto} controleDonneesVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateControleDonneesVehiculeUsingPOST(id: string, controleDonneesVehiculeRequestDto: ControleDonneesVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).updateControleDonneesVehiculeUsingPOST(id, controleDonneesVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les coordonnees du propriétaire pour les fo
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoordonneesProprietairesFoUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).updateCoordonneesProprietairesFoUsingPOST(id, coordonneesProprietaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonneesInterieurVehiculeForNotAdminUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).updateDonneesInterieurVehiculeForNotAdminUsingPOST(id, updateDonneesInterieurVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de modifier les entitées de rattachement d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntitesRattachementFOUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).updateEntitesRattachementFOUsingPOST(id, updateEntitesRattachementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Soumission du formulaire d\'expéditeur de notification manuelle.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {ExpediteurNotificationRequestDto} expediteurNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpediteurNotificationUsingPOST(id: string, expediteurNotificationRequestDto: ExpediteurNotificationRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).updateExpediteurNotificationUsingPOST(id, expediteurNotificationRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de mettre à jour la main levée
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {UpdateMainLeveeRequestDto} updateMainLeveeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMainLeveeUsingPOST(id: string, updateMainLeveeRequestDto: UpdateMainLeveeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).updateMainLeveeUsingPOST(id, updateMainLeveeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary API permettant d\'uploader une photo et les informations associées d\'un côté d\'un véhicule.
         * @param {'AVANT' | 'GAUCHE' | 'DROITE' | 'ARRIERE' | 'AUTRE'} coteVehicule côté du véhicule de la photo
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {any} file Fiche contenant la photo
         * @param {any} photoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPhotoVehiculeUsingPOST(coteVehicule: 'AVANT' | 'GAUCHE' | 'DROITE' | 'ARRIERE' | 'AUTRE', id: string, file: any, photoRequestDto: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).uploadPhotoVehiculeUsingPOST(coteVehicule, id, file, photoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider que les actions hors SIF ont été effectuées
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateActionsHorsSifUsingPOST(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateActionsHorsSifUsingPOST(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider la modification lors du contrôle des données d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {ControleDonneesVehiculeRequestDto} controleDonneesVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateControleDonneesVehiculeUsingPOST(id: string, controleDonneesVehiculeRequestDto: ControleDonneesVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateControleDonneesVehiculeUsingPOST(id, controleDonneesVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ du formulaire de mise à jour des Coordonnéees propriétaires.
         * @param {'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS'} field Le champ à valider, représenté par une énumération.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCoordonneesProprietairesFieldFoUsingPOST(field: 'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS', id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateCoordonneesProprietairesFieldFoUsingPOST(field, id, coordonneesProprietaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider tous les champs du formulaire de mise à jour des coordonnées propriétaires pour les fo
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCoordonneesProprietairesFoUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateCoordonneesProprietairesFoUsingPOST(id, coordonneesProprietaireRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un dossier pour une création FO via une fiche descriptive
         * @param {CreateDossierFromForceOrdreDto} createDossierFromForceOrdreDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDossierWithInitialInfoUsingPOST(createDossierFromForceOrdreDto: CreateDossierFromForceOrdreDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateDossierWithInitialInfoUsingPOST(createDossierFromForceOrdreDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un champ des informations de l\'expéditeur de la notification manuelle pour un dossier existant.
         * @param {'UNITE' | 'ADRESSE' | 'CODE_POSTAL' | 'COMMUNE'} field Le champ à valider, représenté par une énumération.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {ExpediteurNotificationRequestDto} expediteurNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExpediteurNotificationFieldUsingPOST(field: 'UNITE' | 'ADRESSE' | 'CODE_POSTAL' | 'COMMUNE', id: string, expediteurNotificationRequestDto: ExpediteurNotificationRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateExpediteurNotificationFieldUsingPOST(field, id, expediteurNotificationRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs des informations de l\'expéditeur de la notification manuelle pour un dossier existant.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {ExpediteurNotificationRequestDto} expediteurNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExpediteurNotificationUsingPOST(id: string, expediteurNotificationRequestDto: ExpediteurNotificationRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateExpediteurNotificationUsingPOST(id, expediteurNotificationRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche agent pour un dossier non créé.
         * @param {'UNITE_FO'} field Le champ à valider, représenté par une énumération.
         * @param {FicheAgentFoRequestDto} ficheAgentFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheAgentFoFieldWithoutDossierUsingPOST(field: 'UNITE_FO', ficheAgentFoRequestDto: FicheAgentFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheAgentFoFieldWithoutDossierUsingPOST(field, ficheAgentFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche agent pour un dossier non créé.
         * @param {FicheAgentFoRequestDto} ficheAgentFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheAgentWithoutDossierUsingPOST(ficheAgentFoRequestDto: FicheAgentFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheAgentWithoutDossierUsingPOST(ficheAgentFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche conditions pour un dossier non créé.
         * @param {'DATE_CONSTATATION' | 'MOTIVATION_MESURE' | 'ADRESSE' | 'COMMUNE'} field Le champ à valider, représenté par une énumération.
         * @param {FicheConditionsRequestDto} ficheConditionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheConditionsFieldWithoutDossierUsingPOST(field: 'DATE_CONSTATATION' | 'MOTIVATION_MESURE' | 'ADRESSE' | 'COMMUNE', ficheConditionsRequestDto: FicheConditionsRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheConditionsFieldWithoutDossierUsingPOST(field, ficheConditionsRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche conditions pour un dossier non créé.
         * @param {FicheConditionsRequestDto} ficheConditionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheConditionsWithoutDossierUsingPOST(ficheConditionsRequestDto: FicheConditionsRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheConditionsWithoutDossierUsingPOST(ficheConditionsRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche de détails véhicule pour un dossier non créé.
         * @param {'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS'} field Le champ à valider, représenté par une énumération.
         * @param {FicheDetailsVehiculeFoRequestDto} ficheDetailsVehiculeFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheDetailsVehiculeFieldWithoutDossierUsingPOST(field: 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS', ficheDetailsVehiculeFoRequestDto: FicheDetailsVehiculeFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheDetailsVehiculeFieldWithoutDossierUsingPOST(field, ficheDetailsVehiculeFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche de détails véhicule pour un dossier non créé.
         * @param {FicheDetailsVehiculeFoRequestDto} ficheDetailsVehiculeFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheDetailsVehiculeWithoutDossierUsingPOST(ficheDetailsVehiculeFoRequestDto: FicheDetailsVehiculeFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheDetailsVehiculeWithoutDossierUsingPOST(ficheDetailsVehiculeFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche état général pour un dossier non créé.
         * @param {'ETAT_LIBELLE' | 'ETAT_PRECISION'} field Le champ à valider, représenté par une énumération.
         * @param {FicheEtatGeneralFoRequestDto} ficheEtatGeneralFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheEtatGeneralFieldWithoutDossierUsingPOST(field: 'ETAT_LIBELLE' | 'ETAT_PRECISION', ficheEtatGeneralFoRequestDto: FicheEtatGeneralFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheEtatGeneralFieldWithoutDossierUsingPOST(field, ficheEtatGeneralFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche etat général pour un dossier non créé.
         * @param {FicheEtatGeneralFoRequestDto} ficheEtatGeneralFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheEtatGeneralWithoutDossierUsingPOST(ficheEtatGeneralFoRequestDto: FicheEtatGeneralFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheEtatGeneralWithoutDossierUsingPOST(ficheEtatGeneralFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un champ de la fiche fourrière pour un dossier non créé.
         * @param {'FOURRIERE' | 'AUTORITE_FOURRIERE' | 'AUTORITE_QUALIFIEE'} field Le champ à valider, représenté par une énumération.
         * @param {FicheFourriereFoRequestDto} ficheFourriereFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheFourriereFieldWithoutDossierUsingPOST1(field: 'FOURRIERE' | 'AUTORITE_FOURRIERE' | 'AUTORITE_QUALIFIEE', ficheFourriereFoRequestDto: FicheFourriereFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheFourriereFieldWithoutDossierUsingPOST1(field, ficheFourriereFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche fourrière pour un dossier non créé.
         * @param {FicheFourriereFoRequestDto} ficheFourriereFoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheFourriereWithoutDossierUsingPOST1(ficheFourriereFoRequestDto: FicheFourriereFoRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheFourriereWithoutDossierUsingPOST1(ficheFourriereFoRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche véhicule pour un dossier non créé.
         * @param {'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'TYPE_PLAQUE' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS'} field Le champ à valider, représenté par une énumération.
         * @param {FicheVehiculeFoValidationDto} ficheVehiculeFoValidationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheVehiculeFieldWithoutDossierUsingPOST1(field: 'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'TYPE_PLAQUE' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS', ficheVehiculeFoValidationDto: FicheVehiculeFoValidationDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheVehiculeFieldWithoutDossierUsingPOST1(field, ficheVehiculeFoValidationDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche véhicule pour un dossier non créé.
         * @param {FicheVehiculeFoValidationDto} ficheVehiculeFoValidationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheVehiculeWithoutDossierUsingPOST1(ficheVehiculeFoValidationDto: FicheVehiculeFoValidationDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierCreationFoViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFicheVehiculeWithoutDossierUsingPOST1(ficheVehiculeFoValidationDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider la modification d\'un champ lors du contrôle des données d\'un dossier
         * @param {'NEW_MARQUE' | 'NEW_MODELE' | 'NEW_GENRE' | 'NEW_PAYS_ETRANGER' | 'NEW_SANS_PLAQUE' | 'NEW_PLAQUE' | 'NEW_PLAQUE_VISIBLE' | 'NEW_VIN'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {ControleDonneesVehiculeRequestDto} controleDonneesVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFieldControleDonneesVehiculeUsingPOST(field: 'NEW_MARQUE' | 'NEW_MODELE' | 'NEW_GENRE' | 'NEW_PAYS_ETRANGER' | 'NEW_SANS_PLAQUE' | 'NEW_PLAQUE' | 'NEW_PLAQUE_VISIBLE' | 'NEW_VIN', id: string, controleDonneesVehiculeRequestDto: ControleDonneesVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateFieldControleDonneesVehiculeUsingPOST(field, id, controleDonneesVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ des informations de notification manuelle pour un dossier existant.
         * @param {'DATE_ENVOI' | 'DATE_RETOUR' | 'ETAT_DISTRIBUTION'} field Le champ à valider, représenté par une énumération.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {NotificationInfosRequestDto} notificationInfosRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateNotificationInfosFieldUsingPOST(field: 'DATE_ENVOI' | 'DATE_RETOUR' | 'ETAT_DISTRIBUTION', id: string, notificationInfosRequestDto: NotificationInfosRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateNotificationInfosFieldUsingPOST(field, id, notificationInfosRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs des informations d\'une notification manuelle pour un dossier existant.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {NotificationInfosRequestDto} notificationInfosRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateNotificationInfosUsingPOST(id: string, notificationInfosRequestDto: NotificationInfosRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateNotificationInfosUsingPOST(id, notificationInfosRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider une modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
         * @param {'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST(field: 'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF', id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST(field, id, updateDonneesInterieurVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST(id, updateDonneesInterieurVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider l\'ensemble des champs du formulaire de modifications des entités de rattachement d\'un dossier.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementFOUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateUpdateEntitesRattachementFOUsingPOST(id, updateEntitesRattachementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un des champs du formulaire de modifications des entités de rattachement d\'un dossier.
         * @param {'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateEntitesRattachementFieldFOUsingPOST(field: 'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT', id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateUpdateEntitesRattachementFieldFOUsingPOST(field, id, updateEntitesRattachementRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ du formulaire de mise à jour de la main levée.
         * @param {'NUM_PROCES_VERBAL' | 'DATE_PROCES_VERBAL' | 'GRADE_AGENT' | 'MATRICULE_AGENT' | 'COMMUNE_FONCTION' | 'TYPE_RESTITUTION' | 'GENRE_SIMPLIFIE_ID' | 'IMMATRICULATION' | 'MARQUE_ID' | 'NOM_PROPRIETAIRE' | 'LIEU_ADRESSE_PROPRIETAIRE' | 'CODE_POSTAL_PROPRIETAIRE' | 'COMMUNE_ADRESSE_PROPRIETAIRE' | 'FOURRIERE_ID' | 'DEBUT_AUTORISATION' | 'FIN_AUTORISATION' | 'COMMUNE_REDACTION' | 'JUSTIFICATION_SORTIE' | 'SIRET_SOCIETE_REMORQUAGE'} field Le champ à valider, représenté par une énumération.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {UpdateMainLeveeRequestDto} updateMainLeveeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMainLeveeFieldUsingPOST(field: 'NUM_PROCES_VERBAL' | 'DATE_PROCES_VERBAL' | 'GRADE_AGENT' | 'MATRICULE_AGENT' | 'COMMUNE_FONCTION' | 'TYPE_RESTITUTION' | 'GENRE_SIMPLIFIE_ID' | 'IMMATRICULATION' | 'MARQUE_ID' | 'NOM_PROPRIETAIRE' | 'LIEU_ADRESSE_PROPRIETAIRE' | 'CODE_POSTAL_PROPRIETAIRE' | 'COMMUNE_ADRESSE_PROPRIETAIRE' | 'FOURRIERE_ID' | 'DEBUT_AUTORISATION' | 'FIN_AUTORISATION' | 'COMMUNE_REDACTION' | 'JUSTIFICATION_SORTIE' | 'SIRET_SOCIETE_REMORQUAGE', id: string, updateMainLeveeRequestDto: UpdateMainLeveeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateUpdateMainLeveeFieldUsingPOST(field, id, updateMainLeveeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider tous les champs du formulaire de mise à jour de la main levée.
         * @param {string} id ID du dossier, représenté par un UUID
         * @param {UpdateMainLeveeRequestDto} updateMainLeveeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateMainLeveeUsingPOST(id: string, updateMainLeveeRequestDto: UpdateMainLeveeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = ForceOrdreControllerApiFetchParamCreator(configuration).validateUpdateMainLeveeUsingPOST(id, updateMainLeveeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ForceOrdreControllerApi - object-oriented interface
 * @export
 * @class ForceOrdreControllerApi
 * @extends {BaseAPI}
 */
export class ForceOrdreControllerApi extends BaseAPI {
    /**
     * @summary   Route effectuant un contrôle des données du véhicule   relançant la vente si aucune modification n\'est constatée   sinon en relançant l\'identification au SIV 
     * @param {string} id ID du dossier
     * @param {ControleDonneesVehiculeBlocageVenteRequestDto} controleDonneesVehiculeBlocageVenteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public computeControleDonneesVehiculeBlocageVenteUsingPOST(id: string, controleDonneesVehiculeBlocageVenteRequestDto: ControleDonneesVehiculeBlocageVenteRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).computeControleDonneesVehiculeBlocageVenteUsingPOST(id, controleDonneesVehiculeBlocageVenteRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de confirmer la non identifiabilité du propriétaire d\'un véhicule volé
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmNonIdentifiabiliteProprietaireUsingPOST(id: string, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).confirmNonIdentifiabiliteProprietaireUsingPOST(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de confirmer le vol d\'un véhicule identifié vvnr
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmVolVvnrUsingPOST(id: string, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).confirmVolVvnrUsingPOST(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Générer un rapport BDR
     * @param {ReportRequestDto} reportRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBdrReportUsingPOST(reportRequestDto: ReportRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).createBdrReportUsingPOST(reportRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer l\'AR/PND depuis l\'ANTAI
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchArPndUsingPOST(id: string, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).fetchArPndUsingPOST(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer le courrier de notification depuis l\'ANTAI
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchCourrierUsingPOST(id: string, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).fetchCourrierUsingPOST(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Récupération des données à contrôler, dans le cas où les données du véhicule ne correspondent pas aux données du siv.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDonneesAControlerUsingGET(id: string, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).getDonneesAControlerUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de calculer les violations menant à une impossibilité de notifier
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {getSourceImpossibiliteNotifierFoUsingGETQueryParams} queryParams objet contenant les query params de la route getSourceImpossibiliteNotifierFoUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSourceImpossibiliteNotifierFoUsingGET(id: string, queryParams: GetSourceImpossibiliteNotifierFoUsingGETQueryParams, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).getSourceImpossibiliteNotifierFoUsingGET(id, queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route de recherche de dossiers par IDs, retourne le statut de suppression et les actions requises filtrées par profil utilisateur.
     * @param {getStatusUsingGETQueryParams} queryParams objet contenant les query params de la route getStatusUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStatusUsingGET(queryParams: GetStatusUsingGETQueryParams, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).getStatusUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer les PDFs de notification manuelle.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public manualNotificationPdfUsingGET(id: string, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).manualNotificationPdfUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Création d\'un dossier via une fiche descriptive pour un profil force de l\'ordre
     * @param {CreateDossierFromForceOrdreDto} createDossierFromForceOrdreDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postDossierWithInitialInfoUsingPOST(createDossierFromForceOrdreDto: CreateDossierFromForceOrdreDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).postDossierWithInitialInfoUsingPOST(createDossierFromForceOrdreDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route de récupération des coordonnées propriétaire d\'un dossier
     * @param {string} id Id du dossier, représenté par son UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveCoordonneesProprietaireUsingGET(id: string, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).retrieveCoordonneesProprietaireUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer les informations d\'un utilisateur de profile FO.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveFoUserInformationUsingGET(options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).retrieveFoUserInformationUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Récupération des données de la main levée d\'un dossier.
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveMainleveeUsingGET(id: string, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).retrieveMainleveeUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Soumission du formulaire de notification manuelle
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {NotificationInfosRequestDto} notificationInfosRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitNotificationInfosUsingPOST(id: string, notificationInfosRequestDto: NotificationInfosRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).submitNotificationInfosUsingPOST(id, notificationInfosRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant à un FO de supprimer un dossier créé par une de ses unités et qui n\'a pas encore été enregistré par un gardien de fourrière.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public suppressionDossierUsingDELETE1(id: string, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).suppressionDossierUsingDELETE1(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les données d\'un dossier, dans le cas où les données du véhicule ne correspondent pas aux données du siv.
     * @param {string} id 
     * @param {ControleDonneesVehiculeRequestDto} controleDonneesVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateControleDonneesVehiculeUsingPOST(id: string, controleDonneesVehiculeRequestDto: ControleDonneesVehiculeRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).updateControleDonneesVehiculeUsingPOST(id, controleDonneesVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les coordonnees du propriétaire pour les fo
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCoordonneesProprietairesFoUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).updateCoordonneesProprietairesFoUsingPOST(id, coordonneesProprietaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les données relatives au ministère de l\'intérieur d\'un véhicule ou de l\'infraction d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDonneesInterieurVehiculeForNotAdminUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).updateDonneesInterieurVehiculeForNotAdminUsingPOST(id, updateDonneesInterieurVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de modifier les entitées de rattachement d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEntitesRattachementFOUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).updateEntitesRattachementFOUsingPOST(id, updateEntitesRattachementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Soumission du formulaire d\'expéditeur de notification manuelle.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {ExpediteurNotificationRequestDto} expediteurNotificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateExpediteurNotificationUsingPOST(id: string, expediteurNotificationRequestDto: ExpediteurNotificationRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).updateExpediteurNotificationUsingPOST(id, expediteurNotificationRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de mettre à jour la main levée
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {UpdateMainLeveeRequestDto} updateMainLeveeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMainLeveeUsingPOST(id: string, updateMainLeveeRequestDto: UpdateMainLeveeRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).updateMainLeveeUsingPOST(id, updateMainLeveeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary API permettant d\'uploader une photo et les informations associées d\'un côté d\'un véhicule.
     * @param {'AVANT' | 'GAUCHE' | 'DROITE' | 'ARRIERE' | 'AUTRE'} coteVehicule côté du véhicule de la photo
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {any} file Fiche contenant la photo
     * @param {any} photoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPhotoVehiculeUsingPOST(coteVehicule: 'AVANT' | 'GAUCHE' | 'DROITE' | 'ARRIERE' | 'AUTRE', id: string, file: any, photoRequestDto: any, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).uploadPhotoVehiculeUsingPOST(coteVehicule, id, file, photoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider que les actions hors SIF ont été effectuées
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateActionsHorsSifUsingPOST(id: string, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateActionsHorsSifUsingPOST(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider la modification lors du contrôle des données d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {ControleDonneesVehiculeRequestDto} controleDonneesVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateControleDonneesVehiculeUsingPOST(id: string, controleDonneesVehiculeRequestDto: ControleDonneesVehiculeRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateControleDonneesVehiculeUsingPOST(id, controleDonneesVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ du formulaire de mise à jour des Coordonnéees propriétaires.
     * @param {'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS'} field Le champ à valider, représenté par une énumération.
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCoordonneesProprietairesFieldFoUsingPOST(field: 'PRENOM' | 'NOM' | 'RAISON_SOCIALE' | 'POINT_REMISE' | 'NUMERO' | 'EXTENSION' | 'TYPEVOIE' | 'LIBELLE_VOIE' | 'COMPLEMENT_ADRESSE' | 'LIEUDIT' | 'BOITE_POSTALE' | 'CODE_POSTAL' | 'LIBELLE_COMMUNE' | 'CODE_CEDEX' | 'LIBELLE_CEDEX' | 'PAYS', id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateCoordonneesProprietairesFieldFoUsingPOST(field, id, coordonneesProprietaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider tous les champs du formulaire de mise à jour des coordonnées propriétaires pour les fo
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {CoordonneesProprietaireRequestDto} coordonneesProprietaireRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCoordonneesProprietairesFoUsingPOST(id: string, coordonneesProprietaireRequestDto: CoordonneesProprietaireRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateCoordonneesProprietairesFoUsingPOST(id, coordonneesProprietaireRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un dossier pour une création FO via une fiche descriptive
     * @param {CreateDossierFromForceOrdreDto} createDossierFromForceOrdreDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateDossierWithInitialInfoUsingPOST(createDossierFromForceOrdreDto: CreateDossierFromForceOrdreDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateDossierWithInitialInfoUsingPOST(createDossierFromForceOrdreDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un champ des informations de l\'expéditeur de la notification manuelle pour un dossier existant.
     * @param {'UNITE' | 'ADRESSE' | 'CODE_POSTAL' | 'COMMUNE'} field Le champ à valider, représenté par une énumération.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {ExpediteurNotificationRequestDto} expediteurNotificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateExpediteurNotificationFieldUsingPOST(field: 'UNITE' | 'ADRESSE' | 'CODE_POSTAL' | 'COMMUNE', id: string, expediteurNotificationRequestDto: ExpediteurNotificationRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateExpediteurNotificationFieldUsingPOST(field, id, expediteurNotificationRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs des informations de l\'expéditeur de la notification manuelle pour un dossier existant.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {ExpediteurNotificationRequestDto} expediteurNotificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateExpediteurNotificationUsingPOST(id: string, expediteurNotificationRequestDto: ExpediteurNotificationRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateExpediteurNotificationUsingPOST(id, expediteurNotificationRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un seul champ de la fiche agent pour un dossier non créé.
     * @param {'UNITE_FO'} field Le champ à valider, représenté par une énumération.
     * @param {FicheAgentFoRequestDto} ficheAgentFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheAgentFoFieldWithoutDossierUsingPOST(field: 'UNITE_FO', ficheAgentFoRequestDto: FicheAgentFoRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheAgentFoFieldWithoutDossierUsingPOST(field, ficheAgentFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de la fiche agent pour un dossier non créé.
     * @param {FicheAgentFoRequestDto} ficheAgentFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheAgentWithoutDossierUsingPOST(ficheAgentFoRequestDto: FicheAgentFoRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheAgentWithoutDossierUsingPOST(ficheAgentFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un seul champ de la fiche conditions pour un dossier non créé.
     * @param {'DATE_CONSTATATION' | 'MOTIVATION_MESURE' | 'ADRESSE' | 'COMMUNE'} field Le champ à valider, représenté par une énumération.
     * @param {FicheConditionsRequestDto} ficheConditionsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheConditionsFieldWithoutDossierUsingPOST(field: 'DATE_CONSTATATION' | 'MOTIVATION_MESURE' | 'ADRESSE' | 'COMMUNE', ficheConditionsRequestDto: FicheConditionsRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheConditionsFieldWithoutDossierUsingPOST(field, ficheConditionsRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de la fiche conditions pour un dossier non créé.
     * @param {FicheConditionsRequestDto} ficheConditionsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheConditionsWithoutDossierUsingPOST(ficheConditionsRequestDto: FicheConditionsRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheConditionsWithoutDossierUsingPOST(ficheConditionsRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un seul champ de la fiche de détails véhicule pour un dossier non créé.
     * @param {'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS'} field Le champ à valider, représenté par une énumération.
     * @param {FicheDetailsVehiculeFoRequestDto} ficheDetailsVehiculeFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheDetailsVehiculeFieldWithoutDossierUsingPOST(field: 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS', ficheDetailsVehiculeFoRequestDto: FicheDetailsVehiculeFoRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheDetailsVehiculeFieldWithoutDossierUsingPOST(field, ficheDetailsVehiculeFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de la fiche de détails véhicule pour un dossier non créé.
     * @param {FicheDetailsVehiculeFoRequestDto} ficheDetailsVehiculeFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheDetailsVehiculeWithoutDossierUsingPOST(ficheDetailsVehiculeFoRequestDto: FicheDetailsVehiculeFoRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheDetailsVehiculeWithoutDossierUsingPOST(ficheDetailsVehiculeFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un seul champ de la fiche état général pour un dossier non créé.
     * @param {'ETAT_LIBELLE' | 'ETAT_PRECISION'} field Le champ à valider, représenté par une énumération.
     * @param {FicheEtatGeneralFoRequestDto} ficheEtatGeneralFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheEtatGeneralFieldWithoutDossierUsingPOST(field: 'ETAT_LIBELLE' | 'ETAT_PRECISION', ficheEtatGeneralFoRequestDto: FicheEtatGeneralFoRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheEtatGeneralFieldWithoutDossierUsingPOST(field, ficheEtatGeneralFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de la fiche etat général pour un dossier non créé.
     * @param {FicheEtatGeneralFoRequestDto} ficheEtatGeneralFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheEtatGeneralWithoutDossierUsingPOST(ficheEtatGeneralFoRequestDto: FicheEtatGeneralFoRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheEtatGeneralWithoutDossierUsingPOST(ficheEtatGeneralFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un champ de la fiche fourrière pour un dossier non créé.
     * @param {'FOURRIERE' | 'AUTORITE_FOURRIERE' | 'AUTORITE_QUALIFIEE'} field Le champ à valider, représenté par une énumération.
     * @param {FicheFourriereFoRequestDto} ficheFourriereFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheFourriereFieldWithoutDossierUsingPOST1(field: 'FOURRIERE' | 'AUTORITE_FOURRIERE' | 'AUTORITE_QUALIFIEE', ficheFourriereFoRequestDto: FicheFourriereFoRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheFourriereFieldWithoutDossierUsingPOST1(field, ficheFourriereFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de la fiche fourrière pour un dossier non créé.
     * @param {FicheFourriereFoRequestDto} ficheFourriereFoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheFourriereWithoutDossierUsingPOST1(ficheFourriereFoRequestDto: FicheFourriereFoRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheFourriereWithoutDossierUsingPOST1(ficheFourriereFoRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un seul champ de la fiche véhicule pour un dossier non créé.
     * @param {'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'TYPE_PLAQUE' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS'} field Le champ à valider, représenté par une énumération.
     * @param {FicheVehiculeFoValidationDto} ficheVehiculeFoValidationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheVehiculeFieldWithoutDossierUsingPOST1(field: 'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'TYPE_PLAQUE' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS', ficheVehiculeFoValidationDto: FicheVehiculeFoValidationDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheVehiculeFieldWithoutDossierUsingPOST1(field, ficheVehiculeFoValidationDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de la fiche véhicule pour un dossier non créé.
     * @param {FicheVehiculeFoValidationDto} ficheVehiculeFoValidationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheVehiculeWithoutDossierUsingPOST1(ficheVehiculeFoValidationDto: FicheVehiculeFoValidationDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFicheVehiculeWithoutDossierUsingPOST1(ficheVehiculeFoValidationDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider la modification d\'un champ lors du contrôle des données d\'un dossier
     * @param {'NEW_MARQUE' | 'NEW_MODELE' | 'NEW_GENRE' | 'NEW_PAYS_ETRANGER' | 'NEW_SANS_PLAQUE' | 'NEW_PLAQUE' | 'NEW_PLAQUE_VISIBLE' | 'NEW_VIN'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {ControleDonneesVehiculeRequestDto} controleDonneesVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFieldControleDonneesVehiculeUsingPOST(field: 'NEW_MARQUE' | 'NEW_MODELE' | 'NEW_GENRE' | 'NEW_PAYS_ETRANGER' | 'NEW_SANS_PLAQUE' | 'NEW_PLAQUE' | 'NEW_PLAQUE_VISIBLE' | 'NEW_VIN', id: string, controleDonneesVehiculeRequestDto: ControleDonneesVehiculeRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateFieldControleDonneesVehiculeUsingPOST(field, id, controleDonneesVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ des informations de notification manuelle pour un dossier existant.
     * @param {'DATE_ENVOI' | 'DATE_RETOUR' | 'ETAT_DISTRIBUTION'} field Le champ à valider, représenté par une énumération.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {NotificationInfosRequestDto} notificationInfosRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateNotificationInfosFieldUsingPOST(field: 'DATE_ENVOI' | 'DATE_RETOUR' | 'ETAT_DISTRIBUTION', id: string, notificationInfosRequestDto: NotificationInfosRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateNotificationInfosFieldUsingPOST(field, id, notificationInfosRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs des informations d\'une notification manuelle pour un dossier existant.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {NotificationInfosRequestDto} notificationInfosRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateNotificationInfosUsingPOST(id: string, notificationInfosRequestDto: NotificationInfosRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateNotificationInfosUsingPOST(id, notificationInfosRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider une modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
     * @param {'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST(field: 'NEW_MOTIF_ENTREE_ID_CORRELATION' | 'NEW_IS_PAYS_ETRANGER' | 'NEW_IS_SANS_PLAQUE' | 'NEW_PLAQUE_IMMATRICULATION' | 'NEW_ETAT_ID_CORRELATION' | 'COMMENT' | 'NEW_DATE_PROLONGATION_MEF' | 'COMMENT_PROLONGATION_MEF', id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateUpdateDonneesInterieurVehiculeFieldForNotAdminUsingPOST(field, id, updateDonneesInterieurVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications des données relatives au ministère de l\'intérieur du véhicule ou de l\'infraction d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesInterieurVehiculeRequestDto} updateDonneesInterieurVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST(id: string, updateDonneesInterieurVehiculeRequestDto: UpdateDonneesInterieurVehiculeRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateUpdateDonneesInterieurVehiculeForNotAdminUsingPOST(id, updateDonneesInterieurVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider l\'ensemble des champs du formulaire de modifications des entités de rattachement d\'un dossier.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateEntitesRattachementFOUsingPOST(id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateUpdateEntitesRattachementFOUsingPOST(id, updateEntitesRattachementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un des champs du formulaire de modifications des entités de rattachement d\'un dossier.
     * @param {'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateEntitesRattachementRequestDto} updateEntitesRattachementRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateEntitesRattachementFieldFOUsingPOST(field: 'NEW_FOURRIERE_CORRELATION_ID' | 'NEW_AUTORITE_FOURRIERE_CORRELATION_ID' | 'NEW_UNITE_FO_CORRELATION_ID' | 'COMMENT', id: string, updateEntitesRattachementRequestDto: UpdateEntitesRattachementRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateUpdateEntitesRattachementFieldFOUsingPOST(field, id, updateEntitesRattachementRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ du formulaire de mise à jour de la main levée.
     * @param {'NUM_PROCES_VERBAL' | 'DATE_PROCES_VERBAL' | 'GRADE_AGENT' | 'MATRICULE_AGENT' | 'COMMUNE_FONCTION' | 'TYPE_RESTITUTION' | 'GENRE_SIMPLIFIE_ID' | 'IMMATRICULATION' | 'MARQUE_ID' | 'NOM_PROPRIETAIRE' | 'LIEU_ADRESSE_PROPRIETAIRE' | 'CODE_POSTAL_PROPRIETAIRE' | 'COMMUNE_ADRESSE_PROPRIETAIRE' | 'FOURRIERE_ID' | 'DEBUT_AUTORISATION' | 'FIN_AUTORISATION' | 'COMMUNE_REDACTION' | 'JUSTIFICATION_SORTIE' | 'SIRET_SOCIETE_REMORQUAGE'} field Le champ à valider, représenté par une énumération.
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {UpdateMainLeveeRequestDto} updateMainLeveeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateMainLeveeFieldUsingPOST(field: 'NUM_PROCES_VERBAL' | 'DATE_PROCES_VERBAL' | 'GRADE_AGENT' | 'MATRICULE_AGENT' | 'COMMUNE_FONCTION' | 'TYPE_RESTITUTION' | 'GENRE_SIMPLIFIE_ID' | 'IMMATRICULATION' | 'MARQUE_ID' | 'NOM_PROPRIETAIRE' | 'LIEU_ADRESSE_PROPRIETAIRE' | 'CODE_POSTAL_PROPRIETAIRE' | 'COMMUNE_ADRESSE_PROPRIETAIRE' | 'FOURRIERE_ID' | 'DEBUT_AUTORISATION' | 'FIN_AUTORISATION' | 'COMMUNE_REDACTION' | 'JUSTIFICATION_SORTIE' | 'SIRET_SOCIETE_REMORQUAGE', id: string, updateMainLeveeRequestDto: UpdateMainLeveeRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateUpdateMainLeveeFieldUsingPOST(field, id, updateMainLeveeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider tous les champs du formulaire de mise à jour de la main levée.
     * @param {string} id ID du dossier, représenté par un UUID
     * @param {UpdateMainLeveeRequestDto} updateMainLeveeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateMainLeveeUsingPOST(id: string, updateMainLeveeRequestDto: UpdateMainLeveeRequestDto, options?: any) {
        return ForceOrdreControllerApiFp(this.configuration).validateUpdateMainLeveeUsingPOST(id, updateMainLeveeRequestDto, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// GardienFourriereControllerApi /////////////////////////////////////////////////////

/**
 * GardienFourriereControllerApi - fetch parameter creator
 * @export
 */
export const GardienFourriereControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de confirmer les informations de son compte Keycloak
         * @param {string} username Nom d\'utilisateur du compte Keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAccountUsingPUT(username: string, options: any = {}): FetchArgs {
            // verify required parameter 'username' is not null or undefined
            if (username === null || username === undefined) {
                throw new RequiredError('username','Required parameter username was null or undefined when calling confirmAccountUsingPUT.');
            }
            const localVarPath = `/api/comptes-utilisateurs/{username}/confirm`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de confirmer la validité des informations d\'une fourrière
         * @param {string} id Id de la fourrière, et non son id de corrélation, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmFourriereUsingPUT(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling confirmFourriereUsingPUT.');
            }
            const localVarPath = `/api/gardien-fourriere/profil/fourriere/{id}/confirm`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Création d\'un dossier via une fiche descriptive
         * @param {CreateDossierFromGardienFourriereDto} createDossierFromGardienFourriereDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDossierWithInitialInfoUsingPOST(createDossierFromGardienFourriereDto: CreateDossierFromGardienFourriereDto, options: any = {}): FetchArgs {
            // verify required parameter 'createDossierFromGardienFourriereDto' is not null or undefined
            if (createDossierFromGardienFourriereDto === null || createDossierFromGardienFourriereDto === undefined) {
                throw new RequiredError('createDossierFromGardienFourriereDto','Required parameter createDossierFromGardienFourriereDto was null or undefined when calling createDossierWithInitialInfoUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateDossierFromGardienFourriereDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(createDossierFromGardienFourriereDto || {}) : (createDossierFromGardienFourriereDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de renseigner l\'entrée d\'un véhicule.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {EntreeVehiculeRequestDto} entreeVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entreeVehiculeWithFormulaireEntreeUsingPOST(id: string, entreeVehiculeRequestDto: EntreeVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling entreeVehiculeWithFormulaireEntreeUsingPOST.');
            }
            // verify required parameter 'entreeVehiculeRequestDto' is not null or undefined
            if (entreeVehiculeRequestDto === null || entreeVehiculeRequestDto === undefined) {
                throw new RequiredError('entreeVehiculeRequestDto','Required parameter entreeVehiculeRequestDto was null or undefined when calling entreeVehiculeWithFormulaireEntreeUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/{id}/entree`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EntreeVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(entreeVehiculeRequestDto || {}) : (entreeVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Récupération des données d\'une fourrière.
         * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFourriereInfoUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling getFourriereInfoUsingGET.');
            }
            const localVarPath = `/api/gardien-fourriere/profil/fourriere/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Mise à jour des données d\'une fourrière.
         * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
         * @param {ProfilFourriereRequestDto} profilFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFourriereInfoUsingPOST(idCorrelation: string, profilFourriereRequestDto: ProfilFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling setFourriereInfoUsingPOST.');
            }
            // verify required parameter 'profilFourriereRequestDto' is not null or undefined
            if (profilFourriereRequestDto === null || profilFourriereRequestDto === undefined) {
                throw new RequiredError('profilFourriereRequestDto','Required parameter profilFourriereRequestDto was null or undefined when calling setFourriereInfoUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/profil/fourriere/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProfilFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(profilFourriereRequestDto || {}) : (profilFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de créer la fiche sortie d\'un véhicule.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {SortieVehiculeRequestDto} sortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortieVehiculeWithFormulaireSortieUsingPOST(id: string, sortieVehiculeRequestDto: SortieVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sortieVehiculeWithFormulaireSortieUsingPOST.');
            }
            // verify required parameter 'sortieVehiculeRequestDto' is not null or undefined
            if (sortieVehiculeRequestDto === null || sortieVehiculeRequestDto === undefined) {
                throw new RequiredError('sortieVehiculeRequestDto','Required parameter sortieVehiculeRequestDto was null or undefined when calling sortieVehiculeWithFormulaireSortieUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/{id}/sortie-mainlevee-coherente`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SortieVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sortieVehiculeRequestDto || {}) : (sortieVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Mise à jour des données d\'un bon d\'enlèvement gardien.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {BonEnlevementGardienRequestDto} bonEnlevementGardienRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBonEnlevementGardienUsingPOST(id: string, bonEnlevementGardienRequestDto: BonEnlevementGardienRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateBonEnlevementGardienUsingPOST.');
            }
            // verify required parameter 'bonEnlevementGardienRequestDto' is not null or undefined
            if (bonEnlevementGardienRequestDto === null || bonEnlevementGardienRequestDto === undefined) {
                throw new RequiredError('bonEnlevementGardienRequestDto','Required parameter bonEnlevementGardienRequestDto was null or undefined when calling updateBonEnlevementGardienUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/{id}/bon-enlevement-gardien`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BonEnlevementGardienRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(bonEnlevementGardienRequestDto || {}) : (bonEnlevementGardienRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ spécifique d\'un bon d\'enlèvement gardien.
         * @param {'ID_CORRELATION_CENTRE_VHU' | 'FLAG_CARTE_GRISE_RETIREE' | 'MOTIF_ABSENCE_IMMATRICULATION' | 'RAISON_SOCIALE' | 'NUMERO_SIREN' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'NUMERO_AGREMENT' | 'PREFECTURE_AGREMENT'} field Intitulé du champ à vérifier.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {BonEnlevementGardienRequestDto} bonEnlevementGardienRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBonEnlevementGardienFieldUsingPOST(field: 'ID_CORRELATION_CENTRE_VHU' | 'FLAG_CARTE_GRISE_RETIREE' | 'MOTIF_ABSENCE_IMMATRICULATION' | 'RAISON_SOCIALE' | 'NUMERO_SIREN' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'NUMERO_AGREMENT' | 'PREFECTURE_AGREMENT', id: string, bonEnlevementGardienRequestDto: BonEnlevementGardienRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateBonEnlevementGardienFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateBonEnlevementGardienFieldUsingPOST.');
            }
            // verify required parameter 'bonEnlevementGardienRequestDto' is not null or undefined
            if (bonEnlevementGardienRequestDto === null || bonEnlevementGardienRequestDto === undefined) {
                throw new RequiredError('bonEnlevementGardienRequestDto','Required parameter bonEnlevementGardienRequestDto was null or undefined when calling validateBonEnlevementGardienFieldUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/{id}/bon-enlevement-gardien/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BonEnlevementGardienRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(bonEnlevementGardienRequestDto || {}) : (bonEnlevementGardienRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation des données d\'un bon d\'enlèvement gardien.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {BonEnlevementGardienRequestDto} bonEnlevementGardienRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBonEnlevementGardienUsingPOST(id: string, bonEnlevementGardienRequestDto: BonEnlevementGardienRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateBonEnlevementGardienUsingPOST.');
            }
            // verify required parameter 'bonEnlevementGardienRequestDto' is not null or undefined
            if (bonEnlevementGardienRequestDto === null || bonEnlevementGardienRequestDto === undefined) {
                throw new RequiredError('bonEnlevementGardienRequestDto','Required parameter bonEnlevementGardienRequestDto was null or undefined when calling validateBonEnlevementGardienUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/{id}/bon-enlevement-gardien/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BonEnlevementGardienRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(bonEnlevementGardienRequestDto || {}) : (bonEnlevementGardienRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ de la fiche entrée pour un dossier existant.
         * @param {'ID_CORRELATION_AUTORITE_FOURRIERE' | 'ID_CORRELATION_JURIDICTION' | 'DATE_ENLEVEMENT' | 'DATE_ENTREE'} field Le champ à valider, représenté par une énumération.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {EntreeVehiculeRequestDto} entreeVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEntreeVehiculeFormFieldUsingPOST(field: 'ID_CORRELATION_AUTORITE_FOURRIERE' | 'ID_CORRELATION_JURIDICTION' | 'DATE_ENLEVEMENT' | 'DATE_ENTREE', id: string, entreeVehiculeRequestDto: EntreeVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateEntreeVehiculeFormFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateEntreeVehiculeFormFieldUsingPOST.');
            }
            // verify required parameter 'entreeVehiculeRequestDto' is not null or undefined
            if (entreeVehiculeRequestDto === null || entreeVehiculeRequestDto === undefined) {
                throw new RequiredError('entreeVehiculeRequestDto','Required parameter entreeVehiculeRequestDto was null or undefined when calling validateEntreeVehiculeFormFieldUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/{id}/entree/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EntreeVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(entreeVehiculeRequestDto || {}) : (entreeVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche entrée pour un dossier existant.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {EntreeVehiculeRequestDto} entreeVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEntreeVehiculeFormUsingPOST(id: string, entreeVehiculeRequestDto: EntreeVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateEntreeVehiculeFormUsingPOST.');
            }
            // verify required parameter 'entreeVehiculeRequestDto' is not null or undefined
            if (entreeVehiculeRequestDto === null || entreeVehiculeRequestDto === undefined) {
                throw new RequiredError('entreeVehiculeRequestDto','Required parameter entreeVehiculeRequestDto was null or undefined when calling validateEntreeVehiculeFormUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/{id}/entree/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EntreeVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(entreeVehiculeRequestDto || {}) : (entreeVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un champ de la fiche fourrière pour un dossier non créé.
         * @param {'ENTREE' | 'ENLEVEMENT' | 'FOURRIERE' | 'DATE_CONSTATATION'} field Le champ à valider, représenté par une énumération.
         * @param {FichesInfractionAndFourriereRequestsWrapperDto} fichesInfractionAndFourriereRequestsWrapperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheFourriereFieldWithoutDossierUsingPOST(field: 'ENTREE' | 'ENLEVEMENT' | 'FOURRIERE' | 'DATE_CONSTATATION', fichesInfractionAndFourriereRequestsWrapperDto: FichesInfractionAndFourriereRequestsWrapperDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFicheFourriereFieldWithoutDossierUsingPOST.');
            }
            // verify required parameter 'fichesInfractionAndFourriereRequestsWrapperDto' is not null or undefined
            if (fichesInfractionAndFourriereRequestsWrapperDto === null || fichesInfractionAndFourriereRequestsWrapperDto === undefined) {
                throw new RequiredError('fichesInfractionAndFourriereRequestsWrapperDto','Required parameter fichesInfractionAndFourriereRequestsWrapperDto was null or undefined when calling validateFicheFourriereFieldWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/fiche-fourriere/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FichesInfractionAndFourriereRequestsWrapperDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fichesInfractionAndFourriereRequestsWrapperDto || {}) : (fichesInfractionAndFourriereRequestsWrapperDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche fourrière pour un dossier non créé.
         * @param {FichesInfractionAndFourriereRequestsWrapperDto} fichesInfractionAndFourriereRequestsWrapperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheFourriereWithoutDossierUsingPOST(fichesInfractionAndFourriereRequestsWrapperDto: FichesInfractionAndFourriereRequestsWrapperDto, options: any = {}): FetchArgs {
            // verify required parameter 'fichesInfractionAndFourriereRequestsWrapperDto' is not null or undefined
            if (fichesInfractionAndFourriereRequestsWrapperDto === null || fichesInfractionAndFourriereRequestsWrapperDto === undefined) {
                throw new RequiredError('fichesInfractionAndFourriereRequestsWrapperDto','Required parameter fichesInfractionAndFourriereRequestsWrapperDto was null or undefined when calling validateFicheFourriereWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/fiche-fourriere/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FichesInfractionAndFourriereRequestsWrapperDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fichesInfractionAndFourriereRequestsWrapperDto || {}) : (fichesInfractionAndFourriereRequestsWrapperDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un champ de la fiche infraction pour un dossier non créé.
         * @param {'AUTORITE_FOURRIERE' | 'FOURRIERE' | 'DATE_CONSTATATION' | 'NOM_AUTORITE_PRESCRIPTRICE' | 'QUALITE_AUTORITE_PRESCRIPTRICE' | 'NOM_AGENT' | 'NIGEND' | 'UNITE' | 'MAIL_UNITE' | 'MOTIVATION_MESURE' | 'LIEU_PRIVE' | 'LIEU_ENLEVEMENT' | 'COMMUNE' | 'NUIT' | 'PLUIE_NEIGE' | 'AUTORITE_POUR_LEVER_MESURE' | 'DATE_REDACTION'} field Le champ à valider, représenté par une énumération.
         * @param {FicheInfractionRequestDto} ficheInfractionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheInfractionFieldWithoutDossierUsingPOST(field: 'AUTORITE_FOURRIERE' | 'FOURRIERE' | 'DATE_CONSTATATION' | 'NOM_AUTORITE_PRESCRIPTRICE' | 'QUALITE_AUTORITE_PRESCRIPTRICE' | 'NOM_AGENT' | 'NIGEND' | 'UNITE' | 'MAIL_UNITE' | 'MOTIVATION_MESURE' | 'LIEU_PRIVE' | 'LIEU_ENLEVEMENT' | 'COMMUNE' | 'NUIT' | 'PLUIE_NEIGE' | 'AUTORITE_POUR_LEVER_MESURE' | 'DATE_REDACTION', ficheInfractionRequestDto: FicheInfractionRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFicheInfractionFieldWithoutDossierUsingPOST.');
            }
            // verify required parameter 'ficheInfractionRequestDto' is not null or undefined
            if (ficheInfractionRequestDto === null || ficheInfractionRequestDto === undefined) {
                throw new RequiredError('ficheInfractionRequestDto','Required parameter ficheInfractionRequestDto was null or undefined when calling validateFicheInfractionFieldWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/fiche-infraction/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheInfractionRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheInfractionRequestDto || {}) : (ficheInfractionRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de tous les champs de la fiche infraction pour un dossier non créé.
         * @param {FicheInfractionRequestDto} ficheInfractionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheInfractionWithoutDossierUsingPOST(ficheInfractionRequestDto: FicheInfractionRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'ficheInfractionRequestDto' is not null or undefined
            if (ficheInfractionRequestDto === null || ficheInfractionRequestDto === undefined) {
                throw new RequiredError('ficheInfractionRequestDto','Required parameter ficheInfractionRequestDto was null or undefined when calling validateFicheInfractionWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/fiche-infraction/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheInfractionRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheInfractionRequestDto || {}) : (ficheInfractionRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un champ de la fiche judiciaire pour un dossier non créé.
         * @param {'ID_CORRELATION_JURIDICTION' | 'NUMERO_PARQUET' | 'NUMERO_PV' | 'NUMERO_IDJ' | 'VALEUR_JURIDIQUE'} field Le champ à valider, représenté par une énumération.
         * @param {FicheJudiciaireWithMotifMefRequestDto} ficheJudiciaireWithMotifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheJudiciaireFieldUsingPOST(field: 'ID_CORRELATION_JURIDICTION' | 'NUMERO_PARQUET' | 'NUMERO_PV' | 'NUMERO_IDJ' | 'VALEUR_JURIDIQUE', ficheJudiciaireWithMotifMefRequestDto: FicheJudiciaireWithMotifMefRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFicheJudiciaireFieldUsingPOST.');
            }
            // verify required parameter 'ficheJudiciaireWithMotifMefRequestDto' is not null or undefined
            if (ficheJudiciaireWithMotifMefRequestDto === null || ficheJudiciaireWithMotifMefRequestDto === undefined) {
                throw new RequiredError('ficheJudiciaireWithMotifMefRequestDto','Required parameter ficheJudiciaireWithMotifMefRequestDto was null or undefined when calling validateFicheJudiciaireFieldUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/fiche-judiciaire/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheJudiciaireWithMotifMefRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheJudiciaireWithMotifMefRequestDto || {}) : (ficheJudiciaireWithMotifMefRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de tous les champs de la fiche judiciaire pour un dossier non créé.
         * @param {FicheJudiciaireWithMotifMefRequestDto} ficheJudiciaireWithMotifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheJudiciaireUsingPOST(ficheJudiciaireWithMotifMefRequestDto: FicheJudiciaireWithMotifMefRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'ficheJudiciaireWithMotifMefRequestDto' is not null or undefined
            if (ficheJudiciaireWithMotifMefRequestDto === null || ficheJudiciaireWithMotifMefRequestDto === undefined) {
                throw new RequiredError('ficheJudiciaireWithMotifMefRequestDto','Required parameter ficheJudiciaireWithMotifMefRequestDto was null or undefined when calling validateFicheJudiciaireUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/fiche-judiciaire/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheJudiciaireWithMotifMefRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheJudiciaireWithMotifMefRequestDto || {}) : (ficheJudiciaireWithMotifMefRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche véhicule pour un dossier non créé.
         * @param {'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS'} field Le champ à valider, représenté par une énumération.
         * @param {FicheVehiculeRequestDto} ficheVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheVehiculeFieldWithoutDossierUsingPOST(field: 'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS', ficheVehiculeRequestDto: FicheVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFicheVehiculeFieldWithoutDossierUsingPOST.');
            }
            // verify required parameter 'ficheVehiculeRequestDto' is not null or undefined
            if (ficheVehiculeRequestDto === null || ficheVehiculeRequestDto === undefined) {
                throw new RequiredError('ficheVehiculeRequestDto','Required parameter ficheVehiculeRequestDto was null or undefined when calling validateFicheVehiculeFieldWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/fiche-vehicule/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheVehiculeRequestDto || {}) : (ficheVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche véhicule pour un dossier non créé.
         * @param {FicheVehiculeRequestDto} ficheVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheVehiculeWithoutDossierUsingPOST(ficheVehiculeRequestDto: FicheVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'ficheVehiculeRequestDto' is not null or undefined
            if (ficheVehiculeRequestDto === null || ficheVehiculeRequestDto === undefined) {
                throw new RequiredError('ficheVehiculeRequestDto','Required parameter ficheVehiculeRequestDto was null or undefined when calling validateFicheVehiculeWithoutDossierUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/fiche-vehicule/validation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FicheVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(ficheVehiculeRequestDto || {}) : (ficheVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ spécifique d\'une page profil fourrière.
         * @param {'ID' | 'ID_CORRELATION' | 'AUTORITES_FOURRIERE_IDS' | 'RAISON_SOCIALE' | 'NUMERO_AGREMENT' | 'DATE_AGREMENT_DEBUT' | 'DATE_AGREMENT_FIN' | 'NOMBRE_EMPLACEMENTS' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE_FIXE' | 'TELEPHONE_MOBILE' | 'ADRESSE_MAIL' | 'COORDONNEES_GPS' | 'NOM_RESPONSABLE' | 'ADRESSE_MAIL_RESPONSABLE' | 'HORAIRES'} field Intitulé du champ à vérifier.
         * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
         * @param {ProfilFourriereRequestDto} profilFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFourriereInfoFieldUsingPOST(field: 'ID' | 'ID_CORRELATION' | 'AUTORITES_FOURRIERE_IDS' | 'RAISON_SOCIALE' | 'NUMERO_AGREMENT' | 'DATE_AGREMENT_DEBUT' | 'DATE_AGREMENT_FIN' | 'NOMBRE_EMPLACEMENTS' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE_FIXE' | 'TELEPHONE_MOBILE' | 'ADRESSE_MAIL' | 'COORDONNEES_GPS' | 'NOM_RESPONSABLE' | 'ADRESSE_MAIL_RESPONSABLE' | 'HORAIRES', idCorrelation: string, profilFourriereRequestDto: ProfilFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateFourriereInfoFieldUsingPOST.');
            }
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateFourriereInfoFieldUsingPOST.');
            }
            // verify required parameter 'profilFourriereRequestDto' is not null or undefined
            if (profilFourriereRequestDto === null || profilFourriereRequestDto === undefined) {
                throw new RequiredError('profilFourriereRequestDto','Required parameter profilFourriereRequestDto was null or undefined when calling validateFourriereInfoFieldUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/profil/fourriere/{idCorrelation}/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProfilFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(profilFourriereRequestDto || {}) : (profilFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation des données d\'une fourriere.
         * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
         * @param {ProfilFourriereRequestDto} profilFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFourriereInfoUsingPOST(idCorrelation: string, profilFourriereRequestDto: ProfilFourriereRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling validateFourriereInfoUsingPOST.');
            }
            // verify required parameter 'profilFourriereRequestDto' is not null or undefined
            if (profilFourriereRequestDto === null || profilFourriereRequestDto === undefined) {
                throw new RequiredError('profilFourriereRequestDto','Required parameter profilFourriereRequestDto was null or undefined when calling validateFourriereInfoUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/profil/fourriere/{idCorrelation}/validation`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProfilFourriereRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(profilFourriereRequestDto || {}) : (profilFourriereRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider un champ de la fiche sortie pour un dossier existant.
         * @param {'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT'} field Le champ à valider, représenté par une énumération.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {SortieVehiculeRequestDto} sortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSortieVehiculeFormFieldUsingPOST(field: 'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT', id: string, sortieVehiculeRequestDto: SortieVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateSortieVehiculeFormFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateSortieVehiculeFormFieldUsingPOST.');
            }
            // verify required parameter 'sortieVehiculeRequestDto' is not null or undefined
            if (sortieVehiculeRequestDto === null || sortieVehiculeRequestDto === undefined) {
                throw new RequiredError('sortieVehiculeRequestDto','Required parameter sortieVehiculeRequestDto was null or undefined when calling validateSortieVehiculeFormFieldUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/{id}/sortie-mainlevee-coherente/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SortieVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sortieVehiculeRequestDto || {}) : (sortieVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche sortie pour un dossier existant.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {SortieVehiculeRequestDto} sortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSortieVehiculeFormUsingPOST(id: string, sortieVehiculeRequestDto: SortieVehiculeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateSortieVehiculeFormUsingPOST.');
            }
            // verify required parameter 'sortieVehiculeRequestDto' is not null or undefined
            if (sortieVehiculeRequestDto === null || sortieVehiculeRequestDto === undefined) {
                throw new RequiredError('sortieVehiculeRequestDto','Required parameter sortieVehiculeRequestDto was null or undefined when calling validateSortieVehiculeFormUsingPOST.');
            }
            const localVarPath = `/api/gardien-fourriere/dossier/{id}/sortie-mainlevee-coherente/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SortieVehiculeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(sortieVehiculeRequestDto || {}) : (sortieVehiculeRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GardienFourriereControllerApi - functional programming interface
 * @export
 */
export const GardienFourriereControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de confirmer les informations de son compte Keycloak
         * @param {string} username Nom d\'utilisateur du compte Keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAccountUsingPUT(username: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).confirmAccountUsingPUT(username, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de confirmer la validité des informations d\'une fourrière
         * @param {string} id Id de la fourrière, et non son id de corrélation, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmFourriereUsingPUT(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FourriereDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).confirmFourriereUsingPUT(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Création d\'un dossier via une fiche descriptive
         * @param {CreateDossierFromGardienFourriereDto} createDossierFromGardienFourriereDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDossierWithInitialInfoUsingPOST(createDossierFromGardienFourriereDto: CreateDossierFromGardienFourriereDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).createDossierWithInitialInfoUsingPOST(createDossierFromGardienFourriereDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de renseigner l\'entrée d\'un véhicule.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {EntreeVehiculeRequestDto} entreeVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entreeVehiculeWithFormulaireEntreeUsingPOST(id: string, entreeVehiculeRequestDto: EntreeVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).entreeVehiculeWithFormulaireEntreeUsingPOST(id, entreeVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Récupération des données d\'une fourrière.
         * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFourriereInfoUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FourriereDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).getFourriereInfoUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Mise à jour des données d\'une fourrière.
         * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
         * @param {ProfilFourriereRequestDto} profilFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFourriereInfoUsingPOST(idCorrelation: string, profilFourriereRequestDto: ProfilFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FourriereDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).setFourriereInfoUsingPOST(idCorrelation, profilFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de créer la fiche sortie d\'un véhicule.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {SortieVehiculeRequestDto} sortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortieVehiculeWithFormulaireSortieUsingPOST(id: string, sortieVehiculeRequestDto: SortieVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).sortieVehiculeWithFormulaireSortieUsingPOST(id, sortieVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Mise à jour des données d\'un bon d\'enlèvement gardien.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {BonEnlevementGardienRequestDto} bonEnlevementGardienRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBonEnlevementGardienUsingPOST(id: string, bonEnlevementGardienRequestDto: BonEnlevementGardienRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).updateBonEnlevementGardienUsingPOST(id, bonEnlevementGardienRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ spécifique d\'un bon d\'enlèvement gardien.
         * @param {'ID_CORRELATION_CENTRE_VHU' | 'FLAG_CARTE_GRISE_RETIREE' | 'MOTIF_ABSENCE_IMMATRICULATION' | 'RAISON_SOCIALE' | 'NUMERO_SIREN' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'NUMERO_AGREMENT' | 'PREFECTURE_AGREMENT'} field Intitulé du champ à vérifier.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {BonEnlevementGardienRequestDto} bonEnlevementGardienRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBonEnlevementGardienFieldUsingPOST(field: 'ID_CORRELATION_CENTRE_VHU' | 'FLAG_CARTE_GRISE_RETIREE' | 'MOTIF_ABSENCE_IMMATRICULATION' | 'RAISON_SOCIALE' | 'NUMERO_SIREN' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'NUMERO_AGREMENT' | 'PREFECTURE_AGREMENT', id: string, bonEnlevementGardienRequestDto: BonEnlevementGardienRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateBonEnlevementGardienFieldUsingPOST(field, id, bonEnlevementGardienRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation des données d\'un bon d\'enlèvement gardien.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {BonEnlevementGardienRequestDto} bonEnlevementGardienRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBonEnlevementGardienUsingPOST(id: string, bonEnlevementGardienRequestDto: BonEnlevementGardienRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateBonEnlevementGardienUsingPOST(id, bonEnlevementGardienRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ de la fiche entrée pour un dossier existant.
         * @param {'ID_CORRELATION_AUTORITE_FOURRIERE' | 'ID_CORRELATION_JURIDICTION' | 'DATE_ENLEVEMENT' | 'DATE_ENTREE'} field Le champ à valider, représenté par une énumération.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {EntreeVehiculeRequestDto} entreeVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEntreeVehiculeFormFieldUsingPOST(field: 'ID_CORRELATION_AUTORITE_FOURRIERE' | 'ID_CORRELATION_JURIDICTION' | 'DATE_ENLEVEMENT' | 'DATE_ENTREE', id: string, entreeVehiculeRequestDto: EntreeVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierEntreeViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateEntreeVehiculeFormFieldUsingPOST(field, id, entreeVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche entrée pour un dossier existant.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {EntreeVehiculeRequestDto} entreeVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEntreeVehiculeFormUsingPOST(id: string, entreeVehiculeRequestDto: EntreeVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierEntreeViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateEntreeVehiculeFormUsingPOST(id, entreeVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un champ de la fiche fourrière pour un dossier non créé.
         * @param {'ENTREE' | 'ENLEVEMENT' | 'FOURRIERE' | 'DATE_CONSTATATION'} field Le champ à valider, représenté par une énumération.
         * @param {FichesInfractionAndFourriereRequestsWrapperDto} fichesInfractionAndFourriereRequestsWrapperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheFourriereFieldWithoutDossierUsingPOST(field: 'ENTREE' | 'ENLEVEMENT' | 'FOURRIERE' | 'DATE_CONSTATATION', fichesInfractionAndFourriereRequestsWrapperDto: FichesInfractionAndFourriereRequestsWrapperDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateFicheFourriereFieldWithoutDossierUsingPOST(field, fichesInfractionAndFourriereRequestsWrapperDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche fourrière pour un dossier non créé.
         * @param {FichesInfractionAndFourriereRequestsWrapperDto} fichesInfractionAndFourriereRequestsWrapperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheFourriereWithoutDossierUsingPOST(fichesInfractionAndFourriereRequestsWrapperDto: FichesInfractionAndFourriereRequestsWrapperDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateFicheFourriereWithoutDossierUsingPOST(fichesInfractionAndFourriereRequestsWrapperDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un champ de la fiche infraction pour un dossier non créé.
         * @param {'AUTORITE_FOURRIERE' | 'FOURRIERE' | 'DATE_CONSTATATION' | 'NOM_AUTORITE_PRESCRIPTRICE' | 'QUALITE_AUTORITE_PRESCRIPTRICE' | 'NOM_AGENT' | 'NIGEND' | 'UNITE' | 'MAIL_UNITE' | 'MOTIVATION_MESURE' | 'LIEU_PRIVE' | 'LIEU_ENLEVEMENT' | 'COMMUNE' | 'NUIT' | 'PLUIE_NEIGE' | 'AUTORITE_POUR_LEVER_MESURE' | 'DATE_REDACTION'} field Le champ à valider, représenté par une énumération.
         * @param {FicheInfractionRequestDto} ficheInfractionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheInfractionFieldWithoutDossierUsingPOST(field: 'AUTORITE_FOURRIERE' | 'FOURRIERE' | 'DATE_CONSTATATION' | 'NOM_AUTORITE_PRESCRIPTRICE' | 'QUALITE_AUTORITE_PRESCRIPTRICE' | 'NOM_AGENT' | 'NIGEND' | 'UNITE' | 'MAIL_UNITE' | 'MOTIVATION_MESURE' | 'LIEU_PRIVE' | 'LIEU_ENLEVEMENT' | 'COMMUNE' | 'NUIT' | 'PLUIE_NEIGE' | 'AUTORITE_POUR_LEVER_MESURE' | 'DATE_REDACTION', ficheInfractionRequestDto: FicheInfractionRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateFicheInfractionFieldWithoutDossierUsingPOST(field, ficheInfractionRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de tous les champs de la fiche infraction pour un dossier non créé.
         * @param {FicheInfractionRequestDto} ficheInfractionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheInfractionWithoutDossierUsingPOST(ficheInfractionRequestDto: FicheInfractionRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateFicheInfractionWithoutDossierUsingPOST(ficheInfractionRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un champ de la fiche judiciaire pour un dossier non créé.
         * @param {'ID_CORRELATION_JURIDICTION' | 'NUMERO_PARQUET' | 'NUMERO_PV' | 'NUMERO_IDJ' | 'VALEUR_JURIDIQUE'} field Le champ à valider, représenté par une énumération.
         * @param {FicheJudiciaireWithMotifMefRequestDto} ficheJudiciaireWithMotifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheJudiciaireFieldUsingPOST(field: 'ID_CORRELATION_JURIDICTION' | 'NUMERO_PARQUET' | 'NUMERO_PV' | 'NUMERO_IDJ' | 'VALEUR_JURIDIQUE', ficheJudiciaireWithMotifMefRequestDto: FicheJudiciaireWithMotifMefRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateFicheJudiciaireFieldUsingPOST(field, ficheJudiciaireWithMotifMefRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de tous les champs de la fiche judiciaire pour un dossier non créé.
         * @param {FicheJudiciaireWithMotifMefRequestDto} ficheJudiciaireWithMotifMefRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheJudiciaireUsingPOST(ficheJudiciaireWithMotifMefRequestDto: FicheJudiciaireWithMotifMefRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateFicheJudiciaireUsingPOST(ficheJudiciaireWithMotifMefRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un seul champ de la fiche véhicule pour un dossier non créé.
         * @param {'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS'} field Le champ à valider, représenté par une énumération.
         * @param {FicheVehiculeRequestDto} ficheVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheVehiculeFieldWithoutDossierUsingPOST(field: 'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS', ficheVehiculeRequestDto: FicheVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateFicheVehiculeFieldWithoutDossierUsingPOST(field, ficheVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche véhicule pour un dossier non créé.
         * @param {FicheVehiculeRequestDto} ficheVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFicheVehiculeWithoutDossierUsingPOST(ficheVehiculeRequestDto: FicheVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateFicheVehiculeWithoutDossierUsingPOST(ficheVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ spécifique d\'une page profil fourrière.
         * @param {'ID' | 'ID_CORRELATION' | 'AUTORITES_FOURRIERE_IDS' | 'RAISON_SOCIALE' | 'NUMERO_AGREMENT' | 'DATE_AGREMENT_DEBUT' | 'DATE_AGREMENT_FIN' | 'NOMBRE_EMPLACEMENTS' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE_FIXE' | 'TELEPHONE_MOBILE' | 'ADRESSE_MAIL' | 'COORDONNEES_GPS' | 'NOM_RESPONSABLE' | 'ADRESSE_MAIL_RESPONSABLE' | 'HORAIRES'} field Intitulé du champ à vérifier.
         * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
         * @param {ProfilFourriereRequestDto} profilFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFourriereInfoFieldUsingPOST(field: 'ID' | 'ID_CORRELATION' | 'AUTORITES_FOURRIERE_IDS' | 'RAISON_SOCIALE' | 'NUMERO_AGREMENT' | 'DATE_AGREMENT_DEBUT' | 'DATE_AGREMENT_FIN' | 'NOMBRE_EMPLACEMENTS' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE_FIXE' | 'TELEPHONE_MOBILE' | 'ADRESSE_MAIL' | 'COORDONNEES_GPS' | 'NOM_RESPONSABLE' | 'ADRESSE_MAIL_RESPONSABLE' | 'HORAIRES', idCorrelation: string, profilFourriereRequestDto: ProfilFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProfilFourriereViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateFourriereInfoFieldUsingPOST(field, idCorrelation, profilFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation des données d\'une fourriere.
         * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
         * @param {ProfilFourriereRequestDto} profilFourriereRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFourriereInfoUsingPOST(idCorrelation: string, profilFourriereRequestDto: ProfilFourriereRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProfilFourriereViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateFourriereInfoUsingPOST(idCorrelation, profilFourriereRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider un champ de la fiche sortie pour un dossier existant.
         * @param {'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT'} field Le champ à valider, représenté par une énumération.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {SortieVehiculeRequestDto} sortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSortieVehiculeFormFieldUsingPOST(field: 'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT', id: string, sortieVehiculeRequestDto: SortieVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateSortieVehiculeFormFieldUsingPOST(field, id, sortieVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation de l\'ensemble des champs de la fiche sortie pour un dossier existant.
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {SortieVehiculeRequestDto} sortieVehiculeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSortieVehiculeFormUsingPOST(id: string, sortieVehiculeRequestDto: SortieVehiculeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierViolationsDto> {
            const localVarFetchArgs = GardienFourriereControllerApiFetchParamCreator(configuration).validateSortieVehiculeFormUsingPOST(id, sortieVehiculeRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * GardienFourriereControllerApi - object-oriented interface
 * @export
 * @class GardienFourriereControllerApi
 * @extends {BaseAPI}
 */
export class GardienFourriereControllerApi extends BaseAPI {
    /**
     * @summary Route permettant de confirmer les informations de son compte Keycloak
     * @param {string} username Nom d\'utilisateur du compte Keycloak
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmAccountUsingPUT(username: string, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).confirmAccountUsingPUT(username, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de confirmer la validité des informations d\'une fourrière
     * @param {string} id Id de la fourrière, et non son id de corrélation, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmFourriereUsingPUT(id: string, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).confirmFourriereUsingPUT(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Création d\'un dossier via une fiche descriptive
     * @param {CreateDossierFromGardienFourriereDto} createDossierFromGardienFourriereDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createDossierWithInitialInfoUsingPOST(createDossierFromGardienFourriereDto: CreateDossierFromGardienFourriereDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).createDossierWithInitialInfoUsingPOST(createDossierFromGardienFourriereDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de renseigner l\'entrée d\'un véhicule.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {EntreeVehiculeRequestDto} entreeVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public entreeVehiculeWithFormulaireEntreeUsingPOST(id: string, entreeVehiculeRequestDto: EntreeVehiculeRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).entreeVehiculeWithFormulaireEntreeUsingPOST(id, entreeVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Récupération des données d\'une fourrière.
     * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFourriereInfoUsingGET(idCorrelation: string, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).getFourriereInfoUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Mise à jour des données d\'une fourrière.
     * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
     * @param {ProfilFourriereRequestDto} profilFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setFourriereInfoUsingPOST(idCorrelation: string, profilFourriereRequestDto: ProfilFourriereRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).setFourriereInfoUsingPOST(idCorrelation, profilFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de créer la fiche sortie d\'un véhicule.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {SortieVehiculeRequestDto} sortieVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sortieVehiculeWithFormulaireSortieUsingPOST(id: string, sortieVehiculeRequestDto: SortieVehiculeRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).sortieVehiculeWithFormulaireSortieUsingPOST(id, sortieVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Mise à jour des données d\'un bon d\'enlèvement gardien.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {BonEnlevementGardienRequestDto} bonEnlevementGardienRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBonEnlevementGardienUsingPOST(id: string, bonEnlevementGardienRequestDto: BonEnlevementGardienRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).updateBonEnlevementGardienUsingPOST(id, bonEnlevementGardienRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ spécifique d\'un bon d\'enlèvement gardien.
     * @param {'ID_CORRELATION_CENTRE_VHU' | 'FLAG_CARTE_GRISE_RETIREE' | 'MOTIF_ABSENCE_IMMATRICULATION' | 'RAISON_SOCIALE' | 'NUMERO_SIREN' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'NUMERO_AGREMENT' | 'PREFECTURE_AGREMENT'} field Intitulé du champ à vérifier.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {BonEnlevementGardienRequestDto} bonEnlevementGardienRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateBonEnlevementGardienFieldUsingPOST(field: 'ID_CORRELATION_CENTRE_VHU' | 'FLAG_CARTE_GRISE_RETIREE' | 'MOTIF_ABSENCE_IMMATRICULATION' | 'RAISON_SOCIALE' | 'NUMERO_SIREN' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'NUMERO_AGREMENT' | 'PREFECTURE_AGREMENT', id: string, bonEnlevementGardienRequestDto: BonEnlevementGardienRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateBonEnlevementGardienFieldUsingPOST(field, id, bonEnlevementGardienRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation des données d\'un bon d\'enlèvement gardien.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {BonEnlevementGardienRequestDto} bonEnlevementGardienRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateBonEnlevementGardienUsingPOST(id: string, bonEnlevementGardienRequestDto: BonEnlevementGardienRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateBonEnlevementGardienUsingPOST(id, bonEnlevementGardienRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ de la fiche entrée pour un dossier existant.
     * @param {'ID_CORRELATION_AUTORITE_FOURRIERE' | 'ID_CORRELATION_JURIDICTION' | 'DATE_ENLEVEMENT' | 'DATE_ENTREE'} field Le champ à valider, représenté par une énumération.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {EntreeVehiculeRequestDto} entreeVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateEntreeVehiculeFormFieldUsingPOST(field: 'ID_CORRELATION_AUTORITE_FOURRIERE' | 'ID_CORRELATION_JURIDICTION' | 'DATE_ENLEVEMENT' | 'DATE_ENTREE', id: string, entreeVehiculeRequestDto: EntreeVehiculeRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateEntreeVehiculeFormFieldUsingPOST(field, id, entreeVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de la fiche entrée pour un dossier existant.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {EntreeVehiculeRequestDto} entreeVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateEntreeVehiculeFormUsingPOST(id: string, entreeVehiculeRequestDto: EntreeVehiculeRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateEntreeVehiculeFormUsingPOST(id, entreeVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un champ de la fiche fourrière pour un dossier non créé.
     * @param {'ENTREE' | 'ENLEVEMENT' | 'FOURRIERE' | 'DATE_CONSTATATION'} field Le champ à valider, représenté par une énumération.
     * @param {FichesInfractionAndFourriereRequestsWrapperDto} fichesInfractionAndFourriereRequestsWrapperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheFourriereFieldWithoutDossierUsingPOST(field: 'ENTREE' | 'ENLEVEMENT' | 'FOURRIERE' | 'DATE_CONSTATATION', fichesInfractionAndFourriereRequestsWrapperDto: FichesInfractionAndFourriereRequestsWrapperDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateFicheFourriereFieldWithoutDossierUsingPOST(field, fichesInfractionAndFourriereRequestsWrapperDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de la fiche fourrière pour un dossier non créé.
     * @param {FichesInfractionAndFourriereRequestsWrapperDto} fichesInfractionAndFourriereRequestsWrapperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheFourriereWithoutDossierUsingPOST(fichesInfractionAndFourriereRequestsWrapperDto: FichesInfractionAndFourriereRequestsWrapperDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateFicheFourriereWithoutDossierUsingPOST(fichesInfractionAndFourriereRequestsWrapperDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un champ de la fiche infraction pour un dossier non créé.
     * @param {'AUTORITE_FOURRIERE' | 'FOURRIERE' | 'DATE_CONSTATATION' | 'NOM_AUTORITE_PRESCRIPTRICE' | 'QUALITE_AUTORITE_PRESCRIPTRICE' | 'NOM_AGENT' | 'NIGEND' | 'UNITE' | 'MAIL_UNITE' | 'MOTIVATION_MESURE' | 'LIEU_PRIVE' | 'LIEU_ENLEVEMENT' | 'COMMUNE' | 'NUIT' | 'PLUIE_NEIGE' | 'AUTORITE_POUR_LEVER_MESURE' | 'DATE_REDACTION'} field Le champ à valider, représenté par une énumération.
     * @param {FicheInfractionRequestDto} ficheInfractionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheInfractionFieldWithoutDossierUsingPOST(field: 'AUTORITE_FOURRIERE' | 'FOURRIERE' | 'DATE_CONSTATATION' | 'NOM_AUTORITE_PRESCRIPTRICE' | 'QUALITE_AUTORITE_PRESCRIPTRICE' | 'NOM_AGENT' | 'NIGEND' | 'UNITE' | 'MAIL_UNITE' | 'MOTIVATION_MESURE' | 'LIEU_PRIVE' | 'LIEU_ENLEVEMENT' | 'COMMUNE' | 'NUIT' | 'PLUIE_NEIGE' | 'AUTORITE_POUR_LEVER_MESURE' | 'DATE_REDACTION', ficheInfractionRequestDto: FicheInfractionRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateFicheInfractionFieldWithoutDossierUsingPOST(field, ficheInfractionRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de tous les champs de la fiche infraction pour un dossier non créé.
     * @param {FicheInfractionRequestDto} ficheInfractionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheInfractionWithoutDossierUsingPOST(ficheInfractionRequestDto: FicheInfractionRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateFicheInfractionWithoutDossierUsingPOST(ficheInfractionRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un champ de la fiche judiciaire pour un dossier non créé.
     * @param {'ID_CORRELATION_JURIDICTION' | 'NUMERO_PARQUET' | 'NUMERO_PV' | 'NUMERO_IDJ' | 'VALEUR_JURIDIQUE'} field Le champ à valider, représenté par une énumération.
     * @param {FicheJudiciaireWithMotifMefRequestDto} ficheJudiciaireWithMotifMefRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheJudiciaireFieldUsingPOST(field: 'ID_CORRELATION_JURIDICTION' | 'NUMERO_PARQUET' | 'NUMERO_PV' | 'NUMERO_IDJ' | 'VALEUR_JURIDIQUE', ficheJudiciaireWithMotifMefRequestDto: FicheJudiciaireWithMotifMefRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateFicheJudiciaireFieldUsingPOST(field, ficheJudiciaireWithMotifMefRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de tous les champs de la fiche judiciaire pour un dossier non créé.
     * @param {FicheJudiciaireWithMotifMefRequestDto} ficheJudiciaireWithMotifMefRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheJudiciaireUsingPOST(ficheJudiciaireWithMotifMefRequestDto: FicheJudiciaireWithMotifMefRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateFicheJudiciaireUsingPOST(ficheJudiciaireWithMotifMefRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un seul champ de la fiche véhicule pour un dossier non créé.
     * @param {'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS'} field Le champ à valider, représenté par une énumération.
     * @param {FicheVehiculeRequestDto} ficheVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheVehiculeFieldWithoutDossierUsingPOST(field: 'DESCRIPTION_GENRE' | 'DESCRIPTION_MARQUE' | 'DESCRIPTION_MODELE' | 'DESCRIPTION_COULEUR' | 'ETAT_LIBELLE' | 'ETAT_PRECISION' | 'IMMATRICULATION_SANS_PLAQUE' | 'IMMATRICULATION_PAYS_ETRANGER' | 'IMMATRICULATION_NUMERO' | 'IMMATRICULATION_NUMERO_VISIBLE' | 'IMMATRICULATION_VIN' | 'VERROUILLAGE_PORTES' | 'VERROUILLAGE_COFFRES' | 'ACCESSOIRES_AUTO_RADIO_VISIBLE' | 'ACCESSOIRES_POSTE_CB_VISIBLE' | 'ACCESSOIRES_TELEPHONE_PORTABLE' | 'ACCESSOIRES_NOMBRE_ANTENNES' | 'ACCESSOIRES_OBJETS_VISIBLES' | 'ACCESSOIRES_OBSERVATIONS', ficheVehiculeRequestDto: FicheVehiculeRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateFicheVehiculeFieldWithoutDossierUsingPOST(field, ficheVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de la fiche véhicule pour un dossier non créé.
     * @param {FicheVehiculeRequestDto} ficheVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFicheVehiculeWithoutDossierUsingPOST(ficheVehiculeRequestDto: FicheVehiculeRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateFicheVehiculeWithoutDossierUsingPOST(ficheVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ spécifique d\'une page profil fourrière.
     * @param {'ID' | 'ID_CORRELATION' | 'AUTORITES_FOURRIERE_IDS' | 'RAISON_SOCIALE' | 'NUMERO_AGREMENT' | 'DATE_AGREMENT_DEBUT' | 'DATE_AGREMENT_FIN' | 'NOMBRE_EMPLACEMENTS' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE_FIXE' | 'TELEPHONE_MOBILE' | 'ADRESSE_MAIL' | 'COORDONNEES_GPS' | 'NOM_RESPONSABLE' | 'ADRESSE_MAIL_RESPONSABLE' | 'HORAIRES'} field Intitulé du champ à vérifier.
     * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
     * @param {ProfilFourriereRequestDto} profilFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFourriereInfoFieldUsingPOST(field: 'ID' | 'ID_CORRELATION' | 'AUTORITES_FOURRIERE_IDS' | 'RAISON_SOCIALE' | 'NUMERO_AGREMENT' | 'DATE_AGREMENT_DEBUT' | 'DATE_AGREMENT_FIN' | 'NOMBRE_EMPLACEMENTS' | 'NOM_VOIE' | 'NUMERO_VOIE' | 'ADRESSE' | 'COMPLEMENT_ADRESSE' | 'CODE_POSTAL' | 'COMMUNE' | 'TELEPHONE_FIXE' | 'TELEPHONE_MOBILE' | 'ADRESSE_MAIL' | 'COORDONNEES_GPS' | 'NOM_RESPONSABLE' | 'ADRESSE_MAIL_RESPONSABLE' | 'HORAIRES', idCorrelation: string, profilFourriereRequestDto: ProfilFourriereRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateFourriereInfoFieldUsingPOST(field, idCorrelation, profilFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation des données d\'une fourriere.
     * @param {string} idCorrelation Id de la fourrière, représenté par un UUID.
     * @param {ProfilFourriereRequestDto} profilFourriereRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateFourriereInfoUsingPOST(idCorrelation: string, profilFourriereRequestDto: ProfilFourriereRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateFourriereInfoUsingPOST(idCorrelation, profilFourriereRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider un champ de la fiche sortie pour un dossier existant.
     * @param {'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT'} field Le champ à valider, représenté par une énumération.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {SortieVehiculeRequestDto} sortieVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateSortieVehiculeFormFieldUsingPOST(field: 'DATE_SORTIE' | 'MOTIF_SORTIE' | 'NOM_PROPRIETAIRE_COHERENT' | 'CODE_ML_CORRECT' | 'COMMENT', id: string, sortieVehiculeRequestDto: SortieVehiculeRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateSortieVehiculeFormFieldUsingPOST(field, id, sortieVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation de l\'ensemble des champs de la fiche sortie pour un dossier existant.
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {SortieVehiculeRequestDto} sortieVehiculeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateSortieVehiculeFormUsingPOST(id: string, sortieVehiculeRequestDto: SortieVehiculeRequestDto, options?: any) {
        return GardienFourriereControllerApiFp(this.configuration).validateSortieVehiculeFormUsingPOST(id, sortieVehiculeRequestDto, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// HealthCheckControllerApi /////////////////////////////////////////////////////

/**
 * HealthCheckControllerApi - fetch parameter creator
 * @export
 */
export const HealthCheckControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Récupération de l\'état de fonctionnement des MS dossiers et référentiels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMicroServiceStatusUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/health`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthCheckControllerApi - functional programming interface
 * @export
 */
export const HealthCheckControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Récupération de l\'état de fonctionnement des MS dossiers et référentiels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMicroServiceStatusUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = HealthCheckControllerApiFetchParamCreator(configuration).getMicroServiceStatusUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * HealthCheckControllerApi - object-oriented interface
 * @export
 * @class HealthCheckControllerApi
 * @extends {BaseAPI}
 */
export class HealthCheckControllerApi extends BaseAPI {
    /**
     * @summary Récupération de l\'état de fonctionnement des MS dossiers et référentiels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMicroServiceStatusUsingGET(options?: any) {
        return HealthCheckControllerApiFp(this.configuration).getMicroServiceStatusUsingGET(options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// JusticeControllerApi /////////////////////////////////////////////////////

/**
 * JusticeControllerApi - fetch parameter creator
 * @export
 */
export const JusticeControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de modifier les données judiciaires d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonneesJudiciairesUsingPOST(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateDonneesJudiciairesUsingPOST.');
            }
            // verify required parameter 'updateDonneesJudiciairesRequestDto' is not null or undefined
            if (updateDonneesJudiciairesRequestDto === null || updateDonneesJudiciairesRequestDto === undefined) {
                throw new RequiredError('updateDonneesJudiciairesRequestDto','Required parameter updateDonneesJudiciairesRequestDto was null or undefined when calling updateDonneesJudiciairesUsingPOST.');
            }
            const localVarPath = `/api/justice/dossier/{id}/judiciaires`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesJudiciairesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesJudiciairesRequestDto || {}) : (updateDonneesJudiciairesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider une modification des données judiciaires d\'un dossier
         * @param {'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesJudiciairesFieldUsingPOST(field: 'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE', id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUpdateDonneesJudiciairesFieldUsingPOST.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateDonneesJudiciairesFieldUsingPOST.');
            }
            // verify required parameter 'updateDonneesJudiciairesRequestDto' is not null or undefined
            if (updateDonneesJudiciairesRequestDto === null || updateDonneesJudiciairesRequestDto === undefined) {
                throw new RequiredError('updateDonneesJudiciairesRequestDto','Required parameter updateDonneesJudiciairesRequestDto was null or undefined when calling validateUpdateDonneesJudiciairesFieldUsingPOST.');
            }
            const localVarPath = `/api/justice/dossier/{id}/judiciaires/validation/{field}`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesJudiciairesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesJudiciairesRequestDto || {}) : (updateDonneesJudiciairesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de valider les modifications des données judiciaires d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesJudiciairesUsingPOST(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling validateUpdateDonneesJudiciairesUsingPOST.');
            }
            // verify required parameter 'updateDonneesJudiciairesRequestDto' is not null or undefined
            if (updateDonneesJudiciairesRequestDto === null || updateDonneesJudiciairesRequestDto === undefined) {
                throw new RequiredError('updateDonneesJudiciairesRequestDto','Required parameter updateDonneesJudiciairesRequestDto was null or undefined when calling validateUpdateDonneesJudiciairesUsingPOST.');
            }
            const localVarPath = `/api/justice/dossier/{id}/judiciaires/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateDonneesJudiciairesRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(updateDonneesJudiciairesRequestDto || {}) : (updateDonneesJudiciairesRequestDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JusticeControllerApi - functional programming interface
 * @export
 */
export const JusticeControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de modifier les données judiciaires d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDonneesJudiciairesUsingPOST(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = JusticeControllerApiFetchParamCreator(configuration).updateDonneesJudiciairesUsingPOST(id, updateDonneesJudiciairesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider une modification des données judiciaires d\'un dossier
         * @param {'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE'} field 
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesJudiciairesFieldUsingPOST(field: 'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE', id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = JusticeControllerApiFetchParamCreator(configuration).validateUpdateDonneesJudiciairesFieldUsingPOST(field, id, updateDonneesJudiciairesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de valider les modifications des données judiciaires d\'un dossier
         * @param {string} id Id du dossier, représenté par un UUID.
         * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateDonneesJudiciairesUsingPOST(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierModificationViolationsDto> {
            const localVarFetchArgs = JusticeControllerApiFetchParamCreator(configuration).validateUpdateDonneesJudiciairesUsingPOST(id, updateDonneesJudiciairesRequestDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * JusticeControllerApi - object-oriented interface
 * @export
 * @class JusticeControllerApi
 * @extends {BaseAPI}
 */
export class JusticeControllerApi extends BaseAPI {
    /**
     * @summary Route permettant de modifier les données judiciaires d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDonneesJudiciairesUsingPOST(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any) {
        return JusticeControllerApiFp(this.configuration).updateDonneesJudiciairesUsingPOST(id, updateDonneesJudiciairesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider une modification des données judiciaires d\'un dossier
     * @param {'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE'} field 
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateDonneesJudiciairesFieldUsingPOST(field: 'NEW_ID_CORRELATION_JURIDICTION' | 'NEW_NUMERO_PARQUET' | 'NEW_NUMERO_PV' | 'NEW_NUMERO_IDJ' | 'NEW_VALEUR_JURIDIQUE', id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any) {
        return JusticeControllerApiFp(this.configuration).validateUpdateDonneesJudiciairesFieldUsingPOST(field, id, updateDonneesJudiciairesRequestDto, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de valider les modifications des données judiciaires d\'un dossier
     * @param {string} id Id du dossier, représenté par un UUID.
     * @param {UpdateDonneesJudiciairesRequestDto} updateDonneesJudiciairesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUpdateDonneesJudiciairesUsingPOST(id: string, updateDonneesJudiciairesRequestDto: UpdateDonneesJudiciairesRequestDto, options?: any) {
        return JusticeControllerApiFp(this.configuration).validateUpdateDonneesJudiciairesUsingPOST(id, updateDonneesJudiciairesRequestDto, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// ManuelControllerApi /////////////////////////////////////////////////////

/**
 * ManuelControllerApi - fetch parameter creator
 * @export
 */
export const ManuelControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de télécharger un manuel Bdr
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile L\'utilisateur voulant télécharger le manuel, représenté par un UserProfile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadManualBdrUsingGET(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', options: any = {}): FetchArgs {
            // verify required parameter 'userProfile' is not null or undefined
            if (userProfile === null || userProfile === undefined) {
                throw new RequiredError('userProfile','Required parameter userProfile was null or undefined when calling downloadManualBdrUsingGET.');
            }
            const localVarPath = `/api/manual/bdr/download/{userProfile}`
                .replace(`{${"userProfile"}}`, encodeURIComponent(String(userProfile)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de télécharger un manuel utilisateur
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile L\'utilisateur voulant télécharger le manuel, représenté par un UserProfile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadManualUtilisateurUsingGET(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', options: any = {}): FetchArgs {
            // verify required parameter 'userProfile' is not null or undefined
            if (userProfile === null || userProfile === undefined) {
                throw new RequiredError('userProfile','Required parameter userProfile was null or undefined when calling downloadManualUtilisateurUsingGET.');
            }
            const localVarPath = `/api/manual/download/{userProfile}`
                .replace(`{${"userProfile"}}`, encodeURIComponent(String(userProfile)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de sauvegarder un manuel Bdr
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
         * @param {any} file Le manuel, représenté par un InputStream.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManualBdrUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options: any = {}): FetchArgs {
            // verify required parameter 'userProfile' is not null or undefined
            if (userProfile === null || userProfile === undefined) {
                throw new RequiredError('userProfile','Required parameter userProfile was null or undefined when calling saveManualBdrUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling saveManualBdrUsingPOST.');
            }
            const localVarPath = `/api/manual/bdr/{userProfile}`
                .replace(`{${"userProfile"}}`, encodeURIComponent(String(userProfile)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de sauvegarder un manuel utilisateur
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
         * @param {any} file Le manuel, représenté par un InputStream.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManualUtilisateurUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options: any = {}): FetchArgs {
            // verify required parameter 'userProfile' is not null or undefined
            if (userProfile === null || userProfile === undefined) {
                throw new RequiredError('userProfile','Required parameter userProfile was null or undefined when calling saveManualUtilisateurUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling saveManualUtilisateurUsingPOST.');
            }
            const localVarPath = `/api/manual/{userProfile}`
                .replace(`{${"userProfile"}}`, encodeURIComponent(String(userProfile)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManuelControllerApi - functional programming interface
 * @export
 */
export const ManuelControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant de télécharger un manuel Bdr
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile L\'utilisateur voulant télécharger le manuel, représenté par un UserProfile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadManualBdrUsingGET(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManuelControllerApiFetchParamCreator(configuration).downloadManualBdrUsingGET(userProfile, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de télécharger un manuel utilisateur
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile L\'utilisateur voulant télécharger le manuel, représenté par un UserProfile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadManualUtilisateurUsingGET(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManuelControllerApiFetchParamCreator(configuration).downloadManualUtilisateurUsingGET(userProfile, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de sauvegarder un manuel Bdr
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
         * @param {any} file Le manuel, représenté par un InputStream.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManualBdrUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManuelControllerApiFetchParamCreator(configuration).saveManualBdrUsingPOST(userProfile, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de sauvegarder un manuel utilisateur
         * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
         * @param {any} file Le manuel, représenté par un InputStream.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManualUtilisateurUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManuelControllerApiFetchParamCreator(configuration).saveManualUtilisateurUsingPOST(userProfile, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManuelControllerApi - object-oriented interface
 * @export
 * @class ManuelControllerApi
 * @extends {BaseAPI}
 */
export class ManuelControllerApi extends BaseAPI {
    /**
     * @summary Route permettant de télécharger un manuel Bdr
     * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile L\'utilisateur voulant télécharger le manuel, représenté par un UserProfile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadManualBdrUsingGET(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', options?: any) {
        return ManuelControllerApiFp(this.configuration).downloadManualBdrUsingGET(userProfile, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de télécharger un manuel utilisateur
     * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile L\'utilisateur voulant télécharger le manuel, représenté par un UserProfile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadManualUtilisateurUsingGET(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', options?: any) {
        return ManuelControllerApiFp(this.configuration).downloadManualUtilisateurUsingGET(userProfile, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de sauvegarder un manuel Bdr
     * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
     * @param {any} file Le manuel, représenté par un InputStream.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveManualBdrUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options?: any) {
        return ManuelControllerApiFp(this.configuration).saveManualBdrUsingPOST(userProfile, file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de sauvegarder un manuel utilisateur
     * @param {'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE'} userProfile Le type d\'utilisateur visé par le manuel, représenté par un UserProfile.
     * @param {any} file Le manuel, représenté par un InputStream.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveManualUtilisateurUsingPOST(userProfile: 'ADMIN_FONCTIONNEL' | 'FORCE_DE_L_ORDRE' | 'GARDIEN_FOURRIERE' | 'AUTORITE_FOURRIERE' | 'DSR_BLR' | 'CSU' | 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | 'UNITE_OPERATIONNELLE' | 'NATIONAL_JUSTICE', file: any, options?: any) {
        return ManuelControllerApiFp(this.configuration).saveManualUtilisateurUsingPOST(userProfile, file, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// PieceJointeControllerApi /////////////////////////////////////////////////////

/**
 * PieceJointeControllerApi - fetch parameter creator
 * @export
 */
export const PieceJointeControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Suppression d\'une des pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePieceJointeUsingDELETE(dossierId: string, type: string, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling deletePieceJointeUsingDELETE.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling deletePieceJointeUsingDELETE.');
            }
            const localVarPath = `/api/dossier/{dossierId}/piece-jointe/{type}`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Téléchargement d\'une des pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsingGET(dossierId: string, type: string, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling downloadUsingGET.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling downloadUsingGET.');
            }
            const localVarPath = `/api/dossier/{dossierId}/piece-jointe/{type}`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route permettant de récupérer la liste des types de pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPieceJointeTypesUsingGET(dossierId: string, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling getPieceJointeTypesUsingGET.');
            }
            const localVarPath = `/api/dossier/{dossierId}/pieces-jointes/types`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary API permettant d\'uploader une pièce jointe pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPieceJointeUsingPOST(dossierId: string, type: string, file: any, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling uploadPieceJointeUsingPOST.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling uploadPieceJointeUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadPieceJointeUsingPOST.');
            }
            const localVarPath = `/api/dossier/{dossierId}/piece-jointe/{type}`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation d\'un des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {'TYPE' | 'FILE'} field Le champ à valider, représenté par une énumération.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadPieceJointeFieldUsingPOST(dossierId: string, field: 'TYPE' | 'FILE', type: string, file: any, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling validateUploadPieceJointeFieldUsingPOST.');
            }
            // verify required parameter 'field' is not null or undefined
            if (field === null || field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling validateUploadPieceJointeFieldUsingPOST.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling validateUploadPieceJointeFieldUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling validateUploadPieceJointeFieldUsingPOST.');
            }
            const localVarPath = `/api/dossier/{dossierId}/piece-jointe/{type}/validation/{field}`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"field"}}`, encodeURIComponent(String(field)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Validation des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadPieceJointeUsingPOST(dossierId: string, type: string, file: any, options: any = {}): FetchArgs {
            // verify required parameter 'dossierId' is not null or undefined
            if (dossierId === null || dossierId === undefined) {
                throw new RequiredError('dossierId','Required parameter dossierId was null or undefined when calling validateUploadPieceJointeUsingPOST.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling validateUploadPieceJointeUsingPOST.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling validateUploadPieceJointeUsingPOST.');
            }
            const localVarPath = `/api/dossier/{dossierId}/piece-jointe/{type}/validation`
                .replace(`{${"dossierId"}}`, encodeURIComponent(String(dossierId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PieceJointeControllerApi - functional programming interface
 * @export
 */
export const PieceJointeControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Suppression d\'une des pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePieceJointeUsingDELETE(dossierId: string, type: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PieceJointeControllerApiFetchParamCreator(configuration).deletePieceJointeUsingDELETE(dossierId, type, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Téléchargement d\'une des pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsingGET(dossierId: string, type: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PieceJointeControllerApiFetchParamCreator(configuration).downloadUsingGET(dossierId, type, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route permettant de récupérer la liste des types de pièces jointes disponibles pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPieceJointeTypesUsingGET(dossierId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<PieceJointeTypeResponseDto>> {
            const localVarFetchArgs = PieceJointeControllerApiFetchParamCreator(configuration).getPieceJointeTypesUsingGET(dossierId, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary API permettant d\'uploader une pièce jointe pour un dossier
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPieceJointeUsingPOST(dossierId: string, type: string, file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = PieceJointeControllerApiFetchParamCreator(configuration).uploadPieceJointeUsingPOST(dossierId, type, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation d\'un des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {'TYPE' | 'FILE'} field Le champ à valider, représenté par une énumération.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadPieceJointeFieldUsingPOST(dossierId: string, field: 'TYPE' | 'FILE', type: string, file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadPieceJointeFileViolationsDto> {
            const localVarFetchArgs = PieceJointeControllerApiFetchParamCreator(configuration).validateUploadPieceJointeFieldUsingPOST(dossierId, field, type, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Validation des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
         * @param {string} dossierId Id du dossier, représenté par un UUID.
         * @param {string} type Type de la pièce jointe
         * @param {any} file Fichier de la pièce jointe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUploadPieceJointeUsingPOST(dossierId: string, type: string, file: any, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UploadPieceJointeFileViolationsDto> {
            const localVarFetchArgs = PieceJointeControllerApiFetchParamCreator(configuration).validateUploadPieceJointeUsingPOST(dossierId, type, file, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PieceJointeControllerApi - object-oriented interface
 * @export
 * @class PieceJointeControllerApi
 * @extends {BaseAPI}
 */
export class PieceJointeControllerApi extends BaseAPI {
    /**
     * @summary Suppression d\'une des pièces jointes disponibles pour un dossier
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {string} type Type de la pièce jointe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePieceJointeUsingDELETE(dossierId: string, type: string, options?: any) {
        return PieceJointeControllerApiFp(this.configuration).deletePieceJointeUsingDELETE(dossierId, type, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Téléchargement d\'une des pièces jointes disponibles pour un dossier
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {string} type Type de la pièce jointe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadUsingGET(dossierId: string, type: string, options?: any) {
        return PieceJointeControllerApiFp(this.configuration).downloadUsingGET(dossierId, type, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route permettant de récupérer la liste des types de pièces jointes disponibles pour un dossier
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPieceJointeTypesUsingGET(dossierId: string, options?: any) {
        return PieceJointeControllerApiFp(this.configuration).getPieceJointeTypesUsingGET(dossierId, options)(this.fetch, this.basePath);
    }

    /**
     * @summary API permettant d\'uploader une pièce jointe pour un dossier
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {string} type Type de la pièce jointe
     * @param {any} file Fichier de la pièce jointe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPieceJointeUsingPOST(dossierId: string, type: string, file: any, options?: any) {
        return PieceJointeControllerApiFp(this.configuration).uploadPieceJointeUsingPOST(dossierId, type, file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation d\'un des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {'TYPE' | 'FILE'} field Le champ à valider, représenté par une énumération.
     * @param {string} type Type de la pièce jointe
     * @param {any} file Fichier de la pièce jointe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUploadPieceJointeFieldUsingPOST(dossierId: string, field: 'TYPE' | 'FILE', type: string, file: any, options?: any) {
        return PieceJointeControllerApiFp(this.configuration).validateUploadPieceJointeFieldUsingPOST(dossierId, field, type, file, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Validation des champs pour l\'upload d\'une pièce jointe pour un dossier existant.
     * @param {string} dossierId Id du dossier, représenté par un UUID.
     * @param {string} type Type de la pièce jointe
     * @param {any} file Fichier de la pièce jointe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateUploadPieceJointeUsingPOST(dossierId: string, type: string, file: any, options?: any) {
        return PieceJointeControllerApiFp(this.configuration).validateUploadPieceJointeUsingPOST(dossierId, type, file, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// ReferentielControllerApi /////////////////////////////////////////////////////

/**
 * objet contenant les query params de la route getAllInformationMessageUsingGET
 * @export
 * @interface GetAllInformationMessageUsingGETQueryParams
 */
export interface GetAllInformationMessageUsingGETQueryParams {
    /**
     * 
     * @type {number}
     * @memberof GetAllInformationMessageUsingGETQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllInformationMessageUsingGETQueryParams
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetAllInformationMessageUsingGETQueryParams
     */
    search?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllInformationMessageUsingGETQueryParams
     */
    sortByEndDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllInformationMessageUsingGETQueryParams
     */
    sortByStartDate?: boolean;
}

/**
 * objet contenant les query params de la route getOnlyValidFaqsUsingGET
 * @export
 * @interface GetOnlyValidFaqsUsingGETQueryParams
 */
export interface GetOnlyValidFaqsUsingGETQueryParams {
    /**
     * Si spécifié, filtre les faqs qui sont associées ou non à un domaine
     * @type {boolean}
     * @memberof GetOnlyValidFaqsUsingGETQueryParams
     */
    domaine: boolean;
}

/**
 * objet contenant les query params de la route getValidJuridictionByLibelleOrNumeroUsingGET
 * @export
 * @interface GetValidJuridictionByLibelleOrNumeroUsingGETQueryParams
 */
export interface GetValidJuridictionByLibelleOrNumeroUsingGETQueryParams {
    /**
     * 
     * @type {'LIBELLE' | 'NUMERO'}
     * @memberof GetValidJuridictionByLibelleOrNumeroUsingGETQueryParams
     */
    field: 'LIBELLE' | 'NUMERO';
    /**
     * Mots clef de recherche.
     * @type {string}
     * @memberof GetValidJuridictionByLibelleOrNumeroUsingGETQueryParams
     */
    searched: string;
}

/**
 * objet contenant les query params de la route searchAllMotifMefUsingSpecsUsingGET
 * @export
 * @interface SearchAllMotifMefUsingSpecsUsingGETQueryParams
 */
export interface SearchAllMotifMefUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchAllMotifMefUsingSpecsUsingGETQueryParams
     * @type {SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParams
     */
    filters: SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchAllMotifMefUsingSpecsUsingGETQueryParams
     * @type {SearchAllMotifMefUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParams
     */
    sorts: SearchAllMotifMefUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    dateFromStartOfValidity?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    dateToStartOfValidity?: Date;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    enabled?: boolean;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    isDicem?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    isLieuDitEnabled?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    isRodeo?: boolean;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    libelle?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    natureLibelleCourt?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
}

export interface SearchAllMotifMefUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsSorts
    */
    libelle?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAllMotifMefUsingSpecsUsingGETQueryParamsSorts
    */
    natureMef?: boolean;
}

/**
 * objet contenant les query params de la route searchAutoriteFourriereUsingSpecsUsingGET
 * @export
 * @interface SearchAutoriteFourriereUsingSpecsUsingGETQueryParams
 */
export interface SearchAutoriteFourriereUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchAutoriteFourriereUsingSpecsUsingGETQueryParams
     * @type {SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParams
     */
    filters: SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchAutoriteFourriereUsingSpecsUsingGETQueryParams
     * @type {SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParams
     */
    sorts: SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    codeDepartement?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    codePostal?: string;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    dateFromStartOfValidity?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    dateToStartOfValidity?: Date;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    emptyIdAlienation?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    emptyIdAlienationUtilisateur?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    enabled?: boolean;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    idAlienation?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    idAlienationUtilisateur?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelationTypeAutorite?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    libelle?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    libelleDepartement?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    ville?: string;
}

export interface SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsSorts
    */
    codePostal?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsSorts
    */
    departement?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsSorts
    */
    libelle?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsSorts
    */
    type?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchAutoriteFourriereUsingSpecsUsingGETQueryParamsSorts
    */
    ville?: boolean;
}

/**
 * objet contenant les query params de la route searchCentreVHUUsingSpecsUsingGET
 * @export
 * @interface SearchCentreVHUUsingSpecsUsingGETQueryParams
 */
export interface SearchCentreVHUUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchCentreVHUUsingSpecsUsingGETQueryParams
     * @type {SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParams
     */
    filters: SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchCentreVHUUsingSpecsUsingGETQueryParams
     * @type {SearchCentreVHUUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParams
     */
    sorts: SearchCentreVHUUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters
    */
    codePostal?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters
    */
    commune?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters
    */
    numeroAgrementVHU?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters
    */
    raisonSociale?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters
    */
    siren?: string;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

export interface SearchCentreVHUUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsSorts
    */
    codePostal?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsSorts
    */
    commune?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsSorts
    */
    numeroAgrementVHU?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchCentreVHUUsingSpecsUsingGETQueryParamsSorts
    */
    raisonSociale?: boolean;
}

/**
 * objet contenant les query params de la route searchCommuneEnlevementUsingGET
 * @export
 * @interface SearchCommuneEnlevementUsingGETQueryParams
 */
export interface SearchCommuneEnlevementUsingGETQueryParams {
    /**
     * Chaine de caractère de recherche d\'une commune
     * @type {string}
     * @memberof SearchCommuneEnlevementUsingGETQueryParams
     */
    searchStr: string;
}

/**
 * objet contenant les query params de la route searchFourriereUsingSpecsUsingGET
 * @export
 * @interface SearchFourriereUsingSpecsUsingGETQueryParams
 */
export interface SearchFourriereUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchFourriereUsingSpecsUsingGETQueryParams
     * @type {SearchFourriereUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchFourriereUsingSpecsUsingGETQueryParams
     */
    filters: SearchFourriereUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchFourriereUsingSpecsUsingGETQueryParams
     * @type {SearchFourriereUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchFourriereUsingSpecsUsingGETQueryParams
     */
    sorts: SearchFourriereUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchFourriereUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    codePostal?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    commune?: string;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    dateFromStartOfValidity?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    dateToStartOfValidity?: Date;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    emptyIdAlienation?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    enabled?: boolean;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    idAlienation?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelationAF?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsFilters
    */
    raisonSociale?: string;
}

export interface SearchFourriereUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsSorts
    */
    codePostal?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsSorts
    */
    commune?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsSorts
    */
    raisonSociale?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchFourriereUsingSpecsUsingGETQueryParamsSorts
    */
    raisonSocialeDnid?: boolean;
}

/**
 * objet contenant les query params de la route searchJuridictionUsingSpecsUsingGET
 * @export
 * @interface SearchJuridictionUsingSpecsUsingGETQueryParams
 */
export interface SearchJuridictionUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchJuridictionUsingSpecsUsingGETQueryParams
     * @type {SearchJuridictionUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchJuridictionUsingSpecsUsingGETQueryParams
     */
    filters: SearchJuridictionUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchJuridictionUsingSpecsUsingGETQueryParams
     * @type {SearchJuridictionUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchJuridictionUsingSpecsUsingGETQueryParams
     */
    sorts: SearchJuridictionUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchJuridictionUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsFilters
    */
    codePostal?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {Array<string> | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelationJuridictionParentes?: Array<string>;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsFilters
    */
    libelle?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsFilters
    */
    numero?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsFilters
    */
    origineElement?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL' | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsFilters
    */
    type?: 'TRIBUNAL_JUDICIAIRE' | 'COUR_APPEL';
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

export interface SearchJuridictionUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsSorts
    */
    codePostal?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsSorts
    */
    libelle?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsSorts
    */
    numero?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsSorts
    */
    origineElement?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsSorts
    */
    type?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchJuridictionUsingSpecsUsingGETQueryParamsSorts
    */
    valid?: boolean;
}

/**
 * objet contenant les query params de la route searchMarqueUsingSpecsUsingGET
 * @export
 * @interface SearchMarqueUsingSpecsUsingGETQueryParams
 */
export interface SearchMarqueUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchMarqueUsingSpecsUsingGETQueryParams
     * @type {SearchMarqueUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchMarqueUsingSpecsUsingGETQueryParams
     */
    filters: SearchMarqueUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchMarqueUsingSpecsUsingGETQueryParams
     * @type {SearchMarqueUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchMarqueUsingSpecsUsingGETQueryParams
     */
    sorts: SearchMarqueUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchMarqueUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {'A_CATEGORISER' | 'PREMIUM' | 'NON_VALORISABLE' | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    categorie?: 'A_CATEGORISER' | 'PREMIUM' | 'NON_VALORISABLE';
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    dateFromEndOfValidity?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    dateFromStartOfValidity?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    dateToEndOfValidity?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    dateToStartOfValidity?: Date;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    id?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    libelle?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    prioritaire?: boolean;
    /**
    * 
    * @type {Array<'EXACTE' | 'APPROXIMATIVE' | 'INCONNUE'> | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    types?: Array<'EXACTE' | 'APPROXIMATIVE' | 'INCONNUE'>;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

export interface SearchMarqueUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsSorts
    */
    categorie?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsSorts
    */
    libelle?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMarqueUsingSpecsUsingGETQueryParamsSorts
    */
    type?: boolean;
}

/**
 * objet contenant les query params de la route searchModeleUsingSpecsUsingGET
 * @export
 * @interface SearchModeleUsingSpecsUsingGETQueryParams
 */
export interface SearchModeleUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchModeleUsingSpecsUsingGETQueryParams
     * @type {SearchModeleUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchModeleUsingSpecsUsingGETQueryParams
     */
    filters: SearchModeleUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchModeleUsingSpecsUsingGETQueryParams
     * @type {SearchModeleUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchModeleUsingSpecsUsingGETQueryParams
     */
    sorts: SearchModeleUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchModeleUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsFilters
    */
    dateFromEndOfValidity?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsFilters
    */
    dateFromStartOfValidity?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsFilters
    */
    dateToEndOfValidity?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsFilters
    */
    dateToStartOfValidity?: Date;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsFilters
    */
    libelle?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsFilters
    */
    marqueId?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsFilters
    */
    prioritaire?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
}

export interface SearchModeleUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchModeleUsingSpecsUsingGETQueryParamsSorts
    */
    libelle?: boolean;
}

/**
 * objet contenant les query params de la route searchMotifMefUsingSpecsUsingGET
 * @export
 * @interface SearchMotifMefUsingSpecsUsingGETQueryParams
 */
export interface SearchMotifMefUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchMotifMefUsingSpecsUsingGETQueryParams
     * @type {SearchMotifMefUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchMotifMefUsingSpecsUsingGETQueryParams
     */
    filters: SearchMotifMefUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchMotifMefUsingSpecsUsingGETQueryParams
     * @type {SearchMotifMefUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchMotifMefUsingSpecsUsingGETQueryParams
     */
    sorts: SearchMotifMefUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchMotifMefUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    dateFromStartOfValidity?: Date;
    /**
    * 
    * @type {Date | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    dateToStartOfValidity?: Date;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    enabled?: boolean;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    isDicem?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    isLieuDitEnabled?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    isRodeo?: boolean;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    libelle?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    natureLibelleCourt?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
}

export interface SearchMotifMefUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsSorts
    */
    libelle?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchMotifMefUsingSpecsUsingGETQueryParamsSorts
    */
    natureMef?: boolean;
}

/**
 * objet contenant les query params de la route searchUniteFoUsingSpecsUsingGET
 * @export
 * @interface SearchUniteFoUsingSpecsUsingGETQueryParams
 */
export interface SearchUniteFoUsingSpecsUsingGETQueryParams {
    /**
     * objet contenant les filters de SearchUniteFoUsingSpecsUsingGETQueryParams
     * @type {SearchUniteFoUsingSpecsUsingGETQueryParamsFilters}
     * @memberof SearchUniteFoUsingSpecsUsingGETQueryParams
     */
    filters: SearchUniteFoUsingSpecsUsingGETQueryParamsFilters;
    /**
     * objet contenant les sorts de SearchUniteFoUsingSpecsUsingGETQueryParams
     * @type {SearchUniteFoUsingSpecsUsingGETQueryParamsSorts}
     * @memberof SearchUniteFoUsingSpecsUsingGETQueryParams
     */
    sorts: SearchUniteFoUsingSpecsUsingGETQueryParamsSorts;
}

export interface SearchUniteFoUsingSpecsUsingGETQueryParamsFilters {
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    abreviation?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    code?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    codePostal?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    idCorrelation?: string;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    page?: number;
    /**
    * 
    * @type {number | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    pageSize?: number;
    /**
    * 
    * @type {'NOUVELLE_UNITE' | 'ECHEC_DESACTIVATION_DOSSIER_ATTACHE' | 'ECHEC_DESACTIVATION_UNITE_PARENT' | 'MISE_A_JOUR_ERREUR_VALIDATION' | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    rpsiStatus?: 'NOUVELLE_UNITE' | 'ECHEC_DESACTIVATION_DOSSIER_ATTACHE' | 'ECHEC_DESACTIVATION_UNITE_PARENT' | 'MISE_A_JOUR_ERREUR_VALIDATION';
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    type?: string;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    unite?: string;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    valid?: boolean;
    /**
    * 
    * @type {string | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsFilters
    */
    ville?: string;
}

export interface SearchUniteFoUsingSpecsUsingGETQueryParamsSorts {
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsSorts
    */
    abreviation?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsSorts
    */
    code?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsSorts
    */
    codeInsee?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsSorts
    */
    codePostal?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsSorts
    */
    type?: boolean;
    /**
    * 
    * @type {boolean | undefined}
    * @memberof SearchUniteFoUsingSpecsUsingGETQueryParamsSorts
    */
    ville?: boolean;
}

/**
 * objet contenant les query params de la route searchedValidUniteFOUsingGET
 * @export
 * @interface SearchedValidUniteFOUsingGETQueryParams
 */
export interface SearchedValidUniteFOUsingGETQueryParams {
    /**
     * Champs du référentiel unité sur lequel la recherche est effectuée
     * @type {'CODE' | 'UNITE' | 'ABREVIATION'}
     * @memberof SearchedValidUniteFOUsingGETQueryParams
     */
    field: 'CODE' | 'UNITE' | 'ABREVIATION';
    /**
     * Pour les utilisateurs rattachés à une unité des forces de l\'ordre, si spécifié, permet de filtrer les unités FO de son périmètre
     * @type {boolean}
     * @memberof SearchedValidUniteFOUsingGETQueryParams
     */
    isFilteredByProfile?: boolean;
    /**
     * Mots clef de recherche.
     * @type {string}
     * @memberof SearchedValidUniteFOUsingGETQueryParams
     */
    searched: string;
}

/**
 * ReferentielControllerApi - fetch parameter creator
 * @export
 */
export const ReferentielControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant d\'exporter un référentiel au format csv.
         * @param {'AUTORITE_FOURRIERE' | 'BRANCHE' | 'CENTRE_VHU' | 'ETAT' | 'FOURRIERE' | 'FOOTER_LINK' | 'GENRE_SIMPLIFIE' | 'MOTIF_MEF' | 'MOTIF_SORTIE' | 'TYPE_AF' | 'UNITE_FO' | 'FAQ' | 'VIDEO_TUTORIEL'} referentiel Nom du referentiel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCSVReferentielUsingGET(referentiel: 'AUTORITE_FOURRIERE' | 'BRANCHE' | 'CENTRE_VHU' | 'ETAT' | 'FOURRIERE' | 'FOOTER_LINK' | 'GENRE_SIMPLIFIE' | 'MOTIF_MEF' | 'MOTIF_SORTIE' | 'TYPE_AF' | 'UNITE_FO' | 'FAQ' | 'VIDEO_TUTORIEL', options: any = {}): FetchArgs {
            // verify required parameter 'referentiel' is not null or undefined
            if (referentiel === null || referentiel === undefined) {
                throw new RequiredError('referentiel','Required parameter referentiel was null or undefined when calling exportCSVReferentielUsingGET.');
            }
            const localVarPath = `/api/referentiel/export/csv/{referentiel}`
                .replace(`{${"referentiel"}}`, encodeURIComponent(String(referentiel)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant toutes les couleurs de véhicule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCouleurUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/couleur`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant toutes les énergies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEnergieUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/energie`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant tous les bandeaux d\'information
         * @param {getAllInformationMessageUsingGETQueryParams} queryParams objet contenant les query params de la route getAllInformationMessageUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInformationMessageUsingGET(queryParams: GetAllInformationMessageUsingGETQueryParams, options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/message-information`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.page !== undefined) {
                localVarQueryParameter['page'] = queryParams.page;
            }

            if (queryParams.pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = queryParams.pageSize;
            }

            if (queryParams.search !== undefined) {
                localVarQueryParameter['search'] = queryParams.search;
            }

            if (queryParams.sortByEndDate !== undefined) {
                localVarQueryParameter['sortByEndDate'] = queryParams.sortByEndDate;
            }

            if (queryParams.sortByStartDate !== undefined) {
                localVarQueryParameter['sortByStartDate'] = queryParams.sortByStartDate;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant tous les modèles de véhicule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMarqueModeleUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/modele`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant tous les centres VHU valides.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllValidCentreVhuUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/centre-vhu`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant toutes les marques valides.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllValidMarqueUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/marque`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant toutes les natures de mise en fourrière et les branches de workflow associées.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllValidNaturesUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/nature-mef-branche`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant les précisions pour un état donné.
         * @param {'BON_ETAT' | 'DEGRADE' | 'DOMMAGES_GRAVES'} etat Libellé de l\'état.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailFromEtatUsingGET(etat: 'BON_ETAT' | 'DEGRADE' | 'DOMMAGES_GRAVES', options: any = {}): FetchArgs {
            // verify required parameter 'etat' is not null or undefined
            if (etat === null || etat === undefined) {
                throw new RequiredError('etat','Required parameter etat was null or undefined when calling getDetailFromEtatUsingGET.');
            }
            const localVarPath = `/api/referentiel/etat-detail/{etat}`
                .replace(`{${"etat"}}`, encodeURIComponent(String(etat)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant un état par son id.
         * @param {string} id ID de l\'état, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtatByIdUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEtatByIdUsingGET.');
            }
            const localVarPath = `/api/referentiel/etat/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant les différents états
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtatsVehiculeUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/etats-vehicule`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route recherchant une juridiction valide ou non via son id correlation.
         * @param {string} idCorrelation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastJuridictionByIdCorrelationUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling getLastJuridictionByIdCorrelationUsingGET.');
            }
            const localVarPath = `/api/referentiel/juridiction/{idCorrelation}/last`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant une marque par son id.
         * @param {string} id ID de la marque, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarqueByIdUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getMarqueByIdUsingGET.');
            }
            const localVarPath = `/api/referentiel/marque/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant tous les modèles de véhicule pour l\'idCorrelation d\'une marque donnée.
         * @param {string} idCorrelation ID de la marque, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeleByMarqueIdCorrelationUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling getModeleByMarqueIdCorrelationUsingGET.');
            }
            const localVarPath = `/api/referentiel/modele/marqueIdCorrelation/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant tous les modèles de véhicule pour l\'id d\'une marque donnée.
         * @param {string} id ID de la marque, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeleByMarqueUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getModeleByMarqueUsingGET.');
            }
            const localVarPath = `/api/referentiel/modele/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant un motif de mise en fourrière par son id.
         * @param {string} id ID du motif de mef, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotifMefByIdUsingGET(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getMotifMefByIdUsingGET.');
            }
            const localVarPath = `/api/referentiel/motif-mef/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant les questions valides, regroupées par domaines.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidFaqByDomainsUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/foire-aux-questions/domaine`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route rercherchant une question en fonction de son idCorrelation.
         * @param {string} idCorrelation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidFaqDtoUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling getOnlyValidFaqDtoUsingGET.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant les questions valides, avec ou sans domaine.
         * @param {getOnlyValidFaqsUsingGETQueryParams} queryParams objet contenant les query params de la route getOnlyValidFaqsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidFaqsUsingGET(queryParams: GetOnlyValidFaqsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'domaine' is not null or undefined
            if (queryParams.domaine === null || queryParams.domaine === undefined) {
                throw new RequiredError('domaine','Required parameter domaine was null or undefined when calling getOnlyValidFaqsUsingGET.');
            }
            const localVarPath = `/api/referentiel/foire-aux-questions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.domaine !== undefined) {
                localVarQueryParameter['domaine'] = queryParams.domaine;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant les liens du pied de page valides.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidFooterLinkUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/lien-footer`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant les bandeaux d\'information actif pour le profil donné.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidInformationMessageByProfileUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/message-information/profile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant les bandeaux d\'information actif pour Bord de Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidInformationMessageForBDRUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/message-information/bord-de-route`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant les statuts consultables selon le profil.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatutsConsultablesUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/statut-consultable`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route recherchant une autorités de fourrière par son idCorrelation.
         * @param {string} idCorrelation ID de l\'autorités de fourrière, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidAutoriteFourriereByIdCorrelationUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling getValidAutoriteFourriereByIdCorrelationUsingGET.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant toutes les autorités de fourrière.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidAutoriteFourriereUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/autorite-fourriere`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant toutes les autorités fourrière d\'une fourrière via son idCorrelation.
         * @param {string} idCorrelationFourriere IdCorrelation de la fourrière.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidAutoritesFourriereOfFourriereUsingGET(idCorrelationFourriere: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelationFourriere' is not null or undefined
            if (idCorrelationFourriere === null || idCorrelationFourriere === undefined) {
                throw new RequiredError('idCorrelationFourriere','Required parameter idCorrelationFourriere was null or undefined when calling getValidAutoritesFourriereOfFourriereUsingGET.');
            }
            const localVarPath = `/api/referentiel/fourriere/{idCorrelationFourriere}/autoritesfourriere`
                .replace(`{${"idCorrelationFourriere"}}`, encodeURIComponent(String(idCorrelationFourriere)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant toutes les fourrière.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidFourriereUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/fourriere`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant tous les genres simplifiés de véhicules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidGenresSimplifiesUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/genre-simplifie`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route recherchant une juridiction
         * @param {getValidJuridictionByLibelleOrNumeroUsingGETQueryParams} queryParams objet contenant les query params de la route getValidJuridictionByLibelleOrNumeroUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidJuridictionByLibelleOrNumeroUsingGET(queryParams: GetValidJuridictionByLibelleOrNumeroUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (queryParams.field === null || queryParams.field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling getValidJuridictionByLibelleOrNumeroUsingGET.');
            }
            // verify required parameter 'searched' is not null or undefined
            if (queryParams.searched === null || queryParams.searched === undefined) {
                throw new RequiredError('searched','Required parameter searched was null or undefined when calling getValidJuridictionByLibelleOrNumeroUsingGET.');
            }
            const localVarPath = `/api/referentiel/juridiction`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.field !== undefined) {
                localVarQueryParameter['field'] = queryParams.field;
            }

            if (queryParams.searched !== undefined) {
                localVarQueryParameter['searched'] = queryParams.searched;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant tous les motifs de mise en fourrière.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidMotifMefUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/motif-mef`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant tous les motifs de sortie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidMotifSortieUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/motif-sortie`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant tous les types d\'autorités de fourrière.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidTypeAutoriteFourriereUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/type-autorite-fourriere`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route recherchant une unité force de l\'ordre via son idCorrelation.
         * @param {string} idCorrelation ID de l\'unité, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidUniteFOByIdCorrelationUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling getValidUniteFOByIdCorrelationUsingGET.');
            }
            const localVarPath = `/api/referentiel/unite-fo/{idCorrelation}`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant les unités FO liées au profil FO utilisé (unité parente + enfants), via l\'ideCorrelation de l\'unité parente
         * @param {string} idCorrelation idCorrelation de l\'unité parente, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidUniteFOWithChildrenUsingGET(idCorrelation: string, options: any = {}): FetchArgs {
            // verify required parameter 'idCorrelation' is not null or undefined
            if (idCorrelation === null || idCorrelation === undefined) {
                throw new RequiredError('idCorrelation','Required parameter idCorrelation was null or undefined when calling getValidUniteFOWithChildrenUsingGET.');
            }
            const localVarPath = `/api/referentiel/unite-fo/{idCorrelation}/parents-et-enfants`
                .replace(`{${"idCorrelation"}}`, encodeURIComponent(String(idCorrelation)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route récupérant toutes les vidéos tutoriels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoTutorielUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/referentiel/video-tutoriel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche d\'une liste de tous les motifs de mise en fourrière filtrée et triée
         * @param {searchAllMotifMefUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchAllMotifMefUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllMotifMefUsingSpecsUsingGET(queryParams: SearchAllMotifMefUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchAllMotifMefUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchAllMotifMefUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/motif-mef/with-specs/all`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.dateFromStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateFromStartOfValidity'] = (queryParams.filters.dateFromStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.dateToStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateToStartOfValidity'] = (queryParams.filters.dateToStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.enabled !== undefined) {
                localVarQueryParameter['filters.enabled'] = queryParams.filters.enabled;
            }
            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.isDicem !== undefined) {
                localVarQueryParameter['filters.isDicem'] = queryParams.filters.isDicem;
            }
            if (queryParams.filters.isLieuDitEnabled !== undefined) {
                localVarQueryParameter['filters.isLieuDitEnabled'] = queryParams.filters.isLieuDitEnabled;
            }
            if (queryParams.filters.isRodeo !== undefined) {
                localVarQueryParameter['filters.isRodeo'] = queryParams.filters.isRodeo;
            }
            if (queryParams.filters.libelle !== undefined) {
                localVarQueryParameter['filters.libelle'] = queryParams.filters.libelle;
            }
            if (queryParams.filters.natureLibelleCourt !== undefined) {
                localVarQueryParameter['filters.natureLibelleCourt'] = queryParams.filters.natureLibelleCourt;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }

            if (queryParams.sorts.libelle !== undefined) {
                localVarQueryParameter['sorts.libelle'] = queryParams.sorts.libelle;
            }
            if (queryParams.sorts.natureMef !== undefined) {
                localVarQueryParameter['sorts.natureMef'] = queryParams.sorts.natureMef;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche d\'une liste d\'autorités de fourrière filtrée et triée
         * @param {searchAutoriteFourriereUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchAutoriteFourriereUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAutoriteFourriereUsingSpecsUsingGET(queryParams: SearchAutoriteFourriereUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchAutoriteFourriereUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchAutoriteFourriereUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/autorite-fourriere/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.codeDepartement !== undefined) {
                localVarQueryParameter['filters.codeDepartement'] = queryParams.filters.codeDepartement;
            }
            if (queryParams.filters.codePostal !== undefined) {
                localVarQueryParameter['filters.codePostal'] = queryParams.filters.codePostal;
            }
            if (queryParams.filters.dateFromStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateFromStartOfValidity'] = (queryParams.filters.dateFromStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.dateToStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateToStartOfValidity'] = (queryParams.filters.dateToStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.emptyIdAlienation !== undefined) {
                localVarQueryParameter['filters.emptyIdAlienation'] = queryParams.filters.emptyIdAlienation;
            }
            if (queryParams.filters.emptyIdAlienationUtilisateur !== undefined) {
                localVarQueryParameter['filters.emptyIdAlienationUtilisateur'] = queryParams.filters.emptyIdAlienationUtilisateur;
            }
            if (queryParams.filters.enabled !== undefined) {
                localVarQueryParameter['filters.enabled'] = queryParams.filters.enabled;
            }
            if (queryParams.filters.idAlienation !== undefined) {
                localVarQueryParameter['filters.idAlienation'] = queryParams.filters.idAlienation;
            }
            if (queryParams.filters.idAlienationUtilisateur !== undefined) {
                localVarQueryParameter['filters.idAlienationUtilisateur'] = queryParams.filters.idAlienationUtilisateur;
            }
            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.idCorrelationTypeAutorite !== undefined) {
                localVarQueryParameter['filters.idCorrelationTypeAutorite'] = queryParams.filters.idCorrelationTypeAutorite;
            }
            if (queryParams.filters.libelle !== undefined) {
                localVarQueryParameter['filters.libelle'] = queryParams.filters.libelle;
            }
            if (queryParams.filters.libelleDepartement !== undefined) {
                localVarQueryParameter['filters.libelleDepartement'] = queryParams.filters.libelleDepartement;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.ville !== undefined) {
                localVarQueryParameter['filters.ville'] = queryParams.filters.ville;
            }

            if (queryParams.sorts.codePostal !== undefined) {
                localVarQueryParameter['sorts.codePostal'] = queryParams.sorts.codePostal;
            }
            if (queryParams.sorts.departement !== undefined) {
                localVarQueryParameter['sorts.departement'] = queryParams.sorts.departement;
            }
            if (queryParams.sorts.libelle !== undefined) {
                localVarQueryParameter['sorts.libelle'] = queryParams.sorts.libelle;
            }
            if (queryParams.sorts.type !== undefined) {
                localVarQueryParameter['sorts.type'] = queryParams.sorts.type;
            }
            if (queryParams.sorts.ville !== undefined) {
                localVarQueryParameter['sorts.ville'] = queryParams.sorts.ville;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche d\'une liste de centreVHU filtrée et triée
         * @param {searchCentreVHUUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchCentreVHUUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCentreVHUUsingSpecsUsingGET(queryParams: SearchCentreVHUUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchCentreVHUUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchCentreVHUUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/centre-vhu/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.codePostal !== undefined) {
                localVarQueryParameter['filters.codePostal'] = queryParams.filters.codePostal;
            }
            if (queryParams.filters.commune !== undefined) {
                localVarQueryParameter['filters.commune'] = queryParams.filters.commune;
            }
            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.numeroAgrementVHU !== undefined) {
                localVarQueryParameter['filters.numeroAgrementVHU'] = queryParams.filters.numeroAgrementVHU;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.raisonSociale !== undefined) {
                localVarQueryParameter['filters.raisonSociale'] = queryParams.filters.raisonSociale;
            }
            if (queryParams.filters.siren !== undefined) {
                localVarQueryParameter['filters.siren'] = queryParams.filters.siren;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            if (queryParams.sorts.codePostal !== undefined) {
                localVarQueryParameter['sorts.codePostal'] = queryParams.sorts.codePostal;
            }
            if (queryParams.sorts.commune !== undefined) {
                localVarQueryParameter['sorts.commune'] = queryParams.sorts.commune;
            }
            if (queryParams.sorts.numeroAgrementVHU !== undefined) {
                localVarQueryParameter['sorts.numeroAgrementVHU'] = queryParams.sorts.numeroAgrementVHU;
            }
            if (queryParams.sorts.raisonSociale !== undefined) {
                localVarQueryParameter['sorts.raisonSociale'] = queryParams.sorts.raisonSociale;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route de recherche des commune d\'enlevement des dossiers accessibles par l\'utilisateur
         * @param {searchCommuneEnlevementUsingGETQueryParams} queryParams objet contenant les query params de la route searchCommuneEnlevementUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCommuneEnlevementUsingGET(queryParams: SearchCommuneEnlevementUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'searchStr' is not null or undefined
            if (queryParams.searchStr === null || queryParams.searchStr === undefined) {
                throw new RequiredError('searchStr','Required parameter searchStr was null or undefined when calling searchCommuneEnlevementUsingGET.');
            }
            const localVarPath = `/api/referentiel/communes-enlevement`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.searchStr !== undefined) {
                localVarQueryParameter['searchStr'] = queryParams.searchStr;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche d\'une liste des fourrières filtrée et triée
         * @param {searchFourriereUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFourriereUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFourriereUsingSpecsUsingGET(queryParams: SearchFourriereUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchFourriereUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchFourriereUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/fourriere/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.codePostal !== undefined) {
                localVarQueryParameter['filters.codePostal'] = queryParams.filters.codePostal;
            }
            if (queryParams.filters.commune !== undefined) {
                localVarQueryParameter['filters.commune'] = queryParams.filters.commune;
            }
            if (queryParams.filters.dateFromStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateFromStartOfValidity'] = (queryParams.filters.dateFromStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.dateToStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateToStartOfValidity'] = (queryParams.filters.dateToStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.emptyIdAlienation !== undefined) {
                localVarQueryParameter['filters.emptyIdAlienation'] = queryParams.filters.emptyIdAlienation;
            }
            if (queryParams.filters.enabled !== undefined) {
                localVarQueryParameter['filters.enabled'] = queryParams.filters.enabled;
            }
            if (queryParams.filters.idAlienation !== undefined) {
                localVarQueryParameter['filters.idAlienation'] = queryParams.filters.idAlienation;
            }
            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.idCorrelationAF !== undefined) {
                localVarQueryParameter['filters.idCorrelationAF'] = queryParams.filters.idCorrelationAF;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.raisonSociale !== undefined) {
                localVarQueryParameter['filters.raisonSociale'] = queryParams.filters.raisonSociale;
            }

            if (queryParams.sorts.codePostal !== undefined) {
                localVarQueryParameter['sorts.codePostal'] = queryParams.sorts.codePostal;
            }
            if (queryParams.sorts.commune !== undefined) {
                localVarQueryParameter['sorts.commune'] = queryParams.sorts.commune;
            }
            if (queryParams.sorts.raisonSociale !== undefined) {
                localVarQueryParameter['sorts.raisonSociale'] = queryParams.sorts.raisonSociale;
            }
            if (queryParams.sorts.raisonSocialeDnid !== undefined) {
                localVarQueryParameter['sorts.raisonSocialeDnid'] = queryParams.sorts.raisonSocialeDnid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche d\'une liste de juridiction filtrée et triée
         * @param {searchJuridictionUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchJuridictionUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchJuridictionUsingSpecsUsingGET(queryParams: SearchJuridictionUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchJuridictionUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchJuridictionUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/juridiction/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.codePostal !== undefined) {
                localVarQueryParameter['filters.codePostal'] = queryParams.filters.codePostal;
            }
            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.idCorrelationJuridictionParentes !== undefined) {
                localVarQueryParameter['filters.idCorrelationJuridictionParentes'] = queryParams.filters.idCorrelationJuridictionParentes;
            }
            if (queryParams.filters.libelle !== undefined) {
                localVarQueryParameter['filters.libelle'] = queryParams.filters.libelle;
            }
            if (queryParams.filters.numero !== undefined) {
                localVarQueryParameter['filters.numero'] = queryParams.filters.numero;
            }
            if (queryParams.filters.origineElement !== undefined) {
                localVarQueryParameter['filters.origineElement'] = queryParams.filters.origineElement;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.type !== undefined) {
                localVarQueryParameter['filters.type'] = queryParams.filters.type;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            if (queryParams.sorts.codePostal !== undefined) {
                localVarQueryParameter['sorts.codePostal'] = queryParams.sorts.codePostal;
            }
            if (queryParams.sorts.libelle !== undefined) {
                localVarQueryParameter['sorts.libelle'] = queryParams.sorts.libelle;
            }
            if (queryParams.sorts.numero !== undefined) {
                localVarQueryParameter['sorts.numero'] = queryParams.sorts.numero;
            }
            if (queryParams.sorts.origineElement !== undefined) {
                localVarQueryParameter['sorts.origineElement'] = queryParams.sorts.origineElement;
            }
            if (queryParams.sorts.type !== undefined) {
                localVarQueryParameter['sorts.type'] = queryParams.sorts.type;
            }
            if (queryParams.sorts.valid !== undefined) {
                localVarQueryParameter['sorts.valid'] = queryParams.sorts.valid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche d\'une liste de marques filtrée et triée
         * @param {searchMarqueUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchMarqueUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMarqueUsingSpecsUsingGET(queryParams: SearchMarqueUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchMarqueUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchMarqueUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/marque/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.categorie !== undefined) {
                localVarQueryParameter['filters.categorie'] = queryParams.filters.categorie;
            }
            if (queryParams.filters.dateFromEndOfValidity !== undefined) {
                localVarQueryParameter['filters.dateFromEndOfValidity'] = (queryParams.filters.dateFromEndOfValidity as any).toISOString();
            }
            if (queryParams.filters.dateFromStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateFromStartOfValidity'] = (queryParams.filters.dateFromStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.dateToEndOfValidity !== undefined) {
                localVarQueryParameter['filters.dateToEndOfValidity'] = (queryParams.filters.dateToEndOfValidity as any).toISOString();
            }
            if (queryParams.filters.dateToStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateToStartOfValidity'] = (queryParams.filters.dateToStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.id !== undefined) {
                localVarQueryParameter['filters.id'] = queryParams.filters.id;
            }
            if (queryParams.filters.libelle !== undefined) {
                localVarQueryParameter['filters.libelle'] = queryParams.filters.libelle;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.prioritaire !== undefined) {
                localVarQueryParameter['filters.prioritaire'] = queryParams.filters.prioritaire;
            }
            if (queryParams.filters.types !== undefined) {
                localVarQueryParameter['filters.types'] = queryParams.filters.types;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            if (queryParams.sorts.categorie !== undefined) {
                localVarQueryParameter['sorts.categorie'] = queryParams.sorts.categorie;
            }
            if (queryParams.sorts.libelle !== undefined) {
                localVarQueryParameter['sorts.libelle'] = queryParams.sorts.libelle;
            }
            if (queryParams.sorts.type !== undefined) {
                localVarQueryParameter['sorts.type'] = queryParams.sorts.type;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche d\'une liste de modèles filtrée filtrée et triée
         * @param {searchModeleUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchModeleUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchModeleUsingSpecsUsingGET(queryParams: SearchModeleUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchModeleUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchModeleUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/modele/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.dateFromEndOfValidity !== undefined) {
                localVarQueryParameter['filters.dateFromEndOfValidity'] = (queryParams.filters.dateFromEndOfValidity as any).toISOString();
            }
            if (queryParams.filters.dateFromStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateFromStartOfValidity'] = (queryParams.filters.dateFromStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.dateToEndOfValidity !== undefined) {
                localVarQueryParameter['filters.dateToEndOfValidity'] = (queryParams.filters.dateToEndOfValidity as any).toISOString();
            }
            if (queryParams.filters.dateToStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateToStartOfValidity'] = (queryParams.filters.dateToStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.libelle !== undefined) {
                localVarQueryParameter['filters.libelle'] = queryParams.filters.libelle;
            }
            if (queryParams.filters.marqueId !== undefined) {
                localVarQueryParameter['filters.marqueId'] = queryParams.filters.marqueId;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.prioritaire !== undefined) {
                localVarQueryParameter['filters.prioritaire'] = queryParams.filters.prioritaire;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }

            if (queryParams.sorts.libelle !== undefined) {
                localVarQueryParameter['sorts.libelle'] = queryParams.sorts.libelle;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche d\'une liste de motifs de mise en fourrière filtrée et triée
         * @param {searchMotifMefUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchMotifMefUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMotifMefUsingSpecsUsingGET(queryParams: SearchMotifMefUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchMotifMefUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchMotifMefUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/motif-mef/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.dateFromStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateFromStartOfValidity'] = (queryParams.filters.dateFromStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.dateToStartOfValidity !== undefined) {
                localVarQueryParameter['filters.dateToStartOfValidity'] = (queryParams.filters.dateToStartOfValidity as any).toISOString();
            }
            if (queryParams.filters.enabled !== undefined) {
                localVarQueryParameter['filters.enabled'] = queryParams.filters.enabled;
            }
            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.isDicem !== undefined) {
                localVarQueryParameter['filters.isDicem'] = queryParams.filters.isDicem;
            }
            if (queryParams.filters.isLieuDitEnabled !== undefined) {
                localVarQueryParameter['filters.isLieuDitEnabled'] = queryParams.filters.isLieuDitEnabled;
            }
            if (queryParams.filters.isRodeo !== undefined) {
                localVarQueryParameter['filters.isRodeo'] = queryParams.filters.isRodeo;
            }
            if (queryParams.filters.libelle !== undefined) {
                localVarQueryParameter['filters.libelle'] = queryParams.filters.libelle;
            }
            if (queryParams.filters.natureLibelleCourt !== undefined) {
                localVarQueryParameter['filters.natureLibelleCourt'] = queryParams.filters.natureLibelleCourt;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }

            if (queryParams.sorts.libelle !== undefined) {
                localVarQueryParameter['sorts.libelle'] = queryParams.sorts.libelle;
            }
            if (queryParams.sorts.natureMef !== undefined) {
                localVarQueryParameter['sorts.natureMef'] = queryParams.sorts.natureMef;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Recherche d\'une liste d\'UniteFo filtrée et triée
         * @param {searchUniteFoUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchUniteFoUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUniteFoUsingSpecsUsingGET(queryParams: SearchUniteFoUsingSpecsUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'filters' is not null or undefined
            if (queryParams.filters === null || queryParams.filters === undefined) {
                throw new RequiredError('filters','Required parameter filters was null or undefined when calling searchUniteFoUsingSpecsUsingGET.');
            }
            // verify required parameter 'sorts' is not null or undefined
            if (queryParams.sorts === null || queryParams.sorts === undefined) {
                throw new RequiredError('sorts','Required parameter sorts was null or undefined when calling searchUniteFoUsingSpecsUsingGET.');
            }
            const localVarPath = `/api/referentiel/unite-fo/with-specs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.filters.abreviation !== undefined) {
                localVarQueryParameter['filters.abreviation'] = queryParams.filters.abreviation;
            }
            if (queryParams.filters.code !== undefined) {
                localVarQueryParameter['filters.code'] = queryParams.filters.code;
            }
            if (queryParams.filters.codePostal !== undefined) {
                localVarQueryParameter['filters.codePostal'] = queryParams.filters.codePostal;
            }
            if (queryParams.filters.idCorrelation !== undefined) {
                localVarQueryParameter['filters.idCorrelation'] = queryParams.filters.idCorrelation;
            }
            if (queryParams.filters.page !== undefined) {
                localVarQueryParameter['filters.page'] = queryParams.filters.page;
            }
            if (queryParams.filters.pageSize !== undefined) {
                localVarQueryParameter['filters.pageSize'] = queryParams.filters.pageSize;
            }
            if (queryParams.filters.rpsiStatus !== undefined) {
                localVarQueryParameter['filters.rpsiStatus'] = queryParams.filters.rpsiStatus;
            }
            if (queryParams.filters.type !== undefined) {
                localVarQueryParameter['filters.type'] = queryParams.filters.type;
            }
            if (queryParams.filters.unite !== undefined) {
                localVarQueryParameter['filters.unite'] = queryParams.filters.unite;
            }
            if (queryParams.filters.valid !== undefined) {
                localVarQueryParameter['filters.valid'] = queryParams.filters.valid;
            }
            if (queryParams.filters.ville !== undefined) {
                localVarQueryParameter['filters.ville'] = queryParams.filters.ville;
            }

            if (queryParams.sorts.abreviation !== undefined) {
                localVarQueryParameter['sorts.abreviation'] = queryParams.sorts.abreviation;
            }
            if (queryParams.sorts.code !== undefined) {
                localVarQueryParameter['sorts.code'] = queryParams.sorts.code;
            }
            if (queryParams.sorts.codeInsee !== undefined) {
                localVarQueryParameter['sorts.codeInsee'] = queryParams.sorts.codeInsee;
            }
            if (queryParams.sorts.codePostal !== undefined) {
                localVarQueryParameter['sorts.codePostal'] = queryParams.sorts.codePostal;
            }
            if (queryParams.sorts.type !== undefined) {
                localVarQueryParameter['sorts.type'] = queryParams.sorts.type;
            }
            if (queryParams.sorts.ville !== undefined) {
                localVarQueryParameter['sorts.ville'] = queryParams.sorts.ville;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * @summary Route recherchant une unité force de l\'ordre.
         * @param {searchedValidUniteFOUsingGETQueryParams} queryParams objet contenant les query params de la route searchedValidUniteFOUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchedValidUniteFOUsingGET(queryParams: SearchedValidUniteFOUsingGETQueryParams, options: any = {}): FetchArgs {
            // verify required parameter 'field' is not null or undefined
            if (queryParams.field === null || queryParams.field === undefined) {
                throw new RequiredError('field','Required parameter field was null or undefined when calling searchedValidUniteFOUsingGET.');
            }
            // verify required parameter 'searched' is not null or undefined
            if (queryParams.searched === null || queryParams.searched === undefined) {
                throw new RequiredError('searched','Required parameter searched was null or undefined when calling searchedValidUniteFOUsingGET.');
            }
            const localVarPath = `/api/referentiel/unite-fo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (queryParams.field !== undefined) {
                localVarQueryParameter['field'] = queryParams.field;
            }

            if (queryParams.isFilteredByProfile !== undefined) {
                localVarQueryParameter['isFilteredByProfile'] = queryParams.isFilteredByProfile;
            }

            if (queryParams.searched !== undefined) {
                localVarQueryParameter['searched'] = queryParams.searched;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferentielControllerApi - functional programming interface
 * @export
 */
export const ReferentielControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant d\'exporter un référentiel au format csv.
         * @param {'AUTORITE_FOURRIERE' | 'BRANCHE' | 'CENTRE_VHU' | 'ETAT' | 'FOURRIERE' | 'FOOTER_LINK' | 'GENRE_SIMPLIFIE' | 'MOTIF_MEF' | 'MOTIF_SORTIE' | 'TYPE_AF' | 'UNITE_FO' | 'FAQ' | 'VIDEO_TUTORIEL'} referentiel Nom du referentiel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCSVReferentielUsingGET(referentiel: 'AUTORITE_FOURRIERE' | 'BRANCHE' | 'CENTRE_VHU' | 'ETAT' | 'FOURRIERE' | 'FOOTER_LINK' | 'GENRE_SIMPLIFIE' | 'MOTIF_MEF' | 'MOTIF_SORTIE' | 'TYPE_AF' | 'UNITE_FO' | 'FAQ' | 'VIDEO_TUTORIEL', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).exportCSVReferentielUsingGET(referentiel, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant toutes les couleurs de véhicule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCouleurUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoCouleurDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getAllCouleurUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant toutes les énergies.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEnergieUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoEnergieDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getAllEnergieUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant tous les bandeaux d\'information
         * @param {getAllInformationMessageUsingGETQueryParams} queryParams objet contenant les query params de la route getAllInformationMessageUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInformationMessageUsingGET(queryParams: GetAllInformationMessageUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchInformationMessageResultDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getAllInformationMessageUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant tous les modèles de véhicule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMarqueModeleUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoModeleDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getAllMarqueModeleUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant tous les centres VHU valides.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllValidCentreVhuUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoCentreVHUDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getAllValidCentreVhuUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant toutes les marques valides.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllValidMarqueUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoMarqueDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getAllValidMarqueUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant toutes les natures de mise en fourrière et les branches de workflow associées.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllValidNaturesUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoBrancheDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getAllValidNaturesUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant les précisions pour un état donné.
         * @param {'BON_ETAT' | 'DEGRADE' | 'DOMMAGES_GRAVES'} etat Libellé de l\'état.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailFromEtatUsingGET(etat: 'BON_ETAT' | 'DEGRADE' | 'DOMMAGES_GRAVES', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoEtatDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getDetailFromEtatUsingGET(etat, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant un état par son id.
         * @param {string} id ID de l\'état, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtatByIdUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EtatDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getEtatByIdUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant les différents états
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtatsVehiculeUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoEtatDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getEtatsVehiculeUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route recherchant une juridiction valide ou non via son id correlation.
         * @param {string} idCorrelation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastJuridictionByIdCorrelationUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JuridictionResponseDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getLastJuridictionByIdCorrelationUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant une marque par son id.
         * @param {string} id ID de la marque, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarqueByIdUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MarqueDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getMarqueByIdUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant tous les modèles de véhicule pour l\'idCorrelation d\'une marque donnée.
         * @param {string} idCorrelation ID de la marque, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeleByMarqueIdCorrelationUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoModeleDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getModeleByMarqueIdCorrelationUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant tous les modèles de véhicule pour l\'id d\'une marque donnée.
         * @param {string} id ID de la marque, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModeleByMarqueUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoModeleDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getModeleByMarqueUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant un motif de mise en fourrière par son id.
         * @param {string} id ID du motif de mef, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotifMefByIdUsingGET(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<MotifMefDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getMotifMefByIdUsingGET(id, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant les questions valides, regroupées par domaines.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidFaqByDomainsUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoFaqDomainDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getOnlyValidFaqByDomainsUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route rercherchant une question en fonction de son idCorrelation.
         * @param {string} idCorrelation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidFaqDtoUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FaqDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getOnlyValidFaqDtoUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant les questions valides, avec ou sans domaine.
         * @param {getOnlyValidFaqsUsingGETQueryParams} queryParams objet contenant les query params de la route getOnlyValidFaqsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidFaqsUsingGET(queryParams: GetOnlyValidFaqsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoFaqDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getOnlyValidFaqsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant les liens du pied de page valides.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidFooterLinkUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoFooterLinkDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getOnlyValidFooterLinkUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant les bandeaux d\'information actif pour le profil donné.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidInformationMessageByProfileUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoInformationMessageDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getOnlyValidInformationMessageByProfileUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant les bandeaux d\'information actif pour Bord de Route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyValidInformationMessageForBDRUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoInformationMessageDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getOnlyValidInformationMessageForBDRUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant les statuts consultables selon le profil.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatutsConsultablesUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoStatutDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getStatutsConsultablesUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route recherchant une autorités de fourrière par son idCorrelation.
         * @param {string} idCorrelation ID de l\'autorités de fourrière, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidAutoriteFourriereByIdCorrelationUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AutoriteFourriereDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidAutoriteFourriereByIdCorrelationUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant toutes les autorités de fourrière.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidAutoriteFourriereUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoAutoriteFourriereDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidAutoriteFourriereUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant toutes les autorités fourrière d\'une fourrière via son idCorrelation.
         * @param {string} idCorrelationFourriere IdCorrelation de la fourrière.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidAutoritesFourriereOfFourriereUsingGET(idCorrelationFourriere: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoAutoriteFourriereDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidAutoritesFourriereOfFourriereUsingGET(idCorrelationFourriere, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant toutes les fourrière.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidFourriereUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoFourriereDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidFourriereUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant tous les genres simplifiés de véhicules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidGenresSimplifiesUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoGenreSimplifieDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidGenresSimplifiesUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route recherchant une juridiction
         * @param {getValidJuridictionByLibelleOrNumeroUsingGETQueryParams} queryParams objet contenant les query params de la route getValidJuridictionByLibelleOrNumeroUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidJuridictionByLibelleOrNumeroUsingGET(queryParams: GetValidJuridictionByLibelleOrNumeroUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AutocompleteJuridictionResultDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidJuridictionByLibelleOrNumeroUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant tous les motifs de mise en fourrière.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidMotifMefUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoMotifMefDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidMotifMefUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant tous les motifs de sortie.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidMotifSortieUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoMotifSortieDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidMotifSortieUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant tous les types d\'autorités de fourrière.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidTypeAutoriteFourriereUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoTypeAutoriteFourriereDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidTypeAutoriteFourriereUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route recherchant une unité force de l\'ordre via son idCorrelation.
         * @param {string} idCorrelation ID de l\'unité, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidUniteFOByIdCorrelationUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UniteFOResponseDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidUniteFOByIdCorrelationUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant les unités FO liées au profil FO utilisé (unité parente + enfants), via l\'ideCorrelation de l\'unité parente
         * @param {string} idCorrelation idCorrelation de l\'unité parente, représenté par un UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidUniteFOWithChildrenUsingGET(idCorrelation: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<UniteFOResponseDto>> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getValidUniteFOWithChildrenUsingGET(idCorrelation, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route récupérant toutes les vidéos tutoriels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideoTutorielUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferenceDtoVideoTutorielDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).getVideoTutorielUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche d\'une liste de tous les motifs de mise en fourrière filtrée et triée
         * @param {searchAllMotifMefUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchAllMotifMefUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllMotifMefUsingSpecsUsingGET(queryParams: SearchAllMotifMefUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoMotifMefDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchAllMotifMefUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche d\'une liste d\'autorités de fourrière filtrée et triée
         * @param {searchAutoriteFourriereUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchAutoriteFourriereUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAutoriteFourriereUsingSpecsUsingGET(queryParams: SearchAutoriteFourriereUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoAutoriteFourriereDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchAutoriteFourriereUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche d\'une liste de centreVHU filtrée et triée
         * @param {searchCentreVHUUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchCentreVHUUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCentreVHUUsingSpecsUsingGET(queryParams: SearchCentreVHUUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoCentreVHUDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchCentreVHUUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route de recherche des commune d\'enlevement des dossiers accessibles par l\'utilisateur
         * @param {searchCommuneEnlevementUsingGETQueryParams} queryParams objet contenant les query params de la route searchCommuneEnlevementUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCommuneEnlevementUsingGET(queryParams: SearchCommuneEnlevementUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SearchCommuneEnlevementResultDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchCommuneEnlevementUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche d\'une liste des fourrières filtrée et triée
         * @param {searchFourriereUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFourriereUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFourriereUsingSpecsUsingGET(queryParams: SearchFourriereUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoFourriereDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchFourriereUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche d\'une liste de juridiction filtrée et triée
         * @param {searchJuridictionUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchJuridictionUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchJuridictionUsingSpecsUsingGET(queryParams: SearchJuridictionUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoJuridictionAdminResponseDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchJuridictionUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche d\'une liste de marques filtrée et triée
         * @param {searchMarqueUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchMarqueUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMarqueUsingSpecsUsingGET(queryParams: SearchMarqueUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoMarqueDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchMarqueUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche d\'une liste de modèles filtrée filtrée et triée
         * @param {searchModeleUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchModeleUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchModeleUsingSpecsUsingGET(queryParams: SearchModeleUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoModeleDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchModeleUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche d\'une liste de motifs de mise en fourrière filtrée et triée
         * @param {searchMotifMefUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchMotifMefUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMotifMefUsingSpecsUsingGET(queryParams: SearchMotifMefUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoMotifMefDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchMotifMefUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Recherche d\'une liste d\'UniteFo filtrée et triée
         * @param {searchUniteFoUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchUniteFoUsingSpecsUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUniteFoUsingSpecsUsingGET(queryParams: SearchUniteFoUsingSpecsUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReferentielSearchResultDtoUniteFOAdminResponseDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchUniteFoUsingSpecsUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * @summary Route recherchant une unité force de l\'ordre.
         * @param {searchedValidUniteFOUsingGETQueryParams} queryParams objet contenant les query params de la route searchedValidUniteFOUsingGET
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchedValidUniteFOUsingGET(queryParams: SearchedValidUniteFOUsingGETQueryParams, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AutocompleteUniteFOResultDto> {
            const localVarFetchArgs = ReferentielControllerApiFetchParamCreator(configuration).searchedValidUniteFOUsingGET(queryParams, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ReferentielControllerApi - object-oriented interface
 * @export
 * @class ReferentielControllerApi
 * @extends {BaseAPI}
 */
export class ReferentielControllerApi extends BaseAPI {
    /**
     * @summary Route permettant d\'exporter un référentiel au format csv.
     * @param {'AUTORITE_FOURRIERE' | 'BRANCHE' | 'CENTRE_VHU' | 'ETAT' | 'FOURRIERE' | 'FOOTER_LINK' | 'GENRE_SIMPLIFIE' | 'MOTIF_MEF' | 'MOTIF_SORTIE' | 'TYPE_AF' | 'UNITE_FO' | 'FAQ' | 'VIDEO_TUTORIEL'} referentiel Nom du referentiel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportCSVReferentielUsingGET(referentiel: 'AUTORITE_FOURRIERE' | 'BRANCHE' | 'CENTRE_VHU' | 'ETAT' | 'FOURRIERE' | 'FOOTER_LINK' | 'GENRE_SIMPLIFIE' | 'MOTIF_MEF' | 'MOTIF_SORTIE' | 'TYPE_AF' | 'UNITE_FO' | 'FAQ' | 'VIDEO_TUTORIEL', options?: any) {
        return ReferentielControllerApiFp(this.configuration).exportCSVReferentielUsingGET(referentiel, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant toutes les couleurs de véhicule.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllCouleurUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getAllCouleurUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant toutes les énergies.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllEnergieUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getAllEnergieUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant tous les bandeaux d\'information
     * @param {getAllInformationMessageUsingGETQueryParams} queryParams objet contenant les query params de la route getAllInformationMessageUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllInformationMessageUsingGET(queryParams: GetAllInformationMessageUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getAllInformationMessageUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant tous les modèles de véhicule.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllMarqueModeleUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getAllMarqueModeleUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant tous les centres VHU valides.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllValidCentreVhuUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getAllValidCentreVhuUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant toutes les marques valides.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllValidMarqueUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getAllValidMarqueUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant toutes les natures de mise en fourrière et les branches de workflow associées.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllValidNaturesUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getAllValidNaturesUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant les précisions pour un état donné.
     * @param {'BON_ETAT' | 'DEGRADE' | 'DOMMAGES_GRAVES'} etat Libellé de l\'état.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDetailFromEtatUsingGET(etat: 'BON_ETAT' | 'DEGRADE' | 'DOMMAGES_GRAVES', options?: any) {
        return ReferentielControllerApiFp(this.configuration).getDetailFromEtatUsingGET(etat, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant un état par son id.
     * @param {string} id ID de l\'état, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEtatByIdUsingGET(id: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getEtatByIdUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant les différents états
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEtatsVehiculeUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getEtatsVehiculeUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route recherchant une juridiction valide ou non via son id correlation.
     * @param {string} idCorrelation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLastJuridictionByIdCorrelationUsingGET(idCorrelation: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getLastJuridictionByIdCorrelationUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant une marque par son id.
     * @param {string} id ID de la marque, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMarqueByIdUsingGET(id: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getMarqueByIdUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant tous les modèles de véhicule pour l\'idCorrelation d\'une marque donnée.
     * @param {string} idCorrelation ID de la marque, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getModeleByMarqueIdCorrelationUsingGET(idCorrelation: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getModeleByMarqueIdCorrelationUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant tous les modèles de véhicule pour l\'id d\'une marque donnée.
     * @param {string} id ID de la marque, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getModeleByMarqueUsingGET(id: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getModeleByMarqueUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant un motif de mise en fourrière par son id.
     * @param {string} id ID du motif de mef, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMotifMefByIdUsingGET(id: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getMotifMefByIdUsingGET(id, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant les questions valides, regroupées par domaines.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOnlyValidFaqByDomainsUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getOnlyValidFaqByDomainsUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route rercherchant une question en fonction de son idCorrelation.
     * @param {string} idCorrelation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOnlyValidFaqDtoUsingGET(idCorrelation: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getOnlyValidFaqDtoUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant les questions valides, avec ou sans domaine.
     * @param {getOnlyValidFaqsUsingGETQueryParams} queryParams objet contenant les query params de la route getOnlyValidFaqsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOnlyValidFaqsUsingGET(queryParams: GetOnlyValidFaqsUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getOnlyValidFaqsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant les liens du pied de page valides.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOnlyValidFooterLinkUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getOnlyValidFooterLinkUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant les bandeaux d\'information actif pour le profil donné.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOnlyValidInformationMessageByProfileUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getOnlyValidInformationMessageByProfileUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant les bandeaux d\'information actif pour Bord de Route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOnlyValidInformationMessageForBDRUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getOnlyValidInformationMessageForBDRUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant les statuts consultables selon le profil.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStatutsConsultablesUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getStatutsConsultablesUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route recherchant une autorités de fourrière par son idCorrelation.
     * @param {string} idCorrelation ID de l\'autorités de fourrière, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidAutoriteFourriereByIdCorrelationUsingGET(idCorrelation: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidAutoriteFourriereByIdCorrelationUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant toutes les autorités de fourrière.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidAutoriteFourriereUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidAutoriteFourriereUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant toutes les autorités fourrière d\'une fourrière via son idCorrelation.
     * @param {string} idCorrelationFourriere IdCorrelation de la fourrière.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidAutoritesFourriereOfFourriereUsingGET(idCorrelationFourriere: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidAutoritesFourriereOfFourriereUsingGET(idCorrelationFourriere, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant toutes les fourrière.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidFourriereUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidFourriereUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant tous les genres simplifiés de véhicules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidGenresSimplifiesUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidGenresSimplifiesUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route recherchant une juridiction
     * @param {getValidJuridictionByLibelleOrNumeroUsingGETQueryParams} queryParams objet contenant les query params de la route getValidJuridictionByLibelleOrNumeroUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidJuridictionByLibelleOrNumeroUsingGET(queryParams: GetValidJuridictionByLibelleOrNumeroUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidJuridictionByLibelleOrNumeroUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant tous les motifs de mise en fourrière.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidMotifMefUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidMotifMefUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant tous les motifs de sortie.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidMotifSortieUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidMotifSortieUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant tous les types d\'autorités de fourrière.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidTypeAutoriteFourriereUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidTypeAutoriteFourriereUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route recherchant une unité force de l\'ordre via son idCorrelation.
     * @param {string} idCorrelation ID de l\'unité, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidUniteFOByIdCorrelationUsingGET(idCorrelation: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidUniteFOByIdCorrelationUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant les unités FO liées au profil FO utilisé (unité parente + enfants), via l\'ideCorrelation de l\'unité parente
     * @param {string} idCorrelation idCorrelation de l\'unité parente, représenté par un UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValidUniteFOWithChildrenUsingGET(idCorrelation: string, options?: any) {
        return ReferentielControllerApiFp(this.configuration).getValidUniteFOWithChildrenUsingGET(idCorrelation, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route récupérant toutes les vidéos tutoriels.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVideoTutorielUsingGET(options?: any) {
        return ReferentielControllerApiFp(this.configuration).getVideoTutorielUsingGET(options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche d\'une liste de tous les motifs de mise en fourrière filtrée et triée
     * @param {searchAllMotifMefUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchAllMotifMefUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchAllMotifMefUsingSpecsUsingGET(queryParams: SearchAllMotifMefUsingSpecsUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchAllMotifMefUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche d\'une liste d\'autorités de fourrière filtrée et triée
     * @param {searchAutoriteFourriereUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchAutoriteFourriereUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchAutoriteFourriereUsingSpecsUsingGET(queryParams: SearchAutoriteFourriereUsingSpecsUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchAutoriteFourriereUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche d\'une liste de centreVHU filtrée et triée
     * @param {searchCentreVHUUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchCentreVHUUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCentreVHUUsingSpecsUsingGET(queryParams: SearchCentreVHUUsingSpecsUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchCentreVHUUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route de recherche des commune d\'enlevement des dossiers accessibles par l\'utilisateur
     * @param {searchCommuneEnlevementUsingGETQueryParams} queryParams objet contenant les query params de la route searchCommuneEnlevementUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCommuneEnlevementUsingGET(queryParams: SearchCommuneEnlevementUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchCommuneEnlevementUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche d\'une liste des fourrières filtrée et triée
     * @param {searchFourriereUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchFourriereUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFourriereUsingSpecsUsingGET(queryParams: SearchFourriereUsingSpecsUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchFourriereUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche d\'une liste de juridiction filtrée et triée
     * @param {searchJuridictionUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchJuridictionUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchJuridictionUsingSpecsUsingGET(queryParams: SearchJuridictionUsingSpecsUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchJuridictionUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche d\'une liste de marques filtrée et triée
     * @param {searchMarqueUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchMarqueUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchMarqueUsingSpecsUsingGET(queryParams: SearchMarqueUsingSpecsUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchMarqueUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche d\'une liste de modèles filtrée filtrée et triée
     * @param {searchModeleUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchModeleUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchModeleUsingSpecsUsingGET(queryParams: SearchModeleUsingSpecsUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchModeleUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche d\'une liste de motifs de mise en fourrière filtrée et triée
     * @param {searchMotifMefUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchMotifMefUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchMotifMefUsingSpecsUsingGET(queryParams: SearchMotifMefUsingSpecsUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchMotifMefUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Recherche d\'une liste d\'UniteFo filtrée et triée
     * @param {searchUniteFoUsingSpecsUsingGETQueryParams} queryParams objet contenant les query params de la route searchUniteFoUsingSpecsUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUniteFoUsingSpecsUsingGET(queryParams: SearchUniteFoUsingSpecsUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchUniteFoUsingSpecsUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

    /**
     * @summary Route recherchant une unité force de l\'ordre.
     * @param {searchedValidUniteFOUsingGETQueryParams} queryParams objet contenant les query params de la route searchedValidUniteFOUsingGET
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchedValidUniteFOUsingGET(queryParams: SearchedValidUniteFOUsingGETQueryParams, options?: any) {
        return ReferentielControllerApiFp(this.configuration).searchedValidUniteFOUsingGET(queryParams, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// RelanceVenteControllerApi /////////////////////////////////////////////////////

/**
 * RelanceVenteControllerApi - fetch parameter creator
 * @export
 */
export const RelanceVenteControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route déclenchant une relance du processus de vente chez le service des domaines, engendrant une nouvelle remise aux domaines.
         * @param {RelanceVenteDto} relanceVenteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relanceVenteUsingPOST(relanceVenteDto: RelanceVenteDto, options: any = {}): FetchArgs {
            // verify required parameter 'relanceVenteDto' is not null or undefined
            if (relanceVenteDto === null || relanceVenteDto === undefined) {
                throw new RequiredError('relanceVenteDto','Required parameter relanceVenteDto was null or undefined when calling relanceVenteUsingPOST.');
            }
            const localVarPath = `/api/relance-vente/dossier/relance-vente`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RelanceVenteDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(relanceVenteDto || {}) : (relanceVenteDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RelanceVenteControllerApi - functional programming interface
 * @export
 */
export const RelanceVenteControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route déclenchant une relance du processus de vente chez le service des domaines, engendrant une nouvelle remise aux domaines.
         * @param {RelanceVenteDto} relanceVenteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relanceVenteUsingPOST(relanceVenteDto: RelanceVenteDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DossierResponseDto> {
            const localVarFetchArgs = RelanceVenteControllerApiFetchParamCreator(configuration).relanceVenteUsingPOST(relanceVenteDto, options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * RelanceVenteControllerApi - object-oriented interface
 * @export
 * @class RelanceVenteControllerApi
 * @extends {BaseAPI}
 */
export class RelanceVenteControllerApi extends BaseAPI {
    /**
     * @summary Route déclenchant une relance du processus de vente chez le service des domaines, engendrant une nouvelle remise aux domaines.
     * @param {RelanceVenteDto} relanceVenteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public relanceVenteUsingPOST(relanceVenteDto: RelanceVenteDto, options?: any) {
        return RelanceVenteControllerApiFp(this.configuration).relanceVenteUsingPOST(relanceVenteDto, options)(this.fetch, this.basePath);
    }

}

//////////////////////////////////// VersionControllerApi /////////////////////////////////////////////////////

/**
 * VersionControllerApi - fetch parameter creator
 * @export
 */
export const VersionControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant d\'avoir la version du SI Fourrières.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionUsingGET(options: any = {}): FetchArgs {
            const localVarPath = `/api/version`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api-source required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("api-source")
					: configuration.apiKey;
                localVarHeaderParameter["api-source"] = localVarApiKeyValue;
            }

            // authentication Authorization required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionControllerApi - functional programming interface
 * @export
 */
export const VersionControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * @summary Route permettant d\'avoir la version du SI Fourrières.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionUsingGET(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VersionDto> {
            const localVarFetchArgs = VersionControllerApiFetchParamCreator(configuration).getVersionUsingGET(options);
            return (fetch: FetchAPI = window.fetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * VersionControllerApi - object-oriented interface
 * @export
 * @class VersionControllerApi
 * @extends {BaseAPI}
 */
export class VersionControllerApi extends BaseAPI {
    /**
     * @summary Route permettant d\'avoir la version du SI Fourrières.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVersionUsingGET(options?: any) {
        return VersionControllerApiFp(this.configuration).getVersionUsingGET(options)(this.fetch, this.basePath);
    }

}

